/*eslint-disable block-scoped-var, id-length, no-control-regex, no-magic-numbers, no-prototype-builtins, no-redeclare, no-shadow, no-var, sort-vars*/
'use strict';

var $protobuf = require('protobufjs/minimal');

// Common aliases
var $Reader = $protobuf.Reader,
  $Writer = $protobuf.Writer,
  $util = $protobuf.util;

// Exported root namespace
var $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = {});

$root.propel = (function () {
  /**
   * Namespace propel.
   * @exports propel
   * @namespace
   */
  var propel = {};

  propel.commrouter = (function () {
    /**
     * Namespace commrouter.
     * @memberof propel
     * @namespace
     */
    var commrouter = {};

    commrouter.Conversation = (function () {
      /**
       * Properties of a Conversation.
       * @memberof propel.commrouter
       * @interface IConversation
       * @property {string|null} [id] Conversation id
       * @property {propel.commrouter.Conversation.Activity|null} [activity] Conversation activity
       * @property {string|null} [serviceAccountId] Conversation serviceAccountId
       * @property {string|null} [leadAccountId] Conversation leadAccountId
       */

      /**
       * Constructs a new Conversation.
       * @memberof propel.commrouter
       * @classdesc Represents a Conversation.
       * @implements IConversation
       * @constructor
       * @param {propel.commrouter.IConversation=} [properties] Properties to set
       */
      function Conversation(properties) {
        if (properties)
          for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
      }

      /**
       * Conversation id.
       * @member {string} id
       * @memberof propel.commrouter.Conversation
       * @instance
       */
      Conversation.prototype.id = '';

      /**
       * Conversation activity.
       * @member {propel.commrouter.Conversation.Activity} activity
       * @memberof propel.commrouter.Conversation
       * @instance
       */
      Conversation.prototype.activity = 0;

      /**
       * Conversation serviceAccountId.
       * @member {string} serviceAccountId
       * @memberof propel.commrouter.Conversation
       * @instance
       */
      Conversation.prototype.serviceAccountId = '';

      /**
       * Conversation leadAccountId.
       * @member {string} leadAccountId
       * @memberof propel.commrouter.Conversation
       * @instance
       */
      Conversation.prototype.leadAccountId = '';

      /**
       * Creates a new Conversation instance using the specified properties.
       * @function create
       * @memberof propel.commrouter.Conversation
       * @static
       * @param {propel.commrouter.IConversation=} [properties] Properties to set
       * @returns {propel.commrouter.Conversation} Conversation instance
       */
      Conversation.create = function create(properties) {
        return new Conversation(properties);
      };

      /**
       * Encodes the specified Conversation message. Does not implicitly {@link propel.commrouter.Conversation.verify|verify} messages.
       * @function encode
       * @memberof propel.commrouter.Conversation
       * @static
       * @param {propel.commrouter.IConversation} message Conversation message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      Conversation.encode = function encode(message, writer) {
        if (!writer) writer = $Writer.create();
        if (message.id != null && message.hasOwnProperty('id'))
          writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
        if (message.activity != null && message.hasOwnProperty('activity'))
          writer.uint32(/* id 2, wireType 0 =*/ 16).int32(message.activity);
        if (message.serviceAccountId != null && message.hasOwnProperty('serviceAccountId'))
          writer.uint32(/* id 3, wireType 2 =*/ 26).string(message.serviceAccountId);
        if (message.leadAccountId != null && message.hasOwnProperty('leadAccountId'))
          writer.uint32(/* id 4, wireType 2 =*/ 34).string(message.leadAccountId);
        return writer;
      };

      /**
       * Encodes the specified Conversation message, length delimited. Does not implicitly {@link propel.commrouter.Conversation.verify|verify} messages.
       * @function encodeDelimited
       * @memberof propel.commrouter.Conversation
       * @static
       * @param {propel.commrouter.IConversation} message Conversation message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      Conversation.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
      };

      /**
       * Decodes a Conversation message from the specified reader or buffer.
       * @function decode
       * @memberof propel.commrouter.Conversation
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @param {number} [length] Message length if known beforehand
       * @returns {propel.commrouter.Conversation} Conversation
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      Conversation.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length,
          message = new $root.propel.commrouter.Conversation();
        while (reader.pos < end) {
          var tag = reader.uint32();
          switch (tag >>> 3) {
            case 1:
              message.id = reader.string();
              break;
            case 2:
              message.activity = reader.int32();
              break;
            case 3:
              message.serviceAccountId = reader.string();
              break;
            case 4:
              message.leadAccountId = reader.string();
              break;
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };

      /**
       * Decodes a Conversation message from the specified reader or buffer, length delimited.
       * @function decodeDelimited
       * @memberof propel.commrouter.Conversation
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @returns {propel.commrouter.Conversation} Conversation
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      Conversation.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader)) reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
      };

      /**
       * Verifies a Conversation message.
       * @function verify
       * @memberof propel.commrouter.Conversation
       * @static
       * @param {Object.<string,*>} message Plain object to verify
       * @returns {string|null} `null` if valid, otherwise the reason why it is not
       */
      Conversation.verify = function verify(message) {
        if (typeof message !== 'object' || message === null) return 'object expected';
        if (message.id != null && message.hasOwnProperty('id'))
          if (!$util.isString(message.id)) return 'id: string expected';
        if (message.activity != null && message.hasOwnProperty('activity'))
          switch (message.activity) {
            default:
              return 'activity: enum value expected';
            case 0:
            case 1:
            case 2:
              break;
          }
        if (message.serviceAccountId != null && message.hasOwnProperty('serviceAccountId'))
          if (!$util.isString(message.serviceAccountId)) return 'serviceAccountId: string expected';
        if (message.leadAccountId != null && message.hasOwnProperty('leadAccountId'))
          if (!$util.isString(message.leadAccountId)) return 'leadAccountId: string expected';
        return null;
      };

      /**
       * Creates a Conversation message from a plain object. Also converts values to their respective internal types.
       * @function fromObject
       * @memberof propel.commrouter.Conversation
       * @static
       * @param {Object.<string,*>} object Plain object
       * @returns {propel.commrouter.Conversation} Conversation
       */
      Conversation.fromObject = function fromObject(object) {
        if (object instanceof $root.propel.commrouter.Conversation) return object;
        var message = new $root.propel.commrouter.Conversation();
        if (object.id != null) message.id = String(object.id);
        switch (object.activity) {
          case 'ACTIVITY_UNKNOWN':
          case 0:
            message.activity = 0;
            break;
          case 'ACTIVITY_ACTIVE':
          case 1:
            message.activity = 1;
            break;
          case 'ACTIVITY_INACTIVE':
          case 2:
            message.activity = 2;
            break;
        }
        if (object.serviceAccountId != null)
          message.serviceAccountId = String(object.serviceAccountId);
        if (object.leadAccountId != null) message.leadAccountId = String(object.leadAccountId);
        return message;
      };

      /**
       * Creates a plain object from a Conversation message. Also converts values to other types if specified.
       * @function toObject
       * @memberof propel.commrouter.Conversation
       * @static
       * @param {propel.commrouter.Conversation} message Conversation
       * @param {$protobuf.IConversionOptions} [options] Conversion options
       * @returns {Object.<string,*>} Plain object
       */
      Conversation.toObject = function toObject(message, options) {
        if (!options) options = {};
        var object = {};
        if (options.defaults) {
          object.id = '';
          object.activity = options.enums === String ? 'ACTIVITY_UNKNOWN' : 0;
          object.serviceAccountId = '';
          object.leadAccountId = '';
        }
        if (message.id != null && message.hasOwnProperty('id')) object.id = message.id;
        if (message.activity != null && message.hasOwnProperty('activity'))
          object.activity =
            options.enums === String
              ? $root.propel.commrouter.Conversation.Activity[message.activity]
              : message.activity;
        if (message.serviceAccountId != null && message.hasOwnProperty('serviceAccountId'))
          object.serviceAccountId = message.serviceAccountId;
        if (message.leadAccountId != null && message.hasOwnProperty('leadAccountId'))
          object.leadAccountId = message.leadAccountId;
        return object;
      };

      /**
       * Converts this Conversation to JSON.
       * @function toJSON
       * @memberof propel.commrouter.Conversation
       * @instance
       * @returns {Object.<string,*>} JSON object
       */
      Conversation.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
      };

      /**
       * Activity enum.
       * @name propel.commrouter.Conversation.Activity
       * @enum {string}
       * @property {number} ACTIVITY_UNKNOWN=0 ACTIVITY_UNKNOWN value
       * @property {number} ACTIVITY_ACTIVE=1 ACTIVITY_ACTIVE value
       * @property {number} ACTIVITY_INACTIVE=2 ACTIVITY_INACTIVE value
       */
      Conversation.Activity = (function () {
        var valuesById = {},
          values = Object.create(valuesById);
        values[(valuesById[0] = 'ACTIVITY_UNKNOWN')] = 0;
        values[(valuesById[1] = 'ACTIVITY_ACTIVE')] = 1;
        values[(valuesById[2] = 'ACTIVITY_INACTIVE')] = 2;
        return values;
      })();

      return Conversation;
    })();

    commrouter.Job = (function () {
      /**
       * Properties of a Job.
       * @memberof propel.commrouter
       * @interface IJob
       * @property {string|null} [id] Job id
       * @property {string|null} [name] Job name
       * @property {string|null} [description] Job description
       * @property {string|null} [factory] Job factory
       * @property {google.protobuf.IStruct|null} [info] Job info
       * @property {google.protobuf.IStringValue|null} [error] Job error
       * @property {google.protobuf.IStringValue|null} [errorMessage] Job errorMessage
       */

      /**
       * Constructs a new Job.
       * @memberof propel.commrouter
       * @classdesc Represents a Job.
       * @implements IJob
       * @constructor
       * @param {propel.commrouter.IJob=} [properties] Properties to set
       */
      function Job(properties) {
        if (properties)
          for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
      }

      /**
       * Job id.
       * @member {string} id
       * @memberof propel.commrouter.Job
       * @instance
       */
      Job.prototype.id = '';

      /**
       * Job name.
       * @member {string} name
       * @memberof propel.commrouter.Job
       * @instance
       */
      Job.prototype.name = '';

      /**
       * Job description.
       * @member {string} description
       * @memberof propel.commrouter.Job
       * @instance
       */
      Job.prototype.description = '';

      /**
       * Job factory.
       * @member {string} factory
       * @memberof propel.commrouter.Job
       * @instance
       */
      Job.prototype.factory = '';

      /**
       * Job info.
       * @member {google.protobuf.IStruct|null|undefined} info
       * @memberof propel.commrouter.Job
       * @instance
       */
      Job.prototype.info = null;

      /**
       * Job error.
       * @member {google.protobuf.IStringValue|null|undefined} error
       * @memberof propel.commrouter.Job
       * @instance
       */
      Job.prototype.error = null;

      /**
       * Job errorMessage.
       * @member {google.protobuf.IStringValue|null|undefined} errorMessage
       * @memberof propel.commrouter.Job
       * @instance
       */
      Job.prototype.errorMessage = null;

      /**
       * Creates a new Job instance using the specified properties.
       * @function create
       * @memberof propel.commrouter.Job
       * @static
       * @param {propel.commrouter.IJob=} [properties] Properties to set
       * @returns {propel.commrouter.Job} Job instance
       */
      Job.create = function create(properties) {
        return new Job(properties);
      };

      /**
       * Encodes the specified Job message. Does not implicitly {@link propel.commrouter.Job.verify|verify} messages.
       * @function encode
       * @memberof propel.commrouter.Job
       * @static
       * @param {propel.commrouter.IJob} message Job message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      Job.encode = function encode(message, writer) {
        if (!writer) writer = $Writer.create();
        if (message.id != null && message.hasOwnProperty('id'))
          writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
        if (message.name != null && message.hasOwnProperty('name'))
          writer.uint32(/* id 2, wireType 2 =*/ 18).string(message.name);
        if (message.description != null && message.hasOwnProperty('description'))
          writer.uint32(/* id 3, wireType 2 =*/ 26).string(message.description);
        if (message.factory != null && message.hasOwnProperty('factory'))
          writer.uint32(/* id 4, wireType 2 =*/ 34).string(message.factory);
        if (message.info != null && message.hasOwnProperty('info'))
          $root.google.protobuf.Struct.encode(
            message.info,
            writer.uint32(/* id 5, wireType 2 =*/ 42).fork()
          ).ldelim();
        if (message.error != null && message.hasOwnProperty('error'))
          $root.google.protobuf.StringValue.encode(
            message.error,
            writer.uint32(/* id 6, wireType 2 =*/ 50).fork()
          ).ldelim();
        if (message.errorMessage != null && message.hasOwnProperty('errorMessage'))
          $root.google.protobuf.StringValue.encode(
            message.errorMessage,
            writer.uint32(/* id 7, wireType 2 =*/ 58).fork()
          ).ldelim();
        return writer;
      };

      /**
       * Encodes the specified Job message, length delimited. Does not implicitly {@link propel.commrouter.Job.verify|verify} messages.
       * @function encodeDelimited
       * @memberof propel.commrouter.Job
       * @static
       * @param {propel.commrouter.IJob} message Job message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      Job.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
      };

      /**
       * Decodes a Job message from the specified reader or buffer.
       * @function decode
       * @memberof propel.commrouter.Job
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @param {number} [length] Message length if known beforehand
       * @returns {propel.commrouter.Job} Job
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      Job.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length,
          message = new $root.propel.commrouter.Job();
        while (reader.pos < end) {
          var tag = reader.uint32();
          switch (tag >>> 3) {
            case 1:
              message.id = reader.string();
              break;
            case 2:
              message.name = reader.string();
              break;
            case 3:
              message.description = reader.string();
              break;
            case 4:
              message.factory = reader.string();
              break;
            case 5:
              message.info = $root.google.protobuf.Struct.decode(reader, reader.uint32());
              break;
            case 6:
              message.error = $root.google.protobuf.StringValue.decode(reader, reader.uint32());
              break;
            case 7:
              message.errorMessage = $root.google.protobuf.StringValue.decode(
                reader,
                reader.uint32()
              );
              break;
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };

      /**
       * Decodes a Job message from the specified reader or buffer, length delimited.
       * @function decodeDelimited
       * @memberof propel.commrouter.Job
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @returns {propel.commrouter.Job} Job
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      Job.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader)) reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
      };

      /**
       * Verifies a Job message.
       * @function verify
       * @memberof propel.commrouter.Job
       * @static
       * @param {Object.<string,*>} message Plain object to verify
       * @returns {string|null} `null` if valid, otherwise the reason why it is not
       */
      Job.verify = function verify(message) {
        if (typeof message !== 'object' || message === null) return 'object expected';
        if (message.id != null && message.hasOwnProperty('id'))
          if (!$util.isString(message.id)) return 'id: string expected';
        if (message.name != null && message.hasOwnProperty('name'))
          if (!$util.isString(message.name)) return 'name: string expected';
        if (message.description != null && message.hasOwnProperty('description'))
          if (!$util.isString(message.description)) return 'description: string expected';
        if (message.factory != null && message.hasOwnProperty('factory'))
          if (!$util.isString(message.factory)) return 'factory: string expected';
        if (message.info != null && message.hasOwnProperty('info')) {
          var error = $root.google.protobuf.Struct.verify(message.info);
          if (error) return 'info.' + error;
        }
        if (message.error != null && message.hasOwnProperty('error')) {
          var error = $root.google.protobuf.StringValue.verify(message.error);
          if (error) return 'error.' + error;
        }
        if (message.errorMessage != null && message.hasOwnProperty('errorMessage')) {
          var error = $root.google.protobuf.StringValue.verify(message.errorMessage);
          if (error) return 'errorMessage.' + error;
        }
        return null;
      };

      /**
       * Creates a Job message from a plain object. Also converts values to their respective internal types.
       * @function fromObject
       * @memberof propel.commrouter.Job
       * @static
       * @param {Object.<string,*>} object Plain object
       * @returns {propel.commrouter.Job} Job
       */
      Job.fromObject = function fromObject(object) {
        if (object instanceof $root.propel.commrouter.Job) return object;
        var message = new $root.propel.commrouter.Job();
        if (object.id != null) message.id = String(object.id);
        if (object.name != null) message.name = String(object.name);
        if (object.description != null) message.description = String(object.description);
        if (object.factory != null) message.factory = String(object.factory);
        if (object.info != null) {
          if (typeof object.info !== 'object')
            throw TypeError('.propel.commrouter.Job.info: object expected');
          message.info = $root.google.protobuf.Struct.fromObject(object.info);
        }
        if (object.error != null) {
          if (typeof object.error !== 'object')
            throw TypeError('.propel.commrouter.Job.error: object expected');
          message.error = $root.google.protobuf.StringValue.fromObject(object.error);
        }
        if (object.errorMessage != null) {
          if (typeof object.errorMessage !== 'object')
            throw TypeError('.propel.commrouter.Job.errorMessage: object expected');
          message.errorMessage = $root.google.protobuf.StringValue.fromObject(object.errorMessage);
        }
        return message;
      };

      /**
       * Creates a plain object from a Job message. Also converts values to other types if specified.
       * @function toObject
       * @memberof propel.commrouter.Job
       * @static
       * @param {propel.commrouter.Job} message Job
       * @param {$protobuf.IConversionOptions} [options] Conversion options
       * @returns {Object.<string,*>} Plain object
       */
      Job.toObject = function toObject(message, options) {
        if (!options) options = {};
        var object = {};
        if (options.defaults) {
          object.id = '';
          object.name = '';
          object.description = '';
          object.factory = '';
          object.info = null;
          object.error = null;
          object.errorMessage = null;
        }
        if (message.id != null && message.hasOwnProperty('id')) object.id = message.id;
        if (message.name != null && message.hasOwnProperty('name')) object.name = message.name;
        if (message.description != null && message.hasOwnProperty('description'))
          object.description = message.description;
        if (message.factory != null && message.hasOwnProperty('factory'))
          object.factory = message.factory;
        if (message.info != null && message.hasOwnProperty('info'))
          object.info = $root.google.protobuf.Struct.toObject(message.info, options);
        if (message.error != null && message.hasOwnProperty('error'))
          object.error = $root.google.protobuf.StringValue.toObject(message.error, options);
        if (message.errorMessage != null && message.hasOwnProperty('errorMessage'))
          object.errorMessage = $root.google.protobuf.StringValue.toObject(
            message.errorMessage,
            options
          );
        return object;
      };

      /**
       * Converts this Job to JSON.
       * @function toJSON
       * @memberof propel.commrouter.Job
       * @instance
       * @returns {Object.<string,*>} JSON object
       */
      Job.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
      };

      /**
       * State enum.
       * @name propel.commrouter.Job.State
       * @enum {string}
       * @property {number} STATE_UNKNOWN=0 STATE_UNKNOWN value
       * @property {number} STATE_RUNNING=1 STATE_RUNNING value
       * @property {number} STATE_STOPPED=2 STATE_STOPPED value
       * @property {number} STATE_ERROR=3 STATE_ERROR value
       */
      Job.State = (function () {
        var valuesById = {},
          values = Object.create(valuesById);
        values[(valuesById[0] = 'STATE_UNKNOWN')] = 0;
        values[(valuesById[1] = 'STATE_RUNNING')] = 1;
        values[(valuesById[2] = 'STATE_STOPPED')] = 2;
        values[(valuesById[3] = 'STATE_ERROR')] = 3;
        return values;
      })();

      return Job;
    })();

    commrouter.VendorId = (function () {
      /**
       * Properties of a VendorId.
       * @memberof propel.commrouter
       * @interface IVendorId
       * @property {string|null} [id] VendorId id
       * @property {string|null} [source] VendorId source
       */

      /**
       * Constructs a new VendorId.
       * @memberof propel.commrouter
       * @classdesc Represents a VendorId.
       * @implements IVendorId
       * @constructor
       * @param {propel.commrouter.IVendorId=} [properties] Properties to set
       */
      function VendorId(properties) {
        if (properties)
          for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
      }

      /**
       * VendorId id.
       * @member {string} id
       * @memberof propel.commrouter.VendorId
       * @instance
       */
      VendorId.prototype.id = '';

      /**
       * VendorId source.
       * @member {string} source
       * @memberof propel.commrouter.VendorId
       * @instance
       */
      VendorId.prototype.source = '';

      /**
       * Creates a new VendorId instance using the specified properties.
       * @function create
       * @memberof propel.commrouter.VendorId
       * @static
       * @param {propel.commrouter.IVendorId=} [properties] Properties to set
       * @returns {propel.commrouter.VendorId} VendorId instance
       */
      VendorId.create = function create(properties) {
        return new VendorId(properties);
      };

      /**
       * Encodes the specified VendorId message. Does not implicitly {@link propel.commrouter.VendorId.verify|verify} messages.
       * @function encode
       * @memberof propel.commrouter.VendorId
       * @static
       * @param {propel.commrouter.IVendorId} message VendorId message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      VendorId.encode = function encode(message, writer) {
        if (!writer) writer = $Writer.create();
        if (message.id != null && message.hasOwnProperty('id'))
          writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
        if (message.source != null && message.hasOwnProperty('source'))
          writer.uint32(/* id 2, wireType 2 =*/ 18).string(message.source);
        return writer;
      };

      /**
       * Encodes the specified VendorId message, length delimited. Does not implicitly {@link propel.commrouter.VendorId.verify|verify} messages.
       * @function encodeDelimited
       * @memberof propel.commrouter.VendorId
       * @static
       * @param {propel.commrouter.IVendorId} message VendorId message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      VendorId.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
      };

      /**
       * Decodes a VendorId message from the specified reader or buffer.
       * @function decode
       * @memberof propel.commrouter.VendorId
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @param {number} [length] Message length if known beforehand
       * @returns {propel.commrouter.VendorId} VendorId
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      VendorId.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length,
          message = new $root.propel.commrouter.VendorId();
        while (reader.pos < end) {
          var tag = reader.uint32();
          switch (tag >>> 3) {
            case 1:
              message.id = reader.string();
              break;
            case 2:
              message.source = reader.string();
              break;
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };

      /**
       * Decodes a VendorId message from the specified reader or buffer, length delimited.
       * @function decodeDelimited
       * @memberof propel.commrouter.VendorId
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @returns {propel.commrouter.VendorId} VendorId
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      VendorId.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader)) reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
      };

      /**
       * Verifies a VendorId message.
       * @function verify
       * @memberof propel.commrouter.VendorId
       * @static
       * @param {Object.<string,*>} message Plain object to verify
       * @returns {string|null} `null` if valid, otherwise the reason why it is not
       */
      VendorId.verify = function verify(message) {
        if (typeof message !== 'object' || message === null) return 'object expected';
        if (message.id != null && message.hasOwnProperty('id'))
          if (!$util.isString(message.id)) return 'id: string expected';
        if (message.source != null && message.hasOwnProperty('source'))
          if (!$util.isString(message.source)) return 'source: string expected';
        return null;
      };

      /**
       * Creates a VendorId message from a plain object. Also converts values to their respective internal types.
       * @function fromObject
       * @memberof propel.commrouter.VendorId
       * @static
       * @param {Object.<string,*>} object Plain object
       * @returns {propel.commrouter.VendorId} VendorId
       */
      VendorId.fromObject = function fromObject(object) {
        if (object instanceof $root.propel.commrouter.VendorId) return object;
        var message = new $root.propel.commrouter.VendorId();
        if (object.id != null) message.id = String(object.id);
        if (object.source != null) message.source = String(object.source);
        return message;
      };

      /**
       * Creates a plain object from a VendorId message. Also converts values to other types if specified.
       * @function toObject
       * @memberof propel.commrouter.VendorId
       * @static
       * @param {propel.commrouter.VendorId} message VendorId
       * @param {$protobuf.IConversionOptions} [options] Conversion options
       * @returns {Object.<string,*>} Plain object
       */
      VendorId.toObject = function toObject(message, options) {
        if (!options) options = {};
        var object = {};
        if (options.defaults) {
          object.id = '';
          object.source = '';
        }
        if (message.id != null && message.hasOwnProperty('id')) object.id = message.id;
        if (message.source != null && message.hasOwnProperty('source'))
          object.source = message.source;
        return object;
      };

      /**
       * Converts this VendorId to JSON.
       * @function toJSON
       * @memberof propel.commrouter.VendorId
       * @instance
       * @returns {Object.<string,*>} JSON object
       */
      VendorId.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
      };

      return VendorId;
    })();

    commrouter.AccessToken = (function () {
      /**
       * Properties of an AccessToken.
       * @memberof propel.commrouter
       * @interface IAccessToken
       * @property {string|null} [accessToken] AccessToken accessToken
       */

      /**
       * Constructs a new AccessToken.
       * @memberof propel.commrouter
       * @classdesc Represents an AccessToken.
       * @implements IAccessToken
       * @constructor
       * @param {propel.commrouter.IAccessToken=} [properties] Properties to set
       */
      function AccessToken(properties) {
        if (properties)
          for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
      }

      /**
       * AccessToken accessToken.
       * @member {string} accessToken
       * @memberof propel.commrouter.AccessToken
       * @instance
       */
      AccessToken.prototype.accessToken = '';

      /**
       * Creates a new AccessToken instance using the specified properties.
       * @function create
       * @memberof propel.commrouter.AccessToken
       * @static
       * @param {propel.commrouter.IAccessToken=} [properties] Properties to set
       * @returns {propel.commrouter.AccessToken} AccessToken instance
       */
      AccessToken.create = function create(properties) {
        return new AccessToken(properties);
      };

      /**
       * Encodes the specified AccessToken message. Does not implicitly {@link propel.commrouter.AccessToken.verify|verify} messages.
       * @function encode
       * @memberof propel.commrouter.AccessToken
       * @static
       * @param {propel.commrouter.IAccessToken} message AccessToken message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      AccessToken.encode = function encode(message, writer) {
        if (!writer) writer = $Writer.create();
        if (message.accessToken != null && message.hasOwnProperty('accessToken'))
          writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.accessToken);
        return writer;
      };

      /**
       * Encodes the specified AccessToken message, length delimited. Does not implicitly {@link propel.commrouter.AccessToken.verify|verify} messages.
       * @function encodeDelimited
       * @memberof propel.commrouter.AccessToken
       * @static
       * @param {propel.commrouter.IAccessToken} message AccessToken message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      AccessToken.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
      };

      /**
       * Decodes an AccessToken message from the specified reader or buffer.
       * @function decode
       * @memberof propel.commrouter.AccessToken
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @param {number} [length] Message length if known beforehand
       * @returns {propel.commrouter.AccessToken} AccessToken
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      AccessToken.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length,
          message = new $root.propel.commrouter.AccessToken();
        while (reader.pos < end) {
          var tag = reader.uint32();
          switch (tag >>> 3) {
            case 1:
              message.accessToken = reader.string();
              break;
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };

      /**
       * Decodes an AccessToken message from the specified reader or buffer, length delimited.
       * @function decodeDelimited
       * @memberof propel.commrouter.AccessToken
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @returns {propel.commrouter.AccessToken} AccessToken
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      AccessToken.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader)) reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
      };

      /**
       * Verifies an AccessToken message.
       * @function verify
       * @memberof propel.commrouter.AccessToken
       * @static
       * @param {Object.<string,*>} message Plain object to verify
       * @returns {string|null} `null` if valid, otherwise the reason why it is not
       */
      AccessToken.verify = function verify(message) {
        if (typeof message !== 'object' || message === null) return 'object expected';
        if (message.accessToken != null && message.hasOwnProperty('accessToken'))
          if (!$util.isString(message.accessToken)) return 'accessToken: string expected';
        return null;
      };

      /**
       * Creates an AccessToken message from a plain object. Also converts values to their respective internal types.
       * @function fromObject
       * @memberof propel.commrouter.AccessToken
       * @static
       * @param {Object.<string,*>} object Plain object
       * @returns {propel.commrouter.AccessToken} AccessToken
       */
      AccessToken.fromObject = function fromObject(object) {
        if (object instanceof $root.propel.commrouter.AccessToken) return object;
        var message = new $root.propel.commrouter.AccessToken();
        if (object.accessToken != null) message.accessToken = String(object.accessToken);
        return message;
      };

      /**
       * Creates a plain object from an AccessToken message. Also converts values to other types if specified.
       * @function toObject
       * @memberof propel.commrouter.AccessToken
       * @static
       * @param {propel.commrouter.AccessToken} message AccessToken
       * @param {$protobuf.IConversionOptions} [options] Conversion options
       * @returns {Object.<string,*>} Plain object
       */
      AccessToken.toObject = function toObject(message, options) {
        if (!options) options = {};
        var object = {};
        if (options.defaults) object.accessToken = '';
        if (message.accessToken != null && message.hasOwnProperty('accessToken'))
          object.accessToken = message.accessToken;
        return object;
      };

      /**
       * Converts this AccessToken to JSON.
       * @function toJSON
       * @memberof propel.commrouter.AccessToken
       * @instance
       * @returns {Object.<string,*>} JSON object
       */
      AccessToken.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
      };

      return AccessToken;
    })();

    commrouter.Avatar = (function () {
      /**
       * Properties of an Avatar.
       * @memberof propel.commrouter
       * @interface IAvatar
       * @property {propel.commrouter.IVendorId|null} [id] Avatar id
       * @property {propel.commrouter.IVendorId|null} [channelId] Avatar channelId
       * @property {string|null} [name] Avatar name
       * @property {propel.commrouter.Avatar.Type|null} [type] Avatar type
       * @property {propel.commrouter.Avatar.Presence|null} [presence] Avatar presence
       * @property {google.protobuf.IStruct|null} [info] Avatar info
       */

      /**
       * Constructs a new Avatar.
       * @memberof propel.commrouter
       * @classdesc Represents an Avatar.
       * @implements IAvatar
       * @constructor
       * @param {propel.commrouter.IAvatar=} [properties] Properties to set
       */
      function Avatar(properties) {
        if (properties)
          for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
      }

      /**
       * Avatar id.
       * @member {propel.commrouter.IVendorId|null|undefined} id
       * @memberof propel.commrouter.Avatar
       * @instance
       */
      Avatar.prototype.id = null;

      /**
       * Avatar channelId.
       * @member {propel.commrouter.IVendorId|null|undefined} channelId
       * @memberof propel.commrouter.Avatar
       * @instance
       */
      Avatar.prototype.channelId = null;

      /**
       * Avatar name.
       * @member {string} name
       * @memberof propel.commrouter.Avatar
       * @instance
       */
      Avatar.prototype.name = '';

      /**
       * Avatar type.
       * @member {propel.commrouter.Avatar.Type} type
       * @memberof propel.commrouter.Avatar
       * @instance
       */
      Avatar.prototype.type = 0;

      /**
       * Avatar presence.
       * @member {propel.commrouter.Avatar.Presence} presence
       * @memberof propel.commrouter.Avatar
       * @instance
       */
      Avatar.prototype.presence = 0;

      /**
       * Avatar info.
       * @member {google.protobuf.IStruct|null|undefined} info
       * @memberof propel.commrouter.Avatar
       * @instance
       */
      Avatar.prototype.info = null;

      /**
       * Creates a new Avatar instance using the specified properties.
       * @function create
       * @memberof propel.commrouter.Avatar
       * @static
       * @param {propel.commrouter.IAvatar=} [properties] Properties to set
       * @returns {propel.commrouter.Avatar} Avatar instance
       */
      Avatar.create = function create(properties) {
        return new Avatar(properties);
      };

      /**
       * Encodes the specified Avatar message. Does not implicitly {@link propel.commrouter.Avatar.verify|verify} messages.
       * @function encode
       * @memberof propel.commrouter.Avatar
       * @static
       * @param {propel.commrouter.IAvatar} message Avatar message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      Avatar.encode = function encode(message, writer) {
        if (!writer) writer = $Writer.create();
        if (message.id != null && message.hasOwnProperty('id'))
          $root.propel.commrouter.VendorId.encode(
            message.id,
            writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
          ).ldelim();
        if (message.channelId != null && message.hasOwnProperty('channelId'))
          $root.propel.commrouter.VendorId.encode(
            message.channelId,
            writer.uint32(/* id 2, wireType 2 =*/ 18).fork()
          ).ldelim();
        if (message.name != null && message.hasOwnProperty('name'))
          writer.uint32(/* id 3, wireType 2 =*/ 26).string(message.name);
        if (message.type != null && message.hasOwnProperty('type'))
          writer.uint32(/* id 4, wireType 0 =*/ 32).int32(message.type);
        if (message.presence != null && message.hasOwnProperty('presence'))
          writer.uint32(/* id 5, wireType 0 =*/ 40).int32(message.presence);
        if (message.info != null && message.hasOwnProperty('info'))
          $root.google.protobuf.Struct.encode(
            message.info,
            writer.uint32(/* id 7, wireType 2 =*/ 58).fork()
          ).ldelim();
        return writer;
      };

      /**
       * Encodes the specified Avatar message, length delimited. Does not implicitly {@link propel.commrouter.Avatar.verify|verify} messages.
       * @function encodeDelimited
       * @memberof propel.commrouter.Avatar
       * @static
       * @param {propel.commrouter.IAvatar} message Avatar message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      Avatar.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
      };

      /**
       * Decodes an Avatar message from the specified reader or buffer.
       * @function decode
       * @memberof propel.commrouter.Avatar
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @param {number} [length] Message length if known beforehand
       * @returns {propel.commrouter.Avatar} Avatar
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      Avatar.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length,
          message = new $root.propel.commrouter.Avatar();
        while (reader.pos < end) {
          var tag = reader.uint32();
          switch (tag >>> 3) {
            case 1:
              message.id = $root.propel.commrouter.VendorId.decode(reader, reader.uint32());
              break;
            case 2:
              message.channelId = $root.propel.commrouter.VendorId.decode(reader, reader.uint32());
              break;
            case 3:
              message.name = reader.string();
              break;
            case 4:
              message.type = reader.int32();
              break;
            case 5:
              message.presence = reader.int32();
              break;
            case 7:
              message.info = $root.google.protobuf.Struct.decode(reader, reader.uint32());
              break;
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };

      /**
       * Decodes an Avatar message from the specified reader or buffer, length delimited.
       * @function decodeDelimited
       * @memberof propel.commrouter.Avatar
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @returns {propel.commrouter.Avatar} Avatar
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      Avatar.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader)) reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
      };

      /**
       * Verifies an Avatar message.
       * @function verify
       * @memberof propel.commrouter.Avatar
       * @static
       * @param {Object.<string,*>} message Plain object to verify
       * @returns {string|null} `null` if valid, otherwise the reason why it is not
       */
      Avatar.verify = function verify(message) {
        if (typeof message !== 'object' || message === null) return 'object expected';
        if (message.id != null && message.hasOwnProperty('id')) {
          var error = $root.propel.commrouter.VendorId.verify(message.id);
          if (error) return 'id.' + error;
        }
        if (message.channelId != null && message.hasOwnProperty('channelId')) {
          var error = $root.propel.commrouter.VendorId.verify(message.channelId);
          if (error) return 'channelId.' + error;
        }
        if (message.name != null && message.hasOwnProperty('name'))
          if (!$util.isString(message.name)) return 'name: string expected';
        if (message.type != null && message.hasOwnProperty('type'))
          switch (message.type) {
            default:
              return 'type: enum value expected';
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
              break;
          }
        if (message.presence != null && message.hasOwnProperty('presence'))
          switch (message.presence) {
            default:
              return 'presence: enum value expected';
            case 0:
            case 1:
            case 2:
              break;
          }
        if (message.info != null && message.hasOwnProperty('info')) {
          var error = $root.google.protobuf.Struct.verify(message.info);
          if (error) return 'info.' + error;
        }
        return null;
      };

      /**
       * Creates an Avatar message from a plain object. Also converts values to their respective internal types.
       * @function fromObject
       * @memberof propel.commrouter.Avatar
       * @static
       * @param {Object.<string,*>} object Plain object
       * @returns {propel.commrouter.Avatar} Avatar
       */
      Avatar.fromObject = function fromObject(object) {
        if (object instanceof $root.propel.commrouter.Avatar) return object;
        var message = new $root.propel.commrouter.Avatar();
        if (object.id != null) {
          if (typeof object.id !== 'object')
            throw TypeError('.propel.commrouter.Avatar.id: object expected');
          message.id = $root.propel.commrouter.VendorId.fromObject(object.id);
        }
        if (object.channelId != null) {
          if (typeof object.channelId !== 'object')
            throw TypeError('.propel.commrouter.Avatar.channelId: object expected');
          message.channelId = $root.propel.commrouter.VendorId.fromObject(object.channelId);
        }
        if (object.name != null) message.name = String(object.name);
        switch (object.type) {
          case 'AVATAR_UNKNOWN':
          case 0:
            message.type = 0;
            break;
          case 'AVATAR_CUSTOMER':
          case 1:
            message.type = 1;
            break;
          case 'AVATAR_AI':
          case 2:
            message.type = 2;
            break;
          case 'AVATAR_SUPPORT':
          case 3:
            message.type = 3;
            break;
          case 'AVATAR_VIEWER':
          case 4:
            message.type = 4;
            break;
        }
        switch (object.presence) {
          case 'PRESENCE_UNKNOWN':
          case 0:
            message.presence = 0;
            break;
          case 'PRESENCE_PRESENT':
          case 1:
            message.presence = 1;
            break;
          case 'PRESENCE_NOT_PRESENT':
          case 2:
            message.presence = 2;
            break;
        }
        if (object.info != null) {
          if (typeof object.info !== 'object')
            throw TypeError('.propel.commrouter.Avatar.info: object expected');
          message.info = $root.google.protobuf.Struct.fromObject(object.info);
        }
        return message;
      };

      /**
       * Creates a plain object from an Avatar message. Also converts values to other types if specified.
       * @function toObject
       * @memberof propel.commrouter.Avatar
       * @static
       * @param {propel.commrouter.Avatar} message Avatar
       * @param {$protobuf.IConversionOptions} [options] Conversion options
       * @returns {Object.<string,*>} Plain object
       */
      Avatar.toObject = function toObject(message, options) {
        if (!options) options = {};
        var object = {};
        if (options.defaults) {
          object.id = null;
          object.channelId = null;
          object.name = '';
          object.type = options.enums === String ? 'AVATAR_UNKNOWN' : 0;
          object.presence = options.enums === String ? 'PRESENCE_UNKNOWN' : 0;
          object.info = null;
        }
        if (message.id != null && message.hasOwnProperty('id'))
          object.id = $root.propel.commrouter.VendorId.toObject(message.id, options);
        if (message.channelId != null && message.hasOwnProperty('channelId'))
          object.channelId = $root.propel.commrouter.VendorId.toObject(message.channelId, options);
        if (message.name != null && message.hasOwnProperty('name')) object.name = message.name;
        if (message.type != null && message.hasOwnProperty('type'))
          object.type =
            options.enums === String
              ? $root.propel.commrouter.Avatar.Type[message.type]
              : message.type;
        if (message.presence != null && message.hasOwnProperty('presence'))
          object.presence =
            options.enums === String
              ? $root.propel.commrouter.Avatar.Presence[message.presence]
              : message.presence;
        if (message.info != null && message.hasOwnProperty('info'))
          object.info = $root.google.protobuf.Struct.toObject(message.info, options);
        return object;
      };

      /**
       * Converts this Avatar to JSON.
       * @function toJSON
       * @memberof propel.commrouter.Avatar
       * @instance
       * @returns {Object.<string,*>} JSON object
       */
      Avatar.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
      };

      /**
       * Type enum.
       * @name propel.commrouter.Avatar.Type
       * @enum {string}
       * @property {number} AVATAR_UNKNOWN=0 AVATAR_UNKNOWN value
       * @property {number} AVATAR_CUSTOMER=1 AVATAR_CUSTOMER value
       * @property {number} AVATAR_AI=2 AVATAR_AI value
       * @property {number} AVATAR_SUPPORT=3 AVATAR_SUPPORT value
       * @property {number} AVATAR_VIEWER=4 AVATAR_VIEWER value
       */
      Avatar.Type = (function () {
        var valuesById = {},
          values = Object.create(valuesById);
        values[(valuesById[0] = 'AVATAR_UNKNOWN')] = 0;
        values[(valuesById[1] = 'AVATAR_CUSTOMER')] = 1;
        values[(valuesById[2] = 'AVATAR_AI')] = 2;
        values[(valuesById[3] = 'AVATAR_SUPPORT')] = 3;
        values[(valuesById[4] = 'AVATAR_VIEWER')] = 4;
        return values;
      })();

      /**
       * Presence enum.
       * @name propel.commrouter.Avatar.Presence
       * @enum {string}
       * @property {number} PRESENCE_UNKNOWN=0 PRESENCE_UNKNOWN value
       * @property {number} PRESENCE_PRESENT=1 PRESENCE_PRESENT value
       * @property {number} PRESENCE_NOT_PRESENT=2 PRESENCE_NOT_PRESENT value
       */
      Avatar.Presence = (function () {
        var valuesById = {},
          values = Object.create(valuesById);
        values[(valuesById[0] = 'PRESENCE_UNKNOWN')] = 0;
        values[(valuesById[1] = 'PRESENCE_PRESENT')] = 1;
        values[(valuesById[2] = 'PRESENCE_NOT_PRESENT')] = 2;
        return values;
      })();

      return Avatar;
    })();

    commrouter.ConversationCommand = (function () {
      /**
       * Properties of a ConversationCommand.
       * @memberof propel.commrouter
       * @interface IConversationCommand
       * @property {string|null} [id] ConversationCommand id
       * @property {propel.commrouter.ConversationCommand.IUpdateConversation|null} [updateConversation] ConversationCommand updateConversation
       * @property {propel.commrouter.ConversationCommand.IPutAvatar|null} [putAvatar] ConversationCommand putAvatar
       * @property {propel.commrouter.ConversationCommand.IUpdateAvatar|null} [updateAvatar] ConversationCommand updateAvatar
       * @property {propel.commrouter.ConversationCommand.ICreateMessage|null} [createMessage] ConversationCommand createMessage
       * @property {propel.commrouter.ConversationCommand.IUpdateMessage|null} [updateMessage] ConversationCommand updateMessage
       * @property {propel.commrouter.ConversationCommand.ICreateResponse|null} [createResponse] ConversationCommand createResponse
       * @property {propel.commrouter.ConversationCommand.IUpdateSentence|null} [updateSentence] ConversationCommand updateSentence
       * @property {propel.commrouter.ConversationCommand.IPutConversationState|null} [putConversationState] ConversationCommand putConversationState
       * @property {propel.commrouter.ConversationCommand.IPutContext|null} [putContext] ConversationCommand putContext
       * @property {propel.commrouter.ConversationCommand.IPutResponse|null} [putResponse] ConversationCommand putResponse
       * @property {propel.commrouter.ConversationCommand.ICreateResponseMessage|null} [createResponseMessage] ConversationCommand createResponseMessage
       * @property {propel.commrouter.ConversationCommand.IPutConversationMode|null} [putConversationMode] ConversationCommand putConversationMode
       * @property {propel.commrouter.ConversationCommand.IUpdateConversationMode|null} [updateConversationMode] ConversationCommand updateConversationMode
       * @property {propel.commrouter.ConversationCommand.IPutVendorInfo|null} [putVendorInfo] ConversationCommand putVendorInfo
       * @property {propel.commrouter.ConversationCommand.ICreateIncomingLead|null} [createIncomingLead] ConversationCommand createIncomingLead
       * @property {propel.commrouter.ConversationCommand.ICreateTag|null} [createTag] ConversationCommand createTag
       * @property {propel.commrouter.ConversationCommand.IDeleteTag|null} [deleteTag] ConversationCommand deleteTag
       */

      /**
       * Constructs a new ConversationCommand.
       * @memberof propel.commrouter
       * @classdesc Represents a ConversationCommand.
       * @implements IConversationCommand
       * @constructor
       * @param {propel.commrouter.IConversationCommand=} [properties] Properties to set
       */
      function ConversationCommand(properties) {
        if (properties)
          for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
      }

      /**
       * ConversationCommand id.
       * @member {string} id
       * @memberof propel.commrouter.ConversationCommand
       * @instance
       */
      ConversationCommand.prototype.id = '';

      /**
       * ConversationCommand updateConversation.
       * @member {propel.commrouter.ConversationCommand.IUpdateConversation|null|undefined} updateConversation
       * @memberof propel.commrouter.ConversationCommand
       * @instance
       */
      ConversationCommand.prototype.updateConversation = null;

      /**
       * ConversationCommand putAvatar.
       * @member {propel.commrouter.ConversationCommand.IPutAvatar|null|undefined} putAvatar
       * @memberof propel.commrouter.ConversationCommand
       * @instance
       */
      ConversationCommand.prototype.putAvatar = null;

      /**
       * ConversationCommand updateAvatar.
       * @member {propel.commrouter.ConversationCommand.IUpdateAvatar|null|undefined} updateAvatar
       * @memberof propel.commrouter.ConversationCommand
       * @instance
       */
      ConversationCommand.prototype.updateAvatar = null;

      /**
       * ConversationCommand createMessage.
       * @member {propel.commrouter.ConversationCommand.ICreateMessage|null|undefined} createMessage
       * @memberof propel.commrouter.ConversationCommand
       * @instance
       */
      ConversationCommand.prototype.createMessage = null;

      /**
       * ConversationCommand updateMessage.
       * @member {propel.commrouter.ConversationCommand.IUpdateMessage|null|undefined} updateMessage
       * @memberof propel.commrouter.ConversationCommand
       * @instance
       */
      ConversationCommand.prototype.updateMessage = null;

      /**
       * ConversationCommand createResponse.
       * @member {propel.commrouter.ConversationCommand.ICreateResponse|null|undefined} createResponse
       * @memberof propel.commrouter.ConversationCommand
       * @instance
       */
      ConversationCommand.prototype.createResponse = null;

      /**
       * ConversationCommand updateSentence.
       * @member {propel.commrouter.ConversationCommand.IUpdateSentence|null|undefined} updateSentence
       * @memberof propel.commrouter.ConversationCommand
       * @instance
       */
      ConversationCommand.prototype.updateSentence = null;

      /**
       * ConversationCommand putConversationState.
       * @member {propel.commrouter.ConversationCommand.IPutConversationState|null|undefined} putConversationState
       * @memberof propel.commrouter.ConversationCommand
       * @instance
       */
      ConversationCommand.prototype.putConversationState = null;

      /**
       * ConversationCommand putContext.
       * @member {propel.commrouter.ConversationCommand.IPutContext|null|undefined} putContext
       * @memberof propel.commrouter.ConversationCommand
       * @instance
       */
      ConversationCommand.prototype.putContext = null;

      /**
       * ConversationCommand putResponse.
       * @member {propel.commrouter.ConversationCommand.IPutResponse|null|undefined} putResponse
       * @memberof propel.commrouter.ConversationCommand
       * @instance
       */
      ConversationCommand.prototype.putResponse = null;

      /**
       * ConversationCommand createResponseMessage.
       * @member {propel.commrouter.ConversationCommand.ICreateResponseMessage|null|undefined} createResponseMessage
       * @memberof propel.commrouter.ConversationCommand
       * @instance
       */
      ConversationCommand.prototype.createResponseMessage = null;

      /**
       * ConversationCommand putConversationMode.
       * @member {propel.commrouter.ConversationCommand.IPutConversationMode|null|undefined} putConversationMode
       * @memberof propel.commrouter.ConversationCommand
       * @instance
       */
      ConversationCommand.prototype.putConversationMode = null;

      /**
       * ConversationCommand updateConversationMode.
       * @member {propel.commrouter.ConversationCommand.IUpdateConversationMode|null|undefined} updateConversationMode
       * @memberof propel.commrouter.ConversationCommand
       * @instance
       */
      ConversationCommand.prototype.updateConversationMode = null;

      /**
       * ConversationCommand putVendorInfo.
       * @member {propel.commrouter.ConversationCommand.IPutVendorInfo|null|undefined} putVendorInfo
       * @memberof propel.commrouter.ConversationCommand
       * @instance
       */
      ConversationCommand.prototype.putVendorInfo = null;

      /**
       * ConversationCommand createIncomingLead.
       * @member {propel.commrouter.ConversationCommand.ICreateIncomingLead|null|undefined} createIncomingLead
       * @memberof propel.commrouter.ConversationCommand
       * @instance
       */
      ConversationCommand.prototype.createIncomingLead = null;

      /**
       * ConversationCommand createTag.
       * @member {propel.commrouter.ConversationCommand.ICreateTag|null|undefined} createTag
       * @memberof propel.commrouter.ConversationCommand
       * @instance
       */
      ConversationCommand.prototype.createTag = null;

      /**
       * ConversationCommand deleteTag.
       * @member {propel.commrouter.ConversationCommand.IDeleteTag|null|undefined} deleteTag
       * @memberof propel.commrouter.ConversationCommand
       * @instance
       */
      ConversationCommand.prototype.deleteTag = null;

      // OneOf field names bound to virtual getters and setters
      var $oneOfFields;

      /**
       * ConversationCommand command.
       * @member {"updateConversation"|"putAvatar"|"updateAvatar"|"createMessage"|"updateMessage"|"createResponse"|"updateSentence"|"putConversationState"|"putContext"|"putResponse"|"createResponseMessage"|"putConversationMode"|"updateConversationMode"|"putVendorInfo"|"createIncomingLead"|"createTag"|"deleteTag"|undefined} command
       * @memberof propel.commrouter.ConversationCommand
       * @instance
       */
      Object.defineProperty(ConversationCommand.prototype, 'command', {
        get: $util.oneOfGetter(
          ($oneOfFields = [
            'updateConversation',
            'putAvatar',
            'updateAvatar',
            'createMessage',
            'updateMessage',
            'createResponse',
            'updateSentence',
            'putConversationState',
            'putContext',
            'putResponse',
            'createResponseMessage',
            'putConversationMode',
            'updateConversationMode',
            'putVendorInfo',
            'createIncomingLead',
            'createTag',
            'deleteTag',
          ])
        ),
        set: $util.oneOfSetter($oneOfFields),
      });

      /**
       * Creates a new ConversationCommand instance using the specified properties.
       * @function create
       * @memberof propel.commrouter.ConversationCommand
       * @static
       * @param {propel.commrouter.IConversationCommand=} [properties] Properties to set
       * @returns {propel.commrouter.ConversationCommand} ConversationCommand instance
       */
      ConversationCommand.create = function create(properties) {
        return new ConversationCommand(properties);
      };

      /**
       * Encodes the specified ConversationCommand message. Does not implicitly {@link propel.commrouter.ConversationCommand.verify|verify} messages.
       * @function encode
       * @memberof propel.commrouter.ConversationCommand
       * @static
       * @param {propel.commrouter.IConversationCommand} message ConversationCommand message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      ConversationCommand.encode = function encode(message, writer) {
        if (!writer) writer = $Writer.create();
        if (message.id != null && message.hasOwnProperty('id'))
          writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
        if (message.updateConversation != null && message.hasOwnProperty('updateConversation'))
          $root.propel.commrouter.ConversationCommand.UpdateConversation.encode(
            message.updateConversation,
            writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
          ).ldelim();
        if (message.putAvatar != null && message.hasOwnProperty('putAvatar'))
          $root.propel.commrouter.ConversationCommand.PutAvatar.encode(
            message.putAvatar,
            writer.uint32(/* id 101, wireType 2 =*/ 810).fork()
          ).ldelim();
        if (message.updateAvatar != null && message.hasOwnProperty('updateAvatar'))
          $root.propel.commrouter.ConversationCommand.UpdateAvatar.encode(
            message.updateAvatar,
            writer.uint32(/* id 102, wireType 2 =*/ 818).fork()
          ).ldelim();
        if (message.createMessage != null && message.hasOwnProperty('createMessage'))
          $root.propel.commrouter.ConversationCommand.CreateMessage.encode(
            message.createMessage,
            writer.uint32(/* id 103, wireType 2 =*/ 826).fork()
          ).ldelim();
        if (message.updateMessage != null && message.hasOwnProperty('updateMessage'))
          $root.propel.commrouter.ConversationCommand.UpdateMessage.encode(
            message.updateMessage,
            writer.uint32(/* id 104, wireType 2 =*/ 834).fork()
          ).ldelim();
        if (message.createResponse != null && message.hasOwnProperty('createResponse'))
          $root.propel.commrouter.ConversationCommand.CreateResponse.encode(
            message.createResponse,
            writer.uint32(/* id 105, wireType 2 =*/ 842).fork()
          ).ldelim();
        if (message.updateSentence != null && message.hasOwnProperty('updateSentence'))
          $root.propel.commrouter.ConversationCommand.UpdateSentence.encode(
            message.updateSentence,
            writer.uint32(/* id 106, wireType 2 =*/ 850).fork()
          ).ldelim();
        if (message.putConversationState != null && message.hasOwnProperty('putConversationState'))
          $root.propel.commrouter.ConversationCommand.PutConversationState.encode(
            message.putConversationState,
            writer.uint32(/* id 107, wireType 2 =*/ 858).fork()
          ).ldelim();
        if (message.putContext != null && message.hasOwnProperty('putContext'))
          $root.propel.commrouter.ConversationCommand.PutContext.encode(
            message.putContext,
            writer.uint32(/* id 108, wireType 2 =*/ 866).fork()
          ).ldelim();
        if (message.putResponse != null && message.hasOwnProperty('putResponse'))
          $root.propel.commrouter.ConversationCommand.PutResponse.encode(
            message.putResponse,
            writer.uint32(/* id 109, wireType 2 =*/ 874).fork()
          ).ldelim();
        if (
          message.createResponseMessage != null &&
          message.hasOwnProperty('createResponseMessage')
        )
          $root.propel.commrouter.ConversationCommand.CreateResponseMessage.encode(
            message.createResponseMessage,
            writer.uint32(/* id 110, wireType 2 =*/ 882).fork()
          ).ldelim();
        if (message.putConversationMode != null && message.hasOwnProperty('putConversationMode'))
          $root.propel.commrouter.ConversationCommand.PutConversationMode.encode(
            message.putConversationMode,
            writer.uint32(/* id 111, wireType 2 =*/ 890).fork()
          ).ldelim();
        if (
          message.updateConversationMode != null &&
          message.hasOwnProperty('updateConversationMode')
        )
          $root.propel.commrouter.ConversationCommand.UpdateConversationMode.encode(
            message.updateConversationMode,
            writer.uint32(/* id 112, wireType 2 =*/ 898).fork()
          ).ldelim();
        if (message.putVendorInfo != null && message.hasOwnProperty('putVendorInfo'))
          $root.propel.commrouter.ConversationCommand.PutVendorInfo.encode(
            message.putVendorInfo,
            writer.uint32(/* id 113, wireType 2 =*/ 906).fork()
          ).ldelim();
        if (message.createIncomingLead != null && message.hasOwnProperty('createIncomingLead'))
          $root.propel.commrouter.ConversationCommand.CreateIncomingLead.encode(
            message.createIncomingLead,
            writer.uint32(/* id 114, wireType 2 =*/ 914).fork()
          ).ldelim();
        if (message.createTag != null && message.hasOwnProperty('createTag'))
          $root.propel.commrouter.ConversationCommand.CreateTag.encode(
            message.createTag,
            writer.uint32(/* id 115, wireType 2 =*/ 922).fork()
          ).ldelim();
        if (message.deleteTag != null && message.hasOwnProperty('deleteTag'))
          $root.propel.commrouter.ConversationCommand.DeleteTag.encode(
            message.deleteTag,
            writer.uint32(/* id 116, wireType 2 =*/ 930).fork()
          ).ldelim();
        return writer;
      };

      /**
       * Encodes the specified ConversationCommand message, length delimited. Does not implicitly {@link propel.commrouter.ConversationCommand.verify|verify} messages.
       * @function encodeDelimited
       * @memberof propel.commrouter.ConversationCommand
       * @static
       * @param {propel.commrouter.IConversationCommand} message ConversationCommand message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      ConversationCommand.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
      };

      /**
       * Decodes a ConversationCommand message from the specified reader or buffer.
       * @function decode
       * @memberof propel.commrouter.ConversationCommand
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @param {number} [length] Message length if known beforehand
       * @returns {propel.commrouter.ConversationCommand} ConversationCommand
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      ConversationCommand.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length,
          message = new $root.propel.commrouter.ConversationCommand();
        while (reader.pos < end) {
          var tag = reader.uint32();
          switch (tag >>> 3) {
            case 1:
              message.id = reader.string();
              break;
            case 100:
              message.updateConversation =
                $root.propel.commrouter.ConversationCommand.UpdateConversation.decode(
                  reader,
                  reader.uint32()
                );
              break;
            case 101:
              message.putAvatar = $root.propel.commrouter.ConversationCommand.PutAvatar.decode(
                reader,
                reader.uint32()
              );
              break;
            case 102:
              message.updateAvatar =
                $root.propel.commrouter.ConversationCommand.UpdateAvatar.decode(
                  reader,
                  reader.uint32()
                );
              break;
            case 103:
              message.createMessage =
                $root.propel.commrouter.ConversationCommand.CreateMessage.decode(
                  reader,
                  reader.uint32()
                );
              break;
            case 104:
              message.updateMessage =
                $root.propel.commrouter.ConversationCommand.UpdateMessage.decode(
                  reader,
                  reader.uint32()
                );
              break;
            case 105:
              message.createResponse =
                $root.propel.commrouter.ConversationCommand.CreateResponse.decode(
                  reader,
                  reader.uint32()
                );
              break;
            case 106:
              message.updateSentence =
                $root.propel.commrouter.ConversationCommand.UpdateSentence.decode(
                  reader,
                  reader.uint32()
                );
              break;
            case 107:
              message.putConversationState =
                $root.propel.commrouter.ConversationCommand.PutConversationState.decode(
                  reader,
                  reader.uint32()
                );
              break;
            case 108:
              message.putContext = $root.propel.commrouter.ConversationCommand.PutContext.decode(
                reader,
                reader.uint32()
              );
              break;
            case 109:
              message.putResponse = $root.propel.commrouter.ConversationCommand.PutResponse.decode(
                reader,
                reader.uint32()
              );
              break;
            case 110:
              message.createResponseMessage =
                $root.propel.commrouter.ConversationCommand.CreateResponseMessage.decode(
                  reader,
                  reader.uint32()
                );
              break;
            case 111:
              message.putConversationMode =
                $root.propel.commrouter.ConversationCommand.PutConversationMode.decode(
                  reader,
                  reader.uint32()
                );
              break;
            case 112:
              message.updateConversationMode =
                $root.propel.commrouter.ConversationCommand.UpdateConversationMode.decode(
                  reader,
                  reader.uint32()
                );
              break;
            case 113:
              message.putVendorInfo =
                $root.propel.commrouter.ConversationCommand.PutVendorInfo.decode(
                  reader,
                  reader.uint32()
                );
              break;
            case 114:
              message.createIncomingLead =
                $root.propel.commrouter.ConversationCommand.CreateIncomingLead.decode(
                  reader,
                  reader.uint32()
                );
              break;
            case 115:
              message.createTag = $root.propel.commrouter.ConversationCommand.CreateTag.decode(
                reader,
                reader.uint32()
              );
              break;
            case 116:
              message.deleteTag = $root.propel.commrouter.ConversationCommand.DeleteTag.decode(
                reader,
                reader.uint32()
              );
              break;
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };

      /**
       * Decodes a ConversationCommand message from the specified reader or buffer, length delimited.
       * @function decodeDelimited
       * @memberof propel.commrouter.ConversationCommand
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @returns {propel.commrouter.ConversationCommand} ConversationCommand
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      ConversationCommand.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader)) reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
      };

      /**
       * Verifies a ConversationCommand message.
       * @function verify
       * @memberof propel.commrouter.ConversationCommand
       * @static
       * @param {Object.<string,*>} message Plain object to verify
       * @returns {string|null} `null` if valid, otherwise the reason why it is not
       */
      ConversationCommand.verify = function verify(message) {
        if (typeof message !== 'object' || message === null) return 'object expected';
        var properties = {};
        if (message.id != null && message.hasOwnProperty('id'))
          if (!$util.isString(message.id)) return 'id: string expected';
        if (message.updateConversation != null && message.hasOwnProperty('updateConversation')) {
          properties.command = 1;
          {
            var error = $root.propel.commrouter.ConversationCommand.UpdateConversation.verify(
              message.updateConversation
            );
            if (error) return 'updateConversation.' + error;
          }
        }
        if (message.putAvatar != null && message.hasOwnProperty('putAvatar')) {
          if (properties.command === 1) return 'command: multiple values';
          properties.command = 1;
          {
            var error = $root.propel.commrouter.ConversationCommand.PutAvatar.verify(
              message.putAvatar
            );
            if (error) return 'putAvatar.' + error;
          }
        }
        if (message.updateAvatar != null && message.hasOwnProperty('updateAvatar')) {
          if (properties.command === 1) return 'command: multiple values';
          properties.command = 1;
          {
            var error = $root.propel.commrouter.ConversationCommand.UpdateAvatar.verify(
              message.updateAvatar
            );
            if (error) return 'updateAvatar.' + error;
          }
        }
        if (message.createMessage != null && message.hasOwnProperty('createMessage')) {
          if (properties.command === 1) return 'command: multiple values';
          properties.command = 1;
          {
            var error = $root.propel.commrouter.ConversationCommand.CreateMessage.verify(
              message.createMessage
            );
            if (error) return 'createMessage.' + error;
          }
        }
        if (message.updateMessage != null && message.hasOwnProperty('updateMessage')) {
          if (properties.command === 1) return 'command: multiple values';
          properties.command = 1;
          {
            var error = $root.propel.commrouter.ConversationCommand.UpdateMessage.verify(
              message.updateMessage
            );
            if (error) return 'updateMessage.' + error;
          }
        }
        if (message.createResponse != null && message.hasOwnProperty('createResponse')) {
          if (properties.command === 1) return 'command: multiple values';
          properties.command = 1;
          {
            var error = $root.propel.commrouter.ConversationCommand.CreateResponse.verify(
              message.createResponse
            );
            if (error) return 'createResponse.' + error;
          }
        }
        if (message.updateSentence != null && message.hasOwnProperty('updateSentence')) {
          if (properties.command === 1) return 'command: multiple values';
          properties.command = 1;
          {
            var error = $root.propel.commrouter.ConversationCommand.UpdateSentence.verify(
              message.updateSentence
            );
            if (error) return 'updateSentence.' + error;
          }
        }
        if (
          message.putConversationState != null &&
          message.hasOwnProperty('putConversationState')
        ) {
          if (properties.command === 1) return 'command: multiple values';
          properties.command = 1;
          {
            var error = $root.propel.commrouter.ConversationCommand.PutConversationState.verify(
              message.putConversationState
            );
            if (error) return 'putConversationState.' + error;
          }
        }
        if (message.putContext != null && message.hasOwnProperty('putContext')) {
          if (properties.command === 1) return 'command: multiple values';
          properties.command = 1;
          {
            var error = $root.propel.commrouter.ConversationCommand.PutContext.verify(
              message.putContext
            );
            if (error) return 'putContext.' + error;
          }
        }
        if (message.putResponse != null && message.hasOwnProperty('putResponse')) {
          if (properties.command === 1) return 'command: multiple values';
          properties.command = 1;
          {
            var error = $root.propel.commrouter.ConversationCommand.PutResponse.verify(
              message.putResponse
            );
            if (error) return 'putResponse.' + error;
          }
        }
        if (
          message.createResponseMessage != null &&
          message.hasOwnProperty('createResponseMessage')
        ) {
          if (properties.command === 1) return 'command: multiple values';
          properties.command = 1;
          {
            var error = $root.propel.commrouter.ConversationCommand.CreateResponseMessage.verify(
              message.createResponseMessage
            );
            if (error) return 'createResponseMessage.' + error;
          }
        }
        if (message.putConversationMode != null && message.hasOwnProperty('putConversationMode')) {
          if (properties.command === 1) return 'command: multiple values';
          properties.command = 1;
          {
            var error = $root.propel.commrouter.ConversationCommand.PutConversationMode.verify(
              message.putConversationMode
            );
            if (error) return 'putConversationMode.' + error;
          }
        }
        if (
          message.updateConversationMode != null &&
          message.hasOwnProperty('updateConversationMode')
        ) {
          if (properties.command === 1) return 'command: multiple values';
          properties.command = 1;
          {
            var error = $root.propel.commrouter.ConversationCommand.UpdateConversationMode.verify(
              message.updateConversationMode
            );
            if (error) return 'updateConversationMode.' + error;
          }
        }
        if (message.putVendorInfo != null && message.hasOwnProperty('putVendorInfo')) {
          if (properties.command === 1) return 'command: multiple values';
          properties.command = 1;
          {
            var error = $root.propel.commrouter.ConversationCommand.PutVendorInfo.verify(
              message.putVendorInfo
            );
            if (error) return 'putVendorInfo.' + error;
          }
        }
        if (message.createIncomingLead != null && message.hasOwnProperty('createIncomingLead')) {
          if (properties.command === 1) return 'command: multiple values';
          properties.command = 1;
          {
            var error = $root.propel.commrouter.ConversationCommand.CreateIncomingLead.verify(
              message.createIncomingLead
            );
            if (error) return 'createIncomingLead.' + error;
          }
        }
        if (message.createTag != null && message.hasOwnProperty('createTag')) {
          if (properties.command === 1) return 'command: multiple values';
          properties.command = 1;
          {
            var error = $root.propel.commrouter.ConversationCommand.CreateTag.verify(
              message.createTag
            );
            if (error) return 'createTag.' + error;
          }
        }
        if (message.deleteTag != null && message.hasOwnProperty('deleteTag')) {
          if (properties.command === 1) return 'command: multiple values';
          properties.command = 1;
          {
            var error = $root.propel.commrouter.ConversationCommand.DeleteTag.verify(
              message.deleteTag
            );
            if (error) return 'deleteTag.' + error;
          }
        }
        return null;
      };

      /**
       * Creates a ConversationCommand message from a plain object. Also converts values to their respective internal types.
       * @function fromObject
       * @memberof propel.commrouter.ConversationCommand
       * @static
       * @param {Object.<string,*>} object Plain object
       * @returns {propel.commrouter.ConversationCommand} ConversationCommand
       */
      ConversationCommand.fromObject = function fromObject(object) {
        if (object instanceof $root.propel.commrouter.ConversationCommand) return object;
        var message = new $root.propel.commrouter.ConversationCommand();
        if (object.id != null) message.id = String(object.id);
        if (object.updateConversation != null) {
          if (typeof object.updateConversation !== 'object')
            throw TypeError(
              '.propel.commrouter.ConversationCommand.updateConversation: object expected'
            );
          message.updateConversation =
            $root.propel.commrouter.ConversationCommand.UpdateConversation.fromObject(
              object.updateConversation
            );
        }
        if (object.putAvatar != null) {
          if (typeof object.putAvatar !== 'object')
            throw TypeError('.propel.commrouter.ConversationCommand.putAvatar: object expected');
          message.putAvatar = $root.propel.commrouter.ConversationCommand.PutAvatar.fromObject(
            object.putAvatar
          );
        }
        if (object.updateAvatar != null) {
          if (typeof object.updateAvatar !== 'object')
            throw TypeError('.propel.commrouter.ConversationCommand.updateAvatar: object expected');
          message.updateAvatar =
            $root.propel.commrouter.ConversationCommand.UpdateAvatar.fromObject(
              object.updateAvatar
            );
        }
        if (object.createMessage != null) {
          if (typeof object.createMessage !== 'object')
            throw TypeError(
              '.propel.commrouter.ConversationCommand.createMessage: object expected'
            );
          message.createMessage =
            $root.propel.commrouter.ConversationCommand.CreateMessage.fromObject(
              object.createMessage
            );
        }
        if (object.updateMessage != null) {
          if (typeof object.updateMessage !== 'object')
            throw TypeError(
              '.propel.commrouter.ConversationCommand.updateMessage: object expected'
            );
          message.updateMessage =
            $root.propel.commrouter.ConversationCommand.UpdateMessage.fromObject(
              object.updateMessage
            );
        }
        if (object.createResponse != null) {
          if (typeof object.createResponse !== 'object')
            throw TypeError(
              '.propel.commrouter.ConversationCommand.createResponse: object expected'
            );
          message.createResponse =
            $root.propel.commrouter.ConversationCommand.CreateResponse.fromObject(
              object.createResponse
            );
        }
        if (object.updateSentence != null) {
          if (typeof object.updateSentence !== 'object')
            throw TypeError(
              '.propel.commrouter.ConversationCommand.updateSentence: object expected'
            );
          message.updateSentence =
            $root.propel.commrouter.ConversationCommand.UpdateSentence.fromObject(
              object.updateSentence
            );
        }
        if (object.putConversationState != null) {
          if (typeof object.putConversationState !== 'object')
            throw TypeError(
              '.propel.commrouter.ConversationCommand.putConversationState: object expected'
            );
          message.putConversationState =
            $root.propel.commrouter.ConversationCommand.PutConversationState.fromObject(
              object.putConversationState
            );
        }
        if (object.putContext != null) {
          if (typeof object.putContext !== 'object')
            throw TypeError('.propel.commrouter.ConversationCommand.putContext: object expected');
          message.putContext = $root.propel.commrouter.ConversationCommand.PutContext.fromObject(
            object.putContext
          );
        }
        if (object.putResponse != null) {
          if (typeof object.putResponse !== 'object')
            throw TypeError('.propel.commrouter.ConversationCommand.putResponse: object expected');
          message.putResponse = $root.propel.commrouter.ConversationCommand.PutResponse.fromObject(
            object.putResponse
          );
        }
        if (object.createResponseMessage != null) {
          if (typeof object.createResponseMessage !== 'object')
            throw TypeError(
              '.propel.commrouter.ConversationCommand.createResponseMessage: object expected'
            );
          message.createResponseMessage =
            $root.propel.commrouter.ConversationCommand.CreateResponseMessage.fromObject(
              object.createResponseMessage
            );
        }
        if (object.putConversationMode != null) {
          if (typeof object.putConversationMode !== 'object')
            throw TypeError(
              '.propel.commrouter.ConversationCommand.putConversationMode: object expected'
            );
          message.putConversationMode =
            $root.propel.commrouter.ConversationCommand.PutConversationMode.fromObject(
              object.putConversationMode
            );
        }
        if (object.updateConversationMode != null) {
          if (typeof object.updateConversationMode !== 'object')
            throw TypeError(
              '.propel.commrouter.ConversationCommand.updateConversationMode: object expected'
            );
          message.updateConversationMode =
            $root.propel.commrouter.ConversationCommand.UpdateConversationMode.fromObject(
              object.updateConversationMode
            );
        }
        if (object.putVendorInfo != null) {
          if (typeof object.putVendorInfo !== 'object')
            throw TypeError(
              '.propel.commrouter.ConversationCommand.putVendorInfo: object expected'
            );
          message.putVendorInfo =
            $root.propel.commrouter.ConversationCommand.PutVendorInfo.fromObject(
              object.putVendorInfo
            );
        }
        if (object.createIncomingLead != null) {
          if (typeof object.createIncomingLead !== 'object')
            throw TypeError(
              '.propel.commrouter.ConversationCommand.createIncomingLead: object expected'
            );
          message.createIncomingLead =
            $root.propel.commrouter.ConversationCommand.CreateIncomingLead.fromObject(
              object.createIncomingLead
            );
        }
        if (object.createTag != null) {
          if (typeof object.createTag !== 'object')
            throw TypeError('.propel.commrouter.ConversationCommand.createTag: object expected');
          message.createTag = $root.propel.commrouter.ConversationCommand.CreateTag.fromObject(
            object.createTag
          );
        }
        if (object.deleteTag != null) {
          if (typeof object.deleteTag !== 'object')
            throw TypeError('.propel.commrouter.ConversationCommand.deleteTag: object expected');
          message.deleteTag = $root.propel.commrouter.ConversationCommand.DeleteTag.fromObject(
            object.deleteTag
          );
        }
        return message;
      };

      /**
       * Creates a plain object from a ConversationCommand message. Also converts values to other types if specified.
       * @function toObject
       * @memberof propel.commrouter.ConversationCommand
       * @static
       * @param {propel.commrouter.ConversationCommand} message ConversationCommand
       * @param {$protobuf.IConversionOptions} [options] Conversion options
       * @returns {Object.<string,*>} Plain object
       */
      ConversationCommand.toObject = function toObject(message, options) {
        if (!options) options = {};
        var object = {};
        if (options.defaults) object.id = '';
        if (message.id != null && message.hasOwnProperty('id')) object.id = message.id;
        if (message.updateConversation != null && message.hasOwnProperty('updateConversation')) {
          object.updateConversation =
            $root.propel.commrouter.ConversationCommand.UpdateConversation.toObject(
              message.updateConversation,
              options
            );
          if (options.oneofs) object.command = 'updateConversation';
        }
        if (message.putAvatar != null && message.hasOwnProperty('putAvatar')) {
          object.putAvatar = $root.propel.commrouter.ConversationCommand.PutAvatar.toObject(
            message.putAvatar,
            options
          );
          if (options.oneofs) object.command = 'putAvatar';
        }
        if (message.updateAvatar != null && message.hasOwnProperty('updateAvatar')) {
          object.updateAvatar = $root.propel.commrouter.ConversationCommand.UpdateAvatar.toObject(
            message.updateAvatar,
            options
          );
          if (options.oneofs) object.command = 'updateAvatar';
        }
        if (message.createMessage != null && message.hasOwnProperty('createMessage')) {
          object.createMessage = $root.propel.commrouter.ConversationCommand.CreateMessage.toObject(
            message.createMessage,
            options
          );
          if (options.oneofs) object.command = 'createMessage';
        }
        if (message.updateMessage != null && message.hasOwnProperty('updateMessage')) {
          object.updateMessage = $root.propel.commrouter.ConversationCommand.UpdateMessage.toObject(
            message.updateMessage,
            options
          );
          if (options.oneofs) object.command = 'updateMessage';
        }
        if (message.createResponse != null && message.hasOwnProperty('createResponse')) {
          object.createResponse =
            $root.propel.commrouter.ConversationCommand.CreateResponse.toObject(
              message.createResponse,
              options
            );
          if (options.oneofs) object.command = 'createResponse';
        }
        if (message.updateSentence != null && message.hasOwnProperty('updateSentence')) {
          object.updateSentence =
            $root.propel.commrouter.ConversationCommand.UpdateSentence.toObject(
              message.updateSentence,
              options
            );
          if (options.oneofs) object.command = 'updateSentence';
        }
        if (
          message.putConversationState != null &&
          message.hasOwnProperty('putConversationState')
        ) {
          object.putConversationState =
            $root.propel.commrouter.ConversationCommand.PutConversationState.toObject(
              message.putConversationState,
              options
            );
          if (options.oneofs) object.command = 'putConversationState';
        }
        if (message.putContext != null && message.hasOwnProperty('putContext')) {
          object.putContext = $root.propel.commrouter.ConversationCommand.PutContext.toObject(
            message.putContext,
            options
          );
          if (options.oneofs) object.command = 'putContext';
        }
        if (message.putResponse != null && message.hasOwnProperty('putResponse')) {
          object.putResponse = $root.propel.commrouter.ConversationCommand.PutResponse.toObject(
            message.putResponse,
            options
          );
          if (options.oneofs) object.command = 'putResponse';
        }
        if (
          message.createResponseMessage != null &&
          message.hasOwnProperty('createResponseMessage')
        ) {
          object.createResponseMessage =
            $root.propel.commrouter.ConversationCommand.CreateResponseMessage.toObject(
              message.createResponseMessage,
              options
            );
          if (options.oneofs) object.command = 'createResponseMessage';
        }
        if (message.putConversationMode != null && message.hasOwnProperty('putConversationMode')) {
          object.putConversationMode =
            $root.propel.commrouter.ConversationCommand.PutConversationMode.toObject(
              message.putConversationMode,
              options
            );
          if (options.oneofs) object.command = 'putConversationMode';
        }
        if (
          message.updateConversationMode != null &&
          message.hasOwnProperty('updateConversationMode')
        ) {
          object.updateConversationMode =
            $root.propel.commrouter.ConversationCommand.UpdateConversationMode.toObject(
              message.updateConversationMode,
              options
            );
          if (options.oneofs) object.command = 'updateConversationMode';
        }
        if (message.putVendorInfo != null && message.hasOwnProperty('putVendorInfo')) {
          object.putVendorInfo = $root.propel.commrouter.ConversationCommand.PutVendorInfo.toObject(
            message.putVendorInfo,
            options
          );
          if (options.oneofs) object.command = 'putVendorInfo';
        }
        if (message.createIncomingLead != null && message.hasOwnProperty('createIncomingLead')) {
          object.createIncomingLead =
            $root.propel.commrouter.ConversationCommand.CreateIncomingLead.toObject(
              message.createIncomingLead,
              options
            );
          if (options.oneofs) object.command = 'createIncomingLead';
        }
        if (message.createTag != null && message.hasOwnProperty('createTag')) {
          object.createTag = $root.propel.commrouter.ConversationCommand.CreateTag.toObject(
            message.createTag,
            options
          );
          if (options.oneofs) object.command = 'createTag';
        }
        if (message.deleteTag != null && message.hasOwnProperty('deleteTag')) {
          object.deleteTag = $root.propel.commrouter.ConversationCommand.DeleteTag.toObject(
            message.deleteTag,
            options
          );
          if (options.oneofs) object.command = 'deleteTag';
        }
        return object;
      };

      /**
       * Converts this ConversationCommand to JSON.
       * @function toJSON
       * @memberof propel.commrouter.ConversationCommand
       * @instance
       * @returns {Object.<string,*>} JSON object
       */
      ConversationCommand.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
      };

      ConversationCommand.UpdateConversation = (function () {
        /**
         * Properties of an UpdateConversation.
         * @memberof propel.commrouter.ConversationCommand
         * @interface IUpdateConversation
         * @property {propel.commrouter.Conversation.Activity|null} [activity] UpdateConversation activity
         */

        /**
         * Constructs a new UpdateConversation.
         * @memberof propel.commrouter.ConversationCommand
         * @classdesc Represents an UpdateConversation.
         * @implements IUpdateConversation
         * @constructor
         * @param {propel.commrouter.ConversationCommand.IUpdateConversation=} [properties] Properties to set
         */
        function UpdateConversation(properties) {
          if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
              if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
        }

        /**
         * UpdateConversation activity.
         * @member {propel.commrouter.Conversation.Activity} activity
         * @memberof propel.commrouter.ConversationCommand.UpdateConversation
         * @instance
         */
        UpdateConversation.prototype.activity = 0;

        /**
         * Creates a new UpdateConversation instance using the specified properties.
         * @function create
         * @memberof propel.commrouter.ConversationCommand.UpdateConversation
         * @static
         * @param {propel.commrouter.ConversationCommand.IUpdateConversation=} [properties] Properties to set
         * @returns {propel.commrouter.ConversationCommand.UpdateConversation} UpdateConversation instance
         */
        UpdateConversation.create = function create(properties) {
          return new UpdateConversation(properties);
        };

        /**
         * Encodes the specified UpdateConversation message. Does not implicitly {@link propel.commrouter.ConversationCommand.UpdateConversation.verify|verify} messages.
         * @function encode
         * @memberof propel.commrouter.ConversationCommand.UpdateConversation
         * @static
         * @param {propel.commrouter.ConversationCommand.IUpdateConversation} message UpdateConversation message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UpdateConversation.encode = function encode(message, writer) {
          if (!writer) writer = $Writer.create();
          if (message.activity != null && message.hasOwnProperty('activity'))
            writer.uint32(/* id 1, wireType 0 =*/ 8).int32(message.activity);
          return writer;
        };

        /**
         * Encodes the specified UpdateConversation message, length delimited. Does not implicitly {@link propel.commrouter.ConversationCommand.UpdateConversation.verify|verify} messages.
         * @function encodeDelimited
         * @memberof propel.commrouter.ConversationCommand.UpdateConversation
         * @static
         * @param {propel.commrouter.ConversationCommand.IUpdateConversation} message UpdateConversation message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UpdateConversation.encodeDelimited = function encodeDelimited(message, writer) {
          return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an UpdateConversation message from the specified reader or buffer.
         * @function decode
         * @memberof propel.commrouter.ConversationCommand.UpdateConversation
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {propel.commrouter.ConversationCommand.UpdateConversation} UpdateConversation
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UpdateConversation.decode = function decode(reader, length) {
          if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
          var end = length === undefined ? reader.len : reader.pos + length,
            message = new $root.propel.commrouter.ConversationCommand.UpdateConversation();
          while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
              case 1:
                message.activity = reader.int32();
                break;
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };

        /**
         * Decodes an UpdateConversation message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof propel.commrouter.ConversationCommand.UpdateConversation
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {propel.commrouter.ConversationCommand.UpdateConversation} UpdateConversation
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UpdateConversation.decodeDelimited = function decodeDelimited(reader) {
          if (!(reader instanceof $Reader)) reader = new $Reader(reader);
          return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an UpdateConversation message.
         * @function verify
         * @memberof propel.commrouter.ConversationCommand.UpdateConversation
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        UpdateConversation.verify = function verify(message) {
          if (typeof message !== 'object' || message === null) return 'object expected';
          if (message.activity != null && message.hasOwnProperty('activity'))
            switch (message.activity) {
              default:
                return 'activity: enum value expected';
              case 0:
              case 1:
              case 2:
                break;
            }
          return null;
        };

        /**
         * Creates an UpdateConversation message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof propel.commrouter.ConversationCommand.UpdateConversation
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {propel.commrouter.ConversationCommand.UpdateConversation} UpdateConversation
         */
        UpdateConversation.fromObject = function fromObject(object) {
          if (object instanceof $root.propel.commrouter.ConversationCommand.UpdateConversation)
            return object;
          var message = new $root.propel.commrouter.ConversationCommand.UpdateConversation();
          switch (object.activity) {
            case 'ACTIVITY_UNKNOWN':
            case 0:
              message.activity = 0;
              break;
            case 'ACTIVITY_ACTIVE':
            case 1:
              message.activity = 1;
              break;
            case 'ACTIVITY_INACTIVE':
            case 2:
              message.activity = 2;
              break;
          }
          return message;
        };

        /**
         * Creates a plain object from an UpdateConversation message. Also converts values to other types if specified.
         * @function toObject
         * @memberof propel.commrouter.ConversationCommand.UpdateConversation
         * @static
         * @param {propel.commrouter.ConversationCommand.UpdateConversation} message UpdateConversation
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UpdateConversation.toObject = function toObject(message, options) {
          if (!options) options = {};
          var object = {};
          if (options.defaults) object.activity = options.enums === String ? 'ACTIVITY_UNKNOWN' : 0;
          if (message.activity != null && message.hasOwnProperty('activity'))
            object.activity =
              options.enums === String
                ? $root.propel.commrouter.Conversation.Activity[message.activity]
                : message.activity;
          return object;
        };

        /**
         * Converts this UpdateConversation to JSON.
         * @function toJSON
         * @memberof propel.commrouter.ConversationCommand.UpdateConversation
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UpdateConversation.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return UpdateConversation;
      })();

      ConversationCommand.PutAvatar = (function () {
        /**
         * Properties of a PutAvatar.
         * @memberof propel.commrouter.ConversationCommand
         * @interface IPutAvatar
         * @property {propel.commrouter.IAvatar|null} [avatar] PutAvatar avatar
         */

        /**
         * Constructs a new PutAvatar.
         * @memberof propel.commrouter.ConversationCommand
         * @classdesc Represents a PutAvatar.
         * @implements IPutAvatar
         * @constructor
         * @param {propel.commrouter.ConversationCommand.IPutAvatar=} [properties] Properties to set
         */
        function PutAvatar(properties) {
          if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
              if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
        }

        /**
         * PutAvatar avatar.
         * @member {propel.commrouter.IAvatar|null|undefined} avatar
         * @memberof propel.commrouter.ConversationCommand.PutAvatar
         * @instance
         */
        PutAvatar.prototype.avatar = null;

        /**
         * Creates a new PutAvatar instance using the specified properties.
         * @function create
         * @memberof propel.commrouter.ConversationCommand.PutAvatar
         * @static
         * @param {propel.commrouter.ConversationCommand.IPutAvatar=} [properties] Properties to set
         * @returns {propel.commrouter.ConversationCommand.PutAvatar} PutAvatar instance
         */
        PutAvatar.create = function create(properties) {
          return new PutAvatar(properties);
        };

        /**
         * Encodes the specified PutAvatar message. Does not implicitly {@link propel.commrouter.ConversationCommand.PutAvatar.verify|verify} messages.
         * @function encode
         * @memberof propel.commrouter.ConversationCommand.PutAvatar
         * @static
         * @param {propel.commrouter.ConversationCommand.IPutAvatar} message PutAvatar message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PutAvatar.encode = function encode(message, writer) {
          if (!writer) writer = $Writer.create();
          if (message.avatar != null && message.hasOwnProperty('avatar'))
            $root.propel.commrouter.Avatar.encode(
              message.avatar,
              writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
            ).ldelim();
          return writer;
        };

        /**
         * Encodes the specified PutAvatar message, length delimited. Does not implicitly {@link propel.commrouter.ConversationCommand.PutAvatar.verify|verify} messages.
         * @function encodeDelimited
         * @memberof propel.commrouter.ConversationCommand.PutAvatar
         * @static
         * @param {propel.commrouter.ConversationCommand.IPutAvatar} message PutAvatar message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PutAvatar.encodeDelimited = function encodeDelimited(message, writer) {
          return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a PutAvatar message from the specified reader or buffer.
         * @function decode
         * @memberof propel.commrouter.ConversationCommand.PutAvatar
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {propel.commrouter.ConversationCommand.PutAvatar} PutAvatar
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PutAvatar.decode = function decode(reader, length) {
          if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
          var end = length === undefined ? reader.len : reader.pos + length,
            message = new $root.propel.commrouter.ConversationCommand.PutAvatar();
          while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
              case 1:
                message.avatar = $root.propel.commrouter.Avatar.decode(reader, reader.uint32());
                break;
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };

        /**
         * Decodes a PutAvatar message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof propel.commrouter.ConversationCommand.PutAvatar
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {propel.commrouter.ConversationCommand.PutAvatar} PutAvatar
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PutAvatar.decodeDelimited = function decodeDelimited(reader) {
          if (!(reader instanceof $Reader)) reader = new $Reader(reader);
          return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a PutAvatar message.
         * @function verify
         * @memberof propel.commrouter.ConversationCommand.PutAvatar
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        PutAvatar.verify = function verify(message) {
          if (typeof message !== 'object' || message === null) return 'object expected';
          if (message.avatar != null && message.hasOwnProperty('avatar')) {
            var error = $root.propel.commrouter.Avatar.verify(message.avatar);
            if (error) return 'avatar.' + error;
          }
          return null;
        };

        /**
         * Creates a PutAvatar message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof propel.commrouter.ConversationCommand.PutAvatar
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {propel.commrouter.ConversationCommand.PutAvatar} PutAvatar
         */
        PutAvatar.fromObject = function fromObject(object) {
          if (object instanceof $root.propel.commrouter.ConversationCommand.PutAvatar)
            return object;
          var message = new $root.propel.commrouter.ConversationCommand.PutAvatar();
          if (object.avatar != null) {
            if (typeof object.avatar !== 'object')
              throw TypeError(
                '.propel.commrouter.ConversationCommand.PutAvatar.avatar: object expected'
              );
            message.avatar = $root.propel.commrouter.Avatar.fromObject(object.avatar);
          }
          return message;
        };

        /**
         * Creates a plain object from a PutAvatar message. Also converts values to other types if specified.
         * @function toObject
         * @memberof propel.commrouter.ConversationCommand.PutAvatar
         * @static
         * @param {propel.commrouter.ConversationCommand.PutAvatar} message PutAvatar
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        PutAvatar.toObject = function toObject(message, options) {
          if (!options) options = {};
          var object = {};
          if (options.defaults) object.avatar = null;
          if (message.avatar != null && message.hasOwnProperty('avatar'))
            object.avatar = $root.propel.commrouter.Avatar.toObject(message.avatar, options);
          return object;
        };

        /**
         * Converts this PutAvatar to JSON.
         * @function toJSON
         * @memberof propel.commrouter.ConversationCommand.PutAvatar
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        PutAvatar.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return PutAvatar;
      })();

      ConversationCommand.UpdateAvatar = (function () {
        /**
         * Properties of an UpdateAvatar.
         * @memberof propel.commrouter.ConversationCommand
         * @interface IUpdateAvatar
         * @property {propel.commrouter.IVendorId|null} [avatarId] UpdateAvatar avatarId
         * @property {propel.commrouter.IVendorId|null} [channelId] UpdateAvatar channelId
         * @property {propel.commrouter.Avatar.Presence|null} [presence] UpdateAvatar presence
         */

        /**
         * Constructs a new UpdateAvatar.
         * @memberof propel.commrouter.ConversationCommand
         * @classdesc Represents an UpdateAvatar.
         * @implements IUpdateAvatar
         * @constructor
         * @param {propel.commrouter.ConversationCommand.IUpdateAvatar=} [properties] Properties to set
         */
        function UpdateAvatar(properties) {
          if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
              if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
        }

        /**
         * UpdateAvatar avatarId.
         * @member {propel.commrouter.IVendorId|null|undefined} avatarId
         * @memberof propel.commrouter.ConversationCommand.UpdateAvatar
         * @instance
         */
        UpdateAvatar.prototype.avatarId = null;

        /**
         * UpdateAvatar channelId.
         * @member {propel.commrouter.IVendorId|null|undefined} channelId
         * @memberof propel.commrouter.ConversationCommand.UpdateAvatar
         * @instance
         */
        UpdateAvatar.prototype.channelId = null;

        /**
         * UpdateAvatar presence.
         * @member {propel.commrouter.Avatar.Presence} presence
         * @memberof propel.commrouter.ConversationCommand.UpdateAvatar
         * @instance
         */
        UpdateAvatar.prototype.presence = 0;

        /**
         * Creates a new UpdateAvatar instance using the specified properties.
         * @function create
         * @memberof propel.commrouter.ConversationCommand.UpdateAvatar
         * @static
         * @param {propel.commrouter.ConversationCommand.IUpdateAvatar=} [properties] Properties to set
         * @returns {propel.commrouter.ConversationCommand.UpdateAvatar} UpdateAvatar instance
         */
        UpdateAvatar.create = function create(properties) {
          return new UpdateAvatar(properties);
        };

        /**
         * Encodes the specified UpdateAvatar message. Does not implicitly {@link propel.commrouter.ConversationCommand.UpdateAvatar.verify|verify} messages.
         * @function encode
         * @memberof propel.commrouter.ConversationCommand.UpdateAvatar
         * @static
         * @param {propel.commrouter.ConversationCommand.IUpdateAvatar} message UpdateAvatar message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UpdateAvatar.encode = function encode(message, writer) {
          if (!writer) writer = $Writer.create();
          if (message.avatarId != null && message.hasOwnProperty('avatarId'))
            $root.propel.commrouter.VendorId.encode(
              message.avatarId,
              writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
            ).ldelim();
          if (message.channelId != null && message.hasOwnProperty('channelId'))
            $root.propel.commrouter.VendorId.encode(
              message.channelId,
              writer.uint32(/* id 2, wireType 2 =*/ 18).fork()
            ).ldelim();
          if (message.presence != null && message.hasOwnProperty('presence'))
            writer.uint32(/* id 3, wireType 0 =*/ 24).int32(message.presence);
          return writer;
        };

        /**
         * Encodes the specified UpdateAvatar message, length delimited. Does not implicitly {@link propel.commrouter.ConversationCommand.UpdateAvatar.verify|verify} messages.
         * @function encodeDelimited
         * @memberof propel.commrouter.ConversationCommand.UpdateAvatar
         * @static
         * @param {propel.commrouter.ConversationCommand.IUpdateAvatar} message UpdateAvatar message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UpdateAvatar.encodeDelimited = function encodeDelimited(message, writer) {
          return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an UpdateAvatar message from the specified reader or buffer.
         * @function decode
         * @memberof propel.commrouter.ConversationCommand.UpdateAvatar
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {propel.commrouter.ConversationCommand.UpdateAvatar} UpdateAvatar
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UpdateAvatar.decode = function decode(reader, length) {
          if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
          var end = length === undefined ? reader.len : reader.pos + length,
            message = new $root.propel.commrouter.ConversationCommand.UpdateAvatar();
          while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
              case 1:
                message.avatarId = $root.propel.commrouter.VendorId.decode(reader, reader.uint32());
                break;
              case 2:
                message.channelId = $root.propel.commrouter.VendorId.decode(
                  reader,
                  reader.uint32()
                );
                break;
              case 3:
                message.presence = reader.int32();
                break;
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };

        /**
         * Decodes an UpdateAvatar message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof propel.commrouter.ConversationCommand.UpdateAvatar
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {propel.commrouter.ConversationCommand.UpdateAvatar} UpdateAvatar
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UpdateAvatar.decodeDelimited = function decodeDelimited(reader) {
          if (!(reader instanceof $Reader)) reader = new $Reader(reader);
          return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an UpdateAvatar message.
         * @function verify
         * @memberof propel.commrouter.ConversationCommand.UpdateAvatar
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        UpdateAvatar.verify = function verify(message) {
          if (typeof message !== 'object' || message === null) return 'object expected';
          if (message.avatarId != null && message.hasOwnProperty('avatarId')) {
            var error = $root.propel.commrouter.VendorId.verify(message.avatarId);
            if (error) return 'avatarId.' + error;
          }
          if (message.channelId != null && message.hasOwnProperty('channelId')) {
            var error = $root.propel.commrouter.VendorId.verify(message.channelId);
            if (error) return 'channelId.' + error;
          }
          if (message.presence != null && message.hasOwnProperty('presence'))
            switch (message.presence) {
              default:
                return 'presence: enum value expected';
              case 0:
              case 1:
              case 2:
                break;
            }
          return null;
        };

        /**
         * Creates an UpdateAvatar message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof propel.commrouter.ConversationCommand.UpdateAvatar
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {propel.commrouter.ConversationCommand.UpdateAvatar} UpdateAvatar
         */
        UpdateAvatar.fromObject = function fromObject(object) {
          if (object instanceof $root.propel.commrouter.ConversationCommand.UpdateAvatar)
            return object;
          var message = new $root.propel.commrouter.ConversationCommand.UpdateAvatar();
          if (object.avatarId != null) {
            if (typeof object.avatarId !== 'object')
              throw TypeError(
                '.propel.commrouter.ConversationCommand.UpdateAvatar.avatarId: object expected'
              );
            message.avatarId = $root.propel.commrouter.VendorId.fromObject(object.avatarId);
          }
          if (object.channelId != null) {
            if (typeof object.channelId !== 'object')
              throw TypeError(
                '.propel.commrouter.ConversationCommand.UpdateAvatar.channelId: object expected'
              );
            message.channelId = $root.propel.commrouter.VendorId.fromObject(object.channelId);
          }
          switch (object.presence) {
            case 'PRESENCE_UNKNOWN':
            case 0:
              message.presence = 0;
              break;
            case 'PRESENCE_PRESENT':
            case 1:
              message.presence = 1;
              break;
            case 'PRESENCE_NOT_PRESENT':
            case 2:
              message.presence = 2;
              break;
          }
          return message;
        };

        /**
         * Creates a plain object from an UpdateAvatar message. Also converts values to other types if specified.
         * @function toObject
         * @memberof propel.commrouter.ConversationCommand.UpdateAvatar
         * @static
         * @param {propel.commrouter.ConversationCommand.UpdateAvatar} message UpdateAvatar
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UpdateAvatar.toObject = function toObject(message, options) {
          if (!options) options = {};
          var object = {};
          if (options.defaults) {
            object.avatarId = null;
            object.channelId = null;
            object.presence = options.enums === String ? 'PRESENCE_UNKNOWN' : 0;
          }
          if (message.avatarId != null && message.hasOwnProperty('avatarId'))
            object.avatarId = $root.propel.commrouter.VendorId.toObject(message.avatarId, options);
          if (message.channelId != null && message.hasOwnProperty('channelId'))
            object.channelId = $root.propel.commrouter.VendorId.toObject(
              message.channelId,
              options
            );
          if (message.presence != null && message.hasOwnProperty('presence'))
            object.presence =
              options.enums === String
                ? $root.propel.commrouter.Avatar.Presence[message.presence]
                : message.presence;
          return object;
        };

        /**
         * Converts this UpdateAvatar to JSON.
         * @function toJSON
         * @memberof propel.commrouter.ConversationCommand.UpdateAvatar
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UpdateAvatar.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return UpdateAvatar;
      })();

      ConversationCommand.CreateMessage = (function () {
        /**
         * Properties of a CreateMessage.
         * @memberof propel.commrouter.ConversationCommand
         * @interface ICreateMessage
         * @property {propel.core.IMessageBody|null} [body] CreateMessage body
         * @property {propel.commrouter.IVendorId|null} [avatarId] CreateMessage avatarId
         * @property {propel.commrouter.IVendorId|null} [channelId] CreateMessage channelId
         * @property {propel.commrouter.Message.State|null} [state] CreateMessage state
         * @property {google.protobuf.IStringValue|null} [responseId] CreateMessage responseId
         * @property {google.protobuf.IStruct|null} [channelInfo] CreateMessage channelInfo
         * @property {google.protobuf.IStruct|null} [info] CreateMessage info
         */

        /**
         * Constructs a new CreateMessage.
         * @memberof propel.commrouter.ConversationCommand
         * @classdesc Represents a CreateMessage.
         * @implements ICreateMessage
         * @constructor
         * @param {propel.commrouter.ConversationCommand.ICreateMessage=} [properties] Properties to set
         */
        function CreateMessage(properties) {
          if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
              if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
        }

        /**
         * CreateMessage body.
         * @member {propel.core.IMessageBody|null|undefined} body
         * @memberof propel.commrouter.ConversationCommand.CreateMessage
         * @instance
         */
        CreateMessage.prototype.body = null;

        /**
         * CreateMessage avatarId.
         * @member {propel.commrouter.IVendorId|null|undefined} avatarId
         * @memberof propel.commrouter.ConversationCommand.CreateMessage
         * @instance
         */
        CreateMessage.prototype.avatarId = null;

        /**
         * CreateMessage channelId.
         * @member {propel.commrouter.IVendorId|null|undefined} channelId
         * @memberof propel.commrouter.ConversationCommand.CreateMessage
         * @instance
         */
        CreateMessage.prototype.channelId = null;

        /**
         * CreateMessage state.
         * @member {propel.commrouter.Message.State} state
         * @memberof propel.commrouter.ConversationCommand.CreateMessage
         * @instance
         */
        CreateMessage.prototype.state = 0;

        /**
         * CreateMessage responseId.
         * @member {google.protobuf.IStringValue|null|undefined} responseId
         * @memberof propel.commrouter.ConversationCommand.CreateMessage
         * @instance
         */
        CreateMessage.prototype.responseId = null;

        /**
         * CreateMessage channelInfo.
         * @member {google.protobuf.IStruct|null|undefined} channelInfo
         * @memberof propel.commrouter.ConversationCommand.CreateMessage
         * @instance
         */
        CreateMessage.prototype.channelInfo = null;

        /**
         * CreateMessage info.
         * @member {google.protobuf.IStruct|null|undefined} info
         * @memberof propel.commrouter.ConversationCommand.CreateMessage
         * @instance
         */
        CreateMessage.prototype.info = null;

        /**
         * Creates a new CreateMessage instance using the specified properties.
         * @function create
         * @memberof propel.commrouter.ConversationCommand.CreateMessage
         * @static
         * @param {propel.commrouter.ConversationCommand.ICreateMessage=} [properties] Properties to set
         * @returns {propel.commrouter.ConversationCommand.CreateMessage} CreateMessage instance
         */
        CreateMessage.create = function create(properties) {
          return new CreateMessage(properties);
        };

        /**
         * Encodes the specified CreateMessage message. Does not implicitly {@link propel.commrouter.ConversationCommand.CreateMessage.verify|verify} messages.
         * @function encode
         * @memberof propel.commrouter.ConversationCommand.CreateMessage
         * @static
         * @param {propel.commrouter.ConversationCommand.ICreateMessage} message CreateMessage message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CreateMessage.encode = function encode(message, writer) {
          if (!writer) writer = $Writer.create();
          if (message.body != null && message.hasOwnProperty('body'))
            $root.propel.core.MessageBody.encode(
              message.body,
              writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
            ).ldelim();
          if (message.avatarId != null && message.hasOwnProperty('avatarId'))
            $root.propel.commrouter.VendorId.encode(
              message.avatarId,
              writer.uint32(/* id 2, wireType 2 =*/ 18).fork()
            ).ldelim();
          if (message.channelId != null && message.hasOwnProperty('channelId'))
            $root.propel.commrouter.VendorId.encode(
              message.channelId,
              writer.uint32(/* id 3, wireType 2 =*/ 26).fork()
            ).ldelim();
          if (message.state != null && message.hasOwnProperty('state'))
            writer.uint32(/* id 5, wireType 0 =*/ 40).int32(message.state);
          if (message.responseId != null && message.hasOwnProperty('responseId'))
            $root.google.protobuf.StringValue.encode(
              message.responseId,
              writer.uint32(/* id 6, wireType 2 =*/ 50).fork()
            ).ldelim();
          if (message.channelInfo != null && message.hasOwnProperty('channelInfo'))
            $root.google.protobuf.Struct.encode(
              message.channelInfo,
              writer.uint32(/* id 7, wireType 2 =*/ 58).fork()
            ).ldelim();
          if (message.info != null && message.hasOwnProperty('info'))
            $root.google.protobuf.Struct.encode(
              message.info,
              writer.uint32(/* id 8, wireType 2 =*/ 66).fork()
            ).ldelim();
          return writer;
        };

        /**
         * Encodes the specified CreateMessage message, length delimited. Does not implicitly {@link propel.commrouter.ConversationCommand.CreateMessage.verify|verify} messages.
         * @function encodeDelimited
         * @memberof propel.commrouter.ConversationCommand.CreateMessage
         * @static
         * @param {propel.commrouter.ConversationCommand.ICreateMessage} message CreateMessage message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CreateMessage.encodeDelimited = function encodeDelimited(message, writer) {
          return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a CreateMessage message from the specified reader or buffer.
         * @function decode
         * @memberof propel.commrouter.ConversationCommand.CreateMessage
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {propel.commrouter.ConversationCommand.CreateMessage} CreateMessage
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CreateMessage.decode = function decode(reader, length) {
          if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
          var end = length === undefined ? reader.len : reader.pos + length,
            message = new $root.propel.commrouter.ConversationCommand.CreateMessage();
          while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
              case 1:
                message.body = $root.propel.core.MessageBody.decode(reader, reader.uint32());
                break;
              case 2:
                message.avatarId = $root.propel.commrouter.VendorId.decode(reader, reader.uint32());
                break;
              case 3:
                message.channelId = $root.propel.commrouter.VendorId.decode(
                  reader,
                  reader.uint32()
                );
                break;
              case 5:
                message.state = reader.int32();
                break;
              case 6:
                message.responseId = $root.google.protobuf.StringValue.decode(
                  reader,
                  reader.uint32()
                );
                break;
              case 7:
                message.channelInfo = $root.google.protobuf.Struct.decode(reader, reader.uint32());
                break;
              case 8:
                message.info = $root.google.protobuf.Struct.decode(reader, reader.uint32());
                break;
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };

        /**
         * Decodes a CreateMessage message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof propel.commrouter.ConversationCommand.CreateMessage
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {propel.commrouter.ConversationCommand.CreateMessage} CreateMessage
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CreateMessage.decodeDelimited = function decodeDelimited(reader) {
          if (!(reader instanceof $Reader)) reader = new $Reader(reader);
          return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a CreateMessage message.
         * @function verify
         * @memberof propel.commrouter.ConversationCommand.CreateMessage
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        CreateMessage.verify = function verify(message) {
          if (typeof message !== 'object' || message === null) return 'object expected';
          if (message.body != null && message.hasOwnProperty('body')) {
            var error = $root.propel.core.MessageBody.verify(message.body);
            if (error) return 'body.' + error;
          }
          if (message.avatarId != null && message.hasOwnProperty('avatarId')) {
            var error = $root.propel.commrouter.VendorId.verify(message.avatarId);
            if (error) return 'avatarId.' + error;
          }
          if (message.channelId != null && message.hasOwnProperty('channelId')) {
            var error = $root.propel.commrouter.VendorId.verify(message.channelId);
            if (error) return 'channelId.' + error;
          }
          if (message.state != null && message.hasOwnProperty('state'))
            switch (message.state) {
              default:
                return 'state: enum value expected';
              case 0:
              case 1:
              case 2:
              case 3:
                break;
            }
          if (message.responseId != null && message.hasOwnProperty('responseId')) {
            var error = $root.google.protobuf.StringValue.verify(message.responseId);
            if (error) return 'responseId.' + error;
          }
          if (message.channelInfo != null && message.hasOwnProperty('channelInfo')) {
            var error = $root.google.protobuf.Struct.verify(message.channelInfo);
            if (error) return 'channelInfo.' + error;
          }
          if (message.info != null && message.hasOwnProperty('info')) {
            var error = $root.google.protobuf.Struct.verify(message.info);
            if (error) return 'info.' + error;
          }
          return null;
        };

        /**
         * Creates a CreateMessage message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof propel.commrouter.ConversationCommand.CreateMessage
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {propel.commrouter.ConversationCommand.CreateMessage} CreateMessage
         */
        CreateMessage.fromObject = function fromObject(object) {
          if (object instanceof $root.propel.commrouter.ConversationCommand.CreateMessage)
            return object;
          var message = new $root.propel.commrouter.ConversationCommand.CreateMessage();
          if (object.body != null) {
            if (typeof object.body !== 'object')
              throw TypeError(
                '.propel.commrouter.ConversationCommand.CreateMessage.body: object expected'
              );
            message.body = $root.propel.core.MessageBody.fromObject(object.body);
          }
          if (object.avatarId != null) {
            if (typeof object.avatarId !== 'object')
              throw TypeError(
                '.propel.commrouter.ConversationCommand.CreateMessage.avatarId: object expected'
              );
            message.avatarId = $root.propel.commrouter.VendorId.fromObject(object.avatarId);
          }
          if (object.channelId != null) {
            if (typeof object.channelId !== 'object')
              throw TypeError(
                '.propel.commrouter.ConversationCommand.CreateMessage.channelId: object expected'
              );
            message.channelId = $root.propel.commrouter.VendorId.fromObject(object.channelId);
          }
          switch (object.state) {
            case 'STATE_UNKNOWN':
            case 0:
              message.state = 0;
              break;
            case 'STATE_SENDING':
            case 1:
              message.state = 1;
              break;
            case 'STATE_SENT':
            case 2:
              message.state = 2;
              break;
            case 'STATE_ERROR':
            case 3:
              message.state = 3;
              break;
          }
          if (object.responseId != null) {
            if (typeof object.responseId !== 'object')
              throw TypeError(
                '.propel.commrouter.ConversationCommand.CreateMessage.responseId: object expected'
              );
            message.responseId = $root.google.protobuf.StringValue.fromObject(object.responseId);
          }
          if (object.channelInfo != null) {
            if (typeof object.channelInfo !== 'object')
              throw TypeError(
                '.propel.commrouter.ConversationCommand.CreateMessage.channelInfo: object expected'
              );
            message.channelInfo = $root.google.protobuf.Struct.fromObject(object.channelInfo);
          }
          if (object.info != null) {
            if (typeof object.info !== 'object')
              throw TypeError(
                '.propel.commrouter.ConversationCommand.CreateMessage.info: object expected'
              );
            message.info = $root.google.protobuf.Struct.fromObject(object.info);
          }
          return message;
        };

        /**
         * Creates a plain object from a CreateMessage message. Also converts values to other types if specified.
         * @function toObject
         * @memberof propel.commrouter.ConversationCommand.CreateMessage
         * @static
         * @param {propel.commrouter.ConversationCommand.CreateMessage} message CreateMessage
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CreateMessage.toObject = function toObject(message, options) {
          if (!options) options = {};
          var object = {};
          if (options.defaults) {
            object.body = null;
            object.avatarId = null;
            object.channelId = null;
            object.state = options.enums === String ? 'STATE_UNKNOWN' : 0;
            object.responseId = null;
            object.channelInfo = null;
            object.info = null;
          }
          if (message.body != null && message.hasOwnProperty('body'))
            object.body = $root.propel.core.MessageBody.toObject(message.body, options);
          if (message.avatarId != null && message.hasOwnProperty('avatarId'))
            object.avatarId = $root.propel.commrouter.VendorId.toObject(message.avatarId, options);
          if (message.channelId != null && message.hasOwnProperty('channelId'))
            object.channelId = $root.propel.commrouter.VendorId.toObject(
              message.channelId,
              options
            );
          if (message.state != null && message.hasOwnProperty('state'))
            object.state =
              options.enums === String
                ? $root.propel.commrouter.Message.State[message.state]
                : message.state;
          if (message.responseId != null && message.hasOwnProperty('responseId'))
            object.responseId = $root.google.protobuf.StringValue.toObject(
              message.responseId,
              options
            );
          if (message.channelInfo != null && message.hasOwnProperty('channelInfo'))
            object.channelInfo = $root.google.protobuf.Struct.toObject(
              message.channelInfo,
              options
            );
          if (message.info != null && message.hasOwnProperty('info'))
            object.info = $root.google.protobuf.Struct.toObject(message.info, options);
          return object;
        };

        /**
         * Converts this CreateMessage to JSON.
         * @function toJSON
         * @memberof propel.commrouter.ConversationCommand.CreateMessage
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CreateMessage.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return CreateMessage;
      })();

      ConversationCommand.UpdateMessage = (function () {
        /**
         * Properties of an UpdateMessage.
         * @memberof propel.commrouter.ConversationCommand
         * @interface IUpdateMessage
         * @property {string|null} [messageId] UpdateMessage messageId
         * @property {propel.commrouter.Message.State|null} [state] UpdateMessage state
         * @property {google.protobuf.IStringValue|null} [error] UpdateMessage error
         * @property {google.protobuf.IStringValue|null} [errorMessage] UpdateMessage errorMessage
         * @property {google.protobuf.IStruct|null} [channelInfo] UpdateMessage channelInfo
         */

        /**
         * Constructs a new UpdateMessage.
         * @memberof propel.commrouter.ConversationCommand
         * @classdesc Represents an UpdateMessage.
         * @implements IUpdateMessage
         * @constructor
         * @param {propel.commrouter.ConversationCommand.IUpdateMessage=} [properties] Properties to set
         */
        function UpdateMessage(properties) {
          if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
              if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
        }

        /**
         * UpdateMessage messageId.
         * @member {string} messageId
         * @memberof propel.commrouter.ConversationCommand.UpdateMessage
         * @instance
         */
        UpdateMessage.prototype.messageId = '';

        /**
         * UpdateMessage state.
         * @member {propel.commrouter.Message.State} state
         * @memberof propel.commrouter.ConversationCommand.UpdateMessage
         * @instance
         */
        UpdateMessage.prototype.state = 0;

        /**
         * UpdateMessage error.
         * @member {google.protobuf.IStringValue|null|undefined} error
         * @memberof propel.commrouter.ConversationCommand.UpdateMessage
         * @instance
         */
        UpdateMessage.prototype.error = null;

        /**
         * UpdateMessage errorMessage.
         * @member {google.protobuf.IStringValue|null|undefined} errorMessage
         * @memberof propel.commrouter.ConversationCommand.UpdateMessage
         * @instance
         */
        UpdateMessage.prototype.errorMessage = null;

        /**
         * UpdateMessage channelInfo.
         * @member {google.protobuf.IStruct|null|undefined} channelInfo
         * @memberof propel.commrouter.ConversationCommand.UpdateMessage
         * @instance
         */
        UpdateMessage.prototype.channelInfo = null;

        /**
         * Creates a new UpdateMessage instance using the specified properties.
         * @function create
         * @memberof propel.commrouter.ConversationCommand.UpdateMessage
         * @static
         * @param {propel.commrouter.ConversationCommand.IUpdateMessage=} [properties] Properties to set
         * @returns {propel.commrouter.ConversationCommand.UpdateMessage} UpdateMessage instance
         */
        UpdateMessage.create = function create(properties) {
          return new UpdateMessage(properties);
        };

        /**
         * Encodes the specified UpdateMessage message. Does not implicitly {@link propel.commrouter.ConversationCommand.UpdateMessage.verify|verify} messages.
         * @function encode
         * @memberof propel.commrouter.ConversationCommand.UpdateMessage
         * @static
         * @param {propel.commrouter.ConversationCommand.IUpdateMessage} message UpdateMessage message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UpdateMessage.encode = function encode(message, writer) {
          if (!writer) writer = $Writer.create();
          if (message.messageId != null && message.hasOwnProperty('messageId'))
            writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.messageId);
          if (message.state != null && message.hasOwnProperty('state'))
            writer.uint32(/* id 2, wireType 0 =*/ 16).int32(message.state);
          if (message.error != null && message.hasOwnProperty('error'))
            $root.google.protobuf.StringValue.encode(
              message.error,
              writer.uint32(/* id 3, wireType 2 =*/ 26).fork()
            ).ldelim();
          if (message.errorMessage != null && message.hasOwnProperty('errorMessage'))
            $root.google.protobuf.StringValue.encode(
              message.errorMessage,
              writer.uint32(/* id 4, wireType 2 =*/ 34).fork()
            ).ldelim();
          if (message.channelInfo != null && message.hasOwnProperty('channelInfo'))
            $root.google.protobuf.Struct.encode(
              message.channelInfo,
              writer.uint32(/* id 5, wireType 2 =*/ 42).fork()
            ).ldelim();
          return writer;
        };

        /**
         * Encodes the specified UpdateMessage message, length delimited. Does not implicitly {@link propel.commrouter.ConversationCommand.UpdateMessage.verify|verify} messages.
         * @function encodeDelimited
         * @memberof propel.commrouter.ConversationCommand.UpdateMessage
         * @static
         * @param {propel.commrouter.ConversationCommand.IUpdateMessage} message UpdateMessage message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UpdateMessage.encodeDelimited = function encodeDelimited(message, writer) {
          return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an UpdateMessage message from the specified reader or buffer.
         * @function decode
         * @memberof propel.commrouter.ConversationCommand.UpdateMessage
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {propel.commrouter.ConversationCommand.UpdateMessage} UpdateMessage
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UpdateMessage.decode = function decode(reader, length) {
          if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
          var end = length === undefined ? reader.len : reader.pos + length,
            message = new $root.propel.commrouter.ConversationCommand.UpdateMessage();
          while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
              case 1:
                message.messageId = reader.string();
                break;
              case 2:
                message.state = reader.int32();
                break;
              case 3:
                message.error = $root.google.protobuf.StringValue.decode(reader, reader.uint32());
                break;
              case 4:
                message.errorMessage = $root.google.protobuf.StringValue.decode(
                  reader,
                  reader.uint32()
                );
                break;
              case 5:
                message.channelInfo = $root.google.protobuf.Struct.decode(reader, reader.uint32());
                break;
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };

        /**
         * Decodes an UpdateMessage message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof propel.commrouter.ConversationCommand.UpdateMessage
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {propel.commrouter.ConversationCommand.UpdateMessage} UpdateMessage
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UpdateMessage.decodeDelimited = function decodeDelimited(reader) {
          if (!(reader instanceof $Reader)) reader = new $Reader(reader);
          return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an UpdateMessage message.
         * @function verify
         * @memberof propel.commrouter.ConversationCommand.UpdateMessage
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        UpdateMessage.verify = function verify(message) {
          if (typeof message !== 'object' || message === null) return 'object expected';
          if (message.messageId != null && message.hasOwnProperty('messageId'))
            if (!$util.isString(message.messageId)) return 'messageId: string expected';
          if (message.state != null && message.hasOwnProperty('state'))
            switch (message.state) {
              default:
                return 'state: enum value expected';
              case 0:
              case 1:
              case 2:
              case 3:
                break;
            }
          if (message.error != null && message.hasOwnProperty('error')) {
            var error = $root.google.protobuf.StringValue.verify(message.error);
            if (error) return 'error.' + error;
          }
          if (message.errorMessage != null && message.hasOwnProperty('errorMessage')) {
            var error = $root.google.protobuf.StringValue.verify(message.errorMessage);
            if (error) return 'errorMessage.' + error;
          }
          if (message.channelInfo != null && message.hasOwnProperty('channelInfo')) {
            var error = $root.google.protobuf.Struct.verify(message.channelInfo);
            if (error) return 'channelInfo.' + error;
          }
          return null;
        };

        /**
         * Creates an UpdateMessage message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof propel.commrouter.ConversationCommand.UpdateMessage
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {propel.commrouter.ConversationCommand.UpdateMessage} UpdateMessage
         */
        UpdateMessage.fromObject = function fromObject(object) {
          if (object instanceof $root.propel.commrouter.ConversationCommand.UpdateMessage)
            return object;
          var message = new $root.propel.commrouter.ConversationCommand.UpdateMessage();
          if (object.messageId != null) message.messageId = String(object.messageId);
          switch (object.state) {
            case 'STATE_UNKNOWN':
            case 0:
              message.state = 0;
              break;
            case 'STATE_SENDING':
            case 1:
              message.state = 1;
              break;
            case 'STATE_SENT':
            case 2:
              message.state = 2;
              break;
            case 'STATE_ERROR':
            case 3:
              message.state = 3;
              break;
          }
          if (object.error != null) {
            if (typeof object.error !== 'object')
              throw TypeError(
                '.propel.commrouter.ConversationCommand.UpdateMessage.error: object expected'
              );
            message.error = $root.google.protobuf.StringValue.fromObject(object.error);
          }
          if (object.errorMessage != null) {
            if (typeof object.errorMessage !== 'object')
              throw TypeError(
                '.propel.commrouter.ConversationCommand.UpdateMessage.errorMessage: object expected'
              );
            message.errorMessage = $root.google.protobuf.StringValue.fromObject(
              object.errorMessage
            );
          }
          if (object.channelInfo != null) {
            if (typeof object.channelInfo !== 'object')
              throw TypeError(
                '.propel.commrouter.ConversationCommand.UpdateMessage.channelInfo: object expected'
              );
            message.channelInfo = $root.google.protobuf.Struct.fromObject(object.channelInfo);
          }
          return message;
        };

        /**
         * Creates a plain object from an UpdateMessage message. Also converts values to other types if specified.
         * @function toObject
         * @memberof propel.commrouter.ConversationCommand.UpdateMessage
         * @static
         * @param {propel.commrouter.ConversationCommand.UpdateMessage} message UpdateMessage
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UpdateMessage.toObject = function toObject(message, options) {
          if (!options) options = {};
          var object = {};
          if (options.defaults) {
            object.messageId = '';
            object.state = options.enums === String ? 'STATE_UNKNOWN' : 0;
            object.error = null;
            object.errorMessage = null;
            object.channelInfo = null;
          }
          if (message.messageId != null && message.hasOwnProperty('messageId'))
            object.messageId = message.messageId;
          if (message.state != null && message.hasOwnProperty('state'))
            object.state =
              options.enums === String
                ? $root.propel.commrouter.Message.State[message.state]
                : message.state;
          if (message.error != null && message.hasOwnProperty('error'))
            object.error = $root.google.protobuf.StringValue.toObject(message.error, options);
          if (message.errorMessage != null && message.hasOwnProperty('errorMessage'))
            object.errorMessage = $root.google.protobuf.StringValue.toObject(
              message.errorMessage,
              options
            );
          if (message.channelInfo != null && message.hasOwnProperty('channelInfo'))
            object.channelInfo = $root.google.protobuf.Struct.toObject(
              message.channelInfo,
              options
            );
          return object;
        };

        /**
         * Converts this UpdateMessage to JSON.
         * @function toJSON
         * @memberof propel.commrouter.ConversationCommand.UpdateMessage
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UpdateMessage.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return UpdateMessage;
      })();

      ConversationCommand.CreateResponse = (function () {
        /**
         * Properties of a CreateResponse.
         * @memberof propel.commrouter.ConversationCommand
         * @interface ICreateResponse
         * @property {Array.<string>|null} [sentenceIds] CreateResponse sentenceIds
         * @property {Array.<propel.commrouter.ConversationCommand.CreateResponse.ISentenceSpec>|null} [sentenceSpecs] CreateResponse sentenceSpecs
         * @property {google.protobuf.IStringValue|null} [channelType] CreateResponse channelType
         * @property {propel.commrouter.IVendorId|null} [channelId] CreateResponse channelId
         * @property {google.protobuf.IStruct|null} [info] CreateResponse info
         */

        /**
         * Constructs a new CreateResponse.
         * @memberof propel.commrouter.ConversationCommand
         * @classdesc Represents a CreateResponse.
         * @implements ICreateResponse
         * @constructor
         * @param {propel.commrouter.ConversationCommand.ICreateResponse=} [properties] Properties to set
         */
        function CreateResponse(properties) {
          this.sentenceIds = [];
          this.sentenceSpecs = [];
          if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
              if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
        }

        /**
         * CreateResponse sentenceIds.
         * @member {Array.<string>} sentenceIds
         * @memberof propel.commrouter.ConversationCommand.CreateResponse
         * @instance
         */
        CreateResponse.prototype.sentenceIds = $util.emptyArray;

        /**
         * CreateResponse sentenceSpecs.
         * @member {Array.<propel.commrouter.ConversationCommand.CreateResponse.ISentenceSpec>} sentenceSpecs
         * @memberof propel.commrouter.ConversationCommand.CreateResponse
         * @instance
         */
        CreateResponse.prototype.sentenceSpecs = $util.emptyArray;

        /**
         * CreateResponse channelType.
         * @member {google.protobuf.IStringValue|null|undefined} channelType
         * @memberof propel.commrouter.ConversationCommand.CreateResponse
         * @instance
         */
        CreateResponse.prototype.channelType = null;

        /**
         * CreateResponse channelId.
         * @member {propel.commrouter.IVendorId|null|undefined} channelId
         * @memberof propel.commrouter.ConversationCommand.CreateResponse
         * @instance
         */
        CreateResponse.prototype.channelId = null;

        /**
         * CreateResponse info.
         * @member {google.protobuf.IStruct|null|undefined} info
         * @memberof propel.commrouter.ConversationCommand.CreateResponse
         * @instance
         */
        CreateResponse.prototype.info = null;

        /**
         * Creates a new CreateResponse instance using the specified properties.
         * @function create
         * @memberof propel.commrouter.ConversationCommand.CreateResponse
         * @static
         * @param {propel.commrouter.ConversationCommand.ICreateResponse=} [properties] Properties to set
         * @returns {propel.commrouter.ConversationCommand.CreateResponse} CreateResponse instance
         */
        CreateResponse.create = function create(properties) {
          return new CreateResponse(properties);
        };

        /**
         * Encodes the specified CreateResponse message. Does not implicitly {@link propel.commrouter.ConversationCommand.CreateResponse.verify|verify} messages.
         * @function encode
         * @memberof propel.commrouter.ConversationCommand.CreateResponse
         * @static
         * @param {propel.commrouter.ConversationCommand.ICreateResponse} message CreateResponse message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CreateResponse.encode = function encode(message, writer) {
          if (!writer) writer = $Writer.create();
          if (message.sentenceIds != null && message.sentenceIds.length)
            for (var i = 0; i < message.sentenceIds.length; ++i)
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.sentenceIds[i]);
          if (message.sentenceSpecs != null && message.sentenceSpecs.length)
            for (var i = 0; i < message.sentenceSpecs.length; ++i)
              $root.propel.commrouter.ConversationCommand.CreateResponse.SentenceSpec.encode(
                message.sentenceSpecs[i],
                writer.uint32(/* id 2, wireType 2 =*/ 18).fork()
              ).ldelim();
          if (message.channelType != null && message.hasOwnProperty('channelType'))
            $root.google.protobuf.StringValue.encode(
              message.channelType,
              writer.uint32(/* id 3, wireType 2 =*/ 26).fork()
            ).ldelim();
          if (message.channelId != null && message.hasOwnProperty('channelId'))
            $root.propel.commrouter.VendorId.encode(
              message.channelId,
              writer.uint32(/* id 4, wireType 2 =*/ 34).fork()
            ).ldelim();
          if (message.info != null && message.hasOwnProperty('info'))
            $root.google.protobuf.Struct.encode(
              message.info,
              writer.uint32(/* id 5, wireType 2 =*/ 42).fork()
            ).ldelim();
          return writer;
        };

        /**
         * Encodes the specified CreateResponse message, length delimited. Does not implicitly {@link propel.commrouter.ConversationCommand.CreateResponse.verify|verify} messages.
         * @function encodeDelimited
         * @memberof propel.commrouter.ConversationCommand.CreateResponse
         * @static
         * @param {propel.commrouter.ConversationCommand.ICreateResponse} message CreateResponse message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CreateResponse.encodeDelimited = function encodeDelimited(message, writer) {
          return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a CreateResponse message from the specified reader or buffer.
         * @function decode
         * @memberof propel.commrouter.ConversationCommand.CreateResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {propel.commrouter.ConversationCommand.CreateResponse} CreateResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CreateResponse.decode = function decode(reader, length) {
          if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
          var end = length === undefined ? reader.len : reader.pos + length,
            message = new $root.propel.commrouter.ConversationCommand.CreateResponse();
          while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
              case 1:
                if (!(message.sentenceIds && message.sentenceIds.length)) message.sentenceIds = [];
                message.sentenceIds.push(reader.string());
                break;
              case 2:
                if (!(message.sentenceSpecs && message.sentenceSpecs.length))
                  message.sentenceSpecs = [];
                message.sentenceSpecs.push(
                  $root.propel.commrouter.ConversationCommand.CreateResponse.SentenceSpec.decode(
                    reader,
                    reader.uint32()
                  )
                );
                break;
              case 3:
                message.channelType = $root.google.protobuf.StringValue.decode(
                  reader,
                  reader.uint32()
                );
                break;
              case 4:
                message.channelId = $root.propel.commrouter.VendorId.decode(
                  reader,
                  reader.uint32()
                );
                break;
              case 5:
                message.info = $root.google.protobuf.Struct.decode(reader, reader.uint32());
                break;
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };

        /**
         * Decodes a CreateResponse message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof propel.commrouter.ConversationCommand.CreateResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {propel.commrouter.ConversationCommand.CreateResponse} CreateResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CreateResponse.decodeDelimited = function decodeDelimited(reader) {
          if (!(reader instanceof $Reader)) reader = new $Reader(reader);
          return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a CreateResponse message.
         * @function verify
         * @memberof propel.commrouter.ConversationCommand.CreateResponse
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        CreateResponse.verify = function verify(message) {
          if (typeof message !== 'object' || message === null) return 'object expected';
          if (message.sentenceIds != null && message.hasOwnProperty('sentenceIds')) {
            if (!Array.isArray(message.sentenceIds)) return 'sentenceIds: array expected';
            for (var i = 0; i < message.sentenceIds.length; ++i)
              if (!$util.isString(message.sentenceIds[i])) return 'sentenceIds: string[] expected';
          }
          if (message.sentenceSpecs != null && message.hasOwnProperty('sentenceSpecs')) {
            if (!Array.isArray(message.sentenceSpecs)) return 'sentenceSpecs: array expected';
            for (var i = 0; i < message.sentenceSpecs.length; ++i) {
              var error =
                $root.propel.commrouter.ConversationCommand.CreateResponse.SentenceSpec.verify(
                  message.sentenceSpecs[i]
                );
              if (error) return 'sentenceSpecs.' + error;
            }
          }
          if (message.channelType != null && message.hasOwnProperty('channelType')) {
            var error = $root.google.protobuf.StringValue.verify(message.channelType);
            if (error) return 'channelType.' + error;
          }
          if (message.channelId != null && message.hasOwnProperty('channelId')) {
            var error = $root.propel.commrouter.VendorId.verify(message.channelId);
            if (error) return 'channelId.' + error;
          }
          if (message.info != null && message.hasOwnProperty('info')) {
            var error = $root.google.protobuf.Struct.verify(message.info);
            if (error) return 'info.' + error;
          }
          return null;
        };

        /**
         * Creates a CreateResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof propel.commrouter.ConversationCommand.CreateResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {propel.commrouter.ConversationCommand.CreateResponse} CreateResponse
         */
        CreateResponse.fromObject = function fromObject(object) {
          if (object instanceof $root.propel.commrouter.ConversationCommand.CreateResponse)
            return object;
          var message = new $root.propel.commrouter.ConversationCommand.CreateResponse();
          if (object.sentenceIds) {
            if (!Array.isArray(object.sentenceIds))
              throw TypeError(
                '.propel.commrouter.ConversationCommand.CreateResponse.sentenceIds: array expected'
              );
            message.sentenceIds = [];
            for (var i = 0; i < object.sentenceIds.length; ++i)
              message.sentenceIds[i] = String(object.sentenceIds[i]);
          }
          if (object.sentenceSpecs) {
            if (!Array.isArray(object.sentenceSpecs))
              throw TypeError(
                '.propel.commrouter.ConversationCommand.CreateResponse.sentenceSpecs: array expected'
              );
            message.sentenceSpecs = [];
            for (var i = 0; i < object.sentenceSpecs.length; ++i) {
              if (typeof object.sentenceSpecs[i] !== 'object')
                throw TypeError(
                  '.propel.commrouter.ConversationCommand.CreateResponse.sentenceSpecs: object expected'
                );
              message.sentenceSpecs[i] =
                $root.propel.commrouter.ConversationCommand.CreateResponse.SentenceSpec.fromObject(
                  object.sentenceSpecs[i]
                );
            }
          }
          if (object.channelType != null) {
            if (typeof object.channelType !== 'object')
              throw TypeError(
                '.propel.commrouter.ConversationCommand.CreateResponse.channelType: object expected'
              );
            message.channelType = $root.google.protobuf.StringValue.fromObject(object.channelType);
          }
          if (object.channelId != null) {
            if (typeof object.channelId !== 'object')
              throw TypeError(
                '.propel.commrouter.ConversationCommand.CreateResponse.channelId: object expected'
              );
            message.channelId = $root.propel.commrouter.VendorId.fromObject(object.channelId);
          }
          if (object.info != null) {
            if (typeof object.info !== 'object')
              throw TypeError(
                '.propel.commrouter.ConversationCommand.CreateResponse.info: object expected'
              );
            message.info = $root.google.protobuf.Struct.fromObject(object.info);
          }
          return message;
        };

        /**
         * Creates a plain object from a CreateResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof propel.commrouter.ConversationCommand.CreateResponse
         * @static
         * @param {propel.commrouter.ConversationCommand.CreateResponse} message CreateResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CreateResponse.toObject = function toObject(message, options) {
          if (!options) options = {};
          var object = {};
          if (options.arrays || options.defaults) {
            object.sentenceIds = [];
            object.sentenceSpecs = [];
          }
          if (options.defaults) {
            object.channelType = null;
            object.channelId = null;
            object.info = null;
          }
          if (message.sentenceIds && message.sentenceIds.length) {
            object.sentenceIds = [];
            for (var j = 0; j < message.sentenceIds.length; ++j)
              object.sentenceIds[j] = message.sentenceIds[j];
          }
          if (message.sentenceSpecs && message.sentenceSpecs.length) {
            object.sentenceSpecs = [];
            for (var j = 0; j < message.sentenceSpecs.length; ++j)
              object.sentenceSpecs[j] =
                $root.propel.commrouter.ConversationCommand.CreateResponse.SentenceSpec.toObject(
                  message.sentenceSpecs[j],
                  options
                );
          }
          if (message.channelType != null && message.hasOwnProperty('channelType'))
            object.channelType = $root.google.protobuf.StringValue.toObject(
              message.channelType,
              options
            );
          if (message.channelId != null && message.hasOwnProperty('channelId'))
            object.channelId = $root.propel.commrouter.VendorId.toObject(
              message.channelId,
              options
            );
          if (message.info != null && message.hasOwnProperty('info'))
            object.info = $root.google.protobuf.Struct.toObject(message.info, options);
          return object;
        };

        /**
         * Converts this CreateResponse to JSON.
         * @function toJSON
         * @memberof propel.commrouter.ConversationCommand.CreateResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CreateResponse.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        CreateResponse.IntentSpec = (function () {
          /**
           * Properties of an IntentSpec.
           * @memberof propel.commrouter.ConversationCommand.CreateResponse
           * @interface IIntentSpec
           * @property {string|null} [intentId] IntentSpec intentId
           * @property {string|null} [intentClassId] IntentSpec intentClassId
           */

          /**
           * Constructs a new IntentSpec.
           * @memberof propel.commrouter.ConversationCommand.CreateResponse
           * @classdesc Represents an IntentSpec.
           * @implements IIntentSpec
           * @constructor
           * @param {propel.commrouter.ConversationCommand.CreateResponse.IIntentSpec=} [properties] Properties to set
           */
          function IntentSpec(properties) {
            if (properties)
              for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
          }

          /**
           * IntentSpec intentId.
           * @member {string} intentId
           * @memberof propel.commrouter.ConversationCommand.CreateResponse.IntentSpec
           * @instance
           */
          IntentSpec.prototype.intentId = '';

          /**
           * IntentSpec intentClassId.
           * @member {string} intentClassId
           * @memberof propel.commrouter.ConversationCommand.CreateResponse.IntentSpec
           * @instance
           */
          IntentSpec.prototype.intentClassId = '';

          /**
           * Creates a new IntentSpec instance using the specified properties.
           * @function create
           * @memberof propel.commrouter.ConversationCommand.CreateResponse.IntentSpec
           * @static
           * @param {propel.commrouter.ConversationCommand.CreateResponse.IIntentSpec=} [properties] Properties to set
           * @returns {propel.commrouter.ConversationCommand.CreateResponse.IntentSpec} IntentSpec instance
           */
          IntentSpec.create = function create(properties) {
            return new IntentSpec(properties);
          };

          /**
           * Encodes the specified IntentSpec message. Does not implicitly {@link propel.commrouter.ConversationCommand.CreateResponse.IntentSpec.verify|verify} messages.
           * @function encode
           * @memberof propel.commrouter.ConversationCommand.CreateResponse.IntentSpec
           * @static
           * @param {propel.commrouter.ConversationCommand.CreateResponse.IIntentSpec} message IntentSpec message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          IntentSpec.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (message.intentId != null && message.hasOwnProperty('intentId'))
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.intentId);
            if (message.intentClassId != null && message.hasOwnProperty('intentClassId'))
              writer.uint32(/* id 2, wireType 2 =*/ 18).string(message.intentClassId);
            return writer;
          };

          /**
           * Encodes the specified IntentSpec message, length delimited. Does not implicitly {@link propel.commrouter.ConversationCommand.CreateResponse.IntentSpec.verify|verify} messages.
           * @function encodeDelimited
           * @memberof propel.commrouter.ConversationCommand.CreateResponse.IntentSpec
           * @static
           * @param {propel.commrouter.ConversationCommand.CreateResponse.IIntentSpec} message IntentSpec message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          IntentSpec.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
          };

          /**
           * Decodes an IntentSpec message from the specified reader or buffer.
           * @function decode
           * @memberof propel.commrouter.ConversationCommand.CreateResponse.IntentSpec
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {propel.commrouter.ConversationCommand.CreateResponse.IntentSpec} IntentSpec
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          IntentSpec.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message = new $root.propel.commrouter.ConversationCommand.CreateResponse.IntentSpec();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.intentId = reader.string();
                  break;
                case 2:
                  message.intentClassId = reader.string();
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Decodes an IntentSpec message from the specified reader or buffer, length delimited.
           * @function decodeDelimited
           * @memberof propel.commrouter.ConversationCommand.CreateResponse.IntentSpec
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @returns {propel.commrouter.ConversationCommand.CreateResponse.IntentSpec} IntentSpec
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          IntentSpec.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader)) reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
          };

          /**
           * Verifies an IntentSpec message.
           * @function verify
           * @memberof propel.commrouter.ConversationCommand.CreateResponse.IntentSpec
           * @static
           * @param {Object.<string,*>} message Plain object to verify
           * @returns {string|null} `null` if valid, otherwise the reason why it is not
           */
          IntentSpec.verify = function verify(message) {
            if (typeof message !== 'object' || message === null) return 'object expected';
            if (message.intentId != null && message.hasOwnProperty('intentId'))
              if (!$util.isString(message.intentId)) return 'intentId: string expected';
            if (message.intentClassId != null && message.hasOwnProperty('intentClassId'))
              if (!$util.isString(message.intentClassId)) return 'intentClassId: string expected';
            return null;
          };

          /**
           * Creates an IntentSpec message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof propel.commrouter.ConversationCommand.CreateResponse.IntentSpec
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {propel.commrouter.ConversationCommand.CreateResponse.IntentSpec} IntentSpec
           */
          IntentSpec.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.propel.commrouter.ConversationCommand.CreateResponse.IntentSpec
            )
              return object;
            var message =
              new $root.propel.commrouter.ConversationCommand.CreateResponse.IntentSpec();
            if (object.intentId != null) message.intentId = String(object.intentId);
            if (object.intentClassId != null) message.intentClassId = String(object.intentClassId);
            return message;
          };

          /**
           * Creates a plain object from an IntentSpec message. Also converts values to other types if specified.
           * @function toObject
           * @memberof propel.commrouter.ConversationCommand.CreateResponse.IntentSpec
           * @static
           * @param {propel.commrouter.ConversationCommand.CreateResponse.IntentSpec} message IntentSpec
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          IntentSpec.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.intentId = '';
              object.intentClassId = '';
            }
            if (message.intentId != null && message.hasOwnProperty('intentId'))
              object.intentId = message.intentId;
            if (message.intentClassId != null && message.hasOwnProperty('intentClassId'))
              object.intentClassId = message.intentClassId;
            return object;
          };

          /**
           * Converts this IntentSpec to JSON.
           * @function toJSON
           * @memberof propel.commrouter.ConversationCommand.CreateResponse.IntentSpec
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          IntentSpec.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
          };

          return IntentSpec;
        })();

        CreateResponse.SentenceSpec = (function () {
          /**
           * Properties of a SentenceSpec.
           * @memberof propel.commrouter.ConversationCommand.CreateResponse
           * @interface ISentenceSpec
           * @property {string|null} [sentenceId] SentenceSpec sentenceId
           * @property {Array.<propel.commrouter.ConversationCommand.CreateResponse.IIntentSpec>|null} [intentSpecs] SentenceSpec intentSpecs
           */

          /**
           * Constructs a new SentenceSpec.
           * @memberof propel.commrouter.ConversationCommand.CreateResponse
           * @classdesc Represents a SentenceSpec.
           * @implements ISentenceSpec
           * @constructor
           * @param {propel.commrouter.ConversationCommand.CreateResponse.ISentenceSpec=} [properties] Properties to set
           */
          function SentenceSpec(properties) {
            this.intentSpecs = [];
            if (properties)
              for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
          }

          /**
           * SentenceSpec sentenceId.
           * @member {string} sentenceId
           * @memberof propel.commrouter.ConversationCommand.CreateResponse.SentenceSpec
           * @instance
           */
          SentenceSpec.prototype.sentenceId = '';

          /**
           * SentenceSpec intentSpecs.
           * @member {Array.<propel.commrouter.ConversationCommand.CreateResponse.IIntentSpec>} intentSpecs
           * @memberof propel.commrouter.ConversationCommand.CreateResponse.SentenceSpec
           * @instance
           */
          SentenceSpec.prototype.intentSpecs = $util.emptyArray;

          /**
           * Creates a new SentenceSpec instance using the specified properties.
           * @function create
           * @memberof propel.commrouter.ConversationCommand.CreateResponse.SentenceSpec
           * @static
           * @param {propel.commrouter.ConversationCommand.CreateResponse.ISentenceSpec=} [properties] Properties to set
           * @returns {propel.commrouter.ConversationCommand.CreateResponse.SentenceSpec} SentenceSpec instance
           */
          SentenceSpec.create = function create(properties) {
            return new SentenceSpec(properties);
          };

          /**
           * Encodes the specified SentenceSpec message. Does not implicitly {@link propel.commrouter.ConversationCommand.CreateResponse.SentenceSpec.verify|verify} messages.
           * @function encode
           * @memberof propel.commrouter.ConversationCommand.CreateResponse.SentenceSpec
           * @static
           * @param {propel.commrouter.ConversationCommand.CreateResponse.ISentenceSpec} message SentenceSpec message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          SentenceSpec.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (message.sentenceId != null && message.hasOwnProperty('sentenceId'))
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.sentenceId);
            if (message.intentSpecs != null && message.intentSpecs.length)
              for (var i = 0; i < message.intentSpecs.length; ++i)
                $root.propel.commrouter.ConversationCommand.CreateResponse.IntentSpec.encode(
                  message.intentSpecs[i],
                  writer.uint32(/* id 3, wireType 2 =*/ 26).fork()
                ).ldelim();
            return writer;
          };

          /**
           * Encodes the specified SentenceSpec message, length delimited. Does not implicitly {@link propel.commrouter.ConversationCommand.CreateResponse.SentenceSpec.verify|verify} messages.
           * @function encodeDelimited
           * @memberof propel.commrouter.ConversationCommand.CreateResponse.SentenceSpec
           * @static
           * @param {propel.commrouter.ConversationCommand.CreateResponse.ISentenceSpec} message SentenceSpec message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          SentenceSpec.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
          };

          /**
           * Decodes a SentenceSpec message from the specified reader or buffer.
           * @function decode
           * @memberof propel.commrouter.ConversationCommand.CreateResponse.SentenceSpec
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {propel.commrouter.ConversationCommand.CreateResponse.SentenceSpec} SentenceSpec
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          SentenceSpec.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.propel.commrouter.ConversationCommand.CreateResponse.SentenceSpec();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.sentenceId = reader.string();
                  break;
                case 3:
                  if (!(message.intentSpecs && message.intentSpecs.length))
                    message.intentSpecs = [];
                  message.intentSpecs.push(
                    $root.propel.commrouter.ConversationCommand.CreateResponse.IntentSpec.decode(
                      reader,
                      reader.uint32()
                    )
                  );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Decodes a SentenceSpec message from the specified reader or buffer, length delimited.
           * @function decodeDelimited
           * @memberof propel.commrouter.ConversationCommand.CreateResponse.SentenceSpec
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @returns {propel.commrouter.ConversationCommand.CreateResponse.SentenceSpec} SentenceSpec
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          SentenceSpec.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader)) reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
          };

          /**
           * Verifies a SentenceSpec message.
           * @function verify
           * @memberof propel.commrouter.ConversationCommand.CreateResponse.SentenceSpec
           * @static
           * @param {Object.<string,*>} message Plain object to verify
           * @returns {string|null} `null` if valid, otherwise the reason why it is not
           */
          SentenceSpec.verify = function verify(message) {
            if (typeof message !== 'object' || message === null) return 'object expected';
            if (message.sentenceId != null && message.hasOwnProperty('sentenceId'))
              if (!$util.isString(message.sentenceId)) return 'sentenceId: string expected';
            if (message.intentSpecs != null && message.hasOwnProperty('intentSpecs')) {
              if (!Array.isArray(message.intentSpecs)) return 'intentSpecs: array expected';
              for (var i = 0; i < message.intentSpecs.length; ++i) {
                var error =
                  $root.propel.commrouter.ConversationCommand.CreateResponse.IntentSpec.verify(
                    message.intentSpecs[i]
                  );
                if (error) return 'intentSpecs.' + error;
              }
            }
            return null;
          };

          /**
           * Creates a SentenceSpec message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof propel.commrouter.ConversationCommand.CreateResponse.SentenceSpec
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {propel.commrouter.ConversationCommand.CreateResponse.SentenceSpec} SentenceSpec
           */
          SentenceSpec.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.propel.commrouter.ConversationCommand.CreateResponse.SentenceSpec
            )
              return object;
            var message =
              new $root.propel.commrouter.ConversationCommand.CreateResponse.SentenceSpec();
            if (object.sentenceId != null) message.sentenceId = String(object.sentenceId);
            if (object.intentSpecs) {
              if (!Array.isArray(object.intentSpecs))
                throw TypeError(
                  '.propel.commrouter.ConversationCommand.CreateResponse.SentenceSpec.intentSpecs: array expected'
                );
              message.intentSpecs = [];
              for (var i = 0; i < object.intentSpecs.length; ++i) {
                if (typeof object.intentSpecs[i] !== 'object')
                  throw TypeError(
                    '.propel.commrouter.ConversationCommand.CreateResponse.SentenceSpec.intentSpecs: object expected'
                  );
                message.intentSpecs[i] =
                  $root.propel.commrouter.ConversationCommand.CreateResponse.IntentSpec.fromObject(
                    object.intentSpecs[i]
                  );
              }
            }
            return message;
          };

          /**
           * Creates a plain object from a SentenceSpec message. Also converts values to other types if specified.
           * @function toObject
           * @memberof propel.commrouter.ConversationCommand.CreateResponse.SentenceSpec
           * @static
           * @param {propel.commrouter.ConversationCommand.CreateResponse.SentenceSpec} message SentenceSpec
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          SentenceSpec.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.arrays || options.defaults) object.intentSpecs = [];
            if (options.defaults) object.sentenceId = '';
            if (message.sentenceId != null && message.hasOwnProperty('sentenceId'))
              object.sentenceId = message.sentenceId;
            if (message.intentSpecs && message.intentSpecs.length) {
              object.intentSpecs = [];
              for (var j = 0; j < message.intentSpecs.length; ++j)
                object.intentSpecs[j] =
                  $root.propel.commrouter.ConversationCommand.CreateResponse.IntentSpec.toObject(
                    message.intentSpecs[j],
                    options
                  );
            }
            return object;
          };

          /**
           * Converts this SentenceSpec to JSON.
           * @function toJSON
           * @memberof propel.commrouter.ConversationCommand.CreateResponse.SentenceSpec
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          SentenceSpec.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
          };

          return SentenceSpec;
        })();

        return CreateResponse;
      })();

      ConversationCommand.UpdateSentence = (function () {
        /**
         * Properties of an UpdateSentence.
         * @memberof propel.commrouter.ConversationCommand
         * @interface IUpdateSentence
         * @property {string|null} [sentenceId] UpdateSentence sentenceId
         * @property {propel.commrouter.Sentence.State|null} [state] UpdateSentence state
         */

        /**
         * Constructs a new UpdateSentence.
         * @memberof propel.commrouter.ConversationCommand
         * @classdesc Represents an UpdateSentence.
         * @implements IUpdateSentence
         * @constructor
         * @param {propel.commrouter.ConversationCommand.IUpdateSentence=} [properties] Properties to set
         */
        function UpdateSentence(properties) {
          if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
              if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
        }

        /**
         * UpdateSentence sentenceId.
         * @member {string} sentenceId
         * @memberof propel.commrouter.ConversationCommand.UpdateSentence
         * @instance
         */
        UpdateSentence.prototype.sentenceId = '';

        /**
         * UpdateSentence state.
         * @member {propel.commrouter.Sentence.State} state
         * @memberof propel.commrouter.ConversationCommand.UpdateSentence
         * @instance
         */
        UpdateSentence.prototype.state = 0;

        /**
         * Creates a new UpdateSentence instance using the specified properties.
         * @function create
         * @memberof propel.commrouter.ConversationCommand.UpdateSentence
         * @static
         * @param {propel.commrouter.ConversationCommand.IUpdateSentence=} [properties] Properties to set
         * @returns {propel.commrouter.ConversationCommand.UpdateSentence} UpdateSentence instance
         */
        UpdateSentence.create = function create(properties) {
          return new UpdateSentence(properties);
        };

        /**
         * Encodes the specified UpdateSentence message. Does not implicitly {@link propel.commrouter.ConversationCommand.UpdateSentence.verify|verify} messages.
         * @function encode
         * @memberof propel.commrouter.ConversationCommand.UpdateSentence
         * @static
         * @param {propel.commrouter.ConversationCommand.IUpdateSentence} message UpdateSentence message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UpdateSentence.encode = function encode(message, writer) {
          if (!writer) writer = $Writer.create();
          if (message.sentenceId != null && message.hasOwnProperty('sentenceId'))
            writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.sentenceId);
          if (message.state != null && message.hasOwnProperty('state'))
            writer.uint32(/* id 2, wireType 0 =*/ 16).int32(message.state);
          return writer;
        };

        /**
         * Encodes the specified UpdateSentence message, length delimited. Does not implicitly {@link propel.commrouter.ConversationCommand.UpdateSentence.verify|verify} messages.
         * @function encodeDelimited
         * @memberof propel.commrouter.ConversationCommand.UpdateSentence
         * @static
         * @param {propel.commrouter.ConversationCommand.IUpdateSentence} message UpdateSentence message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UpdateSentence.encodeDelimited = function encodeDelimited(message, writer) {
          return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an UpdateSentence message from the specified reader or buffer.
         * @function decode
         * @memberof propel.commrouter.ConversationCommand.UpdateSentence
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {propel.commrouter.ConversationCommand.UpdateSentence} UpdateSentence
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UpdateSentence.decode = function decode(reader, length) {
          if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
          var end = length === undefined ? reader.len : reader.pos + length,
            message = new $root.propel.commrouter.ConversationCommand.UpdateSentence();
          while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
              case 1:
                message.sentenceId = reader.string();
                break;
              case 2:
                message.state = reader.int32();
                break;
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };

        /**
         * Decodes an UpdateSentence message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof propel.commrouter.ConversationCommand.UpdateSentence
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {propel.commrouter.ConversationCommand.UpdateSentence} UpdateSentence
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UpdateSentence.decodeDelimited = function decodeDelimited(reader) {
          if (!(reader instanceof $Reader)) reader = new $Reader(reader);
          return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an UpdateSentence message.
         * @function verify
         * @memberof propel.commrouter.ConversationCommand.UpdateSentence
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        UpdateSentence.verify = function verify(message) {
          if (typeof message !== 'object' || message === null) return 'object expected';
          if (message.sentenceId != null && message.hasOwnProperty('sentenceId'))
            if (!$util.isString(message.sentenceId)) return 'sentenceId: string expected';
          if (message.state != null && message.hasOwnProperty('state'))
            switch (message.state) {
              default:
                return 'state: enum value expected';
              case 0:
              case 1:
              case 2:
              case 3:
                break;
            }
          return null;
        };

        /**
         * Creates an UpdateSentence message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof propel.commrouter.ConversationCommand.UpdateSentence
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {propel.commrouter.ConversationCommand.UpdateSentence} UpdateSentence
         */
        UpdateSentence.fromObject = function fromObject(object) {
          if (object instanceof $root.propel.commrouter.ConversationCommand.UpdateSentence)
            return object;
          var message = new $root.propel.commrouter.ConversationCommand.UpdateSentence();
          if (object.sentenceId != null) message.sentenceId = String(object.sentenceId);
          switch (object.state) {
            case 'STATE_UNKNOWN':
            case 0:
              message.state = 0;
              break;
            case 'STATE_INITIAL':
            case 1:
              message.state = 1;
              break;
            case 'STATE_RESPONDED':
            case 2:
              message.state = 2;
              break;
            case 'STATE_SKIPPED':
            case 3:
              message.state = 3;
              break;
          }
          return message;
        };

        /**
         * Creates a plain object from an UpdateSentence message. Also converts values to other types if specified.
         * @function toObject
         * @memberof propel.commrouter.ConversationCommand.UpdateSentence
         * @static
         * @param {propel.commrouter.ConversationCommand.UpdateSentence} message UpdateSentence
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UpdateSentence.toObject = function toObject(message, options) {
          if (!options) options = {};
          var object = {};
          if (options.defaults) {
            object.sentenceId = '';
            object.state = options.enums === String ? 'STATE_UNKNOWN' : 0;
          }
          if (message.sentenceId != null && message.hasOwnProperty('sentenceId'))
            object.sentenceId = message.sentenceId;
          if (message.state != null && message.hasOwnProperty('state'))
            object.state =
              options.enums === String
                ? $root.propel.commrouter.Sentence.State[message.state]
                : message.state;
          return object;
        };

        /**
         * Converts this UpdateSentence to JSON.
         * @function toJSON
         * @memberof propel.commrouter.ConversationCommand.UpdateSentence
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UpdateSentence.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return UpdateSentence;
      })();

      ConversationCommand.PutConversationState = (function () {
        /**
         * Properties of a PutConversationState.
         * @memberof propel.commrouter.ConversationCommand
         * @interface IPutConversationState
         * @property {propel.commrouter.IConversationState|null} [conversationState] PutConversationState conversationState
         */

        /**
         * Constructs a new PutConversationState.
         * @memberof propel.commrouter.ConversationCommand
         * @classdesc Represents a PutConversationState.
         * @implements IPutConversationState
         * @constructor
         * @param {propel.commrouter.ConversationCommand.IPutConversationState=} [properties] Properties to set
         */
        function PutConversationState(properties) {
          if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
              if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
        }

        /**
         * PutConversationState conversationState.
         * @member {propel.commrouter.IConversationState|null|undefined} conversationState
         * @memberof propel.commrouter.ConversationCommand.PutConversationState
         * @instance
         */
        PutConversationState.prototype.conversationState = null;

        /**
         * Creates a new PutConversationState instance using the specified properties.
         * @function create
         * @memberof propel.commrouter.ConversationCommand.PutConversationState
         * @static
         * @param {propel.commrouter.ConversationCommand.IPutConversationState=} [properties] Properties to set
         * @returns {propel.commrouter.ConversationCommand.PutConversationState} PutConversationState instance
         */
        PutConversationState.create = function create(properties) {
          return new PutConversationState(properties);
        };

        /**
         * Encodes the specified PutConversationState message. Does not implicitly {@link propel.commrouter.ConversationCommand.PutConversationState.verify|verify} messages.
         * @function encode
         * @memberof propel.commrouter.ConversationCommand.PutConversationState
         * @static
         * @param {propel.commrouter.ConversationCommand.IPutConversationState} message PutConversationState message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PutConversationState.encode = function encode(message, writer) {
          if (!writer) writer = $Writer.create();
          if (message.conversationState != null && message.hasOwnProperty('conversationState'))
            $root.propel.commrouter.ConversationState.encode(
              message.conversationState,
              writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
            ).ldelim();
          return writer;
        };

        /**
         * Encodes the specified PutConversationState message, length delimited. Does not implicitly {@link propel.commrouter.ConversationCommand.PutConversationState.verify|verify} messages.
         * @function encodeDelimited
         * @memberof propel.commrouter.ConversationCommand.PutConversationState
         * @static
         * @param {propel.commrouter.ConversationCommand.IPutConversationState} message PutConversationState message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PutConversationState.encodeDelimited = function encodeDelimited(message, writer) {
          return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a PutConversationState message from the specified reader or buffer.
         * @function decode
         * @memberof propel.commrouter.ConversationCommand.PutConversationState
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {propel.commrouter.ConversationCommand.PutConversationState} PutConversationState
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PutConversationState.decode = function decode(reader, length) {
          if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
          var end = length === undefined ? reader.len : reader.pos + length,
            message = new $root.propel.commrouter.ConversationCommand.PutConversationState();
          while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
              case 1:
                message.conversationState = $root.propel.commrouter.ConversationState.decode(
                  reader,
                  reader.uint32()
                );
                break;
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };

        /**
         * Decodes a PutConversationState message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof propel.commrouter.ConversationCommand.PutConversationState
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {propel.commrouter.ConversationCommand.PutConversationState} PutConversationState
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PutConversationState.decodeDelimited = function decodeDelimited(reader) {
          if (!(reader instanceof $Reader)) reader = new $Reader(reader);
          return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a PutConversationState message.
         * @function verify
         * @memberof propel.commrouter.ConversationCommand.PutConversationState
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        PutConversationState.verify = function verify(message) {
          if (typeof message !== 'object' || message === null) return 'object expected';
          if (message.conversationState != null && message.hasOwnProperty('conversationState')) {
            var error = $root.propel.commrouter.ConversationState.verify(message.conversationState);
            if (error) return 'conversationState.' + error;
          }
          return null;
        };

        /**
         * Creates a PutConversationState message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof propel.commrouter.ConversationCommand.PutConversationState
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {propel.commrouter.ConversationCommand.PutConversationState} PutConversationState
         */
        PutConversationState.fromObject = function fromObject(object) {
          if (object instanceof $root.propel.commrouter.ConversationCommand.PutConversationState)
            return object;
          var message = new $root.propel.commrouter.ConversationCommand.PutConversationState();
          if (object.conversationState != null) {
            if (typeof object.conversationState !== 'object')
              throw TypeError(
                '.propel.commrouter.ConversationCommand.PutConversationState.conversationState: object expected'
              );
            message.conversationState = $root.propel.commrouter.ConversationState.fromObject(
              object.conversationState
            );
          }
          return message;
        };

        /**
         * Creates a plain object from a PutConversationState message. Also converts values to other types if specified.
         * @function toObject
         * @memberof propel.commrouter.ConversationCommand.PutConversationState
         * @static
         * @param {propel.commrouter.ConversationCommand.PutConversationState} message PutConversationState
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        PutConversationState.toObject = function toObject(message, options) {
          if (!options) options = {};
          var object = {};
          if (options.defaults) object.conversationState = null;
          if (message.conversationState != null && message.hasOwnProperty('conversationState'))
            object.conversationState = $root.propel.commrouter.ConversationState.toObject(
              message.conversationState,
              options
            );
          return object;
        };

        /**
         * Converts this PutConversationState to JSON.
         * @function toJSON
         * @memberof propel.commrouter.ConversationCommand.PutConversationState
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        PutConversationState.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return PutConversationState;
      })();

      ConversationCommand.PutContext = (function () {
        /**
         * Properties of a PutContext.
         * @memberof propel.commrouter.ConversationCommand
         * @interface IPutContext
         * @property {propel.commrouter.IContext|null} [context] PutContext context
         */

        /**
         * Constructs a new PutContext.
         * @memberof propel.commrouter.ConversationCommand
         * @classdesc Represents a PutContext.
         * @implements IPutContext
         * @constructor
         * @param {propel.commrouter.ConversationCommand.IPutContext=} [properties] Properties to set
         */
        function PutContext(properties) {
          if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
              if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
        }

        /**
         * PutContext context.
         * @member {propel.commrouter.IContext|null|undefined} context
         * @memberof propel.commrouter.ConversationCommand.PutContext
         * @instance
         */
        PutContext.prototype.context = null;

        /**
         * Creates a new PutContext instance using the specified properties.
         * @function create
         * @memberof propel.commrouter.ConversationCommand.PutContext
         * @static
         * @param {propel.commrouter.ConversationCommand.IPutContext=} [properties] Properties to set
         * @returns {propel.commrouter.ConversationCommand.PutContext} PutContext instance
         */
        PutContext.create = function create(properties) {
          return new PutContext(properties);
        };

        /**
         * Encodes the specified PutContext message. Does not implicitly {@link propel.commrouter.ConversationCommand.PutContext.verify|verify} messages.
         * @function encode
         * @memberof propel.commrouter.ConversationCommand.PutContext
         * @static
         * @param {propel.commrouter.ConversationCommand.IPutContext} message PutContext message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PutContext.encode = function encode(message, writer) {
          if (!writer) writer = $Writer.create();
          if (message.context != null && message.hasOwnProperty('context'))
            $root.propel.commrouter.Context.encode(
              message.context,
              writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
            ).ldelim();
          return writer;
        };

        /**
         * Encodes the specified PutContext message, length delimited. Does not implicitly {@link propel.commrouter.ConversationCommand.PutContext.verify|verify} messages.
         * @function encodeDelimited
         * @memberof propel.commrouter.ConversationCommand.PutContext
         * @static
         * @param {propel.commrouter.ConversationCommand.IPutContext} message PutContext message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PutContext.encodeDelimited = function encodeDelimited(message, writer) {
          return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a PutContext message from the specified reader or buffer.
         * @function decode
         * @memberof propel.commrouter.ConversationCommand.PutContext
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {propel.commrouter.ConversationCommand.PutContext} PutContext
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PutContext.decode = function decode(reader, length) {
          if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
          var end = length === undefined ? reader.len : reader.pos + length,
            message = new $root.propel.commrouter.ConversationCommand.PutContext();
          while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
              case 1:
                message.context = $root.propel.commrouter.Context.decode(reader, reader.uint32());
                break;
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };

        /**
         * Decodes a PutContext message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof propel.commrouter.ConversationCommand.PutContext
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {propel.commrouter.ConversationCommand.PutContext} PutContext
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PutContext.decodeDelimited = function decodeDelimited(reader) {
          if (!(reader instanceof $Reader)) reader = new $Reader(reader);
          return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a PutContext message.
         * @function verify
         * @memberof propel.commrouter.ConversationCommand.PutContext
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        PutContext.verify = function verify(message) {
          if (typeof message !== 'object' || message === null) return 'object expected';
          if (message.context != null && message.hasOwnProperty('context')) {
            var error = $root.propel.commrouter.Context.verify(message.context);
            if (error) return 'context.' + error;
          }
          return null;
        };

        /**
         * Creates a PutContext message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof propel.commrouter.ConversationCommand.PutContext
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {propel.commrouter.ConversationCommand.PutContext} PutContext
         */
        PutContext.fromObject = function fromObject(object) {
          if (object instanceof $root.propel.commrouter.ConversationCommand.PutContext)
            return object;
          var message = new $root.propel.commrouter.ConversationCommand.PutContext();
          if (object.context != null) {
            if (typeof object.context !== 'object')
              throw TypeError(
                '.propel.commrouter.ConversationCommand.PutContext.context: object expected'
              );
            message.context = $root.propel.commrouter.Context.fromObject(object.context);
          }
          return message;
        };

        /**
         * Creates a plain object from a PutContext message. Also converts values to other types if specified.
         * @function toObject
         * @memberof propel.commrouter.ConversationCommand.PutContext
         * @static
         * @param {propel.commrouter.ConversationCommand.PutContext} message PutContext
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        PutContext.toObject = function toObject(message, options) {
          if (!options) options = {};
          var object = {};
          if (options.defaults) object.context = null;
          if (message.context != null && message.hasOwnProperty('context'))
            object.context = $root.propel.commrouter.Context.toObject(message.context, options);
          return object;
        };

        /**
         * Converts this PutContext to JSON.
         * @function toJSON
         * @memberof propel.commrouter.ConversationCommand.PutContext
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        PutContext.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return PutContext;
      })();

      ConversationCommand.PutResponse = (function () {
        /**
         * Properties of a PutResponse.
         * @memberof propel.commrouter.ConversationCommand
         * @interface IPutResponse
         * @property {propel.commrouter.IResponse|null} [response] PutResponse response
         */

        /**
         * Constructs a new PutResponse.
         * @memberof propel.commrouter.ConversationCommand
         * @classdesc Represents a PutResponse.
         * @implements IPutResponse
         * @constructor
         * @param {propel.commrouter.ConversationCommand.IPutResponse=} [properties] Properties to set
         */
        function PutResponse(properties) {
          if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
              if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
        }

        /**
         * PutResponse response.
         * @member {propel.commrouter.IResponse|null|undefined} response
         * @memberof propel.commrouter.ConversationCommand.PutResponse
         * @instance
         */
        PutResponse.prototype.response = null;

        /**
         * Creates a new PutResponse instance using the specified properties.
         * @function create
         * @memberof propel.commrouter.ConversationCommand.PutResponse
         * @static
         * @param {propel.commrouter.ConversationCommand.IPutResponse=} [properties] Properties to set
         * @returns {propel.commrouter.ConversationCommand.PutResponse} PutResponse instance
         */
        PutResponse.create = function create(properties) {
          return new PutResponse(properties);
        };

        /**
         * Encodes the specified PutResponse message. Does not implicitly {@link propel.commrouter.ConversationCommand.PutResponse.verify|verify} messages.
         * @function encode
         * @memberof propel.commrouter.ConversationCommand.PutResponse
         * @static
         * @param {propel.commrouter.ConversationCommand.IPutResponse} message PutResponse message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PutResponse.encode = function encode(message, writer) {
          if (!writer) writer = $Writer.create();
          if (message.response != null && message.hasOwnProperty('response'))
            $root.propel.commrouter.Response.encode(
              message.response,
              writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
            ).ldelim();
          return writer;
        };

        /**
         * Encodes the specified PutResponse message, length delimited. Does not implicitly {@link propel.commrouter.ConversationCommand.PutResponse.verify|verify} messages.
         * @function encodeDelimited
         * @memberof propel.commrouter.ConversationCommand.PutResponse
         * @static
         * @param {propel.commrouter.ConversationCommand.IPutResponse} message PutResponse message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PutResponse.encodeDelimited = function encodeDelimited(message, writer) {
          return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a PutResponse message from the specified reader or buffer.
         * @function decode
         * @memberof propel.commrouter.ConversationCommand.PutResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {propel.commrouter.ConversationCommand.PutResponse} PutResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PutResponse.decode = function decode(reader, length) {
          if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
          var end = length === undefined ? reader.len : reader.pos + length,
            message = new $root.propel.commrouter.ConversationCommand.PutResponse();
          while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
              case 1:
                message.response = $root.propel.commrouter.Response.decode(reader, reader.uint32());
                break;
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };

        /**
         * Decodes a PutResponse message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof propel.commrouter.ConversationCommand.PutResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {propel.commrouter.ConversationCommand.PutResponse} PutResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PutResponse.decodeDelimited = function decodeDelimited(reader) {
          if (!(reader instanceof $Reader)) reader = new $Reader(reader);
          return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a PutResponse message.
         * @function verify
         * @memberof propel.commrouter.ConversationCommand.PutResponse
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        PutResponse.verify = function verify(message) {
          if (typeof message !== 'object' || message === null) return 'object expected';
          if (message.response != null && message.hasOwnProperty('response')) {
            var error = $root.propel.commrouter.Response.verify(message.response);
            if (error) return 'response.' + error;
          }
          return null;
        };

        /**
         * Creates a PutResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof propel.commrouter.ConversationCommand.PutResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {propel.commrouter.ConversationCommand.PutResponse} PutResponse
         */
        PutResponse.fromObject = function fromObject(object) {
          if (object instanceof $root.propel.commrouter.ConversationCommand.PutResponse)
            return object;
          var message = new $root.propel.commrouter.ConversationCommand.PutResponse();
          if (object.response != null) {
            if (typeof object.response !== 'object')
              throw TypeError(
                '.propel.commrouter.ConversationCommand.PutResponse.response: object expected'
              );
            message.response = $root.propel.commrouter.Response.fromObject(object.response);
          }
          return message;
        };

        /**
         * Creates a plain object from a PutResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof propel.commrouter.ConversationCommand.PutResponse
         * @static
         * @param {propel.commrouter.ConversationCommand.PutResponse} message PutResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        PutResponse.toObject = function toObject(message, options) {
          if (!options) options = {};
          var object = {};
          if (options.defaults) object.response = null;
          if (message.response != null && message.hasOwnProperty('response'))
            object.response = $root.propel.commrouter.Response.toObject(message.response, options);
          return object;
        };

        /**
         * Converts this PutResponse to JSON.
         * @function toJSON
         * @memberof propel.commrouter.ConversationCommand.PutResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        PutResponse.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return PutResponse;
      })();

      ConversationCommand.CreateResponseMessage = (function () {
        /**
         * Properties of a CreateResponseMessage.
         * @memberof propel.commrouter.ConversationCommand
         * @interface ICreateResponseMessage
         * @property {string|null} [responseId] CreateResponseMessage responseId
         * @property {Array.<propel.core.IMessageBody>|null} [messageBodies] CreateResponseMessage messageBodies
         * @property {propel.commrouter.IVendorId|null} [avatarId] CreateResponseMessage avatarId
         */

        /**
         * Constructs a new CreateResponseMessage.
         * @memberof propel.commrouter.ConversationCommand
         * @classdesc Represents a CreateResponseMessage.
         * @implements ICreateResponseMessage
         * @constructor
         * @param {propel.commrouter.ConversationCommand.ICreateResponseMessage=} [properties] Properties to set
         */
        function CreateResponseMessage(properties) {
          this.messageBodies = [];
          if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
              if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
        }

        /**
         * CreateResponseMessage responseId.
         * @member {string} responseId
         * @memberof propel.commrouter.ConversationCommand.CreateResponseMessage
         * @instance
         */
        CreateResponseMessage.prototype.responseId = '';

        /**
         * CreateResponseMessage messageBodies.
         * @member {Array.<propel.core.IMessageBody>} messageBodies
         * @memberof propel.commrouter.ConversationCommand.CreateResponseMessage
         * @instance
         */
        CreateResponseMessage.prototype.messageBodies = $util.emptyArray;

        /**
         * CreateResponseMessage avatarId.
         * @member {propel.commrouter.IVendorId|null|undefined} avatarId
         * @memberof propel.commrouter.ConversationCommand.CreateResponseMessage
         * @instance
         */
        CreateResponseMessage.prototype.avatarId = null;

        /**
         * Creates a new CreateResponseMessage instance using the specified properties.
         * @function create
         * @memberof propel.commrouter.ConversationCommand.CreateResponseMessage
         * @static
         * @param {propel.commrouter.ConversationCommand.ICreateResponseMessage=} [properties] Properties to set
         * @returns {propel.commrouter.ConversationCommand.CreateResponseMessage} CreateResponseMessage instance
         */
        CreateResponseMessage.create = function create(properties) {
          return new CreateResponseMessage(properties);
        };

        /**
         * Encodes the specified CreateResponseMessage message. Does not implicitly {@link propel.commrouter.ConversationCommand.CreateResponseMessage.verify|verify} messages.
         * @function encode
         * @memberof propel.commrouter.ConversationCommand.CreateResponseMessage
         * @static
         * @param {propel.commrouter.ConversationCommand.ICreateResponseMessage} message CreateResponseMessage message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CreateResponseMessage.encode = function encode(message, writer) {
          if (!writer) writer = $Writer.create();
          if (message.responseId != null && message.hasOwnProperty('responseId'))
            writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.responseId);
          if (message.messageBodies != null && message.messageBodies.length)
            for (var i = 0; i < message.messageBodies.length; ++i)
              $root.propel.core.MessageBody.encode(
                message.messageBodies[i],
                writer.uint32(/* id 2, wireType 2 =*/ 18).fork()
              ).ldelim();
          if (message.avatarId != null && message.hasOwnProperty('avatarId'))
            $root.propel.commrouter.VendorId.encode(
              message.avatarId,
              writer.uint32(/* id 3, wireType 2 =*/ 26).fork()
            ).ldelim();
          return writer;
        };

        /**
         * Encodes the specified CreateResponseMessage message, length delimited. Does not implicitly {@link propel.commrouter.ConversationCommand.CreateResponseMessage.verify|verify} messages.
         * @function encodeDelimited
         * @memberof propel.commrouter.ConversationCommand.CreateResponseMessage
         * @static
         * @param {propel.commrouter.ConversationCommand.ICreateResponseMessage} message CreateResponseMessage message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CreateResponseMessage.encodeDelimited = function encodeDelimited(message, writer) {
          return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a CreateResponseMessage message from the specified reader or buffer.
         * @function decode
         * @memberof propel.commrouter.ConversationCommand.CreateResponseMessage
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {propel.commrouter.ConversationCommand.CreateResponseMessage} CreateResponseMessage
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CreateResponseMessage.decode = function decode(reader, length) {
          if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
          var end = length === undefined ? reader.len : reader.pos + length,
            message = new $root.propel.commrouter.ConversationCommand.CreateResponseMessage();
          while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
              case 1:
                message.responseId = reader.string();
                break;
              case 2:
                if (!(message.messageBodies && message.messageBodies.length))
                  message.messageBodies = [];
                message.messageBodies.push(
                  $root.propel.core.MessageBody.decode(reader, reader.uint32())
                );
                break;
              case 3:
                message.avatarId = $root.propel.commrouter.VendorId.decode(reader, reader.uint32());
                break;
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };

        /**
         * Decodes a CreateResponseMessage message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof propel.commrouter.ConversationCommand.CreateResponseMessage
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {propel.commrouter.ConversationCommand.CreateResponseMessage} CreateResponseMessage
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CreateResponseMessage.decodeDelimited = function decodeDelimited(reader) {
          if (!(reader instanceof $Reader)) reader = new $Reader(reader);
          return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a CreateResponseMessage message.
         * @function verify
         * @memberof propel.commrouter.ConversationCommand.CreateResponseMessage
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        CreateResponseMessage.verify = function verify(message) {
          if (typeof message !== 'object' || message === null) return 'object expected';
          if (message.responseId != null && message.hasOwnProperty('responseId'))
            if (!$util.isString(message.responseId)) return 'responseId: string expected';
          if (message.messageBodies != null && message.hasOwnProperty('messageBodies')) {
            if (!Array.isArray(message.messageBodies)) return 'messageBodies: array expected';
            for (var i = 0; i < message.messageBodies.length; ++i) {
              var error = $root.propel.core.MessageBody.verify(message.messageBodies[i]);
              if (error) return 'messageBodies.' + error;
            }
          }
          if (message.avatarId != null && message.hasOwnProperty('avatarId')) {
            var error = $root.propel.commrouter.VendorId.verify(message.avatarId);
            if (error) return 'avatarId.' + error;
          }
          return null;
        };

        /**
         * Creates a CreateResponseMessage message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof propel.commrouter.ConversationCommand.CreateResponseMessage
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {propel.commrouter.ConversationCommand.CreateResponseMessage} CreateResponseMessage
         */
        CreateResponseMessage.fromObject = function fromObject(object) {
          if (object instanceof $root.propel.commrouter.ConversationCommand.CreateResponseMessage)
            return object;
          var message = new $root.propel.commrouter.ConversationCommand.CreateResponseMessage();
          if (object.responseId != null) message.responseId = String(object.responseId);
          if (object.messageBodies) {
            if (!Array.isArray(object.messageBodies))
              throw TypeError(
                '.propel.commrouter.ConversationCommand.CreateResponseMessage.messageBodies: array expected'
              );
            message.messageBodies = [];
            for (var i = 0; i < object.messageBodies.length; ++i) {
              if (typeof object.messageBodies[i] !== 'object')
                throw TypeError(
                  '.propel.commrouter.ConversationCommand.CreateResponseMessage.messageBodies: object expected'
                );
              message.messageBodies[i] = $root.propel.core.MessageBody.fromObject(
                object.messageBodies[i]
              );
            }
          }
          if (object.avatarId != null) {
            if (typeof object.avatarId !== 'object')
              throw TypeError(
                '.propel.commrouter.ConversationCommand.CreateResponseMessage.avatarId: object expected'
              );
            message.avatarId = $root.propel.commrouter.VendorId.fromObject(object.avatarId);
          }
          return message;
        };

        /**
         * Creates a plain object from a CreateResponseMessage message. Also converts values to other types if specified.
         * @function toObject
         * @memberof propel.commrouter.ConversationCommand.CreateResponseMessage
         * @static
         * @param {propel.commrouter.ConversationCommand.CreateResponseMessage} message CreateResponseMessage
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CreateResponseMessage.toObject = function toObject(message, options) {
          if (!options) options = {};
          var object = {};
          if (options.arrays || options.defaults) object.messageBodies = [];
          if (options.defaults) {
            object.responseId = '';
            object.avatarId = null;
          }
          if (message.responseId != null && message.hasOwnProperty('responseId'))
            object.responseId = message.responseId;
          if (message.messageBodies && message.messageBodies.length) {
            object.messageBodies = [];
            for (var j = 0; j < message.messageBodies.length; ++j)
              object.messageBodies[j] = $root.propel.core.MessageBody.toObject(
                message.messageBodies[j],
                options
              );
          }
          if (message.avatarId != null && message.hasOwnProperty('avatarId'))
            object.avatarId = $root.propel.commrouter.VendorId.toObject(message.avatarId, options);
          return object;
        };

        /**
         * Converts this CreateResponseMessage to JSON.
         * @function toJSON
         * @memberof propel.commrouter.ConversationCommand.CreateResponseMessage
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CreateResponseMessage.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return CreateResponseMessage;
      })();

      ConversationCommand.PutConversationMode = (function () {
        /**
         * Properties of a PutConversationMode.
         * @memberof propel.commrouter.ConversationCommand
         * @interface IPutConversationMode
         * @property {propel.commrouter.IConversationMode|null} [conversationMode] PutConversationMode conversationMode
         */

        /**
         * Constructs a new PutConversationMode.
         * @memberof propel.commrouter.ConversationCommand
         * @classdesc Represents a PutConversationMode.
         * @implements IPutConversationMode
         * @constructor
         * @param {propel.commrouter.ConversationCommand.IPutConversationMode=} [properties] Properties to set
         */
        function PutConversationMode(properties) {
          if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
              if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
        }

        /**
         * PutConversationMode conversationMode.
         * @member {propel.commrouter.IConversationMode|null|undefined} conversationMode
         * @memberof propel.commrouter.ConversationCommand.PutConversationMode
         * @instance
         */
        PutConversationMode.prototype.conversationMode = null;

        /**
         * Creates a new PutConversationMode instance using the specified properties.
         * @function create
         * @memberof propel.commrouter.ConversationCommand.PutConversationMode
         * @static
         * @param {propel.commrouter.ConversationCommand.IPutConversationMode=} [properties] Properties to set
         * @returns {propel.commrouter.ConversationCommand.PutConversationMode} PutConversationMode instance
         */
        PutConversationMode.create = function create(properties) {
          return new PutConversationMode(properties);
        };

        /**
         * Encodes the specified PutConversationMode message. Does not implicitly {@link propel.commrouter.ConversationCommand.PutConversationMode.verify|verify} messages.
         * @function encode
         * @memberof propel.commrouter.ConversationCommand.PutConversationMode
         * @static
         * @param {propel.commrouter.ConversationCommand.IPutConversationMode} message PutConversationMode message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PutConversationMode.encode = function encode(message, writer) {
          if (!writer) writer = $Writer.create();
          if (message.conversationMode != null && message.hasOwnProperty('conversationMode'))
            $root.propel.commrouter.ConversationMode.encode(
              message.conversationMode,
              writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
            ).ldelim();
          return writer;
        };

        /**
         * Encodes the specified PutConversationMode message, length delimited. Does not implicitly {@link propel.commrouter.ConversationCommand.PutConversationMode.verify|verify} messages.
         * @function encodeDelimited
         * @memberof propel.commrouter.ConversationCommand.PutConversationMode
         * @static
         * @param {propel.commrouter.ConversationCommand.IPutConversationMode} message PutConversationMode message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PutConversationMode.encodeDelimited = function encodeDelimited(message, writer) {
          return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a PutConversationMode message from the specified reader or buffer.
         * @function decode
         * @memberof propel.commrouter.ConversationCommand.PutConversationMode
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {propel.commrouter.ConversationCommand.PutConversationMode} PutConversationMode
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PutConversationMode.decode = function decode(reader, length) {
          if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
          var end = length === undefined ? reader.len : reader.pos + length,
            message = new $root.propel.commrouter.ConversationCommand.PutConversationMode();
          while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
              case 1:
                message.conversationMode = $root.propel.commrouter.ConversationMode.decode(
                  reader,
                  reader.uint32()
                );
                break;
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };

        /**
         * Decodes a PutConversationMode message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof propel.commrouter.ConversationCommand.PutConversationMode
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {propel.commrouter.ConversationCommand.PutConversationMode} PutConversationMode
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PutConversationMode.decodeDelimited = function decodeDelimited(reader) {
          if (!(reader instanceof $Reader)) reader = new $Reader(reader);
          return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a PutConversationMode message.
         * @function verify
         * @memberof propel.commrouter.ConversationCommand.PutConversationMode
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        PutConversationMode.verify = function verify(message) {
          if (typeof message !== 'object' || message === null) return 'object expected';
          if (message.conversationMode != null && message.hasOwnProperty('conversationMode')) {
            var error = $root.propel.commrouter.ConversationMode.verify(message.conversationMode);
            if (error) return 'conversationMode.' + error;
          }
          return null;
        };

        /**
         * Creates a PutConversationMode message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof propel.commrouter.ConversationCommand.PutConversationMode
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {propel.commrouter.ConversationCommand.PutConversationMode} PutConversationMode
         */
        PutConversationMode.fromObject = function fromObject(object) {
          if (object instanceof $root.propel.commrouter.ConversationCommand.PutConversationMode)
            return object;
          var message = new $root.propel.commrouter.ConversationCommand.PutConversationMode();
          if (object.conversationMode != null) {
            if (typeof object.conversationMode !== 'object')
              throw TypeError(
                '.propel.commrouter.ConversationCommand.PutConversationMode.conversationMode: object expected'
              );
            message.conversationMode = $root.propel.commrouter.ConversationMode.fromObject(
              object.conversationMode
            );
          }
          return message;
        };

        /**
         * Creates a plain object from a PutConversationMode message. Also converts values to other types if specified.
         * @function toObject
         * @memberof propel.commrouter.ConversationCommand.PutConversationMode
         * @static
         * @param {propel.commrouter.ConversationCommand.PutConversationMode} message PutConversationMode
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        PutConversationMode.toObject = function toObject(message, options) {
          if (!options) options = {};
          var object = {};
          if (options.defaults) object.conversationMode = null;
          if (message.conversationMode != null && message.hasOwnProperty('conversationMode'))
            object.conversationMode = $root.propel.commrouter.ConversationMode.toObject(
              message.conversationMode,
              options
            );
          return object;
        };

        /**
         * Converts this PutConversationMode to JSON.
         * @function toJSON
         * @memberof propel.commrouter.ConversationCommand.PutConversationMode
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        PutConversationMode.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return PutConversationMode;
      })();

      ConversationCommand.UpdateConversationMode = (function () {
        /**
         * Properties of an UpdateConversationMode.
         * @memberof propel.commrouter.ConversationCommand
         * @interface IUpdateConversationMode
         * @property {propel.commrouter.IVendorId|null} [channelId] UpdateConversationMode channelId
         * @property {propel.commrouter.ConversationMode.State|null} [state] UpdateConversationMode state
         * @property {propel.commrouter.ConversationMode.SupportState|null} [supportState] UpdateConversationMode supportState
         * @property {google.protobuf.IStringValue|null} [supportStateType] UpdateConversationMode supportStateType
         * @property {google.protobuf.IStringValue|null} [supportStateReason] UpdateConversationMode supportStateReason
         */

        /**
         * Constructs a new UpdateConversationMode.
         * @memberof propel.commrouter.ConversationCommand
         * @classdesc Represents an UpdateConversationMode.
         * @implements IUpdateConversationMode
         * @constructor
         * @param {propel.commrouter.ConversationCommand.IUpdateConversationMode=} [properties] Properties to set
         */
        function UpdateConversationMode(properties) {
          if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
              if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
        }

        /**
         * UpdateConversationMode channelId.
         * @member {propel.commrouter.IVendorId|null|undefined} channelId
         * @memberof propel.commrouter.ConversationCommand.UpdateConversationMode
         * @instance
         */
        UpdateConversationMode.prototype.channelId = null;

        /**
         * UpdateConversationMode state.
         * @member {propel.commrouter.ConversationMode.State} state
         * @memberof propel.commrouter.ConversationCommand.UpdateConversationMode
         * @instance
         */
        UpdateConversationMode.prototype.state = 0;

        /**
         * UpdateConversationMode supportState.
         * @member {propel.commrouter.ConversationMode.SupportState} supportState
         * @memberof propel.commrouter.ConversationCommand.UpdateConversationMode
         * @instance
         */
        UpdateConversationMode.prototype.supportState = 0;

        /**
         * UpdateConversationMode supportStateType.
         * @member {google.protobuf.IStringValue|null|undefined} supportStateType
         * @memberof propel.commrouter.ConversationCommand.UpdateConversationMode
         * @instance
         */
        UpdateConversationMode.prototype.supportStateType = null;

        /**
         * UpdateConversationMode supportStateReason.
         * @member {google.protobuf.IStringValue|null|undefined} supportStateReason
         * @memberof propel.commrouter.ConversationCommand.UpdateConversationMode
         * @instance
         */
        UpdateConversationMode.prototype.supportStateReason = null;

        /**
         * Creates a new UpdateConversationMode instance using the specified properties.
         * @function create
         * @memberof propel.commrouter.ConversationCommand.UpdateConversationMode
         * @static
         * @param {propel.commrouter.ConversationCommand.IUpdateConversationMode=} [properties] Properties to set
         * @returns {propel.commrouter.ConversationCommand.UpdateConversationMode} UpdateConversationMode instance
         */
        UpdateConversationMode.create = function create(properties) {
          return new UpdateConversationMode(properties);
        };

        /**
         * Encodes the specified UpdateConversationMode message. Does not implicitly {@link propel.commrouter.ConversationCommand.UpdateConversationMode.verify|verify} messages.
         * @function encode
         * @memberof propel.commrouter.ConversationCommand.UpdateConversationMode
         * @static
         * @param {propel.commrouter.ConversationCommand.IUpdateConversationMode} message UpdateConversationMode message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UpdateConversationMode.encode = function encode(message, writer) {
          if (!writer) writer = $Writer.create();
          if (message.state != null && message.hasOwnProperty('state'))
            writer.uint32(/* id 1, wireType 0 =*/ 8).int32(message.state);
          if (message.supportState != null && message.hasOwnProperty('supportState'))
            writer.uint32(/* id 2, wireType 0 =*/ 16).int32(message.supportState);
          if (message.supportStateType != null && message.hasOwnProperty('supportStateType'))
            $root.google.protobuf.StringValue.encode(
              message.supportStateType,
              writer.uint32(/* id 3, wireType 2 =*/ 26).fork()
            ).ldelim();
          if (message.channelId != null && message.hasOwnProperty('channelId'))
            $root.propel.commrouter.VendorId.encode(
              message.channelId,
              writer.uint32(/* id 4, wireType 2 =*/ 34).fork()
            ).ldelim();
          if (message.supportStateReason != null && message.hasOwnProperty('supportStateReason'))
            $root.google.protobuf.StringValue.encode(
              message.supportStateReason,
              writer.uint32(/* id 5, wireType 2 =*/ 42).fork()
            ).ldelim();
          return writer;
        };

        /**
         * Encodes the specified UpdateConversationMode message, length delimited. Does not implicitly {@link propel.commrouter.ConversationCommand.UpdateConversationMode.verify|verify} messages.
         * @function encodeDelimited
         * @memberof propel.commrouter.ConversationCommand.UpdateConversationMode
         * @static
         * @param {propel.commrouter.ConversationCommand.IUpdateConversationMode} message UpdateConversationMode message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UpdateConversationMode.encodeDelimited = function encodeDelimited(message, writer) {
          return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an UpdateConversationMode message from the specified reader or buffer.
         * @function decode
         * @memberof propel.commrouter.ConversationCommand.UpdateConversationMode
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {propel.commrouter.ConversationCommand.UpdateConversationMode} UpdateConversationMode
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UpdateConversationMode.decode = function decode(reader, length) {
          if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
          var end = length === undefined ? reader.len : reader.pos + length,
            message = new $root.propel.commrouter.ConversationCommand.UpdateConversationMode();
          while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
              case 4:
                message.channelId = $root.propel.commrouter.VendorId.decode(
                  reader,
                  reader.uint32()
                );
                break;
              case 1:
                message.state = reader.int32();
                break;
              case 2:
                message.supportState = reader.int32();
                break;
              case 3:
                message.supportStateType = $root.google.protobuf.StringValue.decode(
                  reader,
                  reader.uint32()
                );
                break;
              case 5:
                message.supportStateReason = $root.google.protobuf.StringValue.decode(
                  reader,
                  reader.uint32()
                );
                break;
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };

        /**
         * Decodes an UpdateConversationMode message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof propel.commrouter.ConversationCommand.UpdateConversationMode
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {propel.commrouter.ConversationCommand.UpdateConversationMode} UpdateConversationMode
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UpdateConversationMode.decodeDelimited = function decodeDelimited(reader) {
          if (!(reader instanceof $Reader)) reader = new $Reader(reader);
          return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an UpdateConversationMode message.
         * @function verify
         * @memberof propel.commrouter.ConversationCommand.UpdateConversationMode
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        UpdateConversationMode.verify = function verify(message) {
          if (typeof message !== 'object' || message === null) return 'object expected';
          if (message.channelId != null && message.hasOwnProperty('channelId')) {
            var error = $root.propel.commrouter.VendorId.verify(message.channelId);
            if (error) return 'channelId.' + error;
          }
          if (message.state != null && message.hasOwnProperty('state'))
            switch (message.state) {
              default:
                return 'state: enum value expected';
              case 0:
              case 1:
              case 2:
                break;
            }
          if (message.supportState != null && message.hasOwnProperty('supportState'))
            switch (message.supportState) {
              default:
                return 'supportState: enum value expected';
              case 0:
              case 1:
              case 2:
              case 3:
              case 4:
              case 5:
                break;
            }
          if (message.supportStateType != null && message.hasOwnProperty('supportStateType')) {
            var error = $root.google.protobuf.StringValue.verify(message.supportStateType);
            if (error) return 'supportStateType.' + error;
          }
          if (message.supportStateReason != null && message.hasOwnProperty('supportStateReason')) {
            var error = $root.google.protobuf.StringValue.verify(message.supportStateReason);
            if (error) return 'supportStateReason.' + error;
          }
          return null;
        };

        /**
         * Creates an UpdateConversationMode message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof propel.commrouter.ConversationCommand.UpdateConversationMode
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {propel.commrouter.ConversationCommand.UpdateConversationMode} UpdateConversationMode
         */
        UpdateConversationMode.fromObject = function fromObject(object) {
          if (object instanceof $root.propel.commrouter.ConversationCommand.UpdateConversationMode)
            return object;
          var message = new $root.propel.commrouter.ConversationCommand.UpdateConversationMode();
          if (object.channelId != null) {
            if (typeof object.channelId !== 'object')
              throw TypeError(
                '.propel.commrouter.ConversationCommand.UpdateConversationMode.channelId: object expected'
              );
            message.channelId = $root.propel.commrouter.VendorId.fromObject(object.channelId);
          }
          switch (object.state) {
            case 'STATE_UNKNOWN':
            case 0:
              message.state = 0;
              break;
            case 'STATE_AUTOPILOT':
            case 1:
              message.state = 1;
              break;
            case 'STATE_MANAGED':
            case 2:
              message.state = 2;
              break;
          }
          switch (object.supportState) {
            case 'SUPPORT_STATE_UNKNOWN':
            case 0:
              message.supportState = 0;
              break;
            case 'SUPPORT_STATE_NOT_REQUESTED':
            case 1:
              message.supportState = 1;
              break;
            case 'SUPPORT_STATE_REQUESTED':
            case 2:
              message.supportState = 2;
              break;
            case 'SUPPORT_STATE_MANAGED':
            case 3:
              message.supportState = 3;
              break;
            case 'SUPPORT_STATE_REQUEST_SUCCESS':
            case 4:
              message.supportState = 4;
              break;
            case 'SUPPORT_STATE_REQUEST_ERROR':
            case 5:
              message.supportState = 5;
              break;
          }
          if (object.supportStateType != null) {
            if (typeof object.supportStateType !== 'object')
              throw TypeError(
                '.propel.commrouter.ConversationCommand.UpdateConversationMode.supportStateType: object expected'
              );
            message.supportStateType = $root.google.protobuf.StringValue.fromObject(
              object.supportStateType
            );
          }
          if (object.supportStateReason != null) {
            if (typeof object.supportStateReason !== 'object')
              throw TypeError(
                '.propel.commrouter.ConversationCommand.UpdateConversationMode.supportStateReason: object expected'
              );
            message.supportStateReason = $root.google.protobuf.StringValue.fromObject(
              object.supportStateReason
            );
          }
          return message;
        };

        /**
         * Creates a plain object from an UpdateConversationMode message. Also converts values to other types if specified.
         * @function toObject
         * @memberof propel.commrouter.ConversationCommand.UpdateConversationMode
         * @static
         * @param {propel.commrouter.ConversationCommand.UpdateConversationMode} message UpdateConversationMode
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UpdateConversationMode.toObject = function toObject(message, options) {
          if (!options) options = {};
          var object = {};
          if (options.defaults) {
            object.state = options.enums === String ? 'STATE_UNKNOWN' : 0;
            object.supportState = options.enums === String ? 'SUPPORT_STATE_UNKNOWN' : 0;
            object.supportStateType = null;
            object.channelId = null;
            object.supportStateReason = null;
          }
          if (message.state != null && message.hasOwnProperty('state'))
            object.state =
              options.enums === String
                ? $root.propel.commrouter.ConversationMode.State[message.state]
                : message.state;
          if (message.supportState != null && message.hasOwnProperty('supportState'))
            object.supportState =
              options.enums === String
                ? $root.propel.commrouter.ConversationMode.SupportState[message.supportState]
                : message.supportState;
          if (message.supportStateType != null && message.hasOwnProperty('supportStateType'))
            object.supportStateType = $root.google.protobuf.StringValue.toObject(
              message.supportStateType,
              options
            );
          if (message.channelId != null && message.hasOwnProperty('channelId'))
            object.channelId = $root.propel.commrouter.VendorId.toObject(
              message.channelId,
              options
            );
          if (message.supportStateReason != null && message.hasOwnProperty('supportStateReason'))
            object.supportStateReason = $root.google.protobuf.StringValue.toObject(
              message.supportStateReason,
              options
            );
          return object;
        };

        /**
         * Converts this UpdateConversationMode to JSON.
         * @function toJSON
         * @memberof propel.commrouter.ConversationCommand.UpdateConversationMode
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UpdateConversationMode.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return UpdateConversationMode;
      })();

      ConversationCommand.PutVendorInfo = (function () {
        /**
         * Properties of a PutVendorInfo.
         * @memberof propel.commrouter.ConversationCommand
         * @interface IPutVendorInfo
         * @property {string|null} [key] PutVendorInfo key
         * @property {google.protobuf.IStruct|null} [value] PutVendorInfo value
         */

        /**
         * Constructs a new PutVendorInfo.
         * @memberof propel.commrouter.ConversationCommand
         * @classdesc Represents a PutVendorInfo.
         * @implements IPutVendorInfo
         * @constructor
         * @param {propel.commrouter.ConversationCommand.IPutVendorInfo=} [properties] Properties to set
         */
        function PutVendorInfo(properties) {
          if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
              if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
        }

        /**
         * PutVendorInfo key.
         * @member {string} key
         * @memberof propel.commrouter.ConversationCommand.PutVendorInfo
         * @instance
         */
        PutVendorInfo.prototype.key = '';

        /**
         * PutVendorInfo value.
         * @member {google.protobuf.IStruct|null|undefined} value
         * @memberof propel.commrouter.ConversationCommand.PutVendorInfo
         * @instance
         */
        PutVendorInfo.prototype.value = null;

        /**
         * Creates a new PutVendorInfo instance using the specified properties.
         * @function create
         * @memberof propel.commrouter.ConversationCommand.PutVendorInfo
         * @static
         * @param {propel.commrouter.ConversationCommand.IPutVendorInfo=} [properties] Properties to set
         * @returns {propel.commrouter.ConversationCommand.PutVendorInfo} PutVendorInfo instance
         */
        PutVendorInfo.create = function create(properties) {
          return new PutVendorInfo(properties);
        };

        /**
         * Encodes the specified PutVendorInfo message. Does not implicitly {@link propel.commrouter.ConversationCommand.PutVendorInfo.verify|verify} messages.
         * @function encode
         * @memberof propel.commrouter.ConversationCommand.PutVendorInfo
         * @static
         * @param {propel.commrouter.ConversationCommand.IPutVendorInfo} message PutVendorInfo message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PutVendorInfo.encode = function encode(message, writer) {
          if (!writer) writer = $Writer.create();
          if (message.key != null && message.hasOwnProperty('key'))
            writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.key);
          if (message.value != null && message.hasOwnProperty('value'))
            $root.google.protobuf.Struct.encode(
              message.value,
              writer.uint32(/* id 2, wireType 2 =*/ 18).fork()
            ).ldelim();
          return writer;
        };

        /**
         * Encodes the specified PutVendorInfo message, length delimited. Does not implicitly {@link propel.commrouter.ConversationCommand.PutVendorInfo.verify|verify} messages.
         * @function encodeDelimited
         * @memberof propel.commrouter.ConversationCommand.PutVendorInfo
         * @static
         * @param {propel.commrouter.ConversationCommand.IPutVendorInfo} message PutVendorInfo message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PutVendorInfo.encodeDelimited = function encodeDelimited(message, writer) {
          return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a PutVendorInfo message from the specified reader or buffer.
         * @function decode
         * @memberof propel.commrouter.ConversationCommand.PutVendorInfo
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {propel.commrouter.ConversationCommand.PutVendorInfo} PutVendorInfo
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PutVendorInfo.decode = function decode(reader, length) {
          if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
          var end = length === undefined ? reader.len : reader.pos + length,
            message = new $root.propel.commrouter.ConversationCommand.PutVendorInfo();
          while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
              case 1:
                message.key = reader.string();
                break;
              case 2:
                message.value = $root.google.protobuf.Struct.decode(reader, reader.uint32());
                break;
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };

        /**
         * Decodes a PutVendorInfo message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof propel.commrouter.ConversationCommand.PutVendorInfo
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {propel.commrouter.ConversationCommand.PutVendorInfo} PutVendorInfo
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PutVendorInfo.decodeDelimited = function decodeDelimited(reader) {
          if (!(reader instanceof $Reader)) reader = new $Reader(reader);
          return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a PutVendorInfo message.
         * @function verify
         * @memberof propel.commrouter.ConversationCommand.PutVendorInfo
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        PutVendorInfo.verify = function verify(message) {
          if (typeof message !== 'object' || message === null) return 'object expected';
          if (message.key != null && message.hasOwnProperty('key'))
            if (!$util.isString(message.key)) return 'key: string expected';
          if (message.value != null && message.hasOwnProperty('value')) {
            var error = $root.google.protobuf.Struct.verify(message.value);
            if (error) return 'value.' + error;
          }
          return null;
        };

        /**
         * Creates a PutVendorInfo message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof propel.commrouter.ConversationCommand.PutVendorInfo
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {propel.commrouter.ConversationCommand.PutVendorInfo} PutVendorInfo
         */
        PutVendorInfo.fromObject = function fromObject(object) {
          if (object instanceof $root.propel.commrouter.ConversationCommand.PutVendorInfo)
            return object;
          var message = new $root.propel.commrouter.ConversationCommand.PutVendorInfo();
          if (object.key != null) message.key = String(object.key);
          if (object.value != null) {
            if (typeof object.value !== 'object')
              throw TypeError(
                '.propel.commrouter.ConversationCommand.PutVendorInfo.value: object expected'
              );
            message.value = $root.google.protobuf.Struct.fromObject(object.value);
          }
          return message;
        };

        /**
         * Creates a plain object from a PutVendorInfo message. Also converts values to other types if specified.
         * @function toObject
         * @memberof propel.commrouter.ConversationCommand.PutVendorInfo
         * @static
         * @param {propel.commrouter.ConversationCommand.PutVendorInfo} message PutVendorInfo
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        PutVendorInfo.toObject = function toObject(message, options) {
          if (!options) options = {};
          var object = {};
          if (options.defaults) {
            object.key = '';
            object.value = null;
          }
          if (message.key != null && message.hasOwnProperty('key')) object.key = message.key;
          if (message.value != null && message.hasOwnProperty('value'))
            object.value = $root.google.protobuf.Struct.toObject(message.value, options);
          return object;
        };

        /**
         * Converts this PutVendorInfo to JSON.
         * @function toJSON
         * @memberof propel.commrouter.ConversationCommand.PutVendorInfo
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        PutVendorInfo.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return PutVendorInfo;
      })();

      ConversationCommand.CreateIncomingLead = (function () {
        /**
         * Properties of a CreateIncomingLead.
         * @memberof propel.commrouter.ConversationCommand
         * @interface ICreateIncomingLead
         * @property {propel.core.IIncomingLead|null} [incomingLead] CreateIncomingLead incomingLead
         */

        /**
         * Constructs a new CreateIncomingLead.
         * @memberof propel.commrouter.ConversationCommand
         * @classdesc Represents a CreateIncomingLead.
         * @implements ICreateIncomingLead
         * @constructor
         * @param {propel.commrouter.ConversationCommand.ICreateIncomingLead=} [properties] Properties to set
         */
        function CreateIncomingLead(properties) {
          if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
              if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
        }

        /**
         * CreateIncomingLead incomingLead.
         * @member {propel.core.IIncomingLead|null|undefined} incomingLead
         * @memberof propel.commrouter.ConversationCommand.CreateIncomingLead
         * @instance
         */
        CreateIncomingLead.prototype.incomingLead = null;

        /**
         * Creates a new CreateIncomingLead instance using the specified properties.
         * @function create
         * @memberof propel.commrouter.ConversationCommand.CreateIncomingLead
         * @static
         * @param {propel.commrouter.ConversationCommand.ICreateIncomingLead=} [properties] Properties to set
         * @returns {propel.commrouter.ConversationCommand.CreateIncomingLead} CreateIncomingLead instance
         */
        CreateIncomingLead.create = function create(properties) {
          return new CreateIncomingLead(properties);
        };

        /**
         * Encodes the specified CreateIncomingLead message. Does not implicitly {@link propel.commrouter.ConversationCommand.CreateIncomingLead.verify|verify} messages.
         * @function encode
         * @memberof propel.commrouter.ConversationCommand.CreateIncomingLead
         * @static
         * @param {propel.commrouter.ConversationCommand.ICreateIncomingLead} message CreateIncomingLead message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CreateIncomingLead.encode = function encode(message, writer) {
          if (!writer) writer = $Writer.create();
          if (message.incomingLead != null && message.hasOwnProperty('incomingLead'))
            $root.propel.core.IncomingLead.encode(
              message.incomingLead,
              writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
            ).ldelim();
          return writer;
        };

        /**
         * Encodes the specified CreateIncomingLead message, length delimited. Does not implicitly {@link propel.commrouter.ConversationCommand.CreateIncomingLead.verify|verify} messages.
         * @function encodeDelimited
         * @memberof propel.commrouter.ConversationCommand.CreateIncomingLead
         * @static
         * @param {propel.commrouter.ConversationCommand.ICreateIncomingLead} message CreateIncomingLead message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CreateIncomingLead.encodeDelimited = function encodeDelimited(message, writer) {
          return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a CreateIncomingLead message from the specified reader or buffer.
         * @function decode
         * @memberof propel.commrouter.ConversationCommand.CreateIncomingLead
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {propel.commrouter.ConversationCommand.CreateIncomingLead} CreateIncomingLead
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CreateIncomingLead.decode = function decode(reader, length) {
          if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
          var end = length === undefined ? reader.len : reader.pos + length,
            message = new $root.propel.commrouter.ConversationCommand.CreateIncomingLead();
          while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
              case 1:
                message.incomingLead = $root.propel.core.IncomingLead.decode(
                  reader,
                  reader.uint32()
                );
                break;
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };

        /**
         * Decodes a CreateIncomingLead message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof propel.commrouter.ConversationCommand.CreateIncomingLead
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {propel.commrouter.ConversationCommand.CreateIncomingLead} CreateIncomingLead
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CreateIncomingLead.decodeDelimited = function decodeDelimited(reader) {
          if (!(reader instanceof $Reader)) reader = new $Reader(reader);
          return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a CreateIncomingLead message.
         * @function verify
         * @memberof propel.commrouter.ConversationCommand.CreateIncomingLead
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        CreateIncomingLead.verify = function verify(message) {
          if (typeof message !== 'object' || message === null) return 'object expected';
          if (message.incomingLead != null && message.hasOwnProperty('incomingLead')) {
            var error = $root.propel.core.IncomingLead.verify(message.incomingLead);
            if (error) return 'incomingLead.' + error;
          }
          return null;
        };

        /**
         * Creates a CreateIncomingLead message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof propel.commrouter.ConversationCommand.CreateIncomingLead
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {propel.commrouter.ConversationCommand.CreateIncomingLead} CreateIncomingLead
         */
        CreateIncomingLead.fromObject = function fromObject(object) {
          if (object instanceof $root.propel.commrouter.ConversationCommand.CreateIncomingLead)
            return object;
          var message = new $root.propel.commrouter.ConversationCommand.CreateIncomingLead();
          if (object.incomingLead != null) {
            if (typeof object.incomingLead !== 'object')
              throw TypeError(
                '.propel.commrouter.ConversationCommand.CreateIncomingLead.incomingLead: object expected'
              );
            message.incomingLead = $root.propel.core.IncomingLead.fromObject(object.incomingLead);
          }
          return message;
        };

        /**
         * Creates a plain object from a CreateIncomingLead message. Also converts values to other types if specified.
         * @function toObject
         * @memberof propel.commrouter.ConversationCommand.CreateIncomingLead
         * @static
         * @param {propel.commrouter.ConversationCommand.CreateIncomingLead} message CreateIncomingLead
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CreateIncomingLead.toObject = function toObject(message, options) {
          if (!options) options = {};
          var object = {};
          if (options.defaults) object.incomingLead = null;
          if (message.incomingLead != null && message.hasOwnProperty('incomingLead'))
            object.incomingLead = $root.propel.core.IncomingLead.toObject(
              message.incomingLead,
              options
            );
          return object;
        };

        /**
         * Converts this CreateIncomingLead to JSON.
         * @function toJSON
         * @memberof propel.commrouter.ConversationCommand.CreateIncomingLead
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CreateIncomingLead.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return CreateIncomingLead;
      })();

      ConversationCommand.CreateTag = (function () {
        /**
         * Properties of a CreateTag.
         * @memberof propel.commrouter.ConversationCommand
         * @interface ICreateTag
         * @property {propel.commrouter.ITag|null} [tag] CreateTag tag
         */

        /**
         * Constructs a new CreateTag.
         * @memberof propel.commrouter.ConversationCommand
         * @classdesc Represents a CreateTag.
         * @implements ICreateTag
         * @constructor
         * @param {propel.commrouter.ConversationCommand.ICreateTag=} [properties] Properties to set
         */
        function CreateTag(properties) {
          if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
              if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
        }

        /**
         * CreateTag tag.
         * @member {propel.commrouter.ITag|null|undefined} tag
         * @memberof propel.commrouter.ConversationCommand.CreateTag
         * @instance
         */
        CreateTag.prototype.tag = null;

        /**
         * Creates a new CreateTag instance using the specified properties.
         * @function create
         * @memberof propel.commrouter.ConversationCommand.CreateTag
         * @static
         * @param {propel.commrouter.ConversationCommand.ICreateTag=} [properties] Properties to set
         * @returns {propel.commrouter.ConversationCommand.CreateTag} CreateTag instance
         */
        CreateTag.create = function create(properties) {
          return new CreateTag(properties);
        };

        /**
         * Encodes the specified CreateTag message. Does not implicitly {@link propel.commrouter.ConversationCommand.CreateTag.verify|verify} messages.
         * @function encode
         * @memberof propel.commrouter.ConversationCommand.CreateTag
         * @static
         * @param {propel.commrouter.ConversationCommand.ICreateTag} message CreateTag message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CreateTag.encode = function encode(message, writer) {
          if (!writer) writer = $Writer.create();
          if (message.tag != null && message.hasOwnProperty('tag'))
            $root.propel.commrouter.Tag.encode(
              message.tag,
              writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
            ).ldelim();
          return writer;
        };

        /**
         * Encodes the specified CreateTag message, length delimited. Does not implicitly {@link propel.commrouter.ConversationCommand.CreateTag.verify|verify} messages.
         * @function encodeDelimited
         * @memberof propel.commrouter.ConversationCommand.CreateTag
         * @static
         * @param {propel.commrouter.ConversationCommand.ICreateTag} message CreateTag message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CreateTag.encodeDelimited = function encodeDelimited(message, writer) {
          return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a CreateTag message from the specified reader or buffer.
         * @function decode
         * @memberof propel.commrouter.ConversationCommand.CreateTag
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {propel.commrouter.ConversationCommand.CreateTag} CreateTag
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CreateTag.decode = function decode(reader, length) {
          if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
          var end = length === undefined ? reader.len : reader.pos + length,
            message = new $root.propel.commrouter.ConversationCommand.CreateTag();
          while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
              case 1:
                message.tag = $root.propel.commrouter.Tag.decode(reader, reader.uint32());
                break;
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };

        /**
         * Decodes a CreateTag message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof propel.commrouter.ConversationCommand.CreateTag
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {propel.commrouter.ConversationCommand.CreateTag} CreateTag
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CreateTag.decodeDelimited = function decodeDelimited(reader) {
          if (!(reader instanceof $Reader)) reader = new $Reader(reader);
          return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a CreateTag message.
         * @function verify
         * @memberof propel.commrouter.ConversationCommand.CreateTag
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        CreateTag.verify = function verify(message) {
          if (typeof message !== 'object' || message === null) return 'object expected';
          if (message.tag != null && message.hasOwnProperty('tag')) {
            var error = $root.propel.commrouter.Tag.verify(message.tag);
            if (error) return 'tag.' + error;
          }
          return null;
        };

        /**
         * Creates a CreateTag message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof propel.commrouter.ConversationCommand.CreateTag
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {propel.commrouter.ConversationCommand.CreateTag} CreateTag
         */
        CreateTag.fromObject = function fromObject(object) {
          if (object instanceof $root.propel.commrouter.ConversationCommand.CreateTag)
            return object;
          var message = new $root.propel.commrouter.ConversationCommand.CreateTag();
          if (object.tag != null) {
            if (typeof object.tag !== 'object')
              throw TypeError(
                '.propel.commrouter.ConversationCommand.CreateTag.tag: object expected'
              );
            message.tag = $root.propel.commrouter.Tag.fromObject(object.tag);
          }
          return message;
        };

        /**
         * Creates a plain object from a CreateTag message. Also converts values to other types if specified.
         * @function toObject
         * @memberof propel.commrouter.ConversationCommand.CreateTag
         * @static
         * @param {propel.commrouter.ConversationCommand.CreateTag} message CreateTag
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CreateTag.toObject = function toObject(message, options) {
          if (!options) options = {};
          var object = {};
          if (options.defaults) object.tag = null;
          if (message.tag != null && message.hasOwnProperty('tag'))
            object.tag = $root.propel.commrouter.Tag.toObject(message.tag, options);
          return object;
        };

        /**
         * Converts this CreateTag to JSON.
         * @function toJSON
         * @memberof propel.commrouter.ConversationCommand.CreateTag
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CreateTag.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return CreateTag;
      })();

      ConversationCommand.DeleteTag = (function () {
        /**
         * Properties of a DeleteTag.
         * @memberof propel.commrouter.ConversationCommand
         * @interface IDeleteTag
         * @property {string|null} [name] DeleteTag name
         * @property {propel.commrouter.IVendorId|null} [channelId] DeleteTag channelId
         */

        /**
         * Constructs a new DeleteTag.
         * @memberof propel.commrouter.ConversationCommand
         * @classdesc Represents a DeleteTag.
         * @implements IDeleteTag
         * @constructor
         * @param {propel.commrouter.ConversationCommand.IDeleteTag=} [properties] Properties to set
         */
        function DeleteTag(properties) {
          if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
              if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
        }

        /**
         * DeleteTag name.
         * @member {string} name
         * @memberof propel.commrouter.ConversationCommand.DeleteTag
         * @instance
         */
        DeleteTag.prototype.name = '';

        /**
         * DeleteTag channelId.
         * @member {propel.commrouter.IVendorId|null|undefined} channelId
         * @memberof propel.commrouter.ConversationCommand.DeleteTag
         * @instance
         */
        DeleteTag.prototype.channelId = null;

        /**
         * Creates a new DeleteTag instance using the specified properties.
         * @function create
         * @memberof propel.commrouter.ConversationCommand.DeleteTag
         * @static
         * @param {propel.commrouter.ConversationCommand.IDeleteTag=} [properties] Properties to set
         * @returns {propel.commrouter.ConversationCommand.DeleteTag} DeleteTag instance
         */
        DeleteTag.create = function create(properties) {
          return new DeleteTag(properties);
        };

        /**
         * Encodes the specified DeleteTag message. Does not implicitly {@link propel.commrouter.ConversationCommand.DeleteTag.verify|verify} messages.
         * @function encode
         * @memberof propel.commrouter.ConversationCommand.DeleteTag
         * @static
         * @param {propel.commrouter.ConversationCommand.IDeleteTag} message DeleteTag message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        DeleteTag.encode = function encode(message, writer) {
          if (!writer) writer = $Writer.create();
          if (message.name != null && message.hasOwnProperty('name'))
            writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.name);
          if (message.channelId != null && message.hasOwnProperty('channelId'))
            $root.propel.commrouter.VendorId.encode(
              message.channelId,
              writer.uint32(/* id 2, wireType 2 =*/ 18).fork()
            ).ldelim();
          return writer;
        };

        /**
         * Encodes the specified DeleteTag message, length delimited. Does not implicitly {@link propel.commrouter.ConversationCommand.DeleteTag.verify|verify} messages.
         * @function encodeDelimited
         * @memberof propel.commrouter.ConversationCommand.DeleteTag
         * @static
         * @param {propel.commrouter.ConversationCommand.IDeleteTag} message DeleteTag message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        DeleteTag.encodeDelimited = function encodeDelimited(message, writer) {
          return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a DeleteTag message from the specified reader or buffer.
         * @function decode
         * @memberof propel.commrouter.ConversationCommand.DeleteTag
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {propel.commrouter.ConversationCommand.DeleteTag} DeleteTag
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        DeleteTag.decode = function decode(reader, length) {
          if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
          var end = length === undefined ? reader.len : reader.pos + length,
            message = new $root.propel.commrouter.ConversationCommand.DeleteTag();
          while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
              case 1:
                message.name = reader.string();
                break;
              case 2:
                message.channelId = $root.propel.commrouter.VendorId.decode(
                  reader,
                  reader.uint32()
                );
                break;
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };

        /**
         * Decodes a DeleteTag message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof propel.commrouter.ConversationCommand.DeleteTag
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {propel.commrouter.ConversationCommand.DeleteTag} DeleteTag
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        DeleteTag.decodeDelimited = function decodeDelimited(reader) {
          if (!(reader instanceof $Reader)) reader = new $Reader(reader);
          return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a DeleteTag message.
         * @function verify
         * @memberof propel.commrouter.ConversationCommand.DeleteTag
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        DeleteTag.verify = function verify(message) {
          if (typeof message !== 'object' || message === null) return 'object expected';
          if (message.name != null && message.hasOwnProperty('name'))
            if (!$util.isString(message.name)) return 'name: string expected';
          if (message.channelId != null && message.hasOwnProperty('channelId')) {
            var error = $root.propel.commrouter.VendorId.verify(message.channelId);
            if (error) return 'channelId.' + error;
          }
          return null;
        };

        /**
         * Creates a DeleteTag message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof propel.commrouter.ConversationCommand.DeleteTag
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {propel.commrouter.ConversationCommand.DeleteTag} DeleteTag
         */
        DeleteTag.fromObject = function fromObject(object) {
          if (object instanceof $root.propel.commrouter.ConversationCommand.DeleteTag)
            return object;
          var message = new $root.propel.commrouter.ConversationCommand.DeleteTag();
          if (object.name != null) message.name = String(object.name);
          if (object.channelId != null) {
            if (typeof object.channelId !== 'object')
              throw TypeError(
                '.propel.commrouter.ConversationCommand.DeleteTag.channelId: object expected'
              );
            message.channelId = $root.propel.commrouter.VendorId.fromObject(object.channelId);
          }
          return message;
        };

        /**
         * Creates a plain object from a DeleteTag message. Also converts values to other types if specified.
         * @function toObject
         * @memberof propel.commrouter.ConversationCommand.DeleteTag
         * @static
         * @param {propel.commrouter.ConversationCommand.DeleteTag} message DeleteTag
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        DeleteTag.toObject = function toObject(message, options) {
          if (!options) options = {};
          var object = {};
          if (options.defaults) {
            object.name = '';
            object.channelId = null;
          }
          if (message.name != null && message.hasOwnProperty('name')) object.name = message.name;
          if (message.channelId != null && message.hasOwnProperty('channelId'))
            object.channelId = $root.propel.commrouter.VendorId.toObject(
              message.channelId,
              options
            );
          return object;
        };

        /**
         * Converts this DeleteTag to JSON.
         * @function toJSON
         * @memberof propel.commrouter.ConversationCommand.DeleteTag
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        DeleteTag.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return DeleteTag;
      })();

      return ConversationCommand;
    })();

    commrouter.Note = (function () {
      /**
       * Properties of a Note.
       * @memberof propel.commrouter
       * @interface INote
       * @property {propel.commrouter.IVendorId|null} [channelId] Note channelId
       * @property {propel.core.IMessageBody|null} [body] Note body
       */

      /**
       * Constructs a new Note.
       * @memberof propel.commrouter
       * @classdesc Represents a Note.
       * @implements INote
       * @constructor
       * @param {propel.commrouter.INote=} [properties] Properties to set
       */
      function Note(properties) {
        if (properties)
          for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
      }

      /**
       * Note channelId.
       * @member {propel.commrouter.IVendorId|null|undefined} channelId
       * @memberof propel.commrouter.Note
       * @instance
       */
      Note.prototype.channelId = null;

      /**
       * Note body.
       * @member {propel.core.IMessageBody|null|undefined} body
       * @memberof propel.commrouter.Note
       * @instance
       */
      Note.prototype.body = null;

      /**
       * Creates a new Note instance using the specified properties.
       * @function create
       * @memberof propel.commrouter.Note
       * @static
       * @param {propel.commrouter.INote=} [properties] Properties to set
       * @returns {propel.commrouter.Note} Note instance
       */
      Note.create = function create(properties) {
        return new Note(properties);
      };

      /**
       * Encodes the specified Note message. Does not implicitly {@link propel.commrouter.Note.verify|verify} messages.
       * @function encode
       * @memberof propel.commrouter.Note
       * @static
       * @param {propel.commrouter.INote} message Note message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      Note.encode = function encode(message, writer) {
        if (!writer) writer = $Writer.create();
        if (message.channelId != null && message.hasOwnProperty('channelId'))
          $root.propel.commrouter.VendorId.encode(
            message.channelId,
            writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
          ).ldelim();
        if (message.body != null && message.hasOwnProperty('body'))
          $root.propel.core.MessageBody.encode(
            message.body,
            writer.uint32(/* id 2, wireType 2 =*/ 18).fork()
          ).ldelim();
        return writer;
      };

      /**
       * Encodes the specified Note message, length delimited. Does not implicitly {@link propel.commrouter.Note.verify|verify} messages.
       * @function encodeDelimited
       * @memberof propel.commrouter.Note
       * @static
       * @param {propel.commrouter.INote} message Note message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      Note.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
      };

      /**
       * Decodes a Note message from the specified reader or buffer.
       * @function decode
       * @memberof propel.commrouter.Note
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @param {number} [length] Message length if known beforehand
       * @returns {propel.commrouter.Note} Note
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      Note.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length,
          message = new $root.propel.commrouter.Note();
        while (reader.pos < end) {
          var tag = reader.uint32();
          switch (tag >>> 3) {
            case 1:
              message.channelId = $root.propel.commrouter.VendorId.decode(reader, reader.uint32());
              break;
            case 2:
              message.body = $root.propel.core.MessageBody.decode(reader, reader.uint32());
              break;
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };

      /**
       * Decodes a Note message from the specified reader or buffer, length delimited.
       * @function decodeDelimited
       * @memberof propel.commrouter.Note
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @returns {propel.commrouter.Note} Note
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      Note.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader)) reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
      };

      /**
       * Verifies a Note message.
       * @function verify
       * @memberof propel.commrouter.Note
       * @static
       * @param {Object.<string,*>} message Plain object to verify
       * @returns {string|null} `null` if valid, otherwise the reason why it is not
       */
      Note.verify = function verify(message) {
        if (typeof message !== 'object' || message === null) return 'object expected';
        if (message.channelId != null && message.hasOwnProperty('channelId')) {
          var error = $root.propel.commrouter.VendorId.verify(message.channelId);
          if (error) return 'channelId.' + error;
        }
        if (message.body != null && message.hasOwnProperty('body')) {
          var error = $root.propel.core.MessageBody.verify(message.body);
          if (error) return 'body.' + error;
        }
        return null;
      };

      /**
       * Creates a Note message from a plain object. Also converts values to their respective internal types.
       * @function fromObject
       * @memberof propel.commrouter.Note
       * @static
       * @param {Object.<string,*>} object Plain object
       * @returns {propel.commrouter.Note} Note
       */
      Note.fromObject = function fromObject(object) {
        if (object instanceof $root.propel.commrouter.Note) return object;
        var message = new $root.propel.commrouter.Note();
        if (object.channelId != null) {
          if (typeof object.channelId !== 'object')
            throw TypeError('.propel.commrouter.Note.channelId: object expected');
          message.channelId = $root.propel.commrouter.VendorId.fromObject(object.channelId);
        }
        if (object.body != null) {
          if (typeof object.body !== 'object')
            throw TypeError('.propel.commrouter.Note.body: object expected');
          message.body = $root.propel.core.MessageBody.fromObject(object.body);
        }
        return message;
      };

      /**
       * Creates a plain object from a Note message. Also converts values to other types if specified.
       * @function toObject
       * @memberof propel.commrouter.Note
       * @static
       * @param {propel.commrouter.Note} message Note
       * @param {$protobuf.IConversionOptions} [options] Conversion options
       * @returns {Object.<string,*>} Plain object
       */
      Note.toObject = function toObject(message, options) {
        if (!options) options = {};
        var object = {};
        if (options.defaults) {
          object.channelId = null;
          object.body = null;
        }
        if (message.channelId != null && message.hasOwnProperty('channelId'))
          object.channelId = $root.propel.commrouter.VendorId.toObject(message.channelId, options);
        if (message.body != null && message.hasOwnProperty('body'))
          object.body = $root.propel.core.MessageBody.toObject(message.body, options);
        return object;
      };

      /**
       * Converts this Note to JSON.
       * @function toJSON
       * @memberof propel.commrouter.Note
       * @instance
       * @returns {Object.<string,*>} JSON object
       */
      Note.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
      };

      return Note;
    })();

    commrouter.Message = (function () {
      /**
       * Properties of a Message.
       * @memberof propel.commrouter
       * @interface IMessage
       * @property {string|null} [id] Message id
       * @property {propel.commrouter.Message.State|null} [state] Message state
       * @property {propel.commrouter.IVendorId|null} [avatarId] Message avatarId
       * @property {propel.commrouter.IVendorId|null} [channelId] Message channelId
       * @property {propel.core.IMessageBody|null} [body] Message body
       * @property {google.protobuf.IStringValue|null} [responseId] Message responseId
       * @property {google.protobuf.IStringValue|null} [error] Message error
       * @property {google.protobuf.IStringValue|null} [errorMessage] Message errorMessage
       * @property {google.protobuf.IStruct|null} [channelInfo] Message channelInfo
       * @property {google.protobuf.IStruct|null} [info] Message info
       */

      /**
       * Constructs a new Message.
       * @memberof propel.commrouter
       * @classdesc Represents a Message.
       * @implements IMessage
       * @constructor
       * @param {propel.commrouter.IMessage=} [properties] Properties to set
       */
      function Message(properties) {
        if (properties)
          for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
      }

      /**
       * Message id.
       * @member {string} id
       * @memberof propel.commrouter.Message
       * @instance
       */
      Message.prototype.id = '';

      /**
       * Message state.
       * @member {propel.commrouter.Message.State} state
       * @memberof propel.commrouter.Message
       * @instance
       */
      Message.prototype.state = 0;

      /**
       * Message avatarId.
       * @member {propel.commrouter.IVendorId|null|undefined} avatarId
       * @memberof propel.commrouter.Message
       * @instance
       */
      Message.prototype.avatarId = null;

      /**
       * Message channelId.
       * @member {propel.commrouter.IVendorId|null|undefined} channelId
       * @memberof propel.commrouter.Message
       * @instance
       */
      Message.prototype.channelId = null;

      /**
       * Message body.
       * @member {propel.core.IMessageBody|null|undefined} body
       * @memberof propel.commrouter.Message
       * @instance
       */
      Message.prototype.body = null;

      /**
       * Message responseId.
       * @member {google.protobuf.IStringValue|null|undefined} responseId
       * @memberof propel.commrouter.Message
       * @instance
       */
      Message.prototype.responseId = null;

      /**
       * Message error.
       * @member {google.protobuf.IStringValue|null|undefined} error
       * @memberof propel.commrouter.Message
       * @instance
       */
      Message.prototype.error = null;

      /**
       * Message errorMessage.
       * @member {google.protobuf.IStringValue|null|undefined} errorMessage
       * @memberof propel.commrouter.Message
       * @instance
       */
      Message.prototype.errorMessage = null;

      /**
       * Message channelInfo.
       * @member {google.protobuf.IStruct|null|undefined} channelInfo
       * @memberof propel.commrouter.Message
       * @instance
       */
      Message.prototype.channelInfo = null;

      /**
       * Message info.
       * @member {google.protobuf.IStruct|null|undefined} info
       * @memberof propel.commrouter.Message
       * @instance
       */
      Message.prototype.info = null;

      /**
       * Creates a new Message instance using the specified properties.
       * @function create
       * @memberof propel.commrouter.Message
       * @static
       * @param {propel.commrouter.IMessage=} [properties] Properties to set
       * @returns {propel.commrouter.Message} Message instance
       */
      Message.create = function create(properties) {
        return new Message(properties);
      };

      /**
       * Encodes the specified Message message. Does not implicitly {@link propel.commrouter.Message.verify|verify} messages.
       * @function encode
       * @memberof propel.commrouter.Message
       * @static
       * @param {propel.commrouter.IMessage} message Message message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      Message.encode = function encode(message, writer) {
        if (!writer) writer = $Writer.create();
        if (message.id != null && message.hasOwnProperty('id'))
          writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
        if (message.state != null && message.hasOwnProperty('state'))
          writer.uint32(/* id 2, wireType 0 =*/ 16).int32(message.state);
        if (message.avatarId != null && message.hasOwnProperty('avatarId'))
          $root.propel.commrouter.VendorId.encode(
            message.avatarId,
            writer.uint32(/* id 3, wireType 2 =*/ 26).fork()
          ).ldelim();
        if (message.channelId != null && message.hasOwnProperty('channelId'))
          $root.propel.commrouter.VendorId.encode(
            message.channelId,
            writer.uint32(/* id 5, wireType 2 =*/ 42).fork()
          ).ldelim();
        if (message.body != null && message.hasOwnProperty('body'))
          $root.propel.core.MessageBody.encode(
            message.body,
            writer.uint32(/* id 6, wireType 2 =*/ 50).fork()
          ).ldelim();
        if (message.responseId != null && message.hasOwnProperty('responseId'))
          $root.google.protobuf.StringValue.encode(
            message.responseId,
            writer.uint32(/* id 7, wireType 2 =*/ 58).fork()
          ).ldelim();
        if (message.error != null && message.hasOwnProperty('error'))
          $root.google.protobuf.StringValue.encode(
            message.error,
            writer.uint32(/* id 8, wireType 2 =*/ 66).fork()
          ).ldelim();
        if (message.errorMessage != null && message.hasOwnProperty('errorMessage'))
          $root.google.protobuf.StringValue.encode(
            message.errorMessage,
            writer.uint32(/* id 9, wireType 2 =*/ 74).fork()
          ).ldelim();
        if (message.channelInfo != null && message.hasOwnProperty('channelInfo'))
          $root.google.protobuf.Struct.encode(
            message.channelInfo,
            writer.uint32(/* id 10, wireType 2 =*/ 82).fork()
          ).ldelim();
        if (message.info != null && message.hasOwnProperty('info'))
          $root.google.protobuf.Struct.encode(
            message.info,
            writer.uint32(/* id 11, wireType 2 =*/ 90).fork()
          ).ldelim();
        return writer;
      };

      /**
       * Encodes the specified Message message, length delimited. Does not implicitly {@link propel.commrouter.Message.verify|verify} messages.
       * @function encodeDelimited
       * @memberof propel.commrouter.Message
       * @static
       * @param {propel.commrouter.IMessage} message Message message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      Message.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
      };

      /**
       * Decodes a Message message from the specified reader or buffer.
       * @function decode
       * @memberof propel.commrouter.Message
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @param {number} [length] Message length if known beforehand
       * @returns {propel.commrouter.Message} Message
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      Message.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length,
          message = new $root.propel.commrouter.Message();
        while (reader.pos < end) {
          var tag = reader.uint32();
          switch (tag >>> 3) {
            case 1:
              message.id = reader.string();
              break;
            case 2:
              message.state = reader.int32();
              break;
            case 3:
              message.avatarId = $root.propel.commrouter.VendorId.decode(reader, reader.uint32());
              break;
            case 5:
              message.channelId = $root.propel.commrouter.VendorId.decode(reader, reader.uint32());
              break;
            case 6:
              message.body = $root.propel.core.MessageBody.decode(reader, reader.uint32());
              break;
            case 7:
              message.responseId = $root.google.protobuf.StringValue.decode(
                reader,
                reader.uint32()
              );
              break;
            case 8:
              message.error = $root.google.protobuf.StringValue.decode(reader, reader.uint32());
              break;
            case 9:
              message.errorMessage = $root.google.protobuf.StringValue.decode(
                reader,
                reader.uint32()
              );
              break;
            case 10:
              message.channelInfo = $root.google.protobuf.Struct.decode(reader, reader.uint32());
              break;
            case 11:
              message.info = $root.google.protobuf.Struct.decode(reader, reader.uint32());
              break;
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };

      /**
       * Decodes a Message message from the specified reader or buffer, length delimited.
       * @function decodeDelimited
       * @memberof propel.commrouter.Message
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @returns {propel.commrouter.Message} Message
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      Message.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader)) reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
      };

      /**
       * Verifies a Message message.
       * @function verify
       * @memberof propel.commrouter.Message
       * @static
       * @param {Object.<string,*>} message Plain object to verify
       * @returns {string|null} `null` if valid, otherwise the reason why it is not
       */
      Message.verify = function verify(message) {
        if (typeof message !== 'object' || message === null) return 'object expected';
        if (message.id != null && message.hasOwnProperty('id'))
          if (!$util.isString(message.id)) return 'id: string expected';
        if (message.state != null && message.hasOwnProperty('state'))
          switch (message.state) {
            default:
              return 'state: enum value expected';
            case 0:
            case 1:
            case 2:
            case 3:
              break;
          }
        if (message.avatarId != null && message.hasOwnProperty('avatarId')) {
          var error = $root.propel.commrouter.VendorId.verify(message.avatarId);
          if (error) return 'avatarId.' + error;
        }
        if (message.channelId != null && message.hasOwnProperty('channelId')) {
          var error = $root.propel.commrouter.VendorId.verify(message.channelId);
          if (error) return 'channelId.' + error;
        }
        if (message.body != null && message.hasOwnProperty('body')) {
          var error = $root.propel.core.MessageBody.verify(message.body);
          if (error) return 'body.' + error;
        }
        if (message.responseId != null && message.hasOwnProperty('responseId')) {
          var error = $root.google.protobuf.StringValue.verify(message.responseId);
          if (error) return 'responseId.' + error;
        }
        if (message.error != null && message.hasOwnProperty('error')) {
          var error = $root.google.protobuf.StringValue.verify(message.error);
          if (error) return 'error.' + error;
        }
        if (message.errorMessage != null && message.hasOwnProperty('errorMessage')) {
          var error = $root.google.protobuf.StringValue.verify(message.errorMessage);
          if (error) return 'errorMessage.' + error;
        }
        if (message.channelInfo != null && message.hasOwnProperty('channelInfo')) {
          var error = $root.google.protobuf.Struct.verify(message.channelInfo);
          if (error) return 'channelInfo.' + error;
        }
        if (message.info != null && message.hasOwnProperty('info')) {
          var error = $root.google.protobuf.Struct.verify(message.info);
          if (error) return 'info.' + error;
        }
        return null;
      };

      /**
       * Creates a Message message from a plain object. Also converts values to their respective internal types.
       * @function fromObject
       * @memberof propel.commrouter.Message
       * @static
       * @param {Object.<string,*>} object Plain object
       * @returns {propel.commrouter.Message} Message
       */
      Message.fromObject = function fromObject(object) {
        if (object instanceof $root.propel.commrouter.Message) return object;
        var message = new $root.propel.commrouter.Message();
        if (object.id != null) message.id = String(object.id);
        switch (object.state) {
          case 'STATE_UNKNOWN':
          case 0:
            message.state = 0;
            break;
          case 'STATE_SENDING':
          case 1:
            message.state = 1;
            break;
          case 'STATE_SENT':
          case 2:
            message.state = 2;
            break;
          case 'STATE_ERROR':
          case 3:
            message.state = 3;
            break;
        }
        if (object.avatarId != null) {
          if (typeof object.avatarId !== 'object')
            throw TypeError('.propel.commrouter.Message.avatarId: object expected');
          message.avatarId = $root.propel.commrouter.VendorId.fromObject(object.avatarId);
        }
        if (object.channelId != null) {
          if (typeof object.channelId !== 'object')
            throw TypeError('.propel.commrouter.Message.channelId: object expected');
          message.channelId = $root.propel.commrouter.VendorId.fromObject(object.channelId);
        }
        if (object.body != null) {
          if (typeof object.body !== 'object')
            throw TypeError('.propel.commrouter.Message.body: object expected');
          message.body = $root.propel.core.MessageBody.fromObject(object.body);
        }
        if (object.responseId != null) {
          if (typeof object.responseId !== 'object')
            throw TypeError('.propel.commrouter.Message.responseId: object expected');
          message.responseId = $root.google.protobuf.StringValue.fromObject(object.responseId);
        }
        if (object.error != null) {
          if (typeof object.error !== 'object')
            throw TypeError('.propel.commrouter.Message.error: object expected');
          message.error = $root.google.protobuf.StringValue.fromObject(object.error);
        }
        if (object.errorMessage != null) {
          if (typeof object.errorMessage !== 'object')
            throw TypeError('.propel.commrouter.Message.errorMessage: object expected');
          message.errorMessage = $root.google.protobuf.StringValue.fromObject(object.errorMessage);
        }
        if (object.channelInfo != null) {
          if (typeof object.channelInfo !== 'object')
            throw TypeError('.propel.commrouter.Message.channelInfo: object expected');
          message.channelInfo = $root.google.protobuf.Struct.fromObject(object.channelInfo);
        }
        if (object.info != null) {
          if (typeof object.info !== 'object')
            throw TypeError('.propel.commrouter.Message.info: object expected');
          message.info = $root.google.protobuf.Struct.fromObject(object.info);
        }
        return message;
      };

      /**
       * Creates a plain object from a Message message. Also converts values to other types if specified.
       * @function toObject
       * @memberof propel.commrouter.Message
       * @static
       * @param {propel.commrouter.Message} message Message
       * @param {$protobuf.IConversionOptions} [options] Conversion options
       * @returns {Object.<string,*>} Plain object
       */
      Message.toObject = function toObject(message, options) {
        if (!options) options = {};
        var object = {};
        if (options.defaults) {
          object.id = '';
          object.state = options.enums === String ? 'STATE_UNKNOWN' : 0;
          object.avatarId = null;
          object.channelId = null;
          object.body = null;
          object.responseId = null;
          object.error = null;
          object.errorMessage = null;
          object.channelInfo = null;
          object.info = null;
        }
        if (message.id != null && message.hasOwnProperty('id')) object.id = message.id;
        if (message.state != null && message.hasOwnProperty('state'))
          object.state =
            options.enums === String
              ? $root.propel.commrouter.Message.State[message.state]
              : message.state;
        if (message.avatarId != null && message.hasOwnProperty('avatarId'))
          object.avatarId = $root.propel.commrouter.VendorId.toObject(message.avatarId, options);
        if (message.channelId != null && message.hasOwnProperty('channelId'))
          object.channelId = $root.propel.commrouter.VendorId.toObject(message.channelId, options);
        if (message.body != null && message.hasOwnProperty('body'))
          object.body = $root.propel.core.MessageBody.toObject(message.body, options);
        if (message.responseId != null && message.hasOwnProperty('responseId'))
          object.responseId = $root.google.protobuf.StringValue.toObject(
            message.responseId,
            options
          );
        if (message.error != null && message.hasOwnProperty('error'))
          object.error = $root.google.protobuf.StringValue.toObject(message.error, options);
        if (message.errorMessage != null && message.hasOwnProperty('errorMessage'))
          object.errorMessage = $root.google.protobuf.StringValue.toObject(
            message.errorMessage,
            options
          );
        if (message.channelInfo != null && message.hasOwnProperty('channelInfo'))
          object.channelInfo = $root.google.protobuf.Struct.toObject(message.channelInfo, options);
        if (message.info != null && message.hasOwnProperty('info'))
          object.info = $root.google.protobuf.Struct.toObject(message.info, options);
        return object;
      };

      /**
       * Converts this Message to JSON.
       * @function toJSON
       * @memberof propel.commrouter.Message
       * @instance
       * @returns {Object.<string,*>} JSON object
       */
      Message.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
      };

      /**
       * State enum.
       * @name propel.commrouter.Message.State
       * @enum {string}
       * @property {number} STATE_UNKNOWN=0 STATE_UNKNOWN value
       * @property {number} STATE_SENDING=1 STATE_SENDING value
       * @property {number} STATE_SENT=2 STATE_SENT value
       * @property {number} STATE_ERROR=3 STATE_ERROR value
       */
      Message.State = (function () {
        var valuesById = {},
          values = Object.create(valuesById);
        values[(valuesById[0] = 'STATE_UNKNOWN')] = 0;
        values[(valuesById[1] = 'STATE_SENDING')] = 1;
        values[(valuesById[2] = 'STATE_SENT')] = 2;
        values[(valuesById[3] = 'STATE_ERROR')] = 3;
        return values;
      })();

      return Message;
    })();

    commrouter.Messages = (function () {
      /**
       * Properties of a Messages.
       * @memberof propel.commrouter
       * @interface IMessages
       * @property {Array.<propel.commrouter.IMessage>|null} [list] Messages list
       */

      /**
       * Constructs a new Messages.
       * @memberof propel.commrouter
       * @classdesc Represents a Messages.
       * @implements IMessages
       * @constructor
       * @param {propel.commrouter.IMessages=} [properties] Properties to set
       */
      function Messages(properties) {
        this.list = [];
        if (properties)
          for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
      }

      /**
       * Messages list.
       * @member {Array.<propel.commrouter.IMessage>} list
       * @memberof propel.commrouter.Messages
       * @instance
       */
      Messages.prototype.list = $util.emptyArray;

      /**
       * Creates a new Messages instance using the specified properties.
       * @function create
       * @memberof propel.commrouter.Messages
       * @static
       * @param {propel.commrouter.IMessages=} [properties] Properties to set
       * @returns {propel.commrouter.Messages} Messages instance
       */
      Messages.create = function create(properties) {
        return new Messages(properties);
      };

      /**
       * Encodes the specified Messages message. Does not implicitly {@link propel.commrouter.Messages.verify|verify} messages.
       * @function encode
       * @memberof propel.commrouter.Messages
       * @static
       * @param {propel.commrouter.IMessages} message Messages message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      Messages.encode = function encode(message, writer) {
        if (!writer) writer = $Writer.create();
        if (message.list != null && message.list.length)
          for (var i = 0; i < message.list.length; ++i)
            $root.propel.commrouter.Message.encode(
              message.list[i],
              writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
            ).ldelim();
        return writer;
      };

      /**
       * Encodes the specified Messages message, length delimited. Does not implicitly {@link propel.commrouter.Messages.verify|verify} messages.
       * @function encodeDelimited
       * @memberof propel.commrouter.Messages
       * @static
       * @param {propel.commrouter.IMessages} message Messages message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      Messages.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
      };

      /**
       * Decodes a Messages message from the specified reader or buffer.
       * @function decode
       * @memberof propel.commrouter.Messages
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @param {number} [length] Message length if known beforehand
       * @returns {propel.commrouter.Messages} Messages
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      Messages.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length,
          message = new $root.propel.commrouter.Messages();
        while (reader.pos < end) {
          var tag = reader.uint32();
          switch (tag >>> 3) {
            case 1:
              if (!(message.list && message.list.length)) message.list = [];
              message.list.push($root.propel.commrouter.Message.decode(reader, reader.uint32()));
              break;
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };

      /**
       * Decodes a Messages message from the specified reader or buffer, length delimited.
       * @function decodeDelimited
       * @memberof propel.commrouter.Messages
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @returns {propel.commrouter.Messages} Messages
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      Messages.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader)) reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
      };

      /**
       * Verifies a Messages message.
       * @function verify
       * @memberof propel.commrouter.Messages
       * @static
       * @param {Object.<string,*>} message Plain object to verify
       * @returns {string|null} `null` if valid, otherwise the reason why it is not
       */
      Messages.verify = function verify(message) {
        if (typeof message !== 'object' || message === null) return 'object expected';
        if (message.list != null && message.hasOwnProperty('list')) {
          if (!Array.isArray(message.list)) return 'list: array expected';
          for (var i = 0; i < message.list.length; ++i) {
            var error = $root.propel.commrouter.Message.verify(message.list[i]);
            if (error) return 'list.' + error;
          }
        }
        return null;
      };

      /**
       * Creates a Messages message from a plain object. Also converts values to their respective internal types.
       * @function fromObject
       * @memberof propel.commrouter.Messages
       * @static
       * @param {Object.<string,*>} object Plain object
       * @returns {propel.commrouter.Messages} Messages
       */
      Messages.fromObject = function fromObject(object) {
        if (object instanceof $root.propel.commrouter.Messages) return object;
        var message = new $root.propel.commrouter.Messages();
        if (object.list) {
          if (!Array.isArray(object.list))
            throw TypeError('.propel.commrouter.Messages.list: array expected');
          message.list = [];
          for (var i = 0; i < object.list.length; ++i) {
            if (typeof object.list[i] !== 'object')
              throw TypeError('.propel.commrouter.Messages.list: object expected');
            message.list[i] = $root.propel.commrouter.Message.fromObject(object.list[i]);
          }
        }
        return message;
      };

      /**
       * Creates a plain object from a Messages message. Also converts values to other types if specified.
       * @function toObject
       * @memberof propel.commrouter.Messages
       * @static
       * @param {propel.commrouter.Messages} message Messages
       * @param {$protobuf.IConversionOptions} [options] Conversion options
       * @returns {Object.<string,*>} Plain object
       */
      Messages.toObject = function toObject(message, options) {
        if (!options) options = {};
        var object = {};
        if (options.arrays || options.defaults) object.list = [];
        if (message.list && message.list.length) {
          object.list = [];
          for (var j = 0; j < message.list.length; ++j)
            object.list[j] = $root.propel.commrouter.Message.toObject(message.list[j], options);
        }
        return object;
      };

      /**
       * Converts this Messages to JSON.
       * @function toJSON
       * @memberof propel.commrouter.Messages
       * @instance
       * @returns {Object.<string,*>} JSON object
       */
      Messages.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
      };

      return Messages;
    })();

    commrouter.ConversationMode = (function () {
      /**
       * Properties of a ConversationMode.
       * @memberof propel.commrouter
       * @interface IConversationMode
       * @property {propel.commrouter.IVendorId|null} [channelId] ConversationMode channelId
       * @property {propel.commrouter.ConversationMode.State|null} [state] ConversationMode state
       * @property {propel.commrouter.ConversationMode.SupportState|null} [supportState] ConversationMode supportState
       * @property {google.protobuf.IStringValue|null} [supportStateType] ConversationMode supportStateType
       * @property {google.protobuf.IStringValue|null} [supportStateReason] ConversationMode supportStateReason
       * @property {google.protobuf.IStringValue|null} [supportStateError] ConversationMode supportStateError
       * @property {google.protobuf.IStringValue|null} [supportStateErrorMessage] ConversationMode supportStateErrorMessage
       */

      /**
       * Constructs a new ConversationMode.
       * @memberof propel.commrouter
       * @classdesc Represents a ConversationMode.
       * @implements IConversationMode
       * @constructor
       * @param {propel.commrouter.IConversationMode=} [properties] Properties to set
       */
      function ConversationMode(properties) {
        if (properties)
          for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
      }

      /**
       * ConversationMode channelId.
       * @member {propel.commrouter.IVendorId|null|undefined} channelId
       * @memberof propel.commrouter.ConversationMode
       * @instance
       */
      ConversationMode.prototype.channelId = null;

      /**
       * ConversationMode state.
       * @member {propel.commrouter.ConversationMode.State} state
       * @memberof propel.commrouter.ConversationMode
       * @instance
       */
      ConversationMode.prototype.state = 0;

      /**
       * ConversationMode supportState.
       * @member {propel.commrouter.ConversationMode.SupportState} supportState
       * @memberof propel.commrouter.ConversationMode
       * @instance
       */
      ConversationMode.prototype.supportState = 0;

      /**
       * ConversationMode supportStateType.
       * @member {google.protobuf.IStringValue|null|undefined} supportStateType
       * @memberof propel.commrouter.ConversationMode
       * @instance
       */
      ConversationMode.prototype.supportStateType = null;

      /**
       * ConversationMode supportStateReason.
       * @member {google.protobuf.IStringValue|null|undefined} supportStateReason
       * @memberof propel.commrouter.ConversationMode
       * @instance
       */
      ConversationMode.prototype.supportStateReason = null;

      /**
       * ConversationMode supportStateError.
       * @member {google.protobuf.IStringValue|null|undefined} supportStateError
       * @memberof propel.commrouter.ConversationMode
       * @instance
       */
      ConversationMode.prototype.supportStateError = null;

      /**
       * ConversationMode supportStateErrorMessage.
       * @member {google.protobuf.IStringValue|null|undefined} supportStateErrorMessage
       * @memberof propel.commrouter.ConversationMode
       * @instance
       */
      ConversationMode.prototype.supportStateErrorMessage = null;

      /**
       * Creates a new ConversationMode instance using the specified properties.
       * @function create
       * @memberof propel.commrouter.ConversationMode
       * @static
       * @param {propel.commrouter.IConversationMode=} [properties] Properties to set
       * @returns {propel.commrouter.ConversationMode} ConversationMode instance
       */
      ConversationMode.create = function create(properties) {
        return new ConversationMode(properties);
      };

      /**
       * Encodes the specified ConversationMode message. Does not implicitly {@link propel.commrouter.ConversationMode.verify|verify} messages.
       * @function encode
       * @memberof propel.commrouter.ConversationMode
       * @static
       * @param {propel.commrouter.IConversationMode} message ConversationMode message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      ConversationMode.encode = function encode(message, writer) {
        if (!writer) writer = $Writer.create();
        if (message.state != null && message.hasOwnProperty('state'))
          writer.uint32(/* id 1, wireType 0 =*/ 8).int32(message.state);
        if (message.supportState != null && message.hasOwnProperty('supportState'))
          writer.uint32(/* id 3, wireType 0 =*/ 24).int32(message.supportState);
        if (message.supportStateType != null && message.hasOwnProperty('supportStateType'))
          $root.google.protobuf.StringValue.encode(
            message.supportStateType,
            writer.uint32(/* id 4, wireType 2 =*/ 34).fork()
          ).ldelim();
        if (message.supportStateError != null && message.hasOwnProperty('supportStateError'))
          $root.google.protobuf.StringValue.encode(
            message.supportStateError,
            writer.uint32(/* id 5, wireType 2 =*/ 42).fork()
          ).ldelim();
        if (
          message.supportStateErrorMessage != null &&
          message.hasOwnProperty('supportStateErrorMessage')
        )
          $root.google.protobuf.StringValue.encode(
            message.supportStateErrorMessage,
            writer.uint32(/* id 6, wireType 2 =*/ 50).fork()
          ).ldelim();
        if (message.channelId != null && message.hasOwnProperty('channelId'))
          $root.propel.commrouter.VendorId.encode(
            message.channelId,
            writer.uint32(/* id 7, wireType 2 =*/ 58).fork()
          ).ldelim();
        if (message.supportStateReason != null && message.hasOwnProperty('supportStateReason'))
          $root.google.protobuf.StringValue.encode(
            message.supportStateReason,
            writer.uint32(/* id 8, wireType 2 =*/ 66).fork()
          ).ldelim();
        return writer;
      };

      /**
       * Encodes the specified ConversationMode message, length delimited. Does not implicitly {@link propel.commrouter.ConversationMode.verify|verify} messages.
       * @function encodeDelimited
       * @memberof propel.commrouter.ConversationMode
       * @static
       * @param {propel.commrouter.IConversationMode} message ConversationMode message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      ConversationMode.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
      };

      /**
       * Decodes a ConversationMode message from the specified reader or buffer.
       * @function decode
       * @memberof propel.commrouter.ConversationMode
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @param {number} [length] Message length if known beforehand
       * @returns {propel.commrouter.ConversationMode} ConversationMode
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      ConversationMode.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length,
          message = new $root.propel.commrouter.ConversationMode();
        while (reader.pos < end) {
          var tag = reader.uint32();
          switch (tag >>> 3) {
            case 7:
              message.channelId = $root.propel.commrouter.VendorId.decode(reader, reader.uint32());
              break;
            case 1:
              message.state = reader.int32();
              break;
            case 3:
              message.supportState = reader.int32();
              break;
            case 4:
              message.supportStateType = $root.google.protobuf.StringValue.decode(
                reader,
                reader.uint32()
              );
              break;
            case 8:
              message.supportStateReason = $root.google.protobuf.StringValue.decode(
                reader,
                reader.uint32()
              );
              break;
            case 5:
              message.supportStateError = $root.google.protobuf.StringValue.decode(
                reader,
                reader.uint32()
              );
              break;
            case 6:
              message.supportStateErrorMessage = $root.google.protobuf.StringValue.decode(
                reader,
                reader.uint32()
              );
              break;
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };

      /**
       * Decodes a ConversationMode message from the specified reader or buffer, length delimited.
       * @function decodeDelimited
       * @memberof propel.commrouter.ConversationMode
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @returns {propel.commrouter.ConversationMode} ConversationMode
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      ConversationMode.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader)) reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
      };

      /**
       * Verifies a ConversationMode message.
       * @function verify
       * @memberof propel.commrouter.ConversationMode
       * @static
       * @param {Object.<string,*>} message Plain object to verify
       * @returns {string|null} `null` if valid, otherwise the reason why it is not
       */
      ConversationMode.verify = function verify(message) {
        if (typeof message !== 'object' || message === null) return 'object expected';
        if (message.channelId != null && message.hasOwnProperty('channelId')) {
          var error = $root.propel.commrouter.VendorId.verify(message.channelId);
          if (error) return 'channelId.' + error;
        }
        if (message.state != null && message.hasOwnProperty('state'))
          switch (message.state) {
            default:
              return 'state: enum value expected';
            case 0:
            case 1:
            case 2:
              break;
          }
        if (message.supportState != null && message.hasOwnProperty('supportState'))
          switch (message.supportState) {
            default:
              return 'supportState: enum value expected';
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
              break;
          }
        if (message.supportStateType != null && message.hasOwnProperty('supportStateType')) {
          var error = $root.google.protobuf.StringValue.verify(message.supportStateType);
          if (error) return 'supportStateType.' + error;
        }
        if (message.supportStateReason != null && message.hasOwnProperty('supportStateReason')) {
          var error = $root.google.protobuf.StringValue.verify(message.supportStateReason);
          if (error) return 'supportStateReason.' + error;
        }
        if (message.supportStateError != null && message.hasOwnProperty('supportStateError')) {
          var error = $root.google.protobuf.StringValue.verify(message.supportStateError);
          if (error) return 'supportStateError.' + error;
        }
        if (
          message.supportStateErrorMessage != null &&
          message.hasOwnProperty('supportStateErrorMessage')
        ) {
          var error = $root.google.protobuf.StringValue.verify(message.supportStateErrorMessage);
          if (error) return 'supportStateErrorMessage.' + error;
        }
        return null;
      };

      /**
       * Creates a ConversationMode message from a plain object. Also converts values to their respective internal types.
       * @function fromObject
       * @memberof propel.commrouter.ConversationMode
       * @static
       * @param {Object.<string,*>} object Plain object
       * @returns {propel.commrouter.ConversationMode} ConversationMode
       */
      ConversationMode.fromObject = function fromObject(object) {
        if (object instanceof $root.propel.commrouter.ConversationMode) return object;
        var message = new $root.propel.commrouter.ConversationMode();
        if (object.channelId != null) {
          if (typeof object.channelId !== 'object')
            throw TypeError('.propel.commrouter.ConversationMode.channelId: object expected');
          message.channelId = $root.propel.commrouter.VendorId.fromObject(object.channelId);
        }
        switch (object.state) {
          case 'STATE_UNKNOWN':
          case 0:
            message.state = 0;
            break;
          case 'STATE_AUTOPILOT':
          case 1:
            message.state = 1;
            break;
          case 'STATE_MANAGED':
          case 2:
            message.state = 2;
            break;
        }
        switch (object.supportState) {
          case 'SUPPORT_STATE_UNKNOWN':
          case 0:
            message.supportState = 0;
            break;
          case 'SUPPORT_STATE_NOT_REQUESTED':
          case 1:
            message.supportState = 1;
            break;
          case 'SUPPORT_STATE_REQUESTED':
          case 2:
            message.supportState = 2;
            break;
          case 'SUPPORT_STATE_MANAGED':
          case 3:
            message.supportState = 3;
            break;
          case 'SUPPORT_STATE_REQUEST_SUCCESS':
          case 4:
            message.supportState = 4;
            break;
          case 'SUPPORT_STATE_REQUEST_ERROR':
          case 5:
            message.supportState = 5;
            break;
        }
        if (object.supportStateType != null) {
          if (typeof object.supportStateType !== 'object')
            throw TypeError(
              '.propel.commrouter.ConversationMode.supportStateType: object expected'
            );
          message.supportStateType = $root.google.protobuf.StringValue.fromObject(
            object.supportStateType
          );
        }
        if (object.supportStateReason != null) {
          if (typeof object.supportStateReason !== 'object')
            throw TypeError(
              '.propel.commrouter.ConversationMode.supportStateReason: object expected'
            );
          message.supportStateReason = $root.google.protobuf.StringValue.fromObject(
            object.supportStateReason
          );
        }
        if (object.supportStateError != null) {
          if (typeof object.supportStateError !== 'object')
            throw TypeError(
              '.propel.commrouter.ConversationMode.supportStateError: object expected'
            );
          message.supportStateError = $root.google.protobuf.StringValue.fromObject(
            object.supportStateError
          );
        }
        if (object.supportStateErrorMessage != null) {
          if (typeof object.supportStateErrorMessage !== 'object')
            throw TypeError(
              '.propel.commrouter.ConversationMode.supportStateErrorMessage: object expected'
            );
          message.supportStateErrorMessage = $root.google.protobuf.StringValue.fromObject(
            object.supportStateErrorMessage
          );
        }
        return message;
      };

      /**
       * Creates a plain object from a ConversationMode message. Also converts values to other types if specified.
       * @function toObject
       * @memberof propel.commrouter.ConversationMode
       * @static
       * @param {propel.commrouter.ConversationMode} message ConversationMode
       * @param {$protobuf.IConversionOptions} [options] Conversion options
       * @returns {Object.<string,*>} Plain object
       */
      ConversationMode.toObject = function toObject(message, options) {
        if (!options) options = {};
        var object = {};
        if (options.defaults) {
          object.state = options.enums === String ? 'STATE_UNKNOWN' : 0;
          object.supportState = options.enums === String ? 'SUPPORT_STATE_UNKNOWN' : 0;
          object.supportStateType = null;
          object.supportStateError = null;
          object.supportStateErrorMessage = null;
          object.channelId = null;
          object.supportStateReason = null;
        }
        if (message.state != null && message.hasOwnProperty('state'))
          object.state =
            options.enums === String
              ? $root.propel.commrouter.ConversationMode.State[message.state]
              : message.state;
        if (message.supportState != null && message.hasOwnProperty('supportState'))
          object.supportState =
            options.enums === String
              ? $root.propel.commrouter.ConversationMode.SupportState[message.supportState]
              : message.supportState;
        if (message.supportStateType != null && message.hasOwnProperty('supportStateType'))
          object.supportStateType = $root.google.protobuf.StringValue.toObject(
            message.supportStateType,
            options
          );
        if (message.supportStateError != null && message.hasOwnProperty('supportStateError'))
          object.supportStateError = $root.google.protobuf.StringValue.toObject(
            message.supportStateError,
            options
          );
        if (
          message.supportStateErrorMessage != null &&
          message.hasOwnProperty('supportStateErrorMessage')
        )
          object.supportStateErrorMessage = $root.google.protobuf.StringValue.toObject(
            message.supportStateErrorMessage,
            options
          );
        if (message.channelId != null && message.hasOwnProperty('channelId'))
          object.channelId = $root.propel.commrouter.VendorId.toObject(message.channelId, options);
        if (message.supportStateReason != null && message.hasOwnProperty('supportStateReason'))
          object.supportStateReason = $root.google.protobuf.StringValue.toObject(
            message.supportStateReason,
            options
          );
        return object;
      };

      /**
       * Converts this ConversationMode to JSON.
       * @function toJSON
       * @memberof propel.commrouter.ConversationMode
       * @instance
       * @returns {Object.<string,*>} JSON object
       */
      ConversationMode.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
      };

      /**
       * State enum.
       * @name propel.commrouter.ConversationMode.State
       * @enum {string}
       * @property {number} STATE_UNKNOWN=0 STATE_UNKNOWN value
       * @property {number} STATE_AUTOPILOT=1 STATE_AUTOPILOT value
       * @property {number} STATE_MANAGED=2 STATE_MANAGED value
       */
      ConversationMode.State = (function () {
        var valuesById = {},
          values = Object.create(valuesById);
        values[(valuesById[0] = 'STATE_UNKNOWN')] = 0;
        values[(valuesById[1] = 'STATE_AUTOPILOT')] = 1;
        values[(valuesById[2] = 'STATE_MANAGED')] = 2;
        return values;
      })();

      /**
       * SupportState enum.
       * @name propel.commrouter.ConversationMode.SupportState
       * @enum {string}
       * @property {number} SUPPORT_STATE_UNKNOWN=0 SUPPORT_STATE_UNKNOWN value
       * @property {number} SUPPORT_STATE_NOT_REQUESTED=1 SUPPORT_STATE_NOT_REQUESTED value
       * @property {number} SUPPORT_STATE_REQUESTED=2 SUPPORT_STATE_REQUESTED value
       * @property {number} SUPPORT_STATE_MANAGED=3 SUPPORT_STATE_MANAGED value
       * @property {number} SUPPORT_STATE_REQUEST_SUCCESS=4 SUPPORT_STATE_REQUEST_SUCCESS value
       * @property {number} SUPPORT_STATE_REQUEST_ERROR=5 SUPPORT_STATE_REQUEST_ERROR value
       */
      ConversationMode.SupportState = (function () {
        var valuesById = {},
          values = Object.create(valuesById);
        values[(valuesById[0] = 'SUPPORT_STATE_UNKNOWN')] = 0;
        values[(valuesById[1] = 'SUPPORT_STATE_NOT_REQUESTED')] = 1;
        values[(valuesById[2] = 'SUPPORT_STATE_REQUESTED')] = 2;
        values[(valuesById[3] = 'SUPPORT_STATE_MANAGED')] = 3;
        values[(valuesById[4] = 'SUPPORT_STATE_REQUEST_SUCCESS')] = 4;
        values[(valuesById[5] = 'SUPPORT_STATE_REQUEST_ERROR')] = 5;
        return values;
      })();

      return ConversationMode;
    })();

    commrouter.Context = (function () {
      /**
       * Properties of a Context.
       * @memberof propel.commrouter
       * @interface IContext
       * @property {string|null} [id] Context id
       * @property {propel.commrouter.Context.ICore|null} [core] Context core
       * @property {google.protobuf.IStruct|null} [info] Context info
       */

      /**
       * Constructs a new Context.
       * @memberof propel.commrouter
       * @classdesc Represents a Context.
       * @implements IContext
       * @constructor
       * @param {propel.commrouter.IContext=} [properties] Properties to set
       */
      function Context(properties) {
        if (properties)
          for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
      }

      /**
       * Context id.
       * @member {string} id
       * @memberof propel.commrouter.Context
       * @instance
       */
      Context.prototype.id = '';

      /**
       * Context core.
       * @member {propel.commrouter.Context.ICore|null|undefined} core
       * @memberof propel.commrouter.Context
       * @instance
       */
      Context.prototype.core = null;

      /**
       * Context info.
       * @member {google.protobuf.IStruct|null|undefined} info
       * @memberof propel.commrouter.Context
       * @instance
       */
      Context.prototype.info = null;

      /**
       * Creates a new Context instance using the specified properties.
       * @function create
       * @memberof propel.commrouter.Context
       * @static
       * @param {propel.commrouter.IContext=} [properties] Properties to set
       * @returns {propel.commrouter.Context} Context instance
       */
      Context.create = function create(properties) {
        return new Context(properties);
      };

      /**
       * Encodes the specified Context message. Does not implicitly {@link propel.commrouter.Context.verify|verify} messages.
       * @function encode
       * @memberof propel.commrouter.Context
       * @static
       * @param {propel.commrouter.IContext} message Context message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      Context.encode = function encode(message, writer) {
        if (!writer) writer = $Writer.create();
        if (message.id != null && message.hasOwnProperty('id'))
          writer.uint32(/* id 2, wireType 2 =*/ 18).string(message.id);
        if (message.core != null && message.hasOwnProperty('core'))
          $root.propel.commrouter.Context.Core.encode(
            message.core,
            writer.uint32(/* id 3, wireType 2 =*/ 26).fork()
          ).ldelim();
        if (message.info != null && message.hasOwnProperty('info'))
          $root.google.protobuf.Struct.encode(
            message.info,
            writer.uint32(/* id 4, wireType 2 =*/ 34).fork()
          ).ldelim();
        return writer;
      };

      /**
       * Encodes the specified Context message, length delimited. Does not implicitly {@link propel.commrouter.Context.verify|verify} messages.
       * @function encodeDelimited
       * @memberof propel.commrouter.Context
       * @static
       * @param {propel.commrouter.IContext} message Context message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      Context.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
      };

      /**
       * Decodes a Context message from the specified reader or buffer.
       * @function decode
       * @memberof propel.commrouter.Context
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @param {number} [length] Message length if known beforehand
       * @returns {propel.commrouter.Context} Context
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      Context.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length,
          message = new $root.propel.commrouter.Context();
        while (reader.pos < end) {
          var tag = reader.uint32();
          switch (tag >>> 3) {
            case 2:
              message.id = reader.string();
              break;
            case 3:
              message.core = $root.propel.commrouter.Context.Core.decode(reader, reader.uint32());
              break;
            case 4:
              message.info = $root.google.protobuf.Struct.decode(reader, reader.uint32());
              break;
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };

      /**
       * Decodes a Context message from the specified reader or buffer, length delimited.
       * @function decodeDelimited
       * @memberof propel.commrouter.Context
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @returns {propel.commrouter.Context} Context
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      Context.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader)) reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
      };

      /**
       * Verifies a Context message.
       * @function verify
       * @memberof propel.commrouter.Context
       * @static
       * @param {Object.<string,*>} message Plain object to verify
       * @returns {string|null} `null` if valid, otherwise the reason why it is not
       */
      Context.verify = function verify(message) {
        if (typeof message !== 'object' || message === null) return 'object expected';
        if (message.id != null && message.hasOwnProperty('id'))
          if (!$util.isString(message.id)) return 'id: string expected';
        if (message.core != null && message.hasOwnProperty('core')) {
          var error = $root.propel.commrouter.Context.Core.verify(message.core);
          if (error) return 'core.' + error;
        }
        if (message.info != null && message.hasOwnProperty('info')) {
          var error = $root.google.protobuf.Struct.verify(message.info);
          if (error) return 'info.' + error;
        }
        return null;
      };

      /**
       * Creates a Context message from a plain object. Also converts values to their respective internal types.
       * @function fromObject
       * @memberof propel.commrouter.Context
       * @static
       * @param {Object.<string,*>} object Plain object
       * @returns {propel.commrouter.Context} Context
       */
      Context.fromObject = function fromObject(object) {
        if (object instanceof $root.propel.commrouter.Context) return object;
        var message = new $root.propel.commrouter.Context();
        if (object.id != null) message.id = String(object.id);
        if (object.core != null) {
          if (typeof object.core !== 'object')
            throw TypeError('.propel.commrouter.Context.core: object expected');
          message.core = $root.propel.commrouter.Context.Core.fromObject(object.core);
        }
        if (object.info != null) {
          if (typeof object.info !== 'object')
            throw TypeError('.propel.commrouter.Context.info: object expected');
          message.info = $root.google.protobuf.Struct.fromObject(object.info);
        }
        return message;
      };

      /**
       * Creates a plain object from a Context message. Also converts values to other types if specified.
       * @function toObject
       * @memberof propel.commrouter.Context
       * @static
       * @param {propel.commrouter.Context} message Context
       * @param {$protobuf.IConversionOptions} [options] Conversion options
       * @returns {Object.<string,*>} Plain object
       */
      Context.toObject = function toObject(message, options) {
        if (!options) options = {};
        var object = {};
        if (options.defaults) {
          object.id = '';
          object.core = null;
          object.info = null;
        }
        if (message.id != null && message.hasOwnProperty('id')) object.id = message.id;
        if (message.core != null && message.hasOwnProperty('core'))
          object.core = $root.propel.commrouter.Context.Core.toObject(message.core, options);
        if (message.info != null && message.hasOwnProperty('info'))
          object.info = $root.google.protobuf.Struct.toObject(message.info, options);
        return object;
      };

      /**
       * Converts this Context to JSON.
       * @function toJSON
       * @memberof propel.commrouter.Context
       * @instance
       * @returns {Object.<string,*>} JSON object
       */
      Context.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
      };

      Context.Core = (function () {
        /**
         * Properties of a Core.
         * @memberof propel.commrouter.Context
         * @interface ICore
         * @property {propel.core.ILeadOrigin|null} [origin] Core origin
         */

        /**
         * Constructs a new Core.
         * @memberof propel.commrouter.Context
         * @classdesc Represents a Core.
         * @implements ICore
         * @constructor
         * @param {propel.commrouter.Context.ICore=} [properties] Properties to set
         */
        function Core(properties) {
          if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
              if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
        }

        /**
         * Core origin.
         * @member {propel.core.ILeadOrigin|null|undefined} origin
         * @memberof propel.commrouter.Context.Core
         * @instance
         */
        Core.prototype.origin = null;

        /**
         * Creates a new Core instance using the specified properties.
         * @function create
         * @memberof propel.commrouter.Context.Core
         * @static
         * @param {propel.commrouter.Context.ICore=} [properties] Properties to set
         * @returns {propel.commrouter.Context.Core} Core instance
         */
        Core.create = function create(properties) {
          return new Core(properties);
        };

        /**
         * Encodes the specified Core message. Does not implicitly {@link propel.commrouter.Context.Core.verify|verify} messages.
         * @function encode
         * @memberof propel.commrouter.Context.Core
         * @static
         * @param {propel.commrouter.Context.ICore} message Core message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Core.encode = function encode(message, writer) {
          if (!writer) writer = $Writer.create();
          if (message.origin != null && message.hasOwnProperty('origin'))
            $root.propel.core.LeadOrigin.encode(
              message.origin,
              writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
            ).ldelim();
          return writer;
        };

        /**
         * Encodes the specified Core message, length delimited. Does not implicitly {@link propel.commrouter.Context.Core.verify|verify} messages.
         * @function encodeDelimited
         * @memberof propel.commrouter.Context.Core
         * @static
         * @param {propel.commrouter.Context.ICore} message Core message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Core.encodeDelimited = function encodeDelimited(message, writer) {
          return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a Core message from the specified reader or buffer.
         * @function decode
         * @memberof propel.commrouter.Context.Core
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {propel.commrouter.Context.Core} Core
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Core.decode = function decode(reader, length) {
          if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
          var end = length === undefined ? reader.len : reader.pos + length,
            message = new $root.propel.commrouter.Context.Core();
          while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
              case 1:
                message.origin = $root.propel.core.LeadOrigin.decode(reader, reader.uint32());
                break;
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };

        /**
         * Decodes a Core message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof propel.commrouter.Context.Core
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {propel.commrouter.Context.Core} Core
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Core.decodeDelimited = function decodeDelimited(reader) {
          if (!(reader instanceof $Reader)) reader = new $Reader(reader);
          return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Core message.
         * @function verify
         * @memberof propel.commrouter.Context.Core
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Core.verify = function verify(message) {
          if (typeof message !== 'object' || message === null) return 'object expected';
          if (message.origin != null && message.hasOwnProperty('origin')) {
            var error = $root.propel.core.LeadOrigin.verify(message.origin);
            if (error) return 'origin.' + error;
          }
          return null;
        };

        /**
         * Creates a Core message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof propel.commrouter.Context.Core
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {propel.commrouter.Context.Core} Core
         */
        Core.fromObject = function fromObject(object) {
          if (object instanceof $root.propel.commrouter.Context.Core) return object;
          var message = new $root.propel.commrouter.Context.Core();
          if (object.origin != null) {
            if (typeof object.origin !== 'object')
              throw TypeError('.propel.commrouter.Context.Core.origin: object expected');
            message.origin = $root.propel.core.LeadOrigin.fromObject(object.origin);
          }
          return message;
        };

        /**
         * Creates a plain object from a Core message. Also converts values to other types if specified.
         * @function toObject
         * @memberof propel.commrouter.Context.Core
         * @static
         * @param {propel.commrouter.Context.Core} message Core
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Core.toObject = function toObject(message, options) {
          if (!options) options = {};
          var object = {};
          if (options.defaults) object.origin = null;
          if (message.origin != null && message.hasOwnProperty('origin'))
            object.origin = $root.propel.core.LeadOrigin.toObject(message.origin, options);
          return object;
        };

        /**
         * Converts this Core to JSON.
         * @function toJSON
         * @memberof propel.commrouter.Context.Core
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Core.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Core;
      })();

      return Context;
    })();

    commrouter.Introduction = (function () {
      /**
       * Properties of an Introduction.
       * @memberof propel.commrouter
       * @interface IIntroduction
       * @property {google.protobuf.IStringValue|null} [title] Introduction title
       * @property {google.protobuf.IStringValue|null} [subtitle] Introduction subtitle
       * @property {propel.core.MessageExtension.IQuickReplies|null} [quickReplies] Introduction quickReplies
       */

      /**
       * Constructs a new Introduction.
       * @memberof propel.commrouter
       * @classdesc Represents an Introduction.
       * @implements IIntroduction
       * @constructor
       * @param {propel.commrouter.IIntroduction=} [properties] Properties to set
       */
      function Introduction(properties) {
        if (properties)
          for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
      }

      /**
       * Introduction title.
       * @member {google.protobuf.IStringValue|null|undefined} title
       * @memberof propel.commrouter.Introduction
       * @instance
       */
      Introduction.prototype.title = null;

      /**
       * Introduction subtitle.
       * @member {google.protobuf.IStringValue|null|undefined} subtitle
       * @memberof propel.commrouter.Introduction
       * @instance
       */
      Introduction.prototype.subtitle = null;

      /**
       * Introduction quickReplies.
       * @member {propel.core.MessageExtension.IQuickReplies|null|undefined} quickReplies
       * @memberof propel.commrouter.Introduction
       * @instance
       */
      Introduction.prototype.quickReplies = null;

      /**
       * Creates a new Introduction instance using the specified properties.
       * @function create
       * @memberof propel.commrouter.Introduction
       * @static
       * @param {propel.commrouter.IIntroduction=} [properties] Properties to set
       * @returns {propel.commrouter.Introduction} Introduction instance
       */
      Introduction.create = function create(properties) {
        return new Introduction(properties);
      };

      /**
       * Encodes the specified Introduction message. Does not implicitly {@link propel.commrouter.Introduction.verify|verify} messages.
       * @function encode
       * @memberof propel.commrouter.Introduction
       * @static
       * @param {propel.commrouter.IIntroduction} message Introduction message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      Introduction.encode = function encode(message, writer) {
        if (!writer) writer = $Writer.create();
        if (message.title != null && message.hasOwnProperty('title'))
          $root.google.protobuf.StringValue.encode(
            message.title,
            writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
          ).ldelim();
        if (message.subtitle != null && message.hasOwnProperty('subtitle'))
          $root.google.protobuf.StringValue.encode(
            message.subtitle,
            writer.uint32(/* id 2, wireType 2 =*/ 18).fork()
          ).ldelim();
        if (message.quickReplies != null && message.hasOwnProperty('quickReplies'))
          $root.propel.core.MessageExtension.QuickReplies.encode(
            message.quickReplies,
            writer.uint32(/* id 3, wireType 2 =*/ 26).fork()
          ).ldelim();
        return writer;
      };

      /**
       * Encodes the specified Introduction message, length delimited. Does not implicitly {@link propel.commrouter.Introduction.verify|verify} messages.
       * @function encodeDelimited
       * @memberof propel.commrouter.Introduction
       * @static
       * @param {propel.commrouter.IIntroduction} message Introduction message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      Introduction.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
      };

      /**
       * Decodes an Introduction message from the specified reader or buffer.
       * @function decode
       * @memberof propel.commrouter.Introduction
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @param {number} [length] Message length if known beforehand
       * @returns {propel.commrouter.Introduction} Introduction
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      Introduction.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length,
          message = new $root.propel.commrouter.Introduction();
        while (reader.pos < end) {
          var tag = reader.uint32();
          switch (tag >>> 3) {
            case 1:
              message.title = $root.google.protobuf.StringValue.decode(reader, reader.uint32());
              break;
            case 2:
              message.subtitle = $root.google.protobuf.StringValue.decode(reader, reader.uint32());
              break;
            case 3:
              message.quickReplies = $root.propel.core.MessageExtension.QuickReplies.decode(
                reader,
                reader.uint32()
              );
              break;
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };

      /**
       * Decodes an Introduction message from the specified reader or buffer, length delimited.
       * @function decodeDelimited
       * @memberof propel.commrouter.Introduction
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @returns {propel.commrouter.Introduction} Introduction
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      Introduction.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader)) reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
      };

      /**
       * Verifies an Introduction message.
       * @function verify
       * @memberof propel.commrouter.Introduction
       * @static
       * @param {Object.<string,*>} message Plain object to verify
       * @returns {string|null} `null` if valid, otherwise the reason why it is not
       */
      Introduction.verify = function verify(message) {
        if (typeof message !== 'object' || message === null) return 'object expected';
        if (message.title != null && message.hasOwnProperty('title')) {
          var error = $root.google.protobuf.StringValue.verify(message.title);
          if (error) return 'title.' + error;
        }
        if (message.subtitle != null && message.hasOwnProperty('subtitle')) {
          var error = $root.google.protobuf.StringValue.verify(message.subtitle);
          if (error) return 'subtitle.' + error;
        }
        if (message.quickReplies != null && message.hasOwnProperty('quickReplies')) {
          var error = $root.propel.core.MessageExtension.QuickReplies.verify(message.quickReplies);
          if (error) return 'quickReplies.' + error;
        }
        return null;
      };

      /**
       * Creates an Introduction message from a plain object. Also converts values to their respective internal types.
       * @function fromObject
       * @memberof propel.commrouter.Introduction
       * @static
       * @param {Object.<string,*>} object Plain object
       * @returns {propel.commrouter.Introduction} Introduction
       */
      Introduction.fromObject = function fromObject(object) {
        if (object instanceof $root.propel.commrouter.Introduction) return object;
        var message = new $root.propel.commrouter.Introduction();
        if (object.title != null) {
          if (typeof object.title !== 'object')
            throw TypeError('.propel.commrouter.Introduction.title: object expected');
          message.title = $root.google.protobuf.StringValue.fromObject(object.title);
        }
        if (object.subtitle != null) {
          if (typeof object.subtitle !== 'object')
            throw TypeError('.propel.commrouter.Introduction.subtitle: object expected');
          message.subtitle = $root.google.protobuf.StringValue.fromObject(object.subtitle);
        }
        if (object.quickReplies != null) {
          if (typeof object.quickReplies !== 'object')
            throw TypeError('.propel.commrouter.Introduction.quickReplies: object expected');
          message.quickReplies = $root.propel.core.MessageExtension.QuickReplies.fromObject(
            object.quickReplies
          );
        }
        return message;
      };

      /**
       * Creates a plain object from an Introduction message. Also converts values to other types if specified.
       * @function toObject
       * @memberof propel.commrouter.Introduction
       * @static
       * @param {propel.commrouter.Introduction} message Introduction
       * @param {$protobuf.IConversionOptions} [options] Conversion options
       * @returns {Object.<string,*>} Plain object
       */
      Introduction.toObject = function toObject(message, options) {
        if (!options) options = {};
        var object = {};
        if (options.defaults) {
          object.title = null;
          object.subtitle = null;
          object.quickReplies = null;
        }
        if (message.title != null && message.hasOwnProperty('title'))
          object.title = $root.google.protobuf.StringValue.toObject(message.title, options);
        if (message.subtitle != null && message.hasOwnProperty('subtitle'))
          object.subtitle = $root.google.protobuf.StringValue.toObject(message.subtitle, options);
        if (message.quickReplies != null && message.hasOwnProperty('quickReplies'))
          object.quickReplies = $root.propel.core.MessageExtension.QuickReplies.toObject(
            message.quickReplies,
            options
          );
        return object;
      };

      /**
       * Converts this Introduction to JSON.
       * @function toJSON
       * @memberof propel.commrouter.Introduction
       * @instance
       * @returns {Object.<string,*>} JSON object
       */
      Introduction.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
      };

      return Introduction;
    })();

    commrouter.DebugInformation = (function () {
      /**
       * Properties of a DebugInformation.
       * @memberof propel.commrouter
       * @interface IDebugInformation
       * @property {Array.<propel.commrouter.DebugInformation.IUpdate>|null} [updates] DebugInformation updates
       */

      /**
       * Constructs a new DebugInformation.
       * @memberof propel.commrouter
       * @classdesc Represents a DebugInformation.
       * @implements IDebugInformation
       * @constructor
       * @param {propel.commrouter.IDebugInformation=} [properties] Properties to set
       */
      function DebugInformation(properties) {
        this.updates = [];
        if (properties)
          for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
      }

      /**
       * DebugInformation updates.
       * @member {Array.<propel.commrouter.DebugInformation.IUpdate>} updates
       * @memberof propel.commrouter.DebugInformation
       * @instance
       */
      DebugInformation.prototype.updates = $util.emptyArray;

      /**
       * Creates a new DebugInformation instance using the specified properties.
       * @function create
       * @memberof propel.commrouter.DebugInformation
       * @static
       * @param {propel.commrouter.IDebugInformation=} [properties] Properties to set
       * @returns {propel.commrouter.DebugInformation} DebugInformation instance
       */
      DebugInformation.create = function create(properties) {
        return new DebugInformation(properties);
      };

      /**
       * Encodes the specified DebugInformation message. Does not implicitly {@link propel.commrouter.DebugInformation.verify|verify} messages.
       * @function encode
       * @memberof propel.commrouter.DebugInformation
       * @static
       * @param {propel.commrouter.IDebugInformation} message DebugInformation message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      DebugInformation.encode = function encode(message, writer) {
        if (!writer) writer = $Writer.create();
        if (message.updates != null && message.updates.length)
          for (var i = 0; i < message.updates.length; ++i)
            $root.propel.commrouter.DebugInformation.Update.encode(
              message.updates[i],
              writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
            ).ldelim();
        return writer;
      };

      /**
       * Encodes the specified DebugInformation message, length delimited. Does not implicitly {@link propel.commrouter.DebugInformation.verify|verify} messages.
       * @function encodeDelimited
       * @memberof propel.commrouter.DebugInformation
       * @static
       * @param {propel.commrouter.IDebugInformation} message DebugInformation message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      DebugInformation.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
      };

      /**
       * Decodes a DebugInformation message from the specified reader or buffer.
       * @function decode
       * @memberof propel.commrouter.DebugInformation
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @param {number} [length] Message length if known beforehand
       * @returns {propel.commrouter.DebugInformation} DebugInformation
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      DebugInformation.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length,
          message = new $root.propel.commrouter.DebugInformation();
        while (reader.pos < end) {
          var tag = reader.uint32();
          switch (tag >>> 3) {
            case 1:
              if (!(message.updates && message.updates.length)) message.updates = [];
              message.updates.push(
                $root.propel.commrouter.DebugInformation.Update.decode(reader, reader.uint32())
              );
              break;
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };

      /**
       * Decodes a DebugInformation message from the specified reader or buffer, length delimited.
       * @function decodeDelimited
       * @memberof propel.commrouter.DebugInformation
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @returns {propel.commrouter.DebugInformation} DebugInformation
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      DebugInformation.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader)) reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
      };

      /**
       * Verifies a DebugInformation message.
       * @function verify
       * @memberof propel.commrouter.DebugInformation
       * @static
       * @param {Object.<string,*>} message Plain object to verify
       * @returns {string|null} `null` if valid, otherwise the reason why it is not
       */
      DebugInformation.verify = function verify(message) {
        if (typeof message !== 'object' || message === null) return 'object expected';
        if (message.updates != null && message.hasOwnProperty('updates')) {
          if (!Array.isArray(message.updates)) return 'updates: array expected';
          for (var i = 0; i < message.updates.length; ++i) {
            var error = $root.propel.commrouter.DebugInformation.Update.verify(message.updates[i]);
            if (error) return 'updates.' + error;
          }
        }
        return null;
      };

      /**
       * Creates a DebugInformation message from a plain object. Also converts values to their respective internal types.
       * @function fromObject
       * @memberof propel.commrouter.DebugInformation
       * @static
       * @param {Object.<string,*>} object Plain object
       * @returns {propel.commrouter.DebugInformation} DebugInformation
       */
      DebugInformation.fromObject = function fromObject(object) {
        if (object instanceof $root.propel.commrouter.DebugInformation) return object;
        var message = new $root.propel.commrouter.DebugInformation();
        if (object.updates) {
          if (!Array.isArray(object.updates))
            throw TypeError('.propel.commrouter.DebugInformation.updates: array expected');
          message.updates = [];
          for (var i = 0; i < object.updates.length; ++i) {
            if (typeof object.updates[i] !== 'object')
              throw TypeError('.propel.commrouter.DebugInformation.updates: object expected');
            message.updates[i] = $root.propel.commrouter.DebugInformation.Update.fromObject(
              object.updates[i]
            );
          }
        }
        return message;
      };

      /**
       * Creates a plain object from a DebugInformation message. Also converts values to other types if specified.
       * @function toObject
       * @memberof propel.commrouter.DebugInformation
       * @static
       * @param {propel.commrouter.DebugInformation} message DebugInformation
       * @param {$protobuf.IConversionOptions} [options] Conversion options
       * @returns {Object.<string,*>} Plain object
       */
      DebugInformation.toObject = function toObject(message, options) {
        if (!options) options = {};
        var object = {};
        if (options.arrays || options.defaults) object.updates = [];
        if (message.updates && message.updates.length) {
          object.updates = [];
          for (var j = 0; j < message.updates.length; ++j)
            object.updates[j] = $root.propel.commrouter.DebugInformation.Update.toObject(
              message.updates[j],
              options
            );
        }
        return object;
      };

      /**
       * Converts this DebugInformation to JSON.
       * @function toJSON
       * @memberof propel.commrouter.DebugInformation
       * @instance
       * @returns {Object.<string,*>} JSON object
       */
      DebugInformation.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
      };

      DebugInformation.Update = (function () {
        /**
         * Properties of an Update.
         * @memberof propel.commrouter.DebugInformation
         * @interface IUpdate
         * @property {Object.<string,google.protobuf.IStruct>|null} [info] Update info
         */

        /**
         * Constructs a new Update.
         * @memberof propel.commrouter.DebugInformation
         * @classdesc Represents an Update.
         * @implements IUpdate
         * @constructor
         * @param {propel.commrouter.DebugInformation.IUpdate=} [properties] Properties to set
         */
        function Update(properties) {
          this.info = {};
          if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
              if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
        }

        /**
         * Update info.
         * @member {Object.<string,google.protobuf.IStruct>} info
         * @memberof propel.commrouter.DebugInformation.Update
         * @instance
         */
        Update.prototype.info = $util.emptyObject;

        /**
         * Creates a new Update instance using the specified properties.
         * @function create
         * @memberof propel.commrouter.DebugInformation.Update
         * @static
         * @param {propel.commrouter.DebugInformation.IUpdate=} [properties] Properties to set
         * @returns {propel.commrouter.DebugInformation.Update} Update instance
         */
        Update.create = function create(properties) {
          return new Update(properties);
        };

        /**
         * Encodes the specified Update message. Does not implicitly {@link propel.commrouter.DebugInformation.Update.verify|verify} messages.
         * @function encode
         * @memberof propel.commrouter.DebugInformation.Update
         * @static
         * @param {propel.commrouter.DebugInformation.IUpdate} message Update message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Update.encode = function encode(message, writer) {
          if (!writer) writer = $Writer.create();
          if (message.info != null && message.hasOwnProperty('info'))
            for (var keys = Object.keys(message.info), i = 0; i < keys.length; ++i) {
              writer
                .uint32(/* id 1, wireType 2 =*/ 10)
                .fork()
                .uint32(/* id 1, wireType 2 =*/ 10)
                .string(keys[i]);
              $root.google.protobuf.Struct.encode(
                message.info[keys[i]],
                writer.uint32(/* id 2, wireType 2 =*/ 18).fork()
              )
                .ldelim()
                .ldelim();
            }
          return writer;
        };

        /**
         * Encodes the specified Update message, length delimited. Does not implicitly {@link propel.commrouter.DebugInformation.Update.verify|verify} messages.
         * @function encodeDelimited
         * @memberof propel.commrouter.DebugInformation.Update
         * @static
         * @param {propel.commrouter.DebugInformation.IUpdate} message Update message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Update.encodeDelimited = function encodeDelimited(message, writer) {
          return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an Update message from the specified reader or buffer.
         * @function decode
         * @memberof propel.commrouter.DebugInformation.Update
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {propel.commrouter.DebugInformation.Update} Update
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Update.decode = function decode(reader, length) {
          if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
          var end = length === undefined ? reader.len : reader.pos + length,
            message = new $root.propel.commrouter.DebugInformation.Update(),
            key;
          while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
              case 1:
                reader.skip().pos++;
                if (message.info === $util.emptyObject) message.info = {};
                key = reader.string();
                reader.pos++;
                message.info[key] = $root.google.protobuf.Struct.decode(reader, reader.uint32());
                break;
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };

        /**
         * Decodes an Update message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof propel.commrouter.DebugInformation.Update
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {propel.commrouter.DebugInformation.Update} Update
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Update.decodeDelimited = function decodeDelimited(reader) {
          if (!(reader instanceof $Reader)) reader = new $Reader(reader);
          return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an Update message.
         * @function verify
         * @memberof propel.commrouter.DebugInformation.Update
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Update.verify = function verify(message) {
          if (typeof message !== 'object' || message === null) return 'object expected';
          if (message.info != null && message.hasOwnProperty('info')) {
            if (!$util.isObject(message.info)) return 'info: object expected';
            var key = Object.keys(message.info);
            for (var i = 0; i < key.length; ++i) {
              var error = $root.google.protobuf.Struct.verify(message.info[key[i]]);
              if (error) return 'info.' + error;
            }
          }
          return null;
        };

        /**
         * Creates an Update message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof propel.commrouter.DebugInformation.Update
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {propel.commrouter.DebugInformation.Update} Update
         */
        Update.fromObject = function fromObject(object) {
          if (object instanceof $root.propel.commrouter.DebugInformation.Update) return object;
          var message = new $root.propel.commrouter.DebugInformation.Update();
          if (object.info) {
            if (typeof object.info !== 'object')
              throw TypeError('.propel.commrouter.DebugInformation.Update.info: object expected');
            message.info = {};
            for (var keys = Object.keys(object.info), i = 0; i < keys.length; ++i) {
              if (typeof object.info[keys[i]] !== 'object')
                throw TypeError('.propel.commrouter.DebugInformation.Update.info: object expected');
              message.info[keys[i]] = $root.google.protobuf.Struct.fromObject(object.info[keys[i]]);
            }
          }
          return message;
        };

        /**
         * Creates a plain object from an Update message. Also converts values to other types if specified.
         * @function toObject
         * @memberof propel.commrouter.DebugInformation.Update
         * @static
         * @param {propel.commrouter.DebugInformation.Update} message Update
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Update.toObject = function toObject(message, options) {
          if (!options) options = {};
          var object = {};
          if (options.objects || options.defaults) object.info = {};
          var keys2;
          if (message.info && (keys2 = Object.keys(message.info)).length) {
            object.info = {};
            for (var j = 0; j < keys2.length; ++j)
              object.info[keys2[j]] = $root.google.protobuf.Struct.toObject(
                message.info[keys2[j]],
                options
              );
          }
          return object;
        };

        /**
         * Converts this Update to JSON.
         * @function toJSON
         * @memberof propel.commrouter.DebugInformation.Update
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Update.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Update;
      })();

      return DebugInformation;
    })();

    commrouter.Sentence = (function () {
      /**
       * Properties of a Sentence.
       * @memberof propel.commrouter
       * @interface ISentence
       * @property {string|null} [id] Sentence id
       * @property {propel.commrouter.IVendorId|null} [channelId] Sentence channelId
       * @property {string|null} [messageId] Sentence messageId
       * @property {propel.commrouter.Sentence.State|null} [state] Sentence state
       * @property {string|null} [text] Sentence text
       * @property {Array.<propel.commrouter.IIntent>|null} [intents] Sentence intents
       */

      /**
       * Constructs a new Sentence.
       * @memberof propel.commrouter
       * @classdesc Represents a Sentence.
       * @implements ISentence
       * @constructor
       * @param {propel.commrouter.ISentence=} [properties] Properties to set
       */
      function Sentence(properties) {
        this.intents = [];
        if (properties)
          for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
      }

      /**
       * Sentence id.
       * @member {string} id
       * @memberof propel.commrouter.Sentence
       * @instance
       */
      Sentence.prototype.id = '';

      /**
       * Sentence channelId.
       * @member {propel.commrouter.IVendorId|null|undefined} channelId
       * @memberof propel.commrouter.Sentence
       * @instance
       */
      Sentence.prototype.channelId = null;

      /**
       * Sentence messageId.
       * @member {string} messageId
       * @memberof propel.commrouter.Sentence
       * @instance
       */
      Sentence.prototype.messageId = '';

      /**
       * Sentence state.
       * @member {propel.commrouter.Sentence.State} state
       * @memberof propel.commrouter.Sentence
       * @instance
       */
      Sentence.prototype.state = 0;

      /**
       * Sentence text.
       * @member {string} text
       * @memberof propel.commrouter.Sentence
       * @instance
       */
      Sentence.prototype.text = '';

      /**
       * Sentence intents.
       * @member {Array.<propel.commrouter.IIntent>} intents
       * @memberof propel.commrouter.Sentence
       * @instance
       */
      Sentence.prototype.intents = $util.emptyArray;

      /**
       * Creates a new Sentence instance using the specified properties.
       * @function create
       * @memberof propel.commrouter.Sentence
       * @static
       * @param {propel.commrouter.ISentence=} [properties] Properties to set
       * @returns {propel.commrouter.Sentence} Sentence instance
       */
      Sentence.create = function create(properties) {
        return new Sentence(properties);
      };

      /**
       * Encodes the specified Sentence message. Does not implicitly {@link propel.commrouter.Sentence.verify|verify} messages.
       * @function encode
       * @memberof propel.commrouter.Sentence
       * @static
       * @param {propel.commrouter.ISentence} message Sentence message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      Sentence.encode = function encode(message, writer) {
        if (!writer) writer = $Writer.create();
        if (message.id != null && message.hasOwnProperty('id'))
          writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
        if (message.messageId != null && message.hasOwnProperty('messageId'))
          writer.uint32(/* id 2, wireType 2 =*/ 18).string(message.messageId);
        if (message.state != null && message.hasOwnProperty('state'))
          writer.uint32(/* id 3, wireType 0 =*/ 24).int32(message.state);
        if (message.text != null && message.hasOwnProperty('text'))
          writer.uint32(/* id 4, wireType 2 =*/ 34).string(message.text);
        if (message.intents != null && message.intents.length)
          for (var i = 0; i < message.intents.length; ++i)
            $root.propel.commrouter.Intent.encode(
              message.intents[i],
              writer.uint32(/* id 5, wireType 2 =*/ 42).fork()
            ).ldelim();
        if (message.channelId != null && message.hasOwnProperty('channelId'))
          $root.propel.commrouter.VendorId.encode(
            message.channelId,
            writer.uint32(/* id 6, wireType 2 =*/ 50).fork()
          ).ldelim();
        return writer;
      };

      /**
       * Encodes the specified Sentence message, length delimited. Does not implicitly {@link propel.commrouter.Sentence.verify|verify} messages.
       * @function encodeDelimited
       * @memberof propel.commrouter.Sentence
       * @static
       * @param {propel.commrouter.ISentence} message Sentence message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      Sentence.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
      };

      /**
       * Decodes a Sentence message from the specified reader or buffer.
       * @function decode
       * @memberof propel.commrouter.Sentence
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @param {number} [length] Message length if known beforehand
       * @returns {propel.commrouter.Sentence} Sentence
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      Sentence.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length,
          message = new $root.propel.commrouter.Sentence();
        while (reader.pos < end) {
          var tag = reader.uint32();
          switch (tag >>> 3) {
            case 1:
              message.id = reader.string();
              break;
            case 6:
              message.channelId = $root.propel.commrouter.VendorId.decode(reader, reader.uint32());
              break;
            case 2:
              message.messageId = reader.string();
              break;
            case 3:
              message.state = reader.int32();
              break;
            case 4:
              message.text = reader.string();
              break;
            case 5:
              if (!(message.intents && message.intents.length)) message.intents = [];
              message.intents.push($root.propel.commrouter.Intent.decode(reader, reader.uint32()));
              break;
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };

      /**
       * Decodes a Sentence message from the specified reader or buffer, length delimited.
       * @function decodeDelimited
       * @memberof propel.commrouter.Sentence
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @returns {propel.commrouter.Sentence} Sentence
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      Sentence.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader)) reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
      };

      /**
       * Verifies a Sentence message.
       * @function verify
       * @memberof propel.commrouter.Sentence
       * @static
       * @param {Object.<string,*>} message Plain object to verify
       * @returns {string|null} `null` if valid, otherwise the reason why it is not
       */
      Sentence.verify = function verify(message) {
        if (typeof message !== 'object' || message === null) return 'object expected';
        if (message.id != null && message.hasOwnProperty('id'))
          if (!$util.isString(message.id)) return 'id: string expected';
        if (message.channelId != null && message.hasOwnProperty('channelId')) {
          var error = $root.propel.commrouter.VendorId.verify(message.channelId);
          if (error) return 'channelId.' + error;
        }
        if (message.messageId != null && message.hasOwnProperty('messageId'))
          if (!$util.isString(message.messageId)) return 'messageId: string expected';
        if (message.state != null && message.hasOwnProperty('state'))
          switch (message.state) {
            default:
              return 'state: enum value expected';
            case 0:
            case 1:
            case 2:
            case 3:
              break;
          }
        if (message.text != null && message.hasOwnProperty('text'))
          if (!$util.isString(message.text)) return 'text: string expected';
        if (message.intents != null && message.hasOwnProperty('intents')) {
          if (!Array.isArray(message.intents)) return 'intents: array expected';
          for (var i = 0; i < message.intents.length; ++i) {
            var error = $root.propel.commrouter.Intent.verify(message.intents[i]);
            if (error) return 'intents.' + error;
          }
        }
        return null;
      };

      /**
       * Creates a Sentence message from a plain object. Also converts values to their respective internal types.
       * @function fromObject
       * @memberof propel.commrouter.Sentence
       * @static
       * @param {Object.<string,*>} object Plain object
       * @returns {propel.commrouter.Sentence} Sentence
       */
      Sentence.fromObject = function fromObject(object) {
        if (object instanceof $root.propel.commrouter.Sentence) return object;
        var message = new $root.propel.commrouter.Sentence();
        if (object.id != null) message.id = String(object.id);
        if (object.channelId != null) {
          if (typeof object.channelId !== 'object')
            throw TypeError('.propel.commrouter.Sentence.channelId: object expected');
          message.channelId = $root.propel.commrouter.VendorId.fromObject(object.channelId);
        }
        if (object.messageId != null) message.messageId = String(object.messageId);
        switch (object.state) {
          case 'STATE_UNKNOWN':
          case 0:
            message.state = 0;
            break;
          case 'STATE_INITIAL':
          case 1:
            message.state = 1;
            break;
          case 'STATE_RESPONDED':
          case 2:
            message.state = 2;
            break;
          case 'STATE_SKIPPED':
          case 3:
            message.state = 3;
            break;
        }
        if (object.text != null) message.text = String(object.text);
        if (object.intents) {
          if (!Array.isArray(object.intents))
            throw TypeError('.propel.commrouter.Sentence.intents: array expected');
          message.intents = [];
          for (var i = 0; i < object.intents.length; ++i) {
            if (typeof object.intents[i] !== 'object')
              throw TypeError('.propel.commrouter.Sentence.intents: object expected');
            message.intents[i] = $root.propel.commrouter.Intent.fromObject(object.intents[i]);
          }
        }
        return message;
      };

      /**
       * Creates a plain object from a Sentence message. Also converts values to other types if specified.
       * @function toObject
       * @memberof propel.commrouter.Sentence
       * @static
       * @param {propel.commrouter.Sentence} message Sentence
       * @param {$protobuf.IConversionOptions} [options] Conversion options
       * @returns {Object.<string,*>} Plain object
       */
      Sentence.toObject = function toObject(message, options) {
        if (!options) options = {};
        var object = {};
        if (options.arrays || options.defaults) object.intents = [];
        if (options.defaults) {
          object.id = '';
          object.messageId = '';
          object.state = options.enums === String ? 'STATE_UNKNOWN' : 0;
          object.text = '';
          object.channelId = null;
        }
        if (message.id != null && message.hasOwnProperty('id')) object.id = message.id;
        if (message.messageId != null && message.hasOwnProperty('messageId'))
          object.messageId = message.messageId;
        if (message.state != null && message.hasOwnProperty('state'))
          object.state =
            options.enums === String
              ? $root.propel.commrouter.Sentence.State[message.state]
              : message.state;
        if (message.text != null && message.hasOwnProperty('text')) object.text = message.text;
        if (message.intents && message.intents.length) {
          object.intents = [];
          for (var j = 0; j < message.intents.length; ++j)
            object.intents[j] = $root.propel.commrouter.Intent.toObject(
              message.intents[j],
              options
            );
        }
        if (message.channelId != null && message.hasOwnProperty('channelId'))
          object.channelId = $root.propel.commrouter.VendorId.toObject(message.channelId, options);
        return object;
      };

      /**
       * Converts this Sentence to JSON.
       * @function toJSON
       * @memberof propel.commrouter.Sentence
       * @instance
       * @returns {Object.<string,*>} JSON object
       */
      Sentence.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
      };

      /**
       * State enum.
       * @name propel.commrouter.Sentence.State
       * @enum {string}
       * @property {number} STATE_UNKNOWN=0 STATE_UNKNOWN value
       * @property {number} STATE_INITIAL=1 STATE_INITIAL value
       * @property {number} STATE_RESPONDED=2 STATE_RESPONDED value
       * @property {number} STATE_SKIPPED=3 STATE_SKIPPED value
       */
      Sentence.State = (function () {
        var valuesById = {},
          values = Object.create(valuesById);
        values[(valuesById[0] = 'STATE_UNKNOWN')] = 0;
        values[(valuesById[1] = 'STATE_INITIAL')] = 1;
        values[(valuesById[2] = 'STATE_RESPONDED')] = 2;
        values[(valuesById[3] = 'STATE_SKIPPED')] = 3;
        return values;
      })();

      return Sentence;
    })();

    commrouter.Intent = (function () {
      /**
       * Properties of an Intent.
       * @memberof propel.commrouter
       * @interface IIntent
       * @property {string|null} [id] Intent id
       * @property {number|null} [probability] Intent probability
       * @property {string|null} [classId] Intent classId
       * @property {number|null} [classProbability] Intent classProbability
       * @property {string|null} [label] Intent label
       * @property {boolean|null} [selected] Intent selected
       * @property {string|null} [modelId] Intent modelId
       * @property {string|null} [classModelId] Intent classModelId
       * @property {google.protobuf.IStruct|null} [info] Intent info
       */

      /**
       * Constructs a new Intent.
       * @memberof propel.commrouter
       * @classdesc Represents an Intent.
       * @implements IIntent
       * @constructor
       * @param {propel.commrouter.IIntent=} [properties] Properties to set
       */
      function Intent(properties) {
        if (properties)
          for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
      }

      /**
       * Intent id.
       * @member {string} id
       * @memberof propel.commrouter.Intent
       * @instance
       */
      Intent.prototype.id = '';

      /**
       * Intent probability.
       * @member {number} probability
       * @memberof propel.commrouter.Intent
       * @instance
       */
      Intent.prototype.probability = 0;

      /**
       * Intent classId.
       * @member {string} classId
       * @memberof propel.commrouter.Intent
       * @instance
       */
      Intent.prototype.classId = '';

      /**
       * Intent classProbability.
       * @member {number} classProbability
       * @memberof propel.commrouter.Intent
       * @instance
       */
      Intent.prototype.classProbability = 0;

      /**
       * Intent label.
       * @member {string} label
       * @memberof propel.commrouter.Intent
       * @instance
       */
      Intent.prototype.label = '';

      /**
       * Intent selected.
       * @member {boolean} selected
       * @memberof propel.commrouter.Intent
       * @instance
       */
      Intent.prototype.selected = false;

      /**
       * Intent modelId.
       * @member {string} modelId
       * @memberof propel.commrouter.Intent
       * @instance
       */
      Intent.prototype.modelId = '';

      /**
       * Intent classModelId.
       * @member {string} classModelId
       * @memberof propel.commrouter.Intent
       * @instance
       */
      Intent.prototype.classModelId = '';

      /**
       * Intent info.
       * @member {google.protobuf.IStruct|null|undefined} info
       * @memberof propel.commrouter.Intent
       * @instance
       */
      Intent.prototype.info = null;

      /**
       * Creates a new Intent instance using the specified properties.
       * @function create
       * @memberof propel.commrouter.Intent
       * @static
       * @param {propel.commrouter.IIntent=} [properties] Properties to set
       * @returns {propel.commrouter.Intent} Intent instance
       */
      Intent.create = function create(properties) {
        return new Intent(properties);
      };

      /**
       * Encodes the specified Intent message. Does not implicitly {@link propel.commrouter.Intent.verify|verify} messages.
       * @function encode
       * @memberof propel.commrouter.Intent
       * @static
       * @param {propel.commrouter.IIntent} message Intent message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      Intent.encode = function encode(message, writer) {
        if (!writer) writer = $Writer.create();
        if (message.id != null && message.hasOwnProperty('id'))
          writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
        if (message.probability != null && message.hasOwnProperty('probability'))
          writer.uint32(/* id 2, wireType 1 =*/ 17).double(message.probability);
        if (message.classId != null && message.hasOwnProperty('classId'))
          writer.uint32(/* id 3, wireType 2 =*/ 26).string(message.classId);
        if (message.classProbability != null && message.hasOwnProperty('classProbability'))
          writer.uint32(/* id 4, wireType 1 =*/ 33).double(message.classProbability);
        if (message.label != null && message.hasOwnProperty('label'))
          writer.uint32(/* id 5, wireType 2 =*/ 42).string(message.label);
        if (message.selected != null && message.hasOwnProperty('selected'))
          writer.uint32(/* id 6, wireType 0 =*/ 48).bool(message.selected);
        if (message.modelId != null && message.hasOwnProperty('modelId'))
          writer.uint32(/* id 7, wireType 2 =*/ 58).string(message.modelId);
        if (message.classModelId != null && message.hasOwnProperty('classModelId'))
          writer.uint32(/* id 8, wireType 2 =*/ 66).string(message.classModelId);
        if (message.info != null && message.hasOwnProperty('info'))
          $root.google.protobuf.Struct.encode(
            message.info,
            writer.uint32(/* id 9, wireType 2 =*/ 74).fork()
          ).ldelim();
        return writer;
      };

      /**
       * Encodes the specified Intent message, length delimited. Does not implicitly {@link propel.commrouter.Intent.verify|verify} messages.
       * @function encodeDelimited
       * @memberof propel.commrouter.Intent
       * @static
       * @param {propel.commrouter.IIntent} message Intent message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      Intent.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
      };

      /**
       * Decodes an Intent message from the specified reader or buffer.
       * @function decode
       * @memberof propel.commrouter.Intent
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @param {number} [length] Message length if known beforehand
       * @returns {propel.commrouter.Intent} Intent
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      Intent.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length,
          message = new $root.propel.commrouter.Intent();
        while (reader.pos < end) {
          var tag = reader.uint32();
          switch (tag >>> 3) {
            case 1:
              message.id = reader.string();
              break;
            case 2:
              message.probability = reader.double();
              break;
            case 3:
              message.classId = reader.string();
              break;
            case 4:
              message.classProbability = reader.double();
              break;
            case 5:
              message.label = reader.string();
              break;
            case 6:
              message.selected = reader.bool();
              break;
            case 7:
              message.modelId = reader.string();
              break;
            case 8:
              message.classModelId = reader.string();
              break;
            case 9:
              message.info = $root.google.protobuf.Struct.decode(reader, reader.uint32());
              break;
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };

      /**
       * Decodes an Intent message from the specified reader or buffer, length delimited.
       * @function decodeDelimited
       * @memberof propel.commrouter.Intent
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @returns {propel.commrouter.Intent} Intent
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      Intent.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader)) reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
      };

      /**
       * Verifies an Intent message.
       * @function verify
       * @memberof propel.commrouter.Intent
       * @static
       * @param {Object.<string,*>} message Plain object to verify
       * @returns {string|null} `null` if valid, otherwise the reason why it is not
       */
      Intent.verify = function verify(message) {
        if (typeof message !== 'object' || message === null) return 'object expected';
        if (message.id != null && message.hasOwnProperty('id'))
          if (!$util.isString(message.id)) return 'id: string expected';
        if (message.probability != null && message.hasOwnProperty('probability'))
          if (typeof message.probability !== 'number') return 'probability: number expected';
        if (message.classId != null && message.hasOwnProperty('classId'))
          if (!$util.isString(message.classId)) return 'classId: string expected';
        if (message.classProbability != null && message.hasOwnProperty('classProbability'))
          if (typeof message.classProbability !== 'number')
            return 'classProbability: number expected';
        if (message.label != null && message.hasOwnProperty('label'))
          if (!$util.isString(message.label)) return 'label: string expected';
        if (message.selected != null && message.hasOwnProperty('selected'))
          if (typeof message.selected !== 'boolean') return 'selected: boolean expected';
        if (message.modelId != null && message.hasOwnProperty('modelId'))
          if (!$util.isString(message.modelId)) return 'modelId: string expected';
        if (message.classModelId != null && message.hasOwnProperty('classModelId'))
          if (!$util.isString(message.classModelId)) return 'classModelId: string expected';
        if (message.info != null && message.hasOwnProperty('info')) {
          var error = $root.google.protobuf.Struct.verify(message.info);
          if (error) return 'info.' + error;
        }
        return null;
      };

      /**
       * Creates an Intent message from a plain object. Also converts values to their respective internal types.
       * @function fromObject
       * @memberof propel.commrouter.Intent
       * @static
       * @param {Object.<string,*>} object Plain object
       * @returns {propel.commrouter.Intent} Intent
       */
      Intent.fromObject = function fromObject(object) {
        if (object instanceof $root.propel.commrouter.Intent) return object;
        var message = new $root.propel.commrouter.Intent();
        if (object.id != null) message.id = String(object.id);
        if (object.probability != null) message.probability = Number(object.probability);
        if (object.classId != null) message.classId = String(object.classId);
        if (object.classProbability != null)
          message.classProbability = Number(object.classProbability);
        if (object.label != null) message.label = String(object.label);
        if (object.selected != null) message.selected = Boolean(object.selected);
        if (object.modelId != null) message.modelId = String(object.modelId);
        if (object.classModelId != null) message.classModelId = String(object.classModelId);
        if (object.info != null) {
          if (typeof object.info !== 'object')
            throw TypeError('.propel.commrouter.Intent.info: object expected');
          message.info = $root.google.protobuf.Struct.fromObject(object.info);
        }
        return message;
      };

      /**
       * Creates a plain object from an Intent message. Also converts values to other types if specified.
       * @function toObject
       * @memberof propel.commrouter.Intent
       * @static
       * @param {propel.commrouter.Intent} message Intent
       * @param {$protobuf.IConversionOptions} [options] Conversion options
       * @returns {Object.<string,*>} Plain object
       */
      Intent.toObject = function toObject(message, options) {
        if (!options) options = {};
        var object = {};
        if (options.defaults) {
          object.id = '';
          object.probability = 0;
          object.classId = '';
          object.classProbability = 0;
          object.label = '';
          object.selected = false;
          object.modelId = '';
          object.classModelId = '';
          object.info = null;
        }
        if (message.id != null && message.hasOwnProperty('id')) object.id = message.id;
        if (message.probability != null && message.hasOwnProperty('probability'))
          object.probability =
            options.json && !isFinite(message.probability)
              ? String(message.probability)
              : message.probability;
        if (message.classId != null && message.hasOwnProperty('classId'))
          object.classId = message.classId;
        if (message.classProbability != null && message.hasOwnProperty('classProbability'))
          object.classProbability =
            options.json && !isFinite(message.classProbability)
              ? String(message.classProbability)
              : message.classProbability;
        if (message.label != null && message.hasOwnProperty('label')) object.label = message.label;
        if (message.selected != null && message.hasOwnProperty('selected'))
          object.selected = message.selected;
        if (message.modelId != null && message.hasOwnProperty('modelId'))
          object.modelId = message.modelId;
        if (message.classModelId != null && message.hasOwnProperty('classModelId'))
          object.classModelId = message.classModelId;
        if (message.info != null && message.hasOwnProperty('info'))
          object.info = $root.google.protobuf.Struct.toObject(message.info, options);
        return object;
      };

      /**
       * Converts this Intent to JSON.
       * @function toJSON
       * @memberof propel.commrouter.Intent
       * @instance
       * @returns {Object.<string,*>} JSON object
       */
      Intent.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
      };

      return Intent;
    })();

    commrouter.Response = (function () {
      /**
       * Properties of a Response.
       * @memberof propel.commrouter
       * @interface IResponse
       * @property {string|null} [id] Response id
       * @property {string|null} [channelType] Response channelType
       * @property {propel.commrouter.IVendorId|null} [channelId] Response channelId
       * @property {propel.commrouter.Response.State|null} [state] Response state
       * @property {Array.<string>|null} [sentenceIds] Response sentenceIds
       * @property {Array.<propel.core.IMessageBody>|null} [messageBodies] Response messageBodies
       * @property {Array.<propel.commrouter.ISentence>|null} [sentences] Response sentences
       * @property {Array.<propel.commrouter.ISentence>|null} [outgoingSentences] Response outgoingSentences
       * @property {Array.<string>|null} [conversationUpdateFiles] Response conversationUpdateFiles
       * @property {google.protobuf.IStringValue|null} [contextId] Response contextId
       * @property {google.protobuf.IStringValue|null} [error] Response error
       * @property {google.protobuf.IStringValue|null} [errorMessage] Response errorMessage
       * @property {google.protobuf.IStringValue|null} [debugInformationFile] Response debugInformationFile
       * @property {google.protobuf.IStruct|null} [info] Response info
       * @property {boolean|null} [isLowConfidence] Response isLowConfidence
       */

      /**
       * Constructs a new Response.
       * @memberof propel.commrouter
       * @classdesc Represents a Response.
       * @implements IResponse
       * @constructor
       * @param {propel.commrouter.IResponse=} [properties] Properties to set
       */
      function Response(properties) {
        this.sentenceIds = [];
        this.messageBodies = [];
        this.sentences = [];
        this.outgoingSentences = [];
        this.conversationUpdateFiles = [];
        if (properties)
          for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
      }

      /**
       * Response id.
       * @member {string} id
       * @memberof propel.commrouter.Response
       * @instance
       */
      Response.prototype.id = '';

      /**
       * Response channelType.
       * @member {string} channelType
       * @memberof propel.commrouter.Response
       * @instance
       */
      Response.prototype.channelType = '';

      /**
       * Response channelId.
       * @member {propel.commrouter.IVendorId|null|undefined} channelId
       * @memberof propel.commrouter.Response
       * @instance
       */
      Response.prototype.channelId = null;

      /**
       * Response state.
       * @member {propel.commrouter.Response.State} state
       * @memberof propel.commrouter.Response
       * @instance
       */
      Response.prototype.state = 0;

      /**
       * Response sentenceIds.
       * @member {Array.<string>} sentenceIds
       * @memberof propel.commrouter.Response
       * @instance
       */
      Response.prototype.sentenceIds = $util.emptyArray;

      /**
       * Response messageBodies.
       * @member {Array.<propel.core.IMessageBody>} messageBodies
       * @memberof propel.commrouter.Response
       * @instance
       */
      Response.prototype.messageBodies = $util.emptyArray;

      /**
       * Response sentences.
       * @member {Array.<propel.commrouter.ISentence>} sentences
       * @memberof propel.commrouter.Response
       * @instance
       */
      Response.prototype.sentences = $util.emptyArray;

      /**
       * Response outgoingSentences.
       * @member {Array.<propel.commrouter.ISentence>} outgoingSentences
       * @memberof propel.commrouter.Response
       * @instance
       */
      Response.prototype.outgoingSentences = $util.emptyArray;

      /**
       * Response conversationUpdateFiles.
       * @member {Array.<string>} conversationUpdateFiles
       * @memberof propel.commrouter.Response
       * @instance
       */
      Response.prototype.conversationUpdateFiles = $util.emptyArray;

      /**
       * Response contextId.
       * @member {google.protobuf.IStringValue|null|undefined} contextId
       * @memberof propel.commrouter.Response
       * @instance
       */
      Response.prototype.contextId = null;

      /**
       * Response error.
       * @member {google.protobuf.IStringValue|null|undefined} error
       * @memberof propel.commrouter.Response
       * @instance
       */
      Response.prototype.error = null;

      /**
       * Response errorMessage.
       * @member {google.protobuf.IStringValue|null|undefined} errorMessage
       * @memberof propel.commrouter.Response
       * @instance
       */
      Response.prototype.errorMessage = null;

      /**
       * Response debugInformationFile.
       * @member {google.protobuf.IStringValue|null|undefined} debugInformationFile
       * @memberof propel.commrouter.Response
       * @instance
       */
      Response.prototype.debugInformationFile = null;

      /**
       * Response info.
       * @member {google.protobuf.IStruct|null|undefined} info
       * @memberof propel.commrouter.Response
       * @instance
       */
      Response.prototype.info = null;

      /**
       * Response isLowConfidence.
       * @member {boolean} isLowConfidence
       * @memberof propel.commrouter.Response
       * @instance
       */
      Response.prototype.isLowConfidence = false;

      /**
       * Creates a new Response instance using the specified properties.
       * @function create
       * @memberof propel.commrouter.Response
       * @static
       * @param {propel.commrouter.IResponse=} [properties] Properties to set
       * @returns {propel.commrouter.Response} Response instance
       */
      Response.create = function create(properties) {
        return new Response(properties);
      };

      /**
       * Encodes the specified Response message. Does not implicitly {@link propel.commrouter.Response.verify|verify} messages.
       * @function encode
       * @memberof propel.commrouter.Response
       * @static
       * @param {propel.commrouter.IResponse} message Response message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      Response.encode = function encode(message, writer) {
        if (!writer) writer = $Writer.create();
        if (message.id != null && message.hasOwnProperty('id'))
          writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
        if (message.state != null && message.hasOwnProperty('state'))
          writer.uint32(/* id 2, wireType 0 =*/ 16).int32(message.state);
        if (message.sentenceIds != null && message.sentenceIds.length)
          for (var i = 0; i < message.sentenceIds.length; ++i)
            writer.uint32(/* id 3, wireType 2 =*/ 26).string(message.sentenceIds[i]);
        if (message.messageBodies != null && message.messageBodies.length)
          for (var i = 0; i < message.messageBodies.length; ++i)
            $root.propel.core.MessageBody.encode(
              message.messageBodies[i],
              writer.uint32(/* id 4, wireType 2 =*/ 34).fork()
            ).ldelim();
        if (message.sentences != null && message.sentences.length)
          for (var i = 0; i < message.sentences.length; ++i)
            $root.propel.commrouter.Sentence.encode(
              message.sentences[i],
              writer.uint32(/* id 5, wireType 2 =*/ 42).fork()
            ).ldelim();
        if (message.channelType != null && message.hasOwnProperty('channelType'))
          writer.uint32(/* id 6, wireType 2 =*/ 50).string(message.channelType);
        if (message.contextId != null && message.hasOwnProperty('contextId'))
          $root.google.protobuf.StringValue.encode(
            message.contextId,
            writer.uint32(/* id 8, wireType 2 =*/ 66).fork()
          ).ldelim();
        if (message.error != null && message.hasOwnProperty('error'))
          $root.google.protobuf.StringValue.encode(
            message.error,
            writer.uint32(/* id 9, wireType 2 =*/ 74).fork()
          ).ldelim();
        if (message.errorMessage != null && message.hasOwnProperty('errorMessage'))
          $root.google.protobuf.StringValue.encode(
            message.errorMessage,
            writer.uint32(/* id 10, wireType 2 =*/ 82).fork()
          ).ldelim();
        if (message.debugInformationFile != null && message.hasOwnProperty('debugInformationFile'))
          $root.google.protobuf.StringValue.encode(
            message.debugInformationFile,
            writer.uint32(/* id 11, wireType 2 =*/ 90).fork()
          ).ldelim();
        if (message.info != null && message.hasOwnProperty('info'))
          $root.google.protobuf.Struct.encode(
            message.info,
            writer.uint32(/* id 12, wireType 2 =*/ 98).fork()
          ).ldelim();
        if (message.isLowConfidence != null && message.hasOwnProperty('isLowConfidence'))
          writer.uint32(/* id 13, wireType 0 =*/ 104).bool(message.isLowConfidence);
        if (message.conversationUpdateFiles != null && message.conversationUpdateFiles.length)
          for (var i = 0; i < message.conversationUpdateFiles.length; ++i)
            writer.uint32(/* id 14, wireType 2 =*/ 114).string(message.conversationUpdateFiles[i]);
        if (message.channelId != null && message.hasOwnProperty('channelId'))
          $root.propel.commrouter.VendorId.encode(
            message.channelId,
            writer.uint32(/* id 15, wireType 2 =*/ 122).fork()
          ).ldelim();
        if (message.outgoingSentences != null && message.outgoingSentences.length)
          for (var i = 0; i < message.outgoingSentences.length; ++i)
            $root.propel.commrouter.Sentence.encode(
              message.outgoingSentences[i],
              writer.uint32(/* id 16, wireType 2 =*/ 130).fork()
            ).ldelim();
        return writer;
      };

      /**
       * Encodes the specified Response message, length delimited. Does not implicitly {@link propel.commrouter.Response.verify|verify} messages.
       * @function encodeDelimited
       * @memberof propel.commrouter.Response
       * @static
       * @param {propel.commrouter.IResponse} message Response message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      Response.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
      };

      /**
       * Decodes a Response message from the specified reader or buffer.
       * @function decode
       * @memberof propel.commrouter.Response
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @param {number} [length] Message length if known beforehand
       * @returns {propel.commrouter.Response} Response
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      Response.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length,
          message = new $root.propel.commrouter.Response();
        while (reader.pos < end) {
          var tag = reader.uint32();
          switch (tag >>> 3) {
            case 1:
              message.id = reader.string();
              break;
            case 6:
              message.channelType = reader.string();
              break;
            case 15:
              message.channelId = $root.propel.commrouter.VendorId.decode(reader, reader.uint32());
              break;
            case 2:
              message.state = reader.int32();
              break;
            case 3:
              if (!(message.sentenceIds && message.sentenceIds.length)) message.sentenceIds = [];
              message.sentenceIds.push(reader.string());
              break;
            case 4:
              if (!(message.messageBodies && message.messageBodies.length))
                message.messageBodies = [];
              message.messageBodies.push(
                $root.propel.core.MessageBody.decode(reader, reader.uint32())
              );
              break;
            case 5:
              if (!(message.sentences && message.sentences.length)) message.sentences = [];
              message.sentences.push(
                $root.propel.commrouter.Sentence.decode(reader, reader.uint32())
              );
              break;
            case 16:
              if (!(message.outgoingSentences && message.outgoingSentences.length))
                message.outgoingSentences = [];
              message.outgoingSentences.push(
                $root.propel.commrouter.Sentence.decode(reader, reader.uint32())
              );
              break;
            case 14:
              if (!(message.conversationUpdateFiles && message.conversationUpdateFiles.length))
                message.conversationUpdateFiles = [];
              message.conversationUpdateFiles.push(reader.string());
              break;
            case 8:
              message.contextId = $root.google.protobuf.StringValue.decode(reader, reader.uint32());
              break;
            case 9:
              message.error = $root.google.protobuf.StringValue.decode(reader, reader.uint32());
              break;
            case 10:
              message.errorMessage = $root.google.protobuf.StringValue.decode(
                reader,
                reader.uint32()
              );
              break;
            case 11:
              message.debugInformationFile = $root.google.protobuf.StringValue.decode(
                reader,
                reader.uint32()
              );
              break;
            case 12:
              message.info = $root.google.protobuf.Struct.decode(reader, reader.uint32());
              break;
            case 13:
              message.isLowConfidence = reader.bool();
              break;
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };

      /**
       * Decodes a Response message from the specified reader or buffer, length delimited.
       * @function decodeDelimited
       * @memberof propel.commrouter.Response
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @returns {propel.commrouter.Response} Response
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      Response.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader)) reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
      };

      /**
       * Verifies a Response message.
       * @function verify
       * @memberof propel.commrouter.Response
       * @static
       * @param {Object.<string,*>} message Plain object to verify
       * @returns {string|null} `null` if valid, otherwise the reason why it is not
       */
      Response.verify = function verify(message) {
        if (typeof message !== 'object' || message === null) return 'object expected';
        if (message.id != null && message.hasOwnProperty('id'))
          if (!$util.isString(message.id)) return 'id: string expected';
        if (message.channelType != null && message.hasOwnProperty('channelType'))
          if (!$util.isString(message.channelType)) return 'channelType: string expected';
        if (message.channelId != null && message.hasOwnProperty('channelId')) {
          var error = $root.propel.commrouter.VendorId.verify(message.channelId);
          if (error) return 'channelId.' + error;
        }
        if (message.state != null && message.hasOwnProperty('state'))
          switch (message.state) {
            default:
              return 'state: enum value expected';
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
            case 6:
              break;
          }
        if (message.sentenceIds != null && message.hasOwnProperty('sentenceIds')) {
          if (!Array.isArray(message.sentenceIds)) return 'sentenceIds: array expected';
          for (var i = 0; i < message.sentenceIds.length; ++i)
            if (!$util.isString(message.sentenceIds[i])) return 'sentenceIds: string[] expected';
        }
        if (message.messageBodies != null && message.hasOwnProperty('messageBodies')) {
          if (!Array.isArray(message.messageBodies)) return 'messageBodies: array expected';
          for (var i = 0; i < message.messageBodies.length; ++i) {
            var error = $root.propel.core.MessageBody.verify(message.messageBodies[i]);
            if (error) return 'messageBodies.' + error;
          }
        }
        if (message.sentences != null && message.hasOwnProperty('sentences')) {
          if (!Array.isArray(message.sentences)) return 'sentences: array expected';
          for (var i = 0; i < message.sentences.length; ++i) {
            var error = $root.propel.commrouter.Sentence.verify(message.sentences[i]);
            if (error) return 'sentences.' + error;
          }
        }
        if (message.outgoingSentences != null && message.hasOwnProperty('outgoingSentences')) {
          if (!Array.isArray(message.outgoingSentences)) return 'outgoingSentences: array expected';
          for (var i = 0; i < message.outgoingSentences.length; ++i) {
            var error = $root.propel.commrouter.Sentence.verify(message.outgoingSentences[i]);
            if (error) return 'outgoingSentences.' + error;
          }
        }
        if (
          message.conversationUpdateFiles != null &&
          message.hasOwnProperty('conversationUpdateFiles')
        ) {
          if (!Array.isArray(message.conversationUpdateFiles))
            return 'conversationUpdateFiles: array expected';
          for (var i = 0; i < message.conversationUpdateFiles.length; ++i)
            if (!$util.isString(message.conversationUpdateFiles[i]))
              return 'conversationUpdateFiles: string[] expected';
        }
        if (message.contextId != null && message.hasOwnProperty('contextId')) {
          var error = $root.google.protobuf.StringValue.verify(message.contextId);
          if (error) return 'contextId.' + error;
        }
        if (message.error != null && message.hasOwnProperty('error')) {
          var error = $root.google.protobuf.StringValue.verify(message.error);
          if (error) return 'error.' + error;
        }
        if (message.errorMessage != null && message.hasOwnProperty('errorMessage')) {
          var error = $root.google.protobuf.StringValue.verify(message.errorMessage);
          if (error) return 'errorMessage.' + error;
        }
        if (
          message.debugInformationFile != null &&
          message.hasOwnProperty('debugInformationFile')
        ) {
          var error = $root.google.protobuf.StringValue.verify(message.debugInformationFile);
          if (error) return 'debugInformationFile.' + error;
        }
        if (message.info != null && message.hasOwnProperty('info')) {
          var error = $root.google.protobuf.Struct.verify(message.info);
          if (error) return 'info.' + error;
        }
        if (message.isLowConfidence != null && message.hasOwnProperty('isLowConfidence'))
          if (typeof message.isLowConfidence !== 'boolean')
            return 'isLowConfidence: boolean expected';
        return null;
      };

      /**
       * Creates a Response message from a plain object. Also converts values to their respective internal types.
       * @function fromObject
       * @memberof propel.commrouter.Response
       * @static
       * @param {Object.<string,*>} object Plain object
       * @returns {propel.commrouter.Response} Response
       */
      Response.fromObject = function fromObject(object) {
        if (object instanceof $root.propel.commrouter.Response) return object;
        var message = new $root.propel.commrouter.Response();
        if (object.id != null) message.id = String(object.id);
        if (object.channelType != null) message.channelType = String(object.channelType);
        if (object.channelId != null) {
          if (typeof object.channelId !== 'object')
            throw TypeError('.propel.commrouter.Response.channelId: object expected');
          message.channelId = $root.propel.commrouter.VendorId.fromObject(object.channelId);
        }
        switch (object.state) {
          case 'STATE_UNKNOWN':
          case 0:
            message.state = 0;
            break;
          case 'STATE_UNSENT':
          case 1:
            message.state = 1;
            break;
          case 'STATE_SENT':
          case 2:
            message.state = 2;
            break;
          case 'STATE_GENERATING':
          case 3:
            message.state = 3;
            break;
          case 'STATE_INVALID':
          case 4:
            message.state = 4;
            break;
          case 'STATE_ERROR':
          case 5:
            message.state = 5;
            break;
          case 'STATE_SENDING':
          case 6:
            message.state = 6;
            break;
        }
        if (object.sentenceIds) {
          if (!Array.isArray(object.sentenceIds))
            throw TypeError('.propel.commrouter.Response.sentenceIds: array expected');
          message.sentenceIds = [];
          for (var i = 0; i < object.sentenceIds.length; ++i)
            message.sentenceIds[i] = String(object.sentenceIds[i]);
        }
        if (object.messageBodies) {
          if (!Array.isArray(object.messageBodies))
            throw TypeError('.propel.commrouter.Response.messageBodies: array expected');
          message.messageBodies = [];
          for (var i = 0; i < object.messageBodies.length; ++i) {
            if (typeof object.messageBodies[i] !== 'object')
              throw TypeError('.propel.commrouter.Response.messageBodies: object expected');
            message.messageBodies[i] = $root.propel.core.MessageBody.fromObject(
              object.messageBodies[i]
            );
          }
        }
        if (object.sentences) {
          if (!Array.isArray(object.sentences))
            throw TypeError('.propel.commrouter.Response.sentences: array expected');
          message.sentences = [];
          for (var i = 0; i < object.sentences.length; ++i) {
            if (typeof object.sentences[i] !== 'object')
              throw TypeError('.propel.commrouter.Response.sentences: object expected');
            message.sentences[i] = $root.propel.commrouter.Sentence.fromObject(object.sentences[i]);
          }
        }
        if (object.outgoingSentences) {
          if (!Array.isArray(object.outgoingSentences))
            throw TypeError('.propel.commrouter.Response.outgoingSentences: array expected');
          message.outgoingSentences = [];
          for (var i = 0; i < object.outgoingSentences.length; ++i) {
            if (typeof object.outgoingSentences[i] !== 'object')
              throw TypeError('.propel.commrouter.Response.outgoingSentences: object expected');
            message.outgoingSentences[i] = $root.propel.commrouter.Sentence.fromObject(
              object.outgoingSentences[i]
            );
          }
        }
        if (object.conversationUpdateFiles) {
          if (!Array.isArray(object.conversationUpdateFiles))
            throw TypeError('.propel.commrouter.Response.conversationUpdateFiles: array expected');
          message.conversationUpdateFiles = [];
          for (var i = 0; i < object.conversationUpdateFiles.length; ++i)
            message.conversationUpdateFiles[i] = String(object.conversationUpdateFiles[i]);
        }
        if (object.contextId != null) {
          if (typeof object.contextId !== 'object')
            throw TypeError('.propel.commrouter.Response.contextId: object expected');
          message.contextId = $root.google.protobuf.StringValue.fromObject(object.contextId);
        }
        if (object.error != null) {
          if (typeof object.error !== 'object')
            throw TypeError('.propel.commrouter.Response.error: object expected');
          message.error = $root.google.protobuf.StringValue.fromObject(object.error);
        }
        if (object.errorMessage != null) {
          if (typeof object.errorMessage !== 'object')
            throw TypeError('.propel.commrouter.Response.errorMessage: object expected');
          message.errorMessage = $root.google.protobuf.StringValue.fromObject(object.errorMessage);
        }
        if (object.debugInformationFile != null) {
          if (typeof object.debugInformationFile !== 'object')
            throw TypeError('.propel.commrouter.Response.debugInformationFile: object expected');
          message.debugInformationFile = $root.google.protobuf.StringValue.fromObject(
            object.debugInformationFile
          );
        }
        if (object.info != null) {
          if (typeof object.info !== 'object')
            throw TypeError('.propel.commrouter.Response.info: object expected');
          message.info = $root.google.protobuf.Struct.fromObject(object.info);
        }
        if (object.isLowConfidence != null)
          message.isLowConfidence = Boolean(object.isLowConfidence);
        return message;
      };

      /**
       * Creates a plain object from a Response message. Also converts values to other types if specified.
       * @function toObject
       * @memberof propel.commrouter.Response
       * @static
       * @param {propel.commrouter.Response} message Response
       * @param {$protobuf.IConversionOptions} [options] Conversion options
       * @returns {Object.<string,*>} Plain object
       */
      Response.toObject = function toObject(message, options) {
        if (!options) options = {};
        var object = {};
        if (options.arrays || options.defaults) {
          object.sentenceIds = [];
          object.messageBodies = [];
          object.sentences = [];
          object.conversationUpdateFiles = [];
          object.outgoingSentences = [];
        }
        if (options.defaults) {
          object.id = '';
          object.state = options.enums === String ? 'STATE_UNKNOWN' : 0;
          object.channelType = '';
          object.contextId = null;
          object.error = null;
          object.errorMessage = null;
          object.debugInformationFile = null;
          object.info = null;
          object.isLowConfidence = false;
          object.channelId = null;
        }
        if (message.id != null && message.hasOwnProperty('id')) object.id = message.id;
        if (message.state != null && message.hasOwnProperty('state'))
          object.state =
            options.enums === String
              ? $root.propel.commrouter.Response.State[message.state]
              : message.state;
        if (message.sentenceIds && message.sentenceIds.length) {
          object.sentenceIds = [];
          for (var j = 0; j < message.sentenceIds.length; ++j)
            object.sentenceIds[j] = message.sentenceIds[j];
        }
        if (message.messageBodies && message.messageBodies.length) {
          object.messageBodies = [];
          for (var j = 0; j < message.messageBodies.length; ++j)
            object.messageBodies[j] = $root.propel.core.MessageBody.toObject(
              message.messageBodies[j],
              options
            );
        }
        if (message.sentences && message.sentences.length) {
          object.sentences = [];
          for (var j = 0; j < message.sentences.length; ++j)
            object.sentences[j] = $root.propel.commrouter.Sentence.toObject(
              message.sentences[j],
              options
            );
        }
        if (message.channelType != null && message.hasOwnProperty('channelType'))
          object.channelType = message.channelType;
        if (message.contextId != null && message.hasOwnProperty('contextId'))
          object.contextId = $root.google.protobuf.StringValue.toObject(message.contextId, options);
        if (message.error != null && message.hasOwnProperty('error'))
          object.error = $root.google.protobuf.StringValue.toObject(message.error, options);
        if (message.errorMessage != null && message.hasOwnProperty('errorMessage'))
          object.errorMessage = $root.google.protobuf.StringValue.toObject(
            message.errorMessage,
            options
          );
        if (message.debugInformationFile != null && message.hasOwnProperty('debugInformationFile'))
          object.debugInformationFile = $root.google.protobuf.StringValue.toObject(
            message.debugInformationFile,
            options
          );
        if (message.info != null && message.hasOwnProperty('info'))
          object.info = $root.google.protobuf.Struct.toObject(message.info, options);
        if (message.isLowConfidence != null && message.hasOwnProperty('isLowConfidence'))
          object.isLowConfidence = message.isLowConfidence;
        if (message.conversationUpdateFiles && message.conversationUpdateFiles.length) {
          object.conversationUpdateFiles = [];
          for (var j = 0; j < message.conversationUpdateFiles.length; ++j)
            object.conversationUpdateFiles[j] = message.conversationUpdateFiles[j];
        }
        if (message.channelId != null && message.hasOwnProperty('channelId'))
          object.channelId = $root.propel.commrouter.VendorId.toObject(message.channelId, options);
        if (message.outgoingSentences && message.outgoingSentences.length) {
          object.outgoingSentences = [];
          for (var j = 0; j < message.outgoingSentences.length; ++j)
            object.outgoingSentences[j] = $root.propel.commrouter.Sentence.toObject(
              message.outgoingSentences[j],
              options
            );
        }
        return object;
      };

      /**
       * Converts this Response to JSON.
       * @function toJSON
       * @memberof propel.commrouter.Response
       * @instance
       * @returns {Object.<string,*>} JSON object
       */
      Response.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
      };

      /**
       * State enum.
       * @name propel.commrouter.Response.State
       * @enum {string}
       * @property {number} STATE_UNKNOWN=0 STATE_UNKNOWN value
       * @property {number} STATE_UNSENT=1 STATE_UNSENT value
       * @property {number} STATE_SENT=2 STATE_SENT value
       * @property {number} STATE_GENERATING=3 STATE_GENERATING value
       * @property {number} STATE_INVALID=4 STATE_INVALID value
       * @property {number} STATE_ERROR=5 STATE_ERROR value
       * @property {number} STATE_SENDING=6 STATE_SENDING value
       */
      Response.State = (function () {
        var valuesById = {},
          values = Object.create(valuesById);
        values[(valuesById[0] = 'STATE_UNKNOWN')] = 0;
        values[(valuesById[1] = 'STATE_UNSENT')] = 1;
        values[(valuesById[2] = 'STATE_SENT')] = 2;
        values[(valuesById[3] = 'STATE_GENERATING')] = 3;
        values[(valuesById[4] = 'STATE_INVALID')] = 4;
        values[(valuesById[5] = 'STATE_ERROR')] = 5;
        values[(valuesById[6] = 'STATE_SENDING')] = 6;
        return values;
      })();

      return Response;
    })();

    commrouter.Tag = (function () {
      /**
       * Properties of a Tag.
       * @memberof propel.commrouter
       * @interface ITag
       * @property {string|null} [name] Tag name
       * @property {propel.commrouter.IVendorId|null} [channelId] Tag channelId
       */

      /**
       * Constructs a new Tag.
       * @memberof propel.commrouter
       * @classdesc Represents a Tag.
       * @implements ITag
       * @constructor
       * @param {propel.commrouter.ITag=} [properties] Properties to set
       */
      function Tag(properties) {
        if (properties)
          for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
      }

      /**
       * Tag name.
       * @member {string} name
       * @memberof propel.commrouter.Tag
       * @instance
       */
      Tag.prototype.name = '';

      /**
       * Tag channelId.
       * @member {propel.commrouter.IVendorId|null|undefined} channelId
       * @memberof propel.commrouter.Tag
       * @instance
       */
      Tag.prototype.channelId = null;

      /**
       * Creates a new Tag instance using the specified properties.
       * @function create
       * @memberof propel.commrouter.Tag
       * @static
       * @param {propel.commrouter.ITag=} [properties] Properties to set
       * @returns {propel.commrouter.Tag} Tag instance
       */
      Tag.create = function create(properties) {
        return new Tag(properties);
      };

      /**
       * Encodes the specified Tag message. Does not implicitly {@link propel.commrouter.Tag.verify|verify} messages.
       * @function encode
       * @memberof propel.commrouter.Tag
       * @static
       * @param {propel.commrouter.ITag} message Tag message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      Tag.encode = function encode(message, writer) {
        if (!writer) writer = $Writer.create();
        if (message.name != null && message.hasOwnProperty('name'))
          writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.name);
        if (message.channelId != null && message.hasOwnProperty('channelId'))
          $root.propel.commrouter.VendorId.encode(
            message.channelId,
            writer.uint32(/* id 2, wireType 2 =*/ 18).fork()
          ).ldelim();
        return writer;
      };

      /**
       * Encodes the specified Tag message, length delimited. Does not implicitly {@link propel.commrouter.Tag.verify|verify} messages.
       * @function encodeDelimited
       * @memberof propel.commrouter.Tag
       * @static
       * @param {propel.commrouter.ITag} message Tag message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      Tag.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
      };

      /**
       * Decodes a Tag message from the specified reader or buffer.
       * @function decode
       * @memberof propel.commrouter.Tag
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @param {number} [length] Message length if known beforehand
       * @returns {propel.commrouter.Tag} Tag
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      Tag.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length,
          message = new $root.propel.commrouter.Tag();
        while (reader.pos < end) {
          var tag = reader.uint32();
          switch (tag >>> 3) {
            case 1:
              message.name = reader.string();
              break;
            case 2:
              message.channelId = $root.propel.commrouter.VendorId.decode(reader, reader.uint32());
              break;
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };

      /**
       * Decodes a Tag message from the specified reader or buffer, length delimited.
       * @function decodeDelimited
       * @memberof propel.commrouter.Tag
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @returns {propel.commrouter.Tag} Tag
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      Tag.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader)) reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
      };

      /**
       * Verifies a Tag message.
       * @function verify
       * @memberof propel.commrouter.Tag
       * @static
       * @param {Object.<string,*>} message Plain object to verify
       * @returns {string|null} `null` if valid, otherwise the reason why it is not
       */
      Tag.verify = function verify(message) {
        if (typeof message !== 'object' || message === null) return 'object expected';
        if (message.name != null && message.hasOwnProperty('name'))
          if (!$util.isString(message.name)) return 'name: string expected';
        if (message.channelId != null && message.hasOwnProperty('channelId')) {
          var error = $root.propel.commrouter.VendorId.verify(message.channelId);
          if (error) return 'channelId.' + error;
        }
        return null;
      };

      /**
       * Creates a Tag message from a plain object. Also converts values to their respective internal types.
       * @function fromObject
       * @memberof propel.commrouter.Tag
       * @static
       * @param {Object.<string,*>} object Plain object
       * @returns {propel.commrouter.Tag} Tag
       */
      Tag.fromObject = function fromObject(object) {
        if (object instanceof $root.propel.commrouter.Tag) return object;
        var message = new $root.propel.commrouter.Tag();
        if (object.name != null) message.name = String(object.name);
        if (object.channelId != null) {
          if (typeof object.channelId !== 'object')
            throw TypeError('.propel.commrouter.Tag.channelId: object expected');
          message.channelId = $root.propel.commrouter.VendorId.fromObject(object.channelId);
        }
        return message;
      };

      /**
       * Creates a plain object from a Tag message. Also converts values to other types if specified.
       * @function toObject
       * @memberof propel.commrouter.Tag
       * @static
       * @param {propel.commrouter.Tag} message Tag
       * @param {$protobuf.IConversionOptions} [options] Conversion options
       * @returns {Object.<string,*>} Plain object
       */
      Tag.toObject = function toObject(message, options) {
        if (!options) options = {};
        var object = {};
        if (options.defaults) {
          object.name = '';
          object.channelId = null;
        }
        if (message.name != null && message.hasOwnProperty('name')) object.name = message.name;
        if (message.channelId != null && message.hasOwnProperty('channelId'))
          object.channelId = $root.propel.commrouter.VendorId.toObject(message.channelId, options);
        return object;
      };

      /**
       * Converts this Tag to JSON.
       * @function toJSON
       * @memberof propel.commrouter.Tag
       * @instance
       * @returns {Object.<string,*>} JSON object
       */
      Tag.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
      };

      return Tag;
    })();

    commrouter.ConversationEvent = (function () {
      /**
       * Properties of a ConversationEvent.
       * @memberof propel.commrouter
       * @interface IConversationEvent
       * @property {string|null} [id] ConversationEvent id
       * @property {string|null} [conversationId] ConversationEvent conversationId
       * @property {google.protobuf.IStringValue|null} [commandId] ConversationEvent commandId
       * @property {number|Long|null} [createdAt] ConversationEvent createdAt
       * @property {propel.commrouter.ConversationEvent.IConversationCreated|null} [conversationCreated] ConversationEvent conversationCreated
       * @property {propel.commrouter.ConversationEvent.IConversationUpdated|null} [conversationUpdated] ConversationEvent conversationUpdated
       * @property {propel.commrouter.ConversationEvent.IChannelCreated|null} [channelCreated] ConversationEvent channelCreated
       * @property {propel.commrouter.ConversationEvent.IChannelUpdated|null} [channelUpdated] ConversationEvent channelUpdated
       * @property {propel.commrouter.ConversationEvent.IAvatarCreated|null} [avatarCreated] ConversationEvent avatarCreated
       * @property {propel.commrouter.ConversationEvent.IAvatarUpdated|null} [avatarUpdated] ConversationEvent avatarUpdated
       * @property {propel.commrouter.ConversationEvent.IMessageCreated|null} [messageCreated] ConversationEvent messageCreated
       * @property {propel.commrouter.ConversationEvent.IMessageUpdated|null} [messageUpdated] ConversationEvent messageUpdated
       * @property {propel.commrouter.ConversationEvent.ISentenceCreated|null} [sentenceCreated] ConversationEvent sentenceCreated
       * @property {propel.commrouter.ConversationEvent.ISentenceUpdated|null} [sentenceUpdated] ConversationEvent sentenceUpdated
       * @property {propel.commrouter.ConversationEvent.IResponseCreated|null} [responseCreated] ConversationEvent responseCreated
       * @property {propel.commrouter.ConversationEvent.IResponseUpdated|null} [responseUpdated] ConversationEvent responseUpdated
       * @property {propel.commrouter.ConversationEvent.IConversationStateUpdated|null} [conversationStateUpdated] ConversationEvent conversationStateUpdated
       * @property {propel.commrouter.ConversationEvent.IContextUpdated|null} [contextUpdated] ConversationEvent contextUpdated
       * @property {propel.commrouter.ConversationEvent.IConversationModeUpdated|null} [conversationModeUpdated] ConversationEvent conversationModeUpdated
       * @property {propel.commrouter.ConversationEvent.IEngineStateUpdated|null} [engineStateUpdated] ConversationEvent engineStateUpdated
       * @property {propel.commrouter.ConversationEvent.IChannelInfoUpdated|null} [channelInfoUpdated] ConversationEvent channelInfoUpdated
       * @property {propel.commrouter.ConversationEvent.IIntroductionCreated|null} [introductionCreated] ConversationEvent introductionCreated
       * @property {propel.commrouter.ConversationEvent.IInfoUpdated|null} [infoUpdated] ConversationEvent infoUpdated
       * @property {propel.commrouter.ConversationEvent.ITagCreated|null} [tagCreated] ConversationEvent tagCreated
       * @property {propel.commrouter.ConversationEvent.ITagDeleted|null} [tagDeleted] ConversationEvent tagDeleted
       * @property {propel.commrouter.ConversationEvent.IJobCreated|null} [jobCreated] ConversationEvent jobCreated
       * @property {propel.commrouter.ConversationEvent.IJobUpdated|null} [jobUpdated] ConversationEvent jobUpdated
       * @property {propel.commrouter.ConversationEvent.IJobDeleted|null} [jobDeleted] ConversationEvent jobDeleted
       * @property {propel.commrouter.ConversationEvent.IIncomingLeadRefCreated|null} [incomingLeadRefCreated] ConversationEvent incomingLeadRefCreated
       * @property {propel.commrouter.ConversationEvent.INoteCreated|null} [noteCreated] ConversationEvent noteCreated
       */

      /**
       * Constructs a new ConversationEvent.
       * @memberof propel.commrouter
       * @classdesc Represents a ConversationEvent.
       * @implements IConversationEvent
       * @constructor
       * @param {propel.commrouter.IConversationEvent=} [properties] Properties to set
       */
      function ConversationEvent(properties) {
        if (properties)
          for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
      }

      /**
       * ConversationEvent id.
       * @member {string} id
       * @memberof propel.commrouter.ConversationEvent
       * @instance
       */
      ConversationEvent.prototype.id = '';

      /**
       * ConversationEvent conversationId.
       * @member {string} conversationId
       * @memberof propel.commrouter.ConversationEvent
       * @instance
       */
      ConversationEvent.prototype.conversationId = '';

      /**
       * ConversationEvent commandId.
       * @member {google.protobuf.IStringValue|null|undefined} commandId
       * @memberof propel.commrouter.ConversationEvent
       * @instance
       */
      ConversationEvent.prototype.commandId = null;

      /**
       * ConversationEvent createdAt.
       * @member {number|Long} createdAt
       * @memberof propel.commrouter.ConversationEvent
       * @instance
       */
      ConversationEvent.prototype.createdAt = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;

      /**
       * ConversationEvent conversationCreated.
       * @member {propel.commrouter.ConversationEvent.IConversationCreated|null|undefined} conversationCreated
       * @memberof propel.commrouter.ConversationEvent
       * @instance
       */
      ConversationEvent.prototype.conversationCreated = null;

      /**
       * ConversationEvent conversationUpdated.
       * @member {propel.commrouter.ConversationEvent.IConversationUpdated|null|undefined} conversationUpdated
       * @memberof propel.commrouter.ConversationEvent
       * @instance
       */
      ConversationEvent.prototype.conversationUpdated = null;

      /**
       * ConversationEvent channelCreated.
       * @member {propel.commrouter.ConversationEvent.IChannelCreated|null|undefined} channelCreated
       * @memberof propel.commrouter.ConversationEvent
       * @instance
       */
      ConversationEvent.prototype.channelCreated = null;

      /**
       * ConversationEvent channelUpdated.
       * @member {propel.commrouter.ConversationEvent.IChannelUpdated|null|undefined} channelUpdated
       * @memberof propel.commrouter.ConversationEvent
       * @instance
       */
      ConversationEvent.prototype.channelUpdated = null;

      /**
       * ConversationEvent avatarCreated.
       * @member {propel.commrouter.ConversationEvent.IAvatarCreated|null|undefined} avatarCreated
       * @memberof propel.commrouter.ConversationEvent
       * @instance
       */
      ConversationEvent.prototype.avatarCreated = null;

      /**
       * ConversationEvent avatarUpdated.
       * @member {propel.commrouter.ConversationEvent.IAvatarUpdated|null|undefined} avatarUpdated
       * @memberof propel.commrouter.ConversationEvent
       * @instance
       */
      ConversationEvent.prototype.avatarUpdated = null;

      /**
       * ConversationEvent messageCreated.
       * @member {propel.commrouter.ConversationEvent.IMessageCreated|null|undefined} messageCreated
       * @memberof propel.commrouter.ConversationEvent
       * @instance
       */
      ConversationEvent.prototype.messageCreated = null;

      /**
       * ConversationEvent messageUpdated.
       * @member {propel.commrouter.ConversationEvent.IMessageUpdated|null|undefined} messageUpdated
       * @memberof propel.commrouter.ConversationEvent
       * @instance
       */
      ConversationEvent.prototype.messageUpdated = null;

      /**
       * ConversationEvent sentenceCreated.
       * @member {propel.commrouter.ConversationEvent.ISentenceCreated|null|undefined} sentenceCreated
       * @memberof propel.commrouter.ConversationEvent
       * @instance
       */
      ConversationEvent.prototype.sentenceCreated = null;

      /**
       * ConversationEvent sentenceUpdated.
       * @member {propel.commrouter.ConversationEvent.ISentenceUpdated|null|undefined} sentenceUpdated
       * @memberof propel.commrouter.ConversationEvent
       * @instance
       */
      ConversationEvent.prototype.sentenceUpdated = null;

      /**
       * ConversationEvent responseCreated.
       * @member {propel.commrouter.ConversationEvent.IResponseCreated|null|undefined} responseCreated
       * @memberof propel.commrouter.ConversationEvent
       * @instance
       */
      ConversationEvent.prototype.responseCreated = null;

      /**
       * ConversationEvent responseUpdated.
       * @member {propel.commrouter.ConversationEvent.IResponseUpdated|null|undefined} responseUpdated
       * @memberof propel.commrouter.ConversationEvent
       * @instance
       */
      ConversationEvent.prototype.responseUpdated = null;

      /**
       * ConversationEvent conversationStateUpdated.
       * @member {propel.commrouter.ConversationEvent.IConversationStateUpdated|null|undefined} conversationStateUpdated
       * @memberof propel.commrouter.ConversationEvent
       * @instance
       */
      ConversationEvent.prototype.conversationStateUpdated = null;

      /**
       * ConversationEvent contextUpdated.
       * @member {propel.commrouter.ConversationEvent.IContextUpdated|null|undefined} contextUpdated
       * @memberof propel.commrouter.ConversationEvent
       * @instance
       */
      ConversationEvent.prototype.contextUpdated = null;

      /**
       * ConversationEvent conversationModeUpdated.
       * @member {propel.commrouter.ConversationEvent.IConversationModeUpdated|null|undefined} conversationModeUpdated
       * @memberof propel.commrouter.ConversationEvent
       * @instance
       */
      ConversationEvent.prototype.conversationModeUpdated = null;

      /**
       * ConversationEvent engineStateUpdated.
       * @member {propel.commrouter.ConversationEvent.IEngineStateUpdated|null|undefined} engineStateUpdated
       * @memberof propel.commrouter.ConversationEvent
       * @instance
       */
      ConversationEvent.prototype.engineStateUpdated = null;

      /**
       * ConversationEvent channelInfoUpdated.
       * @member {propel.commrouter.ConversationEvent.IChannelInfoUpdated|null|undefined} channelInfoUpdated
       * @memberof propel.commrouter.ConversationEvent
       * @instance
       */
      ConversationEvent.prototype.channelInfoUpdated = null;

      /**
       * ConversationEvent introductionCreated.
       * @member {propel.commrouter.ConversationEvent.IIntroductionCreated|null|undefined} introductionCreated
       * @memberof propel.commrouter.ConversationEvent
       * @instance
       */
      ConversationEvent.prototype.introductionCreated = null;

      /**
       * ConversationEvent infoUpdated.
       * @member {propel.commrouter.ConversationEvent.IInfoUpdated|null|undefined} infoUpdated
       * @memberof propel.commrouter.ConversationEvent
       * @instance
       */
      ConversationEvent.prototype.infoUpdated = null;

      /**
       * ConversationEvent tagCreated.
       * @member {propel.commrouter.ConversationEvent.ITagCreated|null|undefined} tagCreated
       * @memberof propel.commrouter.ConversationEvent
       * @instance
       */
      ConversationEvent.prototype.tagCreated = null;

      /**
       * ConversationEvent tagDeleted.
       * @member {propel.commrouter.ConversationEvent.ITagDeleted|null|undefined} tagDeleted
       * @memberof propel.commrouter.ConversationEvent
       * @instance
       */
      ConversationEvent.prototype.tagDeleted = null;

      /**
       * ConversationEvent jobCreated.
       * @member {propel.commrouter.ConversationEvent.IJobCreated|null|undefined} jobCreated
       * @memberof propel.commrouter.ConversationEvent
       * @instance
       */
      ConversationEvent.prototype.jobCreated = null;

      /**
       * ConversationEvent jobUpdated.
       * @member {propel.commrouter.ConversationEvent.IJobUpdated|null|undefined} jobUpdated
       * @memberof propel.commrouter.ConversationEvent
       * @instance
       */
      ConversationEvent.prototype.jobUpdated = null;

      /**
       * ConversationEvent jobDeleted.
       * @member {propel.commrouter.ConversationEvent.IJobDeleted|null|undefined} jobDeleted
       * @memberof propel.commrouter.ConversationEvent
       * @instance
       */
      ConversationEvent.prototype.jobDeleted = null;

      /**
       * ConversationEvent incomingLeadRefCreated.
       * @member {propel.commrouter.ConversationEvent.IIncomingLeadRefCreated|null|undefined} incomingLeadRefCreated
       * @memberof propel.commrouter.ConversationEvent
       * @instance
       */
      ConversationEvent.prototype.incomingLeadRefCreated = null;

      /**
       * ConversationEvent noteCreated.
       * @member {propel.commrouter.ConversationEvent.INoteCreated|null|undefined} noteCreated
       * @memberof propel.commrouter.ConversationEvent
       * @instance
       */
      ConversationEvent.prototype.noteCreated = null;

      // OneOf field names bound to virtual getters and setters
      var $oneOfFields;

      /**
       * ConversationEvent event.
       * @member {"conversationCreated"|"conversationUpdated"|"channelCreated"|"channelUpdated"|"avatarCreated"|"avatarUpdated"|"messageCreated"|"messageUpdated"|"sentenceCreated"|"sentenceUpdated"|"responseCreated"|"responseUpdated"|"conversationStateUpdated"|"contextUpdated"|"conversationModeUpdated"|"engineStateUpdated"|"channelInfoUpdated"|"introductionCreated"|"infoUpdated"|"tagCreated"|"tagDeleted"|"jobCreated"|"jobUpdated"|"jobDeleted"|"incomingLeadRefCreated"|"noteCreated"|undefined} event
       * @memberof propel.commrouter.ConversationEvent
       * @instance
       */
      Object.defineProperty(ConversationEvent.prototype, 'event', {
        get: $util.oneOfGetter(
          ($oneOfFields = [
            'conversationCreated',
            'conversationUpdated',
            'channelCreated',
            'channelUpdated',
            'avatarCreated',
            'avatarUpdated',
            'messageCreated',
            'messageUpdated',
            'sentenceCreated',
            'sentenceUpdated',
            'responseCreated',
            'responseUpdated',
            'conversationStateUpdated',
            'contextUpdated',
            'conversationModeUpdated',
            'engineStateUpdated',
            'channelInfoUpdated',
            'introductionCreated',
            'infoUpdated',
            'tagCreated',
            'tagDeleted',
            'jobCreated',
            'jobUpdated',
            'jobDeleted',
            'incomingLeadRefCreated',
            'noteCreated',
          ])
        ),
        set: $util.oneOfSetter($oneOfFields),
      });

      /**
       * Creates a new ConversationEvent instance using the specified properties.
       * @function create
       * @memberof propel.commrouter.ConversationEvent
       * @static
       * @param {propel.commrouter.IConversationEvent=} [properties] Properties to set
       * @returns {propel.commrouter.ConversationEvent} ConversationEvent instance
       */
      ConversationEvent.create = function create(properties) {
        return new ConversationEvent(properties);
      };

      /**
       * Encodes the specified ConversationEvent message. Does not implicitly {@link propel.commrouter.ConversationEvent.verify|verify} messages.
       * @function encode
       * @memberof propel.commrouter.ConversationEvent
       * @static
       * @param {propel.commrouter.IConversationEvent} message ConversationEvent message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      ConversationEvent.encode = function encode(message, writer) {
        if (!writer) writer = $Writer.create();
        if (message.id != null && message.hasOwnProperty('id'))
          writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
        if (message.conversationId != null && message.hasOwnProperty('conversationId'))
          writer.uint32(/* id 2, wireType 2 =*/ 18).string(message.conversationId);
        if (message.commandId != null && message.hasOwnProperty('commandId'))
          $root.google.protobuf.StringValue.encode(
            message.commandId,
            writer.uint32(/* id 3, wireType 2 =*/ 26).fork()
          ).ldelim();
        if (message.createdAt != null && message.hasOwnProperty('createdAt'))
          writer.uint32(/* id 4, wireType 0 =*/ 32).uint64(message.createdAt);
        if (message.conversationCreated != null && message.hasOwnProperty('conversationCreated'))
          $root.propel.commrouter.ConversationEvent.ConversationCreated.encode(
            message.conversationCreated,
            writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
          ).ldelim();
        if (message.conversationUpdated != null && message.hasOwnProperty('conversationUpdated'))
          $root.propel.commrouter.ConversationEvent.ConversationUpdated.encode(
            message.conversationUpdated,
            writer.uint32(/* id 101, wireType 2 =*/ 810).fork()
          ).ldelim();
        if (message.channelCreated != null && message.hasOwnProperty('channelCreated'))
          $root.propel.commrouter.ConversationEvent.ChannelCreated.encode(
            message.channelCreated,
            writer.uint32(/* id 102, wireType 2 =*/ 818).fork()
          ).ldelim();
        if (message.channelUpdated != null && message.hasOwnProperty('channelUpdated'))
          $root.propel.commrouter.ConversationEvent.ChannelUpdated.encode(
            message.channelUpdated,
            writer.uint32(/* id 103, wireType 2 =*/ 826).fork()
          ).ldelim();
        if (message.avatarCreated != null && message.hasOwnProperty('avatarCreated'))
          $root.propel.commrouter.ConversationEvent.AvatarCreated.encode(
            message.avatarCreated,
            writer.uint32(/* id 104, wireType 2 =*/ 834).fork()
          ).ldelim();
        if (message.avatarUpdated != null && message.hasOwnProperty('avatarUpdated'))
          $root.propel.commrouter.ConversationEvent.AvatarUpdated.encode(
            message.avatarUpdated,
            writer.uint32(/* id 105, wireType 2 =*/ 842).fork()
          ).ldelim();
        if (message.messageCreated != null && message.hasOwnProperty('messageCreated'))
          $root.propel.commrouter.ConversationEvent.MessageCreated.encode(
            message.messageCreated,
            writer.uint32(/* id 106, wireType 2 =*/ 850).fork()
          ).ldelim();
        if (message.messageUpdated != null && message.hasOwnProperty('messageUpdated'))
          $root.propel.commrouter.ConversationEvent.MessageUpdated.encode(
            message.messageUpdated,
            writer.uint32(/* id 107, wireType 2 =*/ 858).fork()
          ).ldelim();
        if (message.sentenceCreated != null && message.hasOwnProperty('sentenceCreated'))
          $root.propel.commrouter.ConversationEvent.SentenceCreated.encode(
            message.sentenceCreated,
            writer.uint32(/* id 108, wireType 2 =*/ 866).fork()
          ).ldelim();
        if (message.sentenceUpdated != null && message.hasOwnProperty('sentenceUpdated'))
          $root.propel.commrouter.ConversationEvent.SentenceUpdated.encode(
            message.sentenceUpdated,
            writer.uint32(/* id 109, wireType 2 =*/ 874).fork()
          ).ldelim();
        if (message.responseCreated != null && message.hasOwnProperty('responseCreated'))
          $root.propel.commrouter.ConversationEvent.ResponseCreated.encode(
            message.responseCreated,
            writer.uint32(/* id 110, wireType 2 =*/ 882).fork()
          ).ldelim();
        if (message.responseUpdated != null && message.hasOwnProperty('responseUpdated'))
          $root.propel.commrouter.ConversationEvent.ResponseUpdated.encode(
            message.responseUpdated,
            writer.uint32(/* id 111, wireType 2 =*/ 890).fork()
          ).ldelim();
        if (
          message.conversationStateUpdated != null &&
          message.hasOwnProperty('conversationStateUpdated')
        )
          $root.propel.commrouter.ConversationEvent.ConversationStateUpdated.encode(
            message.conversationStateUpdated,
            writer.uint32(/* id 112, wireType 2 =*/ 898).fork()
          ).ldelim();
        if (message.contextUpdated != null && message.hasOwnProperty('contextUpdated'))
          $root.propel.commrouter.ConversationEvent.ContextUpdated.encode(
            message.contextUpdated,
            writer.uint32(/* id 113, wireType 2 =*/ 906).fork()
          ).ldelim();
        if (
          message.conversationModeUpdated != null &&
          message.hasOwnProperty('conversationModeUpdated')
        )
          $root.propel.commrouter.ConversationEvent.ConversationModeUpdated.encode(
            message.conversationModeUpdated,
            writer.uint32(/* id 114, wireType 2 =*/ 914).fork()
          ).ldelim();
        if (message.engineStateUpdated != null && message.hasOwnProperty('engineStateUpdated'))
          $root.propel.commrouter.ConversationEvent.EngineStateUpdated.encode(
            message.engineStateUpdated,
            writer.uint32(/* id 115, wireType 2 =*/ 922).fork()
          ).ldelim();
        if (message.channelInfoUpdated != null && message.hasOwnProperty('channelInfoUpdated'))
          $root.propel.commrouter.ConversationEvent.ChannelInfoUpdated.encode(
            message.channelInfoUpdated,
            writer.uint32(/* id 116, wireType 2 =*/ 930).fork()
          ).ldelim();
        if (message.introductionCreated != null && message.hasOwnProperty('introductionCreated'))
          $root.propel.commrouter.ConversationEvent.IntroductionCreated.encode(
            message.introductionCreated,
            writer.uint32(/* id 117, wireType 2 =*/ 938).fork()
          ).ldelim();
        if (message.infoUpdated != null && message.hasOwnProperty('infoUpdated'))
          $root.propel.commrouter.ConversationEvent.InfoUpdated.encode(
            message.infoUpdated,
            writer.uint32(/* id 118, wireType 2 =*/ 946).fork()
          ).ldelim();
        if (message.tagCreated != null && message.hasOwnProperty('tagCreated'))
          $root.propel.commrouter.ConversationEvent.TagCreated.encode(
            message.tagCreated,
            writer.uint32(/* id 119, wireType 2 =*/ 954).fork()
          ).ldelim();
        if (message.jobCreated != null && message.hasOwnProperty('jobCreated'))
          $root.propel.commrouter.ConversationEvent.JobCreated.encode(
            message.jobCreated,
            writer.uint32(/* id 120, wireType 2 =*/ 962).fork()
          ).ldelim();
        if (message.jobUpdated != null && message.hasOwnProperty('jobUpdated'))
          $root.propel.commrouter.ConversationEvent.JobUpdated.encode(
            message.jobUpdated,
            writer.uint32(/* id 121, wireType 2 =*/ 970).fork()
          ).ldelim();
        if (message.jobDeleted != null && message.hasOwnProperty('jobDeleted'))
          $root.propel.commrouter.ConversationEvent.JobDeleted.encode(
            message.jobDeleted,
            writer.uint32(/* id 122, wireType 2 =*/ 978).fork()
          ).ldelim();
        if (
          message.incomingLeadRefCreated != null &&
          message.hasOwnProperty('incomingLeadRefCreated')
        )
          $root.propel.commrouter.ConversationEvent.IncomingLeadRefCreated.encode(
            message.incomingLeadRefCreated,
            writer.uint32(/* id 123, wireType 2 =*/ 986).fork()
          ).ldelim();
        if (message.noteCreated != null && message.hasOwnProperty('noteCreated'))
          $root.propel.commrouter.ConversationEvent.NoteCreated.encode(
            message.noteCreated,
            writer.uint32(/* id 124, wireType 2 =*/ 994).fork()
          ).ldelim();
        if (message.tagDeleted != null && message.hasOwnProperty('tagDeleted'))
          $root.propel.commrouter.ConversationEvent.TagDeleted.encode(
            message.tagDeleted,
            writer.uint32(/* id 125, wireType 2 =*/ 1002).fork()
          ).ldelim();
        return writer;
      };

      /**
       * Encodes the specified ConversationEvent message, length delimited. Does not implicitly {@link propel.commrouter.ConversationEvent.verify|verify} messages.
       * @function encodeDelimited
       * @memberof propel.commrouter.ConversationEvent
       * @static
       * @param {propel.commrouter.IConversationEvent} message ConversationEvent message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      ConversationEvent.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
      };

      /**
       * Decodes a ConversationEvent message from the specified reader or buffer.
       * @function decode
       * @memberof propel.commrouter.ConversationEvent
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @param {number} [length] Message length if known beforehand
       * @returns {propel.commrouter.ConversationEvent} ConversationEvent
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      ConversationEvent.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length,
          message = new $root.propel.commrouter.ConversationEvent();
        while (reader.pos < end) {
          var tag = reader.uint32();
          switch (tag >>> 3) {
            case 1:
              message.id = reader.string();
              break;
            case 2:
              message.conversationId = reader.string();
              break;
            case 3:
              message.commandId = $root.google.protobuf.StringValue.decode(reader, reader.uint32());
              break;
            case 4:
              message.createdAt = reader.uint64();
              break;
            case 100:
              message.conversationCreated =
                $root.propel.commrouter.ConversationEvent.ConversationCreated.decode(
                  reader,
                  reader.uint32()
                );
              break;
            case 101:
              message.conversationUpdated =
                $root.propel.commrouter.ConversationEvent.ConversationUpdated.decode(
                  reader,
                  reader.uint32()
                );
              break;
            case 102:
              message.channelCreated =
                $root.propel.commrouter.ConversationEvent.ChannelCreated.decode(
                  reader,
                  reader.uint32()
                );
              break;
            case 103:
              message.channelUpdated =
                $root.propel.commrouter.ConversationEvent.ChannelUpdated.decode(
                  reader,
                  reader.uint32()
                );
              break;
            case 104:
              message.avatarCreated =
                $root.propel.commrouter.ConversationEvent.AvatarCreated.decode(
                  reader,
                  reader.uint32()
                );
              break;
            case 105:
              message.avatarUpdated =
                $root.propel.commrouter.ConversationEvent.AvatarUpdated.decode(
                  reader,
                  reader.uint32()
                );
              break;
            case 106:
              message.messageCreated =
                $root.propel.commrouter.ConversationEvent.MessageCreated.decode(
                  reader,
                  reader.uint32()
                );
              break;
            case 107:
              message.messageUpdated =
                $root.propel.commrouter.ConversationEvent.MessageUpdated.decode(
                  reader,
                  reader.uint32()
                );
              break;
            case 108:
              message.sentenceCreated =
                $root.propel.commrouter.ConversationEvent.SentenceCreated.decode(
                  reader,
                  reader.uint32()
                );
              break;
            case 109:
              message.sentenceUpdated =
                $root.propel.commrouter.ConversationEvent.SentenceUpdated.decode(
                  reader,
                  reader.uint32()
                );
              break;
            case 110:
              message.responseCreated =
                $root.propel.commrouter.ConversationEvent.ResponseCreated.decode(
                  reader,
                  reader.uint32()
                );
              break;
            case 111:
              message.responseUpdated =
                $root.propel.commrouter.ConversationEvent.ResponseUpdated.decode(
                  reader,
                  reader.uint32()
                );
              break;
            case 112:
              message.conversationStateUpdated =
                $root.propel.commrouter.ConversationEvent.ConversationStateUpdated.decode(
                  reader,
                  reader.uint32()
                );
              break;
            case 113:
              message.contextUpdated =
                $root.propel.commrouter.ConversationEvent.ContextUpdated.decode(
                  reader,
                  reader.uint32()
                );
              break;
            case 114:
              message.conversationModeUpdated =
                $root.propel.commrouter.ConversationEvent.ConversationModeUpdated.decode(
                  reader,
                  reader.uint32()
                );
              break;
            case 115:
              message.engineStateUpdated =
                $root.propel.commrouter.ConversationEvent.EngineStateUpdated.decode(
                  reader,
                  reader.uint32()
                );
              break;
            case 116:
              message.channelInfoUpdated =
                $root.propel.commrouter.ConversationEvent.ChannelInfoUpdated.decode(
                  reader,
                  reader.uint32()
                );
              break;
            case 117:
              message.introductionCreated =
                $root.propel.commrouter.ConversationEvent.IntroductionCreated.decode(
                  reader,
                  reader.uint32()
                );
              break;
            case 118:
              message.infoUpdated = $root.propel.commrouter.ConversationEvent.InfoUpdated.decode(
                reader,
                reader.uint32()
              );
              break;
            case 119:
              message.tagCreated = $root.propel.commrouter.ConversationEvent.TagCreated.decode(
                reader,
                reader.uint32()
              );
              break;
            case 125:
              message.tagDeleted = $root.propel.commrouter.ConversationEvent.TagDeleted.decode(
                reader,
                reader.uint32()
              );
              break;
            case 120:
              message.jobCreated = $root.propel.commrouter.ConversationEvent.JobCreated.decode(
                reader,
                reader.uint32()
              );
              break;
            case 121:
              message.jobUpdated = $root.propel.commrouter.ConversationEvent.JobUpdated.decode(
                reader,
                reader.uint32()
              );
              break;
            case 122:
              message.jobDeleted = $root.propel.commrouter.ConversationEvent.JobDeleted.decode(
                reader,
                reader.uint32()
              );
              break;
            case 123:
              message.incomingLeadRefCreated =
                $root.propel.commrouter.ConversationEvent.IncomingLeadRefCreated.decode(
                  reader,
                  reader.uint32()
                );
              break;
            case 124:
              message.noteCreated = $root.propel.commrouter.ConversationEvent.NoteCreated.decode(
                reader,
                reader.uint32()
              );
              break;
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };

      /**
       * Decodes a ConversationEvent message from the specified reader or buffer, length delimited.
       * @function decodeDelimited
       * @memberof propel.commrouter.ConversationEvent
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @returns {propel.commrouter.ConversationEvent} ConversationEvent
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      ConversationEvent.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader)) reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
      };

      /**
       * Verifies a ConversationEvent message.
       * @function verify
       * @memberof propel.commrouter.ConversationEvent
       * @static
       * @param {Object.<string,*>} message Plain object to verify
       * @returns {string|null} `null` if valid, otherwise the reason why it is not
       */
      ConversationEvent.verify = function verify(message) {
        if (typeof message !== 'object' || message === null) return 'object expected';
        var properties = {};
        if (message.id != null && message.hasOwnProperty('id'))
          if (!$util.isString(message.id)) return 'id: string expected';
        if (message.conversationId != null && message.hasOwnProperty('conversationId'))
          if (!$util.isString(message.conversationId)) return 'conversationId: string expected';
        if (message.commandId != null && message.hasOwnProperty('commandId')) {
          var error = $root.google.protobuf.StringValue.verify(message.commandId);
          if (error) return 'commandId.' + error;
        }
        if (message.createdAt != null && message.hasOwnProperty('createdAt'))
          if (
            !$util.isInteger(message.createdAt) &&
            !(
              message.createdAt &&
              $util.isInteger(message.createdAt.low) &&
              $util.isInteger(message.createdAt.high)
            )
          )
            return 'createdAt: integer|Long expected';
        if (message.conversationCreated != null && message.hasOwnProperty('conversationCreated')) {
          properties.event = 1;
          {
            var error = $root.propel.commrouter.ConversationEvent.ConversationCreated.verify(
              message.conversationCreated
            );
            if (error) return 'conversationCreated.' + error;
          }
        }
        if (message.conversationUpdated != null && message.hasOwnProperty('conversationUpdated')) {
          if (properties.event === 1) return 'event: multiple values';
          properties.event = 1;
          {
            var error = $root.propel.commrouter.ConversationEvent.ConversationUpdated.verify(
              message.conversationUpdated
            );
            if (error) return 'conversationUpdated.' + error;
          }
        }
        if (message.channelCreated != null && message.hasOwnProperty('channelCreated')) {
          if (properties.event === 1) return 'event: multiple values';
          properties.event = 1;
          {
            var error = $root.propel.commrouter.ConversationEvent.ChannelCreated.verify(
              message.channelCreated
            );
            if (error) return 'channelCreated.' + error;
          }
        }
        if (message.channelUpdated != null && message.hasOwnProperty('channelUpdated')) {
          if (properties.event === 1) return 'event: multiple values';
          properties.event = 1;
          {
            var error = $root.propel.commrouter.ConversationEvent.ChannelUpdated.verify(
              message.channelUpdated
            );
            if (error) return 'channelUpdated.' + error;
          }
        }
        if (message.avatarCreated != null && message.hasOwnProperty('avatarCreated')) {
          if (properties.event === 1) return 'event: multiple values';
          properties.event = 1;
          {
            var error = $root.propel.commrouter.ConversationEvent.AvatarCreated.verify(
              message.avatarCreated
            );
            if (error) return 'avatarCreated.' + error;
          }
        }
        if (message.avatarUpdated != null && message.hasOwnProperty('avatarUpdated')) {
          if (properties.event === 1) return 'event: multiple values';
          properties.event = 1;
          {
            var error = $root.propel.commrouter.ConversationEvent.AvatarUpdated.verify(
              message.avatarUpdated
            );
            if (error) return 'avatarUpdated.' + error;
          }
        }
        if (message.messageCreated != null && message.hasOwnProperty('messageCreated')) {
          if (properties.event === 1) return 'event: multiple values';
          properties.event = 1;
          {
            var error = $root.propel.commrouter.ConversationEvent.MessageCreated.verify(
              message.messageCreated
            );
            if (error) return 'messageCreated.' + error;
          }
        }
        if (message.messageUpdated != null && message.hasOwnProperty('messageUpdated')) {
          if (properties.event === 1) return 'event: multiple values';
          properties.event = 1;
          {
            var error = $root.propel.commrouter.ConversationEvent.MessageUpdated.verify(
              message.messageUpdated
            );
            if (error) return 'messageUpdated.' + error;
          }
        }
        if (message.sentenceCreated != null && message.hasOwnProperty('sentenceCreated')) {
          if (properties.event === 1) return 'event: multiple values';
          properties.event = 1;
          {
            var error = $root.propel.commrouter.ConversationEvent.SentenceCreated.verify(
              message.sentenceCreated
            );
            if (error) return 'sentenceCreated.' + error;
          }
        }
        if (message.sentenceUpdated != null && message.hasOwnProperty('sentenceUpdated')) {
          if (properties.event === 1) return 'event: multiple values';
          properties.event = 1;
          {
            var error = $root.propel.commrouter.ConversationEvent.SentenceUpdated.verify(
              message.sentenceUpdated
            );
            if (error) return 'sentenceUpdated.' + error;
          }
        }
        if (message.responseCreated != null && message.hasOwnProperty('responseCreated')) {
          if (properties.event === 1) return 'event: multiple values';
          properties.event = 1;
          {
            var error = $root.propel.commrouter.ConversationEvent.ResponseCreated.verify(
              message.responseCreated
            );
            if (error) return 'responseCreated.' + error;
          }
        }
        if (message.responseUpdated != null && message.hasOwnProperty('responseUpdated')) {
          if (properties.event === 1) return 'event: multiple values';
          properties.event = 1;
          {
            var error = $root.propel.commrouter.ConversationEvent.ResponseUpdated.verify(
              message.responseUpdated
            );
            if (error) return 'responseUpdated.' + error;
          }
        }
        if (
          message.conversationStateUpdated != null &&
          message.hasOwnProperty('conversationStateUpdated')
        ) {
          if (properties.event === 1) return 'event: multiple values';
          properties.event = 1;
          {
            var error = $root.propel.commrouter.ConversationEvent.ConversationStateUpdated.verify(
              message.conversationStateUpdated
            );
            if (error) return 'conversationStateUpdated.' + error;
          }
        }
        if (message.contextUpdated != null && message.hasOwnProperty('contextUpdated')) {
          if (properties.event === 1) return 'event: multiple values';
          properties.event = 1;
          {
            var error = $root.propel.commrouter.ConversationEvent.ContextUpdated.verify(
              message.contextUpdated
            );
            if (error) return 'contextUpdated.' + error;
          }
        }
        if (
          message.conversationModeUpdated != null &&
          message.hasOwnProperty('conversationModeUpdated')
        ) {
          if (properties.event === 1) return 'event: multiple values';
          properties.event = 1;
          {
            var error = $root.propel.commrouter.ConversationEvent.ConversationModeUpdated.verify(
              message.conversationModeUpdated
            );
            if (error) return 'conversationModeUpdated.' + error;
          }
        }
        if (message.engineStateUpdated != null && message.hasOwnProperty('engineStateUpdated')) {
          if (properties.event === 1) return 'event: multiple values';
          properties.event = 1;
          {
            var error = $root.propel.commrouter.ConversationEvent.EngineStateUpdated.verify(
              message.engineStateUpdated
            );
            if (error) return 'engineStateUpdated.' + error;
          }
        }
        if (message.channelInfoUpdated != null && message.hasOwnProperty('channelInfoUpdated')) {
          if (properties.event === 1) return 'event: multiple values';
          properties.event = 1;
          {
            var error = $root.propel.commrouter.ConversationEvent.ChannelInfoUpdated.verify(
              message.channelInfoUpdated
            );
            if (error) return 'channelInfoUpdated.' + error;
          }
        }
        if (message.introductionCreated != null && message.hasOwnProperty('introductionCreated')) {
          if (properties.event === 1) return 'event: multiple values';
          properties.event = 1;
          {
            var error = $root.propel.commrouter.ConversationEvent.IntroductionCreated.verify(
              message.introductionCreated
            );
            if (error) return 'introductionCreated.' + error;
          }
        }
        if (message.infoUpdated != null && message.hasOwnProperty('infoUpdated')) {
          if (properties.event === 1) return 'event: multiple values';
          properties.event = 1;
          {
            var error = $root.propel.commrouter.ConversationEvent.InfoUpdated.verify(
              message.infoUpdated
            );
            if (error) return 'infoUpdated.' + error;
          }
        }
        if (message.tagCreated != null && message.hasOwnProperty('tagCreated')) {
          if (properties.event === 1) return 'event: multiple values';
          properties.event = 1;
          {
            var error = $root.propel.commrouter.ConversationEvent.TagCreated.verify(
              message.tagCreated
            );
            if (error) return 'tagCreated.' + error;
          }
        }
        if (message.tagDeleted != null && message.hasOwnProperty('tagDeleted')) {
          if (properties.event === 1) return 'event: multiple values';
          properties.event = 1;
          {
            var error = $root.propel.commrouter.ConversationEvent.TagDeleted.verify(
              message.tagDeleted
            );
            if (error) return 'tagDeleted.' + error;
          }
        }
        if (message.jobCreated != null && message.hasOwnProperty('jobCreated')) {
          if (properties.event === 1) return 'event: multiple values';
          properties.event = 1;
          {
            var error = $root.propel.commrouter.ConversationEvent.JobCreated.verify(
              message.jobCreated
            );
            if (error) return 'jobCreated.' + error;
          }
        }
        if (message.jobUpdated != null && message.hasOwnProperty('jobUpdated')) {
          if (properties.event === 1) return 'event: multiple values';
          properties.event = 1;
          {
            var error = $root.propel.commrouter.ConversationEvent.JobUpdated.verify(
              message.jobUpdated
            );
            if (error) return 'jobUpdated.' + error;
          }
        }
        if (message.jobDeleted != null && message.hasOwnProperty('jobDeleted')) {
          if (properties.event === 1) return 'event: multiple values';
          properties.event = 1;
          {
            var error = $root.propel.commrouter.ConversationEvent.JobDeleted.verify(
              message.jobDeleted
            );
            if (error) return 'jobDeleted.' + error;
          }
        }
        if (
          message.incomingLeadRefCreated != null &&
          message.hasOwnProperty('incomingLeadRefCreated')
        ) {
          if (properties.event === 1) return 'event: multiple values';
          properties.event = 1;
          {
            var error = $root.propel.commrouter.ConversationEvent.IncomingLeadRefCreated.verify(
              message.incomingLeadRefCreated
            );
            if (error) return 'incomingLeadRefCreated.' + error;
          }
        }
        if (message.noteCreated != null && message.hasOwnProperty('noteCreated')) {
          if (properties.event === 1) return 'event: multiple values';
          properties.event = 1;
          {
            var error = $root.propel.commrouter.ConversationEvent.NoteCreated.verify(
              message.noteCreated
            );
            if (error) return 'noteCreated.' + error;
          }
        }
        return null;
      };

      /**
       * Creates a ConversationEvent message from a plain object. Also converts values to their respective internal types.
       * @function fromObject
       * @memberof propel.commrouter.ConversationEvent
       * @static
       * @param {Object.<string,*>} object Plain object
       * @returns {propel.commrouter.ConversationEvent} ConversationEvent
       */
      ConversationEvent.fromObject = function fromObject(object) {
        if (object instanceof $root.propel.commrouter.ConversationEvent) return object;
        var message = new $root.propel.commrouter.ConversationEvent();
        if (object.id != null) message.id = String(object.id);
        if (object.conversationId != null) message.conversationId = String(object.conversationId);
        if (object.commandId != null) {
          if (typeof object.commandId !== 'object')
            throw TypeError('.propel.commrouter.ConversationEvent.commandId: object expected');
          message.commandId = $root.google.protobuf.StringValue.fromObject(object.commandId);
        }
        if (object.createdAt != null)
          if ($util.Long)
            (message.createdAt = $util.Long.fromValue(object.createdAt)).unsigned = true;
          else if (typeof object.createdAt === 'string')
            message.createdAt = parseInt(object.createdAt, 10);
          else if (typeof object.createdAt === 'number') message.createdAt = object.createdAt;
          else if (typeof object.createdAt === 'object')
            message.createdAt = new $util.LongBits(
              object.createdAt.low >>> 0,
              object.createdAt.high >>> 0
            ).toNumber(true);
        if (object.conversationCreated != null) {
          if (typeof object.conversationCreated !== 'object')
            throw TypeError(
              '.propel.commrouter.ConversationEvent.conversationCreated: object expected'
            );
          message.conversationCreated =
            $root.propel.commrouter.ConversationEvent.ConversationCreated.fromObject(
              object.conversationCreated
            );
        }
        if (object.conversationUpdated != null) {
          if (typeof object.conversationUpdated !== 'object')
            throw TypeError(
              '.propel.commrouter.ConversationEvent.conversationUpdated: object expected'
            );
          message.conversationUpdated =
            $root.propel.commrouter.ConversationEvent.ConversationUpdated.fromObject(
              object.conversationUpdated
            );
        }
        if (object.channelCreated != null) {
          if (typeof object.channelCreated !== 'object')
            throw TypeError('.propel.commrouter.ConversationEvent.channelCreated: object expected');
          message.channelCreated =
            $root.propel.commrouter.ConversationEvent.ChannelCreated.fromObject(
              object.channelCreated
            );
        }
        if (object.channelUpdated != null) {
          if (typeof object.channelUpdated !== 'object')
            throw TypeError('.propel.commrouter.ConversationEvent.channelUpdated: object expected');
          message.channelUpdated =
            $root.propel.commrouter.ConversationEvent.ChannelUpdated.fromObject(
              object.channelUpdated
            );
        }
        if (object.avatarCreated != null) {
          if (typeof object.avatarCreated !== 'object')
            throw TypeError('.propel.commrouter.ConversationEvent.avatarCreated: object expected');
          message.avatarCreated =
            $root.propel.commrouter.ConversationEvent.AvatarCreated.fromObject(
              object.avatarCreated
            );
        }
        if (object.avatarUpdated != null) {
          if (typeof object.avatarUpdated !== 'object')
            throw TypeError('.propel.commrouter.ConversationEvent.avatarUpdated: object expected');
          message.avatarUpdated =
            $root.propel.commrouter.ConversationEvent.AvatarUpdated.fromObject(
              object.avatarUpdated
            );
        }
        if (object.messageCreated != null) {
          if (typeof object.messageCreated !== 'object')
            throw TypeError('.propel.commrouter.ConversationEvent.messageCreated: object expected');
          message.messageCreated =
            $root.propel.commrouter.ConversationEvent.MessageCreated.fromObject(
              object.messageCreated
            );
        }
        if (object.messageUpdated != null) {
          if (typeof object.messageUpdated !== 'object')
            throw TypeError('.propel.commrouter.ConversationEvent.messageUpdated: object expected');
          message.messageUpdated =
            $root.propel.commrouter.ConversationEvent.MessageUpdated.fromObject(
              object.messageUpdated
            );
        }
        if (object.sentenceCreated != null) {
          if (typeof object.sentenceCreated !== 'object')
            throw TypeError(
              '.propel.commrouter.ConversationEvent.sentenceCreated: object expected'
            );
          message.sentenceCreated =
            $root.propel.commrouter.ConversationEvent.SentenceCreated.fromObject(
              object.sentenceCreated
            );
        }
        if (object.sentenceUpdated != null) {
          if (typeof object.sentenceUpdated !== 'object')
            throw TypeError(
              '.propel.commrouter.ConversationEvent.sentenceUpdated: object expected'
            );
          message.sentenceUpdated =
            $root.propel.commrouter.ConversationEvent.SentenceUpdated.fromObject(
              object.sentenceUpdated
            );
        }
        if (object.responseCreated != null) {
          if (typeof object.responseCreated !== 'object')
            throw TypeError(
              '.propel.commrouter.ConversationEvent.responseCreated: object expected'
            );
          message.responseCreated =
            $root.propel.commrouter.ConversationEvent.ResponseCreated.fromObject(
              object.responseCreated
            );
        }
        if (object.responseUpdated != null) {
          if (typeof object.responseUpdated !== 'object')
            throw TypeError(
              '.propel.commrouter.ConversationEvent.responseUpdated: object expected'
            );
          message.responseUpdated =
            $root.propel.commrouter.ConversationEvent.ResponseUpdated.fromObject(
              object.responseUpdated
            );
        }
        if (object.conversationStateUpdated != null) {
          if (typeof object.conversationStateUpdated !== 'object')
            throw TypeError(
              '.propel.commrouter.ConversationEvent.conversationStateUpdated: object expected'
            );
          message.conversationStateUpdated =
            $root.propel.commrouter.ConversationEvent.ConversationStateUpdated.fromObject(
              object.conversationStateUpdated
            );
        }
        if (object.contextUpdated != null) {
          if (typeof object.contextUpdated !== 'object')
            throw TypeError('.propel.commrouter.ConversationEvent.contextUpdated: object expected');
          message.contextUpdated =
            $root.propel.commrouter.ConversationEvent.ContextUpdated.fromObject(
              object.contextUpdated
            );
        }
        if (object.conversationModeUpdated != null) {
          if (typeof object.conversationModeUpdated !== 'object')
            throw TypeError(
              '.propel.commrouter.ConversationEvent.conversationModeUpdated: object expected'
            );
          message.conversationModeUpdated =
            $root.propel.commrouter.ConversationEvent.ConversationModeUpdated.fromObject(
              object.conversationModeUpdated
            );
        }
        if (object.engineStateUpdated != null) {
          if (typeof object.engineStateUpdated !== 'object')
            throw TypeError(
              '.propel.commrouter.ConversationEvent.engineStateUpdated: object expected'
            );
          message.engineStateUpdated =
            $root.propel.commrouter.ConversationEvent.EngineStateUpdated.fromObject(
              object.engineStateUpdated
            );
        }
        if (object.channelInfoUpdated != null) {
          if (typeof object.channelInfoUpdated !== 'object')
            throw TypeError(
              '.propel.commrouter.ConversationEvent.channelInfoUpdated: object expected'
            );
          message.channelInfoUpdated =
            $root.propel.commrouter.ConversationEvent.ChannelInfoUpdated.fromObject(
              object.channelInfoUpdated
            );
        }
        if (object.introductionCreated != null) {
          if (typeof object.introductionCreated !== 'object')
            throw TypeError(
              '.propel.commrouter.ConversationEvent.introductionCreated: object expected'
            );
          message.introductionCreated =
            $root.propel.commrouter.ConversationEvent.IntroductionCreated.fromObject(
              object.introductionCreated
            );
        }
        if (object.infoUpdated != null) {
          if (typeof object.infoUpdated !== 'object')
            throw TypeError('.propel.commrouter.ConversationEvent.infoUpdated: object expected');
          message.infoUpdated = $root.propel.commrouter.ConversationEvent.InfoUpdated.fromObject(
            object.infoUpdated
          );
        }
        if (object.tagCreated != null) {
          if (typeof object.tagCreated !== 'object')
            throw TypeError('.propel.commrouter.ConversationEvent.tagCreated: object expected');
          message.tagCreated = $root.propel.commrouter.ConversationEvent.TagCreated.fromObject(
            object.tagCreated
          );
        }
        if (object.tagDeleted != null) {
          if (typeof object.tagDeleted !== 'object')
            throw TypeError('.propel.commrouter.ConversationEvent.tagDeleted: object expected');
          message.tagDeleted = $root.propel.commrouter.ConversationEvent.TagDeleted.fromObject(
            object.tagDeleted
          );
        }
        if (object.jobCreated != null) {
          if (typeof object.jobCreated !== 'object')
            throw TypeError('.propel.commrouter.ConversationEvent.jobCreated: object expected');
          message.jobCreated = $root.propel.commrouter.ConversationEvent.JobCreated.fromObject(
            object.jobCreated
          );
        }
        if (object.jobUpdated != null) {
          if (typeof object.jobUpdated !== 'object')
            throw TypeError('.propel.commrouter.ConversationEvent.jobUpdated: object expected');
          message.jobUpdated = $root.propel.commrouter.ConversationEvent.JobUpdated.fromObject(
            object.jobUpdated
          );
        }
        if (object.jobDeleted != null) {
          if (typeof object.jobDeleted !== 'object')
            throw TypeError('.propel.commrouter.ConversationEvent.jobDeleted: object expected');
          message.jobDeleted = $root.propel.commrouter.ConversationEvent.JobDeleted.fromObject(
            object.jobDeleted
          );
        }
        if (object.incomingLeadRefCreated != null) {
          if (typeof object.incomingLeadRefCreated !== 'object')
            throw TypeError(
              '.propel.commrouter.ConversationEvent.incomingLeadRefCreated: object expected'
            );
          message.incomingLeadRefCreated =
            $root.propel.commrouter.ConversationEvent.IncomingLeadRefCreated.fromObject(
              object.incomingLeadRefCreated
            );
        }
        if (object.noteCreated != null) {
          if (typeof object.noteCreated !== 'object')
            throw TypeError('.propel.commrouter.ConversationEvent.noteCreated: object expected');
          message.noteCreated = $root.propel.commrouter.ConversationEvent.NoteCreated.fromObject(
            object.noteCreated
          );
        }
        return message;
      };

      /**
       * Creates a plain object from a ConversationEvent message. Also converts values to other types if specified.
       * @function toObject
       * @memberof propel.commrouter.ConversationEvent
       * @static
       * @param {propel.commrouter.ConversationEvent} message ConversationEvent
       * @param {$protobuf.IConversionOptions} [options] Conversion options
       * @returns {Object.<string,*>} Plain object
       */
      ConversationEvent.toObject = function toObject(message, options) {
        if (!options) options = {};
        var object = {};
        if (options.defaults) {
          object.id = '';
          object.conversationId = '';
          object.commandId = null;
          if ($util.Long) {
            var long = new $util.Long(0, 0, true);
            object.createdAt =
              options.longs === String
                ? long.toString()
                : options.longs === Number
                ? long.toNumber()
                : long;
          } else object.createdAt = options.longs === String ? '0' : 0;
        }
        if (message.id != null && message.hasOwnProperty('id')) object.id = message.id;
        if (message.conversationId != null && message.hasOwnProperty('conversationId'))
          object.conversationId = message.conversationId;
        if (message.commandId != null && message.hasOwnProperty('commandId'))
          object.commandId = $root.google.protobuf.StringValue.toObject(message.commandId, options);
        if (message.createdAt != null && message.hasOwnProperty('createdAt'))
          if (typeof message.createdAt === 'number')
            object.createdAt =
              options.longs === String ? String(message.createdAt) : message.createdAt;
          else
            object.createdAt =
              options.longs === String
                ? $util.Long.prototype.toString.call(message.createdAt)
                : options.longs === Number
                ? new $util.LongBits(
                    message.createdAt.low >>> 0,
                    message.createdAt.high >>> 0
                  ).toNumber(true)
                : message.createdAt;
        if (message.conversationCreated != null && message.hasOwnProperty('conversationCreated')) {
          object.conversationCreated =
            $root.propel.commrouter.ConversationEvent.ConversationCreated.toObject(
              message.conversationCreated,
              options
            );
          if (options.oneofs) object.event = 'conversationCreated';
        }
        if (message.conversationUpdated != null && message.hasOwnProperty('conversationUpdated')) {
          object.conversationUpdated =
            $root.propel.commrouter.ConversationEvent.ConversationUpdated.toObject(
              message.conversationUpdated,
              options
            );
          if (options.oneofs) object.event = 'conversationUpdated';
        }
        if (message.channelCreated != null && message.hasOwnProperty('channelCreated')) {
          object.channelCreated = $root.propel.commrouter.ConversationEvent.ChannelCreated.toObject(
            message.channelCreated,
            options
          );
          if (options.oneofs) object.event = 'channelCreated';
        }
        if (message.channelUpdated != null && message.hasOwnProperty('channelUpdated')) {
          object.channelUpdated = $root.propel.commrouter.ConversationEvent.ChannelUpdated.toObject(
            message.channelUpdated,
            options
          );
          if (options.oneofs) object.event = 'channelUpdated';
        }
        if (message.avatarCreated != null && message.hasOwnProperty('avatarCreated')) {
          object.avatarCreated = $root.propel.commrouter.ConversationEvent.AvatarCreated.toObject(
            message.avatarCreated,
            options
          );
          if (options.oneofs) object.event = 'avatarCreated';
        }
        if (message.avatarUpdated != null && message.hasOwnProperty('avatarUpdated')) {
          object.avatarUpdated = $root.propel.commrouter.ConversationEvent.AvatarUpdated.toObject(
            message.avatarUpdated,
            options
          );
          if (options.oneofs) object.event = 'avatarUpdated';
        }
        if (message.messageCreated != null && message.hasOwnProperty('messageCreated')) {
          object.messageCreated = $root.propel.commrouter.ConversationEvent.MessageCreated.toObject(
            message.messageCreated,
            options
          );
          if (options.oneofs) object.event = 'messageCreated';
        }
        if (message.messageUpdated != null && message.hasOwnProperty('messageUpdated')) {
          object.messageUpdated = $root.propel.commrouter.ConversationEvent.MessageUpdated.toObject(
            message.messageUpdated,
            options
          );
          if (options.oneofs) object.event = 'messageUpdated';
        }
        if (message.sentenceCreated != null && message.hasOwnProperty('sentenceCreated')) {
          object.sentenceCreated =
            $root.propel.commrouter.ConversationEvent.SentenceCreated.toObject(
              message.sentenceCreated,
              options
            );
          if (options.oneofs) object.event = 'sentenceCreated';
        }
        if (message.sentenceUpdated != null && message.hasOwnProperty('sentenceUpdated')) {
          object.sentenceUpdated =
            $root.propel.commrouter.ConversationEvent.SentenceUpdated.toObject(
              message.sentenceUpdated,
              options
            );
          if (options.oneofs) object.event = 'sentenceUpdated';
        }
        if (message.responseCreated != null && message.hasOwnProperty('responseCreated')) {
          object.responseCreated =
            $root.propel.commrouter.ConversationEvent.ResponseCreated.toObject(
              message.responseCreated,
              options
            );
          if (options.oneofs) object.event = 'responseCreated';
        }
        if (message.responseUpdated != null && message.hasOwnProperty('responseUpdated')) {
          object.responseUpdated =
            $root.propel.commrouter.ConversationEvent.ResponseUpdated.toObject(
              message.responseUpdated,
              options
            );
          if (options.oneofs) object.event = 'responseUpdated';
        }
        if (
          message.conversationStateUpdated != null &&
          message.hasOwnProperty('conversationStateUpdated')
        ) {
          object.conversationStateUpdated =
            $root.propel.commrouter.ConversationEvent.ConversationStateUpdated.toObject(
              message.conversationStateUpdated,
              options
            );
          if (options.oneofs) object.event = 'conversationStateUpdated';
        }
        if (message.contextUpdated != null && message.hasOwnProperty('contextUpdated')) {
          object.contextUpdated = $root.propel.commrouter.ConversationEvent.ContextUpdated.toObject(
            message.contextUpdated,
            options
          );
          if (options.oneofs) object.event = 'contextUpdated';
        }
        if (
          message.conversationModeUpdated != null &&
          message.hasOwnProperty('conversationModeUpdated')
        ) {
          object.conversationModeUpdated =
            $root.propel.commrouter.ConversationEvent.ConversationModeUpdated.toObject(
              message.conversationModeUpdated,
              options
            );
          if (options.oneofs) object.event = 'conversationModeUpdated';
        }
        if (message.engineStateUpdated != null && message.hasOwnProperty('engineStateUpdated')) {
          object.engineStateUpdated =
            $root.propel.commrouter.ConversationEvent.EngineStateUpdated.toObject(
              message.engineStateUpdated,
              options
            );
          if (options.oneofs) object.event = 'engineStateUpdated';
        }
        if (message.channelInfoUpdated != null && message.hasOwnProperty('channelInfoUpdated')) {
          object.channelInfoUpdated =
            $root.propel.commrouter.ConversationEvent.ChannelInfoUpdated.toObject(
              message.channelInfoUpdated,
              options
            );
          if (options.oneofs) object.event = 'channelInfoUpdated';
        }
        if (message.introductionCreated != null && message.hasOwnProperty('introductionCreated')) {
          object.introductionCreated =
            $root.propel.commrouter.ConversationEvent.IntroductionCreated.toObject(
              message.introductionCreated,
              options
            );
          if (options.oneofs) object.event = 'introductionCreated';
        }
        if (message.infoUpdated != null && message.hasOwnProperty('infoUpdated')) {
          object.infoUpdated = $root.propel.commrouter.ConversationEvent.InfoUpdated.toObject(
            message.infoUpdated,
            options
          );
          if (options.oneofs) object.event = 'infoUpdated';
        }
        if (message.tagCreated != null && message.hasOwnProperty('tagCreated')) {
          object.tagCreated = $root.propel.commrouter.ConversationEvent.TagCreated.toObject(
            message.tagCreated,
            options
          );
          if (options.oneofs) object.event = 'tagCreated';
        }
        if (message.jobCreated != null && message.hasOwnProperty('jobCreated')) {
          object.jobCreated = $root.propel.commrouter.ConversationEvent.JobCreated.toObject(
            message.jobCreated,
            options
          );
          if (options.oneofs) object.event = 'jobCreated';
        }
        if (message.jobUpdated != null && message.hasOwnProperty('jobUpdated')) {
          object.jobUpdated = $root.propel.commrouter.ConversationEvent.JobUpdated.toObject(
            message.jobUpdated,
            options
          );
          if (options.oneofs) object.event = 'jobUpdated';
        }
        if (message.jobDeleted != null && message.hasOwnProperty('jobDeleted')) {
          object.jobDeleted = $root.propel.commrouter.ConversationEvent.JobDeleted.toObject(
            message.jobDeleted,
            options
          );
          if (options.oneofs) object.event = 'jobDeleted';
        }
        if (
          message.incomingLeadRefCreated != null &&
          message.hasOwnProperty('incomingLeadRefCreated')
        ) {
          object.incomingLeadRefCreated =
            $root.propel.commrouter.ConversationEvent.IncomingLeadRefCreated.toObject(
              message.incomingLeadRefCreated,
              options
            );
          if (options.oneofs) object.event = 'incomingLeadRefCreated';
        }
        if (message.noteCreated != null && message.hasOwnProperty('noteCreated')) {
          object.noteCreated = $root.propel.commrouter.ConversationEvent.NoteCreated.toObject(
            message.noteCreated,
            options
          );
          if (options.oneofs) object.event = 'noteCreated';
        }
        if (message.tagDeleted != null && message.hasOwnProperty('tagDeleted')) {
          object.tagDeleted = $root.propel.commrouter.ConversationEvent.TagDeleted.toObject(
            message.tagDeleted,
            options
          );
          if (options.oneofs) object.event = 'tagDeleted';
        }
        return object;
      };

      /**
       * Converts this ConversationEvent to JSON.
       * @function toJSON
       * @memberof propel.commrouter.ConversationEvent
       * @instance
       * @returns {Object.<string,*>} JSON object
       */
      ConversationEvent.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
      };

      ConversationEvent.ConversationCreated = (function () {
        /**
         * Properties of a ConversationCreated.
         * @memberof propel.commrouter.ConversationEvent
         * @interface IConversationCreated
         * @property {propel.commrouter.IConversation|null} [conversation] ConversationCreated conversation
         */

        /**
         * Constructs a new ConversationCreated.
         * @memberof propel.commrouter.ConversationEvent
         * @classdesc Represents a ConversationCreated.
         * @implements IConversationCreated
         * @constructor
         * @param {propel.commrouter.ConversationEvent.IConversationCreated=} [properties] Properties to set
         */
        function ConversationCreated(properties) {
          if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
              if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
        }

        /**
         * ConversationCreated conversation.
         * @member {propel.commrouter.IConversation|null|undefined} conversation
         * @memberof propel.commrouter.ConversationEvent.ConversationCreated
         * @instance
         */
        ConversationCreated.prototype.conversation = null;

        /**
         * Creates a new ConversationCreated instance using the specified properties.
         * @function create
         * @memberof propel.commrouter.ConversationEvent.ConversationCreated
         * @static
         * @param {propel.commrouter.ConversationEvent.IConversationCreated=} [properties] Properties to set
         * @returns {propel.commrouter.ConversationEvent.ConversationCreated} ConversationCreated instance
         */
        ConversationCreated.create = function create(properties) {
          return new ConversationCreated(properties);
        };

        /**
         * Encodes the specified ConversationCreated message. Does not implicitly {@link propel.commrouter.ConversationEvent.ConversationCreated.verify|verify} messages.
         * @function encode
         * @memberof propel.commrouter.ConversationEvent.ConversationCreated
         * @static
         * @param {propel.commrouter.ConversationEvent.IConversationCreated} message ConversationCreated message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ConversationCreated.encode = function encode(message, writer) {
          if (!writer) writer = $Writer.create();
          if (message.conversation != null && message.hasOwnProperty('conversation'))
            $root.propel.commrouter.Conversation.encode(
              message.conversation,
              writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
            ).ldelim();
          return writer;
        };

        /**
         * Encodes the specified ConversationCreated message, length delimited. Does not implicitly {@link propel.commrouter.ConversationEvent.ConversationCreated.verify|verify} messages.
         * @function encodeDelimited
         * @memberof propel.commrouter.ConversationEvent.ConversationCreated
         * @static
         * @param {propel.commrouter.ConversationEvent.IConversationCreated} message ConversationCreated message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ConversationCreated.encodeDelimited = function encodeDelimited(message, writer) {
          return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a ConversationCreated message from the specified reader or buffer.
         * @function decode
         * @memberof propel.commrouter.ConversationEvent.ConversationCreated
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {propel.commrouter.ConversationEvent.ConversationCreated} ConversationCreated
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ConversationCreated.decode = function decode(reader, length) {
          if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
          var end = length === undefined ? reader.len : reader.pos + length,
            message = new $root.propel.commrouter.ConversationEvent.ConversationCreated();
          while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
              case 1:
                message.conversation = $root.propel.commrouter.Conversation.decode(
                  reader,
                  reader.uint32()
                );
                break;
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };

        /**
         * Decodes a ConversationCreated message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof propel.commrouter.ConversationEvent.ConversationCreated
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {propel.commrouter.ConversationEvent.ConversationCreated} ConversationCreated
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ConversationCreated.decodeDelimited = function decodeDelimited(reader) {
          if (!(reader instanceof $Reader)) reader = new $Reader(reader);
          return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ConversationCreated message.
         * @function verify
         * @memberof propel.commrouter.ConversationEvent.ConversationCreated
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ConversationCreated.verify = function verify(message) {
          if (typeof message !== 'object' || message === null) return 'object expected';
          if (message.conversation != null && message.hasOwnProperty('conversation')) {
            var error = $root.propel.commrouter.Conversation.verify(message.conversation);
            if (error) return 'conversation.' + error;
          }
          return null;
        };

        /**
         * Creates a ConversationCreated message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof propel.commrouter.ConversationEvent.ConversationCreated
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {propel.commrouter.ConversationEvent.ConversationCreated} ConversationCreated
         */
        ConversationCreated.fromObject = function fromObject(object) {
          if (object instanceof $root.propel.commrouter.ConversationEvent.ConversationCreated)
            return object;
          var message = new $root.propel.commrouter.ConversationEvent.ConversationCreated();
          if (object.conversation != null) {
            if (typeof object.conversation !== 'object')
              throw TypeError(
                '.propel.commrouter.ConversationEvent.ConversationCreated.conversation: object expected'
              );
            message.conversation = $root.propel.commrouter.Conversation.fromObject(
              object.conversation
            );
          }
          return message;
        };

        /**
         * Creates a plain object from a ConversationCreated message. Also converts values to other types if specified.
         * @function toObject
         * @memberof propel.commrouter.ConversationEvent.ConversationCreated
         * @static
         * @param {propel.commrouter.ConversationEvent.ConversationCreated} message ConversationCreated
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ConversationCreated.toObject = function toObject(message, options) {
          if (!options) options = {};
          var object = {};
          if (options.defaults) object.conversation = null;
          if (message.conversation != null && message.hasOwnProperty('conversation'))
            object.conversation = $root.propel.commrouter.Conversation.toObject(
              message.conversation,
              options
            );
          return object;
        };

        /**
         * Converts this ConversationCreated to JSON.
         * @function toJSON
         * @memberof propel.commrouter.ConversationEvent.ConversationCreated
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ConversationCreated.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ConversationCreated;
      })();

      ConversationEvent.ConversationUpdated = (function () {
        /**
         * Properties of a ConversationUpdated.
         * @memberof propel.commrouter.ConversationEvent
         * @interface IConversationUpdated
         * @property {propel.commrouter.IConversation|null} [conversation] ConversationUpdated conversation
         */

        /**
         * Constructs a new ConversationUpdated.
         * @memberof propel.commrouter.ConversationEvent
         * @classdesc Represents a ConversationUpdated.
         * @implements IConversationUpdated
         * @constructor
         * @param {propel.commrouter.ConversationEvent.IConversationUpdated=} [properties] Properties to set
         */
        function ConversationUpdated(properties) {
          if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
              if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
        }

        /**
         * ConversationUpdated conversation.
         * @member {propel.commrouter.IConversation|null|undefined} conversation
         * @memberof propel.commrouter.ConversationEvent.ConversationUpdated
         * @instance
         */
        ConversationUpdated.prototype.conversation = null;

        /**
         * Creates a new ConversationUpdated instance using the specified properties.
         * @function create
         * @memberof propel.commrouter.ConversationEvent.ConversationUpdated
         * @static
         * @param {propel.commrouter.ConversationEvent.IConversationUpdated=} [properties] Properties to set
         * @returns {propel.commrouter.ConversationEvent.ConversationUpdated} ConversationUpdated instance
         */
        ConversationUpdated.create = function create(properties) {
          return new ConversationUpdated(properties);
        };

        /**
         * Encodes the specified ConversationUpdated message. Does not implicitly {@link propel.commrouter.ConversationEvent.ConversationUpdated.verify|verify} messages.
         * @function encode
         * @memberof propel.commrouter.ConversationEvent.ConversationUpdated
         * @static
         * @param {propel.commrouter.ConversationEvent.IConversationUpdated} message ConversationUpdated message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ConversationUpdated.encode = function encode(message, writer) {
          if (!writer) writer = $Writer.create();
          if (message.conversation != null && message.hasOwnProperty('conversation'))
            $root.propel.commrouter.Conversation.encode(
              message.conversation,
              writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
            ).ldelim();
          return writer;
        };

        /**
         * Encodes the specified ConversationUpdated message, length delimited. Does not implicitly {@link propel.commrouter.ConversationEvent.ConversationUpdated.verify|verify} messages.
         * @function encodeDelimited
         * @memberof propel.commrouter.ConversationEvent.ConversationUpdated
         * @static
         * @param {propel.commrouter.ConversationEvent.IConversationUpdated} message ConversationUpdated message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ConversationUpdated.encodeDelimited = function encodeDelimited(message, writer) {
          return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a ConversationUpdated message from the specified reader or buffer.
         * @function decode
         * @memberof propel.commrouter.ConversationEvent.ConversationUpdated
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {propel.commrouter.ConversationEvent.ConversationUpdated} ConversationUpdated
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ConversationUpdated.decode = function decode(reader, length) {
          if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
          var end = length === undefined ? reader.len : reader.pos + length,
            message = new $root.propel.commrouter.ConversationEvent.ConversationUpdated();
          while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
              case 1:
                message.conversation = $root.propel.commrouter.Conversation.decode(
                  reader,
                  reader.uint32()
                );
                break;
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };

        /**
         * Decodes a ConversationUpdated message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof propel.commrouter.ConversationEvent.ConversationUpdated
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {propel.commrouter.ConversationEvent.ConversationUpdated} ConversationUpdated
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ConversationUpdated.decodeDelimited = function decodeDelimited(reader) {
          if (!(reader instanceof $Reader)) reader = new $Reader(reader);
          return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ConversationUpdated message.
         * @function verify
         * @memberof propel.commrouter.ConversationEvent.ConversationUpdated
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ConversationUpdated.verify = function verify(message) {
          if (typeof message !== 'object' || message === null) return 'object expected';
          if (message.conversation != null && message.hasOwnProperty('conversation')) {
            var error = $root.propel.commrouter.Conversation.verify(message.conversation);
            if (error) return 'conversation.' + error;
          }
          return null;
        };

        /**
         * Creates a ConversationUpdated message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof propel.commrouter.ConversationEvent.ConversationUpdated
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {propel.commrouter.ConversationEvent.ConversationUpdated} ConversationUpdated
         */
        ConversationUpdated.fromObject = function fromObject(object) {
          if (object instanceof $root.propel.commrouter.ConversationEvent.ConversationUpdated)
            return object;
          var message = new $root.propel.commrouter.ConversationEvent.ConversationUpdated();
          if (object.conversation != null) {
            if (typeof object.conversation !== 'object')
              throw TypeError(
                '.propel.commrouter.ConversationEvent.ConversationUpdated.conversation: object expected'
              );
            message.conversation = $root.propel.commrouter.Conversation.fromObject(
              object.conversation
            );
          }
          return message;
        };

        /**
         * Creates a plain object from a ConversationUpdated message. Also converts values to other types if specified.
         * @function toObject
         * @memberof propel.commrouter.ConversationEvent.ConversationUpdated
         * @static
         * @param {propel.commrouter.ConversationEvent.ConversationUpdated} message ConversationUpdated
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ConversationUpdated.toObject = function toObject(message, options) {
          if (!options) options = {};
          var object = {};
          if (options.defaults) object.conversation = null;
          if (message.conversation != null && message.hasOwnProperty('conversation'))
            object.conversation = $root.propel.commrouter.Conversation.toObject(
              message.conversation,
              options
            );
          return object;
        };

        /**
         * Converts this ConversationUpdated to JSON.
         * @function toJSON
         * @memberof propel.commrouter.ConversationEvent.ConversationUpdated
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ConversationUpdated.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ConversationUpdated;
      })();

      ConversationEvent.ChannelCreated = (function () {
        /**
         * Properties of a ChannelCreated.
         * @memberof propel.commrouter.ConversationEvent
         * @interface IChannelCreated
         * @property {propel.commrouter.IChannel|null} [channel] ChannelCreated channel
         */

        /**
         * Constructs a new ChannelCreated.
         * @memberof propel.commrouter.ConversationEvent
         * @classdesc Represents a ChannelCreated.
         * @implements IChannelCreated
         * @constructor
         * @param {propel.commrouter.ConversationEvent.IChannelCreated=} [properties] Properties to set
         */
        function ChannelCreated(properties) {
          if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
              if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
        }

        /**
         * ChannelCreated channel.
         * @member {propel.commrouter.IChannel|null|undefined} channel
         * @memberof propel.commrouter.ConversationEvent.ChannelCreated
         * @instance
         */
        ChannelCreated.prototype.channel = null;

        /**
         * Creates a new ChannelCreated instance using the specified properties.
         * @function create
         * @memberof propel.commrouter.ConversationEvent.ChannelCreated
         * @static
         * @param {propel.commrouter.ConversationEvent.IChannelCreated=} [properties] Properties to set
         * @returns {propel.commrouter.ConversationEvent.ChannelCreated} ChannelCreated instance
         */
        ChannelCreated.create = function create(properties) {
          return new ChannelCreated(properties);
        };

        /**
         * Encodes the specified ChannelCreated message. Does not implicitly {@link propel.commrouter.ConversationEvent.ChannelCreated.verify|verify} messages.
         * @function encode
         * @memberof propel.commrouter.ConversationEvent.ChannelCreated
         * @static
         * @param {propel.commrouter.ConversationEvent.IChannelCreated} message ChannelCreated message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ChannelCreated.encode = function encode(message, writer) {
          if (!writer) writer = $Writer.create();
          if (message.channel != null && message.hasOwnProperty('channel'))
            $root.propel.commrouter.Channel.encode(
              message.channel,
              writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
            ).ldelim();
          return writer;
        };

        /**
         * Encodes the specified ChannelCreated message, length delimited. Does not implicitly {@link propel.commrouter.ConversationEvent.ChannelCreated.verify|verify} messages.
         * @function encodeDelimited
         * @memberof propel.commrouter.ConversationEvent.ChannelCreated
         * @static
         * @param {propel.commrouter.ConversationEvent.IChannelCreated} message ChannelCreated message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ChannelCreated.encodeDelimited = function encodeDelimited(message, writer) {
          return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a ChannelCreated message from the specified reader or buffer.
         * @function decode
         * @memberof propel.commrouter.ConversationEvent.ChannelCreated
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {propel.commrouter.ConversationEvent.ChannelCreated} ChannelCreated
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ChannelCreated.decode = function decode(reader, length) {
          if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
          var end = length === undefined ? reader.len : reader.pos + length,
            message = new $root.propel.commrouter.ConversationEvent.ChannelCreated();
          while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
              case 1:
                message.channel = $root.propel.commrouter.Channel.decode(reader, reader.uint32());
                break;
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };

        /**
         * Decodes a ChannelCreated message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof propel.commrouter.ConversationEvent.ChannelCreated
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {propel.commrouter.ConversationEvent.ChannelCreated} ChannelCreated
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ChannelCreated.decodeDelimited = function decodeDelimited(reader) {
          if (!(reader instanceof $Reader)) reader = new $Reader(reader);
          return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ChannelCreated message.
         * @function verify
         * @memberof propel.commrouter.ConversationEvent.ChannelCreated
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ChannelCreated.verify = function verify(message) {
          if (typeof message !== 'object' || message === null) return 'object expected';
          if (message.channel != null && message.hasOwnProperty('channel')) {
            var error = $root.propel.commrouter.Channel.verify(message.channel);
            if (error) return 'channel.' + error;
          }
          return null;
        };

        /**
         * Creates a ChannelCreated message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof propel.commrouter.ConversationEvent.ChannelCreated
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {propel.commrouter.ConversationEvent.ChannelCreated} ChannelCreated
         */
        ChannelCreated.fromObject = function fromObject(object) {
          if (object instanceof $root.propel.commrouter.ConversationEvent.ChannelCreated)
            return object;
          var message = new $root.propel.commrouter.ConversationEvent.ChannelCreated();
          if (object.channel != null) {
            if (typeof object.channel !== 'object')
              throw TypeError(
                '.propel.commrouter.ConversationEvent.ChannelCreated.channel: object expected'
              );
            message.channel = $root.propel.commrouter.Channel.fromObject(object.channel);
          }
          return message;
        };

        /**
         * Creates a plain object from a ChannelCreated message. Also converts values to other types if specified.
         * @function toObject
         * @memberof propel.commrouter.ConversationEvent.ChannelCreated
         * @static
         * @param {propel.commrouter.ConversationEvent.ChannelCreated} message ChannelCreated
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ChannelCreated.toObject = function toObject(message, options) {
          if (!options) options = {};
          var object = {};
          if (options.defaults) object.channel = null;
          if (message.channel != null && message.hasOwnProperty('channel'))
            object.channel = $root.propel.commrouter.Channel.toObject(message.channel, options);
          return object;
        };

        /**
         * Converts this ChannelCreated to JSON.
         * @function toJSON
         * @memberof propel.commrouter.ConversationEvent.ChannelCreated
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ChannelCreated.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ChannelCreated;
      })();

      ConversationEvent.ChannelUpdated = (function () {
        /**
         * Properties of a ChannelUpdated.
         * @memberof propel.commrouter.ConversationEvent
         * @interface IChannelUpdated
         * @property {propel.commrouter.IChannel|null} [channel] ChannelUpdated channel
         */

        /**
         * Constructs a new ChannelUpdated.
         * @memberof propel.commrouter.ConversationEvent
         * @classdesc Represents a ChannelUpdated.
         * @implements IChannelUpdated
         * @constructor
         * @param {propel.commrouter.ConversationEvent.IChannelUpdated=} [properties] Properties to set
         */
        function ChannelUpdated(properties) {
          if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
              if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
        }

        /**
         * ChannelUpdated channel.
         * @member {propel.commrouter.IChannel|null|undefined} channel
         * @memberof propel.commrouter.ConversationEvent.ChannelUpdated
         * @instance
         */
        ChannelUpdated.prototype.channel = null;

        /**
         * Creates a new ChannelUpdated instance using the specified properties.
         * @function create
         * @memberof propel.commrouter.ConversationEvent.ChannelUpdated
         * @static
         * @param {propel.commrouter.ConversationEvent.IChannelUpdated=} [properties] Properties to set
         * @returns {propel.commrouter.ConversationEvent.ChannelUpdated} ChannelUpdated instance
         */
        ChannelUpdated.create = function create(properties) {
          return new ChannelUpdated(properties);
        };

        /**
         * Encodes the specified ChannelUpdated message. Does not implicitly {@link propel.commrouter.ConversationEvent.ChannelUpdated.verify|verify} messages.
         * @function encode
         * @memberof propel.commrouter.ConversationEvent.ChannelUpdated
         * @static
         * @param {propel.commrouter.ConversationEvent.IChannelUpdated} message ChannelUpdated message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ChannelUpdated.encode = function encode(message, writer) {
          if (!writer) writer = $Writer.create();
          if (message.channel != null && message.hasOwnProperty('channel'))
            $root.propel.commrouter.Channel.encode(
              message.channel,
              writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
            ).ldelim();
          return writer;
        };

        /**
         * Encodes the specified ChannelUpdated message, length delimited. Does not implicitly {@link propel.commrouter.ConversationEvent.ChannelUpdated.verify|verify} messages.
         * @function encodeDelimited
         * @memberof propel.commrouter.ConversationEvent.ChannelUpdated
         * @static
         * @param {propel.commrouter.ConversationEvent.IChannelUpdated} message ChannelUpdated message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ChannelUpdated.encodeDelimited = function encodeDelimited(message, writer) {
          return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a ChannelUpdated message from the specified reader or buffer.
         * @function decode
         * @memberof propel.commrouter.ConversationEvent.ChannelUpdated
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {propel.commrouter.ConversationEvent.ChannelUpdated} ChannelUpdated
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ChannelUpdated.decode = function decode(reader, length) {
          if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
          var end = length === undefined ? reader.len : reader.pos + length,
            message = new $root.propel.commrouter.ConversationEvent.ChannelUpdated();
          while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
              case 1:
                message.channel = $root.propel.commrouter.Channel.decode(reader, reader.uint32());
                break;
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };

        /**
         * Decodes a ChannelUpdated message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof propel.commrouter.ConversationEvent.ChannelUpdated
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {propel.commrouter.ConversationEvent.ChannelUpdated} ChannelUpdated
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ChannelUpdated.decodeDelimited = function decodeDelimited(reader) {
          if (!(reader instanceof $Reader)) reader = new $Reader(reader);
          return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ChannelUpdated message.
         * @function verify
         * @memberof propel.commrouter.ConversationEvent.ChannelUpdated
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ChannelUpdated.verify = function verify(message) {
          if (typeof message !== 'object' || message === null) return 'object expected';
          if (message.channel != null && message.hasOwnProperty('channel')) {
            var error = $root.propel.commrouter.Channel.verify(message.channel);
            if (error) return 'channel.' + error;
          }
          return null;
        };

        /**
         * Creates a ChannelUpdated message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof propel.commrouter.ConversationEvent.ChannelUpdated
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {propel.commrouter.ConversationEvent.ChannelUpdated} ChannelUpdated
         */
        ChannelUpdated.fromObject = function fromObject(object) {
          if (object instanceof $root.propel.commrouter.ConversationEvent.ChannelUpdated)
            return object;
          var message = new $root.propel.commrouter.ConversationEvent.ChannelUpdated();
          if (object.channel != null) {
            if (typeof object.channel !== 'object')
              throw TypeError(
                '.propel.commrouter.ConversationEvent.ChannelUpdated.channel: object expected'
              );
            message.channel = $root.propel.commrouter.Channel.fromObject(object.channel);
          }
          return message;
        };

        /**
         * Creates a plain object from a ChannelUpdated message. Also converts values to other types if specified.
         * @function toObject
         * @memberof propel.commrouter.ConversationEvent.ChannelUpdated
         * @static
         * @param {propel.commrouter.ConversationEvent.ChannelUpdated} message ChannelUpdated
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ChannelUpdated.toObject = function toObject(message, options) {
          if (!options) options = {};
          var object = {};
          if (options.defaults) object.channel = null;
          if (message.channel != null && message.hasOwnProperty('channel'))
            object.channel = $root.propel.commrouter.Channel.toObject(message.channel, options);
          return object;
        };

        /**
         * Converts this ChannelUpdated to JSON.
         * @function toJSON
         * @memberof propel.commrouter.ConversationEvent.ChannelUpdated
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ChannelUpdated.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ChannelUpdated;
      })();

      ConversationEvent.AvatarCreated = (function () {
        /**
         * Properties of an AvatarCreated.
         * @memberof propel.commrouter.ConversationEvent
         * @interface IAvatarCreated
         * @property {propel.commrouter.IAvatar|null} [avatar] AvatarCreated avatar
         */

        /**
         * Constructs a new AvatarCreated.
         * @memberof propel.commrouter.ConversationEvent
         * @classdesc Represents an AvatarCreated.
         * @implements IAvatarCreated
         * @constructor
         * @param {propel.commrouter.ConversationEvent.IAvatarCreated=} [properties] Properties to set
         */
        function AvatarCreated(properties) {
          if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
              if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
        }

        /**
         * AvatarCreated avatar.
         * @member {propel.commrouter.IAvatar|null|undefined} avatar
         * @memberof propel.commrouter.ConversationEvent.AvatarCreated
         * @instance
         */
        AvatarCreated.prototype.avatar = null;

        /**
         * Creates a new AvatarCreated instance using the specified properties.
         * @function create
         * @memberof propel.commrouter.ConversationEvent.AvatarCreated
         * @static
         * @param {propel.commrouter.ConversationEvent.IAvatarCreated=} [properties] Properties to set
         * @returns {propel.commrouter.ConversationEvent.AvatarCreated} AvatarCreated instance
         */
        AvatarCreated.create = function create(properties) {
          return new AvatarCreated(properties);
        };

        /**
         * Encodes the specified AvatarCreated message. Does not implicitly {@link propel.commrouter.ConversationEvent.AvatarCreated.verify|verify} messages.
         * @function encode
         * @memberof propel.commrouter.ConversationEvent.AvatarCreated
         * @static
         * @param {propel.commrouter.ConversationEvent.IAvatarCreated} message AvatarCreated message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        AvatarCreated.encode = function encode(message, writer) {
          if (!writer) writer = $Writer.create();
          if (message.avatar != null && message.hasOwnProperty('avatar'))
            $root.propel.commrouter.Avatar.encode(
              message.avatar,
              writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
            ).ldelim();
          return writer;
        };

        /**
         * Encodes the specified AvatarCreated message, length delimited. Does not implicitly {@link propel.commrouter.ConversationEvent.AvatarCreated.verify|verify} messages.
         * @function encodeDelimited
         * @memberof propel.commrouter.ConversationEvent.AvatarCreated
         * @static
         * @param {propel.commrouter.ConversationEvent.IAvatarCreated} message AvatarCreated message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        AvatarCreated.encodeDelimited = function encodeDelimited(message, writer) {
          return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an AvatarCreated message from the specified reader or buffer.
         * @function decode
         * @memberof propel.commrouter.ConversationEvent.AvatarCreated
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {propel.commrouter.ConversationEvent.AvatarCreated} AvatarCreated
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        AvatarCreated.decode = function decode(reader, length) {
          if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
          var end = length === undefined ? reader.len : reader.pos + length,
            message = new $root.propel.commrouter.ConversationEvent.AvatarCreated();
          while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
              case 1:
                message.avatar = $root.propel.commrouter.Avatar.decode(reader, reader.uint32());
                break;
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };

        /**
         * Decodes an AvatarCreated message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof propel.commrouter.ConversationEvent.AvatarCreated
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {propel.commrouter.ConversationEvent.AvatarCreated} AvatarCreated
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        AvatarCreated.decodeDelimited = function decodeDelimited(reader) {
          if (!(reader instanceof $Reader)) reader = new $Reader(reader);
          return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an AvatarCreated message.
         * @function verify
         * @memberof propel.commrouter.ConversationEvent.AvatarCreated
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        AvatarCreated.verify = function verify(message) {
          if (typeof message !== 'object' || message === null) return 'object expected';
          if (message.avatar != null && message.hasOwnProperty('avatar')) {
            var error = $root.propel.commrouter.Avatar.verify(message.avatar);
            if (error) return 'avatar.' + error;
          }
          return null;
        };

        /**
         * Creates an AvatarCreated message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof propel.commrouter.ConversationEvent.AvatarCreated
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {propel.commrouter.ConversationEvent.AvatarCreated} AvatarCreated
         */
        AvatarCreated.fromObject = function fromObject(object) {
          if (object instanceof $root.propel.commrouter.ConversationEvent.AvatarCreated)
            return object;
          var message = new $root.propel.commrouter.ConversationEvent.AvatarCreated();
          if (object.avatar != null) {
            if (typeof object.avatar !== 'object')
              throw TypeError(
                '.propel.commrouter.ConversationEvent.AvatarCreated.avatar: object expected'
              );
            message.avatar = $root.propel.commrouter.Avatar.fromObject(object.avatar);
          }
          return message;
        };

        /**
         * Creates a plain object from an AvatarCreated message. Also converts values to other types if specified.
         * @function toObject
         * @memberof propel.commrouter.ConversationEvent.AvatarCreated
         * @static
         * @param {propel.commrouter.ConversationEvent.AvatarCreated} message AvatarCreated
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        AvatarCreated.toObject = function toObject(message, options) {
          if (!options) options = {};
          var object = {};
          if (options.defaults) object.avatar = null;
          if (message.avatar != null && message.hasOwnProperty('avatar'))
            object.avatar = $root.propel.commrouter.Avatar.toObject(message.avatar, options);
          return object;
        };

        /**
         * Converts this AvatarCreated to JSON.
         * @function toJSON
         * @memberof propel.commrouter.ConversationEvent.AvatarCreated
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        AvatarCreated.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return AvatarCreated;
      })();

      ConversationEvent.AvatarUpdated = (function () {
        /**
         * Properties of an AvatarUpdated.
         * @memberof propel.commrouter.ConversationEvent
         * @interface IAvatarUpdated
         * @property {propel.commrouter.IAvatar|null} [avatar] AvatarUpdated avatar
         */

        /**
         * Constructs a new AvatarUpdated.
         * @memberof propel.commrouter.ConversationEvent
         * @classdesc Represents an AvatarUpdated.
         * @implements IAvatarUpdated
         * @constructor
         * @param {propel.commrouter.ConversationEvent.IAvatarUpdated=} [properties] Properties to set
         */
        function AvatarUpdated(properties) {
          if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
              if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
        }

        /**
         * AvatarUpdated avatar.
         * @member {propel.commrouter.IAvatar|null|undefined} avatar
         * @memberof propel.commrouter.ConversationEvent.AvatarUpdated
         * @instance
         */
        AvatarUpdated.prototype.avatar = null;

        /**
         * Creates a new AvatarUpdated instance using the specified properties.
         * @function create
         * @memberof propel.commrouter.ConversationEvent.AvatarUpdated
         * @static
         * @param {propel.commrouter.ConversationEvent.IAvatarUpdated=} [properties] Properties to set
         * @returns {propel.commrouter.ConversationEvent.AvatarUpdated} AvatarUpdated instance
         */
        AvatarUpdated.create = function create(properties) {
          return new AvatarUpdated(properties);
        };

        /**
         * Encodes the specified AvatarUpdated message. Does not implicitly {@link propel.commrouter.ConversationEvent.AvatarUpdated.verify|verify} messages.
         * @function encode
         * @memberof propel.commrouter.ConversationEvent.AvatarUpdated
         * @static
         * @param {propel.commrouter.ConversationEvent.IAvatarUpdated} message AvatarUpdated message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        AvatarUpdated.encode = function encode(message, writer) {
          if (!writer) writer = $Writer.create();
          if (message.avatar != null && message.hasOwnProperty('avatar'))
            $root.propel.commrouter.Avatar.encode(
              message.avatar,
              writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
            ).ldelim();
          return writer;
        };

        /**
         * Encodes the specified AvatarUpdated message, length delimited. Does not implicitly {@link propel.commrouter.ConversationEvent.AvatarUpdated.verify|verify} messages.
         * @function encodeDelimited
         * @memberof propel.commrouter.ConversationEvent.AvatarUpdated
         * @static
         * @param {propel.commrouter.ConversationEvent.IAvatarUpdated} message AvatarUpdated message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        AvatarUpdated.encodeDelimited = function encodeDelimited(message, writer) {
          return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an AvatarUpdated message from the specified reader or buffer.
         * @function decode
         * @memberof propel.commrouter.ConversationEvent.AvatarUpdated
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {propel.commrouter.ConversationEvent.AvatarUpdated} AvatarUpdated
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        AvatarUpdated.decode = function decode(reader, length) {
          if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
          var end = length === undefined ? reader.len : reader.pos + length,
            message = new $root.propel.commrouter.ConversationEvent.AvatarUpdated();
          while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
              case 1:
                message.avatar = $root.propel.commrouter.Avatar.decode(reader, reader.uint32());
                break;
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };

        /**
         * Decodes an AvatarUpdated message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof propel.commrouter.ConversationEvent.AvatarUpdated
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {propel.commrouter.ConversationEvent.AvatarUpdated} AvatarUpdated
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        AvatarUpdated.decodeDelimited = function decodeDelimited(reader) {
          if (!(reader instanceof $Reader)) reader = new $Reader(reader);
          return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an AvatarUpdated message.
         * @function verify
         * @memberof propel.commrouter.ConversationEvent.AvatarUpdated
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        AvatarUpdated.verify = function verify(message) {
          if (typeof message !== 'object' || message === null) return 'object expected';
          if (message.avatar != null && message.hasOwnProperty('avatar')) {
            var error = $root.propel.commrouter.Avatar.verify(message.avatar);
            if (error) return 'avatar.' + error;
          }
          return null;
        };

        /**
         * Creates an AvatarUpdated message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof propel.commrouter.ConversationEvent.AvatarUpdated
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {propel.commrouter.ConversationEvent.AvatarUpdated} AvatarUpdated
         */
        AvatarUpdated.fromObject = function fromObject(object) {
          if (object instanceof $root.propel.commrouter.ConversationEvent.AvatarUpdated)
            return object;
          var message = new $root.propel.commrouter.ConversationEvent.AvatarUpdated();
          if (object.avatar != null) {
            if (typeof object.avatar !== 'object')
              throw TypeError(
                '.propel.commrouter.ConversationEvent.AvatarUpdated.avatar: object expected'
              );
            message.avatar = $root.propel.commrouter.Avatar.fromObject(object.avatar);
          }
          return message;
        };

        /**
         * Creates a plain object from an AvatarUpdated message. Also converts values to other types if specified.
         * @function toObject
         * @memberof propel.commrouter.ConversationEvent.AvatarUpdated
         * @static
         * @param {propel.commrouter.ConversationEvent.AvatarUpdated} message AvatarUpdated
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        AvatarUpdated.toObject = function toObject(message, options) {
          if (!options) options = {};
          var object = {};
          if (options.defaults) object.avatar = null;
          if (message.avatar != null && message.hasOwnProperty('avatar'))
            object.avatar = $root.propel.commrouter.Avatar.toObject(message.avatar, options);
          return object;
        };

        /**
         * Converts this AvatarUpdated to JSON.
         * @function toJSON
         * @memberof propel.commrouter.ConversationEvent.AvatarUpdated
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        AvatarUpdated.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return AvatarUpdated;
      })();

      ConversationEvent.MessageCreated = (function () {
        /**
         * Properties of a MessageCreated.
         * @memberof propel.commrouter.ConversationEvent
         * @interface IMessageCreated
         * @property {propel.commrouter.IMessage|null} [message] MessageCreated message
         * @property {propel.commrouter.IAvatar|null} [avatar] MessageCreated avatar
         */

        /**
         * Constructs a new MessageCreated.
         * @memberof propel.commrouter.ConversationEvent
         * @classdesc Represents a MessageCreated.
         * @implements IMessageCreated
         * @constructor
         * @param {propel.commrouter.ConversationEvent.IMessageCreated=} [properties] Properties to set
         */
        function MessageCreated(properties) {
          if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
              if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
        }

        /**
         * MessageCreated message.
         * @member {propel.commrouter.IMessage|null|undefined} message
         * @memberof propel.commrouter.ConversationEvent.MessageCreated
         * @instance
         */
        MessageCreated.prototype.message = null;

        /**
         * MessageCreated avatar.
         * @member {propel.commrouter.IAvatar|null|undefined} avatar
         * @memberof propel.commrouter.ConversationEvent.MessageCreated
         * @instance
         */
        MessageCreated.prototype.avatar = null;

        /**
         * Creates a new MessageCreated instance using the specified properties.
         * @function create
         * @memberof propel.commrouter.ConversationEvent.MessageCreated
         * @static
         * @param {propel.commrouter.ConversationEvent.IMessageCreated=} [properties] Properties to set
         * @returns {propel.commrouter.ConversationEvent.MessageCreated} MessageCreated instance
         */
        MessageCreated.create = function create(properties) {
          return new MessageCreated(properties);
        };

        /**
         * Encodes the specified MessageCreated message. Does not implicitly {@link propel.commrouter.ConversationEvent.MessageCreated.verify|verify} messages.
         * @function encode
         * @memberof propel.commrouter.ConversationEvent.MessageCreated
         * @static
         * @param {propel.commrouter.ConversationEvent.IMessageCreated} message MessageCreated message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MessageCreated.encode = function encode(message, writer) {
          if (!writer) writer = $Writer.create();
          if (message.message != null && message.hasOwnProperty('message'))
            $root.propel.commrouter.Message.encode(
              message.message,
              writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
            ).ldelim();
          if (message.avatar != null && message.hasOwnProperty('avatar'))
            $root.propel.commrouter.Avatar.encode(
              message.avatar,
              writer.uint32(/* id 2, wireType 2 =*/ 18).fork()
            ).ldelim();
          return writer;
        };

        /**
         * Encodes the specified MessageCreated message, length delimited. Does not implicitly {@link propel.commrouter.ConversationEvent.MessageCreated.verify|verify} messages.
         * @function encodeDelimited
         * @memberof propel.commrouter.ConversationEvent.MessageCreated
         * @static
         * @param {propel.commrouter.ConversationEvent.IMessageCreated} message MessageCreated message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MessageCreated.encodeDelimited = function encodeDelimited(message, writer) {
          return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a MessageCreated message from the specified reader or buffer.
         * @function decode
         * @memberof propel.commrouter.ConversationEvent.MessageCreated
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {propel.commrouter.ConversationEvent.MessageCreated} MessageCreated
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MessageCreated.decode = function decode(reader, length) {
          if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
          var end = length === undefined ? reader.len : reader.pos + length,
            message = new $root.propel.commrouter.ConversationEvent.MessageCreated();
          while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
              case 1:
                message.message = $root.propel.commrouter.Message.decode(reader, reader.uint32());
                break;
              case 2:
                message.avatar = $root.propel.commrouter.Avatar.decode(reader, reader.uint32());
                break;
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };

        /**
         * Decodes a MessageCreated message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof propel.commrouter.ConversationEvent.MessageCreated
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {propel.commrouter.ConversationEvent.MessageCreated} MessageCreated
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MessageCreated.decodeDelimited = function decodeDelimited(reader) {
          if (!(reader instanceof $Reader)) reader = new $Reader(reader);
          return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a MessageCreated message.
         * @function verify
         * @memberof propel.commrouter.ConversationEvent.MessageCreated
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        MessageCreated.verify = function verify(message) {
          if (typeof message !== 'object' || message === null) return 'object expected';
          if (message.message != null && message.hasOwnProperty('message')) {
            var error = $root.propel.commrouter.Message.verify(message.message);
            if (error) return 'message.' + error;
          }
          if (message.avatar != null && message.hasOwnProperty('avatar')) {
            var error = $root.propel.commrouter.Avatar.verify(message.avatar);
            if (error) return 'avatar.' + error;
          }
          return null;
        };

        /**
         * Creates a MessageCreated message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof propel.commrouter.ConversationEvent.MessageCreated
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {propel.commrouter.ConversationEvent.MessageCreated} MessageCreated
         */
        MessageCreated.fromObject = function fromObject(object) {
          if (object instanceof $root.propel.commrouter.ConversationEvent.MessageCreated)
            return object;
          var message = new $root.propel.commrouter.ConversationEvent.MessageCreated();
          if (object.message != null) {
            if (typeof object.message !== 'object')
              throw TypeError(
                '.propel.commrouter.ConversationEvent.MessageCreated.message: object expected'
              );
            message.message = $root.propel.commrouter.Message.fromObject(object.message);
          }
          if (object.avatar != null) {
            if (typeof object.avatar !== 'object')
              throw TypeError(
                '.propel.commrouter.ConversationEvent.MessageCreated.avatar: object expected'
              );
            message.avatar = $root.propel.commrouter.Avatar.fromObject(object.avatar);
          }
          return message;
        };

        /**
         * Creates a plain object from a MessageCreated message. Also converts values to other types if specified.
         * @function toObject
         * @memberof propel.commrouter.ConversationEvent.MessageCreated
         * @static
         * @param {propel.commrouter.ConversationEvent.MessageCreated} message MessageCreated
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        MessageCreated.toObject = function toObject(message, options) {
          if (!options) options = {};
          var object = {};
          if (options.defaults) {
            object.message = null;
            object.avatar = null;
          }
          if (message.message != null && message.hasOwnProperty('message'))
            object.message = $root.propel.commrouter.Message.toObject(message.message, options);
          if (message.avatar != null && message.hasOwnProperty('avatar'))
            object.avatar = $root.propel.commrouter.Avatar.toObject(message.avatar, options);
          return object;
        };

        /**
         * Converts this MessageCreated to JSON.
         * @function toJSON
         * @memberof propel.commrouter.ConversationEvent.MessageCreated
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        MessageCreated.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return MessageCreated;
      })();

      ConversationEvent.MessageUpdated = (function () {
        /**
         * Properties of a MessageUpdated.
         * @memberof propel.commrouter.ConversationEvent
         * @interface IMessageUpdated
         * @property {propel.commrouter.IMessage|null} [message] MessageUpdated message
         */

        /**
         * Constructs a new MessageUpdated.
         * @memberof propel.commrouter.ConversationEvent
         * @classdesc Represents a MessageUpdated.
         * @implements IMessageUpdated
         * @constructor
         * @param {propel.commrouter.ConversationEvent.IMessageUpdated=} [properties] Properties to set
         */
        function MessageUpdated(properties) {
          if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
              if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
        }

        /**
         * MessageUpdated message.
         * @member {propel.commrouter.IMessage|null|undefined} message
         * @memberof propel.commrouter.ConversationEvent.MessageUpdated
         * @instance
         */
        MessageUpdated.prototype.message = null;

        /**
         * Creates a new MessageUpdated instance using the specified properties.
         * @function create
         * @memberof propel.commrouter.ConversationEvent.MessageUpdated
         * @static
         * @param {propel.commrouter.ConversationEvent.IMessageUpdated=} [properties] Properties to set
         * @returns {propel.commrouter.ConversationEvent.MessageUpdated} MessageUpdated instance
         */
        MessageUpdated.create = function create(properties) {
          return new MessageUpdated(properties);
        };

        /**
         * Encodes the specified MessageUpdated message. Does not implicitly {@link propel.commrouter.ConversationEvent.MessageUpdated.verify|verify} messages.
         * @function encode
         * @memberof propel.commrouter.ConversationEvent.MessageUpdated
         * @static
         * @param {propel.commrouter.ConversationEvent.IMessageUpdated} message MessageUpdated message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MessageUpdated.encode = function encode(message, writer) {
          if (!writer) writer = $Writer.create();
          if (message.message != null && message.hasOwnProperty('message'))
            $root.propel.commrouter.Message.encode(
              message.message,
              writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
            ).ldelim();
          return writer;
        };

        /**
         * Encodes the specified MessageUpdated message, length delimited. Does not implicitly {@link propel.commrouter.ConversationEvent.MessageUpdated.verify|verify} messages.
         * @function encodeDelimited
         * @memberof propel.commrouter.ConversationEvent.MessageUpdated
         * @static
         * @param {propel.commrouter.ConversationEvent.IMessageUpdated} message MessageUpdated message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MessageUpdated.encodeDelimited = function encodeDelimited(message, writer) {
          return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a MessageUpdated message from the specified reader or buffer.
         * @function decode
         * @memberof propel.commrouter.ConversationEvent.MessageUpdated
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {propel.commrouter.ConversationEvent.MessageUpdated} MessageUpdated
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MessageUpdated.decode = function decode(reader, length) {
          if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
          var end = length === undefined ? reader.len : reader.pos + length,
            message = new $root.propel.commrouter.ConversationEvent.MessageUpdated();
          while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
              case 1:
                message.message = $root.propel.commrouter.Message.decode(reader, reader.uint32());
                break;
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };

        /**
         * Decodes a MessageUpdated message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof propel.commrouter.ConversationEvent.MessageUpdated
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {propel.commrouter.ConversationEvent.MessageUpdated} MessageUpdated
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MessageUpdated.decodeDelimited = function decodeDelimited(reader) {
          if (!(reader instanceof $Reader)) reader = new $Reader(reader);
          return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a MessageUpdated message.
         * @function verify
         * @memberof propel.commrouter.ConversationEvent.MessageUpdated
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        MessageUpdated.verify = function verify(message) {
          if (typeof message !== 'object' || message === null) return 'object expected';
          if (message.message != null && message.hasOwnProperty('message')) {
            var error = $root.propel.commrouter.Message.verify(message.message);
            if (error) return 'message.' + error;
          }
          return null;
        };

        /**
         * Creates a MessageUpdated message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof propel.commrouter.ConversationEvent.MessageUpdated
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {propel.commrouter.ConversationEvent.MessageUpdated} MessageUpdated
         */
        MessageUpdated.fromObject = function fromObject(object) {
          if (object instanceof $root.propel.commrouter.ConversationEvent.MessageUpdated)
            return object;
          var message = new $root.propel.commrouter.ConversationEvent.MessageUpdated();
          if (object.message != null) {
            if (typeof object.message !== 'object')
              throw TypeError(
                '.propel.commrouter.ConversationEvent.MessageUpdated.message: object expected'
              );
            message.message = $root.propel.commrouter.Message.fromObject(object.message);
          }
          return message;
        };

        /**
         * Creates a plain object from a MessageUpdated message. Also converts values to other types if specified.
         * @function toObject
         * @memberof propel.commrouter.ConversationEvent.MessageUpdated
         * @static
         * @param {propel.commrouter.ConversationEvent.MessageUpdated} message MessageUpdated
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        MessageUpdated.toObject = function toObject(message, options) {
          if (!options) options = {};
          var object = {};
          if (options.defaults) object.message = null;
          if (message.message != null && message.hasOwnProperty('message'))
            object.message = $root.propel.commrouter.Message.toObject(message.message, options);
          return object;
        };

        /**
         * Converts this MessageUpdated to JSON.
         * @function toJSON
         * @memberof propel.commrouter.ConversationEvent.MessageUpdated
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        MessageUpdated.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return MessageUpdated;
      })();

      ConversationEvent.SentenceCreated = (function () {
        /**
         * Properties of a SentenceCreated.
         * @memberof propel.commrouter.ConversationEvent
         * @interface ISentenceCreated
         * @property {propel.commrouter.ISentence|null} [sentence] SentenceCreated sentence
         */

        /**
         * Constructs a new SentenceCreated.
         * @memberof propel.commrouter.ConversationEvent
         * @classdesc Represents a SentenceCreated.
         * @implements ISentenceCreated
         * @constructor
         * @param {propel.commrouter.ConversationEvent.ISentenceCreated=} [properties] Properties to set
         */
        function SentenceCreated(properties) {
          if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
              if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
        }

        /**
         * SentenceCreated sentence.
         * @member {propel.commrouter.ISentence|null|undefined} sentence
         * @memberof propel.commrouter.ConversationEvent.SentenceCreated
         * @instance
         */
        SentenceCreated.prototype.sentence = null;

        /**
         * Creates a new SentenceCreated instance using the specified properties.
         * @function create
         * @memberof propel.commrouter.ConversationEvent.SentenceCreated
         * @static
         * @param {propel.commrouter.ConversationEvent.ISentenceCreated=} [properties] Properties to set
         * @returns {propel.commrouter.ConversationEvent.SentenceCreated} SentenceCreated instance
         */
        SentenceCreated.create = function create(properties) {
          return new SentenceCreated(properties);
        };

        /**
         * Encodes the specified SentenceCreated message. Does not implicitly {@link propel.commrouter.ConversationEvent.SentenceCreated.verify|verify} messages.
         * @function encode
         * @memberof propel.commrouter.ConversationEvent.SentenceCreated
         * @static
         * @param {propel.commrouter.ConversationEvent.ISentenceCreated} message SentenceCreated message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SentenceCreated.encode = function encode(message, writer) {
          if (!writer) writer = $Writer.create();
          if (message.sentence != null && message.hasOwnProperty('sentence'))
            $root.propel.commrouter.Sentence.encode(
              message.sentence,
              writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
            ).ldelim();
          return writer;
        };

        /**
         * Encodes the specified SentenceCreated message, length delimited. Does not implicitly {@link propel.commrouter.ConversationEvent.SentenceCreated.verify|verify} messages.
         * @function encodeDelimited
         * @memberof propel.commrouter.ConversationEvent.SentenceCreated
         * @static
         * @param {propel.commrouter.ConversationEvent.ISentenceCreated} message SentenceCreated message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SentenceCreated.encodeDelimited = function encodeDelimited(message, writer) {
          return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a SentenceCreated message from the specified reader or buffer.
         * @function decode
         * @memberof propel.commrouter.ConversationEvent.SentenceCreated
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {propel.commrouter.ConversationEvent.SentenceCreated} SentenceCreated
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SentenceCreated.decode = function decode(reader, length) {
          if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
          var end = length === undefined ? reader.len : reader.pos + length,
            message = new $root.propel.commrouter.ConversationEvent.SentenceCreated();
          while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
              case 1:
                message.sentence = $root.propel.commrouter.Sentence.decode(reader, reader.uint32());
                break;
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };

        /**
         * Decodes a SentenceCreated message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof propel.commrouter.ConversationEvent.SentenceCreated
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {propel.commrouter.ConversationEvent.SentenceCreated} SentenceCreated
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SentenceCreated.decodeDelimited = function decodeDelimited(reader) {
          if (!(reader instanceof $Reader)) reader = new $Reader(reader);
          return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a SentenceCreated message.
         * @function verify
         * @memberof propel.commrouter.ConversationEvent.SentenceCreated
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        SentenceCreated.verify = function verify(message) {
          if (typeof message !== 'object' || message === null) return 'object expected';
          if (message.sentence != null && message.hasOwnProperty('sentence')) {
            var error = $root.propel.commrouter.Sentence.verify(message.sentence);
            if (error) return 'sentence.' + error;
          }
          return null;
        };

        /**
         * Creates a SentenceCreated message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof propel.commrouter.ConversationEvent.SentenceCreated
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {propel.commrouter.ConversationEvent.SentenceCreated} SentenceCreated
         */
        SentenceCreated.fromObject = function fromObject(object) {
          if (object instanceof $root.propel.commrouter.ConversationEvent.SentenceCreated)
            return object;
          var message = new $root.propel.commrouter.ConversationEvent.SentenceCreated();
          if (object.sentence != null) {
            if (typeof object.sentence !== 'object')
              throw TypeError(
                '.propel.commrouter.ConversationEvent.SentenceCreated.sentence: object expected'
              );
            message.sentence = $root.propel.commrouter.Sentence.fromObject(object.sentence);
          }
          return message;
        };

        /**
         * Creates a plain object from a SentenceCreated message. Also converts values to other types if specified.
         * @function toObject
         * @memberof propel.commrouter.ConversationEvent.SentenceCreated
         * @static
         * @param {propel.commrouter.ConversationEvent.SentenceCreated} message SentenceCreated
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        SentenceCreated.toObject = function toObject(message, options) {
          if (!options) options = {};
          var object = {};
          if (options.defaults) object.sentence = null;
          if (message.sentence != null && message.hasOwnProperty('sentence'))
            object.sentence = $root.propel.commrouter.Sentence.toObject(message.sentence, options);
          return object;
        };

        /**
         * Converts this SentenceCreated to JSON.
         * @function toJSON
         * @memberof propel.commrouter.ConversationEvent.SentenceCreated
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        SentenceCreated.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return SentenceCreated;
      })();

      ConversationEvent.SentenceUpdated = (function () {
        /**
         * Properties of a SentenceUpdated.
         * @memberof propel.commrouter.ConversationEvent
         * @interface ISentenceUpdated
         * @property {propel.commrouter.ISentence|null} [sentence] SentenceUpdated sentence
         */

        /**
         * Constructs a new SentenceUpdated.
         * @memberof propel.commrouter.ConversationEvent
         * @classdesc Represents a SentenceUpdated.
         * @implements ISentenceUpdated
         * @constructor
         * @param {propel.commrouter.ConversationEvent.ISentenceUpdated=} [properties] Properties to set
         */
        function SentenceUpdated(properties) {
          if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
              if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
        }

        /**
         * SentenceUpdated sentence.
         * @member {propel.commrouter.ISentence|null|undefined} sentence
         * @memberof propel.commrouter.ConversationEvent.SentenceUpdated
         * @instance
         */
        SentenceUpdated.prototype.sentence = null;

        /**
         * Creates a new SentenceUpdated instance using the specified properties.
         * @function create
         * @memberof propel.commrouter.ConversationEvent.SentenceUpdated
         * @static
         * @param {propel.commrouter.ConversationEvent.ISentenceUpdated=} [properties] Properties to set
         * @returns {propel.commrouter.ConversationEvent.SentenceUpdated} SentenceUpdated instance
         */
        SentenceUpdated.create = function create(properties) {
          return new SentenceUpdated(properties);
        };

        /**
         * Encodes the specified SentenceUpdated message. Does not implicitly {@link propel.commrouter.ConversationEvent.SentenceUpdated.verify|verify} messages.
         * @function encode
         * @memberof propel.commrouter.ConversationEvent.SentenceUpdated
         * @static
         * @param {propel.commrouter.ConversationEvent.ISentenceUpdated} message SentenceUpdated message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SentenceUpdated.encode = function encode(message, writer) {
          if (!writer) writer = $Writer.create();
          if (message.sentence != null && message.hasOwnProperty('sentence'))
            $root.propel.commrouter.Sentence.encode(
              message.sentence,
              writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
            ).ldelim();
          return writer;
        };

        /**
         * Encodes the specified SentenceUpdated message, length delimited. Does not implicitly {@link propel.commrouter.ConversationEvent.SentenceUpdated.verify|verify} messages.
         * @function encodeDelimited
         * @memberof propel.commrouter.ConversationEvent.SentenceUpdated
         * @static
         * @param {propel.commrouter.ConversationEvent.ISentenceUpdated} message SentenceUpdated message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SentenceUpdated.encodeDelimited = function encodeDelimited(message, writer) {
          return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a SentenceUpdated message from the specified reader or buffer.
         * @function decode
         * @memberof propel.commrouter.ConversationEvent.SentenceUpdated
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {propel.commrouter.ConversationEvent.SentenceUpdated} SentenceUpdated
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SentenceUpdated.decode = function decode(reader, length) {
          if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
          var end = length === undefined ? reader.len : reader.pos + length,
            message = new $root.propel.commrouter.ConversationEvent.SentenceUpdated();
          while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
              case 1:
                message.sentence = $root.propel.commrouter.Sentence.decode(reader, reader.uint32());
                break;
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };

        /**
         * Decodes a SentenceUpdated message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof propel.commrouter.ConversationEvent.SentenceUpdated
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {propel.commrouter.ConversationEvent.SentenceUpdated} SentenceUpdated
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SentenceUpdated.decodeDelimited = function decodeDelimited(reader) {
          if (!(reader instanceof $Reader)) reader = new $Reader(reader);
          return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a SentenceUpdated message.
         * @function verify
         * @memberof propel.commrouter.ConversationEvent.SentenceUpdated
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        SentenceUpdated.verify = function verify(message) {
          if (typeof message !== 'object' || message === null) return 'object expected';
          if (message.sentence != null && message.hasOwnProperty('sentence')) {
            var error = $root.propel.commrouter.Sentence.verify(message.sentence);
            if (error) return 'sentence.' + error;
          }
          return null;
        };

        /**
         * Creates a SentenceUpdated message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof propel.commrouter.ConversationEvent.SentenceUpdated
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {propel.commrouter.ConversationEvent.SentenceUpdated} SentenceUpdated
         */
        SentenceUpdated.fromObject = function fromObject(object) {
          if (object instanceof $root.propel.commrouter.ConversationEvent.SentenceUpdated)
            return object;
          var message = new $root.propel.commrouter.ConversationEvent.SentenceUpdated();
          if (object.sentence != null) {
            if (typeof object.sentence !== 'object')
              throw TypeError(
                '.propel.commrouter.ConversationEvent.SentenceUpdated.sentence: object expected'
              );
            message.sentence = $root.propel.commrouter.Sentence.fromObject(object.sentence);
          }
          return message;
        };

        /**
         * Creates a plain object from a SentenceUpdated message. Also converts values to other types if specified.
         * @function toObject
         * @memberof propel.commrouter.ConversationEvent.SentenceUpdated
         * @static
         * @param {propel.commrouter.ConversationEvent.SentenceUpdated} message SentenceUpdated
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        SentenceUpdated.toObject = function toObject(message, options) {
          if (!options) options = {};
          var object = {};
          if (options.defaults) object.sentence = null;
          if (message.sentence != null && message.hasOwnProperty('sentence'))
            object.sentence = $root.propel.commrouter.Sentence.toObject(message.sentence, options);
          return object;
        };

        /**
         * Converts this SentenceUpdated to JSON.
         * @function toJSON
         * @memberof propel.commrouter.ConversationEvent.SentenceUpdated
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        SentenceUpdated.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return SentenceUpdated;
      })();

      ConversationEvent.ResponseCreated = (function () {
        /**
         * Properties of a ResponseCreated.
         * @memberof propel.commrouter.ConversationEvent
         * @interface IResponseCreated
         * @property {propel.commrouter.IResponse|null} [response] ResponseCreated response
         */

        /**
         * Constructs a new ResponseCreated.
         * @memberof propel.commrouter.ConversationEvent
         * @classdesc Represents a ResponseCreated.
         * @implements IResponseCreated
         * @constructor
         * @param {propel.commrouter.ConversationEvent.IResponseCreated=} [properties] Properties to set
         */
        function ResponseCreated(properties) {
          if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
              if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
        }

        /**
         * ResponseCreated response.
         * @member {propel.commrouter.IResponse|null|undefined} response
         * @memberof propel.commrouter.ConversationEvent.ResponseCreated
         * @instance
         */
        ResponseCreated.prototype.response = null;

        /**
         * Creates a new ResponseCreated instance using the specified properties.
         * @function create
         * @memberof propel.commrouter.ConversationEvent.ResponseCreated
         * @static
         * @param {propel.commrouter.ConversationEvent.IResponseCreated=} [properties] Properties to set
         * @returns {propel.commrouter.ConversationEvent.ResponseCreated} ResponseCreated instance
         */
        ResponseCreated.create = function create(properties) {
          return new ResponseCreated(properties);
        };

        /**
         * Encodes the specified ResponseCreated message. Does not implicitly {@link propel.commrouter.ConversationEvent.ResponseCreated.verify|verify} messages.
         * @function encode
         * @memberof propel.commrouter.ConversationEvent.ResponseCreated
         * @static
         * @param {propel.commrouter.ConversationEvent.IResponseCreated} message ResponseCreated message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ResponseCreated.encode = function encode(message, writer) {
          if (!writer) writer = $Writer.create();
          if (message.response != null && message.hasOwnProperty('response'))
            $root.propel.commrouter.Response.encode(
              message.response,
              writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
            ).ldelim();
          return writer;
        };

        /**
         * Encodes the specified ResponseCreated message, length delimited. Does not implicitly {@link propel.commrouter.ConversationEvent.ResponseCreated.verify|verify} messages.
         * @function encodeDelimited
         * @memberof propel.commrouter.ConversationEvent.ResponseCreated
         * @static
         * @param {propel.commrouter.ConversationEvent.IResponseCreated} message ResponseCreated message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ResponseCreated.encodeDelimited = function encodeDelimited(message, writer) {
          return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a ResponseCreated message from the specified reader or buffer.
         * @function decode
         * @memberof propel.commrouter.ConversationEvent.ResponseCreated
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {propel.commrouter.ConversationEvent.ResponseCreated} ResponseCreated
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ResponseCreated.decode = function decode(reader, length) {
          if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
          var end = length === undefined ? reader.len : reader.pos + length,
            message = new $root.propel.commrouter.ConversationEvent.ResponseCreated();
          while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
              case 1:
                message.response = $root.propel.commrouter.Response.decode(reader, reader.uint32());
                break;
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };

        /**
         * Decodes a ResponseCreated message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof propel.commrouter.ConversationEvent.ResponseCreated
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {propel.commrouter.ConversationEvent.ResponseCreated} ResponseCreated
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ResponseCreated.decodeDelimited = function decodeDelimited(reader) {
          if (!(reader instanceof $Reader)) reader = new $Reader(reader);
          return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ResponseCreated message.
         * @function verify
         * @memberof propel.commrouter.ConversationEvent.ResponseCreated
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ResponseCreated.verify = function verify(message) {
          if (typeof message !== 'object' || message === null) return 'object expected';
          if (message.response != null && message.hasOwnProperty('response')) {
            var error = $root.propel.commrouter.Response.verify(message.response);
            if (error) return 'response.' + error;
          }
          return null;
        };

        /**
         * Creates a ResponseCreated message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof propel.commrouter.ConversationEvent.ResponseCreated
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {propel.commrouter.ConversationEvent.ResponseCreated} ResponseCreated
         */
        ResponseCreated.fromObject = function fromObject(object) {
          if (object instanceof $root.propel.commrouter.ConversationEvent.ResponseCreated)
            return object;
          var message = new $root.propel.commrouter.ConversationEvent.ResponseCreated();
          if (object.response != null) {
            if (typeof object.response !== 'object')
              throw TypeError(
                '.propel.commrouter.ConversationEvent.ResponseCreated.response: object expected'
              );
            message.response = $root.propel.commrouter.Response.fromObject(object.response);
          }
          return message;
        };

        /**
         * Creates a plain object from a ResponseCreated message. Also converts values to other types if specified.
         * @function toObject
         * @memberof propel.commrouter.ConversationEvent.ResponseCreated
         * @static
         * @param {propel.commrouter.ConversationEvent.ResponseCreated} message ResponseCreated
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ResponseCreated.toObject = function toObject(message, options) {
          if (!options) options = {};
          var object = {};
          if (options.defaults) object.response = null;
          if (message.response != null && message.hasOwnProperty('response'))
            object.response = $root.propel.commrouter.Response.toObject(message.response, options);
          return object;
        };

        /**
         * Converts this ResponseCreated to JSON.
         * @function toJSON
         * @memberof propel.commrouter.ConversationEvent.ResponseCreated
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ResponseCreated.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ResponseCreated;
      })();

      ConversationEvent.ResponseUpdated = (function () {
        /**
         * Properties of a ResponseUpdated.
         * @memberof propel.commrouter.ConversationEvent
         * @interface IResponseUpdated
         * @property {propel.commrouter.IResponse|null} [response] ResponseUpdated response
         */

        /**
         * Constructs a new ResponseUpdated.
         * @memberof propel.commrouter.ConversationEvent
         * @classdesc Represents a ResponseUpdated.
         * @implements IResponseUpdated
         * @constructor
         * @param {propel.commrouter.ConversationEvent.IResponseUpdated=} [properties] Properties to set
         */
        function ResponseUpdated(properties) {
          if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
              if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
        }

        /**
         * ResponseUpdated response.
         * @member {propel.commrouter.IResponse|null|undefined} response
         * @memberof propel.commrouter.ConversationEvent.ResponseUpdated
         * @instance
         */
        ResponseUpdated.prototype.response = null;

        /**
         * Creates a new ResponseUpdated instance using the specified properties.
         * @function create
         * @memberof propel.commrouter.ConversationEvent.ResponseUpdated
         * @static
         * @param {propel.commrouter.ConversationEvent.IResponseUpdated=} [properties] Properties to set
         * @returns {propel.commrouter.ConversationEvent.ResponseUpdated} ResponseUpdated instance
         */
        ResponseUpdated.create = function create(properties) {
          return new ResponseUpdated(properties);
        };

        /**
         * Encodes the specified ResponseUpdated message. Does not implicitly {@link propel.commrouter.ConversationEvent.ResponseUpdated.verify|verify} messages.
         * @function encode
         * @memberof propel.commrouter.ConversationEvent.ResponseUpdated
         * @static
         * @param {propel.commrouter.ConversationEvent.IResponseUpdated} message ResponseUpdated message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ResponseUpdated.encode = function encode(message, writer) {
          if (!writer) writer = $Writer.create();
          if (message.response != null && message.hasOwnProperty('response'))
            $root.propel.commrouter.Response.encode(
              message.response,
              writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
            ).ldelim();
          return writer;
        };

        /**
         * Encodes the specified ResponseUpdated message, length delimited. Does not implicitly {@link propel.commrouter.ConversationEvent.ResponseUpdated.verify|verify} messages.
         * @function encodeDelimited
         * @memberof propel.commrouter.ConversationEvent.ResponseUpdated
         * @static
         * @param {propel.commrouter.ConversationEvent.IResponseUpdated} message ResponseUpdated message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ResponseUpdated.encodeDelimited = function encodeDelimited(message, writer) {
          return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a ResponseUpdated message from the specified reader or buffer.
         * @function decode
         * @memberof propel.commrouter.ConversationEvent.ResponseUpdated
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {propel.commrouter.ConversationEvent.ResponseUpdated} ResponseUpdated
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ResponseUpdated.decode = function decode(reader, length) {
          if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
          var end = length === undefined ? reader.len : reader.pos + length,
            message = new $root.propel.commrouter.ConversationEvent.ResponseUpdated();
          while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
              case 1:
                message.response = $root.propel.commrouter.Response.decode(reader, reader.uint32());
                break;
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };

        /**
         * Decodes a ResponseUpdated message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof propel.commrouter.ConversationEvent.ResponseUpdated
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {propel.commrouter.ConversationEvent.ResponseUpdated} ResponseUpdated
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ResponseUpdated.decodeDelimited = function decodeDelimited(reader) {
          if (!(reader instanceof $Reader)) reader = new $Reader(reader);
          return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ResponseUpdated message.
         * @function verify
         * @memberof propel.commrouter.ConversationEvent.ResponseUpdated
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ResponseUpdated.verify = function verify(message) {
          if (typeof message !== 'object' || message === null) return 'object expected';
          if (message.response != null && message.hasOwnProperty('response')) {
            var error = $root.propel.commrouter.Response.verify(message.response);
            if (error) return 'response.' + error;
          }
          return null;
        };

        /**
         * Creates a ResponseUpdated message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof propel.commrouter.ConversationEvent.ResponseUpdated
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {propel.commrouter.ConversationEvent.ResponseUpdated} ResponseUpdated
         */
        ResponseUpdated.fromObject = function fromObject(object) {
          if (object instanceof $root.propel.commrouter.ConversationEvent.ResponseUpdated)
            return object;
          var message = new $root.propel.commrouter.ConversationEvent.ResponseUpdated();
          if (object.response != null) {
            if (typeof object.response !== 'object')
              throw TypeError(
                '.propel.commrouter.ConversationEvent.ResponseUpdated.response: object expected'
              );
            message.response = $root.propel.commrouter.Response.fromObject(object.response);
          }
          return message;
        };

        /**
         * Creates a plain object from a ResponseUpdated message. Also converts values to other types if specified.
         * @function toObject
         * @memberof propel.commrouter.ConversationEvent.ResponseUpdated
         * @static
         * @param {propel.commrouter.ConversationEvent.ResponseUpdated} message ResponseUpdated
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ResponseUpdated.toObject = function toObject(message, options) {
          if (!options) options = {};
          var object = {};
          if (options.defaults) object.response = null;
          if (message.response != null && message.hasOwnProperty('response'))
            object.response = $root.propel.commrouter.Response.toObject(message.response, options);
          return object;
        };

        /**
         * Converts this ResponseUpdated to JSON.
         * @function toJSON
         * @memberof propel.commrouter.ConversationEvent.ResponseUpdated
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ResponseUpdated.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ResponseUpdated;
      })();

      ConversationEvent.ConversationStateUpdated = (function () {
        /**
         * Properties of a ConversationStateUpdated.
         * @memberof propel.commrouter.ConversationEvent
         * @interface IConversationStateUpdated
         * @property {propel.commrouter.IConversationState|null} [conversationState] ConversationStateUpdated conversationState
         */

        /**
         * Constructs a new ConversationStateUpdated.
         * @memberof propel.commrouter.ConversationEvent
         * @classdesc Represents a ConversationStateUpdated.
         * @implements IConversationStateUpdated
         * @constructor
         * @param {propel.commrouter.ConversationEvent.IConversationStateUpdated=} [properties] Properties to set
         */
        function ConversationStateUpdated(properties) {
          if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
              if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
        }

        /**
         * ConversationStateUpdated conversationState.
         * @member {propel.commrouter.IConversationState|null|undefined} conversationState
         * @memberof propel.commrouter.ConversationEvent.ConversationStateUpdated
         * @instance
         */
        ConversationStateUpdated.prototype.conversationState = null;

        /**
         * Creates a new ConversationStateUpdated instance using the specified properties.
         * @function create
         * @memberof propel.commrouter.ConversationEvent.ConversationStateUpdated
         * @static
         * @param {propel.commrouter.ConversationEvent.IConversationStateUpdated=} [properties] Properties to set
         * @returns {propel.commrouter.ConversationEvent.ConversationStateUpdated} ConversationStateUpdated instance
         */
        ConversationStateUpdated.create = function create(properties) {
          return new ConversationStateUpdated(properties);
        };

        /**
         * Encodes the specified ConversationStateUpdated message. Does not implicitly {@link propel.commrouter.ConversationEvent.ConversationStateUpdated.verify|verify} messages.
         * @function encode
         * @memberof propel.commrouter.ConversationEvent.ConversationStateUpdated
         * @static
         * @param {propel.commrouter.ConversationEvent.IConversationStateUpdated} message ConversationStateUpdated message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ConversationStateUpdated.encode = function encode(message, writer) {
          if (!writer) writer = $Writer.create();
          if (message.conversationState != null && message.hasOwnProperty('conversationState'))
            $root.propel.commrouter.ConversationState.encode(
              message.conversationState,
              writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
            ).ldelim();
          return writer;
        };

        /**
         * Encodes the specified ConversationStateUpdated message, length delimited. Does not implicitly {@link propel.commrouter.ConversationEvent.ConversationStateUpdated.verify|verify} messages.
         * @function encodeDelimited
         * @memberof propel.commrouter.ConversationEvent.ConversationStateUpdated
         * @static
         * @param {propel.commrouter.ConversationEvent.IConversationStateUpdated} message ConversationStateUpdated message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ConversationStateUpdated.encodeDelimited = function encodeDelimited(message, writer) {
          return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a ConversationStateUpdated message from the specified reader or buffer.
         * @function decode
         * @memberof propel.commrouter.ConversationEvent.ConversationStateUpdated
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {propel.commrouter.ConversationEvent.ConversationStateUpdated} ConversationStateUpdated
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ConversationStateUpdated.decode = function decode(reader, length) {
          if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
          var end = length === undefined ? reader.len : reader.pos + length,
            message = new $root.propel.commrouter.ConversationEvent.ConversationStateUpdated();
          while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
              case 1:
                message.conversationState = $root.propel.commrouter.ConversationState.decode(
                  reader,
                  reader.uint32()
                );
                break;
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };

        /**
         * Decodes a ConversationStateUpdated message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof propel.commrouter.ConversationEvent.ConversationStateUpdated
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {propel.commrouter.ConversationEvent.ConversationStateUpdated} ConversationStateUpdated
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ConversationStateUpdated.decodeDelimited = function decodeDelimited(reader) {
          if (!(reader instanceof $Reader)) reader = new $Reader(reader);
          return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ConversationStateUpdated message.
         * @function verify
         * @memberof propel.commrouter.ConversationEvent.ConversationStateUpdated
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ConversationStateUpdated.verify = function verify(message) {
          if (typeof message !== 'object' || message === null) return 'object expected';
          if (message.conversationState != null && message.hasOwnProperty('conversationState')) {
            var error = $root.propel.commrouter.ConversationState.verify(message.conversationState);
            if (error) return 'conversationState.' + error;
          }
          return null;
        };

        /**
         * Creates a ConversationStateUpdated message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof propel.commrouter.ConversationEvent.ConversationStateUpdated
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {propel.commrouter.ConversationEvent.ConversationStateUpdated} ConversationStateUpdated
         */
        ConversationStateUpdated.fromObject = function fromObject(object) {
          if (object instanceof $root.propel.commrouter.ConversationEvent.ConversationStateUpdated)
            return object;
          var message = new $root.propel.commrouter.ConversationEvent.ConversationStateUpdated();
          if (object.conversationState != null) {
            if (typeof object.conversationState !== 'object')
              throw TypeError(
                '.propel.commrouter.ConversationEvent.ConversationStateUpdated.conversationState: object expected'
              );
            message.conversationState = $root.propel.commrouter.ConversationState.fromObject(
              object.conversationState
            );
          }
          return message;
        };

        /**
         * Creates a plain object from a ConversationStateUpdated message. Also converts values to other types if specified.
         * @function toObject
         * @memberof propel.commrouter.ConversationEvent.ConversationStateUpdated
         * @static
         * @param {propel.commrouter.ConversationEvent.ConversationStateUpdated} message ConversationStateUpdated
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ConversationStateUpdated.toObject = function toObject(message, options) {
          if (!options) options = {};
          var object = {};
          if (options.defaults) object.conversationState = null;
          if (message.conversationState != null && message.hasOwnProperty('conversationState'))
            object.conversationState = $root.propel.commrouter.ConversationState.toObject(
              message.conversationState,
              options
            );
          return object;
        };

        /**
         * Converts this ConversationStateUpdated to JSON.
         * @function toJSON
         * @memberof propel.commrouter.ConversationEvent.ConversationStateUpdated
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ConversationStateUpdated.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ConversationStateUpdated;
      })();

      ConversationEvent.ContextUpdated = (function () {
        /**
         * Properties of a ContextUpdated.
         * @memberof propel.commrouter.ConversationEvent
         * @interface IContextUpdated
         * @property {propel.commrouter.IContext|null} [context] ContextUpdated context
         */

        /**
         * Constructs a new ContextUpdated.
         * @memberof propel.commrouter.ConversationEvent
         * @classdesc Represents a ContextUpdated.
         * @implements IContextUpdated
         * @constructor
         * @param {propel.commrouter.ConversationEvent.IContextUpdated=} [properties] Properties to set
         */
        function ContextUpdated(properties) {
          if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
              if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
        }

        /**
         * ContextUpdated context.
         * @member {propel.commrouter.IContext|null|undefined} context
         * @memberof propel.commrouter.ConversationEvent.ContextUpdated
         * @instance
         */
        ContextUpdated.prototype.context = null;

        /**
         * Creates a new ContextUpdated instance using the specified properties.
         * @function create
         * @memberof propel.commrouter.ConversationEvent.ContextUpdated
         * @static
         * @param {propel.commrouter.ConversationEvent.IContextUpdated=} [properties] Properties to set
         * @returns {propel.commrouter.ConversationEvent.ContextUpdated} ContextUpdated instance
         */
        ContextUpdated.create = function create(properties) {
          return new ContextUpdated(properties);
        };

        /**
         * Encodes the specified ContextUpdated message. Does not implicitly {@link propel.commrouter.ConversationEvent.ContextUpdated.verify|verify} messages.
         * @function encode
         * @memberof propel.commrouter.ConversationEvent.ContextUpdated
         * @static
         * @param {propel.commrouter.ConversationEvent.IContextUpdated} message ContextUpdated message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ContextUpdated.encode = function encode(message, writer) {
          if (!writer) writer = $Writer.create();
          if (message.context != null && message.hasOwnProperty('context'))
            $root.propel.commrouter.Context.encode(
              message.context,
              writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
            ).ldelim();
          return writer;
        };

        /**
         * Encodes the specified ContextUpdated message, length delimited. Does not implicitly {@link propel.commrouter.ConversationEvent.ContextUpdated.verify|verify} messages.
         * @function encodeDelimited
         * @memberof propel.commrouter.ConversationEvent.ContextUpdated
         * @static
         * @param {propel.commrouter.ConversationEvent.IContextUpdated} message ContextUpdated message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ContextUpdated.encodeDelimited = function encodeDelimited(message, writer) {
          return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a ContextUpdated message from the specified reader or buffer.
         * @function decode
         * @memberof propel.commrouter.ConversationEvent.ContextUpdated
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {propel.commrouter.ConversationEvent.ContextUpdated} ContextUpdated
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ContextUpdated.decode = function decode(reader, length) {
          if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
          var end = length === undefined ? reader.len : reader.pos + length,
            message = new $root.propel.commrouter.ConversationEvent.ContextUpdated();
          while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
              case 1:
                message.context = $root.propel.commrouter.Context.decode(reader, reader.uint32());
                break;
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };

        /**
         * Decodes a ContextUpdated message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof propel.commrouter.ConversationEvent.ContextUpdated
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {propel.commrouter.ConversationEvent.ContextUpdated} ContextUpdated
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ContextUpdated.decodeDelimited = function decodeDelimited(reader) {
          if (!(reader instanceof $Reader)) reader = new $Reader(reader);
          return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ContextUpdated message.
         * @function verify
         * @memberof propel.commrouter.ConversationEvent.ContextUpdated
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ContextUpdated.verify = function verify(message) {
          if (typeof message !== 'object' || message === null) return 'object expected';
          if (message.context != null && message.hasOwnProperty('context')) {
            var error = $root.propel.commrouter.Context.verify(message.context);
            if (error) return 'context.' + error;
          }
          return null;
        };

        /**
         * Creates a ContextUpdated message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof propel.commrouter.ConversationEvent.ContextUpdated
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {propel.commrouter.ConversationEvent.ContextUpdated} ContextUpdated
         */
        ContextUpdated.fromObject = function fromObject(object) {
          if (object instanceof $root.propel.commrouter.ConversationEvent.ContextUpdated)
            return object;
          var message = new $root.propel.commrouter.ConversationEvent.ContextUpdated();
          if (object.context != null) {
            if (typeof object.context !== 'object')
              throw TypeError(
                '.propel.commrouter.ConversationEvent.ContextUpdated.context: object expected'
              );
            message.context = $root.propel.commrouter.Context.fromObject(object.context);
          }
          return message;
        };

        /**
         * Creates a plain object from a ContextUpdated message. Also converts values to other types if specified.
         * @function toObject
         * @memberof propel.commrouter.ConversationEvent.ContextUpdated
         * @static
         * @param {propel.commrouter.ConversationEvent.ContextUpdated} message ContextUpdated
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ContextUpdated.toObject = function toObject(message, options) {
          if (!options) options = {};
          var object = {};
          if (options.defaults) object.context = null;
          if (message.context != null && message.hasOwnProperty('context'))
            object.context = $root.propel.commrouter.Context.toObject(message.context, options);
          return object;
        };

        /**
         * Converts this ContextUpdated to JSON.
         * @function toJSON
         * @memberof propel.commrouter.ConversationEvent.ContextUpdated
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ContextUpdated.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ContextUpdated;
      })();

      ConversationEvent.ConversationModeUpdated = (function () {
        /**
         * Properties of a ConversationModeUpdated.
         * @memberof propel.commrouter.ConversationEvent
         * @interface IConversationModeUpdated
         * @property {propel.commrouter.IConversationMode|null} [conversationMode] ConversationModeUpdated conversationMode
         * @property {propel.commrouter.IConversationMode|null} [previousConversationMode] ConversationModeUpdated previousConversationMode
         */

        /**
         * Constructs a new ConversationModeUpdated.
         * @memberof propel.commrouter.ConversationEvent
         * @classdesc Represents a ConversationModeUpdated.
         * @implements IConversationModeUpdated
         * @constructor
         * @param {propel.commrouter.ConversationEvent.IConversationModeUpdated=} [properties] Properties to set
         */
        function ConversationModeUpdated(properties) {
          if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
              if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
        }

        /**
         * ConversationModeUpdated conversationMode.
         * @member {propel.commrouter.IConversationMode|null|undefined} conversationMode
         * @memberof propel.commrouter.ConversationEvent.ConversationModeUpdated
         * @instance
         */
        ConversationModeUpdated.prototype.conversationMode = null;

        /**
         * ConversationModeUpdated previousConversationMode.
         * @member {propel.commrouter.IConversationMode|null|undefined} previousConversationMode
         * @memberof propel.commrouter.ConversationEvent.ConversationModeUpdated
         * @instance
         */
        ConversationModeUpdated.prototype.previousConversationMode = null;

        /**
         * Creates a new ConversationModeUpdated instance using the specified properties.
         * @function create
         * @memberof propel.commrouter.ConversationEvent.ConversationModeUpdated
         * @static
         * @param {propel.commrouter.ConversationEvent.IConversationModeUpdated=} [properties] Properties to set
         * @returns {propel.commrouter.ConversationEvent.ConversationModeUpdated} ConversationModeUpdated instance
         */
        ConversationModeUpdated.create = function create(properties) {
          return new ConversationModeUpdated(properties);
        };

        /**
         * Encodes the specified ConversationModeUpdated message. Does not implicitly {@link propel.commrouter.ConversationEvent.ConversationModeUpdated.verify|verify} messages.
         * @function encode
         * @memberof propel.commrouter.ConversationEvent.ConversationModeUpdated
         * @static
         * @param {propel.commrouter.ConversationEvent.IConversationModeUpdated} message ConversationModeUpdated message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ConversationModeUpdated.encode = function encode(message, writer) {
          if (!writer) writer = $Writer.create();
          if (message.conversationMode != null && message.hasOwnProperty('conversationMode'))
            $root.propel.commrouter.ConversationMode.encode(
              message.conversationMode,
              writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
            ).ldelim();
          if (
            message.previousConversationMode != null &&
            message.hasOwnProperty('previousConversationMode')
          )
            $root.propel.commrouter.ConversationMode.encode(
              message.previousConversationMode,
              writer.uint32(/* id 2, wireType 2 =*/ 18).fork()
            ).ldelim();
          return writer;
        };

        /**
         * Encodes the specified ConversationModeUpdated message, length delimited. Does not implicitly {@link propel.commrouter.ConversationEvent.ConversationModeUpdated.verify|verify} messages.
         * @function encodeDelimited
         * @memberof propel.commrouter.ConversationEvent.ConversationModeUpdated
         * @static
         * @param {propel.commrouter.ConversationEvent.IConversationModeUpdated} message ConversationModeUpdated message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ConversationModeUpdated.encodeDelimited = function encodeDelimited(message, writer) {
          return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a ConversationModeUpdated message from the specified reader or buffer.
         * @function decode
         * @memberof propel.commrouter.ConversationEvent.ConversationModeUpdated
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {propel.commrouter.ConversationEvent.ConversationModeUpdated} ConversationModeUpdated
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ConversationModeUpdated.decode = function decode(reader, length) {
          if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
          var end = length === undefined ? reader.len : reader.pos + length,
            message = new $root.propel.commrouter.ConversationEvent.ConversationModeUpdated();
          while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
              case 1:
                message.conversationMode = $root.propel.commrouter.ConversationMode.decode(
                  reader,
                  reader.uint32()
                );
                break;
              case 2:
                message.previousConversationMode = $root.propel.commrouter.ConversationMode.decode(
                  reader,
                  reader.uint32()
                );
                break;
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };

        /**
         * Decodes a ConversationModeUpdated message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof propel.commrouter.ConversationEvent.ConversationModeUpdated
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {propel.commrouter.ConversationEvent.ConversationModeUpdated} ConversationModeUpdated
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ConversationModeUpdated.decodeDelimited = function decodeDelimited(reader) {
          if (!(reader instanceof $Reader)) reader = new $Reader(reader);
          return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ConversationModeUpdated message.
         * @function verify
         * @memberof propel.commrouter.ConversationEvent.ConversationModeUpdated
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ConversationModeUpdated.verify = function verify(message) {
          if (typeof message !== 'object' || message === null) return 'object expected';
          if (message.conversationMode != null && message.hasOwnProperty('conversationMode')) {
            var error = $root.propel.commrouter.ConversationMode.verify(message.conversationMode);
            if (error) return 'conversationMode.' + error;
          }
          if (
            message.previousConversationMode != null &&
            message.hasOwnProperty('previousConversationMode')
          ) {
            var error = $root.propel.commrouter.ConversationMode.verify(
              message.previousConversationMode
            );
            if (error) return 'previousConversationMode.' + error;
          }
          return null;
        };

        /**
         * Creates a ConversationModeUpdated message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof propel.commrouter.ConversationEvent.ConversationModeUpdated
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {propel.commrouter.ConversationEvent.ConversationModeUpdated} ConversationModeUpdated
         */
        ConversationModeUpdated.fromObject = function fromObject(object) {
          if (object instanceof $root.propel.commrouter.ConversationEvent.ConversationModeUpdated)
            return object;
          var message = new $root.propel.commrouter.ConversationEvent.ConversationModeUpdated();
          if (object.conversationMode != null) {
            if (typeof object.conversationMode !== 'object')
              throw TypeError(
                '.propel.commrouter.ConversationEvent.ConversationModeUpdated.conversationMode: object expected'
              );
            message.conversationMode = $root.propel.commrouter.ConversationMode.fromObject(
              object.conversationMode
            );
          }
          if (object.previousConversationMode != null) {
            if (typeof object.previousConversationMode !== 'object')
              throw TypeError(
                '.propel.commrouter.ConversationEvent.ConversationModeUpdated.previousConversationMode: object expected'
              );
            message.previousConversationMode = $root.propel.commrouter.ConversationMode.fromObject(
              object.previousConversationMode
            );
          }
          return message;
        };

        /**
         * Creates a plain object from a ConversationModeUpdated message. Also converts values to other types if specified.
         * @function toObject
         * @memberof propel.commrouter.ConversationEvent.ConversationModeUpdated
         * @static
         * @param {propel.commrouter.ConversationEvent.ConversationModeUpdated} message ConversationModeUpdated
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ConversationModeUpdated.toObject = function toObject(message, options) {
          if (!options) options = {};
          var object = {};
          if (options.defaults) {
            object.conversationMode = null;
            object.previousConversationMode = null;
          }
          if (message.conversationMode != null && message.hasOwnProperty('conversationMode'))
            object.conversationMode = $root.propel.commrouter.ConversationMode.toObject(
              message.conversationMode,
              options
            );
          if (
            message.previousConversationMode != null &&
            message.hasOwnProperty('previousConversationMode')
          )
            object.previousConversationMode = $root.propel.commrouter.ConversationMode.toObject(
              message.previousConversationMode,
              options
            );
          return object;
        };

        /**
         * Converts this ConversationModeUpdated to JSON.
         * @function toJSON
         * @memberof propel.commrouter.ConversationEvent.ConversationModeUpdated
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ConversationModeUpdated.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ConversationModeUpdated;
      })();

      ConversationEvent.EngineStateUpdated = (function () {
        /**
         * Properties of an EngineStateUpdated.
         * @memberof propel.commrouter.ConversationEvent
         * @interface IEngineStateUpdated
         * @property {propel.commrouter.IEngineState|null} [engineState] EngineStateUpdated engineState
         */

        /**
         * Constructs a new EngineStateUpdated.
         * @memberof propel.commrouter.ConversationEvent
         * @classdesc Represents an EngineStateUpdated.
         * @implements IEngineStateUpdated
         * @constructor
         * @param {propel.commrouter.ConversationEvent.IEngineStateUpdated=} [properties] Properties to set
         */
        function EngineStateUpdated(properties) {
          if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
              if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
        }

        /**
         * EngineStateUpdated engineState.
         * @member {propel.commrouter.IEngineState|null|undefined} engineState
         * @memberof propel.commrouter.ConversationEvent.EngineStateUpdated
         * @instance
         */
        EngineStateUpdated.prototype.engineState = null;

        /**
         * Creates a new EngineStateUpdated instance using the specified properties.
         * @function create
         * @memberof propel.commrouter.ConversationEvent.EngineStateUpdated
         * @static
         * @param {propel.commrouter.ConversationEvent.IEngineStateUpdated=} [properties] Properties to set
         * @returns {propel.commrouter.ConversationEvent.EngineStateUpdated} EngineStateUpdated instance
         */
        EngineStateUpdated.create = function create(properties) {
          return new EngineStateUpdated(properties);
        };

        /**
         * Encodes the specified EngineStateUpdated message. Does not implicitly {@link propel.commrouter.ConversationEvent.EngineStateUpdated.verify|verify} messages.
         * @function encode
         * @memberof propel.commrouter.ConversationEvent.EngineStateUpdated
         * @static
         * @param {propel.commrouter.ConversationEvent.IEngineStateUpdated} message EngineStateUpdated message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        EngineStateUpdated.encode = function encode(message, writer) {
          if (!writer) writer = $Writer.create();
          if (message.engineState != null && message.hasOwnProperty('engineState'))
            $root.propel.commrouter.EngineState.encode(
              message.engineState,
              writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
            ).ldelim();
          return writer;
        };

        /**
         * Encodes the specified EngineStateUpdated message, length delimited. Does not implicitly {@link propel.commrouter.ConversationEvent.EngineStateUpdated.verify|verify} messages.
         * @function encodeDelimited
         * @memberof propel.commrouter.ConversationEvent.EngineStateUpdated
         * @static
         * @param {propel.commrouter.ConversationEvent.IEngineStateUpdated} message EngineStateUpdated message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        EngineStateUpdated.encodeDelimited = function encodeDelimited(message, writer) {
          return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an EngineStateUpdated message from the specified reader or buffer.
         * @function decode
         * @memberof propel.commrouter.ConversationEvent.EngineStateUpdated
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {propel.commrouter.ConversationEvent.EngineStateUpdated} EngineStateUpdated
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        EngineStateUpdated.decode = function decode(reader, length) {
          if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
          var end = length === undefined ? reader.len : reader.pos + length,
            message = new $root.propel.commrouter.ConversationEvent.EngineStateUpdated();
          while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
              case 1:
                message.engineState = $root.propel.commrouter.EngineState.decode(
                  reader,
                  reader.uint32()
                );
                break;
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };

        /**
         * Decodes an EngineStateUpdated message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof propel.commrouter.ConversationEvent.EngineStateUpdated
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {propel.commrouter.ConversationEvent.EngineStateUpdated} EngineStateUpdated
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        EngineStateUpdated.decodeDelimited = function decodeDelimited(reader) {
          if (!(reader instanceof $Reader)) reader = new $Reader(reader);
          return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an EngineStateUpdated message.
         * @function verify
         * @memberof propel.commrouter.ConversationEvent.EngineStateUpdated
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        EngineStateUpdated.verify = function verify(message) {
          if (typeof message !== 'object' || message === null) return 'object expected';
          if (message.engineState != null && message.hasOwnProperty('engineState')) {
            var error = $root.propel.commrouter.EngineState.verify(message.engineState);
            if (error) return 'engineState.' + error;
          }
          return null;
        };

        /**
         * Creates an EngineStateUpdated message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof propel.commrouter.ConversationEvent.EngineStateUpdated
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {propel.commrouter.ConversationEvent.EngineStateUpdated} EngineStateUpdated
         */
        EngineStateUpdated.fromObject = function fromObject(object) {
          if (object instanceof $root.propel.commrouter.ConversationEvent.EngineStateUpdated)
            return object;
          var message = new $root.propel.commrouter.ConversationEvent.EngineStateUpdated();
          if (object.engineState != null) {
            if (typeof object.engineState !== 'object')
              throw TypeError(
                '.propel.commrouter.ConversationEvent.EngineStateUpdated.engineState: object expected'
              );
            message.engineState = $root.propel.commrouter.EngineState.fromObject(
              object.engineState
            );
          }
          return message;
        };

        /**
         * Creates a plain object from an EngineStateUpdated message. Also converts values to other types if specified.
         * @function toObject
         * @memberof propel.commrouter.ConversationEvent.EngineStateUpdated
         * @static
         * @param {propel.commrouter.ConversationEvent.EngineStateUpdated} message EngineStateUpdated
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        EngineStateUpdated.toObject = function toObject(message, options) {
          if (!options) options = {};
          var object = {};
          if (options.defaults) object.engineState = null;
          if (message.engineState != null && message.hasOwnProperty('engineState'))
            object.engineState = $root.propel.commrouter.EngineState.toObject(
              message.engineState,
              options
            );
          return object;
        };

        /**
         * Converts this EngineStateUpdated to JSON.
         * @function toJSON
         * @memberof propel.commrouter.ConversationEvent.EngineStateUpdated
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        EngineStateUpdated.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return EngineStateUpdated;
      })();

      ConversationEvent.ChannelInfoUpdated = (function () {
        /**
         * Properties of a ChannelInfoUpdated.
         * @memberof propel.commrouter.ConversationEvent
         * @interface IChannelInfoUpdated
         * @property {propel.commrouter.IVendorId|null} [channelId] ChannelInfoUpdated channelId
         * @property {google.protobuf.IStruct|null} [info] ChannelInfoUpdated info
         */

        /**
         * Constructs a new ChannelInfoUpdated.
         * @memberof propel.commrouter.ConversationEvent
         * @classdesc Represents a ChannelInfoUpdated.
         * @implements IChannelInfoUpdated
         * @constructor
         * @param {propel.commrouter.ConversationEvent.IChannelInfoUpdated=} [properties] Properties to set
         */
        function ChannelInfoUpdated(properties) {
          if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
              if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
        }

        /**
         * ChannelInfoUpdated channelId.
         * @member {propel.commrouter.IVendorId|null|undefined} channelId
         * @memberof propel.commrouter.ConversationEvent.ChannelInfoUpdated
         * @instance
         */
        ChannelInfoUpdated.prototype.channelId = null;

        /**
         * ChannelInfoUpdated info.
         * @member {google.protobuf.IStruct|null|undefined} info
         * @memberof propel.commrouter.ConversationEvent.ChannelInfoUpdated
         * @instance
         */
        ChannelInfoUpdated.prototype.info = null;

        /**
         * Creates a new ChannelInfoUpdated instance using the specified properties.
         * @function create
         * @memberof propel.commrouter.ConversationEvent.ChannelInfoUpdated
         * @static
         * @param {propel.commrouter.ConversationEvent.IChannelInfoUpdated=} [properties] Properties to set
         * @returns {propel.commrouter.ConversationEvent.ChannelInfoUpdated} ChannelInfoUpdated instance
         */
        ChannelInfoUpdated.create = function create(properties) {
          return new ChannelInfoUpdated(properties);
        };

        /**
         * Encodes the specified ChannelInfoUpdated message. Does not implicitly {@link propel.commrouter.ConversationEvent.ChannelInfoUpdated.verify|verify} messages.
         * @function encode
         * @memberof propel.commrouter.ConversationEvent.ChannelInfoUpdated
         * @static
         * @param {propel.commrouter.ConversationEvent.IChannelInfoUpdated} message ChannelInfoUpdated message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ChannelInfoUpdated.encode = function encode(message, writer) {
          if (!writer) writer = $Writer.create();
          if (message.channelId != null && message.hasOwnProperty('channelId'))
            $root.propel.commrouter.VendorId.encode(
              message.channelId,
              writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
            ).ldelim();
          if (message.info != null && message.hasOwnProperty('info'))
            $root.google.protobuf.Struct.encode(
              message.info,
              writer.uint32(/* id 2, wireType 2 =*/ 18).fork()
            ).ldelim();
          return writer;
        };

        /**
         * Encodes the specified ChannelInfoUpdated message, length delimited. Does not implicitly {@link propel.commrouter.ConversationEvent.ChannelInfoUpdated.verify|verify} messages.
         * @function encodeDelimited
         * @memberof propel.commrouter.ConversationEvent.ChannelInfoUpdated
         * @static
         * @param {propel.commrouter.ConversationEvent.IChannelInfoUpdated} message ChannelInfoUpdated message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ChannelInfoUpdated.encodeDelimited = function encodeDelimited(message, writer) {
          return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a ChannelInfoUpdated message from the specified reader or buffer.
         * @function decode
         * @memberof propel.commrouter.ConversationEvent.ChannelInfoUpdated
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {propel.commrouter.ConversationEvent.ChannelInfoUpdated} ChannelInfoUpdated
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ChannelInfoUpdated.decode = function decode(reader, length) {
          if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
          var end = length === undefined ? reader.len : reader.pos + length,
            message = new $root.propel.commrouter.ConversationEvent.ChannelInfoUpdated();
          while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
              case 1:
                message.channelId = $root.propel.commrouter.VendorId.decode(
                  reader,
                  reader.uint32()
                );
                break;
              case 2:
                message.info = $root.google.protobuf.Struct.decode(reader, reader.uint32());
                break;
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };

        /**
         * Decodes a ChannelInfoUpdated message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof propel.commrouter.ConversationEvent.ChannelInfoUpdated
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {propel.commrouter.ConversationEvent.ChannelInfoUpdated} ChannelInfoUpdated
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ChannelInfoUpdated.decodeDelimited = function decodeDelimited(reader) {
          if (!(reader instanceof $Reader)) reader = new $Reader(reader);
          return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ChannelInfoUpdated message.
         * @function verify
         * @memberof propel.commrouter.ConversationEvent.ChannelInfoUpdated
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ChannelInfoUpdated.verify = function verify(message) {
          if (typeof message !== 'object' || message === null) return 'object expected';
          if (message.channelId != null && message.hasOwnProperty('channelId')) {
            var error = $root.propel.commrouter.VendorId.verify(message.channelId);
            if (error) return 'channelId.' + error;
          }
          if (message.info != null && message.hasOwnProperty('info')) {
            var error = $root.google.protobuf.Struct.verify(message.info);
            if (error) return 'info.' + error;
          }
          return null;
        };

        /**
         * Creates a ChannelInfoUpdated message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof propel.commrouter.ConversationEvent.ChannelInfoUpdated
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {propel.commrouter.ConversationEvent.ChannelInfoUpdated} ChannelInfoUpdated
         */
        ChannelInfoUpdated.fromObject = function fromObject(object) {
          if (object instanceof $root.propel.commrouter.ConversationEvent.ChannelInfoUpdated)
            return object;
          var message = new $root.propel.commrouter.ConversationEvent.ChannelInfoUpdated();
          if (object.channelId != null) {
            if (typeof object.channelId !== 'object')
              throw TypeError(
                '.propel.commrouter.ConversationEvent.ChannelInfoUpdated.channelId: object expected'
              );
            message.channelId = $root.propel.commrouter.VendorId.fromObject(object.channelId);
          }
          if (object.info != null) {
            if (typeof object.info !== 'object')
              throw TypeError(
                '.propel.commrouter.ConversationEvent.ChannelInfoUpdated.info: object expected'
              );
            message.info = $root.google.protobuf.Struct.fromObject(object.info);
          }
          return message;
        };

        /**
         * Creates a plain object from a ChannelInfoUpdated message. Also converts values to other types if specified.
         * @function toObject
         * @memberof propel.commrouter.ConversationEvent.ChannelInfoUpdated
         * @static
         * @param {propel.commrouter.ConversationEvent.ChannelInfoUpdated} message ChannelInfoUpdated
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ChannelInfoUpdated.toObject = function toObject(message, options) {
          if (!options) options = {};
          var object = {};
          if (options.defaults) {
            object.channelId = null;
            object.info = null;
          }
          if (message.channelId != null && message.hasOwnProperty('channelId'))
            object.channelId = $root.propel.commrouter.VendorId.toObject(
              message.channelId,
              options
            );
          if (message.info != null && message.hasOwnProperty('info'))
            object.info = $root.google.protobuf.Struct.toObject(message.info, options);
          return object;
        };

        /**
         * Converts this ChannelInfoUpdated to JSON.
         * @function toJSON
         * @memberof propel.commrouter.ConversationEvent.ChannelInfoUpdated
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ChannelInfoUpdated.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ChannelInfoUpdated;
      })();

      ConversationEvent.IntroductionCreated = (function () {
        /**
         * Properties of an IntroductionCreated.
         * @memberof propel.commrouter.ConversationEvent
         * @interface IIntroductionCreated
         * @property {propel.commrouter.IIntroduction|null} [Introduction] IntroductionCreated Introduction
         * @property {propel.commrouter.IContext|null} [context] IntroductionCreated context
         */

        /**
         * Constructs a new IntroductionCreated.
         * @memberof propel.commrouter.ConversationEvent
         * @classdesc Represents an IntroductionCreated.
         * @implements IIntroductionCreated
         * @constructor
         * @param {propel.commrouter.ConversationEvent.IIntroductionCreated=} [properties] Properties to set
         */
        function IntroductionCreated(properties) {
          if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
              if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
        }

        /**
         * IntroductionCreated Introduction.
         * @member {propel.commrouter.IIntroduction|null|undefined} Introduction
         * @memberof propel.commrouter.ConversationEvent.IntroductionCreated
         * @instance
         */
        IntroductionCreated.prototype.Introduction = null;

        /**
         * IntroductionCreated context.
         * @member {propel.commrouter.IContext|null|undefined} context
         * @memberof propel.commrouter.ConversationEvent.IntroductionCreated
         * @instance
         */
        IntroductionCreated.prototype.context = null;

        /**
         * Creates a new IntroductionCreated instance using the specified properties.
         * @function create
         * @memberof propel.commrouter.ConversationEvent.IntroductionCreated
         * @static
         * @param {propel.commrouter.ConversationEvent.IIntroductionCreated=} [properties] Properties to set
         * @returns {propel.commrouter.ConversationEvent.IntroductionCreated} IntroductionCreated instance
         */
        IntroductionCreated.create = function create(properties) {
          return new IntroductionCreated(properties);
        };

        /**
         * Encodes the specified IntroductionCreated message. Does not implicitly {@link propel.commrouter.ConversationEvent.IntroductionCreated.verify|verify} messages.
         * @function encode
         * @memberof propel.commrouter.ConversationEvent.IntroductionCreated
         * @static
         * @param {propel.commrouter.ConversationEvent.IIntroductionCreated} message IntroductionCreated message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        IntroductionCreated.encode = function encode(message, writer) {
          if (!writer) writer = $Writer.create();
          if (message.Introduction != null && message.hasOwnProperty('Introduction'))
            $root.propel.commrouter.Introduction.encode(
              message.Introduction,
              writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
            ).ldelim();
          if (message.context != null && message.hasOwnProperty('context'))
            $root.propel.commrouter.Context.encode(
              message.context,
              writer.uint32(/* id 2, wireType 2 =*/ 18).fork()
            ).ldelim();
          return writer;
        };

        /**
         * Encodes the specified IntroductionCreated message, length delimited. Does not implicitly {@link propel.commrouter.ConversationEvent.IntroductionCreated.verify|verify} messages.
         * @function encodeDelimited
         * @memberof propel.commrouter.ConversationEvent.IntroductionCreated
         * @static
         * @param {propel.commrouter.ConversationEvent.IIntroductionCreated} message IntroductionCreated message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        IntroductionCreated.encodeDelimited = function encodeDelimited(message, writer) {
          return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an IntroductionCreated message from the specified reader or buffer.
         * @function decode
         * @memberof propel.commrouter.ConversationEvent.IntroductionCreated
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {propel.commrouter.ConversationEvent.IntroductionCreated} IntroductionCreated
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        IntroductionCreated.decode = function decode(reader, length) {
          if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
          var end = length === undefined ? reader.len : reader.pos + length,
            message = new $root.propel.commrouter.ConversationEvent.IntroductionCreated();
          while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
              case 1:
                message.Introduction = $root.propel.commrouter.Introduction.decode(
                  reader,
                  reader.uint32()
                );
                break;
              case 2:
                message.context = $root.propel.commrouter.Context.decode(reader, reader.uint32());
                break;
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };

        /**
         * Decodes an IntroductionCreated message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof propel.commrouter.ConversationEvent.IntroductionCreated
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {propel.commrouter.ConversationEvent.IntroductionCreated} IntroductionCreated
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        IntroductionCreated.decodeDelimited = function decodeDelimited(reader) {
          if (!(reader instanceof $Reader)) reader = new $Reader(reader);
          return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an IntroductionCreated message.
         * @function verify
         * @memberof propel.commrouter.ConversationEvent.IntroductionCreated
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        IntroductionCreated.verify = function verify(message) {
          if (typeof message !== 'object' || message === null) return 'object expected';
          if (message.Introduction != null && message.hasOwnProperty('Introduction')) {
            var error = $root.propel.commrouter.Introduction.verify(message.Introduction);
            if (error) return 'Introduction.' + error;
          }
          if (message.context != null && message.hasOwnProperty('context')) {
            var error = $root.propel.commrouter.Context.verify(message.context);
            if (error) return 'context.' + error;
          }
          return null;
        };

        /**
         * Creates an IntroductionCreated message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof propel.commrouter.ConversationEvent.IntroductionCreated
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {propel.commrouter.ConversationEvent.IntroductionCreated} IntroductionCreated
         */
        IntroductionCreated.fromObject = function fromObject(object) {
          if (object instanceof $root.propel.commrouter.ConversationEvent.IntroductionCreated)
            return object;
          var message = new $root.propel.commrouter.ConversationEvent.IntroductionCreated();
          if (object.Introduction != null) {
            if (typeof object.Introduction !== 'object')
              throw TypeError(
                '.propel.commrouter.ConversationEvent.IntroductionCreated.Introduction: object expected'
              );
            message.Introduction = $root.propel.commrouter.Introduction.fromObject(
              object.Introduction
            );
          }
          if (object.context != null) {
            if (typeof object.context !== 'object')
              throw TypeError(
                '.propel.commrouter.ConversationEvent.IntroductionCreated.context: object expected'
              );
            message.context = $root.propel.commrouter.Context.fromObject(object.context);
          }
          return message;
        };

        /**
         * Creates a plain object from an IntroductionCreated message. Also converts values to other types if specified.
         * @function toObject
         * @memberof propel.commrouter.ConversationEvent.IntroductionCreated
         * @static
         * @param {propel.commrouter.ConversationEvent.IntroductionCreated} message IntroductionCreated
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        IntroductionCreated.toObject = function toObject(message, options) {
          if (!options) options = {};
          var object = {};
          if (options.defaults) {
            object.Introduction = null;
            object.context = null;
          }
          if (message.Introduction != null && message.hasOwnProperty('Introduction'))
            object.Introduction = $root.propel.commrouter.Introduction.toObject(
              message.Introduction,
              options
            );
          if (message.context != null && message.hasOwnProperty('context'))
            object.context = $root.propel.commrouter.Context.toObject(message.context, options);
          return object;
        };

        /**
         * Converts this IntroductionCreated to JSON.
         * @function toJSON
         * @memberof propel.commrouter.ConversationEvent.IntroductionCreated
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        IntroductionCreated.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return IntroductionCreated;
      })();

      ConversationEvent.InfoUpdated = (function () {
        /**
         * Properties of an InfoUpdated.
         * @memberof propel.commrouter.ConversationEvent
         * @interface IInfoUpdated
         * @property {string|null} [key] InfoUpdated key
         * @property {google.protobuf.IStruct|null} [value] InfoUpdated value
         */

        /**
         * Constructs a new InfoUpdated.
         * @memberof propel.commrouter.ConversationEvent
         * @classdesc Represents an InfoUpdated.
         * @implements IInfoUpdated
         * @constructor
         * @param {propel.commrouter.ConversationEvent.IInfoUpdated=} [properties] Properties to set
         */
        function InfoUpdated(properties) {
          if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
              if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
        }

        /**
         * InfoUpdated key.
         * @member {string} key
         * @memberof propel.commrouter.ConversationEvent.InfoUpdated
         * @instance
         */
        InfoUpdated.prototype.key = '';

        /**
         * InfoUpdated value.
         * @member {google.protobuf.IStruct|null|undefined} value
         * @memberof propel.commrouter.ConversationEvent.InfoUpdated
         * @instance
         */
        InfoUpdated.prototype.value = null;

        /**
         * Creates a new InfoUpdated instance using the specified properties.
         * @function create
         * @memberof propel.commrouter.ConversationEvent.InfoUpdated
         * @static
         * @param {propel.commrouter.ConversationEvent.IInfoUpdated=} [properties] Properties to set
         * @returns {propel.commrouter.ConversationEvent.InfoUpdated} InfoUpdated instance
         */
        InfoUpdated.create = function create(properties) {
          return new InfoUpdated(properties);
        };

        /**
         * Encodes the specified InfoUpdated message. Does not implicitly {@link propel.commrouter.ConversationEvent.InfoUpdated.verify|verify} messages.
         * @function encode
         * @memberof propel.commrouter.ConversationEvent.InfoUpdated
         * @static
         * @param {propel.commrouter.ConversationEvent.IInfoUpdated} message InfoUpdated message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        InfoUpdated.encode = function encode(message, writer) {
          if (!writer) writer = $Writer.create();
          if (message.key != null && message.hasOwnProperty('key'))
            writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.key);
          if (message.value != null && message.hasOwnProperty('value'))
            $root.google.protobuf.Struct.encode(
              message.value,
              writer.uint32(/* id 2, wireType 2 =*/ 18).fork()
            ).ldelim();
          return writer;
        };

        /**
         * Encodes the specified InfoUpdated message, length delimited. Does not implicitly {@link propel.commrouter.ConversationEvent.InfoUpdated.verify|verify} messages.
         * @function encodeDelimited
         * @memberof propel.commrouter.ConversationEvent.InfoUpdated
         * @static
         * @param {propel.commrouter.ConversationEvent.IInfoUpdated} message InfoUpdated message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        InfoUpdated.encodeDelimited = function encodeDelimited(message, writer) {
          return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an InfoUpdated message from the specified reader or buffer.
         * @function decode
         * @memberof propel.commrouter.ConversationEvent.InfoUpdated
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {propel.commrouter.ConversationEvent.InfoUpdated} InfoUpdated
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        InfoUpdated.decode = function decode(reader, length) {
          if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
          var end = length === undefined ? reader.len : reader.pos + length,
            message = new $root.propel.commrouter.ConversationEvent.InfoUpdated();
          while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
              case 1:
                message.key = reader.string();
                break;
              case 2:
                message.value = $root.google.protobuf.Struct.decode(reader, reader.uint32());
                break;
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };

        /**
         * Decodes an InfoUpdated message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof propel.commrouter.ConversationEvent.InfoUpdated
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {propel.commrouter.ConversationEvent.InfoUpdated} InfoUpdated
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        InfoUpdated.decodeDelimited = function decodeDelimited(reader) {
          if (!(reader instanceof $Reader)) reader = new $Reader(reader);
          return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an InfoUpdated message.
         * @function verify
         * @memberof propel.commrouter.ConversationEvent.InfoUpdated
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        InfoUpdated.verify = function verify(message) {
          if (typeof message !== 'object' || message === null) return 'object expected';
          if (message.key != null && message.hasOwnProperty('key'))
            if (!$util.isString(message.key)) return 'key: string expected';
          if (message.value != null && message.hasOwnProperty('value')) {
            var error = $root.google.protobuf.Struct.verify(message.value);
            if (error) return 'value.' + error;
          }
          return null;
        };

        /**
         * Creates an InfoUpdated message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof propel.commrouter.ConversationEvent.InfoUpdated
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {propel.commrouter.ConversationEvent.InfoUpdated} InfoUpdated
         */
        InfoUpdated.fromObject = function fromObject(object) {
          if (object instanceof $root.propel.commrouter.ConversationEvent.InfoUpdated)
            return object;
          var message = new $root.propel.commrouter.ConversationEvent.InfoUpdated();
          if (object.key != null) message.key = String(object.key);
          if (object.value != null) {
            if (typeof object.value !== 'object')
              throw TypeError(
                '.propel.commrouter.ConversationEvent.InfoUpdated.value: object expected'
              );
            message.value = $root.google.protobuf.Struct.fromObject(object.value);
          }
          return message;
        };

        /**
         * Creates a plain object from an InfoUpdated message. Also converts values to other types if specified.
         * @function toObject
         * @memberof propel.commrouter.ConversationEvent.InfoUpdated
         * @static
         * @param {propel.commrouter.ConversationEvent.InfoUpdated} message InfoUpdated
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        InfoUpdated.toObject = function toObject(message, options) {
          if (!options) options = {};
          var object = {};
          if (options.defaults) {
            object.key = '';
            object.value = null;
          }
          if (message.key != null && message.hasOwnProperty('key')) object.key = message.key;
          if (message.value != null && message.hasOwnProperty('value'))
            object.value = $root.google.protobuf.Struct.toObject(message.value, options);
          return object;
        };

        /**
         * Converts this InfoUpdated to JSON.
         * @function toJSON
         * @memberof propel.commrouter.ConversationEvent.InfoUpdated
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        InfoUpdated.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return InfoUpdated;
      })();

      ConversationEvent.TagCreated = (function () {
        /**
         * Properties of a TagCreated.
         * @memberof propel.commrouter.ConversationEvent
         * @interface ITagCreated
         * @property {propel.commrouter.ITag|null} [tag] TagCreated tag
         */

        /**
         * Constructs a new TagCreated.
         * @memberof propel.commrouter.ConversationEvent
         * @classdesc Represents a TagCreated.
         * @implements ITagCreated
         * @constructor
         * @param {propel.commrouter.ConversationEvent.ITagCreated=} [properties] Properties to set
         */
        function TagCreated(properties) {
          if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
              if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
        }

        /**
         * TagCreated tag.
         * @member {propel.commrouter.ITag|null|undefined} tag
         * @memberof propel.commrouter.ConversationEvent.TagCreated
         * @instance
         */
        TagCreated.prototype.tag = null;

        /**
         * Creates a new TagCreated instance using the specified properties.
         * @function create
         * @memberof propel.commrouter.ConversationEvent.TagCreated
         * @static
         * @param {propel.commrouter.ConversationEvent.ITagCreated=} [properties] Properties to set
         * @returns {propel.commrouter.ConversationEvent.TagCreated} TagCreated instance
         */
        TagCreated.create = function create(properties) {
          return new TagCreated(properties);
        };

        /**
         * Encodes the specified TagCreated message. Does not implicitly {@link propel.commrouter.ConversationEvent.TagCreated.verify|verify} messages.
         * @function encode
         * @memberof propel.commrouter.ConversationEvent.TagCreated
         * @static
         * @param {propel.commrouter.ConversationEvent.ITagCreated} message TagCreated message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        TagCreated.encode = function encode(message, writer) {
          if (!writer) writer = $Writer.create();
          if (message.tag != null && message.hasOwnProperty('tag'))
            $root.propel.commrouter.Tag.encode(
              message.tag,
              writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
            ).ldelim();
          return writer;
        };

        /**
         * Encodes the specified TagCreated message, length delimited. Does not implicitly {@link propel.commrouter.ConversationEvent.TagCreated.verify|verify} messages.
         * @function encodeDelimited
         * @memberof propel.commrouter.ConversationEvent.TagCreated
         * @static
         * @param {propel.commrouter.ConversationEvent.ITagCreated} message TagCreated message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        TagCreated.encodeDelimited = function encodeDelimited(message, writer) {
          return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a TagCreated message from the specified reader or buffer.
         * @function decode
         * @memberof propel.commrouter.ConversationEvent.TagCreated
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {propel.commrouter.ConversationEvent.TagCreated} TagCreated
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        TagCreated.decode = function decode(reader, length) {
          if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
          var end = length === undefined ? reader.len : reader.pos + length,
            message = new $root.propel.commrouter.ConversationEvent.TagCreated();
          while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
              case 1:
                message.tag = $root.propel.commrouter.Tag.decode(reader, reader.uint32());
                break;
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };

        /**
         * Decodes a TagCreated message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof propel.commrouter.ConversationEvent.TagCreated
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {propel.commrouter.ConversationEvent.TagCreated} TagCreated
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        TagCreated.decodeDelimited = function decodeDelimited(reader) {
          if (!(reader instanceof $Reader)) reader = new $Reader(reader);
          return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a TagCreated message.
         * @function verify
         * @memberof propel.commrouter.ConversationEvent.TagCreated
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        TagCreated.verify = function verify(message) {
          if (typeof message !== 'object' || message === null) return 'object expected';
          if (message.tag != null && message.hasOwnProperty('tag')) {
            var error = $root.propel.commrouter.Tag.verify(message.tag);
            if (error) return 'tag.' + error;
          }
          return null;
        };

        /**
         * Creates a TagCreated message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof propel.commrouter.ConversationEvent.TagCreated
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {propel.commrouter.ConversationEvent.TagCreated} TagCreated
         */
        TagCreated.fromObject = function fromObject(object) {
          if (object instanceof $root.propel.commrouter.ConversationEvent.TagCreated) return object;
          var message = new $root.propel.commrouter.ConversationEvent.TagCreated();
          if (object.tag != null) {
            if (typeof object.tag !== 'object')
              throw TypeError(
                '.propel.commrouter.ConversationEvent.TagCreated.tag: object expected'
              );
            message.tag = $root.propel.commrouter.Tag.fromObject(object.tag);
          }
          return message;
        };

        /**
         * Creates a plain object from a TagCreated message. Also converts values to other types if specified.
         * @function toObject
         * @memberof propel.commrouter.ConversationEvent.TagCreated
         * @static
         * @param {propel.commrouter.ConversationEvent.TagCreated} message TagCreated
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        TagCreated.toObject = function toObject(message, options) {
          if (!options) options = {};
          var object = {};
          if (options.defaults) object.tag = null;
          if (message.tag != null && message.hasOwnProperty('tag'))
            object.tag = $root.propel.commrouter.Tag.toObject(message.tag, options);
          return object;
        };

        /**
         * Converts this TagCreated to JSON.
         * @function toJSON
         * @memberof propel.commrouter.ConversationEvent.TagCreated
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        TagCreated.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return TagCreated;
      })();

      ConversationEvent.TagDeleted = (function () {
        /**
         * Properties of a TagDeleted.
         * @memberof propel.commrouter.ConversationEvent
         * @interface ITagDeleted
         * @property {string|null} [name] TagDeleted name
         * @property {propel.commrouter.IVendorId|null} [channelId] TagDeleted channelId
         */

        /**
         * Constructs a new TagDeleted.
         * @memberof propel.commrouter.ConversationEvent
         * @classdesc Represents a TagDeleted.
         * @implements ITagDeleted
         * @constructor
         * @param {propel.commrouter.ConversationEvent.ITagDeleted=} [properties] Properties to set
         */
        function TagDeleted(properties) {
          if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
              if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
        }

        /**
         * TagDeleted name.
         * @member {string} name
         * @memberof propel.commrouter.ConversationEvent.TagDeleted
         * @instance
         */
        TagDeleted.prototype.name = '';

        /**
         * TagDeleted channelId.
         * @member {propel.commrouter.IVendorId|null|undefined} channelId
         * @memberof propel.commrouter.ConversationEvent.TagDeleted
         * @instance
         */
        TagDeleted.prototype.channelId = null;

        /**
         * Creates a new TagDeleted instance using the specified properties.
         * @function create
         * @memberof propel.commrouter.ConversationEvent.TagDeleted
         * @static
         * @param {propel.commrouter.ConversationEvent.ITagDeleted=} [properties] Properties to set
         * @returns {propel.commrouter.ConversationEvent.TagDeleted} TagDeleted instance
         */
        TagDeleted.create = function create(properties) {
          return new TagDeleted(properties);
        };

        /**
         * Encodes the specified TagDeleted message. Does not implicitly {@link propel.commrouter.ConversationEvent.TagDeleted.verify|verify} messages.
         * @function encode
         * @memberof propel.commrouter.ConversationEvent.TagDeleted
         * @static
         * @param {propel.commrouter.ConversationEvent.ITagDeleted} message TagDeleted message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        TagDeleted.encode = function encode(message, writer) {
          if (!writer) writer = $Writer.create();
          if (message.name != null && message.hasOwnProperty('name'))
            writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.name);
          if (message.channelId != null && message.hasOwnProperty('channelId'))
            $root.propel.commrouter.VendorId.encode(
              message.channelId,
              writer.uint32(/* id 2, wireType 2 =*/ 18).fork()
            ).ldelim();
          return writer;
        };

        /**
         * Encodes the specified TagDeleted message, length delimited. Does not implicitly {@link propel.commrouter.ConversationEvent.TagDeleted.verify|verify} messages.
         * @function encodeDelimited
         * @memberof propel.commrouter.ConversationEvent.TagDeleted
         * @static
         * @param {propel.commrouter.ConversationEvent.ITagDeleted} message TagDeleted message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        TagDeleted.encodeDelimited = function encodeDelimited(message, writer) {
          return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a TagDeleted message from the specified reader or buffer.
         * @function decode
         * @memberof propel.commrouter.ConversationEvent.TagDeleted
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {propel.commrouter.ConversationEvent.TagDeleted} TagDeleted
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        TagDeleted.decode = function decode(reader, length) {
          if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
          var end = length === undefined ? reader.len : reader.pos + length,
            message = new $root.propel.commrouter.ConversationEvent.TagDeleted();
          while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
              case 1:
                message.name = reader.string();
                break;
              case 2:
                message.channelId = $root.propel.commrouter.VendorId.decode(
                  reader,
                  reader.uint32()
                );
                break;
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };

        /**
         * Decodes a TagDeleted message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof propel.commrouter.ConversationEvent.TagDeleted
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {propel.commrouter.ConversationEvent.TagDeleted} TagDeleted
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        TagDeleted.decodeDelimited = function decodeDelimited(reader) {
          if (!(reader instanceof $Reader)) reader = new $Reader(reader);
          return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a TagDeleted message.
         * @function verify
         * @memberof propel.commrouter.ConversationEvent.TagDeleted
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        TagDeleted.verify = function verify(message) {
          if (typeof message !== 'object' || message === null) return 'object expected';
          if (message.name != null && message.hasOwnProperty('name'))
            if (!$util.isString(message.name)) return 'name: string expected';
          if (message.channelId != null && message.hasOwnProperty('channelId')) {
            var error = $root.propel.commrouter.VendorId.verify(message.channelId);
            if (error) return 'channelId.' + error;
          }
          return null;
        };

        /**
         * Creates a TagDeleted message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof propel.commrouter.ConversationEvent.TagDeleted
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {propel.commrouter.ConversationEvent.TagDeleted} TagDeleted
         */
        TagDeleted.fromObject = function fromObject(object) {
          if (object instanceof $root.propel.commrouter.ConversationEvent.TagDeleted) return object;
          var message = new $root.propel.commrouter.ConversationEvent.TagDeleted();
          if (object.name != null) message.name = String(object.name);
          if (object.channelId != null) {
            if (typeof object.channelId !== 'object')
              throw TypeError(
                '.propel.commrouter.ConversationEvent.TagDeleted.channelId: object expected'
              );
            message.channelId = $root.propel.commrouter.VendorId.fromObject(object.channelId);
          }
          return message;
        };

        /**
         * Creates a plain object from a TagDeleted message. Also converts values to other types if specified.
         * @function toObject
         * @memberof propel.commrouter.ConversationEvent.TagDeleted
         * @static
         * @param {propel.commrouter.ConversationEvent.TagDeleted} message TagDeleted
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        TagDeleted.toObject = function toObject(message, options) {
          if (!options) options = {};
          var object = {};
          if (options.defaults) {
            object.name = '';
            object.channelId = null;
          }
          if (message.name != null && message.hasOwnProperty('name')) object.name = message.name;
          if (message.channelId != null && message.hasOwnProperty('channelId'))
            object.channelId = $root.propel.commrouter.VendorId.toObject(
              message.channelId,
              options
            );
          return object;
        };

        /**
         * Converts this TagDeleted to JSON.
         * @function toJSON
         * @memberof propel.commrouter.ConversationEvent.TagDeleted
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        TagDeleted.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return TagDeleted;
      })();

      ConversationEvent.JobCreated = (function () {
        /**
         * Properties of a JobCreated.
         * @memberof propel.commrouter.ConversationEvent
         * @interface IJobCreated
         * @property {propel.commrouter.IJob|null} [job] JobCreated job
         */

        /**
         * Constructs a new JobCreated.
         * @memberof propel.commrouter.ConversationEvent
         * @classdesc Represents a JobCreated.
         * @implements IJobCreated
         * @constructor
         * @param {propel.commrouter.ConversationEvent.IJobCreated=} [properties] Properties to set
         */
        function JobCreated(properties) {
          if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
              if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
        }

        /**
         * JobCreated job.
         * @member {propel.commrouter.IJob|null|undefined} job
         * @memberof propel.commrouter.ConversationEvent.JobCreated
         * @instance
         */
        JobCreated.prototype.job = null;

        /**
         * Creates a new JobCreated instance using the specified properties.
         * @function create
         * @memberof propel.commrouter.ConversationEvent.JobCreated
         * @static
         * @param {propel.commrouter.ConversationEvent.IJobCreated=} [properties] Properties to set
         * @returns {propel.commrouter.ConversationEvent.JobCreated} JobCreated instance
         */
        JobCreated.create = function create(properties) {
          return new JobCreated(properties);
        };

        /**
         * Encodes the specified JobCreated message. Does not implicitly {@link propel.commrouter.ConversationEvent.JobCreated.verify|verify} messages.
         * @function encode
         * @memberof propel.commrouter.ConversationEvent.JobCreated
         * @static
         * @param {propel.commrouter.ConversationEvent.IJobCreated} message JobCreated message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        JobCreated.encode = function encode(message, writer) {
          if (!writer) writer = $Writer.create();
          if (message.job != null && message.hasOwnProperty('job'))
            $root.propel.commrouter.Job.encode(
              message.job,
              writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
            ).ldelim();
          return writer;
        };

        /**
         * Encodes the specified JobCreated message, length delimited. Does not implicitly {@link propel.commrouter.ConversationEvent.JobCreated.verify|verify} messages.
         * @function encodeDelimited
         * @memberof propel.commrouter.ConversationEvent.JobCreated
         * @static
         * @param {propel.commrouter.ConversationEvent.IJobCreated} message JobCreated message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        JobCreated.encodeDelimited = function encodeDelimited(message, writer) {
          return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a JobCreated message from the specified reader or buffer.
         * @function decode
         * @memberof propel.commrouter.ConversationEvent.JobCreated
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {propel.commrouter.ConversationEvent.JobCreated} JobCreated
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        JobCreated.decode = function decode(reader, length) {
          if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
          var end = length === undefined ? reader.len : reader.pos + length,
            message = new $root.propel.commrouter.ConversationEvent.JobCreated();
          while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
              case 1:
                message.job = $root.propel.commrouter.Job.decode(reader, reader.uint32());
                break;
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };

        /**
         * Decodes a JobCreated message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof propel.commrouter.ConversationEvent.JobCreated
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {propel.commrouter.ConversationEvent.JobCreated} JobCreated
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        JobCreated.decodeDelimited = function decodeDelimited(reader) {
          if (!(reader instanceof $Reader)) reader = new $Reader(reader);
          return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a JobCreated message.
         * @function verify
         * @memberof propel.commrouter.ConversationEvent.JobCreated
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        JobCreated.verify = function verify(message) {
          if (typeof message !== 'object' || message === null) return 'object expected';
          if (message.job != null && message.hasOwnProperty('job')) {
            var error = $root.propel.commrouter.Job.verify(message.job);
            if (error) return 'job.' + error;
          }
          return null;
        };

        /**
         * Creates a JobCreated message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof propel.commrouter.ConversationEvent.JobCreated
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {propel.commrouter.ConversationEvent.JobCreated} JobCreated
         */
        JobCreated.fromObject = function fromObject(object) {
          if (object instanceof $root.propel.commrouter.ConversationEvent.JobCreated) return object;
          var message = new $root.propel.commrouter.ConversationEvent.JobCreated();
          if (object.job != null) {
            if (typeof object.job !== 'object')
              throw TypeError(
                '.propel.commrouter.ConversationEvent.JobCreated.job: object expected'
              );
            message.job = $root.propel.commrouter.Job.fromObject(object.job);
          }
          return message;
        };

        /**
         * Creates a plain object from a JobCreated message. Also converts values to other types if specified.
         * @function toObject
         * @memberof propel.commrouter.ConversationEvent.JobCreated
         * @static
         * @param {propel.commrouter.ConversationEvent.JobCreated} message JobCreated
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        JobCreated.toObject = function toObject(message, options) {
          if (!options) options = {};
          var object = {};
          if (options.defaults) object.job = null;
          if (message.job != null && message.hasOwnProperty('job'))
            object.job = $root.propel.commrouter.Job.toObject(message.job, options);
          return object;
        };

        /**
         * Converts this JobCreated to JSON.
         * @function toJSON
         * @memberof propel.commrouter.ConversationEvent.JobCreated
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        JobCreated.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return JobCreated;
      })();

      ConversationEvent.JobUpdated = (function () {
        /**
         * Properties of a JobUpdated.
         * @memberof propel.commrouter.ConversationEvent
         * @interface IJobUpdated
         * @property {propel.commrouter.IJob|null} [job] JobUpdated job
         */

        /**
         * Constructs a new JobUpdated.
         * @memberof propel.commrouter.ConversationEvent
         * @classdesc Represents a JobUpdated.
         * @implements IJobUpdated
         * @constructor
         * @param {propel.commrouter.ConversationEvent.IJobUpdated=} [properties] Properties to set
         */
        function JobUpdated(properties) {
          if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
              if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
        }

        /**
         * JobUpdated job.
         * @member {propel.commrouter.IJob|null|undefined} job
         * @memberof propel.commrouter.ConversationEvent.JobUpdated
         * @instance
         */
        JobUpdated.prototype.job = null;

        /**
         * Creates a new JobUpdated instance using the specified properties.
         * @function create
         * @memberof propel.commrouter.ConversationEvent.JobUpdated
         * @static
         * @param {propel.commrouter.ConversationEvent.IJobUpdated=} [properties] Properties to set
         * @returns {propel.commrouter.ConversationEvent.JobUpdated} JobUpdated instance
         */
        JobUpdated.create = function create(properties) {
          return new JobUpdated(properties);
        };

        /**
         * Encodes the specified JobUpdated message. Does not implicitly {@link propel.commrouter.ConversationEvent.JobUpdated.verify|verify} messages.
         * @function encode
         * @memberof propel.commrouter.ConversationEvent.JobUpdated
         * @static
         * @param {propel.commrouter.ConversationEvent.IJobUpdated} message JobUpdated message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        JobUpdated.encode = function encode(message, writer) {
          if (!writer) writer = $Writer.create();
          if (message.job != null && message.hasOwnProperty('job'))
            $root.propel.commrouter.Job.encode(
              message.job,
              writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
            ).ldelim();
          return writer;
        };

        /**
         * Encodes the specified JobUpdated message, length delimited. Does not implicitly {@link propel.commrouter.ConversationEvent.JobUpdated.verify|verify} messages.
         * @function encodeDelimited
         * @memberof propel.commrouter.ConversationEvent.JobUpdated
         * @static
         * @param {propel.commrouter.ConversationEvent.IJobUpdated} message JobUpdated message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        JobUpdated.encodeDelimited = function encodeDelimited(message, writer) {
          return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a JobUpdated message from the specified reader or buffer.
         * @function decode
         * @memberof propel.commrouter.ConversationEvent.JobUpdated
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {propel.commrouter.ConversationEvent.JobUpdated} JobUpdated
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        JobUpdated.decode = function decode(reader, length) {
          if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
          var end = length === undefined ? reader.len : reader.pos + length,
            message = new $root.propel.commrouter.ConversationEvent.JobUpdated();
          while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
              case 1:
                message.job = $root.propel.commrouter.Job.decode(reader, reader.uint32());
                break;
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };

        /**
         * Decodes a JobUpdated message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof propel.commrouter.ConversationEvent.JobUpdated
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {propel.commrouter.ConversationEvent.JobUpdated} JobUpdated
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        JobUpdated.decodeDelimited = function decodeDelimited(reader) {
          if (!(reader instanceof $Reader)) reader = new $Reader(reader);
          return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a JobUpdated message.
         * @function verify
         * @memberof propel.commrouter.ConversationEvent.JobUpdated
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        JobUpdated.verify = function verify(message) {
          if (typeof message !== 'object' || message === null) return 'object expected';
          if (message.job != null && message.hasOwnProperty('job')) {
            var error = $root.propel.commrouter.Job.verify(message.job);
            if (error) return 'job.' + error;
          }
          return null;
        };

        /**
         * Creates a JobUpdated message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof propel.commrouter.ConversationEvent.JobUpdated
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {propel.commrouter.ConversationEvent.JobUpdated} JobUpdated
         */
        JobUpdated.fromObject = function fromObject(object) {
          if (object instanceof $root.propel.commrouter.ConversationEvent.JobUpdated) return object;
          var message = new $root.propel.commrouter.ConversationEvent.JobUpdated();
          if (object.job != null) {
            if (typeof object.job !== 'object')
              throw TypeError(
                '.propel.commrouter.ConversationEvent.JobUpdated.job: object expected'
              );
            message.job = $root.propel.commrouter.Job.fromObject(object.job);
          }
          return message;
        };

        /**
         * Creates a plain object from a JobUpdated message. Also converts values to other types if specified.
         * @function toObject
         * @memberof propel.commrouter.ConversationEvent.JobUpdated
         * @static
         * @param {propel.commrouter.ConversationEvent.JobUpdated} message JobUpdated
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        JobUpdated.toObject = function toObject(message, options) {
          if (!options) options = {};
          var object = {};
          if (options.defaults) object.job = null;
          if (message.job != null && message.hasOwnProperty('job'))
            object.job = $root.propel.commrouter.Job.toObject(message.job, options);
          return object;
        };

        /**
         * Converts this JobUpdated to JSON.
         * @function toJSON
         * @memberof propel.commrouter.ConversationEvent.JobUpdated
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        JobUpdated.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return JobUpdated;
      })();

      ConversationEvent.JobDeleted = (function () {
        /**
         * Properties of a JobDeleted.
         * @memberof propel.commrouter.ConversationEvent
         * @interface IJobDeleted
         * @property {string|null} [jobId] JobDeleted jobId
         */

        /**
         * Constructs a new JobDeleted.
         * @memberof propel.commrouter.ConversationEvent
         * @classdesc Represents a JobDeleted.
         * @implements IJobDeleted
         * @constructor
         * @param {propel.commrouter.ConversationEvent.IJobDeleted=} [properties] Properties to set
         */
        function JobDeleted(properties) {
          if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
              if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
        }

        /**
         * JobDeleted jobId.
         * @member {string} jobId
         * @memberof propel.commrouter.ConversationEvent.JobDeleted
         * @instance
         */
        JobDeleted.prototype.jobId = '';

        /**
         * Creates a new JobDeleted instance using the specified properties.
         * @function create
         * @memberof propel.commrouter.ConversationEvent.JobDeleted
         * @static
         * @param {propel.commrouter.ConversationEvent.IJobDeleted=} [properties] Properties to set
         * @returns {propel.commrouter.ConversationEvent.JobDeleted} JobDeleted instance
         */
        JobDeleted.create = function create(properties) {
          return new JobDeleted(properties);
        };

        /**
         * Encodes the specified JobDeleted message. Does not implicitly {@link propel.commrouter.ConversationEvent.JobDeleted.verify|verify} messages.
         * @function encode
         * @memberof propel.commrouter.ConversationEvent.JobDeleted
         * @static
         * @param {propel.commrouter.ConversationEvent.IJobDeleted} message JobDeleted message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        JobDeleted.encode = function encode(message, writer) {
          if (!writer) writer = $Writer.create();
          if (message.jobId != null && message.hasOwnProperty('jobId'))
            writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.jobId);
          return writer;
        };

        /**
         * Encodes the specified JobDeleted message, length delimited. Does not implicitly {@link propel.commrouter.ConversationEvent.JobDeleted.verify|verify} messages.
         * @function encodeDelimited
         * @memberof propel.commrouter.ConversationEvent.JobDeleted
         * @static
         * @param {propel.commrouter.ConversationEvent.IJobDeleted} message JobDeleted message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        JobDeleted.encodeDelimited = function encodeDelimited(message, writer) {
          return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a JobDeleted message from the specified reader or buffer.
         * @function decode
         * @memberof propel.commrouter.ConversationEvent.JobDeleted
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {propel.commrouter.ConversationEvent.JobDeleted} JobDeleted
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        JobDeleted.decode = function decode(reader, length) {
          if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
          var end = length === undefined ? reader.len : reader.pos + length,
            message = new $root.propel.commrouter.ConversationEvent.JobDeleted();
          while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
              case 1:
                message.jobId = reader.string();
                break;
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };

        /**
         * Decodes a JobDeleted message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof propel.commrouter.ConversationEvent.JobDeleted
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {propel.commrouter.ConversationEvent.JobDeleted} JobDeleted
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        JobDeleted.decodeDelimited = function decodeDelimited(reader) {
          if (!(reader instanceof $Reader)) reader = new $Reader(reader);
          return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a JobDeleted message.
         * @function verify
         * @memberof propel.commrouter.ConversationEvent.JobDeleted
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        JobDeleted.verify = function verify(message) {
          if (typeof message !== 'object' || message === null) return 'object expected';
          if (message.jobId != null && message.hasOwnProperty('jobId'))
            if (!$util.isString(message.jobId)) return 'jobId: string expected';
          return null;
        };

        /**
         * Creates a JobDeleted message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof propel.commrouter.ConversationEvent.JobDeleted
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {propel.commrouter.ConversationEvent.JobDeleted} JobDeleted
         */
        JobDeleted.fromObject = function fromObject(object) {
          if (object instanceof $root.propel.commrouter.ConversationEvent.JobDeleted) return object;
          var message = new $root.propel.commrouter.ConversationEvent.JobDeleted();
          if (object.jobId != null) message.jobId = String(object.jobId);
          return message;
        };

        /**
         * Creates a plain object from a JobDeleted message. Also converts values to other types if specified.
         * @function toObject
         * @memberof propel.commrouter.ConversationEvent.JobDeleted
         * @static
         * @param {propel.commrouter.ConversationEvent.JobDeleted} message JobDeleted
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        JobDeleted.toObject = function toObject(message, options) {
          if (!options) options = {};
          var object = {};
          if (options.defaults) object.jobId = '';
          if (message.jobId != null && message.hasOwnProperty('jobId'))
            object.jobId = message.jobId;
          return object;
        };

        /**
         * Converts this JobDeleted to JSON.
         * @function toJSON
         * @memberof propel.commrouter.ConversationEvent.JobDeleted
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        JobDeleted.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return JobDeleted;
      })();

      ConversationEvent.IncomingLeadRefCreated = (function () {
        /**
         * Properties of an IncomingLeadRefCreated.
         * @memberof propel.commrouter.ConversationEvent
         * @interface IIncomingLeadRefCreated
         * @property {propel.commrouter.IIncomingLeadRef|null} [incomingLeadRef] IncomingLeadRefCreated incomingLeadRef
         */

        /**
         * Constructs a new IncomingLeadRefCreated.
         * @memberof propel.commrouter.ConversationEvent
         * @classdesc Represents an IncomingLeadRefCreated.
         * @implements IIncomingLeadRefCreated
         * @constructor
         * @param {propel.commrouter.ConversationEvent.IIncomingLeadRefCreated=} [properties] Properties to set
         */
        function IncomingLeadRefCreated(properties) {
          if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
              if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
        }

        /**
         * IncomingLeadRefCreated incomingLeadRef.
         * @member {propel.commrouter.IIncomingLeadRef|null|undefined} incomingLeadRef
         * @memberof propel.commrouter.ConversationEvent.IncomingLeadRefCreated
         * @instance
         */
        IncomingLeadRefCreated.prototype.incomingLeadRef = null;

        /**
         * Creates a new IncomingLeadRefCreated instance using the specified properties.
         * @function create
         * @memberof propel.commrouter.ConversationEvent.IncomingLeadRefCreated
         * @static
         * @param {propel.commrouter.ConversationEvent.IIncomingLeadRefCreated=} [properties] Properties to set
         * @returns {propel.commrouter.ConversationEvent.IncomingLeadRefCreated} IncomingLeadRefCreated instance
         */
        IncomingLeadRefCreated.create = function create(properties) {
          return new IncomingLeadRefCreated(properties);
        };

        /**
         * Encodes the specified IncomingLeadRefCreated message. Does not implicitly {@link propel.commrouter.ConversationEvent.IncomingLeadRefCreated.verify|verify} messages.
         * @function encode
         * @memberof propel.commrouter.ConversationEvent.IncomingLeadRefCreated
         * @static
         * @param {propel.commrouter.ConversationEvent.IIncomingLeadRefCreated} message IncomingLeadRefCreated message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        IncomingLeadRefCreated.encode = function encode(message, writer) {
          if (!writer) writer = $Writer.create();
          if (message.incomingLeadRef != null && message.hasOwnProperty('incomingLeadRef'))
            $root.propel.commrouter.IncomingLeadRef.encode(
              message.incomingLeadRef,
              writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
            ).ldelim();
          return writer;
        };

        /**
         * Encodes the specified IncomingLeadRefCreated message, length delimited. Does not implicitly {@link propel.commrouter.ConversationEvent.IncomingLeadRefCreated.verify|verify} messages.
         * @function encodeDelimited
         * @memberof propel.commrouter.ConversationEvent.IncomingLeadRefCreated
         * @static
         * @param {propel.commrouter.ConversationEvent.IIncomingLeadRefCreated} message IncomingLeadRefCreated message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        IncomingLeadRefCreated.encodeDelimited = function encodeDelimited(message, writer) {
          return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an IncomingLeadRefCreated message from the specified reader or buffer.
         * @function decode
         * @memberof propel.commrouter.ConversationEvent.IncomingLeadRefCreated
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {propel.commrouter.ConversationEvent.IncomingLeadRefCreated} IncomingLeadRefCreated
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        IncomingLeadRefCreated.decode = function decode(reader, length) {
          if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
          var end = length === undefined ? reader.len : reader.pos + length,
            message = new $root.propel.commrouter.ConversationEvent.IncomingLeadRefCreated();
          while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
              case 1:
                message.incomingLeadRef = $root.propel.commrouter.IncomingLeadRef.decode(
                  reader,
                  reader.uint32()
                );
                break;
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };

        /**
         * Decodes an IncomingLeadRefCreated message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof propel.commrouter.ConversationEvent.IncomingLeadRefCreated
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {propel.commrouter.ConversationEvent.IncomingLeadRefCreated} IncomingLeadRefCreated
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        IncomingLeadRefCreated.decodeDelimited = function decodeDelimited(reader) {
          if (!(reader instanceof $Reader)) reader = new $Reader(reader);
          return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an IncomingLeadRefCreated message.
         * @function verify
         * @memberof propel.commrouter.ConversationEvent.IncomingLeadRefCreated
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        IncomingLeadRefCreated.verify = function verify(message) {
          if (typeof message !== 'object' || message === null) return 'object expected';
          if (message.incomingLeadRef != null && message.hasOwnProperty('incomingLeadRef')) {
            var error = $root.propel.commrouter.IncomingLeadRef.verify(message.incomingLeadRef);
            if (error) return 'incomingLeadRef.' + error;
          }
          return null;
        };

        /**
         * Creates an IncomingLeadRefCreated message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof propel.commrouter.ConversationEvent.IncomingLeadRefCreated
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {propel.commrouter.ConversationEvent.IncomingLeadRefCreated} IncomingLeadRefCreated
         */
        IncomingLeadRefCreated.fromObject = function fromObject(object) {
          if (object instanceof $root.propel.commrouter.ConversationEvent.IncomingLeadRefCreated)
            return object;
          var message = new $root.propel.commrouter.ConversationEvent.IncomingLeadRefCreated();
          if (object.incomingLeadRef != null) {
            if (typeof object.incomingLeadRef !== 'object')
              throw TypeError(
                '.propel.commrouter.ConversationEvent.IncomingLeadRefCreated.incomingLeadRef: object expected'
              );
            message.incomingLeadRef = $root.propel.commrouter.IncomingLeadRef.fromObject(
              object.incomingLeadRef
            );
          }
          return message;
        };

        /**
         * Creates a plain object from an IncomingLeadRefCreated message. Also converts values to other types if specified.
         * @function toObject
         * @memberof propel.commrouter.ConversationEvent.IncomingLeadRefCreated
         * @static
         * @param {propel.commrouter.ConversationEvent.IncomingLeadRefCreated} message IncomingLeadRefCreated
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        IncomingLeadRefCreated.toObject = function toObject(message, options) {
          if (!options) options = {};
          var object = {};
          if (options.defaults) object.incomingLeadRef = null;
          if (message.incomingLeadRef != null && message.hasOwnProperty('incomingLeadRef'))
            object.incomingLeadRef = $root.propel.commrouter.IncomingLeadRef.toObject(
              message.incomingLeadRef,
              options
            );
          return object;
        };

        /**
         * Converts this IncomingLeadRefCreated to JSON.
         * @function toJSON
         * @memberof propel.commrouter.ConversationEvent.IncomingLeadRefCreated
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        IncomingLeadRefCreated.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return IncomingLeadRefCreated;
      })();

      ConversationEvent.NoteCreated = (function () {
        /**
         * Properties of a NoteCreated.
         * @memberof propel.commrouter.ConversationEvent
         * @interface INoteCreated
         * @property {propel.commrouter.INote|null} [note] NoteCreated note
         */

        /**
         * Constructs a new NoteCreated.
         * @memberof propel.commrouter.ConversationEvent
         * @classdesc Represents a NoteCreated.
         * @implements INoteCreated
         * @constructor
         * @param {propel.commrouter.ConversationEvent.INoteCreated=} [properties] Properties to set
         */
        function NoteCreated(properties) {
          if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
              if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
        }

        /**
         * NoteCreated note.
         * @member {propel.commrouter.INote|null|undefined} note
         * @memberof propel.commrouter.ConversationEvent.NoteCreated
         * @instance
         */
        NoteCreated.prototype.note = null;

        /**
         * Creates a new NoteCreated instance using the specified properties.
         * @function create
         * @memberof propel.commrouter.ConversationEvent.NoteCreated
         * @static
         * @param {propel.commrouter.ConversationEvent.INoteCreated=} [properties] Properties to set
         * @returns {propel.commrouter.ConversationEvent.NoteCreated} NoteCreated instance
         */
        NoteCreated.create = function create(properties) {
          return new NoteCreated(properties);
        };

        /**
         * Encodes the specified NoteCreated message. Does not implicitly {@link propel.commrouter.ConversationEvent.NoteCreated.verify|verify} messages.
         * @function encode
         * @memberof propel.commrouter.ConversationEvent.NoteCreated
         * @static
         * @param {propel.commrouter.ConversationEvent.INoteCreated} message NoteCreated message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        NoteCreated.encode = function encode(message, writer) {
          if (!writer) writer = $Writer.create();
          if (message.note != null && message.hasOwnProperty('note'))
            $root.propel.commrouter.Note.encode(
              message.note,
              writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
            ).ldelim();
          return writer;
        };

        /**
         * Encodes the specified NoteCreated message, length delimited. Does not implicitly {@link propel.commrouter.ConversationEvent.NoteCreated.verify|verify} messages.
         * @function encodeDelimited
         * @memberof propel.commrouter.ConversationEvent.NoteCreated
         * @static
         * @param {propel.commrouter.ConversationEvent.INoteCreated} message NoteCreated message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        NoteCreated.encodeDelimited = function encodeDelimited(message, writer) {
          return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a NoteCreated message from the specified reader or buffer.
         * @function decode
         * @memberof propel.commrouter.ConversationEvent.NoteCreated
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {propel.commrouter.ConversationEvent.NoteCreated} NoteCreated
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        NoteCreated.decode = function decode(reader, length) {
          if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
          var end = length === undefined ? reader.len : reader.pos + length,
            message = new $root.propel.commrouter.ConversationEvent.NoteCreated();
          while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
              case 1:
                message.note = $root.propel.commrouter.Note.decode(reader, reader.uint32());
                break;
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };

        /**
         * Decodes a NoteCreated message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof propel.commrouter.ConversationEvent.NoteCreated
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {propel.commrouter.ConversationEvent.NoteCreated} NoteCreated
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        NoteCreated.decodeDelimited = function decodeDelimited(reader) {
          if (!(reader instanceof $Reader)) reader = new $Reader(reader);
          return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a NoteCreated message.
         * @function verify
         * @memberof propel.commrouter.ConversationEvent.NoteCreated
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        NoteCreated.verify = function verify(message) {
          if (typeof message !== 'object' || message === null) return 'object expected';
          if (message.note != null && message.hasOwnProperty('note')) {
            var error = $root.propel.commrouter.Note.verify(message.note);
            if (error) return 'note.' + error;
          }
          return null;
        };

        /**
         * Creates a NoteCreated message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof propel.commrouter.ConversationEvent.NoteCreated
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {propel.commrouter.ConversationEvent.NoteCreated} NoteCreated
         */
        NoteCreated.fromObject = function fromObject(object) {
          if (object instanceof $root.propel.commrouter.ConversationEvent.NoteCreated)
            return object;
          var message = new $root.propel.commrouter.ConversationEvent.NoteCreated();
          if (object.note != null) {
            if (typeof object.note !== 'object')
              throw TypeError(
                '.propel.commrouter.ConversationEvent.NoteCreated.note: object expected'
              );
            message.note = $root.propel.commrouter.Note.fromObject(object.note);
          }
          return message;
        };

        /**
         * Creates a plain object from a NoteCreated message. Also converts values to other types if specified.
         * @function toObject
         * @memberof propel.commrouter.ConversationEvent.NoteCreated
         * @static
         * @param {propel.commrouter.ConversationEvent.NoteCreated} message NoteCreated
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        NoteCreated.toObject = function toObject(message, options) {
          if (!options) options = {};
          var object = {};
          if (options.defaults) object.note = null;
          if (message.note != null && message.hasOwnProperty('note'))
            object.note = $root.propel.commrouter.Note.toObject(message.note, options);
          return object;
        };

        /**
         * Converts this NoteCreated to JSON.
         * @function toJSON
         * @memberof propel.commrouter.ConversationEvent.NoteCreated
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        NoteCreated.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return NoteCreated;
      })();

      return ConversationEvent;
    })();

    commrouter.ConversationEventPoll = (function () {
      /**
       * Properties of a ConversationEventPoll.
       * @memberof propel.commrouter
       * @interface IConversationEventPoll
       * @property {string|null} [id] ConversationEventPoll id
       * @property {string|null} [conversationId] ConversationEventPoll conversationId
       * @property {Array.<string>|null} [events] ConversationEventPoll events
       */

      /**
       * Constructs a new ConversationEventPoll.
       * @memberof propel.commrouter
       * @classdesc Represents a ConversationEventPoll.
       * @implements IConversationEventPoll
       * @constructor
       * @param {propel.commrouter.IConversationEventPoll=} [properties] Properties to set
       */
      function ConversationEventPoll(properties) {
        this.events = [];
        if (properties)
          for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
      }

      /**
       * ConversationEventPoll id.
       * @member {string} id
       * @memberof propel.commrouter.ConversationEventPoll
       * @instance
       */
      ConversationEventPoll.prototype.id = '';

      /**
       * ConversationEventPoll conversationId.
       * @member {string} conversationId
       * @memberof propel.commrouter.ConversationEventPoll
       * @instance
       */
      ConversationEventPoll.prototype.conversationId = '';

      /**
       * ConversationEventPoll events.
       * @member {Array.<string>} events
       * @memberof propel.commrouter.ConversationEventPoll
       * @instance
       */
      ConversationEventPoll.prototype.events = $util.emptyArray;

      /**
       * Creates a new ConversationEventPoll instance using the specified properties.
       * @function create
       * @memberof propel.commrouter.ConversationEventPoll
       * @static
       * @param {propel.commrouter.IConversationEventPoll=} [properties] Properties to set
       * @returns {propel.commrouter.ConversationEventPoll} ConversationEventPoll instance
       */
      ConversationEventPoll.create = function create(properties) {
        return new ConversationEventPoll(properties);
      };

      /**
       * Encodes the specified ConversationEventPoll message. Does not implicitly {@link propel.commrouter.ConversationEventPoll.verify|verify} messages.
       * @function encode
       * @memberof propel.commrouter.ConversationEventPoll
       * @static
       * @param {propel.commrouter.IConversationEventPoll} message ConversationEventPoll message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      ConversationEventPoll.encode = function encode(message, writer) {
        if (!writer) writer = $Writer.create();
        if (message.id != null && message.hasOwnProperty('id'))
          writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
        if (message.conversationId != null && message.hasOwnProperty('conversationId'))
          writer.uint32(/* id 2, wireType 2 =*/ 18).string(message.conversationId);
        if (message.events != null && message.events.length)
          for (var i = 0; i < message.events.length; ++i)
            writer.uint32(/* id 3, wireType 2 =*/ 26).string(message.events[i]);
        return writer;
      };

      /**
       * Encodes the specified ConversationEventPoll message, length delimited. Does not implicitly {@link propel.commrouter.ConversationEventPoll.verify|verify} messages.
       * @function encodeDelimited
       * @memberof propel.commrouter.ConversationEventPoll
       * @static
       * @param {propel.commrouter.IConversationEventPoll} message ConversationEventPoll message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      ConversationEventPoll.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
      };

      /**
       * Decodes a ConversationEventPoll message from the specified reader or buffer.
       * @function decode
       * @memberof propel.commrouter.ConversationEventPoll
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @param {number} [length] Message length if known beforehand
       * @returns {propel.commrouter.ConversationEventPoll} ConversationEventPoll
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      ConversationEventPoll.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length,
          message = new $root.propel.commrouter.ConversationEventPoll();
        while (reader.pos < end) {
          var tag = reader.uint32();
          switch (tag >>> 3) {
            case 1:
              message.id = reader.string();
              break;
            case 2:
              message.conversationId = reader.string();
              break;
            case 3:
              if (!(message.events && message.events.length)) message.events = [];
              message.events.push(reader.string());
              break;
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };

      /**
       * Decodes a ConversationEventPoll message from the specified reader or buffer, length delimited.
       * @function decodeDelimited
       * @memberof propel.commrouter.ConversationEventPoll
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @returns {propel.commrouter.ConversationEventPoll} ConversationEventPoll
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      ConversationEventPoll.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader)) reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
      };

      /**
       * Verifies a ConversationEventPoll message.
       * @function verify
       * @memberof propel.commrouter.ConversationEventPoll
       * @static
       * @param {Object.<string,*>} message Plain object to verify
       * @returns {string|null} `null` if valid, otherwise the reason why it is not
       */
      ConversationEventPoll.verify = function verify(message) {
        if (typeof message !== 'object' || message === null) return 'object expected';
        if (message.id != null && message.hasOwnProperty('id'))
          if (!$util.isString(message.id)) return 'id: string expected';
        if (message.conversationId != null && message.hasOwnProperty('conversationId'))
          if (!$util.isString(message.conversationId)) return 'conversationId: string expected';
        if (message.events != null && message.hasOwnProperty('events')) {
          if (!Array.isArray(message.events)) return 'events: array expected';
          for (var i = 0; i < message.events.length; ++i)
            if (!$util.isString(message.events[i])) return 'events: string[] expected';
        }
        return null;
      };

      /**
       * Creates a ConversationEventPoll message from a plain object. Also converts values to their respective internal types.
       * @function fromObject
       * @memberof propel.commrouter.ConversationEventPoll
       * @static
       * @param {Object.<string,*>} object Plain object
       * @returns {propel.commrouter.ConversationEventPoll} ConversationEventPoll
       */
      ConversationEventPoll.fromObject = function fromObject(object) {
        if (object instanceof $root.propel.commrouter.ConversationEventPoll) return object;
        var message = new $root.propel.commrouter.ConversationEventPoll();
        if (object.id != null) message.id = String(object.id);
        if (object.conversationId != null) message.conversationId = String(object.conversationId);
        if (object.events) {
          if (!Array.isArray(object.events))
            throw TypeError('.propel.commrouter.ConversationEventPoll.events: array expected');
          message.events = [];
          for (var i = 0; i < object.events.length; ++i)
            message.events[i] = String(object.events[i]);
        }
        return message;
      };

      /**
       * Creates a plain object from a ConversationEventPoll message. Also converts values to other types if specified.
       * @function toObject
       * @memberof propel.commrouter.ConversationEventPoll
       * @static
       * @param {propel.commrouter.ConversationEventPoll} message ConversationEventPoll
       * @param {$protobuf.IConversionOptions} [options] Conversion options
       * @returns {Object.<string,*>} Plain object
       */
      ConversationEventPoll.toObject = function toObject(message, options) {
        if (!options) options = {};
        var object = {};
        if (options.arrays || options.defaults) object.events = [];
        if (options.defaults) {
          object.id = '';
          object.conversationId = '';
        }
        if (message.id != null && message.hasOwnProperty('id')) object.id = message.id;
        if (message.conversationId != null && message.hasOwnProperty('conversationId'))
          object.conversationId = message.conversationId;
        if (message.events && message.events.length) {
          object.events = [];
          for (var j = 0; j < message.events.length; ++j) object.events[j] = message.events[j];
        }
        return object;
      };

      /**
       * Converts this ConversationEventPoll to JSON.
       * @function toJSON
       * @memberof propel.commrouter.ConversationEventPoll
       * @instance
       * @returns {Object.<string,*>} JSON object
       */
      ConversationEventPoll.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
      };

      return ConversationEventPoll;
    })();

    commrouter.Channel = (function () {
      /**
       * Properties of a Channel.
       * @memberof propel.commrouter
       * @interface IChannel
       * @property {propel.commrouter.IVendorId|null} [id] Channel id
       * @property {Array.<propel.commrouter.IAvatar>|null} [avatars] Channel avatars
       * @property {google.protobuf.IStruct|null} [info] Channel info
       * @property {propel.commrouter.IConversationMode|null} [conversationMode] Channel conversationMode
       */

      /**
       * Constructs a new Channel.
       * @memberof propel.commrouter
       * @classdesc Represents a Channel.
       * @implements IChannel
       * @constructor
       * @param {propel.commrouter.IChannel=} [properties] Properties to set
       */
      function Channel(properties) {
        this.avatars = [];
        if (properties)
          for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
      }

      /**
       * Channel id.
       * @member {propel.commrouter.IVendorId|null|undefined} id
       * @memberof propel.commrouter.Channel
       * @instance
       */
      Channel.prototype.id = null;

      /**
       * Channel avatars.
       * @member {Array.<propel.commrouter.IAvatar>} avatars
       * @memberof propel.commrouter.Channel
       * @instance
       */
      Channel.prototype.avatars = $util.emptyArray;

      /**
       * Channel info.
       * @member {google.protobuf.IStruct|null|undefined} info
       * @memberof propel.commrouter.Channel
       * @instance
       */
      Channel.prototype.info = null;

      /**
       * Channel conversationMode.
       * @member {propel.commrouter.IConversationMode|null|undefined} conversationMode
       * @memberof propel.commrouter.Channel
       * @instance
       */
      Channel.prototype.conversationMode = null;

      /**
       * Creates a new Channel instance using the specified properties.
       * @function create
       * @memberof propel.commrouter.Channel
       * @static
       * @param {propel.commrouter.IChannel=} [properties] Properties to set
       * @returns {propel.commrouter.Channel} Channel instance
       */
      Channel.create = function create(properties) {
        return new Channel(properties);
      };

      /**
       * Encodes the specified Channel message. Does not implicitly {@link propel.commrouter.Channel.verify|verify} messages.
       * @function encode
       * @memberof propel.commrouter.Channel
       * @static
       * @param {propel.commrouter.IChannel} message Channel message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      Channel.encode = function encode(message, writer) {
        if (!writer) writer = $Writer.create();
        if (message.id != null && message.hasOwnProperty('id'))
          $root.propel.commrouter.VendorId.encode(
            message.id,
            writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
          ).ldelim();
        if (message.avatars != null && message.avatars.length)
          for (var i = 0; i < message.avatars.length; ++i)
            $root.propel.commrouter.Avatar.encode(
              message.avatars[i],
              writer.uint32(/* id 2, wireType 2 =*/ 18).fork()
            ).ldelim();
        if (message.info != null && message.hasOwnProperty('info'))
          $root.google.protobuf.Struct.encode(
            message.info,
            writer.uint32(/* id 3, wireType 2 =*/ 26).fork()
          ).ldelim();
        if (message.conversationMode != null && message.hasOwnProperty('conversationMode'))
          $root.propel.commrouter.ConversationMode.encode(
            message.conversationMode,
            writer.uint32(/* id 4, wireType 2 =*/ 34).fork()
          ).ldelim();
        return writer;
      };

      /**
       * Encodes the specified Channel message, length delimited. Does not implicitly {@link propel.commrouter.Channel.verify|verify} messages.
       * @function encodeDelimited
       * @memberof propel.commrouter.Channel
       * @static
       * @param {propel.commrouter.IChannel} message Channel message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      Channel.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
      };

      /**
       * Decodes a Channel message from the specified reader or buffer.
       * @function decode
       * @memberof propel.commrouter.Channel
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @param {number} [length] Message length if known beforehand
       * @returns {propel.commrouter.Channel} Channel
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      Channel.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length,
          message = new $root.propel.commrouter.Channel();
        while (reader.pos < end) {
          var tag = reader.uint32();
          switch (tag >>> 3) {
            case 1:
              message.id = $root.propel.commrouter.VendorId.decode(reader, reader.uint32());
              break;
            case 2:
              if (!(message.avatars && message.avatars.length)) message.avatars = [];
              message.avatars.push($root.propel.commrouter.Avatar.decode(reader, reader.uint32()));
              break;
            case 3:
              message.info = $root.google.protobuf.Struct.decode(reader, reader.uint32());
              break;
            case 4:
              message.conversationMode = $root.propel.commrouter.ConversationMode.decode(
                reader,
                reader.uint32()
              );
              break;
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };

      /**
       * Decodes a Channel message from the specified reader or buffer, length delimited.
       * @function decodeDelimited
       * @memberof propel.commrouter.Channel
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @returns {propel.commrouter.Channel} Channel
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      Channel.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader)) reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
      };

      /**
       * Verifies a Channel message.
       * @function verify
       * @memberof propel.commrouter.Channel
       * @static
       * @param {Object.<string,*>} message Plain object to verify
       * @returns {string|null} `null` if valid, otherwise the reason why it is not
       */
      Channel.verify = function verify(message) {
        if (typeof message !== 'object' || message === null) return 'object expected';
        if (message.id != null && message.hasOwnProperty('id')) {
          var error = $root.propel.commrouter.VendorId.verify(message.id);
          if (error) return 'id.' + error;
        }
        if (message.avatars != null && message.hasOwnProperty('avatars')) {
          if (!Array.isArray(message.avatars)) return 'avatars: array expected';
          for (var i = 0; i < message.avatars.length; ++i) {
            var error = $root.propel.commrouter.Avatar.verify(message.avatars[i]);
            if (error) return 'avatars.' + error;
          }
        }
        if (message.info != null && message.hasOwnProperty('info')) {
          var error = $root.google.protobuf.Struct.verify(message.info);
          if (error) return 'info.' + error;
        }
        if (message.conversationMode != null && message.hasOwnProperty('conversationMode')) {
          var error = $root.propel.commrouter.ConversationMode.verify(message.conversationMode);
          if (error) return 'conversationMode.' + error;
        }
        return null;
      };

      /**
       * Creates a Channel message from a plain object. Also converts values to their respective internal types.
       * @function fromObject
       * @memberof propel.commrouter.Channel
       * @static
       * @param {Object.<string,*>} object Plain object
       * @returns {propel.commrouter.Channel} Channel
       */
      Channel.fromObject = function fromObject(object) {
        if (object instanceof $root.propel.commrouter.Channel) return object;
        var message = new $root.propel.commrouter.Channel();
        if (object.id != null) {
          if (typeof object.id !== 'object')
            throw TypeError('.propel.commrouter.Channel.id: object expected');
          message.id = $root.propel.commrouter.VendorId.fromObject(object.id);
        }
        if (object.avatars) {
          if (!Array.isArray(object.avatars))
            throw TypeError('.propel.commrouter.Channel.avatars: array expected');
          message.avatars = [];
          for (var i = 0; i < object.avatars.length; ++i) {
            if (typeof object.avatars[i] !== 'object')
              throw TypeError('.propel.commrouter.Channel.avatars: object expected');
            message.avatars[i] = $root.propel.commrouter.Avatar.fromObject(object.avatars[i]);
          }
        }
        if (object.info != null) {
          if (typeof object.info !== 'object')
            throw TypeError('.propel.commrouter.Channel.info: object expected');
          message.info = $root.google.protobuf.Struct.fromObject(object.info);
        }
        if (object.conversationMode != null) {
          if (typeof object.conversationMode !== 'object')
            throw TypeError('.propel.commrouter.Channel.conversationMode: object expected');
          message.conversationMode = $root.propel.commrouter.ConversationMode.fromObject(
            object.conversationMode
          );
        }
        return message;
      };

      /**
       * Creates a plain object from a Channel message. Also converts values to other types if specified.
       * @function toObject
       * @memberof propel.commrouter.Channel
       * @static
       * @param {propel.commrouter.Channel} message Channel
       * @param {$protobuf.IConversionOptions} [options] Conversion options
       * @returns {Object.<string,*>} Plain object
       */
      Channel.toObject = function toObject(message, options) {
        if (!options) options = {};
        var object = {};
        if (options.arrays || options.defaults) object.avatars = [];
        if (options.defaults) {
          object.id = null;
          object.info = null;
          object.conversationMode = null;
        }
        if (message.id != null && message.hasOwnProperty('id'))
          object.id = $root.propel.commrouter.VendorId.toObject(message.id, options);
        if (message.avatars && message.avatars.length) {
          object.avatars = [];
          for (var j = 0; j < message.avatars.length; ++j)
            object.avatars[j] = $root.propel.commrouter.Avatar.toObject(
              message.avatars[j],
              options
            );
        }
        if (message.info != null && message.hasOwnProperty('info'))
          object.info = $root.google.protobuf.Struct.toObject(message.info, options);
        if (message.conversationMode != null && message.hasOwnProperty('conversationMode'))
          object.conversationMode = $root.propel.commrouter.ConversationMode.toObject(
            message.conversationMode,
            options
          );
        return object;
      };

      /**
       * Converts this Channel to JSON.
       * @function toJSON
       * @memberof propel.commrouter.Channel
       * @instance
       * @returns {Object.<string,*>} JSON object
       */
      Channel.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
      };

      return Channel;
    })();

    commrouter.EngineState = (function () {
      /**
       * Properties of an EngineState.
       * @memberof propel.commrouter
       * @interface IEngineState
       * @property {Array.<string>|null} [conversationUpdateFiles] EngineState conversationUpdateFiles
       * @property {google.protobuf.IStringValue|null} [currentContextId] EngineState currentContextId
       */

      /**
       * Constructs a new EngineState.
       * @memberof propel.commrouter
       * @classdesc Represents an EngineState.
       * @implements IEngineState
       * @constructor
       * @param {propel.commrouter.IEngineState=} [properties] Properties to set
       */
      function EngineState(properties) {
        this.conversationUpdateFiles = [];
        if (properties)
          for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
      }

      /**
       * EngineState conversationUpdateFiles.
       * @member {Array.<string>} conversationUpdateFiles
       * @memberof propel.commrouter.EngineState
       * @instance
       */
      EngineState.prototype.conversationUpdateFiles = $util.emptyArray;

      /**
       * EngineState currentContextId.
       * @member {google.protobuf.IStringValue|null|undefined} currentContextId
       * @memberof propel.commrouter.EngineState
       * @instance
       */
      EngineState.prototype.currentContextId = null;

      /**
       * Creates a new EngineState instance using the specified properties.
       * @function create
       * @memberof propel.commrouter.EngineState
       * @static
       * @param {propel.commrouter.IEngineState=} [properties] Properties to set
       * @returns {propel.commrouter.EngineState} EngineState instance
       */
      EngineState.create = function create(properties) {
        return new EngineState(properties);
      };

      /**
       * Encodes the specified EngineState message. Does not implicitly {@link propel.commrouter.EngineState.verify|verify} messages.
       * @function encode
       * @memberof propel.commrouter.EngineState
       * @static
       * @param {propel.commrouter.IEngineState} message EngineState message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      EngineState.encode = function encode(message, writer) {
        if (!writer) writer = $Writer.create();
        if (message.conversationUpdateFiles != null && message.conversationUpdateFiles.length)
          for (var i = 0; i < message.conversationUpdateFiles.length; ++i)
            writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.conversationUpdateFiles[i]);
        if (message.currentContextId != null && message.hasOwnProperty('currentContextId'))
          $root.google.protobuf.StringValue.encode(
            message.currentContextId,
            writer.uint32(/* id 2, wireType 2 =*/ 18).fork()
          ).ldelim();
        return writer;
      };

      /**
       * Encodes the specified EngineState message, length delimited. Does not implicitly {@link propel.commrouter.EngineState.verify|verify} messages.
       * @function encodeDelimited
       * @memberof propel.commrouter.EngineState
       * @static
       * @param {propel.commrouter.IEngineState} message EngineState message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      EngineState.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
      };

      /**
       * Decodes an EngineState message from the specified reader or buffer.
       * @function decode
       * @memberof propel.commrouter.EngineState
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @param {number} [length] Message length if known beforehand
       * @returns {propel.commrouter.EngineState} EngineState
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      EngineState.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length,
          message = new $root.propel.commrouter.EngineState();
        while (reader.pos < end) {
          var tag = reader.uint32();
          switch (tag >>> 3) {
            case 1:
              if (!(message.conversationUpdateFiles && message.conversationUpdateFiles.length))
                message.conversationUpdateFiles = [];
              message.conversationUpdateFiles.push(reader.string());
              break;
            case 2:
              message.currentContextId = $root.google.protobuf.StringValue.decode(
                reader,
                reader.uint32()
              );
              break;
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };

      /**
       * Decodes an EngineState message from the specified reader or buffer, length delimited.
       * @function decodeDelimited
       * @memberof propel.commrouter.EngineState
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @returns {propel.commrouter.EngineState} EngineState
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      EngineState.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader)) reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
      };

      /**
       * Verifies an EngineState message.
       * @function verify
       * @memberof propel.commrouter.EngineState
       * @static
       * @param {Object.<string,*>} message Plain object to verify
       * @returns {string|null} `null` if valid, otherwise the reason why it is not
       */
      EngineState.verify = function verify(message) {
        if (typeof message !== 'object' || message === null) return 'object expected';
        if (
          message.conversationUpdateFiles != null &&
          message.hasOwnProperty('conversationUpdateFiles')
        ) {
          if (!Array.isArray(message.conversationUpdateFiles))
            return 'conversationUpdateFiles: array expected';
          for (var i = 0; i < message.conversationUpdateFiles.length; ++i)
            if (!$util.isString(message.conversationUpdateFiles[i]))
              return 'conversationUpdateFiles: string[] expected';
        }
        if (message.currentContextId != null && message.hasOwnProperty('currentContextId')) {
          var error = $root.google.protobuf.StringValue.verify(message.currentContextId);
          if (error) return 'currentContextId.' + error;
        }
        return null;
      };

      /**
       * Creates an EngineState message from a plain object. Also converts values to their respective internal types.
       * @function fromObject
       * @memberof propel.commrouter.EngineState
       * @static
       * @param {Object.<string,*>} object Plain object
       * @returns {propel.commrouter.EngineState} EngineState
       */
      EngineState.fromObject = function fromObject(object) {
        if (object instanceof $root.propel.commrouter.EngineState) return object;
        var message = new $root.propel.commrouter.EngineState();
        if (object.conversationUpdateFiles) {
          if (!Array.isArray(object.conversationUpdateFiles))
            throw TypeError(
              '.propel.commrouter.EngineState.conversationUpdateFiles: array expected'
            );
          message.conversationUpdateFiles = [];
          for (var i = 0; i < object.conversationUpdateFiles.length; ++i)
            message.conversationUpdateFiles[i] = String(object.conversationUpdateFiles[i]);
        }
        if (object.currentContextId != null) {
          if (typeof object.currentContextId !== 'object')
            throw TypeError('.propel.commrouter.EngineState.currentContextId: object expected');
          message.currentContextId = $root.google.protobuf.StringValue.fromObject(
            object.currentContextId
          );
        }
        return message;
      };

      /**
       * Creates a plain object from an EngineState message. Also converts values to other types if specified.
       * @function toObject
       * @memberof propel.commrouter.EngineState
       * @static
       * @param {propel.commrouter.EngineState} message EngineState
       * @param {$protobuf.IConversionOptions} [options] Conversion options
       * @returns {Object.<string,*>} Plain object
       */
      EngineState.toObject = function toObject(message, options) {
        if (!options) options = {};
        var object = {};
        if (options.arrays || options.defaults) object.conversationUpdateFiles = [];
        if (options.defaults) object.currentContextId = null;
        if (message.conversationUpdateFiles && message.conversationUpdateFiles.length) {
          object.conversationUpdateFiles = [];
          for (var j = 0; j < message.conversationUpdateFiles.length; ++j)
            object.conversationUpdateFiles[j] = message.conversationUpdateFiles[j];
        }
        if (message.currentContextId != null && message.hasOwnProperty('currentContextId'))
          object.currentContextId = $root.google.protobuf.StringValue.toObject(
            message.currentContextId,
            options
          );
        return object;
      };

      /**
       * Converts this EngineState to JSON.
       * @function toJSON
       * @memberof propel.commrouter.EngineState
       * @instance
       * @returns {Object.<string,*>} JSON object
       */
      EngineState.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
      };

      return EngineState;
    })();

    commrouter.IncomingLeadRef = (function () {
      /**
       * Properties of an IncomingLeadRef.
       * @memberof propel.commrouter
       * @interface IIncomingLeadRef
       * @property {string|null} [id] IncomingLeadRef id
       * @property {string|null} [file] IncomingLeadRef file
       */

      /**
       * Constructs a new IncomingLeadRef.
       * @memberof propel.commrouter
       * @classdesc Represents an IncomingLeadRef.
       * @implements IIncomingLeadRef
       * @constructor
       * @param {propel.commrouter.IIncomingLeadRef=} [properties] Properties to set
       */
      function IncomingLeadRef(properties) {
        if (properties)
          for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
      }

      /**
       * IncomingLeadRef id.
       * @member {string} id
       * @memberof propel.commrouter.IncomingLeadRef
       * @instance
       */
      IncomingLeadRef.prototype.id = '';

      /**
       * IncomingLeadRef file.
       * @member {string} file
       * @memberof propel.commrouter.IncomingLeadRef
       * @instance
       */
      IncomingLeadRef.prototype.file = '';

      /**
       * Creates a new IncomingLeadRef instance using the specified properties.
       * @function create
       * @memberof propel.commrouter.IncomingLeadRef
       * @static
       * @param {propel.commrouter.IIncomingLeadRef=} [properties] Properties to set
       * @returns {propel.commrouter.IncomingLeadRef} IncomingLeadRef instance
       */
      IncomingLeadRef.create = function create(properties) {
        return new IncomingLeadRef(properties);
      };

      /**
       * Encodes the specified IncomingLeadRef message. Does not implicitly {@link propel.commrouter.IncomingLeadRef.verify|verify} messages.
       * @function encode
       * @memberof propel.commrouter.IncomingLeadRef
       * @static
       * @param {propel.commrouter.IIncomingLeadRef} message IncomingLeadRef message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      IncomingLeadRef.encode = function encode(message, writer) {
        if (!writer) writer = $Writer.create();
        if (message.id != null && message.hasOwnProperty('id'))
          writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
        if (message.file != null && message.hasOwnProperty('file'))
          writer.uint32(/* id 2, wireType 2 =*/ 18).string(message.file);
        return writer;
      };

      /**
       * Encodes the specified IncomingLeadRef message, length delimited. Does not implicitly {@link propel.commrouter.IncomingLeadRef.verify|verify} messages.
       * @function encodeDelimited
       * @memberof propel.commrouter.IncomingLeadRef
       * @static
       * @param {propel.commrouter.IIncomingLeadRef} message IncomingLeadRef message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      IncomingLeadRef.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
      };

      /**
       * Decodes an IncomingLeadRef message from the specified reader or buffer.
       * @function decode
       * @memberof propel.commrouter.IncomingLeadRef
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @param {number} [length] Message length if known beforehand
       * @returns {propel.commrouter.IncomingLeadRef} IncomingLeadRef
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      IncomingLeadRef.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length,
          message = new $root.propel.commrouter.IncomingLeadRef();
        while (reader.pos < end) {
          var tag = reader.uint32();
          switch (tag >>> 3) {
            case 1:
              message.id = reader.string();
              break;
            case 2:
              message.file = reader.string();
              break;
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };

      /**
       * Decodes an IncomingLeadRef message from the specified reader or buffer, length delimited.
       * @function decodeDelimited
       * @memberof propel.commrouter.IncomingLeadRef
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @returns {propel.commrouter.IncomingLeadRef} IncomingLeadRef
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      IncomingLeadRef.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader)) reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
      };

      /**
       * Verifies an IncomingLeadRef message.
       * @function verify
       * @memberof propel.commrouter.IncomingLeadRef
       * @static
       * @param {Object.<string,*>} message Plain object to verify
       * @returns {string|null} `null` if valid, otherwise the reason why it is not
       */
      IncomingLeadRef.verify = function verify(message) {
        if (typeof message !== 'object' || message === null) return 'object expected';
        if (message.id != null && message.hasOwnProperty('id'))
          if (!$util.isString(message.id)) return 'id: string expected';
        if (message.file != null && message.hasOwnProperty('file'))
          if (!$util.isString(message.file)) return 'file: string expected';
        return null;
      };

      /**
       * Creates an IncomingLeadRef message from a plain object. Also converts values to their respective internal types.
       * @function fromObject
       * @memberof propel.commrouter.IncomingLeadRef
       * @static
       * @param {Object.<string,*>} object Plain object
       * @returns {propel.commrouter.IncomingLeadRef} IncomingLeadRef
       */
      IncomingLeadRef.fromObject = function fromObject(object) {
        if (object instanceof $root.propel.commrouter.IncomingLeadRef) return object;
        var message = new $root.propel.commrouter.IncomingLeadRef();
        if (object.id != null) message.id = String(object.id);
        if (object.file != null) message.file = String(object.file);
        return message;
      };

      /**
       * Creates a plain object from an IncomingLeadRef message. Also converts values to other types if specified.
       * @function toObject
       * @memberof propel.commrouter.IncomingLeadRef
       * @static
       * @param {propel.commrouter.IncomingLeadRef} message IncomingLeadRef
       * @param {$protobuf.IConversionOptions} [options] Conversion options
       * @returns {Object.<string,*>} Plain object
       */
      IncomingLeadRef.toObject = function toObject(message, options) {
        if (!options) options = {};
        var object = {};
        if (options.defaults) {
          object.id = '';
          object.file = '';
        }
        if (message.id != null && message.hasOwnProperty('id')) object.id = message.id;
        if (message.file != null && message.hasOwnProperty('file')) object.file = message.file;
        return object;
      };

      /**
       * Converts this IncomingLeadRef to JSON.
       * @function toJSON
       * @memberof propel.commrouter.IncomingLeadRef
       * @instance
       * @returns {Object.<string,*>} JSON object
       */
      IncomingLeadRef.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
      };

      return IncomingLeadRef;
    })();

    commrouter.TransientConversationState = (function () {
      /**
       * Properties of a TransientConversationState.
       * @memberof propel.commrouter
       * @interface ITransientConversationState
       * @property {Array.<propel.commrouter.IResponse>|null} [responses] TransientConversationState responses
       */

      /**
       * Constructs a new TransientConversationState.
       * @memberof propel.commrouter
       * @classdesc Represents a TransientConversationState.
       * @implements ITransientConversationState
       * @constructor
       * @param {propel.commrouter.ITransientConversationState=} [properties] Properties to set
       */
      function TransientConversationState(properties) {
        this.responses = [];
        if (properties)
          for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
      }

      /**
       * TransientConversationState responses.
       * @member {Array.<propel.commrouter.IResponse>} responses
       * @memberof propel.commrouter.TransientConversationState
       * @instance
       */
      TransientConversationState.prototype.responses = $util.emptyArray;

      /**
       * Creates a new TransientConversationState instance using the specified properties.
       * @function create
       * @memberof propel.commrouter.TransientConversationState
       * @static
       * @param {propel.commrouter.ITransientConversationState=} [properties] Properties to set
       * @returns {propel.commrouter.TransientConversationState} TransientConversationState instance
       */
      TransientConversationState.create = function create(properties) {
        return new TransientConversationState(properties);
      };

      /**
       * Encodes the specified TransientConversationState message. Does not implicitly {@link propel.commrouter.TransientConversationState.verify|verify} messages.
       * @function encode
       * @memberof propel.commrouter.TransientConversationState
       * @static
       * @param {propel.commrouter.ITransientConversationState} message TransientConversationState message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      TransientConversationState.encode = function encode(message, writer) {
        if (!writer) writer = $Writer.create();
        if (message.responses != null && message.responses.length)
          for (var i = 0; i < message.responses.length; ++i)
            $root.propel.commrouter.Response.encode(
              message.responses[i],
              writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
            ).ldelim();
        return writer;
      };

      /**
       * Encodes the specified TransientConversationState message, length delimited. Does not implicitly {@link propel.commrouter.TransientConversationState.verify|verify} messages.
       * @function encodeDelimited
       * @memberof propel.commrouter.TransientConversationState
       * @static
       * @param {propel.commrouter.ITransientConversationState} message TransientConversationState message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      TransientConversationState.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
      };

      /**
       * Decodes a TransientConversationState message from the specified reader or buffer.
       * @function decode
       * @memberof propel.commrouter.TransientConversationState
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @param {number} [length] Message length if known beforehand
       * @returns {propel.commrouter.TransientConversationState} TransientConversationState
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      TransientConversationState.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length,
          message = new $root.propel.commrouter.TransientConversationState();
        while (reader.pos < end) {
          var tag = reader.uint32();
          switch (tag >>> 3) {
            case 1:
              if (!(message.responses && message.responses.length)) message.responses = [];
              message.responses.push(
                $root.propel.commrouter.Response.decode(reader, reader.uint32())
              );
              break;
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };

      /**
       * Decodes a TransientConversationState message from the specified reader or buffer, length delimited.
       * @function decodeDelimited
       * @memberof propel.commrouter.TransientConversationState
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @returns {propel.commrouter.TransientConversationState} TransientConversationState
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      TransientConversationState.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader)) reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
      };

      /**
       * Verifies a TransientConversationState message.
       * @function verify
       * @memberof propel.commrouter.TransientConversationState
       * @static
       * @param {Object.<string,*>} message Plain object to verify
       * @returns {string|null} `null` if valid, otherwise the reason why it is not
       */
      TransientConversationState.verify = function verify(message) {
        if (typeof message !== 'object' || message === null) return 'object expected';
        if (message.responses != null && message.hasOwnProperty('responses')) {
          if (!Array.isArray(message.responses)) return 'responses: array expected';
          for (var i = 0; i < message.responses.length; ++i) {
            var error = $root.propel.commrouter.Response.verify(message.responses[i]);
            if (error) return 'responses.' + error;
          }
        }
        return null;
      };

      /**
       * Creates a TransientConversationState message from a plain object. Also converts values to their respective internal types.
       * @function fromObject
       * @memberof propel.commrouter.TransientConversationState
       * @static
       * @param {Object.<string,*>} object Plain object
       * @returns {propel.commrouter.TransientConversationState} TransientConversationState
       */
      TransientConversationState.fromObject = function fromObject(object) {
        if (object instanceof $root.propel.commrouter.TransientConversationState) return object;
        var message = new $root.propel.commrouter.TransientConversationState();
        if (object.responses) {
          if (!Array.isArray(object.responses))
            throw TypeError(
              '.propel.commrouter.TransientConversationState.responses: array expected'
            );
          message.responses = [];
          for (var i = 0; i < object.responses.length; ++i) {
            if (typeof object.responses[i] !== 'object')
              throw TypeError(
                '.propel.commrouter.TransientConversationState.responses: object expected'
              );
            message.responses[i] = $root.propel.commrouter.Response.fromObject(object.responses[i]);
          }
        }
        return message;
      };

      /**
       * Creates a plain object from a TransientConversationState message. Also converts values to other types if specified.
       * @function toObject
       * @memberof propel.commrouter.TransientConversationState
       * @static
       * @param {propel.commrouter.TransientConversationState} message TransientConversationState
       * @param {$protobuf.IConversionOptions} [options] Conversion options
       * @returns {Object.<string,*>} Plain object
       */
      TransientConversationState.toObject = function toObject(message, options) {
        if (!options) options = {};
        var object = {};
        if (options.arrays || options.defaults) object.responses = [];
        if (message.responses && message.responses.length) {
          object.responses = [];
          for (var j = 0; j < message.responses.length; ++j)
            object.responses[j] = $root.propel.commrouter.Response.toObject(
              message.responses[j],
              options
            );
        }
        return object;
      };

      /**
       * Converts this TransientConversationState to JSON.
       * @function toJSON
       * @memberof propel.commrouter.TransientConversationState
       * @instance
       * @returns {Object.<string,*>} JSON object
       */
      TransientConversationState.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
      };

      return TransientConversationState;
    })();

    commrouter.ConversationState = (function () {
      /**
       * Properties of a ConversationState.
       * @memberof propel.commrouter
       * @interface IConversationState
       * @property {string|null} [conversationId] ConversationState conversationId
       * @property {Array.<propel.commrouter.IChannel>|null} [channels] ConversationState channels
       * @property {propel.commrouter.IVendorId|null} [lastChannelId] ConversationState lastChannelId
       * @property {Array.<propel.commrouter.IAvatar>|null} [avatars] ConversationState avatars
       * @property {Array.<propel.commrouter.IMessage>|null} [sendingMessages] ConversationState sendingMessages
       * @property {Array.<propel.commrouter.ISentence>|null} [queuedSentences] ConversationState queuedSentences
       * @property {propel.commrouter.IContext|null} [context] ConversationState context
       * @property {propel.commrouter.IConversationMode|null} [conversationMode] ConversationState conversationMode
       * @property {propel.commrouter.IEngineState|null} [engineState] ConversationState engineState
       * @property {Object.<string,google.protobuf.IStruct>|null} [info] ConversationState info
       * @property {Array.<propel.commrouter.ITag>|null} [tags] ConversationState tags
       * @property {Array.<propel.commrouter.IJob>|null} [jobs] ConversationState jobs
       * @property {Array.<propel.commrouter.IIncomingLeadRef>|null} [incomingLeadRefs] ConversationState incomingLeadRefs
       * @property {propel.commrouter.ITransientConversationState|null} [transient] ConversationState transient
       */

      /**
       * Constructs a new ConversationState.
       * @memberof propel.commrouter
       * @classdesc Represents a ConversationState.
       * @implements IConversationState
       * @constructor
       * @param {propel.commrouter.IConversationState=} [properties] Properties to set
       */
      function ConversationState(properties) {
        this.channels = [];
        this.avatars = [];
        this.sendingMessages = [];
        this.queuedSentences = [];
        this.info = {};
        this.tags = [];
        this.jobs = [];
        this.incomingLeadRefs = [];
        if (properties)
          for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
      }

      /**
       * ConversationState conversationId.
       * @member {string} conversationId
       * @memberof propel.commrouter.ConversationState
       * @instance
       */
      ConversationState.prototype.conversationId = '';

      /**
       * ConversationState channels.
       * @member {Array.<propel.commrouter.IChannel>} channels
       * @memberof propel.commrouter.ConversationState
       * @instance
       */
      ConversationState.prototype.channels = $util.emptyArray;

      /**
       * ConversationState lastChannelId.
       * @member {propel.commrouter.IVendorId|null|undefined} lastChannelId
       * @memberof propel.commrouter.ConversationState
       * @instance
       */
      ConversationState.prototype.lastChannelId = null;

      /**
       * ConversationState avatars.
       * @member {Array.<propel.commrouter.IAvatar>} avatars
       * @memberof propel.commrouter.ConversationState
       * @instance
       */
      ConversationState.prototype.avatars = $util.emptyArray;

      /**
       * ConversationState sendingMessages.
       * @member {Array.<propel.commrouter.IMessage>} sendingMessages
       * @memberof propel.commrouter.ConversationState
       * @instance
       */
      ConversationState.prototype.sendingMessages = $util.emptyArray;

      /**
       * ConversationState queuedSentences.
       * @member {Array.<propel.commrouter.ISentence>} queuedSentences
       * @memberof propel.commrouter.ConversationState
       * @instance
       */
      ConversationState.prototype.queuedSentences = $util.emptyArray;

      /**
       * ConversationState context.
       * @member {propel.commrouter.IContext|null|undefined} context
       * @memberof propel.commrouter.ConversationState
       * @instance
       */
      ConversationState.prototype.context = null;

      /**
       * ConversationState conversationMode.
       * @member {propel.commrouter.IConversationMode|null|undefined} conversationMode
       * @memberof propel.commrouter.ConversationState
       * @instance
       */
      ConversationState.prototype.conversationMode = null;

      /**
       * ConversationState engineState.
       * @member {propel.commrouter.IEngineState|null|undefined} engineState
       * @memberof propel.commrouter.ConversationState
       * @instance
       */
      ConversationState.prototype.engineState = null;

      /**
       * ConversationState info.
       * @member {Object.<string,google.protobuf.IStruct>} info
       * @memberof propel.commrouter.ConversationState
       * @instance
       */
      ConversationState.prototype.info = $util.emptyObject;

      /**
       * ConversationState tags.
       * @member {Array.<propel.commrouter.ITag>} tags
       * @memberof propel.commrouter.ConversationState
       * @instance
       */
      ConversationState.prototype.tags = $util.emptyArray;

      /**
       * ConversationState jobs.
       * @member {Array.<propel.commrouter.IJob>} jobs
       * @memberof propel.commrouter.ConversationState
       * @instance
       */
      ConversationState.prototype.jobs = $util.emptyArray;

      /**
       * ConversationState incomingLeadRefs.
       * @member {Array.<propel.commrouter.IIncomingLeadRef>} incomingLeadRefs
       * @memberof propel.commrouter.ConversationState
       * @instance
       */
      ConversationState.prototype.incomingLeadRefs = $util.emptyArray;

      /**
       * ConversationState transient.
       * @member {propel.commrouter.ITransientConversationState|null|undefined} transient
       * @memberof propel.commrouter.ConversationState
       * @instance
       */
      ConversationState.prototype.transient = null;

      /**
       * Creates a new ConversationState instance using the specified properties.
       * @function create
       * @memberof propel.commrouter.ConversationState
       * @static
       * @param {propel.commrouter.IConversationState=} [properties] Properties to set
       * @returns {propel.commrouter.ConversationState} ConversationState instance
       */
      ConversationState.create = function create(properties) {
        return new ConversationState(properties);
      };

      /**
       * Encodes the specified ConversationState message. Does not implicitly {@link propel.commrouter.ConversationState.verify|verify} messages.
       * @function encode
       * @memberof propel.commrouter.ConversationState
       * @static
       * @param {propel.commrouter.IConversationState} message ConversationState message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      ConversationState.encode = function encode(message, writer) {
        if (!writer) writer = $Writer.create();
        if (message.conversationId != null && message.hasOwnProperty('conversationId'))
          writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.conversationId);
        if (message.channels != null && message.channels.length)
          for (var i = 0; i < message.channels.length; ++i)
            $root.propel.commrouter.Channel.encode(
              message.channels[i],
              writer.uint32(/* id 2, wireType 2 =*/ 18).fork()
            ).ldelim();
        if (message.lastChannelId != null && message.hasOwnProperty('lastChannelId'))
          $root.propel.commrouter.VendorId.encode(
            message.lastChannelId,
            writer.uint32(/* id 3, wireType 2 =*/ 26).fork()
          ).ldelim();
        if (message.avatars != null && message.avatars.length)
          for (var i = 0; i < message.avatars.length; ++i)
            $root.propel.commrouter.Avatar.encode(
              message.avatars[i],
              writer.uint32(/* id 4, wireType 2 =*/ 34).fork()
            ).ldelim();
        if (message.sendingMessages != null && message.sendingMessages.length)
          for (var i = 0; i < message.sendingMessages.length; ++i)
            $root.propel.commrouter.Message.encode(
              message.sendingMessages[i],
              writer.uint32(/* id 5, wireType 2 =*/ 42).fork()
            ).ldelim();
        if (message.queuedSentences != null && message.queuedSentences.length)
          for (var i = 0; i < message.queuedSentences.length; ++i)
            $root.propel.commrouter.Sentence.encode(
              message.queuedSentences[i],
              writer.uint32(/* id 6, wireType 2 =*/ 50).fork()
            ).ldelim();
        if (message.context != null && message.hasOwnProperty('context'))
          $root.propel.commrouter.Context.encode(
            message.context,
            writer.uint32(/* id 8, wireType 2 =*/ 66).fork()
          ).ldelim();
        if (message.conversationMode != null && message.hasOwnProperty('conversationMode'))
          $root.propel.commrouter.ConversationMode.encode(
            message.conversationMode,
            writer.uint32(/* id 9, wireType 2 =*/ 74).fork()
          ).ldelim();
        if (message.engineState != null && message.hasOwnProperty('engineState'))
          $root.propel.commrouter.EngineState.encode(
            message.engineState,
            writer.uint32(/* id 10, wireType 2 =*/ 82).fork()
          ).ldelim();
        if (message.info != null && message.hasOwnProperty('info'))
          for (var keys = Object.keys(message.info), i = 0; i < keys.length; ++i) {
            writer
              .uint32(/* id 11, wireType 2 =*/ 90)
              .fork()
              .uint32(/* id 1, wireType 2 =*/ 10)
              .string(keys[i]);
            $root.google.protobuf.Struct.encode(
              message.info[keys[i]],
              writer.uint32(/* id 2, wireType 2 =*/ 18).fork()
            )
              .ldelim()
              .ldelim();
          }
        if (message.tags != null && message.tags.length)
          for (var i = 0; i < message.tags.length; ++i)
            $root.propel.commrouter.Tag.encode(
              message.tags[i],
              writer.uint32(/* id 12, wireType 2 =*/ 98).fork()
            ).ldelim();
        if (message.jobs != null && message.jobs.length)
          for (var i = 0; i < message.jobs.length; ++i)
            $root.propel.commrouter.Job.encode(
              message.jobs[i],
              writer.uint32(/* id 13, wireType 2 =*/ 106).fork()
            ).ldelim();
        if (message.incomingLeadRefs != null && message.incomingLeadRefs.length)
          for (var i = 0; i < message.incomingLeadRefs.length; ++i)
            $root.propel.commrouter.IncomingLeadRef.encode(
              message.incomingLeadRefs[i],
              writer.uint32(/* id 14, wireType 2 =*/ 114).fork()
            ).ldelim();
        if (message.transient != null && message.hasOwnProperty('transient'))
          $root.propel.commrouter.TransientConversationState.encode(
            message.transient,
            writer.uint32(/* id 1000, wireType 2 =*/ 8002).fork()
          ).ldelim();
        return writer;
      };

      /**
       * Encodes the specified ConversationState message, length delimited. Does not implicitly {@link propel.commrouter.ConversationState.verify|verify} messages.
       * @function encodeDelimited
       * @memberof propel.commrouter.ConversationState
       * @static
       * @param {propel.commrouter.IConversationState} message ConversationState message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      ConversationState.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
      };

      /**
       * Decodes a ConversationState message from the specified reader or buffer.
       * @function decode
       * @memberof propel.commrouter.ConversationState
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @param {number} [length] Message length if known beforehand
       * @returns {propel.commrouter.ConversationState} ConversationState
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      ConversationState.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length,
          message = new $root.propel.commrouter.ConversationState(),
          key;
        while (reader.pos < end) {
          var tag = reader.uint32();
          switch (tag >>> 3) {
            case 1:
              message.conversationId = reader.string();
              break;
            case 2:
              if (!(message.channels && message.channels.length)) message.channels = [];
              message.channels.push(
                $root.propel.commrouter.Channel.decode(reader, reader.uint32())
              );
              break;
            case 3:
              message.lastChannelId = $root.propel.commrouter.VendorId.decode(
                reader,
                reader.uint32()
              );
              break;
            case 4:
              if (!(message.avatars && message.avatars.length)) message.avatars = [];
              message.avatars.push($root.propel.commrouter.Avatar.decode(reader, reader.uint32()));
              break;
            case 5:
              if (!(message.sendingMessages && message.sendingMessages.length))
                message.sendingMessages = [];
              message.sendingMessages.push(
                $root.propel.commrouter.Message.decode(reader, reader.uint32())
              );
              break;
            case 6:
              if (!(message.queuedSentences && message.queuedSentences.length))
                message.queuedSentences = [];
              message.queuedSentences.push(
                $root.propel.commrouter.Sentence.decode(reader, reader.uint32())
              );
              break;
            case 8:
              message.context = $root.propel.commrouter.Context.decode(reader, reader.uint32());
              break;
            case 9:
              message.conversationMode = $root.propel.commrouter.ConversationMode.decode(
                reader,
                reader.uint32()
              );
              break;
            case 10:
              message.engineState = $root.propel.commrouter.EngineState.decode(
                reader,
                reader.uint32()
              );
              break;
            case 11:
              reader.skip().pos++;
              if (message.info === $util.emptyObject) message.info = {};
              key = reader.string();
              reader.pos++;
              message.info[key] = $root.google.protobuf.Struct.decode(reader, reader.uint32());
              break;
            case 12:
              if (!(message.tags && message.tags.length)) message.tags = [];
              message.tags.push($root.propel.commrouter.Tag.decode(reader, reader.uint32()));
              break;
            case 13:
              if (!(message.jobs && message.jobs.length)) message.jobs = [];
              message.jobs.push($root.propel.commrouter.Job.decode(reader, reader.uint32()));
              break;
            case 14:
              if (!(message.incomingLeadRefs && message.incomingLeadRefs.length))
                message.incomingLeadRefs = [];
              message.incomingLeadRefs.push(
                $root.propel.commrouter.IncomingLeadRef.decode(reader, reader.uint32())
              );
              break;
            case 1000:
              message.transient = $root.propel.commrouter.TransientConversationState.decode(
                reader,
                reader.uint32()
              );
              break;
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };

      /**
       * Decodes a ConversationState message from the specified reader or buffer, length delimited.
       * @function decodeDelimited
       * @memberof propel.commrouter.ConversationState
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @returns {propel.commrouter.ConversationState} ConversationState
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      ConversationState.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader)) reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
      };

      /**
       * Verifies a ConversationState message.
       * @function verify
       * @memberof propel.commrouter.ConversationState
       * @static
       * @param {Object.<string,*>} message Plain object to verify
       * @returns {string|null} `null` if valid, otherwise the reason why it is not
       */
      ConversationState.verify = function verify(message) {
        if (typeof message !== 'object' || message === null) return 'object expected';
        if (message.conversationId != null && message.hasOwnProperty('conversationId'))
          if (!$util.isString(message.conversationId)) return 'conversationId: string expected';
        if (message.channels != null && message.hasOwnProperty('channels')) {
          if (!Array.isArray(message.channels)) return 'channels: array expected';
          for (var i = 0; i < message.channels.length; ++i) {
            var error = $root.propel.commrouter.Channel.verify(message.channels[i]);
            if (error) return 'channels.' + error;
          }
        }
        if (message.lastChannelId != null && message.hasOwnProperty('lastChannelId')) {
          var error = $root.propel.commrouter.VendorId.verify(message.lastChannelId);
          if (error) return 'lastChannelId.' + error;
        }
        if (message.avatars != null && message.hasOwnProperty('avatars')) {
          if (!Array.isArray(message.avatars)) return 'avatars: array expected';
          for (var i = 0; i < message.avatars.length; ++i) {
            var error = $root.propel.commrouter.Avatar.verify(message.avatars[i]);
            if (error) return 'avatars.' + error;
          }
        }
        if (message.sendingMessages != null && message.hasOwnProperty('sendingMessages')) {
          if (!Array.isArray(message.sendingMessages)) return 'sendingMessages: array expected';
          for (var i = 0; i < message.sendingMessages.length; ++i) {
            var error = $root.propel.commrouter.Message.verify(message.sendingMessages[i]);
            if (error) return 'sendingMessages.' + error;
          }
        }
        if (message.queuedSentences != null && message.hasOwnProperty('queuedSentences')) {
          if (!Array.isArray(message.queuedSentences)) return 'queuedSentences: array expected';
          for (var i = 0; i < message.queuedSentences.length; ++i) {
            var error = $root.propel.commrouter.Sentence.verify(message.queuedSentences[i]);
            if (error) return 'queuedSentences.' + error;
          }
        }
        if (message.context != null && message.hasOwnProperty('context')) {
          var error = $root.propel.commrouter.Context.verify(message.context);
          if (error) return 'context.' + error;
        }
        if (message.conversationMode != null && message.hasOwnProperty('conversationMode')) {
          var error = $root.propel.commrouter.ConversationMode.verify(message.conversationMode);
          if (error) return 'conversationMode.' + error;
        }
        if (message.engineState != null && message.hasOwnProperty('engineState')) {
          var error = $root.propel.commrouter.EngineState.verify(message.engineState);
          if (error) return 'engineState.' + error;
        }
        if (message.info != null && message.hasOwnProperty('info')) {
          if (!$util.isObject(message.info)) return 'info: object expected';
          var key = Object.keys(message.info);
          for (var i = 0; i < key.length; ++i) {
            var error = $root.google.protobuf.Struct.verify(message.info[key[i]]);
            if (error) return 'info.' + error;
          }
        }
        if (message.tags != null && message.hasOwnProperty('tags')) {
          if (!Array.isArray(message.tags)) return 'tags: array expected';
          for (var i = 0; i < message.tags.length; ++i) {
            var error = $root.propel.commrouter.Tag.verify(message.tags[i]);
            if (error) return 'tags.' + error;
          }
        }
        if (message.jobs != null && message.hasOwnProperty('jobs')) {
          if (!Array.isArray(message.jobs)) return 'jobs: array expected';
          for (var i = 0; i < message.jobs.length; ++i) {
            var error = $root.propel.commrouter.Job.verify(message.jobs[i]);
            if (error) return 'jobs.' + error;
          }
        }
        if (message.incomingLeadRefs != null && message.hasOwnProperty('incomingLeadRefs')) {
          if (!Array.isArray(message.incomingLeadRefs)) return 'incomingLeadRefs: array expected';
          for (var i = 0; i < message.incomingLeadRefs.length; ++i) {
            var error = $root.propel.commrouter.IncomingLeadRef.verify(message.incomingLeadRefs[i]);
            if (error) return 'incomingLeadRefs.' + error;
          }
        }
        if (message.transient != null && message.hasOwnProperty('transient')) {
          var error = $root.propel.commrouter.TransientConversationState.verify(message.transient);
          if (error) return 'transient.' + error;
        }
        return null;
      };

      /**
       * Creates a ConversationState message from a plain object. Also converts values to their respective internal types.
       * @function fromObject
       * @memberof propel.commrouter.ConversationState
       * @static
       * @param {Object.<string,*>} object Plain object
       * @returns {propel.commrouter.ConversationState} ConversationState
       */
      ConversationState.fromObject = function fromObject(object) {
        if (object instanceof $root.propel.commrouter.ConversationState) return object;
        var message = new $root.propel.commrouter.ConversationState();
        if (object.conversationId != null) message.conversationId = String(object.conversationId);
        if (object.channels) {
          if (!Array.isArray(object.channels))
            throw TypeError('.propel.commrouter.ConversationState.channels: array expected');
          message.channels = [];
          for (var i = 0; i < object.channels.length; ++i) {
            if (typeof object.channels[i] !== 'object')
              throw TypeError('.propel.commrouter.ConversationState.channels: object expected');
            message.channels[i] = $root.propel.commrouter.Channel.fromObject(object.channels[i]);
          }
        }
        if (object.lastChannelId != null) {
          if (typeof object.lastChannelId !== 'object')
            throw TypeError('.propel.commrouter.ConversationState.lastChannelId: object expected');
          message.lastChannelId = $root.propel.commrouter.VendorId.fromObject(object.lastChannelId);
        }
        if (object.avatars) {
          if (!Array.isArray(object.avatars))
            throw TypeError('.propel.commrouter.ConversationState.avatars: array expected');
          message.avatars = [];
          for (var i = 0; i < object.avatars.length; ++i) {
            if (typeof object.avatars[i] !== 'object')
              throw TypeError('.propel.commrouter.ConversationState.avatars: object expected');
            message.avatars[i] = $root.propel.commrouter.Avatar.fromObject(object.avatars[i]);
          }
        }
        if (object.sendingMessages) {
          if (!Array.isArray(object.sendingMessages))
            throw TypeError('.propel.commrouter.ConversationState.sendingMessages: array expected');
          message.sendingMessages = [];
          for (var i = 0; i < object.sendingMessages.length; ++i) {
            if (typeof object.sendingMessages[i] !== 'object')
              throw TypeError(
                '.propel.commrouter.ConversationState.sendingMessages: object expected'
              );
            message.sendingMessages[i] = $root.propel.commrouter.Message.fromObject(
              object.sendingMessages[i]
            );
          }
        }
        if (object.queuedSentences) {
          if (!Array.isArray(object.queuedSentences))
            throw TypeError('.propel.commrouter.ConversationState.queuedSentences: array expected');
          message.queuedSentences = [];
          for (var i = 0; i < object.queuedSentences.length; ++i) {
            if (typeof object.queuedSentences[i] !== 'object')
              throw TypeError(
                '.propel.commrouter.ConversationState.queuedSentences: object expected'
              );
            message.queuedSentences[i] = $root.propel.commrouter.Sentence.fromObject(
              object.queuedSentences[i]
            );
          }
        }
        if (object.context != null) {
          if (typeof object.context !== 'object')
            throw TypeError('.propel.commrouter.ConversationState.context: object expected');
          message.context = $root.propel.commrouter.Context.fromObject(object.context);
        }
        if (object.conversationMode != null) {
          if (typeof object.conversationMode !== 'object')
            throw TypeError(
              '.propel.commrouter.ConversationState.conversationMode: object expected'
            );
          message.conversationMode = $root.propel.commrouter.ConversationMode.fromObject(
            object.conversationMode
          );
        }
        if (object.engineState != null) {
          if (typeof object.engineState !== 'object')
            throw TypeError('.propel.commrouter.ConversationState.engineState: object expected');
          message.engineState = $root.propel.commrouter.EngineState.fromObject(object.engineState);
        }
        if (object.info) {
          if (typeof object.info !== 'object')
            throw TypeError('.propel.commrouter.ConversationState.info: object expected');
          message.info = {};
          for (var keys = Object.keys(object.info), i = 0; i < keys.length; ++i) {
            if (typeof object.info[keys[i]] !== 'object')
              throw TypeError('.propel.commrouter.ConversationState.info: object expected');
            message.info[keys[i]] = $root.google.protobuf.Struct.fromObject(object.info[keys[i]]);
          }
        }
        if (object.tags) {
          if (!Array.isArray(object.tags))
            throw TypeError('.propel.commrouter.ConversationState.tags: array expected');
          message.tags = [];
          for (var i = 0; i < object.tags.length; ++i) {
            if (typeof object.tags[i] !== 'object')
              throw TypeError('.propel.commrouter.ConversationState.tags: object expected');
            message.tags[i] = $root.propel.commrouter.Tag.fromObject(object.tags[i]);
          }
        }
        if (object.jobs) {
          if (!Array.isArray(object.jobs))
            throw TypeError('.propel.commrouter.ConversationState.jobs: array expected');
          message.jobs = [];
          for (var i = 0; i < object.jobs.length; ++i) {
            if (typeof object.jobs[i] !== 'object')
              throw TypeError('.propel.commrouter.ConversationState.jobs: object expected');
            message.jobs[i] = $root.propel.commrouter.Job.fromObject(object.jobs[i]);
          }
        }
        if (object.incomingLeadRefs) {
          if (!Array.isArray(object.incomingLeadRefs))
            throw TypeError(
              '.propel.commrouter.ConversationState.incomingLeadRefs: array expected'
            );
          message.incomingLeadRefs = [];
          for (var i = 0; i < object.incomingLeadRefs.length; ++i) {
            if (typeof object.incomingLeadRefs[i] !== 'object')
              throw TypeError(
                '.propel.commrouter.ConversationState.incomingLeadRefs: object expected'
              );
            message.incomingLeadRefs[i] = $root.propel.commrouter.IncomingLeadRef.fromObject(
              object.incomingLeadRefs[i]
            );
          }
        }
        if (object.transient != null) {
          if (typeof object.transient !== 'object')
            throw TypeError('.propel.commrouter.ConversationState.transient: object expected');
          message.transient = $root.propel.commrouter.TransientConversationState.fromObject(
            object.transient
          );
        }
        return message;
      };

      /**
       * Creates a plain object from a ConversationState message. Also converts values to other types if specified.
       * @function toObject
       * @memberof propel.commrouter.ConversationState
       * @static
       * @param {propel.commrouter.ConversationState} message ConversationState
       * @param {$protobuf.IConversionOptions} [options] Conversion options
       * @returns {Object.<string,*>} Plain object
       */
      ConversationState.toObject = function toObject(message, options) {
        if (!options) options = {};
        var object = {};
        if (options.arrays || options.defaults) {
          object.channels = [];
          object.avatars = [];
          object.sendingMessages = [];
          object.queuedSentences = [];
          object.tags = [];
          object.jobs = [];
          object.incomingLeadRefs = [];
        }
        if (options.objects || options.defaults) object.info = {};
        if (options.defaults) {
          object.conversationId = '';
          object.lastChannelId = null;
          object.context = null;
          object.conversationMode = null;
          object.engineState = null;
          object.transient = null;
        }
        if (message.conversationId != null && message.hasOwnProperty('conversationId'))
          object.conversationId = message.conversationId;
        if (message.channels && message.channels.length) {
          object.channels = [];
          for (var j = 0; j < message.channels.length; ++j)
            object.channels[j] = $root.propel.commrouter.Channel.toObject(
              message.channels[j],
              options
            );
        }
        if (message.lastChannelId != null && message.hasOwnProperty('lastChannelId'))
          object.lastChannelId = $root.propel.commrouter.VendorId.toObject(
            message.lastChannelId,
            options
          );
        if (message.avatars && message.avatars.length) {
          object.avatars = [];
          for (var j = 0; j < message.avatars.length; ++j)
            object.avatars[j] = $root.propel.commrouter.Avatar.toObject(
              message.avatars[j],
              options
            );
        }
        if (message.sendingMessages && message.sendingMessages.length) {
          object.sendingMessages = [];
          for (var j = 0; j < message.sendingMessages.length; ++j)
            object.sendingMessages[j] = $root.propel.commrouter.Message.toObject(
              message.sendingMessages[j],
              options
            );
        }
        if (message.queuedSentences && message.queuedSentences.length) {
          object.queuedSentences = [];
          for (var j = 0; j < message.queuedSentences.length; ++j)
            object.queuedSentences[j] = $root.propel.commrouter.Sentence.toObject(
              message.queuedSentences[j],
              options
            );
        }
        if (message.context != null && message.hasOwnProperty('context'))
          object.context = $root.propel.commrouter.Context.toObject(message.context, options);
        if (message.conversationMode != null && message.hasOwnProperty('conversationMode'))
          object.conversationMode = $root.propel.commrouter.ConversationMode.toObject(
            message.conversationMode,
            options
          );
        if (message.engineState != null && message.hasOwnProperty('engineState'))
          object.engineState = $root.propel.commrouter.EngineState.toObject(
            message.engineState,
            options
          );
        var keys2;
        if (message.info && (keys2 = Object.keys(message.info)).length) {
          object.info = {};
          for (var j = 0; j < keys2.length; ++j)
            object.info[keys2[j]] = $root.google.protobuf.Struct.toObject(
              message.info[keys2[j]],
              options
            );
        }
        if (message.tags && message.tags.length) {
          object.tags = [];
          for (var j = 0; j < message.tags.length; ++j)
            object.tags[j] = $root.propel.commrouter.Tag.toObject(message.tags[j], options);
        }
        if (message.jobs && message.jobs.length) {
          object.jobs = [];
          for (var j = 0; j < message.jobs.length; ++j)
            object.jobs[j] = $root.propel.commrouter.Job.toObject(message.jobs[j], options);
        }
        if (message.incomingLeadRefs && message.incomingLeadRefs.length) {
          object.incomingLeadRefs = [];
          for (var j = 0; j < message.incomingLeadRefs.length; ++j)
            object.incomingLeadRefs[j] = $root.propel.commrouter.IncomingLeadRef.toObject(
              message.incomingLeadRefs[j],
              options
            );
        }
        if (message.transient != null && message.hasOwnProperty('transient'))
          object.transient = $root.propel.commrouter.TransientConversationState.toObject(
            message.transient,
            options
          );
        return object;
      };

      /**
       * Converts this ConversationState to JSON.
       * @function toJSON
       * @memberof propel.commrouter.ConversationState
       * @instance
       * @returns {Object.<string,*>} JSON object
       */
      ConversationState.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
      };

      return ConversationState;
    })();

    commrouter.CreateConversationRequest = (function () {
      /**
       * Properties of a CreateConversationRequest.
       * @memberof propel.commrouter
       * @interface ICreateConversationRequest
       * @property {google.protobuf.IStringValue|null} [conversationId] CreateConversationRequest conversationId
       * @property {string|null} [serviceAccountId] CreateConversationRequest serviceAccountId
       * @property {string|null} [leadAccountId] CreateConversationRequest leadAccountId
       */

      /**
       * Constructs a new CreateConversationRequest.
       * @memberof propel.commrouter
       * @classdesc Represents a CreateConversationRequest.
       * @implements ICreateConversationRequest
       * @constructor
       * @param {propel.commrouter.ICreateConversationRequest=} [properties] Properties to set
       */
      function CreateConversationRequest(properties) {
        if (properties)
          for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
      }

      /**
       * CreateConversationRequest conversationId.
       * @member {google.protobuf.IStringValue|null|undefined} conversationId
       * @memberof propel.commrouter.CreateConversationRequest
       * @instance
       */
      CreateConversationRequest.prototype.conversationId = null;

      /**
       * CreateConversationRequest serviceAccountId.
       * @member {string} serviceAccountId
       * @memberof propel.commrouter.CreateConversationRequest
       * @instance
       */
      CreateConversationRequest.prototype.serviceAccountId = '';

      /**
       * CreateConversationRequest leadAccountId.
       * @member {string} leadAccountId
       * @memberof propel.commrouter.CreateConversationRequest
       * @instance
       */
      CreateConversationRequest.prototype.leadAccountId = '';

      /**
       * Creates a new CreateConversationRequest instance using the specified properties.
       * @function create
       * @memberof propel.commrouter.CreateConversationRequest
       * @static
       * @param {propel.commrouter.ICreateConversationRequest=} [properties] Properties to set
       * @returns {propel.commrouter.CreateConversationRequest} CreateConversationRequest instance
       */
      CreateConversationRequest.create = function create(properties) {
        return new CreateConversationRequest(properties);
      };

      /**
       * Encodes the specified CreateConversationRequest message. Does not implicitly {@link propel.commrouter.CreateConversationRequest.verify|verify} messages.
       * @function encode
       * @memberof propel.commrouter.CreateConversationRequest
       * @static
       * @param {propel.commrouter.ICreateConversationRequest} message CreateConversationRequest message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      CreateConversationRequest.encode = function encode(message, writer) {
        if (!writer) writer = $Writer.create();
        if (message.conversationId != null && message.hasOwnProperty('conversationId'))
          $root.google.protobuf.StringValue.encode(
            message.conversationId,
            writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
          ).ldelim();
        if (message.serviceAccountId != null && message.hasOwnProperty('serviceAccountId'))
          writer.uint32(/* id 2, wireType 2 =*/ 18).string(message.serviceAccountId);
        if (message.leadAccountId != null && message.hasOwnProperty('leadAccountId'))
          writer.uint32(/* id 3, wireType 2 =*/ 26).string(message.leadAccountId);
        return writer;
      };

      /**
       * Encodes the specified CreateConversationRequest message, length delimited. Does not implicitly {@link propel.commrouter.CreateConversationRequest.verify|verify} messages.
       * @function encodeDelimited
       * @memberof propel.commrouter.CreateConversationRequest
       * @static
       * @param {propel.commrouter.ICreateConversationRequest} message CreateConversationRequest message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      CreateConversationRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
      };

      /**
       * Decodes a CreateConversationRequest message from the specified reader or buffer.
       * @function decode
       * @memberof propel.commrouter.CreateConversationRequest
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @param {number} [length] Message length if known beforehand
       * @returns {propel.commrouter.CreateConversationRequest} CreateConversationRequest
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      CreateConversationRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length,
          message = new $root.propel.commrouter.CreateConversationRequest();
        while (reader.pos < end) {
          var tag = reader.uint32();
          switch (tag >>> 3) {
            case 1:
              message.conversationId = $root.google.protobuf.StringValue.decode(
                reader,
                reader.uint32()
              );
              break;
            case 2:
              message.serviceAccountId = reader.string();
              break;
            case 3:
              message.leadAccountId = reader.string();
              break;
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };

      /**
       * Decodes a CreateConversationRequest message from the specified reader or buffer, length delimited.
       * @function decodeDelimited
       * @memberof propel.commrouter.CreateConversationRequest
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @returns {propel.commrouter.CreateConversationRequest} CreateConversationRequest
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      CreateConversationRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader)) reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
      };

      /**
       * Verifies a CreateConversationRequest message.
       * @function verify
       * @memberof propel.commrouter.CreateConversationRequest
       * @static
       * @param {Object.<string,*>} message Plain object to verify
       * @returns {string|null} `null` if valid, otherwise the reason why it is not
       */
      CreateConversationRequest.verify = function verify(message) {
        if (typeof message !== 'object' || message === null) return 'object expected';
        if (message.conversationId != null && message.hasOwnProperty('conversationId')) {
          var error = $root.google.protobuf.StringValue.verify(message.conversationId);
          if (error) return 'conversationId.' + error;
        }
        if (message.serviceAccountId != null && message.hasOwnProperty('serviceAccountId'))
          if (!$util.isString(message.serviceAccountId)) return 'serviceAccountId: string expected';
        if (message.leadAccountId != null && message.hasOwnProperty('leadAccountId'))
          if (!$util.isString(message.leadAccountId)) return 'leadAccountId: string expected';
        return null;
      };

      /**
       * Creates a CreateConversationRequest message from a plain object. Also converts values to their respective internal types.
       * @function fromObject
       * @memberof propel.commrouter.CreateConversationRequest
       * @static
       * @param {Object.<string,*>} object Plain object
       * @returns {propel.commrouter.CreateConversationRequest} CreateConversationRequest
       */
      CreateConversationRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.propel.commrouter.CreateConversationRequest) return object;
        var message = new $root.propel.commrouter.CreateConversationRequest();
        if (object.conversationId != null) {
          if (typeof object.conversationId !== 'object')
            throw TypeError(
              '.propel.commrouter.CreateConversationRequest.conversationId: object expected'
            );
          message.conversationId = $root.google.protobuf.StringValue.fromObject(
            object.conversationId
          );
        }
        if (object.serviceAccountId != null)
          message.serviceAccountId = String(object.serviceAccountId);
        if (object.leadAccountId != null) message.leadAccountId = String(object.leadAccountId);
        return message;
      };

      /**
       * Creates a plain object from a CreateConversationRequest message. Also converts values to other types if specified.
       * @function toObject
       * @memberof propel.commrouter.CreateConversationRequest
       * @static
       * @param {propel.commrouter.CreateConversationRequest} message CreateConversationRequest
       * @param {$protobuf.IConversionOptions} [options] Conversion options
       * @returns {Object.<string,*>} Plain object
       */
      CreateConversationRequest.toObject = function toObject(message, options) {
        if (!options) options = {};
        var object = {};
        if (options.defaults) {
          object.conversationId = null;
          object.serviceAccountId = '';
          object.leadAccountId = '';
        }
        if (message.conversationId != null && message.hasOwnProperty('conversationId'))
          object.conversationId = $root.google.protobuf.StringValue.toObject(
            message.conversationId,
            options
          );
        if (message.serviceAccountId != null && message.hasOwnProperty('serviceAccountId'))
          object.serviceAccountId = message.serviceAccountId;
        if (message.leadAccountId != null && message.hasOwnProperty('leadAccountId'))
          object.leadAccountId = message.leadAccountId;
        return object;
      };

      /**
       * Converts this CreateConversationRequest to JSON.
       * @function toJSON
       * @memberof propel.commrouter.CreateConversationRequest
       * @instance
       * @returns {Object.<string,*>} JSON object
       */
      CreateConversationRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
      };

      return CreateConversationRequest;
    })();

    commrouter.GetConversationRequest = (function () {
      /**
       * Properties of a GetConversationRequest.
       * @memberof propel.commrouter
       * @interface IGetConversationRequest
       * @property {string|null} [conversationId] GetConversationRequest conversationId
       */

      /**
       * Constructs a new GetConversationRequest.
       * @memberof propel.commrouter
       * @classdesc Represents a GetConversationRequest.
       * @implements IGetConversationRequest
       * @constructor
       * @param {propel.commrouter.IGetConversationRequest=} [properties] Properties to set
       */
      function GetConversationRequest(properties) {
        if (properties)
          for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
      }

      /**
       * GetConversationRequest conversationId.
       * @member {string} conversationId
       * @memberof propel.commrouter.GetConversationRequest
       * @instance
       */
      GetConversationRequest.prototype.conversationId = '';

      /**
       * Creates a new GetConversationRequest instance using the specified properties.
       * @function create
       * @memberof propel.commrouter.GetConversationRequest
       * @static
       * @param {propel.commrouter.IGetConversationRequest=} [properties] Properties to set
       * @returns {propel.commrouter.GetConversationRequest} GetConversationRequest instance
       */
      GetConversationRequest.create = function create(properties) {
        return new GetConversationRequest(properties);
      };

      /**
       * Encodes the specified GetConversationRequest message. Does not implicitly {@link propel.commrouter.GetConversationRequest.verify|verify} messages.
       * @function encode
       * @memberof propel.commrouter.GetConversationRequest
       * @static
       * @param {propel.commrouter.IGetConversationRequest} message GetConversationRequest message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      GetConversationRequest.encode = function encode(message, writer) {
        if (!writer) writer = $Writer.create();
        if (message.conversationId != null && message.hasOwnProperty('conversationId'))
          writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.conversationId);
        return writer;
      };

      /**
       * Encodes the specified GetConversationRequest message, length delimited. Does not implicitly {@link propel.commrouter.GetConversationRequest.verify|verify} messages.
       * @function encodeDelimited
       * @memberof propel.commrouter.GetConversationRequest
       * @static
       * @param {propel.commrouter.IGetConversationRequest} message GetConversationRequest message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      GetConversationRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
      };

      /**
       * Decodes a GetConversationRequest message from the specified reader or buffer.
       * @function decode
       * @memberof propel.commrouter.GetConversationRequest
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @param {number} [length] Message length if known beforehand
       * @returns {propel.commrouter.GetConversationRequest} GetConversationRequest
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      GetConversationRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length,
          message = new $root.propel.commrouter.GetConversationRequest();
        while (reader.pos < end) {
          var tag = reader.uint32();
          switch (tag >>> 3) {
            case 1:
              message.conversationId = reader.string();
              break;
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };

      /**
       * Decodes a GetConversationRequest message from the specified reader or buffer, length delimited.
       * @function decodeDelimited
       * @memberof propel.commrouter.GetConversationRequest
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @returns {propel.commrouter.GetConversationRequest} GetConversationRequest
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      GetConversationRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader)) reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
      };

      /**
       * Verifies a GetConversationRequest message.
       * @function verify
       * @memberof propel.commrouter.GetConversationRequest
       * @static
       * @param {Object.<string,*>} message Plain object to verify
       * @returns {string|null} `null` if valid, otherwise the reason why it is not
       */
      GetConversationRequest.verify = function verify(message) {
        if (typeof message !== 'object' || message === null) return 'object expected';
        if (message.conversationId != null && message.hasOwnProperty('conversationId'))
          if (!$util.isString(message.conversationId)) return 'conversationId: string expected';
        return null;
      };

      /**
       * Creates a GetConversationRequest message from a plain object. Also converts values to their respective internal types.
       * @function fromObject
       * @memberof propel.commrouter.GetConversationRequest
       * @static
       * @param {Object.<string,*>} object Plain object
       * @returns {propel.commrouter.GetConversationRequest} GetConversationRequest
       */
      GetConversationRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.propel.commrouter.GetConversationRequest) return object;
        var message = new $root.propel.commrouter.GetConversationRequest();
        if (object.conversationId != null) message.conversationId = String(object.conversationId);
        return message;
      };

      /**
       * Creates a plain object from a GetConversationRequest message. Also converts values to other types if specified.
       * @function toObject
       * @memberof propel.commrouter.GetConversationRequest
       * @static
       * @param {propel.commrouter.GetConversationRequest} message GetConversationRequest
       * @param {$protobuf.IConversionOptions} [options] Conversion options
       * @returns {Object.<string,*>} Plain object
       */
      GetConversationRequest.toObject = function toObject(message, options) {
        if (!options) options = {};
        var object = {};
        if (options.defaults) object.conversationId = '';
        if (message.conversationId != null && message.hasOwnProperty('conversationId'))
          object.conversationId = message.conversationId;
        return object;
      };

      /**
       * Converts this GetConversationRequest to JSON.
       * @function toJSON
       * @memberof propel.commrouter.GetConversationRequest
       * @instance
       * @returns {Object.<string,*>} JSON object
       */
      GetConversationRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
      };

      return GetConversationRequest;
    })();

    commrouter.GetConversationStateRequest = (function () {
      /**
       * Properties of a GetConversationStateRequest.
       * @memberof propel.commrouter
       * @interface IGetConversationStateRequest
       * @property {string|null} [conversationId] GetConversationStateRequest conversationId
       */

      /**
       * Constructs a new GetConversationStateRequest.
       * @memberof propel.commrouter
       * @classdesc Represents a GetConversationStateRequest.
       * @implements IGetConversationStateRequest
       * @constructor
       * @param {propel.commrouter.IGetConversationStateRequest=} [properties] Properties to set
       */
      function GetConversationStateRequest(properties) {
        if (properties)
          for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
      }

      /**
       * GetConversationStateRequest conversationId.
       * @member {string} conversationId
       * @memberof propel.commrouter.GetConversationStateRequest
       * @instance
       */
      GetConversationStateRequest.prototype.conversationId = '';

      /**
       * Creates a new GetConversationStateRequest instance using the specified properties.
       * @function create
       * @memberof propel.commrouter.GetConversationStateRequest
       * @static
       * @param {propel.commrouter.IGetConversationStateRequest=} [properties] Properties to set
       * @returns {propel.commrouter.GetConversationStateRequest} GetConversationStateRequest instance
       */
      GetConversationStateRequest.create = function create(properties) {
        return new GetConversationStateRequest(properties);
      };

      /**
       * Encodes the specified GetConversationStateRequest message. Does not implicitly {@link propel.commrouter.GetConversationStateRequest.verify|verify} messages.
       * @function encode
       * @memberof propel.commrouter.GetConversationStateRequest
       * @static
       * @param {propel.commrouter.IGetConversationStateRequest} message GetConversationStateRequest message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      GetConversationStateRequest.encode = function encode(message, writer) {
        if (!writer) writer = $Writer.create();
        if (message.conversationId != null && message.hasOwnProperty('conversationId'))
          writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.conversationId);
        return writer;
      };

      /**
       * Encodes the specified GetConversationStateRequest message, length delimited. Does not implicitly {@link propel.commrouter.GetConversationStateRequest.verify|verify} messages.
       * @function encodeDelimited
       * @memberof propel.commrouter.GetConversationStateRequest
       * @static
       * @param {propel.commrouter.IGetConversationStateRequest} message GetConversationStateRequest message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      GetConversationStateRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
      };

      /**
       * Decodes a GetConversationStateRequest message from the specified reader or buffer.
       * @function decode
       * @memberof propel.commrouter.GetConversationStateRequest
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @param {number} [length] Message length if known beforehand
       * @returns {propel.commrouter.GetConversationStateRequest} GetConversationStateRequest
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      GetConversationStateRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length,
          message = new $root.propel.commrouter.GetConversationStateRequest();
        while (reader.pos < end) {
          var tag = reader.uint32();
          switch (tag >>> 3) {
            case 1:
              message.conversationId = reader.string();
              break;
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };

      /**
       * Decodes a GetConversationStateRequest message from the specified reader or buffer, length delimited.
       * @function decodeDelimited
       * @memberof propel.commrouter.GetConversationStateRequest
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @returns {propel.commrouter.GetConversationStateRequest} GetConversationStateRequest
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      GetConversationStateRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader)) reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
      };

      /**
       * Verifies a GetConversationStateRequest message.
       * @function verify
       * @memberof propel.commrouter.GetConversationStateRequest
       * @static
       * @param {Object.<string,*>} message Plain object to verify
       * @returns {string|null} `null` if valid, otherwise the reason why it is not
       */
      GetConversationStateRequest.verify = function verify(message) {
        if (typeof message !== 'object' || message === null) return 'object expected';
        if (message.conversationId != null && message.hasOwnProperty('conversationId'))
          if (!$util.isString(message.conversationId)) return 'conversationId: string expected';
        return null;
      };

      /**
       * Creates a GetConversationStateRequest message from a plain object. Also converts values to their respective internal types.
       * @function fromObject
       * @memberof propel.commrouter.GetConversationStateRequest
       * @static
       * @param {Object.<string,*>} object Plain object
       * @returns {propel.commrouter.GetConversationStateRequest} GetConversationStateRequest
       */
      GetConversationStateRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.propel.commrouter.GetConversationStateRequest) return object;
        var message = new $root.propel.commrouter.GetConversationStateRequest();
        if (object.conversationId != null) message.conversationId = String(object.conversationId);
        return message;
      };

      /**
       * Creates a plain object from a GetConversationStateRequest message. Also converts values to other types if specified.
       * @function toObject
       * @memberof propel.commrouter.GetConversationStateRequest
       * @static
       * @param {propel.commrouter.GetConversationStateRequest} message GetConversationStateRequest
       * @param {$protobuf.IConversionOptions} [options] Conversion options
       * @returns {Object.<string,*>} Plain object
       */
      GetConversationStateRequest.toObject = function toObject(message, options) {
        if (!options) options = {};
        var object = {};
        if (options.defaults) object.conversationId = '';
        if (message.conversationId != null && message.hasOwnProperty('conversationId'))
          object.conversationId = message.conversationId;
        return object;
      };

      /**
       * Converts this GetConversationStateRequest to JSON.
       * @function toJSON
       * @memberof propel.commrouter.GetConversationStateRequest
       * @instance
       * @returns {Object.<string,*>} JSON object
       */
      GetConversationStateRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
      };

      return GetConversationStateRequest;
    })();

    commrouter.GetIntroductionRequest = (function () {
      /**
       * Properties of a GetIntroductionRequest.
       * @memberof propel.commrouter
       * @interface IGetIntroductionRequest
       * @property {string|null} [conversationId] GetIntroductionRequest conversationId
       * @property {propel.commrouter.IContext|null} [context] GetIntroductionRequest context
       * @property {google.protobuf.IStringValue|null} [source] GetIntroductionRequest source
       */

      /**
       * Constructs a new GetIntroductionRequest.
       * @memberof propel.commrouter
       * @classdesc Represents a GetIntroductionRequest.
       * @implements IGetIntroductionRequest
       * @constructor
       * @param {propel.commrouter.IGetIntroductionRequest=} [properties] Properties to set
       */
      function GetIntroductionRequest(properties) {
        if (properties)
          for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
      }

      /**
       * GetIntroductionRequest conversationId.
       * @member {string} conversationId
       * @memberof propel.commrouter.GetIntroductionRequest
       * @instance
       */
      GetIntroductionRequest.prototype.conversationId = '';

      /**
       * GetIntroductionRequest context.
       * @member {propel.commrouter.IContext|null|undefined} context
       * @memberof propel.commrouter.GetIntroductionRequest
       * @instance
       */
      GetIntroductionRequest.prototype.context = null;

      /**
       * GetIntroductionRequest source.
       * @member {google.protobuf.IStringValue|null|undefined} source
       * @memberof propel.commrouter.GetIntroductionRequest
       * @instance
       */
      GetIntroductionRequest.prototype.source = null;

      /**
       * Creates a new GetIntroductionRequest instance using the specified properties.
       * @function create
       * @memberof propel.commrouter.GetIntroductionRequest
       * @static
       * @param {propel.commrouter.IGetIntroductionRequest=} [properties] Properties to set
       * @returns {propel.commrouter.GetIntroductionRequest} GetIntroductionRequest instance
       */
      GetIntroductionRequest.create = function create(properties) {
        return new GetIntroductionRequest(properties);
      };

      /**
       * Encodes the specified GetIntroductionRequest message. Does not implicitly {@link propel.commrouter.GetIntroductionRequest.verify|verify} messages.
       * @function encode
       * @memberof propel.commrouter.GetIntroductionRequest
       * @static
       * @param {propel.commrouter.IGetIntroductionRequest} message GetIntroductionRequest message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      GetIntroductionRequest.encode = function encode(message, writer) {
        if (!writer) writer = $Writer.create();
        if (message.conversationId != null && message.hasOwnProperty('conversationId'))
          writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.conversationId);
        if (message.context != null && message.hasOwnProperty('context'))
          $root.propel.commrouter.Context.encode(
            message.context,
            writer.uint32(/* id 2, wireType 2 =*/ 18).fork()
          ).ldelim();
        if (message.source != null && message.hasOwnProperty('source'))
          $root.google.protobuf.StringValue.encode(
            message.source,
            writer.uint32(/* id 3, wireType 2 =*/ 26).fork()
          ).ldelim();
        return writer;
      };

      /**
       * Encodes the specified GetIntroductionRequest message, length delimited. Does not implicitly {@link propel.commrouter.GetIntroductionRequest.verify|verify} messages.
       * @function encodeDelimited
       * @memberof propel.commrouter.GetIntroductionRequest
       * @static
       * @param {propel.commrouter.IGetIntroductionRequest} message GetIntroductionRequest message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      GetIntroductionRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
      };

      /**
       * Decodes a GetIntroductionRequest message from the specified reader or buffer.
       * @function decode
       * @memberof propel.commrouter.GetIntroductionRequest
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @param {number} [length] Message length if known beforehand
       * @returns {propel.commrouter.GetIntroductionRequest} GetIntroductionRequest
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      GetIntroductionRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length,
          message = new $root.propel.commrouter.GetIntroductionRequest();
        while (reader.pos < end) {
          var tag = reader.uint32();
          switch (tag >>> 3) {
            case 1:
              message.conversationId = reader.string();
              break;
            case 2:
              message.context = $root.propel.commrouter.Context.decode(reader, reader.uint32());
              break;
            case 3:
              message.source = $root.google.protobuf.StringValue.decode(reader, reader.uint32());
              break;
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };

      /**
       * Decodes a GetIntroductionRequest message from the specified reader or buffer, length delimited.
       * @function decodeDelimited
       * @memberof propel.commrouter.GetIntroductionRequest
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @returns {propel.commrouter.GetIntroductionRequest} GetIntroductionRequest
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      GetIntroductionRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader)) reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
      };

      /**
       * Verifies a GetIntroductionRequest message.
       * @function verify
       * @memberof propel.commrouter.GetIntroductionRequest
       * @static
       * @param {Object.<string,*>} message Plain object to verify
       * @returns {string|null} `null` if valid, otherwise the reason why it is not
       */
      GetIntroductionRequest.verify = function verify(message) {
        if (typeof message !== 'object' || message === null) return 'object expected';
        if (message.conversationId != null && message.hasOwnProperty('conversationId'))
          if (!$util.isString(message.conversationId)) return 'conversationId: string expected';
        if (message.context != null && message.hasOwnProperty('context')) {
          var error = $root.propel.commrouter.Context.verify(message.context);
          if (error) return 'context.' + error;
        }
        if (message.source != null && message.hasOwnProperty('source')) {
          var error = $root.google.protobuf.StringValue.verify(message.source);
          if (error) return 'source.' + error;
        }
        return null;
      };

      /**
       * Creates a GetIntroductionRequest message from a plain object. Also converts values to their respective internal types.
       * @function fromObject
       * @memberof propel.commrouter.GetIntroductionRequest
       * @static
       * @param {Object.<string,*>} object Plain object
       * @returns {propel.commrouter.GetIntroductionRequest} GetIntroductionRequest
       */
      GetIntroductionRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.propel.commrouter.GetIntroductionRequest) return object;
        var message = new $root.propel.commrouter.GetIntroductionRequest();
        if (object.conversationId != null) message.conversationId = String(object.conversationId);
        if (object.context != null) {
          if (typeof object.context !== 'object')
            throw TypeError('.propel.commrouter.GetIntroductionRequest.context: object expected');
          message.context = $root.propel.commrouter.Context.fromObject(object.context);
        }
        if (object.source != null) {
          if (typeof object.source !== 'object')
            throw TypeError('.propel.commrouter.GetIntroductionRequest.source: object expected');
          message.source = $root.google.protobuf.StringValue.fromObject(object.source);
        }
        return message;
      };

      /**
       * Creates a plain object from a GetIntroductionRequest message. Also converts values to other types if specified.
       * @function toObject
       * @memberof propel.commrouter.GetIntroductionRequest
       * @static
       * @param {propel.commrouter.GetIntroductionRequest} message GetIntroductionRequest
       * @param {$protobuf.IConversionOptions} [options] Conversion options
       * @returns {Object.<string,*>} Plain object
       */
      GetIntroductionRequest.toObject = function toObject(message, options) {
        if (!options) options = {};
        var object = {};
        if (options.defaults) {
          object.conversationId = '';
          object.context = null;
          object.source = null;
        }
        if (message.conversationId != null && message.hasOwnProperty('conversationId'))
          object.conversationId = message.conversationId;
        if (message.context != null && message.hasOwnProperty('context'))
          object.context = $root.propel.commrouter.Context.toObject(message.context, options);
        if (message.source != null && message.hasOwnProperty('source'))
          object.source = $root.google.protobuf.StringValue.toObject(message.source, options);
        return object;
      };

      /**
       * Converts this GetIntroductionRequest to JSON.
       * @function toJSON
       * @memberof propel.commrouter.GetIntroductionRequest
       * @instance
       * @returns {Object.<string,*>} JSON object
       */
      GetIntroductionRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
      };

      return GetIntroductionRequest;
    })();

    commrouter.GetVendorInfoRequest = (function () {
      /**
       * Properties of a GetVendorInfoRequest.
       * @memberof propel.commrouter
       * @interface IGetVendorInfoRequest
       * @property {string|null} [conversationId] GetVendorInfoRequest conversationId
       * @property {string|null} [key] GetVendorInfoRequest key
       */

      /**
       * Constructs a new GetVendorInfoRequest.
       * @memberof propel.commrouter
       * @classdesc Represents a GetVendorInfoRequest.
       * @implements IGetVendorInfoRequest
       * @constructor
       * @param {propel.commrouter.IGetVendorInfoRequest=} [properties] Properties to set
       */
      function GetVendorInfoRequest(properties) {
        if (properties)
          for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
      }

      /**
       * GetVendorInfoRequest conversationId.
       * @member {string} conversationId
       * @memberof propel.commrouter.GetVendorInfoRequest
       * @instance
       */
      GetVendorInfoRequest.prototype.conversationId = '';

      /**
       * GetVendorInfoRequest key.
       * @member {string} key
       * @memberof propel.commrouter.GetVendorInfoRequest
       * @instance
       */
      GetVendorInfoRequest.prototype.key = '';

      /**
       * Creates a new GetVendorInfoRequest instance using the specified properties.
       * @function create
       * @memberof propel.commrouter.GetVendorInfoRequest
       * @static
       * @param {propel.commrouter.IGetVendorInfoRequest=} [properties] Properties to set
       * @returns {propel.commrouter.GetVendorInfoRequest} GetVendorInfoRequest instance
       */
      GetVendorInfoRequest.create = function create(properties) {
        return new GetVendorInfoRequest(properties);
      };

      /**
       * Encodes the specified GetVendorInfoRequest message. Does not implicitly {@link propel.commrouter.GetVendorInfoRequest.verify|verify} messages.
       * @function encode
       * @memberof propel.commrouter.GetVendorInfoRequest
       * @static
       * @param {propel.commrouter.IGetVendorInfoRequest} message GetVendorInfoRequest message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      GetVendorInfoRequest.encode = function encode(message, writer) {
        if (!writer) writer = $Writer.create();
        if (message.conversationId != null && message.hasOwnProperty('conversationId'))
          writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.conversationId);
        if (message.key != null && message.hasOwnProperty('key'))
          writer.uint32(/* id 2, wireType 2 =*/ 18).string(message.key);
        return writer;
      };

      /**
       * Encodes the specified GetVendorInfoRequest message, length delimited. Does not implicitly {@link propel.commrouter.GetVendorInfoRequest.verify|verify} messages.
       * @function encodeDelimited
       * @memberof propel.commrouter.GetVendorInfoRequest
       * @static
       * @param {propel.commrouter.IGetVendorInfoRequest} message GetVendorInfoRequest message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      GetVendorInfoRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
      };

      /**
       * Decodes a GetVendorInfoRequest message from the specified reader or buffer.
       * @function decode
       * @memberof propel.commrouter.GetVendorInfoRequest
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @param {number} [length] Message length if known beforehand
       * @returns {propel.commrouter.GetVendorInfoRequest} GetVendorInfoRequest
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      GetVendorInfoRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length,
          message = new $root.propel.commrouter.GetVendorInfoRequest();
        while (reader.pos < end) {
          var tag = reader.uint32();
          switch (tag >>> 3) {
            case 1:
              message.conversationId = reader.string();
              break;
            case 2:
              message.key = reader.string();
              break;
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };

      /**
       * Decodes a GetVendorInfoRequest message from the specified reader or buffer, length delimited.
       * @function decodeDelimited
       * @memberof propel.commrouter.GetVendorInfoRequest
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @returns {propel.commrouter.GetVendorInfoRequest} GetVendorInfoRequest
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      GetVendorInfoRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader)) reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
      };

      /**
       * Verifies a GetVendorInfoRequest message.
       * @function verify
       * @memberof propel.commrouter.GetVendorInfoRequest
       * @static
       * @param {Object.<string,*>} message Plain object to verify
       * @returns {string|null} `null` if valid, otherwise the reason why it is not
       */
      GetVendorInfoRequest.verify = function verify(message) {
        if (typeof message !== 'object' || message === null) return 'object expected';
        if (message.conversationId != null && message.hasOwnProperty('conversationId'))
          if (!$util.isString(message.conversationId)) return 'conversationId: string expected';
        if (message.key != null && message.hasOwnProperty('key'))
          if (!$util.isString(message.key)) return 'key: string expected';
        return null;
      };

      /**
       * Creates a GetVendorInfoRequest message from a plain object. Also converts values to their respective internal types.
       * @function fromObject
       * @memberof propel.commrouter.GetVendorInfoRequest
       * @static
       * @param {Object.<string,*>} object Plain object
       * @returns {propel.commrouter.GetVendorInfoRequest} GetVendorInfoRequest
       */
      GetVendorInfoRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.propel.commrouter.GetVendorInfoRequest) return object;
        var message = new $root.propel.commrouter.GetVendorInfoRequest();
        if (object.conversationId != null) message.conversationId = String(object.conversationId);
        if (object.key != null) message.key = String(object.key);
        return message;
      };

      /**
       * Creates a plain object from a GetVendorInfoRequest message. Also converts values to other types if specified.
       * @function toObject
       * @memberof propel.commrouter.GetVendorInfoRequest
       * @static
       * @param {propel.commrouter.GetVendorInfoRequest} message GetVendorInfoRequest
       * @param {$protobuf.IConversionOptions} [options] Conversion options
       * @returns {Object.<string,*>} Plain object
       */
      GetVendorInfoRequest.toObject = function toObject(message, options) {
        if (!options) options = {};
        var object = {};
        if (options.defaults) {
          object.conversationId = '';
          object.key = '';
        }
        if (message.conversationId != null && message.hasOwnProperty('conversationId'))
          object.conversationId = message.conversationId;
        if (message.key != null && message.hasOwnProperty('key')) object.key = message.key;
        return object;
      };

      /**
       * Converts this GetVendorInfoRequest to JSON.
       * @function toJSON
       * @memberof propel.commrouter.GetVendorInfoRequest
       * @instance
       * @returns {Object.<string,*>} JSON object
       */
      GetVendorInfoRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
      };

      return GetVendorInfoRequest;
    })();

    commrouter.PutConversationStateRequest = (function () {
      /**
       * Properties of a PutConversationStateRequest.
       * @memberof propel.commrouter
       * @interface IPutConversationStateRequest
       * @property {string|null} [conversationId] PutConversationStateRequest conversationId
       * @property {propel.commrouter.ConversationCommand.IPutConversationState|null} [putConversationState] PutConversationStateRequest putConversationState
       */

      /**
       * Constructs a new PutConversationStateRequest.
       * @memberof propel.commrouter
       * @classdesc Represents a PutConversationStateRequest.
       * @implements IPutConversationStateRequest
       * @constructor
       * @param {propel.commrouter.IPutConversationStateRequest=} [properties] Properties to set
       */
      function PutConversationStateRequest(properties) {
        if (properties)
          for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
      }

      /**
       * PutConversationStateRequest conversationId.
       * @member {string} conversationId
       * @memberof propel.commrouter.PutConversationStateRequest
       * @instance
       */
      PutConversationStateRequest.prototype.conversationId = '';

      /**
       * PutConversationStateRequest putConversationState.
       * @member {propel.commrouter.ConversationCommand.IPutConversationState|null|undefined} putConversationState
       * @memberof propel.commrouter.PutConversationStateRequest
       * @instance
       */
      PutConversationStateRequest.prototype.putConversationState = null;

      /**
       * Creates a new PutConversationStateRequest instance using the specified properties.
       * @function create
       * @memberof propel.commrouter.PutConversationStateRequest
       * @static
       * @param {propel.commrouter.IPutConversationStateRequest=} [properties] Properties to set
       * @returns {propel.commrouter.PutConversationStateRequest} PutConversationStateRequest instance
       */
      PutConversationStateRequest.create = function create(properties) {
        return new PutConversationStateRequest(properties);
      };

      /**
       * Encodes the specified PutConversationStateRequest message. Does not implicitly {@link propel.commrouter.PutConversationStateRequest.verify|verify} messages.
       * @function encode
       * @memberof propel.commrouter.PutConversationStateRequest
       * @static
       * @param {propel.commrouter.IPutConversationStateRequest} message PutConversationStateRequest message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      PutConversationStateRequest.encode = function encode(message, writer) {
        if (!writer) writer = $Writer.create();
        if (message.conversationId != null && message.hasOwnProperty('conversationId'))
          writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.conversationId);
        if (message.putConversationState != null && message.hasOwnProperty('putConversationState'))
          $root.propel.commrouter.ConversationCommand.PutConversationState.encode(
            message.putConversationState,
            writer.uint32(/* id 2, wireType 2 =*/ 18).fork()
          ).ldelim();
        return writer;
      };

      /**
       * Encodes the specified PutConversationStateRequest message, length delimited. Does not implicitly {@link propel.commrouter.PutConversationStateRequest.verify|verify} messages.
       * @function encodeDelimited
       * @memberof propel.commrouter.PutConversationStateRequest
       * @static
       * @param {propel.commrouter.IPutConversationStateRequest} message PutConversationStateRequest message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      PutConversationStateRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
      };

      /**
       * Decodes a PutConversationStateRequest message from the specified reader or buffer.
       * @function decode
       * @memberof propel.commrouter.PutConversationStateRequest
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @param {number} [length] Message length if known beforehand
       * @returns {propel.commrouter.PutConversationStateRequest} PutConversationStateRequest
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      PutConversationStateRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length,
          message = new $root.propel.commrouter.PutConversationStateRequest();
        while (reader.pos < end) {
          var tag = reader.uint32();
          switch (tag >>> 3) {
            case 1:
              message.conversationId = reader.string();
              break;
            case 2:
              message.putConversationState =
                $root.propel.commrouter.ConversationCommand.PutConversationState.decode(
                  reader,
                  reader.uint32()
                );
              break;
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };

      /**
       * Decodes a PutConversationStateRequest message from the specified reader or buffer, length delimited.
       * @function decodeDelimited
       * @memberof propel.commrouter.PutConversationStateRequest
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @returns {propel.commrouter.PutConversationStateRequest} PutConversationStateRequest
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      PutConversationStateRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader)) reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
      };

      /**
       * Verifies a PutConversationStateRequest message.
       * @function verify
       * @memberof propel.commrouter.PutConversationStateRequest
       * @static
       * @param {Object.<string,*>} message Plain object to verify
       * @returns {string|null} `null` if valid, otherwise the reason why it is not
       */
      PutConversationStateRequest.verify = function verify(message) {
        if (typeof message !== 'object' || message === null) return 'object expected';
        if (message.conversationId != null && message.hasOwnProperty('conversationId'))
          if (!$util.isString(message.conversationId)) return 'conversationId: string expected';
        if (
          message.putConversationState != null &&
          message.hasOwnProperty('putConversationState')
        ) {
          var error = $root.propel.commrouter.ConversationCommand.PutConversationState.verify(
            message.putConversationState
          );
          if (error) return 'putConversationState.' + error;
        }
        return null;
      };

      /**
       * Creates a PutConversationStateRequest message from a plain object. Also converts values to their respective internal types.
       * @function fromObject
       * @memberof propel.commrouter.PutConversationStateRequest
       * @static
       * @param {Object.<string,*>} object Plain object
       * @returns {propel.commrouter.PutConversationStateRequest} PutConversationStateRequest
       */
      PutConversationStateRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.propel.commrouter.PutConversationStateRequest) return object;
        var message = new $root.propel.commrouter.PutConversationStateRequest();
        if (object.conversationId != null) message.conversationId = String(object.conversationId);
        if (object.putConversationState != null) {
          if (typeof object.putConversationState !== 'object')
            throw TypeError(
              '.propel.commrouter.PutConversationStateRequest.putConversationState: object expected'
            );
          message.putConversationState =
            $root.propel.commrouter.ConversationCommand.PutConversationState.fromObject(
              object.putConversationState
            );
        }
        return message;
      };

      /**
       * Creates a plain object from a PutConversationStateRequest message. Also converts values to other types if specified.
       * @function toObject
       * @memberof propel.commrouter.PutConversationStateRequest
       * @static
       * @param {propel.commrouter.PutConversationStateRequest} message PutConversationStateRequest
       * @param {$protobuf.IConversionOptions} [options] Conversion options
       * @returns {Object.<string,*>} Plain object
       */
      PutConversationStateRequest.toObject = function toObject(message, options) {
        if (!options) options = {};
        var object = {};
        if (options.defaults) {
          object.conversationId = '';
          object.putConversationState = null;
        }
        if (message.conversationId != null && message.hasOwnProperty('conversationId'))
          object.conversationId = message.conversationId;
        if (message.putConversationState != null && message.hasOwnProperty('putConversationState'))
          object.putConversationState =
            $root.propel.commrouter.ConversationCommand.PutConversationState.toObject(
              message.putConversationState,
              options
            );
        return object;
      };

      /**
       * Converts this PutConversationStateRequest to JSON.
       * @function toJSON
       * @memberof propel.commrouter.PutConversationStateRequest
       * @instance
       * @returns {Object.<string,*>} JSON object
       */
      PutConversationStateRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
      };

      return PutConversationStateRequest;
    })();

    commrouter.GetContextRequest = (function () {
      /**
       * Properties of a GetContextRequest.
       * @memberof propel.commrouter
       * @interface IGetContextRequest
       * @property {string|null} [conversationId] GetContextRequest conversationId
       */

      /**
       * Constructs a new GetContextRequest.
       * @memberof propel.commrouter
       * @classdesc Represents a GetContextRequest.
       * @implements IGetContextRequest
       * @constructor
       * @param {propel.commrouter.IGetContextRequest=} [properties] Properties to set
       */
      function GetContextRequest(properties) {
        if (properties)
          for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
      }

      /**
       * GetContextRequest conversationId.
       * @member {string} conversationId
       * @memberof propel.commrouter.GetContextRequest
       * @instance
       */
      GetContextRequest.prototype.conversationId = '';

      /**
       * Creates a new GetContextRequest instance using the specified properties.
       * @function create
       * @memberof propel.commrouter.GetContextRequest
       * @static
       * @param {propel.commrouter.IGetContextRequest=} [properties] Properties to set
       * @returns {propel.commrouter.GetContextRequest} GetContextRequest instance
       */
      GetContextRequest.create = function create(properties) {
        return new GetContextRequest(properties);
      };

      /**
       * Encodes the specified GetContextRequest message. Does not implicitly {@link propel.commrouter.GetContextRequest.verify|verify} messages.
       * @function encode
       * @memberof propel.commrouter.GetContextRequest
       * @static
       * @param {propel.commrouter.IGetContextRequest} message GetContextRequest message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      GetContextRequest.encode = function encode(message, writer) {
        if (!writer) writer = $Writer.create();
        if (message.conversationId != null && message.hasOwnProperty('conversationId'))
          writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.conversationId);
        return writer;
      };

      /**
       * Encodes the specified GetContextRequest message, length delimited. Does not implicitly {@link propel.commrouter.GetContextRequest.verify|verify} messages.
       * @function encodeDelimited
       * @memberof propel.commrouter.GetContextRequest
       * @static
       * @param {propel.commrouter.IGetContextRequest} message GetContextRequest message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      GetContextRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
      };

      /**
       * Decodes a GetContextRequest message from the specified reader or buffer.
       * @function decode
       * @memberof propel.commrouter.GetContextRequest
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @param {number} [length] Message length if known beforehand
       * @returns {propel.commrouter.GetContextRequest} GetContextRequest
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      GetContextRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length,
          message = new $root.propel.commrouter.GetContextRequest();
        while (reader.pos < end) {
          var tag = reader.uint32();
          switch (tag >>> 3) {
            case 1:
              message.conversationId = reader.string();
              break;
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };

      /**
       * Decodes a GetContextRequest message from the specified reader or buffer, length delimited.
       * @function decodeDelimited
       * @memberof propel.commrouter.GetContextRequest
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @returns {propel.commrouter.GetContextRequest} GetContextRequest
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      GetContextRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader)) reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
      };

      /**
       * Verifies a GetContextRequest message.
       * @function verify
       * @memberof propel.commrouter.GetContextRequest
       * @static
       * @param {Object.<string,*>} message Plain object to verify
       * @returns {string|null} `null` if valid, otherwise the reason why it is not
       */
      GetContextRequest.verify = function verify(message) {
        if (typeof message !== 'object' || message === null) return 'object expected';
        if (message.conversationId != null && message.hasOwnProperty('conversationId'))
          if (!$util.isString(message.conversationId)) return 'conversationId: string expected';
        return null;
      };

      /**
       * Creates a GetContextRequest message from a plain object. Also converts values to their respective internal types.
       * @function fromObject
       * @memberof propel.commrouter.GetContextRequest
       * @static
       * @param {Object.<string,*>} object Plain object
       * @returns {propel.commrouter.GetContextRequest} GetContextRequest
       */
      GetContextRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.propel.commrouter.GetContextRequest) return object;
        var message = new $root.propel.commrouter.GetContextRequest();
        if (object.conversationId != null) message.conversationId = String(object.conversationId);
        return message;
      };

      /**
       * Creates a plain object from a GetContextRequest message. Also converts values to other types if specified.
       * @function toObject
       * @memberof propel.commrouter.GetContextRequest
       * @static
       * @param {propel.commrouter.GetContextRequest} message GetContextRequest
       * @param {$protobuf.IConversionOptions} [options] Conversion options
       * @returns {Object.<string,*>} Plain object
       */
      GetContextRequest.toObject = function toObject(message, options) {
        if (!options) options = {};
        var object = {};
        if (options.defaults) object.conversationId = '';
        if (message.conversationId != null && message.hasOwnProperty('conversationId'))
          object.conversationId = message.conversationId;
        return object;
      };

      /**
       * Converts this GetContextRequest to JSON.
       * @function toJSON
       * @memberof propel.commrouter.GetContextRequest
       * @instance
       * @returns {Object.<string,*>} JSON object
       */
      GetContextRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
      };

      return GetContextRequest;
    })();

    commrouter.PutContextRequest = (function () {
      /**
       * Properties of a PutContextRequest.
       * @memberof propel.commrouter
       * @interface IPutContextRequest
       * @property {string|null} [conversationId] PutContextRequest conversationId
       * @property {propel.commrouter.ConversationCommand.IPutContext|null} [putContext] PutContextRequest putContext
       */

      /**
       * Constructs a new PutContextRequest.
       * @memberof propel.commrouter
       * @classdesc Represents a PutContextRequest.
       * @implements IPutContextRequest
       * @constructor
       * @param {propel.commrouter.IPutContextRequest=} [properties] Properties to set
       */
      function PutContextRequest(properties) {
        if (properties)
          for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
      }

      /**
       * PutContextRequest conversationId.
       * @member {string} conversationId
       * @memberof propel.commrouter.PutContextRequest
       * @instance
       */
      PutContextRequest.prototype.conversationId = '';

      /**
       * PutContextRequest putContext.
       * @member {propel.commrouter.ConversationCommand.IPutContext|null|undefined} putContext
       * @memberof propel.commrouter.PutContextRequest
       * @instance
       */
      PutContextRequest.prototype.putContext = null;

      /**
       * Creates a new PutContextRequest instance using the specified properties.
       * @function create
       * @memberof propel.commrouter.PutContextRequest
       * @static
       * @param {propel.commrouter.IPutContextRequest=} [properties] Properties to set
       * @returns {propel.commrouter.PutContextRequest} PutContextRequest instance
       */
      PutContextRequest.create = function create(properties) {
        return new PutContextRequest(properties);
      };

      /**
       * Encodes the specified PutContextRequest message. Does not implicitly {@link propel.commrouter.PutContextRequest.verify|verify} messages.
       * @function encode
       * @memberof propel.commrouter.PutContextRequest
       * @static
       * @param {propel.commrouter.IPutContextRequest} message PutContextRequest message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      PutContextRequest.encode = function encode(message, writer) {
        if (!writer) writer = $Writer.create();
        if (message.conversationId != null && message.hasOwnProperty('conversationId'))
          writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.conversationId);
        if (message.putContext != null && message.hasOwnProperty('putContext'))
          $root.propel.commrouter.ConversationCommand.PutContext.encode(
            message.putContext,
            writer.uint32(/* id 2, wireType 2 =*/ 18).fork()
          ).ldelim();
        return writer;
      };

      /**
       * Encodes the specified PutContextRequest message, length delimited. Does not implicitly {@link propel.commrouter.PutContextRequest.verify|verify} messages.
       * @function encodeDelimited
       * @memberof propel.commrouter.PutContextRequest
       * @static
       * @param {propel.commrouter.IPutContextRequest} message PutContextRequest message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      PutContextRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
      };

      /**
       * Decodes a PutContextRequest message from the specified reader or buffer.
       * @function decode
       * @memberof propel.commrouter.PutContextRequest
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @param {number} [length] Message length if known beforehand
       * @returns {propel.commrouter.PutContextRequest} PutContextRequest
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      PutContextRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length,
          message = new $root.propel.commrouter.PutContextRequest();
        while (reader.pos < end) {
          var tag = reader.uint32();
          switch (tag >>> 3) {
            case 1:
              message.conversationId = reader.string();
              break;
            case 2:
              message.putContext = $root.propel.commrouter.ConversationCommand.PutContext.decode(
                reader,
                reader.uint32()
              );
              break;
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };

      /**
       * Decodes a PutContextRequest message from the specified reader or buffer, length delimited.
       * @function decodeDelimited
       * @memberof propel.commrouter.PutContextRequest
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @returns {propel.commrouter.PutContextRequest} PutContextRequest
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      PutContextRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader)) reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
      };

      /**
       * Verifies a PutContextRequest message.
       * @function verify
       * @memberof propel.commrouter.PutContextRequest
       * @static
       * @param {Object.<string,*>} message Plain object to verify
       * @returns {string|null} `null` if valid, otherwise the reason why it is not
       */
      PutContextRequest.verify = function verify(message) {
        if (typeof message !== 'object' || message === null) return 'object expected';
        if (message.conversationId != null && message.hasOwnProperty('conversationId'))
          if (!$util.isString(message.conversationId)) return 'conversationId: string expected';
        if (message.putContext != null && message.hasOwnProperty('putContext')) {
          var error = $root.propel.commrouter.ConversationCommand.PutContext.verify(
            message.putContext
          );
          if (error) return 'putContext.' + error;
        }
        return null;
      };

      /**
       * Creates a PutContextRequest message from a plain object. Also converts values to their respective internal types.
       * @function fromObject
       * @memberof propel.commrouter.PutContextRequest
       * @static
       * @param {Object.<string,*>} object Plain object
       * @returns {propel.commrouter.PutContextRequest} PutContextRequest
       */
      PutContextRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.propel.commrouter.PutContextRequest) return object;
        var message = new $root.propel.commrouter.PutContextRequest();
        if (object.conversationId != null) message.conversationId = String(object.conversationId);
        if (object.putContext != null) {
          if (typeof object.putContext !== 'object')
            throw TypeError('.propel.commrouter.PutContextRequest.putContext: object expected');
          message.putContext = $root.propel.commrouter.ConversationCommand.PutContext.fromObject(
            object.putContext
          );
        }
        return message;
      };

      /**
       * Creates a plain object from a PutContextRequest message. Also converts values to other types if specified.
       * @function toObject
       * @memberof propel.commrouter.PutContextRequest
       * @static
       * @param {propel.commrouter.PutContextRequest} message PutContextRequest
       * @param {$protobuf.IConversionOptions} [options] Conversion options
       * @returns {Object.<string,*>} Plain object
       */
      PutContextRequest.toObject = function toObject(message, options) {
        if (!options) options = {};
        var object = {};
        if (options.defaults) {
          object.conversationId = '';
          object.putContext = null;
        }
        if (message.conversationId != null && message.hasOwnProperty('conversationId'))
          object.conversationId = message.conversationId;
        if (message.putContext != null && message.hasOwnProperty('putContext'))
          object.putContext = $root.propel.commrouter.ConversationCommand.PutContext.toObject(
            message.putContext,
            options
          );
        return object;
      };

      /**
       * Converts this PutContextRequest to JSON.
       * @function toJSON
       * @memberof propel.commrouter.PutContextRequest
       * @instance
       * @returns {Object.<string,*>} JSON object
       */
      PutContextRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
      };

      return PutContextRequest;
    })();

    commrouter.PutVendorInfoRequest = (function () {
      /**
       * Properties of a PutVendorInfoRequest.
       * @memberof propel.commrouter
       * @interface IPutVendorInfoRequest
       * @property {string|null} [conversationId] PutVendorInfoRequest conversationId
       * @property {propel.commrouter.ConversationCommand.IPutVendorInfo|null} [putVendorInfo] PutVendorInfoRequest putVendorInfo
       */

      /**
       * Constructs a new PutVendorInfoRequest.
       * @memberof propel.commrouter
       * @classdesc Represents a PutVendorInfoRequest.
       * @implements IPutVendorInfoRequest
       * @constructor
       * @param {propel.commrouter.IPutVendorInfoRequest=} [properties] Properties to set
       */
      function PutVendorInfoRequest(properties) {
        if (properties)
          for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
      }

      /**
       * PutVendorInfoRequest conversationId.
       * @member {string} conversationId
       * @memberof propel.commrouter.PutVendorInfoRequest
       * @instance
       */
      PutVendorInfoRequest.prototype.conversationId = '';

      /**
       * PutVendorInfoRequest putVendorInfo.
       * @member {propel.commrouter.ConversationCommand.IPutVendorInfo|null|undefined} putVendorInfo
       * @memberof propel.commrouter.PutVendorInfoRequest
       * @instance
       */
      PutVendorInfoRequest.prototype.putVendorInfo = null;

      /**
       * Creates a new PutVendorInfoRequest instance using the specified properties.
       * @function create
       * @memberof propel.commrouter.PutVendorInfoRequest
       * @static
       * @param {propel.commrouter.IPutVendorInfoRequest=} [properties] Properties to set
       * @returns {propel.commrouter.PutVendorInfoRequest} PutVendorInfoRequest instance
       */
      PutVendorInfoRequest.create = function create(properties) {
        return new PutVendorInfoRequest(properties);
      };

      /**
       * Encodes the specified PutVendorInfoRequest message. Does not implicitly {@link propel.commrouter.PutVendorInfoRequest.verify|verify} messages.
       * @function encode
       * @memberof propel.commrouter.PutVendorInfoRequest
       * @static
       * @param {propel.commrouter.IPutVendorInfoRequest} message PutVendorInfoRequest message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      PutVendorInfoRequest.encode = function encode(message, writer) {
        if (!writer) writer = $Writer.create();
        if (message.conversationId != null && message.hasOwnProperty('conversationId'))
          writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.conversationId);
        if (message.putVendorInfo != null && message.hasOwnProperty('putVendorInfo'))
          $root.propel.commrouter.ConversationCommand.PutVendorInfo.encode(
            message.putVendorInfo,
            writer.uint32(/* id 2, wireType 2 =*/ 18).fork()
          ).ldelim();
        return writer;
      };

      /**
       * Encodes the specified PutVendorInfoRequest message, length delimited. Does not implicitly {@link propel.commrouter.PutVendorInfoRequest.verify|verify} messages.
       * @function encodeDelimited
       * @memberof propel.commrouter.PutVendorInfoRequest
       * @static
       * @param {propel.commrouter.IPutVendorInfoRequest} message PutVendorInfoRequest message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      PutVendorInfoRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
      };

      /**
       * Decodes a PutVendorInfoRequest message from the specified reader or buffer.
       * @function decode
       * @memberof propel.commrouter.PutVendorInfoRequest
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @param {number} [length] Message length if known beforehand
       * @returns {propel.commrouter.PutVendorInfoRequest} PutVendorInfoRequest
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      PutVendorInfoRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length,
          message = new $root.propel.commrouter.PutVendorInfoRequest();
        while (reader.pos < end) {
          var tag = reader.uint32();
          switch (tag >>> 3) {
            case 1:
              message.conversationId = reader.string();
              break;
            case 2:
              message.putVendorInfo =
                $root.propel.commrouter.ConversationCommand.PutVendorInfo.decode(
                  reader,
                  reader.uint32()
                );
              break;
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };

      /**
       * Decodes a PutVendorInfoRequest message from the specified reader or buffer, length delimited.
       * @function decodeDelimited
       * @memberof propel.commrouter.PutVendorInfoRequest
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @returns {propel.commrouter.PutVendorInfoRequest} PutVendorInfoRequest
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      PutVendorInfoRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader)) reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
      };

      /**
       * Verifies a PutVendorInfoRequest message.
       * @function verify
       * @memberof propel.commrouter.PutVendorInfoRequest
       * @static
       * @param {Object.<string,*>} message Plain object to verify
       * @returns {string|null} `null` if valid, otherwise the reason why it is not
       */
      PutVendorInfoRequest.verify = function verify(message) {
        if (typeof message !== 'object' || message === null) return 'object expected';
        if (message.conversationId != null && message.hasOwnProperty('conversationId'))
          if (!$util.isString(message.conversationId)) return 'conversationId: string expected';
        if (message.putVendorInfo != null && message.hasOwnProperty('putVendorInfo')) {
          var error = $root.propel.commrouter.ConversationCommand.PutVendorInfo.verify(
            message.putVendorInfo
          );
          if (error) return 'putVendorInfo.' + error;
        }
        return null;
      };

      /**
       * Creates a PutVendorInfoRequest message from a plain object. Also converts values to their respective internal types.
       * @function fromObject
       * @memberof propel.commrouter.PutVendorInfoRequest
       * @static
       * @param {Object.<string,*>} object Plain object
       * @returns {propel.commrouter.PutVendorInfoRequest} PutVendorInfoRequest
       */
      PutVendorInfoRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.propel.commrouter.PutVendorInfoRequest) return object;
        var message = new $root.propel.commrouter.PutVendorInfoRequest();
        if (object.conversationId != null) message.conversationId = String(object.conversationId);
        if (object.putVendorInfo != null) {
          if (typeof object.putVendorInfo !== 'object')
            throw TypeError(
              '.propel.commrouter.PutVendorInfoRequest.putVendorInfo: object expected'
            );
          message.putVendorInfo =
            $root.propel.commrouter.ConversationCommand.PutVendorInfo.fromObject(
              object.putVendorInfo
            );
        }
        return message;
      };

      /**
       * Creates a plain object from a PutVendorInfoRequest message. Also converts values to other types if specified.
       * @function toObject
       * @memberof propel.commrouter.PutVendorInfoRequest
       * @static
       * @param {propel.commrouter.PutVendorInfoRequest} message PutVendorInfoRequest
       * @param {$protobuf.IConversionOptions} [options] Conversion options
       * @returns {Object.<string,*>} Plain object
       */
      PutVendorInfoRequest.toObject = function toObject(message, options) {
        if (!options) options = {};
        var object = {};
        if (options.defaults) {
          object.conversationId = '';
          object.putVendorInfo = null;
        }
        if (message.conversationId != null && message.hasOwnProperty('conversationId'))
          object.conversationId = message.conversationId;
        if (message.putVendorInfo != null && message.hasOwnProperty('putVendorInfo'))
          object.putVendorInfo = $root.propel.commrouter.ConversationCommand.PutVendorInfo.toObject(
            message.putVendorInfo,
            options
          );
        return object;
      };

      /**
       * Converts this PutVendorInfoRequest to JSON.
       * @function toJSON
       * @memberof propel.commrouter.PutVendorInfoRequest
       * @instance
       * @returns {Object.<string,*>} JSON object
       */
      PutVendorInfoRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
      };

      return PutVendorInfoRequest;
    })();

    commrouter.ExecuteVendorCommandRequest = (function () {
      /**
       * Properties of an ExecuteVendorCommandRequest.
       * @memberof propel.commrouter
       * @interface IExecuteVendorCommandRequest
       * @property {string|null} [commandName] ExecuteVendorCommandRequest commandName
       * @property {google.protobuf.IStringValue|null} [conversationId] ExecuteVendorCommandRequest conversationId
       * @property {google.protobuf.IStruct|null} [value] ExecuteVendorCommandRequest value
       */

      /**
       * Constructs a new ExecuteVendorCommandRequest.
       * @memberof propel.commrouter
       * @classdesc Represents an ExecuteVendorCommandRequest.
       * @implements IExecuteVendorCommandRequest
       * @constructor
       * @param {propel.commrouter.IExecuteVendorCommandRequest=} [properties] Properties to set
       */
      function ExecuteVendorCommandRequest(properties) {
        if (properties)
          for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
      }

      /**
       * ExecuteVendorCommandRequest commandName.
       * @member {string} commandName
       * @memberof propel.commrouter.ExecuteVendorCommandRequest
       * @instance
       */
      ExecuteVendorCommandRequest.prototype.commandName = '';

      /**
       * ExecuteVendorCommandRequest conversationId.
       * @member {google.protobuf.IStringValue|null|undefined} conversationId
       * @memberof propel.commrouter.ExecuteVendorCommandRequest
       * @instance
       */
      ExecuteVendorCommandRequest.prototype.conversationId = null;

      /**
       * ExecuteVendorCommandRequest value.
       * @member {google.protobuf.IStruct|null|undefined} value
       * @memberof propel.commrouter.ExecuteVendorCommandRequest
       * @instance
       */
      ExecuteVendorCommandRequest.prototype.value = null;

      /**
       * Creates a new ExecuteVendorCommandRequest instance using the specified properties.
       * @function create
       * @memberof propel.commrouter.ExecuteVendorCommandRequest
       * @static
       * @param {propel.commrouter.IExecuteVendorCommandRequest=} [properties] Properties to set
       * @returns {propel.commrouter.ExecuteVendorCommandRequest} ExecuteVendorCommandRequest instance
       */
      ExecuteVendorCommandRequest.create = function create(properties) {
        return new ExecuteVendorCommandRequest(properties);
      };

      /**
       * Encodes the specified ExecuteVendorCommandRequest message. Does not implicitly {@link propel.commrouter.ExecuteVendorCommandRequest.verify|verify} messages.
       * @function encode
       * @memberof propel.commrouter.ExecuteVendorCommandRequest
       * @static
       * @param {propel.commrouter.IExecuteVendorCommandRequest} message ExecuteVendorCommandRequest message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      ExecuteVendorCommandRequest.encode = function encode(message, writer) {
        if (!writer) writer = $Writer.create();
        if (message.commandName != null && message.hasOwnProperty('commandName'))
          writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.commandName);
        if (message.conversationId != null && message.hasOwnProperty('conversationId'))
          $root.google.protobuf.StringValue.encode(
            message.conversationId,
            writer.uint32(/* id 2, wireType 2 =*/ 18).fork()
          ).ldelim();
        if (message.value != null && message.hasOwnProperty('value'))
          $root.google.protobuf.Struct.encode(
            message.value,
            writer.uint32(/* id 3, wireType 2 =*/ 26).fork()
          ).ldelim();
        return writer;
      };

      /**
       * Encodes the specified ExecuteVendorCommandRequest message, length delimited. Does not implicitly {@link propel.commrouter.ExecuteVendorCommandRequest.verify|verify} messages.
       * @function encodeDelimited
       * @memberof propel.commrouter.ExecuteVendorCommandRequest
       * @static
       * @param {propel.commrouter.IExecuteVendorCommandRequest} message ExecuteVendorCommandRequest message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      ExecuteVendorCommandRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
      };

      /**
       * Decodes an ExecuteVendorCommandRequest message from the specified reader or buffer.
       * @function decode
       * @memberof propel.commrouter.ExecuteVendorCommandRequest
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @param {number} [length] Message length if known beforehand
       * @returns {propel.commrouter.ExecuteVendorCommandRequest} ExecuteVendorCommandRequest
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      ExecuteVendorCommandRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length,
          message = new $root.propel.commrouter.ExecuteVendorCommandRequest();
        while (reader.pos < end) {
          var tag = reader.uint32();
          switch (tag >>> 3) {
            case 1:
              message.commandName = reader.string();
              break;
            case 2:
              message.conversationId = $root.google.protobuf.StringValue.decode(
                reader,
                reader.uint32()
              );
              break;
            case 3:
              message.value = $root.google.protobuf.Struct.decode(reader, reader.uint32());
              break;
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };

      /**
       * Decodes an ExecuteVendorCommandRequest message from the specified reader or buffer, length delimited.
       * @function decodeDelimited
       * @memberof propel.commrouter.ExecuteVendorCommandRequest
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @returns {propel.commrouter.ExecuteVendorCommandRequest} ExecuteVendorCommandRequest
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      ExecuteVendorCommandRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader)) reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
      };

      /**
       * Verifies an ExecuteVendorCommandRequest message.
       * @function verify
       * @memberof propel.commrouter.ExecuteVendorCommandRequest
       * @static
       * @param {Object.<string,*>} message Plain object to verify
       * @returns {string|null} `null` if valid, otherwise the reason why it is not
       */
      ExecuteVendorCommandRequest.verify = function verify(message) {
        if (typeof message !== 'object' || message === null) return 'object expected';
        if (message.commandName != null && message.hasOwnProperty('commandName'))
          if (!$util.isString(message.commandName)) return 'commandName: string expected';
        if (message.conversationId != null && message.hasOwnProperty('conversationId')) {
          var error = $root.google.protobuf.StringValue.verify(message.conversationId);
          if (error) return 'conversationId.' + error;
        }
        if (message.value != null && message.hasOwnProperty('value')) {
          var error = $root.google.protobuf.Struct.verify(message.value);
          if (error) return 'value.' + error;
        }
        return null;
      };

      /**
       * Creates an ExecuteVendorCommandRequest message from a plain object. Also converts values to their respective internal types.
       * @function fromObject
       * @memberof propel.commrouter.ExecuteVendorCommandRequest
       * @static
       * @param {Object.<string,*>} object Plain object
       * @returns {propel.commrouter.ExecuteVendorCommandRequest} ExecuteVendorCommandRequest
       */
      ExecuteVendorCommandRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.propel.commrouter.ExecuteVendorCommandRequest) return object;
        var message = new $root.propel.commrouter.ExecuteVendorCommandRequest();
        if (object.commandName != null) message.commandName = String(object.commandName);
        if (object.conversationId != null) {
          if (typeof object.conversationId !== 'object')
            throw TypeError(
              '.propel.commrouter.ExecuteVendorCommandRequest.conversationId: object expected'
            );
          message.conversationId = $root.google.protobuf.StringValue.fromObject(
            object.conversationId
          );
        }
        if (object.value != null) {
          if (typeof object.value !== 'object')
            throw TypeError(
              '.propel.commrouter.ExecuteVendorCommandRequest.value: object expected'
            );
          message.value = $root.google.protobuf.Struct.fromObject(object.value);
        }
        return message;
      };

      /**
       * Creates a plain object from an ExecuteVendorCommandRequest message. Also converts values to other types if specified.
       * @function toObject
       * @memberof propel.commrouter.ExecuteVendorCommandRequest
       * @static
       * @param {propel.commrouter.ExecuteVendorCommandRequest} message ExecuteVendorCommandRequest
       * @param {$protobuf.IConversionOptions} [options] Conversion options
       * @returns {Object.<string,*>} Plain object
       */
      ExecuteVendorCommandRequest.toObject = function toObject(message, options) {
        if (!options) options = {};
        var object = {};
        if (options.defaults) {
          object.commandName = '';
          object.conversationId = null;
          object.value = null;
        }
        if (message.commandName != null && message.hasOwnProperty('commandName'))
          object.commandName = message.commandName;
        if (message.conversationId != null && message.hasOwnProperty('conversationId'))
          object.conversationId = $root.google.protobuf.StringValue.toObject(
            message.conversationId,
            options
          );
        if (message.value != null && message.hasOwnProperty('value'))
          object.value = $root.google.protobuf.Struct.toObject(message.value, options);
        return object;
      };

      /**
       * Converts this ExecuteVendorCommandRequest to JSON.
       * @function toJSON
       * @memberof propel.commrouter.ExecuteVendorCommandRequest
       * @instance
       * @returns {Object.<string,*>} JSON object
       */
      ExecuteVendorCommandRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
      };

      return ExecuteVendorCommandRequest;
    })();

    commrouter.UpdateSentenceRequest = (function () {
      /**
       * Properties of an UpdateSentenceRequest.
       * @memberof propel.commrouter
       * @interface IUpdateSentenceRequest
       * @property {string|null} [conversationId] UpdateSentenceRequest conversationId
       * @property {propel.commrouter.ConversationCommand.IUpdateSentence|null} [updateSentence] UpdateSentenceRequest updateSentence
       */

      /**
       * Constructs a new UpdateSentenceRequest.
       * @memberof propel.commrouter
       * @classdesc Represents an UpdateSentenceRequest.
       * @implements IUpdateSentenceRequest
       * @constructor
       * @param {propel.commrouter.IUpdateSentenceRequest=} [properties] Properties to set
       */
      function UpdateSentenceRequest(properties) {
        if (properties)
          for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
      }

      /**
       * UpdateSentenceRequest conversationId.
       * @member {string} conversationId
       * @memberof propel.commrouter.UpdateSentenceRequest
       * @instance
       */
      UpdateSentenceRequest.prototype.conversationId = '';

      /**
       * UpdateSentenceRequest updateSentence.
       * @member {propel.commrouter.ConversationCommand.IUpdateSentence|null|undefined} updateSentence
       * @memberof propel.commrouter.UpdateSentenceRequest
       * @instance
       */
      UpdateSentenceRequest.prototype.updateSentence = null;

      /**
       * Creates a new UpdateSentenceRequest instance using the specified properties.
       * @function create
       * @memberof propel.commrouter.UpdateSentenceRequest
       * @static
       * @param {propel.commrouter.IUpdateSentenceRequest=} [properties] Properties to set
       * @returns {propel.commrouter.UpdateSentenceRequest} UpdateSentenceRequest instance
       */
      UpdateSentenceRequest.create = function create(properties) {
        return new UpdateSentenceRequest(properties);
      };

      /**
       * Encodes the specified UpdateSentenceRequest message. Does not implicitly {@link propel.commrouter.UpdateSentenceRequest.verify|verify} messages.
       * @function encode
       * @memberof propel.commrouter.UpdateSentenceRequest
       * @static
       * @param {propel.commrouter.IUpdateSentenceRequest} message UpdateSentenceRequest message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      UpdateSentenceRequest.encode = function encode(message, writer) {
        if (!writer) writer = $Writer.create();
        if (message.conversationId != null && message.hasOwnProperty('conversationId'))
          writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.conversationId);
        if (message.updateSentence != null && message.hasOwnProperty('updateSentence'))
          $root.propel.commrouter.ConversationCommand.UpdateSentence.encode(
            message.updateSentence,
            writer.uint32(/* id 2, wireType 2 =*/ 18).fork()
          ).ldelim();
        return writer;
      };

      /**
       * Encodes the specified UpdateSentenceRequest message, length delimited. Does not implicitly {@link propel.commrouter.UpdateSentenceRequest.verify|verify} messages.
       * @function encodeDelimited
       * @memberof propel.commrouter.UpdateSentenceRequest
       * @static
       * @param {propel.commrouter.IUpdateSentenceRequest} message UpdateSentenceRequest message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      UpdateSentenceRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
      };

      /**
       * Decodes an UpdateSentenceRequest message from the specified reader or buffer.
       * @function decode
       * @memberof propel.commrouter.UpdateSentenceRequest
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @param {number} [length] Message length if known beforehand
       * @returns {propel.commrouter.UpdateSentenceRequest} UpdateSentenceRequest
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      UpdateSentenceRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length,
          message = new $root.propel.commrouter.UpdateSentenceRequest();
        while (reader.pos < end) {
          var tag = reader.uint32();
          switch (tag >>> 3) {
            case 1:
              message.conversationId = reader.string();
              break;
            case 2:
              message.updateSentence =
                $root.propel.commrouter.ConversationCommand.UpdateSentence.decode(
                  reader,
                  reader.uint32()
                );
              break;
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };

      /**
       * Decodes an UpdateSentenceRequest message from the specified reader or buffer, length delimited.
       * @function decodeDelimited
       * @memberof propel.commrouter.UpdateSentenceRequest
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @returns {propel.commrouter.UpdateSentenceRequest} UpdateSentenceRequest
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      UpdateSentenceRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader)) reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
      };

      /**
       * Verifies an UpdateSentenceRequest message.
       * @function verify
       * @memberof propel.commrouter.UpdateSentenceRequest
       * @static
       * @param {Object.<string,*>} message Plain object to verify
       * @returns {string|null} `null` if valid, otherwise the reason why it is not
       */
      UpdateSentenceRequest.verify = function verify(message) {
        if (typeof message !== 'object' || message === null) return 'object expected';
        if (message.conversationId != null && message.hasOwnProperty('conversationId'))
          if (!$util.isString(message.conversationId)) return 'conversationId: string expected';
        if (message.updateSentence != null && message.hasOwnProperty('updateSentence')) {
          var error = $root.propel.commrouter.ConversationCommand.UpdateSentence.verify(
            message.updateSentence
          );
          if (error) return 'updateSentence.' + error;
        }
        return null;
      };

      /**
       * Creates an UpdateSentenceRequest message from a plain object. Also converts values to their respective internal types.
       * @function fromObject
       * @memberof propel.commrouter.UpdateSentenceRequest
       * @static
       * @param {Object.<string,*>} object Plain object
       * @returns {propel.commrouter.UpdateSentenceRequest} UpdateSentenceRequest
       */
      UpdateSentenceRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.propel.commrouter.UpdateSentenceRequest) return object;
        var message = new $root.propel.commrouter.UpdateSentenceRequest();
        if (object.conversationId != null) message.conversationId = String(object.conversationId);
        if (object.updateSentence != null) {
          if (typeof object.updateSentence !== 'object')
            throw TypeError(
              '.propel.commrouter.UpdateSentenceRequest.updateSentence: object expected'
            );
          message.updateSentence =
            $root.propel.commrouter.ConversationCommand.UpdateSentence.fromObject(
              object.updateSentence
            );
        }
        return message;
      };

      /**
       * Creates a plain object from an UpdateSentenceRequest message. Also converts values to other types if specified.
       * @function toObject
       * @memberof propel.commrouter.UpdateSentenceRequest
       * @static
       * @param {propel.commrouter.UpdateSentenceRequest} message UpdateSentenceRequest
       * @param {$protobuf.IConversionOptions} [options] Conversion options
       * @returns {Object.<string,*>} Plain object
       */
      UpdateSentenceRequest.toObject = function toObject(message, options) {
        if (!options) options = {};
        var object = {};
        if (options.defaults) {
          object.conversationId = '';
          object.updateSentence = null;
        }
        if (message.conversationId != null && message.hasOwnProperty('conversationId'))
          object.conversationId = message.conversationId;
        if (message.updateSentence != null && message.hasOwnProperty('updateSentence'))
          object.updateSentence =
            $root.propel.commrouter.ConversationCommand.UpdateSentence.toObject(
              message.updateSentence,
              options
            );
        return object;
      };

      /**
       * Converts this UpdateSentenceRequest to JSON.
       * @function toJSON
       * @memberof propel.commrouter.UpdateSentenceRequest
       * @instance
       * @returns {Object.<string,*>} JSON object
       */
      UpdateSentenceRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
      };

      return UpdateSentenceRequest;
    })();

    commrouter.CreateResponseRequest = (function () {
      /**
       * Properties of a CreateResponseRequest.
       * @memberof propel.commrouter
       * @interface ICreateResponseRequest
       * @property {string|null} [conversationId] CreateResponseRequest conversationId
       * @property {propel.commrouter.ConversationCommand.ICreateResponse|null} [createResponse] CreateResponseRequest createResponse
       */

      /**
       * Constructs a new CreateResponseRequest.
       * @memberof propel.commrouter
       * @classdesc Represents a CreateResponseRequest.
       * @implements ICreateResponseRequest
       * @constructor
       * @param {propel.commrouter.ICreateResponseRequest=} [properties] Properties to set
       */
      function CreateResponseRequest(properties) {
        if (properties)
          for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
      }

      /**
       * CreateResponseRequest conversationId.
       * @member {string} conversationId
       * @memberof propel.commrouter.CreateResponseRequest
       * @instance
       */
      CreateResponseRequest.prototype.conversationId = '';

      /**
       * CreateResponseRequest createResponse.
       * @member {propel.commrouter.ConversationCommand.ICreateResponse|null|undefined} createResponse
       * @memberof propel.commrouter.CreateResponseRequest
       * @instance
       */
      CreateResponseRequest.prototype.createResponse = null;

      /**
       * Creates a new CreateResponseRequest instance using the specified properties.
       * @function create
       * @memberof propel.commrouter.CreateResponseRequest
       * @static
       * @param {propel.commrouter.ICreateResponseRequest=} [properties] Properties to set
       * @returns {propel.commrouter.CreateResponseRequest} CreateResponseRequest instance
       */
      CreateResponseRequest.create = function create(properties) {
        return new CreateResponseRequest(properties);
      };

      /**
       * Encodes the specified CreateResponseRequest message. Does not implicitly {@link propel.commrouter.CreateResponseRequest.verify|verify} messages.
       * @function encode
       * @memberof propel.commrouter.CreateResponseRequest
       * @static
       * @param {propel.commrouter.ICreateResponseRequest} message CreateResponseRequest message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      CreateResponseRequest.encode = function encode(message, writer) {
        if (!writer) writer = $Writer.create();
        if (message.conversationId != null && message.hasOwnProperty('conversationId'))
          writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.conversationId);
        if (message.createResponse != null && message.hasOwnProperty('createResponse'))
          $root.propel.commrouter.ConversationCommand.CreateResponse.encode(
            message.createResponse,
            writer.uint32(/* id 2, wireType 2 =*/ 18).fork()
          ).ldelim();
        return writer;
      };

      /**
       * Encodes the specified CreateResponseRequest message, length delimited. Does not implicitly {@link propel.commrouter.CreateResponseRequest.verify|verify} messages.
       * @function encodeDelimited
       * @memberof propel.commrouter.CreateResponseRequest
       * @static
       * @param {propel.commrouter.ICreateResponseRequest} message CreateResponseRequest message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      CreateResponseRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
      };

      /**
       * Decodes a CreateResponseRequest message from the specified reader or buffer.
       * @function decode
       * @memberof propel.commrouter.CreateResponseRequest
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @param {number} [length] Message length if known beforehand
       * @returns {propel.commrouter.CreateResponseRequest} CreateResponseRequest
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      CreateResponseRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length,
          message = new $root.propel.commrouter.CreateResponseRequest();
        while (reader.pos < end) {
          var tag = reader.uint32();
          switch (tag >>> 3) {
            case 1:
              message.conversationId = reader.string();
              break;
            case 2:
              message.createResponse =
                $root.propel.commrouter.ConversationCommand.CreateResponse.decode(
                  reader,
                  reader.uint32()
                );
              break;
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };

      /**
       * Decodes a CreateResponseRequest message from the specified reader or buffer, length delimited.
       * @function decodeDelimited
       * @memberof propel.commrouter.CreateResponseRequest
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @returns {propel.commrouter.CreateResponseRequest} CreateResponseRequest
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      CreateResponseRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader)) reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
      };

      /**
       * Verifies a CreateResponseRequest message.
       * @function verify
       * @memberof propel.commrouter.CreateResponseRequest
       * @static
       * @param {Object.<string,*>} message Plain object to verify
       * @returns {string|null} `null` if valid, otherwise the reason why it is not
       */
      CreateResponseRequest.verify = function verify(message) {
        if (typeof message !== 'object' || message === null) return 'object expected';
        if (message.conversationId != null && message.hasOwnProperty('conversationId'))
          if (!$util.isString(message.conversationId)) return 'conversationId: string expected';
        if (message.createResponse != null && message.hasOwnProperty('createResponse')) {
          var error = $root.propel.commrouter.ConversationCommand.CreateResponse.verify(
            message.createResponse
          );
          if (error) return 'createResponse.' + error;
        }
        return null;
      };

      /**
       * Creates a CreateResponseRequest message from a plain object. Also converts values to their respective internal types.
       * @function fromObject
       * @memberof propel.commrouter.CreateResponseRequest
       * @static
       * @param {Object.<string,*>} object Plain object
       * @returns {propel.commrouter.CreateResponseRequest} CreateResponseRequest
       */
      CreateResponseRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.propel.commrouter.CreateResponseRequest) return object;
        var message = new $root.propel.commrouter.CreateResponseRequest();
        if (object.conversationId != null) message.conversationId = String(object.conversationId);
        if (object.createResponse != null) {
          if (typeof object.createResponse !== 'object')
            throw TypeError(
              '.propel.commrouter.CreateResponseRequest.createResponse: object expected'
            );
          message.createResponse =
            $root.propel.commrouter.ConversationCommand.CreateResponse.fromObject(
              object.createResponse
            );
        }
        return message;
      };

      /**
       * Creates a plain object from a CreateResponseRequest message. Also converts values to other types if specified.
       * @function toObject
       * @memberof propel.commrouter.CreateResponseRequest
       * @static
       * @param {propel.commrouter.CreateResponseRequest} message CreateResponseRequest
       * @param {$protobuf.IConversionOptions} [options] Conversion options
       * @returns {Object.<string,*>} Plain object
       */
      CreateResponseRequest.toObject = function toObject(message, options) {
        if (!options) options = {};
        var object = {};
        if (options.defaults) {
          object.conversationId = '';
          object.createResponse = null;
        }
        if (message.conversationId != null && message.hasOwnProperty('conversationId'))
          object.conversationId = message.conversationId;
        if (message.createResponse != null && message.hasOwnProperty('createResponse'))
          object.createResponse =
            $root.propel.commrouter.ConversationCommand.CreateResponse.toObject(
              message.createResponse,
              options
            );
        return object;
      };

      /**
       * Converts this CreateResponseRequest to JSON.
       * @function toJSON
       * @memberof propel.commrouter.CreateResponseRequest
       * @instance
       * @returns {Object.<string,*>} JSON object
       */
      CreateResponseRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
      };

      return CreateResponseRequest;
    })();

    commrouter.CreateIncomingLeadRequest = (function () {
      /**
       * Properties of a CreateIncomingLeadRequest.
       * @memberof propel.commrouter
       * @interface ICreateIncomingLeadRequest
       * @property {string|null} [conversationId] CreateIncomingLeadRequest conversationId
       * @property {propel.commrouter.ConversationCommand.ICreateIncomingLead|null} [createIncomingLead] CreateIncomingLeadRequest createIncomingLead
       */

      /**
       * Constructs a new CreateIncomingLeadRequest.
       * @memberof propel.commrouter
       * @classdesc Represents a CreateIncomingLeadRequest.
       * @implements ICreateIncomingLeadRequest
       * @constructor
       * @param {propel.commrouter.ICreateIncomingLeadRequest=} [properties] Properties to set
       */
      function CreateIncomingLeadRequest(properties) {
        if (properties)
          for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
      }

      /**
       * CreateIncomingLeadRequest conversationId.
       * @member {string} conversationId
       * @memberof propel.commrouter.CreateIncomingLeadRequest
       * @instance
       */
      CreateIncomingLeadRequest.prototype.conversationId = '';

      /**
       * CreateIncomingLeadRequest createIncomingLead.
       * @member {propel.commrouter.ConversationCommand.ICreateIncomingLead|null|undefined} createIncomingLead
       * @memberof propel.commrouter.CreateIncomingLeadRequest
       * @instance
       */
      CreateIncomingLeadRequest.prototype.createIncomingLead = null;

      /**
       * Creates a new CreateIncomingLeadRequest instance using the specified properties.
       * @function create
       * @memberof propel.commrouter.CreateIncomingLeadRequest
       * @static
       * @param {propel.commrouter.ICreateIncomingLeadRequest=} [properties] Properties to set
       * @returns {propel.commrouter.CreateIncomingLeadRequest} CreateIncomingLeadRequest instance
       */
      CreateIncomingLeadRequest.create = function create(properties) {
        return new CreateIncomingLeadRequest(properties);
      };

      /**
       * Encodes the specified CreateIncomingLeadRequest message. Does not implicitly {@link propel.commrouter.CreateIncomingLeadRequest.verify|verify} messages.
       * @function encode
       * @memberof propel.commrouter.CreateIncomingLeadRequest
       * @static
       * @param {propel.commrouter.ICreateIncomingLeadRequest} message CreateIncomingLeadRequest message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      CreateIncomingLeadRequest.encode = function encode(message, writer) {
        if (!writer) writer = $Writer.create();
        if (message.conversationId != null && message.hasOwnProperty('conversationId'))
          writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.conversationId);
        if (message.createIncomingLead != null && message.hasOwnProperty('createIncomingLead'))
          $root.propel.commrouter.ConversationCommand.CreateIncomingLead.encode(
            message.createIncomingLead,
            writer.uint32(/* id 2, wireType 2 =*/ 18).fork()
          ).ldelim();
        return writer;
      };

      /**
       * Encodes the specified CreateIncomingLeadRequest message, length delimited. Does not implicitly {@link propel.commrouter.CreateIncomingLeadRequest.verify|verify} messages.
       * @function encodeDelimited
       * @memberof propel.commrouter.CreateIncomingLeadRequest
       * @static
       * @param {propel.commrouter.ICreateIncomingLeadRequest} message CreateIncomingLeadRequest message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      CreateIncomingLeadRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
      };

      /**
       * Decodes a CreateIncomingLeadRequest message from the specified reader or buffer.
       * @function decode
       * @memberof propel.commrouter.CreateIncomingLeadRequest
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @param {number} [length] Message length if known beforehand
       * @returns {propel.commrouter.CreateIncomingLeadRequest} CreateIncomingLeadRequest
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      CreateIncomingLeadRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length,
          message = new $root.propel.commrouter.CreateIncomingLeadRequest();
        while (reader.pos < end) {
          var tag = reader.uint32();
          switch (tag >>> 3) {
            case 1:
              message.conversationId = reader.string();
              break;
            case 2:
              message.createIncomingLead =
                $root.propel.commrouter.ConversationCommand.CreateIncomingLead.decode(
                  reader,
                  reader.uint32()
                );
              break;
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };

      /**
       * Decodes a CreateIncomingLeadRequest message from the specified reader or buffer, length delimited.
       * @function decodeDelimited
       * @memberof propel.commrouter.CreateIncomingLeadRequest
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @returns {propel.commrouter.CreateIncomingLeadRequest} CreateIncomingLeadRequest
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      CreateIncomingLeadRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader)) reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
      };

      /**
       * Verifies a CreateIncomingLeadRequest message.
       * @function verify
       * @memberof propel.commrouter.CreateIncomingLeadRequest
       * @static
       * @param {Object.<string,*>} message Plain object to verify
       * @returns {string|null} `null` if valid, otherwise the reason why it is not
       */
      CreateIncomingLeadRequest.verify = function verify(message) {
        if (typeof message !== 'object' || message === null) return 'object expected';
        if (message.conversationId != null && message.hasOwnProperty('conversationId'))
          if (!$util.isString(message.conversationId)) return 'conversationId: string expected';
        if (message.createIncomingLead != null && message.hasOwnProperty('createIncomingLead')) {
          var error = $root.propel.commrouter.ConversationCommand.CreateIncomingLead.verify(
            message.createIncomingLead
          );
          if (error) return 'createIncomingLead.' + error;
        }
        return null;
      };

      /**
       * Creates a CreateIncomingLeadRequest message from a plain object. Also converts values to their respective internal types.
       * @function fromObject
       * @memberof propel.commrouter.CreateIncomingLeadRequest
       * @static
       * @param {Object.<string,*>} object Plain object
       * @returns {propel.commrouter.CreateIncomingLeadRequest} CreateIncomingLeadRequest
       */
      CreateIncomingLeadRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.propel.commrouter.CreateIncomingLeadRequest) return object;
        var message = new $root.propel.commrouter.CreateIncomingLeadRequest();
        if (object.conversationId != null) message.conversationId = String(object.conversationId);
        if (object.createIncomingLead != null) {
          if (typeof object.createIncomingLead !== 'object')
            throw TypeError(
              '.propel.commrouter.CreateIncomingLeadRequest.createIncomingLead: object expected'
            );
          message.createIncomingLead =
            $root.propel.commrouter.ConversationCommand.CreateIncomingLead.fromObject(
              object.createIncomingLead
            );
        }
        return message;
      };

      /**
       * Creates a plain object from a CreateIncomingLeadRequest message. Also converts values to other types if specified.
       * @function toObject
       * @memberof propel.commrouter.CreateIncomingLeadRequest
       * @static
       * @param {propel.commrouter.CreateIncomingLeadRequest} message CreateIncomingLeadRequest
       * @param {$protobuf.IConversionOptions} [options] Conversion options
       * @returns {Object.<string,*>} Plain object
       */
      CreateIncomingLeadRequest.toObject = function toObject(message, options) {
        if (!options) options = {};
        var object = {};
        if (options.defaults) {
          object.conversationId = '';
          object.createIncomingLead = null;
        }
        if (message.conversationId != null && message.hasOwnProperty('conversationId'))
          object.conversationId = message.conversationId;
        if (message.createIncomingLead != null && message.hasOwnProperty('createIncomingLead'))
          object.createIncomingLead =
            $root.propel.commrouter.ConversationCommand.CreateIncomingLead.toObject(
              message.createIncomingLead,
              options
            );
        return object;
      };

      /**
       * Converts this CreateIncomingLeadRequest to JSON.
       * @function toJSON
       * @memberof propel.commrouter.CreateIncomingLeadRequest
       * @instance
       * @returns {Object.<string,*>} JSON object
       */
      CreateIncomingLeadRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
      };

      return CreateIncomingLeadRequest;
    })();

    commrouter.CreateResponseMessageRequest = (function () {
      /**
       * Properties of a CreateResponseMessageRequest.
       * @memberof propel.commrouter
       * @interface ICreateResponseMessageRequest
       * @property {string|null} [conversationId] CreateResponseMessageRequest conversationId
       * @property {propel.commrouter.ConversationCommand.ICreateResponseMessage|null} [createResponseMessage] CreateResponseMessageRequest createResponseMessage
       */

      /**
       * Constructs a new CreateResponseMessageRequest.
       * @memberof propel.commrouter
       * @classdesc Represents a CreateResponseMessageRequest.
       * @implements ICreateResponseMessageRequest
       * @constructor
       * @param {propel.commrouter.ICreateResponseMessageRequest=} [properties] Properties to set
       */
      function CreateResponseMessageRequest(properties) {
        if (properties)
          for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
      }

      /**
       * CreateResponseMessageRequest conversationId.
       * @member {string} conversationId
       * @memberof propel.commrouter.CreateResponseMessageRequest
       * @instance
       */
      CreateResponseMessageRequest.prototype.conversationId = '';

      /**
       * CreateResponseMessageRequest createResponseMessage.
       * @member {propel.commrouter.ConversationCommand.ICreateResponseMessage|null|undefined} createResponseMessage
       * @memberof propel.commrouter.CreateResponseMessageRequest
       * @instance
       */
      CreateResponseMessageRequest.prototype.createResponseMessage = null;

      /**
       * Creates a new CreateResponseMessageRequest instance using the specified properties.
       * @function create
       * @memberof propel.commrouter.CreateResponseMessageRequest
       * @static
       * @param {propel.commrouter.ICreateResponseMessageRequest=} [properties] Properties to set
       * @returns {propel.commrouter.CreateResponseMessageRequest} CreateResponseMessageRequest instance
       */
      CreateResponseMessageRequest.create = function create(properties) {
        return new CreateResponseMessageRequest(properties);
      };

      /**
       * Encodes the specified CreateResponseMessageRequest message. Does not implicitly {@link propel.commrouter.CreateResponseMessageRequest.verify|verify} messages.
       * @function encode
       * @memberof propel.commrouter.CreateResponseMessageRequest
       * @static
       * @param {propel.commrouter.ICreateResponseMessageRequest} message CreateResponseMessageRequest message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      CreateResponseMessageRequest.encode = function encode(message, writer) {
        if (!writer) writer = $Writer.create();
        if (message.conversationId != null && message.hasOwnProperty('conversationId'))
          writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.conversationId);
        if (
          message.createResponseMessage != null &&
          message.hasOwnProperty('createResponseMessage')
        )
          $root.propel.commrouter.ConversationCommand.CreateResponseMessage.encode(
            message.createResponseMessage,
            writer.uint32(/* id 2, wireType 2 =*/ 18).fork()
          ).ldelim();
        return writer;
      };

      /**
       * Encodes the specified CreateResponseMessageRequest message, length delimited. Does not implicitly {@link propel.commrouter.CreateResponseMessageRequest.verify|verify} messages.
       * @function encodeDelimited
       * @memberof propel.commrouter.CreateResponseMessageRequest
       * @static
       * @param {propel.commrouter.ICreateResponseMessageRequest} message CreateResponseMessageRequest message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      CreateResponseMessageRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
      };

      /**
       * Decodes a CreateResponseMessageRequest message from the specified reader or buffer.
       * @function decode
       * @memberof propel.commrouter.CreateResponseMessageRequest
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @param {number} [length] Message length if known beforehand
       * @returns {propel.commrouter.CreateResponseMessageRequest} CreateResponseMessageRequest
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      CreateResponseMessageRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length,
          message = new $root.propel.commrouter.CreateResponseMessageRequest();
        while (reader.pos < end) {
          var tag = reader.uint32();
          switch (tag >>> 3) {
            case 1:
              message.conversationId = reader.string();
              break;
            case 2:
              message.createResponseMessage =
                $root.propel.commrouter.ConversationCommand.CreateResponseMessage.decode(
                  reader,
                  reader.uint32()
                );
              break;
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };

      /**
       * Decodes a CreateResponseMessageRequest message from the specified reader or buffer, length delimited.
       * @function decodeDelimited
       * @memberof propel.commrouter.CreateResponseMessageRequest
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @returns {propel.commrouter.CreateResponseMessageRequest} CreateResponseMessageRequest
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      CreateResponseMessageRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader)) reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
      };

      /**
       * Verifies a CreateResponseMessageRequest message.
       * @function verify
       * @memberof propel.commrouter.CreateResponseMessageRequest
       * @static
       * @param {Object.<string,*>} message Plain object to verify
       * @returns {string|null} `null` if valid, otherwise the reason why it is not
       */
      CreateResponseMessageRequest.verify = function verify(message) {
        if (typeof message !== 'object' || message === null) return 'object expected';
        if (message.conversationId != null && message.hasOwnProperty('conversationId'))
          if (!$util.isString(message.conversationId)) return 'conversationId: string expected';
        if (
          message.createResponseMessage != null &&
          message.hasOwnProperty('createResponseMessage')
        ) {
          var error = $root.propel.commrouter.ConversationCommand.CreateResponseMessage.verify(
            message.createResponseMessage
          );
          if (error) return 'createResponseMessage.' + error;
        }
        return null;
      };

      /**
       * Creates a CreateResponseMessageRequest message from a plain object. Also converts values to their respective internal types.
       * @function fromObject
       * @memberof propel.commrouter.CreateResponseMessageRequest
       * @static
       * @param {Object.<string,*>} object Plain object
       * @returns {propel.commrouter.CreateResponseMessageRequest} CreateResponseMessageRequest
       */
      CreateResponseMessageRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.propel.commrouter.CreateResponseMessageRequest) return object;
        var message = new $root.propel.commrouter.CreateResponseMessageRequest();
        if (object.conversationId != null) message.conversationId = String(object.conversationId);
        if (object.createResponseMessage != null) {
          if (typeof object.createResponseMessage !== 'object')
            throw TypeError(
              '.propel.commrouter.CreateResponseMessageRequest.createResponseMessage: object expected'
            );
          message.createResponseMessage =
            $root.propel.commrouter.ConversationCommand.CreateResponseMessage.fromObject(
              object.createResponseMessage
            );
        }
        return message;
      };

      /**
       * Creates a plain object from a CreateResponseMessageRequest message. Also converts values to other types if specified.
       * @function toObject
       * @memberof propel.commrouter.CreateResponseMessageRequest
       * @static
       * @param {propel.commrouter.CreateResponseMessageRequest} message CreateResponseMessageRequest
       * @param {$protobuf.IConversionOptions} [options] Conversion options
       * @returns {Object.<string,*>} Plain object
       */
      CreateResponseMessageRequest.toObject = function toObject(message, options) {
        if (!options) options = {};
        var object = {};
        if (options.defaults) {
          object.conversationId = '';
          object.createResponseMessage = null;
        }
        if (message.conversationId != null && message.hasOwnProperty('conversationId'))
          object.conversationId = message.conversationId;
        if (
          message.createResponseMessage != null &&
          message.hasOwnProperty('createResponseMessage')
        )
          object.createResponseMessage =
            $root.propel.commrouter.ConversationCommand.CreateResponseMessage.toObject(
              message.createResponseMessage,
              options
            );
        return object;
      };

      /**
       * Converts this CreateResponseMessageRequest to JSON.
       * @function toJSON
       * @memberof propel.commrouter.CreateResponseMessageRequest
       * @instance
       * @returns {Object.<string,*>} JSON object
       */
      CreateResponseMessageRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
      };

      return CreateResponseMessageRequest;
    })();

    commrouter.ListConversationEventPollEventsRequest = (function () {
      /**
       * Properties of a ListConversationEventPollEventsRequest.
       * @memberof propel.commrouter
       * @interface IListConversationEventPollEventsRequest
       * @property {string|null} [conversationId] ListConversationEventPollEventsRequest conversationId
       * @property {string|null} [eventPollId] ListConversationEventPollEventsRequest eventPollId
       */

      /**
       * Constructs a new ListConversationEventPollEventsRequest.
       * @memberof propel.commrouter
       * @classdesc Represents a ListConversationEventPollEventsRequest.
       * @implements IListConversationEventPollEventsRequest
       * @constructor
       * @param {propel.commrouter.IListConversationEventPollEventsRequest=} [properties] Properties to set
       */
      function ListConversationEventPollEventsRequest(properties) {
        if (properties)
          for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
      }

      /**
       * ListConversationEventPollEventsRequest conversationId.
       * @member {string} conversationId
       * @memberof propel.commrouter.ListConversationEventPollEventsRequest
       * @instance
       */
      ListConversationEventPollEventsRequest.prototype.conversationId = '';

      /**
       * ListConversationEventPollEventsRequest eventPollId.
       * @member {string} eventPollId
       * @memberof propel.commrouter.ListConversationEventPollEventsRequest
       * @instance
       */
      ListConversationEventPollEventsRequest.prototype.eventPollId = '';

      /**
       * Creates a new ListConversationEventPollEventsRequest instance using the specified properties.
       * @function create
       * @memberof propel.commrouter.ListConversationEventPollEventsRequest
       * @static
       * @param {propel.commrouter.IListConversationEventPollEventsRequest=} [properties] Properties to set
       * @returns {propel.commrouter.ListConversationEventPollEventsRequest} ListConversationEventPollEventsRequest instance
       */
      ListConversationEventPollEventsRequest.create = function create(properties) {
        return new ListConversationEventPollEventsRequest(properties);
      };

      /**
       * Encodes the specified ListConversationEventPollEventsRequest message. Does not implicitly {@link propel.commrouter.ListConversationEventPollEventsRequest.verify|verify} messages.
       * @function encode
       * @memberof propel.commrouter.ListConversationEventPollEventsRequest
       * @static
       * @param {propel.commrouter.IListConversationEventPollEventsRequest} message ListConversationEventPollEventsRequest message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      ListConversationEventPollEventsRequest.encode = function encode(message, writer) {
        if (!writer) writer = $Writer.create();
        if (message.conversationId != null && message.hasOwnProperty('conversationId'))
          writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.conversationId);
        if (message.eventPollId != null && message.hasOwnProperty('eventPollId'))
          writer.uint32(/* id 2, wireType 2 =*/ 18).string(message.eventPollId);
        return writer;
      };

      /**
       * Encodes the specified ListConversationEventPollEventsRequest message, length delimited. Does not implicitly {@link propel.commrouter.ListConversationEventPollEventsRequest.verify|verify} messages.
       * @function encodeDelimited
       * @memberof propel.commrouter.ListConversationEventPollEventsRequest
       * @static
       * @param {propel.commrouter.IListConversationEventPollEventsRequest} message ListConversationEventPollEventsRequest message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      ListConversationEventPollEventsRequest.encodeDelimited = function encodeDelimited(
        message,
        writer
      ) {
        return this.encode(message, writer).ldelim();
      };

      /**
       * Decodes a ListConversationEventPollEventsRequest message from the specified reader or buffer.
       * @function decode
       * @memberof propel.commrouter.ListConversationEventPollEventsRequest
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @param {number} [length] Message length if known beforehand
       * @returns {propel.commrouter.ListConversationEventPollEventsRequest} ListConversationEventPollEventsRequest
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      ListConversationEventPollEventsRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length,
          message = new $root.propel.commrouter.ListConversationEventPollEventsRequest();
        while (reader.pos < end) {
          var tag = reader.uint32();
          switch (tag >>> 3) {
            case 1:
              message.conversationId = reader.string();
              break;
            case 2:
              message.eventPollId = reader.string();
              break;
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };

      /**
       * Decodes a ListConversationEventPollEventsRequest message from the specified reader or buffer, length delimited.
       * @function decodeDelimited
       * @memberof propel.commrouter.ListConversationEventPollEventsRequest
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @returns {propel.commrouter.ListConversationEventPollEventsRequest} ListConversationEventPollEventsRequest
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      ListConversationEventPollEventsRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader)) reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
      };

      /**
       * Verifies a ListConversationEventPollEventsRequest message.
       * @function verify
       * @memberof propel.commrouter.ListConversationEventPollEventsRequest
       * @static
       * @param {Object.<string,*>} message Plain object to verify
       * @returns {string|null} `null` if valid, otherwise the reason why it is not
       */
      ListConversationEventPollEventsRequest.verify = function verify(message) {
        if (typeof message !== 'object' || message === null) return 'object expected';
        if (message.conversationId != null && message.hasOwnProperty('conversationId'))
          if (!$util.isString(message.conversationId)) return 'conversationId: string expected';
        if (message.eventPollId != null && message.hasOwnProperty('eventPollId'))
          if (!$util.isString(message.eventPollId)) return 'eventPollId: string expected';
        return null;
      };

      /**
       * Creates a ListConversationEventPollEventsRequest message from a plain object. Also converts values to their respective internal types.
       * @function fromObject
       * @memberof propel.commrouter.ListConversationEventPollEventsRequest
       * @static
       * @param {Object.<string,*>} object Plain object
       * @returns {propel.commrouter.ListConversationEventPollEventsRequest} ListConversationEventPollEventsRequest
       */
      ListConversationEventPollEventsRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.propel.commrouter.ListConversationEventPollEventsRequest)
          return object;
        var message = new $root.propel.commrouter.ListConversationEventPollEventsRequest();
        if (object.conversationId != null) message.conversationId = String(object.conversationId);
        if (object.eventPollId != null) message.eventPollId = String(object.eventPollId);
        return message;
      };

      /**
       * Creates a plain object from a ListConversationEventPollEventsRequest message. Also converts values to other types if specified.
       * @function toObject
       * @memberof propel.commrouter.ListConversationEventPollEventsRequest
       * @static
       * @param {propel.commrouter.ListConversationEventPollEventsRequest} message ListConversationEventPollEventsRequest
       * @param {$protobuf.IConversionOptions} [options] Conversion options
       * @returns {Object.<string,*>} Plain object
       */
      ListConversationEventPollEventsRequest.toObject = function toObject(message, options) {
        if (!options) options = {};
        var object = {};
        if (options.defaults) {
          object.conversationId = '';
          object.eventPollId = '';
        }
        if (message.conversationId != null && message.hasOwnProperty('conversationId'))
          object.conversationId = message.conversationId;
        if (message.eventPollId != null && message.hasOwnProperty('eventPollId'))
          object.eventPollId = message.eventPollId;
        return object;
      };

      /**
       * Converts this ListConversationEventPollEventsRequest to JSON.
       * @function toJSON
       * @memberof propel.commrouter.ListConversationEventPollEventsRequest
       * @instance
       * @returns {Object.<string,*>} JSON object
       */
      ListConversationEventPollEventsRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
      };

      return ListConversationEventPollEventsRequest;
    })();

    commrouter.GetDebugInformationRequest = (function () {
      /**
       * Properties of a GetDebugInformationRequest.
       * @memberof propel.commrouter
       * @interface IGetDebugInformationRequest
       * @property {string|null} [conversationId] GetDebugInformationRequest conversationId
       * @property {string|null} [debugInformationId] GetDebugInformationRequest debugInformationId
       * @property {google.protobuf.IUInt32Value|null} [from] GetDebugInformationRequest from
       * @property {google.protobuf.IUInt32Value|null} [to] GetDebugInformationRequest to
       */

      /**
       * Constructs a new GetDebugInformationRequest.
       * @memberof propel.commrouter
       * @classdesc Represents a GetDebugInformationRequest.
       * @implements IGetDebugInformationRequest
       * @constructor
       * @param {propel.commrouter.IGetDebugInformationRequest=} [properties] Properties to set
       */
      function GetDebugInformationRequest(properties) {
        if (properties)
          for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
      }

      /**
       * GetDebugInformationRequest conversationId.
       * @member {string} conversationId
       * @memberof propel.commrouter.GetDebugInformationRequest
       * @instance
       */
      GetDebugInformationRequest.prototype.conversationId = '';

      /**
       * GetDebugInformationRequest debugInformationId.
       * @member {string} debugInformationId
       * @memberof propel.commrouter.GetDebugInformationRequest
       * @instance
       */
      GetDebugInformationRequest.prototype.debugInformationId = '';

      /**
       * GetDebugInformationRequest from.
       * @member {google.protobuf.IUInt32Value|null|undefined} from
       * @memberof propel.commrouter.GetDebugInformationRequest
       * @instance
       */
      GetDebugInformationRequest.prototype.from = null;

      /**
       * GetDebugInformationRequest to.
       * @member {google.protobuf.IUInt32Value|null|undefined} to
       * @memberof propel.commrouter.GetDebugInformationRequest
       * @instance
       */
      GetDebugInformationRequest.prototype.to = null;

      /**
       * Creates a new GetDebugInformationRequest instance using the specified properties.
       * @function create
       * @memberof propel.commrouter.GetDebugInformationRequest
       * @static
       * @param {propel.commrouter.IGetDebugInformationRequest=} [properties] Properties to set
       * @returns {propel.commrouter.GetDebugInformationRequest} GetDebugInformationRequest instance
       */
      GetDebugInformationRequest.create = function create(properties) {
        return new GetDebugInformationRequest(properties);
      };

      /**
       * Encodes the specified GetDebugInformationRequest message. Does not implicitly {@link propel.commrouter.GetDebugInformationRequest.verify|verify} messages.
       * @function encode
       * @memberof propel.commrouter.GetDebugInformationRequest
       * @static
       * @param {propel.commrouter.IGetDebugInformationRequest} message GetDebugInformationRequest message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      GetDebugInformationRequest.encode = function encode(message, writer) {
        if (!writer) writer = $Writer.create();
        if (message.conversationId != null && message.hasOwnProperty('conversationId'))
          writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.conversationId);
        if (message.debugInformationId != null && message.hasOwnProperty('debugInformationId'))
          writer.uint32(/* id 2, wireType 2 =*/ 18).string(message.debugInformationId);
        if (message.from != null && message.hasOwnProperty('from'))
          $root.google.protobuf.UInt32Value.encode(
            message.from,
            writer.uint32(/* id 3, wireType 2 =*/ 26).fork()
          ).ldelim();
        if (message.to != null && message.hasOwnProperty('to'))
          $root.google.protobuf.UInt32Value.encode(
            message.to,
            writer.uint32(/* id 4, wireType 2 =*/ 34).fork()
          ).ldelim();
        return writer;
      };

      /**
       * Encodes the specified GetDebugInformationRequest message, length delimited. Does not implicitly {@link propel.commrouter.GetDebugInformationRequest.verify|verify} messages.
       * @function encodeDelimited
       * @memberof propel.commrouter.GetDebugInformationRequest
       * @static
       * @param {propel.commrouter.IGetDebugInformationRequest} message GetDebugInformationRequest message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      GetDebugInformationRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
      };

      /**
       * Decodes a GetDebugInformationRequest message from the specified reader or buffer.
       * @function decode
       * @memberof propel.commrouter.GetDebugInformationRequest
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @param {number} [length] Message length if known beforehand
       * @returns {propel.commrouter.GetDebugInformationRequest} GetDebugInformationRequest
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      GetDebugInformationRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length,
          message = new $root.propel.commrouter.GetDebugInformationRequest();
        while (reader.pos < end) {
          var tag = reader.uint32();
          switch (tag >>> 3) {
            case 1:
              message.conversationId = reader.string();
              break;
            case 2:
              message.debugInformationId = reader.string();
              break;
            case 3:
              message.from = $root.google.protobuf.UInt32Value.decode(reader, reader.uint32());
              break;
            case 4:
              message.to = $root.google.protobuf.UInt32Value.decode(reader, reader.uint32());
              break;
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };

      /**
       * Decodes a GetDebugInformationRequest message from the specified reader or buffer, length delimited.
       * @function decodeDelimited
       * @memberof propel.commrouter.GetDebugInformationRequest
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @returns {propel.commrouter.GetDebugInformationRequest} GetDebugInformationRequest
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      GetDebugInformationRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader)) reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
      };

      /**
       * Verifies a GetDebugInformationRequest message.
       * @function verify
       * @memberof propel.commrouter.GetDebugInformationRequest
       * @static
       * @param {Object.<string,*>} message Plain object to verify
       * @returns {string|null} `null` if valid, otherwise the reason why it is not
       */
      GetDebugInformationRequest.verify = function verify(message) {
        if (typeof message !== 'object' || message === null) return 'object expected';
        if (message.conversationId != null && message.hasOwnProperty('conversationId'))
          if (!$util.isString(message.conversationId)) return 'conversationId: string expected';
        if (message.debugInformationId != null && message.hasOwnProperty('debugInformationId'))
          if (!$util.isString(message.debugInformationId))
            return 'debugInformationId: string expected';
        if (message.from != null && message.hasOwnProperty('from')) {
          var error = $root.google.protobuf.UInt32Value.verify(message.from);
          if (error) return 'from.' + error;
        }
        if (message.to != null && message.hasOwnProperty('to')) {
          var error = $root.google.protobuf.UInt32Value.verify(message.to);
          if (error) return 'to.' + error;
        }
        return null;
      };

      /**
       * Creates a GetDebugInformationRequest message from a plain object. Also converts values to their respective internal types.
       * @function fromObject
       * @memberof propel.commrouter.GetDebugInformationRequest
       * @static
       * @param {Object.<string,*>} object Plain object
       * @returns {propel.commrouter.GetDebugInformationRequest} GetDebugInformationRequest
       */
      GetDebugInformationRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.propel.commrouter.GetDebugInformationRequest) return object;
        var message = new $root.propel.commrouter.GetDebugInformationRequest();
        if (object.conversationId != null) message.conversationId = String(object.conversationId);
        if (object.debugInformationId != null)
          message.debugInformationId = String(object.debugInformationId);
        if (object.from != null) {
          if (typeof object.from !== 'object')
            throw TypeError('.propel.commrouter.GetDebugInformationRequest.from: object expected');
          message.from = $root.google.protobuf.UInt32Value.fromObject(object.from);
        }
        if (object.to != null) {
          if (typeof object.to !== 'object')
            throw TypeError('.propel.commrouter.GetDebugInformationRequest.to: object expected');
          message.to = $root.google.protobuf.UInt32Value.fromObject(object.to);
        }
        return message;
      };

      /**
       * Creates a plain object from a GetDebugInformationRequest message. Also converts values to other types if specified.
       * @function toObject
       * @memberof propel.commrouter.GetDebugInformationRequest
       * @static
       * @param {propel.commrouter.GetDebugInformationRequest} message GetDebugInformationRequest
       * @param {$protobuf.IConversionOptions} [options] Conversion options
       * @returns {Object.<string,*>} Plain object
       */
      GetDebugInformationRequest.toObject = function toObject(message, options) {
        if (!options) options = {};
        var object = {};
        if (options.defaults) {
          object.conversationId = '';
          object.debugInformationId = '';
          object.from = null;
          object.to = null;
        }
        if (message.conversationId != null && message.hasOwnProperty('conversationId'))
          object.conversationId = message.conversationId;
        if (message.debugInformationId != null && message.hasOwnProperty('debugInformationId'))
          object.debugInformationId = message.debugInformationId;
        if (message.from != null && message.hasOwnProperty('from'))
          object.from = $root.google.protobuf.UInt32Value.toObject(message.from, options);
        if (message.to != null && message.hasOwnProperty('to'))
          object.to = $root.google.protobuf.UInt32Value.toObject(message.to, options);
        return object;
      };

      /**
       * Converts this GetDebugInformationRequest to JSON.
       * @function toJSON
       * @memberof propel.commrouter.GetDebugInformationRequest
       * @instance
       * @returns {Object.<string,*>} JSON object
       */
      GetDebugInformationRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
      };

      return GetDebugInformationRequest;
    })();

    commrouter.ConversationExecuteCommandRequest = (function () {
      /**
       * Properties of a ConversationExecuteCommandRequest.
       * @memberof propel.commrouter
       * @interface IConversationExecuteCommandRequest
       * @property {string|null} [conversationId] ConversationExecuteCommandRequest conversationId
       * @property {propel.commrouter.IConversationCommand|null} [command] ConversationExecuteCommandRequest command
       */

      /**
       * Constructs a new ConversationExecuteCommandRequest.
       * @memberof propel.commrouter
       * @classdesc Represents a ConversationExecuteCommandRequest.
       * @implements IConversationExecuteCommandRequest
       * @constructor
       * @param {propel.commrouter.IConversationExecuteCommandRequest=} [properties] Properties to set
       */
      function ConversationExecuteCommandRequest(properties) {
        if (properties)
          for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
      }

      /**
       * ConversationExecuteCommandRequest conversationId.
       * @member {string} conversationId
       * @memberof propel.commrouter.ConversationExecuteCommandRequest
       * @instance
       */
      ConversationExecuteCommandRequest.prototype.conversationId = '';

      /**
       * ConversationExecuteCommandRequest command.
       * @member {propel.commrouter.IConversationCommand|null|undefined} command
       * @memberof propel.commrouter.ConversationExecuteCommandRequest
       * @instance
       */
      ConversationExecuteCommandRequest.prototype.command = null;

      /**
       * Creates a new ConversationExecuteCommandRequest instance using the specified properties.
       * @function create
       * @memberof propel.commrouter.ConversationExecuteCommandRequest
       * @static
       * @param {propel.commrouter.IConversationExecuteCommandRequest=} [properties] Properties to set
       * @returns {propel.commrouter.ConversationExecuteCommandRequest} ConversationExecuteCommandRequest instance
       */
      ConversationExecuteCommandRequest.create = function create(properties) {
        return new ConversationExecuteCommandRequest(properties);
      };

      /**
       * Encodes the specified ConversationExecuteCommandRequest message. Does not implicitly {@link propel.commrouter.ConversationExecuteCommandRequest.verify|verify} messages.
       * @function encode
       * @memberof propel.commrouter.ConversationExecuteCommandRequest
       * @static
       * @param {propel.commrouter.IConversationExecuteCommandRequest} message ConversationExecuteCommandRequest message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      ConversationExecuteCommandRequest.encode = function encode(message, writer) {
        if (!writer) writer = $Writer.create();
        if (message.conversationId != null && message.hasOwnProperty('conversationId'))
          writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.conversationId);
        if (message.command != null && message.hasOwnProperty('command'))
          $root.propel.commrouter.ConversationCommand.encode(
            message.command,
            writer.uint32(/* id 2, wireType 2 =*/ 18).fork()
          ).ldelim();
        return writer;
      };

      /**
       * Encodes the specified ConversationExecuteCommandRequest message, length delimited. Does not implicitly {@link propel.commrouter.ConversationExecuteCommandRequest.verify|verify} messages.
       * @function encodeDelimited
       * @memberof propel.commrouter.ConversationExecuteCommandRequest
       * @static
       * @param {propel.commrouter.IConversationExecuteCommandRequest} message ConversationExecuteCommandRequest message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      ConversationExecuteCommandRequest.encodeDelimited = function encodeDelimited(
        message,
        writer
      ) {
        return this.encode(message, writer).ldelim();
      };

      /**
       * Decodes a ConversationExecuteCommandRequest message from the specified reader or buffer.
       * @function decode
       * @memberof propel.commrouter.ConversationExecuteCommandRequest
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @param {number} [length] Message length if known beforehand
       * @returns {propel.commrouter.ConversationExecuteCommandRequest} ConversationExecuteCommandRequest
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      ConversationExecuteCommandRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length,
          message = new $root.propel.commrouter.ConversationExecuteCommandRequest();
        while (reader.pos < end) {
          var tag = reader.uint32();
          switch (tag >>> 3) {
            case 1:
              message.conversationId = reader.string();
              break;
            case 2:
              message.command = $root.propel.commrouter.ConversationCommand.decode(
                reader,
                reader.uint32()
              );
              break;
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };

      /**
       * Decodes a ConversationExecuteCommandRequest message from the specified reader or buffer, length delimited.
       * @function decodeDelimited
       * @memberof propel.commrouter.ConversationExecuteCommandRequest
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @returns {propel.commrouter.ConversationExecuteCommandRequest} ConversationExecuteCommandRequest
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      ConversationExecuteCommandRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader)) reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
      };

      /**
       * Verifies a ConversationExecuteCommandRequest message.
       * @function verify
       * @memberof propel.commrouter.ConversationExecuteCommandRequest
       * @static
       * @param {Object.<string,*>} message Plain object to verify
       * @returns {string|null} `null` if valid, otherwise the reason why it is not
       */
      ConversationExecuteCommandRequest.verify = function verify(message) {
        if (typeof message !== 'object' || message === null) return 'object expected';
        if (message.conversationId != null && message.hasOwnProperty('conversationId'))
          if (!$util.isString(message.conversationId)) return 'conversationId: string expected';
        if (message.command != null && message.hasOwnProperty('command')) {
          var error = $root.propel.commrouter.ConversationCommand.verify(message.command);
          if (error) return 'command.' + error;
        }
        return null;
      };

      /**
       * Creates a ConversationExecuteCommandRequest message from a plain object. Also converts values to their respective internal types.
       * @function fromObject
       * @memberof propel.commrouter.ConversationExecuteCommandRequest
       * @static
       * @param {Object.<string,*>} object Plain object
       * @returns {propel.commrouter.ConversationExecuteCommandRequest} ConversationExecuteCommandRequest
       */
      ConversationExecuteCommandRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.propel.commrouter.ConversationExecuteCommandRequest)
          return object;
        var message = new $root.propel.commrouter.ConversationExecuteCommandRequest();
        if (object.conversationId != null) message.conversationId = String(object.conversationId);
        if (object.command != null) {
          if (typeof object.command !== 'object')
            throw TypeError(
              '.propel.commrouter.ConversationExecuteCommandRequest.command: object expected'
            );
          message.command = $root.propel.commrouter.ConversationCommand.fromObject(object.command);
        }
        return message;
      };

      /**
       * Creates a plain object from a ConversationExecuteCommandRequest message. Also converts values to other types if specified.
       * @function toObject
       * @memberof propel.commrouter.ConversationExecuteCommandRequest
       * @static
       * @param {propel.commrouter.ConversationExecuteCommandRequest} message ConversationExecuteCommandRequest
       * @param {$protobuf.IConversionOptions} [options] Conversion options
       * @returns {Object.<string,*>} Plain object
       */
      ConversationExecuteCommandRequest.toObject = function toObject(message, options) {
        if (!options) options = {};
        var object = {};
        if (options.defaults) {
          object.conversationId = '';
          object.command = null;
        }
        if (message.conversationId != null && message.hasOwnProperty('conversationId'))
          object.conversationId = message.conversationId;
        if (message.command != null && message.hasOwnProperty('command'))
          object.command = $root.propel.commrouter.ConversationCommand.toObject(
            message.command,
            options
          );
        return object;
      };

      /**
       * Converts this ConversationExecuteCommandRequest to JSON.
       * @function toJSON
       * @memberof propel.commrouter.ConversationExecuteCommandRequest
       * @instance
       * @returns {Object.<string,*>} JSON object
       */
      ConversationExecuteCommandRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
      };

      return ConversationExecuteCommandRequest;
    })();

    commrouter.AuthenticateAvatarRequest = (function () {
      /**
       * Properties of an AuthenticateAvatarRequest.
       * @memberof propel.commrouter
       * @interface IAuthenticateAvatarRequest
       * @property {string|null} [conversationId] AuthenticateAvatarRequest conversationId
       * @property {propel.commrouter.IVendorId|null} [avatarId] AuthenticateAvatarRequest avatarId
       * @property {string|null} [name] AuthenticateAvatarRequest name
       * @property {propel.commrouter.Avatar.Type|null} [avatarType] AuthenticateAvatarRequest avatarType
       * @property {google.protobuf.IStruct|null} [meta] AuthenticateAvatarRequest meta
       */

      /**
       * Constructs a new AuthenticateAvatarRequest.
       * @memberof propel.commrouter
       * @classdesc Represents an AuthenticateAvatarRequest.
       * @implements IAuthenticateAvatarRequest
       * @constructor
       * @param {propel.commrouter.IAuthenticateAvatarRequest=} [properties] Properties to set
       */
      function AuthenticateAvatarRequest(properties) {
        if (properties)
          for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
      }

      /**
       * AuthenticateAvatarRequest conversationId.
       * @member {string} conversationId
       * @memberof propel.commrouter.AuthenticateAvatarRequest
       * @instance
       */
      AuthenticateAvatarRequest.prototype.conversationId = '';

      /**
       * AuthenticateAvatarRequest avatarId.
       * @member {propel.commrouter.IVendorId|null|undefined} avatarId
       * @memberof propel.commrouter.AuthenticateAvatarRequest
       * @instance
       */
      AuthenticateAvatarRequest.prototype.avatarId = null;

      /**
       * AuthenticateAvatarRequest name.
       * @member {string} name
       * @memberof propel.commrouter.AuthenticateAvatarRequest
       * @instance
       */
      AuthenticateAvatarRequest.prototype.name = '';

      /**
       * AuthenticateAvatarRequest avatarType.
       * @member {propel.commrouter.Avatar.Type} avatarType
       * @memberof propel.commrouter.AuthenticateAvatarRequest
       * @instance
       */
      AuthenticateAvatarRequest.prototype.avatarType = 0;

      /**
       * AuthenticateAvatarRequest meta.
       * @member {google.protobuf.IStruct|null|undefined} meta
       * @memberof propel.commrouter.AuthenticateAvatarRequest
       * @instance
       */
      AuthenticateAvatarRequest.prototype.meta = null;

      /**
       * Creates a new AuthenticateAvatarRequest instance using the specified properties.
       * @function create
       * @memberof propel.commrouter.AuthenticateAvatarRequest
       * @static
       * @param {propel.commrouter.IAuthenticateAvatarRequest=} [properties] Properties to set
       * @returns {propel.commrouter.AuthenticateAvatarRequest} AuthenticateAvatarRequest instance
       */
      AuthenticateAvatarRequest.create = function create(properties) {
        return new AuthenticateAvatarRequest(properties);
      };

      /**
       * Encodes the specified AuthenticateAvatarRequest message. Does not implicitly {@link propel.commrouter.AuthenticateAvatarRequest.verify|verify} messages.
       * @function encode
       * @memberof propel.commrouter.AuthenticateAvatarRequest
       * @static
       * @param {propel.commrouter.IAuthenticateAvatarRequest} message AuthenticateAvatarRequest message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      AuthenticateAvatarRequest.encode = function encode(message, writer) {
        if (!writer) writer = $Writer.create();
        if (message.conversationId != null && message.hasOwnProperty('conversationId'))
          writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.conversationId);
        if (message.avatarId != null && message.hasOwnProperty('avatarId'))
          $root.propel.commrouter.VendorId.encode(
            message.avatarId,
            writer.uint32(/* id 2, wireType 2 =*/ 18).fork()
          ).ldelim();
        if (message.name != null && message.hasOwnProperty('name'))
          writer.uint32(/* id 3, wireType 2 =*/ 26).string(message.name);
        if (message.avatarType != null && message.hasOwnProperty('avatarType'))
          writer.uint32(/* id 4, wireType 0 =*/ 32).int32(message.avatarType);
        if (message.meta != null && message.hasOwnProperty('meta'))
          $root.google.protobuf.Struct.encode(
            message.meta,
            writer.uint32(/* id 5, wireType 2 =*/ 42).fork()
          ).ldelim();
        return writer;
      };

      /**
       * Encodes the specified AuthenticateAvatarRequest message, length delimited. Does not implicitly {@link propel.commrouter.AuthenticateAvatarRequest.verify|verify} messages.
       * @function encodeDelimited
       * @memberof propel.commrouter.AuthenticateAvatarRequest
       * @static
       * @param {propel.commrouter.IAuthenticateAvatarRequest} message AuthenticateAvatarRequest message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      AuthenticateAvatarRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
      };

      /**
       * Decodes an AuthenticateAvatarRequest message from the specified reader or buffer.
       * @function decode
       * @memberof propel.commrouter.AuthenticateAvatarRequest
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @param {number} [length] Message length if known beforehand
       * @returns {propel.commrouter.AuthenticateAvatarRequest} AuthenticateAvatarRequest
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      AuthenticateAvatarRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length,
          message = new $root.propel.commrouter.AuthenticateAvatarRequest();
        while (reader.pos < end) {
          var tag = reader.uint32();
          switch (tag >>> 3) {
            case 1:
              message.conversationId = reader.string();
              break;
            case 2:
              message.avatarId = $root.propel.commrouter.VendorId.decode(reader, reader.uint32());
              break;
            case 3:
              message.name = reader.string();
              break;
            case 4:
              message.avatarType = reader.int32();
              break;
            case 5:
              message.meta = $root.google.protobuf.Struct.decode(reader, reader.uint32());
              break;
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };

      /**
       * Decodes an AuthenticateAvatarRequest message from the specified reader or buffer, length delimited.
       * @function decodeDelimited
       * @memberof propel.commrouter.AuthenticateAvatarRequest
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @returns {propel.commrouter.AuthenticateAvatarRequest} AuthenticateAvatarRequest
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      AuthenticateAvatarRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader)) reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
      };

      /**
       * Verifies an AuthenticateAvatarRequest message.
       * @function verify
       * @memberof propel.commrouter.AuthenticateAvatarRequest
       * @static
       * @param {Object.<string,*>} message Plain object to verify
       * @returns {string|null} `null` if valid, otherwise the reason why it is not
       */
      AuthenticateAvatarRequest.verify = function verify(message) {
        if (typeof message !== 'object' || message === null) return 'object expected';
        if (message.conversationId != null && message.hasOwnProperty('conversationId'))
          if (!$util.isString(message.conversationId)) return 'conversationId: string expected';
        if (message.avatarId != null && message.hasOwnProperty('avatarId')) {
          var error = $root.propel.commrouter.VendorId.verify(message.avatarId);
          if (error) return 'avatarId.' + error;
        }
        if (message.name != null && message.hasOwnProperty('name'))
          if (!$util.isString(message.name)) return 'name: string expected';
        if (message.avatarType != null && message.hasOwnProperty('avatarType'))
          switch (message.avatarType) {
            default:
              return 'avatarType: enum value expected';
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
              break;
          }
        if (message.meta != null && message.hasOwnProperty('meta')) {
          var error = $root.google.protobuf.Struct.verify(message.meta);
          if (error) return 'meta.' + error;
        }
        return null;
      };

      /**
       * Creates an AuthenticateAvatarRequest message from a plain object. Also converts values to their respective internal types.
       * @function fromObject
       * @memberof propel.commrouter.AuthenticateAvatarRequest
       * @static
       * @param {Object.<string,*>} object Plain object
       * @returns {propel.commrouter.AuthenticateAvatarRequest} AuthenticateAvatarRequest
       */
      AuthenticateAvatarRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.propel.commrouter.AuthenticateAvatarRequest) return object;
        var message = new $root.propel.commrouter.AuthenticateAvatarRequest();
        if (object.conversationId != null) message.conversationId = String(object.conversationId);
        if (object.avatarId != null) {
          if (typeof object.avatarId !== 'object')
            throw TypeError(
              '.propel.commrouter.AuthenticateAvatarRequest.avatarId: object expected'
            );
          message.avatarId = $root.propel.commrouter.VendorId.fromObject(object.avatarId);
        }
        if (object.name != null) message.name = String(object.name);
        switch (object.avatarType) {
          case 'AVATAR_UNKNOWN':
          case 0:
            message.avatarType = 0;
            break;
          case 'AVATAR_CUSTOMER':
          case 1:
            message.avatarType = 1;
            break;
          case 'AVATAR_AI':
          case 2:
            message.avatarType = 2;
            break;
          case 'AVATAR_SUPPORT':
          case 3:
            message.avatarType = 3;
            break;
          case 'AVATAR_VIEWER':
          case 4:
            message.avatarType = 4;
            break;
        }
        if (object.meta != null) {
          if (typeof object.meta !== 'object')
            throw TypeError('.propel.commrouter.AuthenticateAvatarRequest.meta: object expected');
          message.meta = $root.google.protobuf.Struct.fromObject(object.meta);
        }
        return message;
      };

      /**
       * Creates a plain object from an AuthenticateAvatarRequest message. Also converts values to other types if specified.
       * @function toObject
       * @memberof propel.commrouter.AuthenticateAvatarRequest
       * @static
       * @param {propel.commrouter.AuthenticateAvatarRequest} message AuthenticateAvatarRequest
       * @param {$protobuf.IConversionOptions} [options] Conversion options
       * @returns {Object.<string,*>} Plain object
       */
      AuthenticateAvatarRequest.toObject = function toObject(message, options) {
        if (!options) options = {};
        var object = {};
        if (options.defaults) {
          object.conversationId = '';
          object.avatarId = null;
          object.name = '';
          object.avatarType = options.enums === String ? 'AVATAR_UNKNOWN' : 0;
          object.meta = null;
        }
        if (message.conversationId != null && message.hasOwnProperty('conversationId'))
          object.conversationId = message.conversationId;
        if (message.avatarId != null && message.hasOwnProperty('avatarId'))
          object.avatarId = $root.propel.commrouter.VendorId.toObject(message.avatarId, options);
        if (message.name != null && message.hasOwnProperty('name')) object.name = message.name;
        if (message.avatarType != null && message.hasOwnProperty('avatarType'))
          object.avatarType =
            options.enums === String
              ? $root.propel.commrouter.Avatar.Type[message.avatarType]
              : message.avatarType;
        if (message.meta != null && message.hasOwnProperty('meta'))
          object.meta = $root.google.protobuf.Struct.toObject(message.meta, options);
        return object;
      };

      /**
       * Converts this AuthenticateAvatarRequest to JSON.
       * @function toJSON
       * @memberof propel.commrouter.AuthenticateAvatarRequest
       * @instance
       * @returns {Object.<string,*>} JSON object
       */
      AuthenticateAvatarRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
      };

      return AuthenticateAvatarRequest;
    })();

    commrouter.CreateConversationEventPollRequest = (function () {
      /**
       * Properties of a CreateConversationEventPollRequest.
       * @memberof propel.commrouter
       * @interface ICreateConversationEventPollRequest
       * @property {string|null} [conversationId] CreateConversationEventPollRequest conversationId
       * @property {boolean|null} [queueInitial] CreateConversationEventPollRequest queueInitial
       * @property {Array.<string>|null} [events] CreateConversationEventPollRequest events
       */

      /**
       * Constructs a new CreateConversationEventPollRequest.
       * @memberof propel.commrouter
       * @classdesc Represents a CreateConversationEventPollRequest.
       * @implements ICreateConversationEventPollRequest
       * @constructor
       * @param {propel.commrouter.ICreateConversationEventPollRequest=} [properties] Properties to set
       */
      function CreateConversationEventPollRequest(properties) {
        this.events = [];
        if (properties)
          for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
      }

      /**
       * CreateConversationEventPollRequest conversationId.
       * @member {string} conversationId
       * @memberof propel.commrouter.CreateConversationEventPollRequest
       * @instance
       */
      CreateConversationEventPollRequest.prototype.conversationId = '';

      /**
       * CreateConversationEventPollRequest queueInitial.
       * @member {boolean} queueInitial
       * @memberof propel.commrouter.CreateConversationEventPollRequest
       * @instance
       */
      CreateConversationEventPollRequest.prototype.queueInitial = false;

      /**
       * CreateConversationEventPollRequest events.
       * @member {Array.<string>} events
       * @memberof propel.commrouter.CreateConversationEventPollRequest
       * @instance
       */
      CreateConversationEventPollRequest.prototype.events = $util.emptyArray;

      /**
       * Creates a new CreateConversationEventPollRequest instance using the specified properties.
       * @function create
       * @memberof propel.commrouter.CreateConversationEventPollRequest
       * @static
       * @param {propel.commrouter.ICreateConversationEventPollRequest=} [properties] Properties to set
       * @returns {propel.commrouter.CreateConversationEventPollRequest} CreateConversationEventPollRequest instance
       */
      CreateConversationEventPollRequest.create = function create(properties) {
        return new CreateConversationEventPollRequest(properties);
      };

      /**
       * Encodes the specified CreateConversationEventPollRequest message. Does not implicitly {@link propel.commrouter.CreateConversationEventPollRequest.verify|verify} messages.
       * @function encode
       * @memberof propel.commrouter.CreateConversationEventPollRequest
       * @static
       * @param {propel.commrouter.ICreateConversationEventPollRequest} message CreateConversationEventPollRequest message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      CreateConversationEventPollRequest.encode = function encode(message, writer) {
        if (!writer) writer = $Writer.create();
        if (message.conversationId != null && message.hasOwnProperty('conversationId'))
          writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.conversationId);
        if (message.queueInitial != null && message.hasOwnProperty('queueInitial'))
          writer.uint32(/* id 2, wireType 0 =*/ 16).bool(message.queueInitial);
        if (message.events != null && message.events.length)
          for (var i = 0; i < message.events.length; ++i)
            writer.uint32(/* id 3, wireType 2 =*/ 26).string(message.events[i]);
        return writer;
      };

      /**
       * Encodes the specified CreateConversationEventPollRequest message, length delimited. Does not implicitly {@link propel.commrouter.CreateConversationEventPollRequest.verify|verify} messages.
       * @function encodeDelimited
       * @memberof propel.commrouter.CreateConversationEventPollRequest
       * @static
       * @param {propel.commrouter.ICreateConversationEventPollRequest} message CreateConversationEventPollRequest message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      CreateConversationEventPollRequest.encodeDelimited = function encodeDelimited(
        message,
        writer
      ) {
        return this.encode(message, writer).ldelim();
      };

      /**
       * Decodes a CreateConversationEventPollRequest message from the specified reader or buffer.
       * @function decode
       * @memberof propel.commrouter.CreateConversationEventPollRequest
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @param {number} [length] Message length if known beforehand
       * @returns {propel.commrouter.CreateConversationEventPollRequest} CreateConversationEventPollRequest
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      CreateConversationEventPollRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length,
          message = new $root.propel.commrouter.CreateConversationEventPollRequest();
        while (reader.pos < end) {
          var tag = reader.uint32();
          switch (tag >>> 3) {
            case 1:
              message.conversationId = reader.string();
              break;
            case 2:
              message.queueInitial = reader.bool();
              break;
            case 3:
              if (!(message.events && message.events.length)) message.events = [];
              message.events.push(reader.string());
              break;
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };

      /**
       * Decodes a CreateConversationEventPollRequest message from the specified reader or buffer, length delimited.
       * @function decodeDelimited
       * @memberof propel.commrouter.CreateConversationEventPollRequest
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @returns {propel.commrouter.CreateConversationEventPollRequest} CreateConversationEventPollRequest
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      CreateConversationEventPollRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader)) reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
      };

      /**
       * Verifies a CreateConversationEventPollRequest message.
       * @function verify
       * @memberof propel.commrouter.CreateConversationEventPollRequest
       * @static
       * @param {Object.<string,*>} message Plain object to verify
       * @returns {string|null} `null` if valid, otherwise the reason why it is not
       */
      CreateConversationEventPollRequest.verify = function verify(message) {
        if (typeof message !== 'object' || message === null) return 'object expected';
        if (message.conversationId != null && message.hasOwnProperty('conversationId'))
          if (!$util.isString(message.conversationId)) return 'conversationId: string expected';
        if (message.queueInitial != null && message.hasOwnProperty('queueInitial'))
          if (typeof message.queueInitial !== 'boolean') return 'queueInitial: boolean expected';
        if (message.events != null && message.hasOwnProperty('events')) {
          if (!Array.isArray(message.events)) return 'events: array expected';
          for (var i = 0; i < message.events.length; ++i)
            if (!$util.isString(message.events[i])) return 'events: string[] expected';
        }
        return null;
      };

      /**
       * Creates a CreateConversationEventPollRequest message from a plain object. Also converts values to their respective internal types.
       * @function fromObject
       * @memberof propel.commrouter.CreateConversationEventPollRequest
       * @static
       * @param {Object.<string,*>} object Plain object
       * @returns {propel.commrouter.CreateConversationEventPollRequest} CreateConversationEventPollRequest
       */
      CreateConversationEventPollRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.propel.commrouter.CreateConversationEventPollRequest)
          return object;
        var message = new $root.propel.commrouter.CreateConversationEventPollRequest();
        if (object.conversationId != null) message.conversationId = String(object.conversationId);
        if (object.queueInitial != null) message.queueInitial = Boolean(object.queueInitial);
        if (object.events) {
          if (!Array.isArray(object.events))
            throw TypeError(
              '.propel.commrouter.CreateConversationEventPollRequest.events: array expected'
            );
          message.events = [];
          for (var i = 0; i < object.events.length; ++i)
            message.events[i] = String(object.events[i]);
        }
        return message;
      };

      /**
       * Creates a plain object from a CreateConversationEventPollRequest message. Also converts values to other types if specified.
       * @function toObject
       * @memberof propel.commrouter.CreateConversationEventPollRequest
       * @static
       * @param {propel.commrouter.CreateConversationEventPollRequest} message CreateConversationEventPollRequest
       * @param {$protobuf.IConversionOptions} [options] Conversion options
       * @returns {Object.<string,*>} Plain object
       */
      CreateConversationEventPollRequest.toObject = function toObject(message, options) {
        if (!options) options = {};
        var object = {};
        if (options.arrays || options.defaults) object.events = [];
        if (options.defaults) {
          object.conversationId = '';
          object.queueInitial = false;
        }
        if (message.conversationId != null && message.hasOwnProperty('conversationId'))
          object.conversationId = message.conversationId;
        if (message.queueInitial != null && message.hasOwnProperty('queueInitial'))
          object.queueInitial = message.queueInitial;
        if (message.events && message.events.length) {
          object.events = [];
          for (var j = 0; j < message.events.length; ++j) object.events[j] = message.events[j];
        }
        return object;
      };

      /**
       * Converts this CreateConversationEventPollRequest to JSON.
       * @function toJSON
       * @memberof propel.commrouter.CreateConversationEventPollRequest
       * @instance
       * @returns {Object.<string,*>} JSON object
       */
      CreateConversationEventPollRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
      };

      return CreateConversationEventPollRequest;
    })();

    commrouter.PcommRouter = (function () {
      /**
       * Constructs a new PcommRouter service.
       * @memberof propel.commrouter
       * @classdesc Represents a PcommRouter
       * @extends $protobuf.rpc.Service
       * @constructor
       * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
       * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
       * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
       */
      function PcommRouter(rpcImpl, requestDelimited, responseDelimited) {
        $protobuf.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
      }

      (PcommRouter.prototype = Object.create($protobuf.rpc.Service.prototype)).constructor =
        PcommRouter;

      /**
       * Creates new PcommRouter service using the specified rpc implementation.
       * @function create
       * @memberof propel.commrouter.PcommRouter
       * @static
       * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
       * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
       * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
       * @returns {PcommRouter} RPC service. Useful where requests and/or responses are streamed.
       */
      PcommRouter.create = function create(rpcImpl, requestDelimited, responseDelimited) {
        return new this(rpcImpl, requestDelimited, responseDelimited);
      };

      /**
       * Callback as used by {@link propel.commrouter.PcommRouter#createConversation}.
       * @memberof propel.commrouter.PcommRouter
       * @typedef CreateConversationCallback
       * @type {function}
       * @param {Error|null} error Error, if any
       * @param {propel.commrouter.Conversation} [response] Conversation
       */

      /**
       * Calls CreateConversation.
       * @function createConversation
       * @memberof propel.commrouter.PcommRouter
       * @instance
       * @param {propel.commrouter.ICreateConversationRequest} request CreateConversationRequest message or plain object
       * @param {propel.commrouter.PcommRouter.CreateConversationCallback} callback Node-style callback called with the error, if any, and Conversation
       * @returns {undefined}
       * @variation 1
       */
      Object.defineProperty(
        (PcommRouter.prototype.createConversation = function createConversation(request, callback) {
          return this.rpcCall(
            createConversation,
            $root.propel.commrouter.CreateConversationRequest,
            $root.propel.commrouter.Conversation,
            request,
            callback
          );
        }),
        'name',
        { value: 'CreateConversation' }
      );

      /**
       * Calls CreateConversation.
       * @function createConversation
       * @memberof propel.commrouter.PcommRouter
       * @instance
       * @param {propel.commrouter.ICreateConversationRequest} request CreateConversationRequest message or plain object
       * @returns {Promise<propel.commrouter.Conversation>} Promise
       * @variation 2
       */

      /**
       * Callback as used by {@link propel.commrouter.PcommRouter#getConversation}.
       * @memberof propel.commrouter.PcommRouter
       * @typedef GetConversationCallback
       * @type {function}
       * @param {Error|null} error Error, if any
       * @param {propel.commrouter.Conversation} [response] Conversation
       */

      /**
       * Calls GetConversation.
       * @function getConversation
       * @memberof propel.commrouter.PcommRouter
       * @instance
       * @param {propel.commrouter.IGetConversationRequest} request GetConversationRequest message or plain object
       * @param {propel.commrouter.PcommRouter.GetConversationCallback} callback Node-style callback called with the error, if any, and Conversation
       * @returns {undefined}
       * @variation 1
       */
      Object.defineProperty(
        (PcommRouter.prototype.getConversation = function getConversation(request, callback) {
          return this.rpcCall(
            getConversation,
            $root.propel.commrouter.GetConversationRequest,
            $root.propel.commrouter.Conversation,
            request,
            callback
          );
        }),
        'name',
        { value: 'GetConversation' }
      );

      /**
       * Calls GetConversation.
       * @function getConversation
       * @memberof propel.commrouter.PcommRouter
       * @instance
       * @param {propel.commrouter.IGetConversationRequest} request GetConversationRequest message or plain object
       * @returns {Promise<propel.commrouter.Conversation>} Promise
       * @variation 2
       */

      /**
       * Callback as used by {@link propel.commrouter.PcommRouter#getConversationState}.
       * @memberof propel.commrouter.PcommRouter
       * @typedef GetConversationStateCallback
       * @type {function}
       * @param {Error|null} error Error, if any
       * @param {propel.commrouter.ConversationState} [response] ConversationState
       */

      /**
       * Calls GetConversationState.
       * @function getConversationState
       * @memberof propel.commrouter.PcommRouter
       * @instance
       * @param {propel.commrouter.IGetConversationStateRequest} request GetConversationStateRequest message or plain object
       * @param {propel.commrouter.PcommRouter.GetConversationStateCallback} callback Node-style callback called with the error, if any, and ConversationState
       * @returns {undefined}
       * @variation 1
       */
      Object.defineProperty(
        (PcommRouter.prototype.getConversationState = function getConversationState(
          request,
          callback
        ) {
          return this.rpcCall(
            getConversationState,
            $root.propel.commrouter.GetConversationStateRequest,
            $root.propel.commrouter.ConversationState,
            request,
            callback
          );
        }),
        'name',
        { value: 'GetConversationState' }
      );

      /**
       * Calls GetConversationState.
       * @function getConversationState
       * @memberof propel.commrouter.PcommRouter
       * @instance
       * @param {propel.commrouter.IGetConversationStateRequest} request GetConversationStateRequest message or plain object
       * @returns {Promise<propel.commrouter.ConversationState>} Promise
       * @variation 2
       */

      /**
       * Callback as used by {@link propel.commrouter.PcommRouter#putConversationState}.
       * @memberof propel.commrouter.PcommRouter
       * @typedef PutConversationStateCallback
       * @type {function}
       * @param {Error|null} error Error, if any
       * @param {propel.commrouter.ConversationState} [response] ConversationState
       */

      /**
       * Calls PutConversationState.
       * @function putConversationState
       * @memberof propel.commrouter.PcommRouter
       * @instance
       * @param {propel.commrouter.IPutConversationStateRequest} request PutConversationStateRequest message or plain object
       * @param {propel.commrouter.PcommRouter.PutConversationStateCallback} callback Node-style callback called with the error, if any, and ConversationState
       * @returns {undefined}
       * @variation 1
       */
      Object.defineProperty(
        (PcommRouter.prototype.putConversationState = function putConversationState(
          request,
          callback
        ) {
          return this.rpcCall(
            putConversationState,
            $root.propel.commrouter.PutConversationStateRequest,
            $root.propel.commrouter.ConversationState,
            request,
            callback
          );
        }),
        'name',
        { value: 'PutConversationState' }
      );

      /**
       * Calls PutConversationState.
       * @function putConversationState
       * @memberof propel.commrouter.PcommRouter
       * @instance
       * @param {propel.commrouter.IPutConversationStateRequest} request PutConversationStateRequest message or plain object
       * @returns {Promise<propel.commrouter.ConversationState>} Promise
       * @variation 2
       */

      /**
       * Callback as used by {@link propel.commrouter.PcommRouter#updateSentence}.
       * @memberof propel.commrouter.PcommRouter
       * @typedef UpdateSentenceCallback
       * @type {function}
       * @param {Error|null} error Error, if any
       * @param {propel.commrouter.Sentence} [response] Sentence
       */

      /**
       * Calls UpdateSentence.
       * @function updateSentence
       * @memberof propel.commrouter.PcommRouter
       * @instance
       * @param {propel.commrouter.IUpdateSentenceRequest} request UpdateSentenceRequest message or plain object
       * @param {propel.commrouter.PcommRouter.UpdateSentenceCallback} callback Node-style callback called with the error, if any, and Sentence
       * @returns {undefined}
       * @variation 1
       */
      Object.defineProperty(
        (PcommRouter.prototype.updateSentence = function updateSentence(request, callback) {
          return this.rpcCall(
            updateSentence,
            $root.propel.commrouter.UpdateSentenceRequest,
            $root.propel.commrouter.Sentence,
            request,
            callback
          );
        }),
        'name',
        { value: 'UpdateSentence' }
      );

      /**
       * Calls UpdateSentence.
       * @function updateSentence
       * @memberof propel.commrouter.PcommRouter
       * @instance
       * @param {propel.commrouter.IUpdateSentenceRequest} request UpdateSentenceRequest message or plain object
       * @returns {Promise<propel.commrouter.Sentence>} Promise
       * @variation 2
       */

      /**
       * Callback as used by {@link propel.commrouter.PcommRouter#getContext}.
       * @memberof propel.commrouter.PcommRouter
       * @typedef GetContextCallback
       * @type {function}
       * @param {Error|null} error Error, if any
       * @param {propel.commrouter.Context} [response] Context
       */

      /**
       * Calls GetContext.
       * @function getContext
       * @memberof propel.commrouter.PcommRouter
       * @instance
       * @param {propel.commrouter.IGetContextRequest} request GetContextRequest message or plain object
       * @param {propel.commrouter.PcommRouter.GetContextCallback} callback Node-style callback called with the error, if any, and Context
       * @returns {undefined}
       * @variation 1
       */
      Object.defineProperty(
        (PcommRouter.prototype.getContext = function getContext(request, callback) {
          return this.rpcCall(
            getContext,
            $root.propel.commrouter.GetContextRequest,
            $root.propel.commrouter.Context,
            request,
            callback
          );
        }),
        'name',
        { value: 'GetContext' }
      );

      /**
       * Calls GetContext.
       * @function getContext
       * @memberof propel.commrouter.PcommRouter
       * @instance
       * @param {propel.commrouter.IGetContextRequest} request GetContextRequest message or plain object
       * @returns {Promise<propel.commrouter.Context>} Promise
       * @variation 2
       */

      /**
       * Callback as used by {@link propel.commrouter.PcommRouter#putContext}.
       * @memberof propel.commrouter.PcommRouter
       * @typedef PutContextCallback
       * @type {function}
       * @param {Error|null} error Error, if any
       * @param {propel.commrouter.Context} [response] Context
       */

      /**
       * Calls PutContext.
       * @function putContext
       * @memberof propel.commrouter.PcommRouter
       * @instance
       * @param {propel.commrouter.IPutContextRequest} request PutContextRequest message or plain object
       * @param {propel.commrouter.PcommRouter.PutContextCallback} callback Node-style callback called with the error, if any, and Context
       * @returns {undefined}
       * @variation 1
       */
      Object.defineProperty(
        (PcommRouter.prototype.putContext = function putContext(request, callback) {
          return this.rpcCall(
            putContext,
            $root.propel.commrouter.PutContextRequest,
            $root.propel.commrouter.Context,
            request,
            callback
          );
        }),
        'name',
        { value: 'PutContext' }
      );

      /**
       * Calls PutContext.
       * @function putContext
       * @memberof propel.commrouter.PcommRouter
       * @instance
       * @param {propel.commrouter.IPutContextRequest} request PutContextRequest message or plain object
       * @returns {Promise<propel.commrouter.Context>} Promise
       * @variation 2
       */

      /**
       * Callback as used by {@link propel.commrouter.PcommRouter#getDebugInformation}.
       * @memberof propel.commrouter.PcommRouter
       * @typedef GetDebugInformationCallback
       * @type {function}
       * @param {Error|null} error Error, if any
       * @param {propel.commrouter.DebugInformation} [response] DebugInformation
       */

      /**
       * Calls GetDebugInformation.
       * @function getDebugInformation
       * @memberof propel.commrouter.PcommRouter
       * @instance
       * @param {propel.commrouter.IGetDebugInformationRequest} request GetDebugInformationRequest message or plain object
       * @param {propel.commrouter.PcommRouter.GetDebugInformationCallback} callback Node-style callback called with the error, if any, and DebugInformation
       * @returns {undefined}
       * @variation 1
       */
      Object.defineProperty(
        (PcommRouter.prototype.getDebugInformation = function getDebugInformation(
          request,
          callback
        ) {
          return this.rpcCall(
            getDebugInformation,
            $root.propel.commrouter.GetDebugInformationRequest,
            $root.propel.commrouter.DebugInformation,
            request,
            callback
          );
        }),
        'name',
        { value: 'GetDebugInformation' }
      );

      /**
       * Calls GetDebugInformation.
       * @function getDebugInformation
       * @memberof propel.commrouter.PcommRouter
       * @instance
       * @param {propel.commrouter.IGetDebugInformationRequest} request GetDebugInformationRequest message or plain object
       * @returns {Promise<propel.commrouter.DebugInformation>} Promise
       * @variation 2
       */

      /**
       * Callback as used by {@link propel.commrouter.PcommRouter#createResponse}.
       * @memberof propel.commrouter.PcommRouter
       * @typedef CreateResponseCallback
       * @type {function}
       * @param {Error|null} error Error, if any
       * @param {propel.commrouter.Response} [response] Response
       */

      /**
       * Calls CreateResponse.
       * @function createResponse
       * @memberof propel.commrouter.PcommRouter
       * @instance
       * @param {propel.commrouter.ICreateResponseRequest} request CreateResponseRequest message or plain object
       * @param {propel.commrouter.PcommRouter.CreateResponseCallback} callback Node-style callback called with the error, if any, and Response
       * @returns {undefined}
       * @variation 1
       */
      Object.defineProperty(
        (PcommRouter.prototype.createResponse = function createResponse(request, callback) {
          return this.rpcCall(
            createResponse,
            $root.propel.commrouter.CreateResponseRequest,
            $root.propel.commrouter.Response,
            request,
            callback
          );
        }),
        'name',
        { value: 'CreateResponse' }
      );

      /**
       * Calls CreateResponse.
       * @function createResponse
       * @memberof propel.commrouter.PcommRouter
       * @instance
       * @param {propel.commrouter.ICreateResponseRequest} request CreateResponseRequest message or plain object
       * @returns {Promise<propel.commrouter.Response>} Promise
       * @variation 2
       */

      /**
       * Callback as used by {@link propel.commrouter.PcommRouter#createResponseMessage}.
       * @memberof propel.commrouter.PcommRouter
       * @typedef CreateResponseMessageCallback
       * @type {function}
       * @param {Error|null} error Error, if any
       * @param {propel.commrouter.Message} [response] Message
       */

      /**
       * Calls CreateResponseMessage.
       * @function createResponseMessage
       * @memberof propel.commrouter.PcommRouter
       * @instance
       * @param {propel.commrouter.ICreateResponseMessageRequest} request CreateResponseMessageRequest message or plain object
       * @param {propel.commrouter.PcommRouter.CreateResponseMessageCallback} callback Node-style callback called with the error, if any, and Message
       * @returns {undefined}
       * @variation 1
       */
      Object.defineProperty(
        (PcommRouter.prototype.createResponseMessage = function createResponseMessage(
          request,
          callback
        ) {
          return this.rpcCall(
            createResponseMessage,
            $root.propel.commrouter.CreateResponseMessageRequest,
            $root.propel.commrouter.Message,
            request,
            callback
          );
        }),
        'name',
        { value: 'CreateResponseMessage' }
      );

      /**
       * Calls CreateResponseMessage.
       * @function createResponseMessage
       * @memberof propel.commrouter.PcommRouter
       * @instance
       * @param {propel.commrouter.ICreateResponseMessageRequest} request CreateResponseMessageRequest message or plain object
       * @returns {Promise<propel.commrouter.Message>} Promise
       * @variation 2
       */

      /**
       * Callback as used by {@link propel.commrouter.PcommRouter#createIncomingLead}.
       * @memberof propel.commrouter.PcommRouter
       * @typedef CreateIncomingLeadCallback
       * @type {function}
       * @param {Error|null} error Error, if any
       * @param {propel.commrouter.IncomingLeadRef} [response] IncomingLeadRef
       */

      /**
       * Calls CreateIncomingLead.
       * @function createIncomingLead
       * @memberof propel.commrouter.PcommRouter
       * @instance
       * @param {propel.commrouter.ICreateIncomingLeadRequest} request CreateIncomingLeadRequest message or plain object
       * @param {propel.commrouter.PcommRouter.CreateIncomingLeadCallback} callback Node-style callback called with the error, if any, and IncomingLeadRef
       * @returns {undefined}
       * @variation 1
       */
      Object.defineProperty(
        (PcommRouter.prototype.createIncomingLead = function createIncomingLead(request, callback) {
          return this.rpcCall(
            createIncomingLead,
            $root.propel.commrouter.CreateIncomingLeadRequest,
            $root.propel.commrouter.IncomingLeadRef,
            request,
            callback
          );
        }),
        'name',
        { value: 'CreateIncomingLead' }
      );

      /**
       * Calls CreateIncomingLead.
       * @function createIncomingLead
       * @memberof propel.commrouter.PcommRouter
       * @instance
       * @param {propel.commrouter.ICreateIncomingLeadRequest} request CreateIncomingLeadRequest message or plain object
       * @returns {Promise<propel.commrouter.IncomingLeadRef>} Promise
       * @variation 2
       */

      /**
       * Callback as used by {@link propel.commrouter.PcommRouter#getIntroduction}.
       * @memberof propel.commrouter.PcommRouter
       * @typedef GetIntroductionCallback
       * @type {function}
       * @param {Error|null} error Error, if any
       * @param {propel.commrouter.Introduction} [response] Introduction
       */

      /**
       * Calls GetIntroduction.
       * @function getIntroduction
       * @memberof propel.commrouter.PcommRouter
       * @instance
       * @param {propel.commrouter.IGetIntroductionRequest} request GetIntroductionRequest message or plain object
       * @param {propel.commrouter.PcommRouter.GetIntroductionCallback} callback Node-style callback called with the error, if any, and Introduction
       * @returns {undefined}
       * @variation 1
       */
      Object.defineProperty(
        (PcommRouter.prototype.getIntroduction = function getIntroduction(request, callback) {
          return this.rpcCall(
            getIntroduction,
            $root.propel.commrouter.GetIntroductionRequest,
            $root.propel.commrouter.Introduction,
            request,
            callback
          );
        }),
        'name',
        { value: 'GetIntroduction' }
      );

      /**
       * Calls GetIntroduction.
       * @function getIntroduction
       * @memberof propel.commrouter.PcommRouter
       * @instance
       * @param {propel.commrouter.IGetIntroductionRequest} request GetIntroductionRequest message or plain object
       * @returns {Promise<propel.commrouter.Introduction>} Promise
       * @variation 2
       */

      /**
       * Callback as used by {@link propel.commrouter.PcommRouter#getVendorInfo}.
       * @memberof propel.commrouter.PcommRouter
       * @typedef GetVendorInfoCallback
       * @type {function}
       * @param {Error|null} error Error, if any
       * @param {google.protobuf.Struct} [response] Struct
       */

      /**
       * Calls GetVendorInfo.
       * @function getVendorInfo
       * @memberof propel.commrouter.PcommRouter
       * @instance
       * @param {propel.commrouter.IGetVendorInfoRequest} request GetVendorInfoRequest message or plain object
       * @param {propel.commrouter.PcommRouter.GetVendorInfoCallback} callback Node-style callback called with the error, if any, and Struct
       * @returns {undefined}
       * @variation 1
       */
      Object.defineProperty(
        (PcommRouter.prototype.getVendorInfo = function getVendorInfo(request, callback) {
          return this.rpcCall(
            getVendorInfo,
            $root.propel.commrouter.GetVendorInfoRequest,
            $root.google.protobuf.Struct,
            request,
            callback
          );
        }),
        'name',
        { value: 'GetVendorInfo' }
      );

      /**
       * Calls GetVendorInfo.
       * @function getVendorInfo
       * @memberof propel.commrouter.PcommRouter
       * @instance
       * @param {propel.commrouter.IGetVendorInfoRequest} request GetVendorInfoRequest message or plain object
       * @returns {Promise<google.protobuf.Struct>} Promise
       * @variation 2
       */

      /**
       * Callback as used by {@link propel.commrouter.PcommRouter#putVendorInfo}.
       * @memberof propel.commrouter.PcommRouter
       * @typedef PutVendorInfoCallback
       * @type {function}
       * @param {Error|null} error Error, if any
       * @param {google.protobuf.Struct} [response] Struct
       */

      /**
       * Calls PutVendorInfo.
       * @function putVendorInfo
       * @memberof propel.commrouter.PcommRouter
       * @instance
       * @param {propel.commrouter.IPutVendorInfoRequest} request PutVendorInfoRequest message or plain object
       * @param {propel.commrouter.PcommRouter.PutVendorInfoCallback} callback Node-style callback called with the error, if any, and Struct
       * @returns {undefined}
       * @variation 1
       */
      Object.defineProperty(
        (PcommRouter.prototype.putVendorInfo = function putVendorInfo(request, callback) {
          return this.rpcCall(
            putVendorInfo,
            $root.propel.commrouter.PutVendorInfoRequest,
            $root.google.protobuf.Struct,
            request,
            callback
          );
        }),
        'name',
        { value: 'PutVendorInfo' }
      );

      /**
       * Calls PutVendorInfo.
       * @function putVendorInfo
       * @memberof propel.commrouter.PcommRouter
       * @instance
       * @param {propel.commrouter.IPutVendorInfoRequest} request PutVendorInfoRequest message or plain object
       * @returns {Promise<google.protobuf.Struct>} Promise
       * @variation 2
       */

      /**
       * Callback as used by {@link propel.commrouter.PcommRouter#createConversationEventPoll}.
       * @memberof propel.commrouter.PcommRouter
       * @typedef CreateConversationEventPollCallback
       * @type {function}
       * @param {Error|null} error Error, if any
       * @param {propel.commrouter.ConversationEventPoll} [response] ConversationEventPoll
       */

      /**
       * Calls CreateConversationEventPoll.
       * @function createConversationEventPoll
       * @memberof propel.commrouter.PcommRouter
       * @instance
       * @param {propel.commrouter.ICreateConversationEventPollRequest} request CreateConversationEventPollRequest message or plain object
       * @param {propel.commrouter.PcommRouter.CreateConversationEventPollCallback} callback Node-style callback called with the error, if any, and ConversationEventPoll
       * @returns {undefined}
       * @variation 1
       */
      Object.defineProperty(
        (PcommRouter.prototype.createConversationEventPoll = function createConversationEventPoll(
          request,
          callback
        ) {
          return this.rpcCall(
            createConversationEventPoll,
            $root.propel.commrouter.CreateConversationEventPollRequest,
            $root.propel.commrouter.ConversationEventPoll,
            request,
            callback
          );
        }),
        'name',
        { value: 'CreateConversationEventPoll' }
      );

      /**
       * Calls CreateConversationEventPoll.
       * @function createConversationEventPoll
       * @memberof propel.commrouter.PcommRouter
       * @instance
       * @param {propel.commrouter.ICreateConversationEventPollRequest} request CreateConversationEventPollRequest message or plain object
       * @returns {Promise<propel.commrouter.ConversationEventPoll>} Promise
       * @variation 2
       */

      /**
       * Callback as used by {@link propel.commrouter.PcommRouter#listConversationEventPollEvents}.
       * @memberof propel.commrouter.PcommRouter
       * @typedef ListConversationEventPollEventsCallback
       * @type {function}
       * @param {Error|null} error Error, if any
       * @param {propel.commrouter.ConversationEvent} [response] ConversationEvent
       */

      /**
       * Calls ListConversationEventPollEvents.
       * @function listConversationEventPollEvents
       * @memberof propel.commrouter.PcommRouter
       * @instance
       * @param {propel.commrouter.IListConversationEventPollEventsRequest} request ListConversationEventPollEventsRequest message or plain object
       * @param {propel.commrouter.PcommRouter.ListConversationEventPollEventsCallback} callback Node-style callback called with the error, if any, and ConversationEvent
       * @returns {undefined}
       * @variation 1
       */
      Object.defineProperty(
        (PcommRouter.prototype.listConversationEventPollEvents =
          function listConversationEventPollEvents(request, callback) {
            return this.rpcCall(
              listConversationEventPollEvents,
              $root.propel.commrouter.ListConversationEventPollEventsRequest,
              $root.propel.commrouter.ConversationEvent,
              request,
              callback
            );
          }),
        'name',
        { value: 'ListConversationEventPollEvents' }
      );

      /**
       * Calls ListConversationEventPollEvents.
       * @function listConversationEventPollEvents
       * @memberof propel.commrouter.PcommRouter
       * @instance
       * @param {propel.commrouter.IListConversationEventPollEventsRequest} request ListConversationEventPollEventsRequest message or plain object
       * @returns {Promise<propel.commrouter.ConversationEvent>} Promise
       * @variation 2
       */

      /**
       * Callback as used by {@link propel.commrouter.PcommRouter#conversationExecuteCommand}.
       * @memberof propel.commrouter.PcommRouter
       * @typedef ConversationExecuteCommandCallback
       * @type {function}
       * @param {Error|null} error Error, if any
       * @param {google.protobuf.Empty} [response] Empty
       */

      /**
       * Calls ConversationExecuteCommand.
       * @function conversationExecuteCommand
       * @memberof propel.commrouter.PcommRouter
       * @instance
       * @param {propel.commrouter.IConversationExecuteCommandRequest} request ConversationExecuteCommandRequest message or plain object
       * @param {propel.commrouter.PcommRouter.ConversationExecuteCommandCallback} callback Node-style callback called with the error, if any, and Empty
       * @returns {undefined}
       * @variation 1
       */
      Object.defineProperty(
        (PcommRouter.prototype.conversationExecuteCommand = function conversationExecuteCommand(
          request,
          callback
        ) {
          return this.rpcCall(
            conversationExecuteCommand,
            $root.propel.commrouter.ConversationExecuteCommandRequest,
            $root.google.protobuf.Empty,
            request,
            callback
          );
        }),
        'name',
        { value: 'ConversationExecuteCommand' }
      );

      /**
       * Calls ConversationExecuteCommand.
       * @function conversationExecuteCommand
       * @memberof propel.commrouter.PcommRouter
       * @instance
       * @param {propel.commrouter.IConversationExecuteCommandRequest} request ConversationExecuteCommandRequest message or plain object
       * @returns {Promise<google.protobuf.Empty>} Promise
       * @variation 2
       */

      /**
       * Callback as used by {@link propel.commrouter.PcommRouter#executeVendorCommand}.
       * @memberof propel.commrouter.PcommRouter
       * @typedef ExecuteVendorCommandCallback
       * @type {function}
       * @param {Error|null} error Error, if any
       * @param {google.protobuf.Struct} [response] Struct
       */

      /**
       * Calls ExecuteVendorCommand.
       * @function executeVendorCommand
       * @memberof propel.commrouter.PcommRouter
       * @instance
       * @param {propel.commrouter.IExecuteVendorCommandRequest} request ExecuteVendorCommandRequest message or plain object
       * @param {propel.commrouter.PcommRouter.ExecuteVendorCommandCallback} callback Node-style callback called with the error, if any, and Struct
       * @returns {undefined}
       * @variation 1
       */
      Object.defineProperty(
        (PcommRouter.prototype.executeVendorCommand = function executeVendorCommand(
          request,
          callback
        ) {
          return this.rpcCall(
            executeVendorCommand,
            $root.propel.commrouter.ExecuteVendorCommandRequest,
            $root.google.protobuf.Struct,
            request,
            callback
          );
        }),
        'name',
        { value: 'ExecuteVendorCommand' }
      );

      /**
       * Calls ExecuteVendorCommand.
       * @function executeVendorCommand
       * @memberof propel.commrouter.PcommRouter
       * @instance
       * @param {propel.commrouter.IExecuteVendorCommandRequest} request ExecuteVendorCommandRequest message or plain object
       * @returns {Promise<google.protobuf.Struct>} Promise
       * @variation 2
       */

      /**
       * Callback as used by {@link propel.commrouter.PcommRouter#authenticateAvatar}.
       * @memberof propel.commrouter.PcommRouter
       * @typedef AuthenticateAvatarCallback
       * @type {function}
       * @param {Error|null} error Error, if any
       * @param {propel.commrouter.AccessToken} [response] AccessToken
       */

      /**
       * Calls AuthenticateAvatar.
       * @function authenticateAvatar
       * @memberof propel.commrouter.PcommRouter
       * @instance
       * @param {propel.commrouter.IAuthenticateAvatarRequest} request AuthenticateAvatarRequest message or plain object
       * @param {propel.commrouter.PcommRouter.AuthenticateAvatarCallback} callback Node-style callback called with the error, if any, and AccessToken
       * @returns {undefined}
       * @variation 1
       */
      Object.defineProperty(
        (PcommRouter.prototype.authenticateAvatar = function authenticateAvatar(request, callback) {
          return this.rpcCall(
            authenticateAvatar,
            $root.propel.commrouter.AuthenticateAvatarRequest,
            $root.propel.commrouter.AccessToken,
            request,
            callback
          );
        }),
        'name',
        { value: 'AuthenticateAvatar' }
      );

      /**
       * Calls AuthenticateAvatar.
       * @function authenticateAvatar
       * @memberof propel.commrouter.PcommRouter
       * @instance
       * @param {propel.commrouter.IAuthenticateAvatarRequest} request AuthenticateAvatarRequest message or plain object
       * @returns {Promise<propel.commrouter.AccessToken>} Promise
       * @variation 2
       */

      return PcommRouter;
    })();

    return commrouter;
  })();

  propel.core = (function () {
    /**
     * Namespace core.
     * @memberof propel
     * @namespace
     */
    var core = {};

    core.MessageBody = (function () {
      /**
       * Properties of a MessageBody.
       * @memberof propel.core
       * @interface IMessageBody
       * @property {google.protobuf.IStringValue|null} [text] MessageBody text
       * @property {propel.core.IMessageExtension|null} [extension] MessageBody extension
       * @property {google.protobuf.IStruct|null} [payload] MessageBody payload
       */

      /**
       * Constructs a new MessageBody.
       * @memberof propel.core
       * @classdesc Represents a MessageBody.
       * @implements IMessageBody
       * @constructor
       * @param {propel.core.IMessageBody=} [properties] Properties to set
       */
      function MessageBody(properties) {
        if (properties)
          for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
      }

      /**
       * MessageBody text.
       * @member {google.protobuf.IStringValue|null|undefined} text
       * @memberof propel.core.MessageBody
       * @instance
       */
      MessageBody.prototype.text = null;

      /**
       * MessageBody extension.
       * @member {propel.core.IMessageExtension|null|undefined} extension
       * @memberof propel.core.MessageBody
       * @instance
       */
      MessageBody.prototype.extension = null;

      /**
       * MessageBody payload.
       * @member {google.protobuf.IStruct|null|undefined} payload
       * @memberof propel.core.MessageBody
       * @instance
       */
      MessageBody.prototype.payload = null;

      /**
       * Creates a new MessageBody instance using the specified properties.
       * @function create
       * @memberof propel.core.MessageBody
       * @static
       * @param {propel.core.IMessageBody=} [properties] Properties to set
       * @returns {propel.core.MessageBody} MessageBody instance
       */
      MessageBody.create = function create(properties) {
        return new MessageBody(properties);
      };

      /**
       * Encodes the specified MessageBody message. Does not implicitly {@link propel.core.MessageBody.verify|verify} messages.
       * @function encode
       * @memberof propel.core.MessageBody
       * @static
       * @param {propel.core.IMessageBody} message MessageBody message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      MessageBody.encode = function encode(message, writer) {
        if (!writer) writer = $Writer.create();
        if (message.text != null && message.hasOwnProperty('text'))
          $root.google.protobuf.StringValue.encode(
            message.text,
            writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
          ).ldelim();
        if (message.extension != null && message.hasOwnProperty('extension'))
          $root.propel.core.MessageExtension.encode(
            message.extension,
            writer.uint32(/* id 2, wireType 2 =*/ 18).fork()
          ).ldelim();
        if (message.payload != null && message.hasOwnProperty('payload'))
          $root.google.protobuf.Struct.encode(
            message.payload,
            writer.uint32(/* id 3, wireType 2 =*/ 26).fork()
          ).ldelim();
        return writer;
      };

      /**
       * Encodes the specified MessageBody message, length delimited. Does not implicitly {@link propel.core.MessageBody.verify|verify} messages.
       * @function encodeDelimited
       * @memberof propel.core.MessageBody
       * @static
       * @param {propel.core.IMessageBody} message MessageBody message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      MessageBody.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
      };

      /**
       * Decodes a MessageBody message from the specified reader or buffer.
       * @function decode
       * @memberof propel.core.MessageBody
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @param {number} [length] Message length if known beforehand
       * @returns {propel.core.MessageBody} MessageBody
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      MessageBody.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length,
          message = new $root.propel.core.MessageBody();
        while (reader.pos < end) {
          var tag = reader.uint32();
          switch (tag >>> 3) {
            case 1:
              message.text = $root.google.protobuf.StringValue.decode(reader, reader.uint32());
              break;
            case 2:
              message.extension = $root.propel.core.MessageExtension.decode(
                reader,
                reader.uint32()
              );
              break;
            case 3:
              message.payload = $root.google.protobuf.Struct.decode(reader, reader.uint32());
              break;
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };

      /**
       * Decodes a MessageBody message from the specified reader or buffer, length delimited.
       * @function decodeDelimited
       * @memberof propel.core.MessageBody
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @returns {propel.core.MessageBody} MessageBody
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      MessageBody.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader)) reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
      };

      /**
       * Verifies a MessageBody message.
       * @function verify
       * @memberof propel.core.MessageBody
       * @static
       * @param {Object.<string,*>} message Plain object to verify
       * @returns {string|null} `null` if valid, otherwise the reason why it is not
       */
      MessageBody.verify = function verify(message) {
        if (typeof message !== 'object' || message === null) return 'object expected';
        if (message.text != null && message.hasOwnProperty('text')) {
          var error = $root.google.protobuf.StringValue.verify(message.text);
          if (error) return 'text.' + error;
        }
        if (message.extension != null && message.hasOwnProperty('extension')) {
          var error = $root.propel.core.MessageExtension.verify(message.extension);
          if (error) return 'extension.' + error;
        }
        if (message.payload != null && message.hasOwnProperty('payload')) {
          var error = $root.google.protobuf.Struct.verify(message.payload);
          if (error) return 'payload.' + error;
        }
        return null;
      };

      /**
       * Creates a MessageBody message from a plain object. Also converts values to their respective internal types.
       * @function fromObject
       * @memberof propel.core.MessageBody
       * @static
       * @param {Object.<string,*>} object Plain object
       * @returns {propel.core.MessageBody} MessageBody
       */
      MessageBody.fromObject = function fromObject(object) {
        if (object instanceof $root.propel.core.MessageBody) return object;
        var message = new $root.propel.core.MessageBody();
        if (object.text != null) {
          if (typeof object.text !== 'object')
            throw TypeError('.propel.core.MessageBody.text: object expected');
          message.text = $root.google.protobuf.StringValue.fromObject(object.text);
        }
        if (object.extension != null) {
          if (typeof object.extension !== 'object')
            throw TypeError('.propel.core.MessageBody.extension: object expected');
          message.extension = $root.propel.core.MessageExtension.fromObject(object.extension);
        }
        if (object.payload != null) {
          if (typeof object.payload !== 'object')
            throw TypeError('.propel.core.MessageBody.payload: object expected');
          message.payload = $root.google.protobuf.Struct.fromObject(object.payload);
        }
        return message;
      };

      /**
       * Creates a plain object from a MessageBody message. Also converts values to other types if specified.
       * @function toObject
       * @memberof propel.core.MessageBody
       * @static
       * @param {propel.core.MessageBody} message MessageBody
       * @param {$protobuf.IConversionOptions} [options] Conversion options
       * @returns {Object.<string,*>} Plain object
       */
      MessageBody.toObject = function toObject(message, options) {
        if (!options) options = {};
        var object = {};
        if (options.defaults) {
          object.text = null;
          object.extension = null;
          object.payload = null;
        }
        if (message.text != null && message.hasOwnProperty('text'))
          object.text = $root.google.protobuf.StringValue.toObject(message.text, options);
        if (message.extension != null && message.hasOwnProperty('extension'))
          object.extension = $root.propel.core.MessageExtension.toObject(
            message.extension,
            options
          );
        if (message.payload != null && message.hasOwnProperty('payload'))
          object.payload = $root.google.protobuf.Struct.toObject(message.payload, options);
        return object;
      };

      /**
       * Converts this MessageBody to JSON.
       * @function toJSON
       * @memberof propel.core.MessageBody
       * @instance
       * @returns {Object.<string,*>} JSON object
       */
      MessageBody.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
      };

      return MessageBody;
    })();

    core.MessageBodies = (function () {
      /**
       * Properties of a MessageBodies.
       * @memberof propel.core
       * @interface IMessageBodies
       * @property {Array.<propel.core.IMessageBody>|null} [list] MessageBodies list
       */

      /**
       * Constructs a new MessageBodies.
       * @memberof propel.core
       * @classdesc Represents a MessageBodies.
       * @implements IMessageBodies
       * @constructor
       * @param {propel.core.IMessageBodies=} [properties] Properties to set
       */
      function MessageBodies(properties) {
        this.list = [];
        if (properties)
          for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
      }

      /**
       * MessageBodies list.
       * @member {Array.<propel.core.IMessageBody>} list
       * @memberof propel.core.MessageBodies
       * @instance
       */
      MessageBodies.prototype.list = $util.emptyArray;

      /**
       * Creates a new MessageBodies instance using the specified properties.
       * @function create
       * @memberof propel.core.MessageBodies
       * @static
       * @param {propel.core.IMessageBodies=} [properties] Properties to set
       * @returns {propel.core.MessageBodies} MessageBodies instance
       */
      MessageBodies.create = function create(properties) {
        return new MessageBodies(properties);
      };

      /**
       * Encodes the specified MessageBodies message. Does not implicitly {@link propel.core.MessageBodies.verify|verify} messages.
       * @function encode
       * @memberof propel.core.MessageBodies
       * @static
       * @param {propel.core.IMessageBodies} message MessageBodies message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      MessageBodies.encode = function encode(message, writer) {
        if (!writer) writer = $Writer.create();
        if (message.list != null && message.list.length)
          for (var i = 0; i < message.list.length; ++i)
            $root.propel.core.MessageBody.encode(
              message.list[i],
              writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
            ).ldelim();
        return writer;
      };

      /**
       * Encodes the specified MessageBodies message, length delimited. Does not implicitly {@link propel.core.MessageBodies.verify|verify} messages.
       * @function encodeDelimited
       * @memberof propel.core.MessageBodies
       * @static
       * @param {propel.core.IMessageBodies} message MessageBodies message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      MessageBodies.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
      };

      /**
       * Decodes a MessageBodies message from the specified reader or buffer.
       * @function decode
       * @memberof propel.core.MessageBodies
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @param {number} [length] Message length if known beforehand
       * @returns {propel.core.MessageBodies} MessageBodies
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      MessageBodies.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length,
          message = new $root.propel.core.MessageBodies();
        while (reader.pos < end) {
          var tag = reader.uint32();
          switch (tag >>> 3) {
            case 1:
              if (!(message.list && message.list.length)) message.list = [];
              message.list.push($root.propel.core.MessageBody.decode(reader, reader.uint32()));
              break;
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };

      /**
       * Decodes a MessageBodies message from the specified reader or buffer, length delimited.
       * @function decodeDelimited
       * @memberof propel.core.MessageBodies
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @returns {propel.core.MessageBodies} MessageBodies
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      MessageBodies.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader)) reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
      };

      /**
       * Verifies a MessageBodies message.
       * @function verify
       * @memberof propel.core.MessageBodies
       * @static
       * @param {Object.<string,*>} message Plain object to verify
       * @returns {string|null} `null` if valid, otherwise the reason why it is not
       */
      MessageBodies.verify = function verify(message) {
        if (typeof message !== 'object' || message === null) return 'object expected';
        if (message.list != null && message.hasOwnProperty('list')) {
          if (!Array.isArray(message.list)) return 'list: array expected';
          for (var i = 0; i < message.list.length; ++i) {
            var error = $root.propel.core.MessageBody.verify(message.list[i]);
            if (error) return 'list.' + error;
          }
        }
        return null;
      };

      /**
       * Creates a MessageBodies message from a plain object. Also converts values to their respective internal types.
       * @function fromObject
       * @memberof propel.core.MessageBodies
       * @static
       * @param {Object.<string,*>} object Plain object
       * @returns {propel.core.MessageBodies} MessageBodies
       */
      MessageBodies.fromObject = function fromObject(object) {
        if (object instanceof $root.propel.core.MessageBodies) return object;
        var message = new $root.propel.core.MessageBodies();
        if (object.list) {
          if (!Array.isArray(object.list))
            throw TypeError('.propel.core.MessageBodies.list: array expected');
          message.list = [];
          for (var i = 0; i < object.list.length; ++i) {
            if (typeof object.list[i] !== 'object')
              throw TypeError('.propel.core.MessageBodies.list: object expected');
            message.list[i] = $root.propel.core.MessageBody.fromObject(object.list[i]);
          }
        }
        return message;
      };

      /**
       * Creates a plain object from a MessageBodies message. Also converts values to other types if specified.
       * @function toObject
       * @memberof propel.core.MessageBodies
       * @static
       * @param {propel.core.MessageBodies} message MessageBodies
       * @param {$protobuf.IConversionOptions} [options] Conversion options
       * @returns {Object.<string,*>} Plain object
       */
      MessageBodies.toObject = function toObject(message, options) {
        if (!options) options = {};
        var object = {};
        if (options.arrays || options.defaults) object.list = [];
        if (message.list && message.list.length) {
          object.list = [];
          for (var j = 0; j < message.list.length; ++j)
            object.list[j] = $root.propel.core.MessageBody.toObject(message.list[j], options);
        }
        return object;
      };

      /**
       * Converts this MessageBodies to JSON.
       * @function toJSON
       * @memberof propel.core.MessageBodies
       * @instance
       * @returns {Object.<string,*>} JSON object
       */
      MessageBodies.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
      };

      return MessageBodies;
    })();

    core.MessageExtension = (function () {
      /**
       * Properties of a MessageExtension.
       * @memberof propel.core
       * @interface IMessageExtension
       * @property {propel.core.MessageExtension.ICarousel|null} [carousel] MessageExtension carousel
       * @property {propel.core.MessageExtension.IInformation|null} [information] MessageExtension information
       * @property {propel.core.MessageExtension.IQuickReplies|null} [quickReplies] MessageExtension quickReplies
       * @property {propel.core.MessageExtension.IAvatarUpdate|null} [avatarUpdate] MessageExtension avatarUpdate
       * @property {propel.core.IMessageBodies|null} [messageBodies] MessageExtension messageBodies
       * @property {propel.core.MessageExtension.IForm|null} [form] MessageExtension form
       */

      /**
       * Constructs a new MessageExtension.
       * @memberof propel.core
       * @classdesc Represents a MessageExtension.
       * @implements IMessageExtension
       * @constructor
       * @param {propel.core.IMessageExtension=} [properties] Properties to set
       */
      function MessageExtension(properties) {
        if (properties)
          for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
      }

      /**
       * MessageExtension carousel.
       * @member {propel.core.MessageExtension.ICarousel|null|undefined} carousel
       * @memberof propel.core.MessageExtension
       * @instance
       */
      MessageExtension.prototype.carousel = null;

      /**
       * MessageExtension information.
       * @member {propel.core.MessageExtension.IInformation|null|undefined} information
       * @memberof propel.core.MessageExtension
       * @instance
       */
      MessageExtension.prototype.information = null;

      /**
       * MessageExtension quickReplies.
       * @member {propel.core.MessageExtension.IQuickReplies|null|undefined} quickReplies
       * @memberof propel.core.MessageExtension
       * @instance
       */
      MessageExtension.prototype.quickReplies = null;

      /**
       * MessageExtension avatarUpdate.
       * @member {propel.core.MessageExtension.IAvatarUpdate|null|undefined} avatarUpdate
       * @memberof propel.core.MessageExtension
       * @instance
       */
      MessageExtension.prototype.avatarUpdate = null;

      /**
       * MessageExtension messageBodies.
       * @member {propel.core.IMessageBodies|null|undefined} messageBodies
       * @memberof propel.core.MessageExtension
       * @instance
       */
      MessageExtension.prototype.messageBodies = null;

      /**
       * MessageExtension form.
       * @member {propel.core.MessageExtension.IForm|null|undefined} form
       * @memberof propel.core.MessageExtension
       * @instance
       */
      MessageExtension.prototype.form = null;

      // OneOf field names bound to virtual getters and setters
      var $oneOfFields;

      /**
       * MessageExtension value.
       * @member {"carousel"|"information"|"quickReplies"|"avatarUpdate"|"messageBodies"|"form"|undefined} value
       * @memberof propel.core.MessageExtension
       * @instance
       */
      Object.defineProperty(MessageExtension.prototype, 'value', {
        get: $util.oneOfGetter(
          ($oneOfFields = [
            'carousel',
            'information',
            'quickReplies',
            'avatarUpdate',
            'messageBodies',
            'form',
          ])
        ),
        set: $util.oneOfSetter($oneOfFields),
      });

      /**
       * Creates a new MessageExtension instance using the specified properties.
       * @function create
       * @memberof propel.core.MessageExtension
       * @static
       * @param {propel.core.IMessageExtension=} [properties] Properties to set
       * @returns {propel.core.MessageExtension} MessageExtension instance
       */
      MessageExtension.create = function create(properties) {
        return new MessageExtension(properties);
      };

      /**
       * Encodes the specified MessageExtension message. Does not implicitly {@link propel.core.MessageExtension.verify|verify} messages.
       * @function encode
       * @memberof propel.core.MessageExtension
       * @static
       * @param {propel.core.IMessageExtension} message MessageExtension message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      MessageExtension.encode = function encode(message, writer) {
        if (!writer) writer = $Writer.create();
        if (message.carousel != null && message.hasOwnProperty('carousel'))
          $root.propel.core.MessageExtension.Carousel.encode(
            message.carousel,
            writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
          ).ldelim();
        if (message.information != null && message.hasOwnProperty('information'))
          $root.propel.core.MessageExtension.Information.encode(
            message.information,
            writer.uint32(/* id 101, wireType 2 =*/ 810).fork()
          ).ldelim();
        if (message.quickReplies != null && message.hasOwnProperty('quickReplies'))
          $root.propel.core.MessageExtension.QuickReplies.encode(
            message.quickReplies,
            writer.uint32(/* id 102, wireType 2 =*/ 818).fork()
          ).ldelim();
        if (message.messageBodies != null && message.hasOwnProperty('messageBodies'))
          $root.propel.core.MessageBodies.encode(
            message.messageBodies,
            writer.uint32(/* id 103, wireType 2 =*/ 826).fork()
          ).ldelim();
        if (message.avatarUpdate != null && message.hasOwnProperty('avatarUpdate'))
          $root.propel.core.MessageExtension.AvatarUpdate.encode(
            message.avatarUpdate,
            writer.uint32(/* id 104, wireType 2 =*/ 834).fork()
          ).ldelim();
        if (message.form != null && message.hasOwnProperty('form'))
          $root.propel.core.MessageExtension.Form.encode(
            message.form,
            writer.uint32(/* id 105, wireType 2 =*/ 842).fork()
          ).ldelim();
        return writer;
      };

      /**
       * Encodes the specified MessageExtension message, length delimited. Does not implicitly {@link propel.core.MessageExtension.verify|verify} messages.
       * @function encodeDelimited
       * @memberof propel.core.MessageExtension
       * @static
       * @param {propel.core.IMessageExtension} message MessageExtension message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      MessageExtension.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
      };

      /**
       * Decodes a MessageExtension message from the specified reader or buffer.
       * @function decode
       * @memberof propel.core.MessageExtension
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @param {number} [length] Message length if known beforehand
       * @returns {propel.core.MessageExtension} MessageExtension
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      MessageExtension.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length,
          message = new $root.propel.core.MessageExtension();
        while (reader.pos < end) {
          var tag = reader.uint32();
          switch (tag >>> 3) {
            case 100:
              message.carousel = $root.propel.core.MessageExtension.Carousel.decode(
                reader,
                reader.uint32()
              );
              break;
            case 101:
              message.information = $root.propel.core.MessageExtension.Information.decode(
                reader,
                reader.uint32()
              );
              break;
            case 102:
              message.quickReplies = $root.propel.core.MessageExtension.QuickReplies.decode(
                reader,
                reader.uint32()
              );
              break;
            case 104:
              message.avatarUpdate = $root.propel.core.MessageExtension.AvatarUpdate.decode(
                reader,
                reader.uint32()
              );
              break;
            case 103:
              message.messageBodies = $root.propel.core.MessageBodies.decode(
                reader,
                reader.uint32()
              );
              break;
            case 105:
              message.form = $root.propel.core.MessageExtension.Form.decode(
                reader,
                reader.uint32()
              );
              break;
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };

      /**
       * Decodes a MessageExtension message from the specified reader or buffer, length delimited.
       * @function decodeDelimited
       * @memberof propel.core.MessageExtension
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @returns {propel.core.MessageExtension} MessageExtension
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      MessageExtension.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader)) reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
      };

      /**
       * Verifies a MessageExtension message.
       * @function verify
       * @memberof propel.core.MessageExtension
       * @static
       * @param {Object.<string,*>} message Plain object to verify
       * @returns {string|null} `null` if valid, otherwise the reason why it is not
       */
      MessageExtension.verify = function verify(message) {
        if (typeof message !== 'object' || message === null) return 'object expected';
        var properties = {};
        if (message.carousel != null && message.hasOwnProperty('carousel')) {
          properties.value = 1;
          {
            var error = $root.propel.core.MessageExtension.Carousel.verify(message.carousel);
            if (error) return 'carousel.' + error;
          }
        }
        if (message.information != null && message.hasOwnProperty('information')) {
          if (properties.value === 1) return 'value: multiple values';
          properties.value = 1;
          {
            var error = $root.propel.core.MessageExtension.Information.verify(message.information);
            if (error) return 'information.' + error;
          }
        }
        if (message.quickReplies != null && message.hasOwnProperty('quickReplies')) {
          if (properties.value === 1) return 'value: multiple values';
          properties.value = 1;
          {
            var error = $root.propel.core.MessageExtension.QuickReplies.verify(
              message.quickReplies
            );
            if (error) return 'quickReplies.' + error;
          }
        }
        if (message.avatarUpdate != null && message.hasOwnProperty('avatarUpdate')) {
          if (properties.value === 1) return 'value: multiple values';
          properties.value = 1;
          {
            var error = $root.propel.core.MessageExtension.AvatarUpdate.verify(
              message.avatarUpdate
            );
            if (error) return 'avatarUpdate.' + error;
          }
        }
        if (message.messageBodies != null && message.hasOwnProperty('messageBodies')) {
          if (properties.value === 1) return 'value: multiple values';
          properties.value = 1;
          {
            var error = $root.propel.core.MessageBodies.verify(message.messageBodies);
            if (error) return 'messageBodies.' + error;
          }
        }
        if (message.form != null && message.hasOwnProperty('form')) {
          if (properties.value === 1) return 'value: multiple values';
          properties.value = 1;
          {
            var error = $root.propel.core.MessageExtension.Form.verify(message.form);
            if (error) return 'form.' + error;
          }
        }
        return null;
      };

      /**
       * Creates a MessageExtension message from a plain object. Also converts values to their respective internal types.
       * @function fromObject
       * @memberof propel.core.MessageExtension
       * @static
       * @param {Object.<string,*>} object Plain object
       * @returns {propel.core.MessageExtension} MessageExtension
       */
      MessageExtension.fromObject = function fromObject(object) {
        if (object instanceof $root.propel.core.MessageExtension) return object;
        var message = new $root.propel.core.MessageExtension();
        if (object.carousel != null) {
          if (typeof object.carousel !== 'object')
            throw TypeError('.propel.core.MessageExtension.carousel: object expected');
          message.carousel = $root.propel.core.MessageExtension.Carousel.fromObject(
            object.carousel
          );
        }
        if (object.information != null) {
          if (typeof object.information !== 'object')
            throw TypeError('.propel.core.MessageExtension.information: object expected');
          message.information = $root.propel.core.MessageExtension.Information.fromObject(
            object.information
          );
        }
        if (object.quickReplies != null) {
          if (typeof object.quickReplies !== 'object')
            throw TypeError('.propel.core.MessageExtension.quickReplies: object expected');
          message.quickReplies = $root.propel.core.MessageExtension.QuickReplies.fromObject(
            object.quickReplies
          );
        }
        if (object.avatarUpdate != null) {
          if (typeof object.avatarUpdate !== 'object')
            throw TypeError('.propel.core.MessageExtension.avatarUpdate: object expected');
          message.avatarUpdate = $root.propel.core.MessageExtension.AvatarUpdate.fromObject(
            object.avatarUpdate
          );
        }
        if (object.messageBodies != null) {
          if (typeof object.messageBodies !== 'object')
            throw TypeError('.propel.core.MessageExtension.messageBodies: object expected');
          message.messageBodies = $root.propel.core.MessageBodies.fromObject(object.messageBodies);
        }
        if (object.form != null) {
          if (typeof object.form !== 'object')
            throw TypeError('.propel.core.MessageExtension.form: object expected');
          message.form = $root.propel.core.MessageExtension.Form.fromObject(object.form);
        }
        return message;
      };

      /**
       * Creates a plain object from a MessageExtension message. Also converts values to other types if specified.
       * @function toObject
       * @memberof propel.core.MessageExtension
       * @static
       * @param {propel.core.MessageExtension} message MessageExtension
       * @param {$protobuf.IConversionOptions} [options] Conversion options
       * @returns {Object.<string,*>} Plain object
       */
      MessageExtension.toObject = function toObject(message, options) {
        if (!options) options = {};
        var object = {};
        if (message.carousel != null && message.hasOwnProperty('carousel')) {
          object.carousel = $root.propel.core.MessageExtension.Carousel.toObject(
            message.carousel,
            options
          );
          if (options.oneofs) object.value = 'carousel';
        }
        if (message.information != null && message.hasOwnProperty('information')) {
          object.information = $root.propel.core.MessageExtension.Information.toObject(
            message.information,
            options
          );
          if (options.oneofs) object.value = 'information';
        }
        if (message.quickReplies != null && message.hasOwnProperty('quickReplies')) {
          object.quickReplies = $root.propel.core.MessageExtension.QuickReplies.toObject(
            message.quickReplies,
            options
          );
          if (options.oneofs) object.value = 'quickReplies';
        }
        if (message.messageBodies != null && message.hasOwnProperty('messageBodies')) {
          object.messageBodies = $root.propel.core.MessageBodies.toObject(
            message.messageBodies,
            options
          );
          if (options.oneofs) object.value = 'messageBodies';
        }
        if (message.avatarUpdate != null && message.hasOwnProperty('avatarUpdate')) {
          object.avatarUpdate = $root.propel.core.MessageExtension.AvatarUpdate.toObject(
            message.avatarUpdate,
            options
          );
          if (options.oneofs) object.value = 'avatarUpdate';
        }
        if (message.form != null && message.hasOwnProperty('form')) {
          object.form = $root.propel.core.MessageExtension.Form.toObject(message.form, options);
          if (options.oneofs) object.value = 'form';
        }
        return object;
      };

      /**
       * Converts this MessageExtension to JSON.
       * @function toJSON
       * @memberof propel.core.MessageExtension
       * @instance
       * @returns {Object.<string,*>} JSON object
       */
      MessageExtension.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
      };

      MessageExtension.Action = (function () {
        /**
         * Properties of an Action.
         * @memberof propel.core.MessageExtension
         * @interface IAction
         * @property {string|null} [type] Action type
         * @property {string|null} [url] Action url
         */

        /**
         * Constructs a new Action.
         * @memberof propel.core.MessageExtension
         * @classdesc Represents an Action.
         * @implements IAction
         * @constructor
         * @param {propel.core.MessageExtension.IAction=} [properties] Properties to set
         */
        function Action(properties) {
          if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
              if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
        }

        /**
         * Action type.
         * @member {string} type
         * @memberof propel.core.MessageExtension.Action
         * @instance
         */
        Action.prototype.type = '';

        /**
         * Action url.
         * @member {string} url
         * @memberof propel.core.MessageExtension.Action
         * @instance
         */
        Action.prototype.url = '';

        /**
         * Creates a new Action instance using the specified properties.
         * @function create
         * @memberof propel.core.MessageExtension.Action
         * @static
         * @param {propel.core.MessageExtension.IAction=} [properties] Properties to set
         * @returns {propel.core.MessageExtension.Action} Action instance
         */
        Action.create = function create(properties) {
          return new Action(properties);
        };

        /**
         * Encodes the specified Action message. Does not implicitly {@link propel.core.MessageExtension.Action.verify|verify} messages.
         * @function encode
         * @memberof propel.core.MessageExtension.Action
         * @static
         * @param {propel.core.MessageExtension.IAction} message Action message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Action.encode = function encode(message, writer) {
          if (!writer) writer = $Writer.create();
          if (message.type != null && message.hasOwnProperty('type'))
            writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.type);
          if (message.url != null && message.hasOwnProperty('url'))
            writer.uint32(/* id 2, wireType 2 =*/ 18).string(message.url);
          return writer;
        };

        /**
         * Encodes the specified Action message, length delimited. Does not implicitly {@link propel.core.MessageExtension.Action.verify|verify} messages.
         * @function encodeDelimited
         * @memberof propel.core.MessageExtension.Action
         * @static
         * @param {propel.core.MessageExtension.IAction} message Action message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Action.encodeDelimited = function encodeDelimited(message, writer) {
          return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an Action message from the specified reader or buffer.
         * @function decode
         * @memberof propel.core.MessageExtension.Action
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {propel.core.MessageExtension.Action} Action
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Action.decode = function decode(reader, length) {
          if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
          var end = length === undefined ? reader.len : reader.pos + length,
            message = new $root.propel.core.MessageExtension.Action();
          while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
              case 1:
                message.type = reader.string();
                break;
              case 2:
                message.url = reader.string();
                break;
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };

        /**
         * Decodes an Action message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof propel.core.MessageExtension.Action
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {propel.core.MessageExtension.Action} Action
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Action.decodeDelimited = function decodeDelimited(reader) {
          if (!(reader instanceof $Reader)) reader = new $Reader(reader);
          return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an Action message.
         * @function verify
         * @memberof propel.core.MessageExtension.Action
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Action.verify = function verify(message) {
          if (typeof message !== 'object' || message === null) return 'object expected';
          if (message.type != null && message.hasOwnProperty('type'))
            if (!$util.isString(message.type)) return 'type: string expected';
          if (message.url != null && message.hasOwnProperty('url'))
            if (!$util.isString(message.url)) return 'url: string expected';
          return null;
        };

        /**
         * Creates an Action message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof propel.core.MessageExtension.Action
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {propel.core.MessageExtension.Action} Action
         */
        Action.fromObject = function fromObject(object) {
          if (object instanceof $root.propel.core.MessageExtension.Action) return object;
          var message = new $root.propel.core.MessageExtension.Action();
          if (object.type != null) message.type = String(object.type);
          if (object.url != null) message.url = String(object.url);
          return message;
        };

        /**
         * Creates a plain object from an Action message. Also converts values to other types if specified.
         * @function toObject
         * @memberof propel.core.MessageExtension.Action
         * @static
         * @param {propel.core.MessageExtension.Action} message Action
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Action.toObject = function toObject(message, options) {
          if (!options) options = {};
          var object = {};
          if (options.defaults) {
            object.type = '';
            object.url = '';
          }
          if (message.type != null && message.hasOwnProperty('type')) object.type = message.type;
          if (message.url != null && message.hasOwnProperty('url')) object.url = message.url;
          return object;
        };

        /**
         * Converts this Action to JSON.
         * @function toJSON
         * @memberof propel.core.MessageExtension.Action
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Action.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Action;
      })();

      MessageExtension.Button = (function () {
        /**
         * Properties of a Button.
         * @memberof propel.core.MessageExtension
         * @interface IButton
         * @property {string|null} [title] Button title
         * @property {propel.core.MessageExtension.IAction|null} [action] Button action
         */

        /**
         * Constructs a new Button.
         * @memberof propel.core.MessageExtension
         * @classdesc Represents a Button.
         * @implements IButton
         * @constructor
         * @param {propel.core.MessageExtension.IButton=} [properties] Properties to set
         */
        function Button(properties) {
          if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
              if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
        }

        /**
         * Button title.
         * @member {string} title
         * @memberof propel.core.MessageExtension.Button
         * @instance
         */
        Button.prototype.title = '';

        /**
         * Button action.
         * @member {propel.core.MessageExtension.IAction|null|undefined} action
         * @memberof propel.core.MessageExtension.Button
         * @instance
         */
        Button.prototype.action = null;

        /**
         * Creates a new Button instance using the specified properties.
         * @function create
         * @memberof propel.core.MessageExtension.Button
         * @static
         * @param {propel.core.MessageExtension.IButton=} [properties] Properties to set
         * @returns {propel.core.MessageExtension.Button} Button instance
         */
        Button.create = function create(properties) {
          return new Button(properties);
        };

        /**
         * Encodes the specified Button message. Does not implicitly {@link propel.core.MessageExtension.Button.verify|verify} messages.
         * @function encode
         * @memberof propel.core.MessageExtension.Button
         * @static
         * @param {propel.core.MessageExtension.IButton} message Button message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Button.encode = function encode(message, writer) {
          if (!writer) writer = $Writer.create();
          if (message.title != null && message.hasOwnProperty('title'))
            writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.title);
          if (message.action != null && message.hasOwnProperty('action'))
            $root.propel.core.MessageExtension.Action.encode(
              message.action,
              writer.uint32(/* id 2, wireType 2 =*/ 18).fork()
            ).ldelim();
          return writer;
        };

        /**
         * Encodes the specified Button message, length delimited. Does not implicitly {@link propel.core.MessageExtension.Button.verify|verify} messages.
         * @function encodeDelimited
         * @memberof propel.core.MessageExtension.Button
         * @static
         * @param {propel.core.MessageExtension.IButton} message Button message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Button.encodeDelimited = function encodeDelimited(message, writer) {
          return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a Button message from the specified reader or buffer.
         * @function decode
         * @memberof propel.core.MessageExtension.Button
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {propel.core.MessageExtension.Button} Button
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Button.decode = function decode(reader, length) {
          if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
          var end = length === undefined ? reader.len : reader.pos + length,
            message = new $root.propel.core.MessageExtension.Button();
          while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
              case 1:
                message.title = reader.string();
                break;
              case 2:
                message.action = $root.propel.core.MessageExtension.Action.decode(
                  reader,
                  reader.uint32()
                );
                break;
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };

        /**
         * Decodes a Button message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof propel.core.MessageExtension.Button
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {propel.core.MessageExtension.Button} Button
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Button.decodeDelimited = function decodeDelimited(reader) {
          if (!(reader instanceof $Reader)) reader = new $Reader(reader);
          return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Button message.
         * @function verify
         * @memberof propel.core.MessageExtension.Button
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Button.verify = function verify(message) {
          if (typeof message !== 'object' || message === null) return 'object expected';
          if (message.title != null && message.hasOwnProperty('title'))
            if (!$util.isString(message.title)) return 'title: string expected';
          if (message.action != null && message.hasOwnProperty('action')) {
            var error = $root.propel.core.MessageExtension.Action.verify(message.action);
            if (error) return 'action.' + error;
          }
          return null;
        };

        /**
         * Creates a Button message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof propel.core.MessageExtension.Button
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {propel.core.MessageExtension.Button} Button
         */
        Button.fromObject = function fromObject(object) {
          if (object instanceof $root.propel.core.MessageExtension.Button) return object;
          var message = new $root.propel.core.MessageExtension.Button();
          if (object.title != null) message.title = String(object.title);
          if (object.action != null) {
            if (typeof object.action !== 'object')
              throw TypeError('.propel.core.MessageExtension.Button.action: object expected');
            message.action = $root.propel.core.MessageExtension.Action.fromObject(object.action);
          }
          return message;
        };

        /**
         * Creates a plain object from a Button message. Also converts values to other types if specified.
         * @function toObject
         * @memberof propel.core.MessageExtension.Button
         * @static
         * @param {propel.core.MessageExtension.Button} message Button
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Button.toObject = function toObject(message, options) {
          if (!options) options = {};
          var object = {};
          if (options.defaults) {
            object.title = '';
            object.action = null;
          }
          if (message.title != null && message.hasOwnProperty('title'))
            object.title = message.title;
          if (message.action != null && message.hasOwnProperty('action'))
            object.action = $root.propel.core.MessageExtension.Action.toObject(
              message.action,
              options
            );
          return object;
        };

        /**
         * Converts this Button to JSON.
         * @function toJSON
         * @memberof propel.core.MessageExtension.Button
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Button.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Button;
      })();

      MessageExtension.Buttons = (function () {
        /**
         * Properties of a Buttons.
         * @memberof propel.core.MessageExtension
         * @interface IButtons
         * @property {Array.<propel.core.MessageExtension.IButton>|null} [buttons] Buttons buttons
         */

        /**
         * Constructs a new Buttons.
         * @memberof propel.core.MessageExtension
         * @classdesc Represents a Buttons.
         * @implements IButtons
         * @constructor
         * @param {propel.core.MessageExtension.IButtons=} [properties] Properties to set
         */
        function Buttons(properties) {
          this.buttons = [];
          if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
              if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
        }

        /**
         * Buttons buttons.
         * @member {Array.<propel.core.MessageExtension.IButton>} buttons
         * @memberof propel.core.MessageExtension.Buttons
         * @instance
         */
        Buttons.prototype.buttons = $util.emptyArray;

        /**
         * Creates a new Buttons instance using the specified properties.
         * @function create
         * @memberof propel.core.MessageExtension.Buttons
         * @static
         * @param {propel.core.MessageExtension.IButtons=} [properties] Properties to set
         * @returns {propel.core.MessageExtension.Buttons} Buttons instance
         */
        Buttons.create = function create(properties) {
          return new Buttons(properties);
        };

        /**
         * Encodes the specified Buttons message. Does not implicitly {@link propel.core.MessageExtension.Buttons.verify|verify} messages.
         * @function encode
         * @memberof propel.core.MessageExtension.Buttons
         * @static
         * @param {propel.core.MessageExtension.IButtons} message Buttons message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Buttons.encode = function encode(message, writer) {
          if (!writer) writer = $Writer.create();
          if (message.buttons != null && message.buttons.length)
            for (var i = 0; i < message.buttons.length; ++i)
              $root.propel.core.MessageExtension.Button.encode(
                message.buttons[i],
                writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
              ).ldelim();
          return writer;
        };

        /**
         * Encodes the specified Buttons message, length delimited. Does not implicitly {@link propel.core.MessageExtension.Buttons.verify|verify} messages.
         * @function encodeDelimited
         * @memberof propel.core.MessageExtension.Buttons
         * @static
         * @param {propel.core.MessageExtension.IButtons} message Buttons message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Buttons.encodeDelimited = function encodeDelimited(message, writer) {
          return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a Buttons message from the specified reader or buffer.
         * @function decode
         * @memberof propel.core.MessageExtension.Buttons
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {propel.core.MessageExtension.Buttons} Buttons
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Buttons.decode = function decode(reader, length) {
          if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
          var end = length === undefined ? reader.len : reader.pos + length,
            message = new $root.propel.core.MessageExtension.Buttons();
          while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
              case 1:
                if (!(message.buttons && message.buttons.length)) message.buttons = [];
                message.buttons.push(
                  $root.propel.core.MessageExtension.Button.decode(reader, reader.uint32())
                );
                break;
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };

        /**
         * Decodes a Buttons message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof propel.core.MessageExtension.Buttons
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {propel.core.MessageExtension.Buttons} Buttons
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Buttons.decodeDelimited = function decodeDelimited(reader) {
          if (!(reader instanceof $Reader)) reader = new $Reader(reader);
          return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Buttons message.
         * @function verify
         * @memberof propel.core.MessageExtension.Buttons
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Buttons.verify = function verify(message) {
          if (typeof message !== 'object' || message === null) return 'object expected';
          if (message.buttons != null && message.hasOwnProperty('buttons')) {
            if (!Array.isArray(message.buttons)) return 'buttons: array expected';
            for (var i = 0; i < message.buttons.length; ++i) {
              var error = $root.propel.core.MessageExtension.Button.verify(message.buttons[i]);
              if (error) return 'buttons.' + error;
            }
          }
          return null;
        };

        /**
         * Creates a Buttons message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof propel.core.MessageExtension.Buttons
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {propel.core.MessageExtension.Buttons} Buttons
         */
        Buttons.fromObject = function fromObject(object) {
          if (object instanceof $root.propel.core.MessageExtension.Buttons) return object;
          var message = new $root.propel.core.MessageExtension.Buttons();
          if (object.buttons) {
            if (!Array.isArray(object.buttons))
              throw TypeError('.propel.core.MessageExtension.Buttons.buttons: array expected');
            message.buttons = [];
            for (var i = 0; i < object.buttons.length; ++i) {
              if (typeof object.buttons[i] !== 'object')
                throw TypeError('.propel.core.MessageExtension.Buttons.buttons: object expected');
              message.buttons[i] = $root.propel.core.MessageExtension.Button.fromObject(
                object.buttons[i]
              );
            }
          }
          return message;
        };

        /**
         * Creates a plain object from a Buttons message. Also converts values to other types if specified.
         * @function toObject
         * @memberof propel.core.MessageExtension.Buttons
         * @static
         * @param {propel.core.MessageExtension.Buttons} message Buttons
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Buttons.toObject = function toObject(message, options) {
          if (!options) options = {};
          var object = {};
          if (options.arrays || options.defaults) object.buttons = [];
          if (message.buttons && message.buttons.length) {
            object.buttons = [];
            for (var j = 0; j < message.buttons.length; ++j)
              object.buttons[j] = $root.propel.core.MessageExtension.Button.toObject(
                message.buttons[j],
                options
              );
          }
          return object;
        };

        /**
         * Converts this Buttons to JSON.
         * @function toJSON
         * @memberof propel.core.MessageExtension.Buttons
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Buttons.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Buttons;
      })();

      MessageExtension.Carousel = (function () {
        /**
         * Properties of a Carousel.
         * @memberof propel.core.MessageExtension
         * @interface ICarousel
         * @property {string|null} [templateType] Carousel templateType
         * @property {Array.<propel.core.MessageExtension.Carousel.IItem>|null} [items] Carousel items
         */

        /**
         * Constructs a new Carousel.
         * @memberof propel.core.MessageExtension
         * @classdesc Represents a Carousel.
         * @implements ICarousel
         * @constructor
         * @param {propel.core.MessageExtension.ICarousel=} [properties] Properties to set
         */
        function Carousel(properties) {
          this.items = [];
          if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
              if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
        }

        /**
         * Carousel templateType.
         * @member {string} templateType
         * @memberof propel.core.MessageExtension.Carousel
         * @instance
         */
        Carousel.prototype.templateType = '';

        /**
         * Carousel items.
         * @member {Array.<propel.core.MessageExtension.Carousel.IItem>} items
         * @memberof propel.core.MessageExtension.Carousel
         * @instance
         */
        Carousel.prototype.items = $util.emptyArray;

        /**
         * Creates a new Carousel instance using the specified properties.
         * @function create
         * @memberof propel.core.MessageExtension.Carousel
         * @static
         * @param {propel.core.MessageExtension.ICarousel=} [properties] Properties to set
         * @returns {propel.core.MessageExtension.Carousel} Carousel instance
         */
        Carousel.create = function create(properties) {
          return new Carousel(properties);
        };

        /**
         * Encodes the specified Carousel message. Does not implicitly {@link propel.core.MessageExtension.Carousel.verify|verify} messages.
         * @function encode
         * @memberof propel.core.MessageExtension.Carousel
         * @static
         * @param {propel.core.MessageExtension.ICarousel} message Carousel message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Carousel.encode = function encode(message, writer) {
          if (!writer) writer = $Writer.create();
          if (message.items != null && message.items.length)
            for (var i = 0; i < message.items.length; ++i)
              $root.propel.core.MessageExtension.Carousel.Item.encode(
                message.items[i],
                writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
              ).ldelim();
          if (message.templateType != null && message.hasOwnProperty('templateType'))
            writer.uint32(/* id 2, wireType 2 =*/ 18).string(message.templateType);
          return writer;
        };

        /**
         * Encodes the specified Carousel message, length delimited. Does not implicitly {@link propel.core.MessageExtension.Carousel.verify|verify} messages.
         * @function encodeDelimited
         * @memberof propel.core.MessageExtension.Carousel
         * @static
         * @param {propel.core.MessageExtension.ICarousel} message Carousel message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Carousel.encodeDelimited = function encodeDelimited(message, writer) {
          return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a Carousel message from the specified reader or buffer.
         * @function decode
         * @memberof propel.core.MessageExtension.Carousel
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {propel.core.MessageExtension.Carousel} Carousel
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Carousel.decode = function decode(reader, length) {
          if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
          var end = length === undefined ? reader.len : reader.pos + length,
            message = new $root.propel.core.MessageExtension.Carousel();
          while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
              case 2:
                message.templateType = reader.string();
                break;
              case 1:
                if (!(message.items && message.items.length)) message.items = [];
                message.items.push(
                  $root.propel.core.MessageExtension.Carousel.Item.decode(reader, reader.uint32())
                );
                break;
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };

        /**
         * Decodes a Carousel message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof propel.core.MessageExtension.Carousel
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {propel.core.MessageExtension.Carousel} Carousel
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Carousel.decodeDelimited = function decodeDelimited(reader) {
          if (!(reader instanceof $Reader)) reader = new $Reader(reader);
          return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Carousel message.
         * @function verify
         * @memberof propel.core.MessageExtension.Carousel
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Carousel.verify = function verify(message) {
          if (typeof message !== 'object' || message === null) return 'object expected';
          if (message.templateType != null && message.hasOwnProperty('templateType'))
            if (!$util.isString(message.templateType)) return 'templateType: string expected';
          if (message.items != null && message.hasOwnProperty('items')) {
            if (!Array.isArray(message.items)) return 'items: array expected';
            for (var i = 0; i < message.items.length; ++i) {
              var error = $root.propel.core.MessageExtension.Carousel.Item.verify(message.items[i]);
              if (error) return 'items.' + error;
            }
          }
          return null;
        };

        /**
         * Creates a Carousel message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof propel.core.MessageExtension.Carousel
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {propel.core.MessageExtension.Carousel} Carousel
         */
        Carousel.fromObject = function fromObject(object) {
          if (object instanceof $root.propel.core.MessageExtension.Carousel) return object;
          var message = new $root.propel.core.MessageExtension.Carousel();
          if (object.templateType != null) message.templateType = String(object.templateType);
          if (object.items) {
            if (!Array.isArray(object.items))
              throw TypeError('.propel.core.MessageExtension.Carousel.items: array expected');
            message.items = [];
            for (var i = 0; i < object.items.length; ++i) {
              if (typeof object.items[i] !== 'object')
                throw TypeError('.propel.core.MessageExtension.Carousel.items: object expected');
              message.items[i] = $root.propel.core.MessageExtension.Carousel.Item.fromObject(
                object.items[i]
              );
            }
          }
          return message;
        };

        /**
         * Creates a plain object from a Carousel message. Also converts values to other types if specified.
         * @function toObject
         * @memberof propel.core.MessageExtension.Carousel
         * @static
         * @param {propel.core.MessageExtension.Carousel} message Carousel
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Carousel.toObject = function toObject(message, options) {
          if (!options) options = {};
          var object = {};
          if (options.arrays || options.defaults) object.items = [];
          if (options.defaults) object.templateType = '';
          if (message.items && message.items.length) {
            object.items = [];
            for (var j = 0; j < message.items.length; ++j)
              object.items[j] = $root.propel.core.MessageExtension.Carousel.Item.toObject(
                message.items[j],
                options
              );
          }
          if (message.templateType != null && message.hasOwnProperty('templateType'))
            object.templateType = message.templateType;
          return object;
        };

        /**
         * Converts this Carousel to JSON.
         * @function toJSON
         * @memberof propel.core.MessageExtension.Carousel
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Carousel.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        Carousel.Item = (function () {
          /**
           * Properties of an Item.
           * @memberof propel.core.MessageExtension.Carousel
           * @interface IItem
           * @property {string|null} [templateType] Item templateType
           * @property {string|null} [title] Item title
           * @property {google.protobuf.IStringValue|null} [subtitle] Item subtitle
           * @property {string|null} [imageUrl] Item imageUrl
           * @property {propel.core.MessageExtension.IAction|null} [action] Item action
           * @property {google.protobuf.IStruct|null} [info] Item info
           * @property {propel.core.MessageExtension.IButtons|null} [buttons] Item buttons
           */

          /**
           * Constructs a new Item.
           * @memberof propel.core.MessageExtension.Carousel
           * @classdesc Represents an Item.
           * @implements IItem
           * @constructor
           * @param {propel.core.MessageExtension.Carousel.IItem=} [properties] Properties to set
           */
          function Item(properties) {
            if (properties)
              for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
          }

          /**
           * Item templateType.
           * @member {string} templateType
           * @memberof propel.core.MessageExtension.Carousel.Item
           * @instance
           */
          Item.prototype.templateType = '';

          /**
           * Item title.
           * @member {string} title
           * @memberof propel.core.MessageExtension.Carousel.Item
           * @instance
           */
          Item.prototype.title = '';

          /**
           * Item subtitle.
           * @member {google.protobuf.IStringValue|null|undefined} subtitle
           * @memberof propel.core.MessageExtension.Carousel.Item
           * @instance
           */
          Item.prototype.subtitle = null;

          /**
           * Item imageUrl.
           * @member {string} imageUrl
           * @memberof propel.core.MessageExtension.Carousel.Item
           * @instance
           */
          Item.prototype.imageUrl = '';

          /**
           * Item action.
           * @member {propel.core.MessageExtension.IAction|null|undefined} action
           * @memberof propel.core.MessageExtension.Carousel.Item
           * @instance
           */
          Item.prototype.action = null;

          /**
           * Item info.
           * @member {google.protobuf.IStruct|null|undefined} info
           * @memberof propel.core.MessageExtension.Carousel.Item
           * @instance
           */
          Item.prototype.info = null;

          /**
           * Item buttons.
           * @member {propel.core.MessageExtension.IButtons|null|undefined} buttons
           * @memberof propel.core.MessageExtension.Carousel.Item
           * @instance
           */
          Item.prototype.buttons = null;

          /**
           * Creates a new Item instance using the specified properties.
           * @function create
           * @memberof propel.core.MessageExtension.Carousel.Item
           * @static
           * @param {propel.core.MessageExtension.Carousel.IItem=} [properties] Properties to set
           * @returns {propel.core.MessageExtension.Carousel.Item} Item instance
           */
          Item.create = function create(properties) {
            return new Item(properties);
          };

          /**
           * Encodes the specified Item message. Does not implicitly {@link propel.core.MessageExtension.Carousel.Item.verify|verify} messages.
           * @function encode
           * @memberof propel.core.MessageExtension.Carousel.Item
           * @static
           * @param {propel.core.MessageExtension.Carousel.IItem} message Item message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          Item.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (message.title != null && message.hasOwnProperty('title'))
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.title);
            if (message.imageUrl != null && message.hasOwnProperty('imageUrl'))
              writer.uint32(/* id 2, wireType 2 =*/ 18).string(message.imageUrl);
            if (message.action != null && message.hasOwnProperty('action'))
              $root.propel.core.MessageExtension.Action.encode(
                message.action,
                writer.uint32(/* id 3, wireType 2 =*/ 26).fork()
              ).ldelim();
            if (message.info != null && message.hasOwnProperty('info'))
              $root.google.protobuf.Struct.encode(
                message.info,
                writer.uint32(/* id 4, wireType 2 =*/ 34).fork()
              ).ldelim();
            if (message.buttons != null && message.hasOwnProperty('buttons'))
              $root.propel.core.MessageExtension.Buttons.encode(
                message.buttons,
                writer.uint32(/* id 5, wireType 2 =*/ 42).fork()
              ).ldelim();
            if (message.subtitle != null && message.hasOwnProperty('subtitle'))
              $root.google.protobuf.StringValue.encode(
                message.subtitle,
                writer.uint32(/* id 6, wireType 2 =*/ 50).fork()
              ).ldelim();
            if (message.templateType != null && message.hasOwnProperty('templateType'))
              writer.uint32(/* id 7, wireType 2 =*/ 58).string(message.templateType);
            return writer;
          };

          /**
           * Encodes the specified Item message, length delimited. Does not implicitly {@link propel.core.MessageExtension.Carousel.Item.verify|verify} messages.
           * @function encodeDelimited
           * @memberof propel.core.MessageExtension.Carousel.Item
           * @static
           * @param {propel.core.MessageExtension.Carousel.IItem} message Item message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          Item.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
          };

          /**
           * Decodes an Item message from the specified reader or buffer.
           * @function decode
           * @memberof propel.core.MessageExtension.Carousel.Item
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {propel.core.MessageExtension.Carousel.Item} Item
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          Item.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message = new $root.propel.core.MessageExtension.Carousel.Item();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 7:
                  message.templateType = reader.string();
                  break;
                case 1:
                  message.title = reader.string();
                  break;
                case 6:
                  message.subtitle = $root.google.protobuf.StringValue.decode(
                    reader,
                    reader.uint32()
                  );
                  break;
                case 2:
                  message.imageUrl = reader.string();
                  break;
                case 3:
                  message.action = $root.propel.core.MessageExtension.Action.decode(
                    reader,
                    reader.uint32()
                  );
                  break;
                case 4:
                  message.info = $root.google.protobuf.Struct.decode(reader, reader.uint32());
                  break;
                case 5:
                  message.buttons = $root.propel.core.MessageExtension.Buttons.decode(
                    reader,
                    reader.uint32()
                  );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Decodes an Item message from the specified reader or buffer, length delimited.
           * @function decodeDelimited
           * @memberof propel.core.MessageExtension.Carousel.Item
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @returns {propel.core.MessageExtension.Carousel.Item} Item
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          Item.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader)) reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
          };

          /**
           * Verifies an Item message.
           * @function verify
           * @memberof propel.core.MessageExtension.Carousel.Item
           * @static
           * @param {Object.<string,*>} message Plain object to verify
           * @returns {string|null} `null` if valid, otherwise the reason why it is not
           */
          Item.verify = function verify(message) {
            if (typeof message !== 'object' || message === null) return 'object expected';
            if (message.templateType != null && message.hasOwnProperty('templateType'))
              if (!$util.isString(message.templateType)) return 'templateType: string expected';
            if (message.title != null && message.hasOwnProperty('title'))
              if (!$util.isString(message.title)) return 'title: string expected';
            if (message.subtitle != null && message.hasOwnProperty('subtitle')) {
              var error = $root.google.protobuf.StringValue.verify(message.subtitle);
              if (error) return 'subtitle.' + error;
            }
            if (message.imageUrl != null && message.hasOwnProperty('imageUrl'))
              if (!$util.isString(message.imageUrl)) return 'imageUrl: string expected';
            if (message.action != null && message.hasOwnProperty('action')) {
              var error = $root.propel.core.MessageExtension.Action.verify(message.action);
              if (error) return 'action.' + error;
            }
            if (message.info != null && message.hasOwnProperty('info')) {
              var error = $root.google.protobuf.Struct.verify(message.info);
              if (error) return 'info.' + error;
            }
            if (message.buttons != null && message.hasOwnProperty('buttons')) {
              var error = $root.propel.core.MessageExtension.Buttons.verify(message.buttons);
              if (error) return 'buttons.' + error;
            }
            return null;
          };

          /**
           * Creates an Item message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof propel.core.MessageExtension.Carousel.Item
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {propel.core.MessageExtension.Carousel.Item} Item
           */
          Item.fromObject = function fromObject(object) {
            if (object instanceof $root.propel.core.MessageExtension.Carousel.Item) return object;
            var message = new $root.propel.core.MessageExtension.Carousel.Item();
            if (object.templateType != null) message.templateType = String(object.templateType);
            if (object.title != null) message.title = String(object.title);
            if (object.subtitle != null) {
              if (typeof object.subtitle !== 'object')
                throw TypeError(
                  '.propel.core.MessageExtension.Carousel.Item.subtitle: object expected'
                );
              message.subtitle = $root.google.protobuf.StringValue.fromObject(object.subtitle);
            }
            if (object.imageUrl != null) message.imageUrl = String(object.imageUrl);
            if (object.action != null) {
              if (typeof object.action !== 'object')
                throw TypeError(
                  '.propel.core.MessageExtension.Carousel.Item.action: object expected'
                );
              message.action = $root.propel.core.MessageExtension.Action.fromObject(object.action);
            }
            if (object.info != null) {
              if (typeof object.info !== 'object')
                throw TypeError(
                  '.propel.core.MessageExtension.Carousel.Item.info: object expected'
                );
              message.info = $root.google.protobuf.Struct.fromObject(object.info);
            }
            if (object.buttons != null) {
              if (typeof object.buttons !== 'object')
                throw TypeError(
                  '.propel.core.MessageExtension.Carousel.Item.buttons: object expected'
                );
              message.buttons = $root.propel.core.MessageExtension.Buttons.fromObject(
                object.buttons
              );
            }
            return message;
          };

          /**
           * Creates a plain object from an Item message. Also converts values to other types if specified.
           * @function toObject
           * @memberof propel.core.MessageExtension.Carousel.Item
           * @static
           * @param {propel.core.MessageExtension.Carousel.Item} message Item
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          Item.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.title = '';
              object.imageUrl = '';
              object.action = null;
              object.info = null;
              object.buttons = null;
              object.subtitle = null;
              object.templateType = '';
            }
            if (message.title != null && message.hasOwnProperty('title'))
              object.title = message.title;
            if (message.imageUrl != null && message.hasOwnProperty('imageUrl'))
              object.imageUrl = message.imageUrl;
            if (message.action != null && message.hasOwnProperty('action'))
              object.action = $root.propel.core.MessageExtension.Action.toObject(
                message.action,
                options
              );
            if (message.info != null && message.hasOwnProperty('info'))
              object.info = $root.google.protobuf.Struct.toObject(message.info, options);
            if (message.buttons != null && message.hasOwnProperty('buttons'))
              object.buttons = $root.propel.core.MessageExtension.Buttons.toObject(
                message.buttons,
                options
              );
            if (message.subtitle != null && message.hasOwnProperty('subtitle'))
              object.subtitle = $root.google.protobuf.StringValue.toObject(
                message.subtitle,
                options
              );
            if (message.templateType != null && message.hasOwnProperty('templateType'))
              object.templateType = message.templateType;
            return object;
          };

          /**
           * Converts this Item to JSON.
           * @function toJSON
           * @memberof propel.core.MessageExtension.Carousel.Item
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          Item.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
          };

          return Item;
        })();

        return Carousel;
      })();

      MessageExtension.Information = (function () {
        /**
         * Properties of an Information.
         * @memberof propel.core.MessageExtension
         * @interface IInformation
         * @property {string|null} [templateType] Information templateType
         * @property {string|null} [title] Information title
         * @property {string|null} [body] Information body
         * @property {propel.core.MessageExtension.IButton|null} [button] Information button
         * @property {string|null} [id] Information id
         * @property {string|null} [imageUrl] Information imageUrl
         */

        /**
         * Constructs a new Information.
         * @memberof propel.core.MessageExtension
         * @classdesc Represents an Information.
         * @implements IInformation
         * @constructor
         * @param {propel.core.MessageExtension.IInformation=} [properties] Properties to set
         */
        function Information(properties) {
          if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
              if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
        }

        /**
         * Information templateType.
         * @member {string} templateType
         * @memberof propel.core.MessageExtension.Information
         * @instance
         */
        Information.prototype.templateType = '';

        /**
         * Information title.
         * @member {string} title
         * @memberof propel.core.MessageExtension.Information
         * @instance
         */
        Information.prototype.title = '';

        /**
         * Information body.
         * @member {string} body
         * @memberof propel.core.MessageExtension.Information
         * @instance
         */
        Information.prototype.body = '';

        /**
         * Information button.
         * @member {propel.core.MessageExtension.IButton|null|undefined} button
         * @memberof propel.core.MessageExtension.Information
         * @instance
         */
        Information.prototype.button = null;

        /**
         * Information id.
         * @member {string} id
         * @memberof propel.core.MessageExtension.Information
         * @instance
         */
        Information.prototype.id = '';

        /**
         * Information imageUrl.
         * @member {string} imageUrl
         * @memberof propel.core.MessageExtension.Information
         * @instance
         */
        Information.prototype.imageUrl = '';

        /**
         * Creates a new Information instance using the specified properties.
         * @function create
         * @memberof propel.core.MessageExtension.Information
         * @static
         * @param {propel.core.MessageExtension.IInformation=} [properties] Properties to set
         * @returns {propel.core.MessageExtension.Information} Information instance
         */
        Information.create = function create(properties) {
          return new Information(properties);
        };

        /**
         * Encodes the specified Information message. Does not implicitly {@link propel.core.MessageExtension.Information.verify|verify} messages.
         * @function encode
         * @memberof propel.core.MessageExtension.Information
         * @static
         * @param {propel.core.MessageExtension.IInformation} message Information message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Information.encode = function encode(message, writer) {
          if (!writer) writer = $Writer.create();
          if (message.title != null && message.hasOwnProperty('title'))
            writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.title);
          if (message.body != null && message.hasOwnProperty('body'))
            writer.uint32(/* id 2, wireType 2 =*/ 18).string(message.body);
          if (message.button != null && message.hasOwnProperty('button'))
            $root.propel.core.MessageExtension.Button.encode(
              message.button,
              writer.uint32(/* id 3, wireType 2 =*/ 26).fork()
            ).ldelim();
          if (message.id != null && message.hasOwnProperty('id'))
            writer.uint32(/* id 4, wireType 2 =*/ 34).string(message.id);
          if (message.templateType != null && message.hasOwnProperty('templateType'))
            writer.uint32(/* id 5, wireType 2 =*/ 42).string(message.templateType);
          if (message.imageUrl != null && message.hasOwnProperty('imageUrl'))
            writer.uint32(/* id 6, wireType 2 =*/ 50).string(message.imageUrl);
          return writer;
        };

        /**
         * Encodes the specified Information message, length delimited. Does not implicitly {@link propel.core.MessageExtension.Information.verify|verify} messages.
         * @function encodeDelimited
         * @memberof propel.core.MessageExtension.Information
         * @static
         * @param {propel.core.MessageExtension.IInformation} message Information message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Information.encodeDelimited = function encodeDelimited(message, writer) {
          return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an Information message from the specified reader or buffer.
         * @function decode
         * @memberof propel.core.MessageExtension.Information
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {propel.core.MessageExtension.Information} Information
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Information.decode = function decode(reader, length) {
          if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
          var end = length === undefined ? reader.len : reader.pos + length,
            message = new $root.propel.core.MessageExtension.Information();
          while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
              case 5:
                message.templateType = reader.string();
                break;
              case 1:
                message.title = reader.string();
                break;
              case 2:
                message.body = reader.string();
                break;
              case 3:
                message.button = $root.propel.core.MessageExtension.Button.decode(
                  reader,
                  reader.uint32()
                );
                break;
              case 4:
                message.id = reader.string();
                break;
              case 6:
                message.imageUrl = reader.string();
                break;
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };

        /**
         * Decodes an Information message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof propel.core.MessageExtension.Information
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {propel.core.MessageExtension.Information} Information
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Information.decodeDelimited = function decodeDelimited(reader) {
          if (!(reader instanceof $Reader)) reader = new $Reader(reader);
          return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an Information message.
         * @function verify
         * @memberof propel.core.MessageExtension.Information
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Information.verify = function verify(message) {
          if (typeof message !== 'object' || message === null) return 'object expected';
          if (message.templateType != null && message.hasOwnProperty('templateType'))
            if (!$util.isString(message.templateType)) return 'templateType: string expected';
          if (message.title != null && message.hasOwnProperty('title'))
            if (!$util.isString(message.title)) return 'title: string expected';
          if (message.body != null && message.hasOwnProperty('body'))
            if (!$util.isString(message.body)) return 'body: string expected';
          if (message.button != null && message.hasOwnProperty('button')) {
            var error = $root.propel.core.MessageExtension.Button.verify(message.button);
            if (error) return 'button.' + error;
          }
          if (message.id != null && message.hasOwnProperty('id'))
            if (!$util.isString(message.id)) return 'id: string expected';
          if (message.imageUrl != null && message.hasOwnProperty('imageUrl'))
            if (!$util.isString(message.imageUrl)) return 'imageUrl: string expected';
          return null;
        };

        /**
         * Creates an Information message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof propel.core.MessageExtension.Information
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {propel.core.MessageExtension.Information} Information
         */
        Information.fromObject = function fromObject(object) {
          if (object instanceof $root.propel.core.MessageExtension.Information) return object;
          var message = new $root.propel.core.MessageExtension.Information();
          if (object.templateType != null) message.templateType = String(object.templateType);
          if (object.title != null) message.title = String(object.title);
          if (object.body != null) message.body = String(object.body);
          if (object.button != null) {
            if (typeof object.button !== 'object')
              throw TypeError('.propel.core.MessageExtension.Information.button: object expected');
            message.button = $root.propel.core.MessageExtension.Button.fromObject(object.button);
          }
          if (object.id != null) message.id = String(object.id);
          if (object.imageUrl != null) message.imageUrl = String(object.imageUrl);
          return message;
        };

        /**
         * Creates a plain object from an Information message. Also converts values to other types if specified.
         * @function toObject
         * @memberof propel.core.MessageExtension.Information
         * @static
         * @param {propel.core.MessageExtension.Information} message Information
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Information.toObject = function toObject(message, options) {
          if (!options) options = {};
          var object = {};
          if (options.defaults) {
            object.title = '';
            object.body = '';
            object.button = null;
            object.id = '';
            object.templateType = '';
            object.imageUrl = '';
          }
          if (message.title != null && message.hasOwnProperty('title'))
            object.title = message.title;
          if (message.body != null && message.hasOwnProperty('body')) object.body = message.body;
          if (message.button != null && message.hasOwnProperty('button'))
            object.button = $root.propel.core.MessageExtension.Button.toObject(
              message.button,
              options
            );
          if (message.id != null && message.hasOwnProperty('id')) object.id = message.id;
          if (message.templateType != null && message.hasOwnProperty('templateType'))
            object.templateType = message.templateType;
          if (message.imageUrl != null && message.hasOwnProperty('imageUrl'))
            object.imageUrl = message.imageUrl;
          return object;
        };

        /**
         * Converts this Information to JSON.
         * @function toJSON
         * @memberof propel.core.MessageExtension.Information
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Information.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Information;
      })();

      MessageExtension.QuickReply = (function () {
        /**
         * Properties of a QuickReply.
         * @memberof propel.core.MessageExtension
         * @interface IQuickReply
         * @property {string|null} [id] QuickReply id
         * @property {string|null} [title] QuickReply title
         * @property {google.protobuf.IStruct|null} [payload] QuickReply payload
         * @property {google.protobuf.IStringValue|null} [imageUrl] QuickReply imageUrl
         */

        /**
         * Constructs a new QuickReply.
         * @memberof propel.core.MessageExtension
         * @classdesc Represents a QuickReply.
         * @implements IQuickReply
         * @constructor
         * @param {propel.core.MessageExtension.IQuickReply=} [properties] Properties to set
         */
        function QuickReply(properties) {
          if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
              if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
        }

        /**
         * QuickReply id.
         * @member {string} id
         * @memberof propel.core.MessageExtension.QuickReply
         * @instance
         */
        QuickReply.prototype.id = '';

        /**
         * QuickReply title.
         * @member {string} title
         * @memberof propel.core.MessageExtension.QuickReply
         * @instance
         */
        QuickReply.prototype.title = '';

        /**
         * QuickReply payload.
         * @member {google.protobuf.IStruct|null|undefined} payload
         * @memberof propel.core.MessageExtension.QuickReply
         * @instance
         */
        QuickReply.prototype.payload = null;

        /**
         * QuickReply imageUrl.
         * @member {google.protobuf.IStringValue|null|undefined} imageUrl
         * @memberof propel.core.MessageExtension.QuickReply
         * @instance
         */
        QuickReply.prototype.imageUrl = null;

        /**
         * Creates a new QuickReply instance using the specified properties.
         * @function create
         * @memberof propel.core.MessageExtension.QuickReply
         * @static
         * @param {propel.core.MessageExtension.IQuickReply=} [properties] Properties to set
         * @returns {propel.core.MessageExtension.QuickReply} QuickReply instance
         */
        QuickReply.create = function create(properties) {
          return new QuickReply(properties);
        };

        /**
         * Encodes the specified QuickReply message. Does not implicitly {@link propel.core.MessageExtension.QuickReply.verify|verify} messages.
         * @function encode
         * @memberof propel.core.MessageExtension.QuickReply
         * @static
         * @param {propel.core.MessageExtension.IQuickReply} message QuickReply message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        QuickReply.encode = function encode(message, writer) {
          if (!writer) writer = $Writer.create();
          if (message.id != null && message.hasOwnProperty('id'))
            writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
          if (message.title != null && message.hasOwnProperty('title'))
            writer.uint32(/* id 2, wireType 2 =*/ 18).string(message.title);
          if (message.payload != null && message.hasOwnProperty('payload'))
            $root.google.protobuf.Struct.encode(
              message.payload,
              writer.uint32(/* id 3, wireType 2 =*/ 26).fork()
            ).ldelim();
          if (message.imageUrl != null && message.hasOwnProperty('imageUrl'))
            $root.google.protobuf.StringValue.encode(
              message.imageUrl,
              writer.uint32(/* id 4, wireType 2 =*/ 34).fork()
            ).ldelim();
          return writer;
        };

        /**
         * Encodes the specified QuickReply message, length delimited. Does not implicitly {@link propel.core.MessageExtension.QuickReply.verify|verify} messages.
         * @function encodeDelimited
         * @memberof propel.core.MessageExtension.QuickReply
         * @static
         * @param {propel.core.MessageExtension.IQuickReply} message QuickReply message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        QuickReply.encodeDelimited = function encodeDelimited(message, writer) {
          return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a QuickReply message from the specified reader or buffer.
         * @function decode
         * @memberof propel.core.MessageExtension.QuickReply
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {propel.core.MessageExtension.QuickReply} QuickReply
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        QuickReply.decode = function decode(reader, length) {
          if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
          var end = length === undefined ? reader.len : reader.pos + length,
            message = new $root.propel.core.MessageExtension.QuickReply();
          while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
              case 1:
                message.id = reader.string();
                break;
              case 2:
                message.title = reader.string();
                break;
              case 3:
                message.payload = $root.google.protobuf.Struct.decode(reader, reader.uint32());
                break;
              case 4:
                message.imageUrl = $root.google.protobuf.StringValue.decode(
                  reader,
                  reader.uint32()
                );
                break;
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };

        /**
         * Decodes a QuickReply message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof propel.core.MessageExtension.QuickReply
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {propel.core.MessageExtension.QuickReply} QuickReply
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        QuickReply.decodeDelimited = function decodeDelimited(reader) {
          if (!(reader instanceof $Reader)) reader = new $Reader(reader);
          return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a QuickReply message.
         * @function verify
         * @memberof propel.core.MessageExtension.QuickReply
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        QuickReply.verify = function verify(message) {
          if (typeof message !== 'object' || message === null) return 'object expected';
          if (message.id != null && message.hasOwnProperty('id'))
            if (!$util.isString(message.id)) return 'id: string expected';
          if (message.title != null && message.hasOwnProperty('title'))
            if (!$util.isString(message.title)) return 'title: string expected';
          if (message.payload != null && message.hasOwnProperty('payload')) {
            var error = $root.google.protobuf.Struct.verify(message.payload);
            if (error) return 'payload.' + error;
          }
          if (message.imageUrl != null && message.hasOwnProperty('imageUrl')) {
            var error = $root.google.protobuf.StringValue.verify(message.imageUrl);
            if (error) return 'imageUrl.' + error;
          }
          return null;
        };

        /**
         * Creates a QuickReply message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof propel.core.MessageExtension.QuickReply
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {propel.core.MessageExtension.QuickReply} QuickReply
         */
        QuickReply.fromObject = function fromObject(object) {
          if (object instanceof $root.propel.core.MessageExtension.QuickReply) return object;
          var message = new $root.propel.core.MessageExtension.QuickReply();
          if (object.id != null) message.id = String(object.id);
          if (object.title != null) message.title = String(object.title);
          if (object.payload != null) {
            if (typeof object.payload !== 'object')
              throw TypeError('.propel.core.MessageExtension.QuickReply.payload: object expected');
            message.payload = $root.google.protobuf.Struct.fromObject(object.payload);
          }
          if (object.imageUrl != null) {
            if (typeof object.imageUrl !== 'object')
              throw TypeError('.propel.core.MessageExtension.QuickReply.imageUrl: object expected');
            message.imageUrl = $root.google.protobuf.StringValue.fromObject(object.imageUrl);
          }
          return message;
        };

        /**
         * Creates a plain object from a QuickReply message. Also converts values to other types if specified.
         * @function toObject
         * @memberof propel.core.MessageExtension.QuickReply
         * @static
         * @param {propel.core.MessageExtension.QuickReply} message QuickReply
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        QuickReply.toObject = function toObject(message, options) {
          if (!options) options = {};
          var object = {};
          if (options.defaults) {
            object.id = '';
            object.title = '';
            object.payload = null;
            object.imageUrl = null;
          }
          if (message.id != null && message.hasOwnProperty('id')) object.id = message.id;
          if (message.title != null && message.hasOwnProperty('title'))
            object.title = message.title;
          if (message.payload != null && message.hasOwnProperty('payload'))
            object.payload = $root.google.protobuf.Struct.toObject(message.payload, options);
          if (message.imageUrl != null && message.hasOwnProperty('imageUrl'))
            object.imageUrl = $root.google.protobuf.StringValue.toObject(message.imageUrl, options);
          return object;
        };

        /**
         * Converts this QuickReply to JSON.
         * @function toJSON
         * @memberof propel.core.MessageExtension.QuickReply
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        QuickReply.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return QuickReply;
      })();

      MessageExtension.QuickReplies = (function () {
        /**
         * Properties of a QuickReplies.
         * @memberof propel.core.MessageExtension
         * @interface IQuickReplies
         * @property {string|null} [templateType] QuickReplies templateType
         * @property {Array.<propel.core.MessageExtension.IQuickReply>|null} [quickReplies] QuickReplies quickReplies
         * @property {google.protobuf.IStringValue|null} [title] QuickReplies title
         * @property {google.protobuf.IStringValue|null} [subtitle] QuickReplies subtitle
         */

        /**
         * Constructs a new QuickReplies.
         * @memberof propel.core.MessageExtension
         * @classdesc Represents a QuickReplies.
         * @implements IQuickReplies
         * @constructor
         * @param {propel.core.MessageExtension.IQuickReplies=} [properties] Properties to set
         */
        function QuickReplies(properties) {
          this.quickReplies = [];
          if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
              if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
        }

        /**
         * QuickReplies templateType.
         * @member {string} templateType
         * @memberof propel.core.MessageExtension.QuickReplies
         * @instance
         */
        QuickReplies.prototype.templateType = '';

        /**
         * QuickReplies quickReplies.
         * @member {Array.<propel.core.MessageExtension.IQuickReply>} quickReplies
         * @memberof propel.core.MessageExtension.QuickReplies
         * @instance
         */
        QuickReplies.prototype.quickReplies = $util.emptyArray;

        /**
         * QuickReplies title.
         * @member {google.protobuf.IStringValue|null|undefined} title
         * @memberof propel.core.MessageExtension.QuickReplies
         * @instance
         */
        QuickReplies.prototype.title = null;

        /**
         * QuickReplies subtitle.
         * @member {google.protobuf.IStringValue|null|undefined} subtitle
         * @memberof propel.core.MessageExtension.QuickReplies
         * @instance
         */
        QuickReplies.prototype.subtitle = null;

        /**
         * Creates a new QuickReplies instance using the specified properties.
         * @function create
         * @memberof propel.core.MessageExtension.QuickReplies
         * @static
         * @param {propel.core.MessageExtension.IQuickReplies=} [properties] Properties to set
         * @returns {propel.core.MessageExtension.QuickReplies} QuickReplies instance
         */
        QuickReplies.create = function create(properties) {
          return new QuickReplies(properties);
        };

        /**
         * Encodes the specified QuickReplies message. Does not implicitly {@link propel.core.MessageExtension.QuickReplies.verify|verify} messages.
         * @function encode
         * @memberof propel.core.MessageExtension.QuickReplies
         * @static
         * @param {propel.core.MessageExtension.IQuickReplies} message QuickReplies message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        QuickReplies.encode = function encode(message, writer) {
          if (!writer) writer = $Writer.create();
          if (message.quickReplies != null && message.quickReplies.length)
            for (var i = 0; i < message.quickReplies.length; ++i)
              $root.propel.core.MessageExtension.QuickReply.encode(
                message.quickReplies[i],
                writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
              ).ldelim();
          if (message.title != null && message.hasOwnProperty('title'))
            $root.google.protobuf.StringValue.encode(
              message.title,
              writer.uint32(/* id 2, wireType 2 =*/ 18).fork()
            ).ldelim();
          if (message.templateType != null && message.hasOwnProperty('templateType'))
            writer.uint32(/* id 3, wireType 2 =*/ 26).string(message.templateType);
          if (message.subtitle != null && message.hasOwnProperty('subtitle'))
            $root.google.protobuf.StringValue.encode(
              message.subtitle,
              writer.uint32(/* id 4, wireType 2 =*/ 34).fork()
            ).ldelim();
          return writer;
        };

        /**
         * Encodes the specified QuickReplies message, length delimited. Does not implicitly {@link propel.core.MessageExtension.QuickReplies.verify|verify} messages.
         * @function encodeDelimited
         * @memberof propel.core.MessageExtension.QuickReplies
         * @static
         * @param {propel.core.MessageExtension.IQuickReplies} message QuickReplies message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        QuickReplies.encodeDelimited = function encodeDelimited(message, writer) {
          return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a QuickReplies message from the specified reader or buffer.
         * @function decode
         * @memberof propel.core.MessageExtension.QuickReplies
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {propel.core.MessageExtension.QuickReplies} QuickReplies
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        QuickReplies.decode = function decode(reader, length) {
          if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
          var end = length === undefined ? reader.len : reader.pos + length,
            message = new $root.propel.core.MessageExtension.QuickReplies();
          while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
              case 3:
                message.templateType = reader.string();
                break;
              case 1:
                if (!(message.quickReplies && message.quickReplies.length))
                  message.quickReplies = [];
                message.quickReplies.push(
                  $root.propel.core.MessageExtension.QuickReply.decode(reader, reader.uint32())
                );
                break;
              case 2:
                message.title = $root.google.protobuf.StringValue.decode(reader, reader.uint32());
                break;
              case 4:
                message.subtitle = $root.google.protobuf.StringValue.decode(
                  reader,
                  reader.uint32()
                );
                break;
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };

        /**
         * Decodes a QuickReplies message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof propel.core.MessageExtension.QuickReplies
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {propel.core.MessageExtension.QuickReplies} QuickReplies
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        QuickReplies.decodeDelimited = function decodeDelimited(reader) {
          if (!(reader instanceof $Reader)) reader = new $Reader(reader);
          return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a QuickReplies message.
         * @function verify
         * @memberof propel.core.MessageExtension.QuickReplies
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        QuickReplies.verify = function verify(message) {
          if (typeof message !== 'object' || message === null) return 'object expected';
          if (message.templateType != null && message.hasOwnProperty('templateType'))
            if (!$util.isString(message.templateType)) return 'templateType: string expected';
          if (message.quickReplies != null && message.hasOwnProperty('quickReplies')) {
            if (!Array.isArray(message.quickReplies)) return 'quickReplies: array expected';
            for (var i = 0; i < message.quickReplies.length; ++i) {
              var error = $root.propel.core.MessageExtension.QuickReply.verify(
                message.quickReplies[i]
              );
              if (error) return 'quickReplies.' + error;
            }
          }
          if (message.title != null && message.hasOwnProperty('title')) {
            var error = $root.google.protobuf.StringValue.verify(message.title);
            if (error) return 'title.' + error;
          }
          if (message.subtitle != null && message.hasOwnProperty('subtitle')) {
            var error = $root.google.protobuf.StringValue.verify(message.subtitle);
            if (error) return 'subtitle.' + error;
          }
          return null;
        };

        /**
         * Creates a QuickReplies message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof propel.core.MessageExtension.QuickReplies
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {propel.core.MessageExtension.QuickReplies} QuickReplies
         */
        QuickReplies.fromObject = function fromObject(object) {
          if (object instanceof $root.propel.core.MessageExtension.QuickReplies) return object;
          var message = new $root.propel.core.MessageExtension.QuickReplies();
          if (object.templateType != null) message.templateType = String(object.templateType);
          if (object.quickReplies) {
            if (!Array.isArray(object.quickReplies))
              throw TypeError(
                '.propel.core.MessageExtension.QuickReplies.quickReplies: array expected'
              );
            message.quickReplies = [];
            for (var i = 0; i < object.quickReplies.length; ++i) {
              if (typeof object.quickReplies[i] !== 'object')
                throw TypeError(
                  '.propel.core.MessageExtension.QuickReplies.quickReplies: object expected'
                );
              message.quickReplies[i] = $root.propel.core.MessageExtension.QuickReply.fromObject(
                object.quickReplies[i]
              );
            }
          }
          if (object.title != null) {
            if (typeof object.title !== 'object')
              throw TypeError('.propel.core.MessageExtension.QuickReplies.title: object expected');
            message.title = $root.google.protobuf.StringValue.fromObject(object.title);
          }
          if (object.subtitle != null) {
            if (typeof object.subtitle !== 'object')
              throw TypeError(
                '.propel.core.MessageExtension.QuickReplies.subtitle: object expected'
              );
            message.subtitle = $root.google.protobuf.StringValue.fromObject(object.subtitle);
          }
          return message;
        };

        /**
         * Creates a plain object from a QuickReplies message. Also converts values to other types if specified.
         * @function toObject
         * @memberof propel.core.MessageExtension.QuickReplies
         * @static
         * @param {propel.core.MessageExtension.QuickReplies} message QuickReplies
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        QuickReplies.toObject = function toObject(message, options) {
          if (!options) options = {};
          var object = {};
          if (options.arrays || options.defaults) object.quickReplies = [];
          if (options.defaults) {
            object.title = null;
            object.templateType = '';
            object.subtitle = null;
          }
          if (message.quickReplies && message.quickReplies.length) {
            object.quickReplies = [];
            for (var j = 0; j < message.quickReplies.length; ++j)
              object.quickReplies[j] = $root.propel.core.MessageExtension.QuickReply.toObject(
                message.quickReplies[j],
                options
              );
          }
          if (message.title != null && message.hasOwnProperty('title'))
            object.title = $root.google.protobuf.StringValue.toObject(message.title, options);
          if (message.templateType != null && message.hasOwnProperty('templateType'))
            object.templateType = message.templateType;
          if (message.subtitle != null && message.hasOwnProperty('subtitle'))
            object.subtitle = $root.google.protobuf.StringValue.toObject(message.subtitle, options);
          return object;
        };

        /**
         * Converts this QuickReplies to JSON.
         * @function toJSON
         * @memberof propel.core.MessageExtension.QuickReplies
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        QuickReplies.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return QuickReplies;
      })();

      MessageExtension.AvatarUpdate = (function () {
        /**
         * Properties of an AvatarUpdate.
         * @memberof propel.core.MessageExtension
         * @interface IAvatarUpdate
         * @property {propel.core.MessageExtension.AvatarUpdate.State|null} [state] AvatarUpdate state
         * @property {string|null} [name] AvatarUpdate name
         * @property {string|null} [imageUrl] AvatarUpdate imageUrl
         */

        /**
         * Constructs a new AvatarUpdate.
         * @memberof propel.core.MessageExtension
         * @classdesc Represents an AvatarUpdate.
         * @implements IAvatarUpdate
         * @constructor
         * @param {propel.core.MessageExtension.IAvatarUpdate=} [properties] Properties to set
         */
        function AvatarUpdate(properties) {
          if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
              if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
        }

        /**
         * AvatarUpdate state.
         * @member {propel.core.MessageExtension.AvatarUpdate.State} state
         * @memberof propel.core.MessageExtension.AvatarUpdate
         * @instance
         */
        AvatarUpdate.prototype.state = 0;

        /**
         * AvatarUpdate name.
         * @member {string} name
         * @memberof propel.core.MessageExtension.AvatarUpdate
         * @instance
         */
        AvatarUpdate.prototype.name = '';

        /**
         * AvatarUpdate imageUrl.
         * @member {string} imageUrl
         * @memberof propel.core.MessageExtension.AvatarUpdate
         * @instance
         */
        AvatarUpdate.prototype.imageUrl = '';

        /**
         * Creates a new AvatarUpdate instance using the specified properties.
         * @function create
         * @memberof propel.core.MessageExtension.AvatarUpdate
         * @static
         * @param {propel.core.MessageExtension.IAvatarUpdate=} [properties] Properties to set
         * @returns {propel.core.MessageExtension.AvatarUpdate} AvatarUpdate instance
         */
        AvatarUpdate.create = function create(properties) {
          return new AvatarUpdate(properties);
        };

        /**
         * Encodes the specified AvatarUpdate message. Does not implicitly {@link propel.core.MessageExtension.AvatarUpdate.verify|verify} messages.
         * @function encode
         * @memberof propel.core.MessageExtension.AvatarUpdate
         * @static
         * @param {propel.core.MessageExtension.IAvatarUpdate} message AvatarUpdate message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        AvatarUpdate.encode = function encode(message, writer) {
          if (!writer) writer = $Writer.create();
          if (message.state != null && message.hasOwnProperty('state'))
            writer.uint32(/* id 1, wireType 0 =*/ 8).int32(message.state);
          if (message.name != null && message.hasOwnProperty('name'))
            writer.uint32(/* id 2, wireType 2 =*/ 18).string(message.name);
          if (message.imageUrl != null && message.hasOwnProperty('imageUrl'))
            writer.uint32(/* id 3, wireType 2 =*/ 26).string(message.imageUrl);
          return writer;
        };

        /**
         * Encodes the specified AvatarUpdate message, length delimited. Does not implicitly {@link propel.core.MessageExtension.AvatarUpdate.verify|verify} messages.
         * @function encodeDelimited
         * @memberof propel.core.MessageExtension.AvatarUpdate
         * @static
         * @param {propel.core.MessageExtension.IAvatarUpdate} message AvatarUpdate message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        AvatarUpdate.encodeDelimited = function encodeDelimited(message, writer) {
          return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an AvatarUpdate message from the specified reader or buffer.
         * @function decode
         * @memberof propel.core.MessageExtension.AvatarUpdate
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {propel.core.MessageExtension.AvatarUpdate} AvatarUpdate
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        AvatarUpdate.decode = function decode(reader, length) {
          if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
          var end = length === undefined ? reader.len : reader.pos + length,
            message = new $root.propel.core.MessageExtension.AvatarUpdate();
          while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
              case 1:
                message.state = reader.int32();
                break;
              case 2:
                message.name = reader.string();
                break;
              case 3:
                message.imageUrl = reader.string();
                break;
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };

        /**
         * Decodes an AvatarUpdate message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof propel.core.MessageExtension.AvatarUpdate
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {propel.core.MessageExtension.AvatarUpdate} AvatarUpdate
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        AvatarUpdate.decodeDelimited = function decodeDelimited(reader) {
          if (!(reader instanceof $Reader)) reader = new $Reader(reader);
          return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an AvatarUpdate message.
         * @function verify
         * @memberof propel.core.MessageExtension.AvatarUpdate
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        AvatarUpdate.verify = function verify(message) {
          if (typeof message !== 'object' || message === null) return 'object expected';
          if (message.state != null && message.hasOwnProperty('state'))
            switch (message.state) {
              default:
                return 'state: enum value expected';
              case 0:
              case 1:
              case 2:
                break;
            }
          if (message.name != null && message.hasOwnProperty('name'))
            if (!$util.isString(message.name)) return 'name: string expected';
          if (message.imageUrl != null && message.hasOwnProperty('imageUrl'))
            if (!$util.isString(message.imageUrl)) return 'imageUrl: string expected';
          return null;
        };

        /**
         * Creates an AvatarUpdate message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof propel.core.MessageExtension.AvatarUpdate
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {propel.core.MessageExtension.AvatarUpdate} AvatarUpdate
         */
        AvatarUpdate.fromObject = function fromObject(object) {
          if (object instanceof $root.propel.core.MessageExtension.AvatarUpdate) return object;
          var message = new $root.propel.core.MessageExtension.AvatarUpdate();
          switch (object.state) {
            case 'STATE_UNKNOWN':
            case 0:
              message.state = 0;
              break;
            case 'STATE_PRESENT':
            case 1:
              message.state = 1;
              break;
            case 'STATE_NOT_PRESENT':
            case 2:
              message.state = 2;
              break;
          }
          if (object.name != null) message.name = String(object.name);
          if (object.imageUrl != null) message.imageUrl = String(object.imageUrl);
          return message;
        };

        /**
         * Creates a plain object from an AvatarUpdate message. Also converts values to other types if specified.
         * @function toObject
         * @memberof propel.core.MessageExtension.AvatarUpdate
         * @static
         * @param {propel.core.MessageExtension.AvatarUpdate} message AvatarUpdate
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        AvatarUpdate.toObject = function toObject(message, options) {
          if (!options) options = {};
          var object = {};
          if (options.defaults) {
            object.state = options.enums === String ? 'STATE_UNKNOWN' : 0;
            object.name = '';
            object.imageUrl = '';
          }
          if (message.state != null && message.hasOwnProperty('state'))
            object.state =
              options.enums === String
                ? $root.propel.core.MessageExtension.AvatarUpdate.State[message.state]
                : message.state;
          if (message.name != null && message.hasOwnProperty('name')) object.name = message.name;
          if (message.imageUrl != null && message.hasOwnProperty('imageUrl'))
            object.imageUrl = message.imageUrl;
          return object;
        };

        /**
         * Converts this AvatarUpdate to JSON.
         * @function toJSON
         * @memberof propel.core.MessageExtension.AvatarUpdate
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        AvatarUpdate.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * State enum.
         * @name propel.core.MessageExtension.AvatarUpdate.State
         * @enum {string}
         * @property {number} STATE_UNKNOWN=0 STATE_UNKNOWN value
         * @property {number} STATE_PRESENT=1 STATE_PRESENT value
         * @property {number} STATE_NOT_PRESENT=2 STATE_NOT_PRESENT value
         */
        AvatarUpdate.State = (function () {
          var valuesById = {},
            values = Object.create(valuesById);
          values[(valuesById[0] = 'STATE_UNKNOWN')] = 0;
          values[(valuesById[1] = 'STATE_PRESENT')] = 1;
          values[(valuesById[2] = 'STATE_NOT_PRESENT')] = 2;
          return values;
        })();

        return AvatarUpdate;
      })();

      MessageExtension.Form = (function () {
        /**
         * Properties of a Form.
         * @memberof propel.core.MessageExtension
         * @interface IForm
         * @property {string|null} [id] Form id
         * @property {string|null} [templateType] Form templateType
         * @property {string|null} [url] Form url
         * @property {boolean|null} [isCompleted] Form isCompleted
         * @property {google.protobuf.IStruct|null} [info] Form info
         */

        /**
         * Constructs a new Form.
         * @memberof propel.core.MessageExtension
         * @classdesc Represents a Form.
         * @implements IForm
         * @constructor
         * @param {propel.core.MessageExtension.IForm=} [properties] Properties to set
         */
        function Form(properties) {
          if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
              if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
        }

        /**
         * Form id.
         * @member {string} id
         * @memberof propel.core.MessageExtension.Form
         * @instance
         */
        Form.prototype.id = '';

        /**
         * Form templateType.
         * @member {string} templateType
         * @memberof propel.core.MessageExtension.Form
         * @instance
         */
        Form.prototype.templateType = '';

        /**
         * Form url.
         * @member {string} url
         * @memberof propel.core.MessageExtension.Form
         * @instance
         */
        Form.prototype.url = '';

        /**
         * Form isCompleted.
         * @member {boolean} isCompleted
         * @memberof propel.core.MessageExtension.Form
         * @instance
         */
        Form.prototype.isCompleted = false;

        /**
         * Form info.
         * @member {google.protobuf.IStruct|null|undefined} info
         * @memberof propel.core.MessageExtension.Form
         * @instance
         */
        Form.prototype.info = null;

        /**
         * Creates a new Form instance using the specified properties.
         * @function create
         * @memberof propel.core.MessageExtension.Form
         * @static
         * @param {propel.core.MessageExtension.IForm=} [properties] Properties to set
         * @returns {propel.core.MessageExtension.Form} Form instance
         */
        Form.create = function create(properties) {
          return new Form(properties);
        };

        /**
         * Encodes the specified Form message. Does not implicitly {@link propel.core.MessageExtension.Form.verify|verify} messages.
         * @function encode
         * @memberof propel.core.MessageExtension.Form
         * @static
         * @param {propel.core.MessageExtension.IForm} message Form message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Form.encode = function encode(message, writer) {
          if (!writer) writer = $Writer.create();
          if (message.id != null && message.hasOwnProperty('id'))
            writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
          if (message.templateType != null && message.hasOwnProperty('templateType'))
            writer.uint32(/* id 2, wireType 2 =*/ 18).string(message.templateType);
          if (message.url != null && message.hasOwnProperty('url'))
            writer.uint32(/* id 3, wireType 2 =*/ 26).string(message.url);
          if (message.isCompleted != null && message.hasOwnProperty('isCompleted'))
            writer.uint32(/* id 4, wireType 0 =*/ 32).bool(message.isCompleted);
          if (message.info != null && message.hasOwnProperty('info'))
            $root.google.protobuf.Struct.encode(
              message.info,
              writer.uint32(/* id 5, wireType 2 =*/ 42).fork()
            ).ldelim();
          return writer;
        };

        /**
         * Encodes the specified Form message, length delimited. Does not implicitly {@link propel.core.MessageExtension.Form.verify|verify} messages.
         * @function encodeDelimited
         * @memberof propel.core.MessageExtension.Form
         * @static
         * @param {propel.core.MessageExtension.IForm} message Form message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Form.encodeDelimited = function encodeDelimited(message, writer) {
          return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a Form message from the specified reader or buffer.
         * @function decode
         * @memberof propel.core.MessageExtension.Form
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {propel.core.MessageExtension.Form} Form
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Form.decode = function decode(reader, length) {
          if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
          var end = length === undefined ? reader.len : reader.pos + length,
            message = new $root.propel.core.MessageExtension.Form();
          while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
              case 1:
                message.id = reader.string();
                break;
              case 2:
                message.templateType = reader.string();
                break;
              case 3:
                message.url = reader.string();
                break;
              case 4:
                message.isCompleted = reader.bool();
                break;
              case 5:
                message.info = $root.google.protobuf.Struct.decode(reader, reader.uint32());
                break;
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };

        /**
         * Decodes a Form message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof propel.core.MessageExtension.Form
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {propel.core.MessageExtension.Form} Form
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Form.decodeDelimited = function decodeDelimited(reader) {
          if (!(reader instanceof $Reader)) reader = new $Reader(reader);
          return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Form message.
         * @function verify
         * @memberof propel.core.MessageExtension.Form
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Form.verify = function verify(message) {
          if (typeof message !== 'object' || message === null) return 'object expected';
          if (message.id != null && message.hasOwnProperty('id'))
            if (!$util.isString(message.id)) return 'id: string expected';
          if (message.templateType != null && message.hasOwnProperty('templateType'))
            if (!$util.isString(message.templateType)) return 'templateType: string expected';
          if (message.url != null && message.hasOwnProperty('url'))
            if (!$util.isString(message.url)) return 'url: string expected';
          if (message.isCompleted != null && message.hasOwnProperty('isCompleted'))
            if (typeof message.isCompleted !== 'boolean') return 'isCompleted: boolean expected';
          if (message.info != null && message.hasOwnProperty('info')) {
            var error = $root.google.protobuf.Struct.verify(message.info);
            if (error) return 'info.' + error;
          }
          return null;
        };

        /**
         * Creates a Form message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof propel.core.MessageExtension.Form
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {propel.core.MessageExtension.Form} Form
         */
        Form.fromObject = function fromObject(object) {
          if (object instanceof $root.propel.core.MessageExtension.Form) return object;
          var message = new $root.propel.core.MessageExtension.Form();
          if (object.id != null) message.id = String(object.id);
          if (object.templateType != null) message.templateType = String(object.templateType);
          if (object.url != null) message.url = String(object.url);
          if (object.isCompleted != null) message.isCompleted = Boolean(object.isCompleted);
          if (object.info != null) {
            if (typeof object.info !== 'object')
              throw TypeError('.propel.core.MessageExtension.Form.info: object expected');
            message.info = $root.google.protobuf.Struct.fromObject(object.info);
          }
          return message;
        };

        /**
         * Creates a plain object from a Form message. Also converts values to other types if specified.
         * @function toObject
         * @memberof propel.core.MessageExtension.Form
         * @static
         * @param {propel.core.MessageExtension.Form} message Form
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Form.toObject = function toObject(message, options) {
          if (!options) options = {};
          var object = {};
          if (options.defaults) {
            object.id = '';
            object.templateType = '';
            object.url = '';
            object.isCompleted = false;
            object.info = null;
          }
          if (message.id != null && message.hasOwnProperty('id')) object.id = message.id;
          if (message.templateType != null && message.hasOwnProperty('templateType'))
            object.templateType = message.templateType;
          if (message.url != null && message.hasOwnProperty('url')) object.url = message.url;
          if (message.isCompleted != null && message.hasOwnProperty('isCompleted'))
            object.isCompleted = message.isCompleted;
          if (message.info != null && message.hasOwnProperty('info'))
            object.info = $root.google.protobuf.Struct.toObject(message.info, options);
          return object;
        };

        /**
         * Converts this Form to JSON.
         * @function toJSON
         * @memberof propel.core.MessageExtension.Form
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Form.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Form;
      })();

      return MessageExtension;
    })();

    /**
     * LeadContactPreference enum.
     * @name propel.core.LeadContactPreference
     * @enum {string}
     * @property {number} CONTACT_UNKNOWN=0 CONTACT_UNKNOWN value
     * @property {number} CONTACT_EMAIL=1 CONTACT_EMAIL value
     * @property {number} CONTACT_SMS=2 CONTACT_SMS value
     * @property {number} CONTACT_CALL=3 CONTACT_CALL value
     */
    core.LeadContactPreference = (function () {
      var valuesById = {},
        values = Object.create(valuesById);
      values[(valuesById[0] = 'CONTACT_UNKNOWN')] = 0;
      values[(valuesById[1] = 'CONTACT_EMAIL')] = 1;
      values[(valuesById[2] = 'CONTACT_SMS')] = 2;
      values[(valuesById[3] = 'CONTACT_CALL')] = 3;
      return values;
    })();

    /**
     * LeadContactTimePreference enum.
     * @name propel.core.LeadContactTimePreference
     * @enum {string}
     * @property {number} TIME_UNKNOWN=0 TIME_UNKNOWN value
     * @property {number} TIME_MORNING=1 TIME_MORNING value
     * @property {number} TIME_AFTERNOON=2 TIME_AFTERNOON value
     * @property {number} TIME_EVENING=3 TIME_EVENING value
     * @property {number} TIME_DAY=4 TIME_DAY value
     */
    core.LeadContactTimePreference = (function () {
      var valuesById = {},
        values = Object.create(valuesById);
      values[(valuesById[0] = 'TIME_UNKNOWN')] = 0;
      values[(valuesById[1] = 'TIME_MORNING')] = 1;
      values[(valuesById[2] = 'TIME_AFTERNOON')] = 2;
      values[(valuesById[3] = 'TIME_EVENING')] = 3;
      values[(valuesById[4] = 'TIME_DAY')] = 4;
      return values;
    })();

    core.LeadOrigin = (function () {
      /**
       * Properties of a LeadOrigin.
       * @memberof propel.core
       * @interface ILeadOrigin
       * @property {google.protobuf.IStringValue|null} [vendorId] LeadOrigin vendorId
       * @property {google.protobuf.IStringValue|null} [name] LeadOrigin name
       * @property {google.protobuf.IStringValue|null} [service] LeadOrigin service
       * @property {google.protobuf.IStringValue|null} [url] LeadOrigin url
       * @property {Object.<string,string>|null} [meta] LeadOrigin meta
       */

      /**
       * Constructs a new LeadOrigin.
       * @memberof propel.core
       * @classdesc Represents a LeadOrigin.
       * @implements ILeadOrigin
       * @constructor
       * @param {propel.core.ILeadOrigin=} [properties] Properties to set
       */
      function LeadOrigin(properties) {
        this.meta = {};
        if (properties)
          for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
      }

      /**
       * LeadOrigin vendorId.
       * @member {google.protobuf.IStringValue|null|undefined} vendorId
       * @memberof propel.core.LeadOrigin
       * @instance
       */
      LeadOrigin.prototype.vendorId = null;

      /**
       * LeadOrigin name.
       * @member {google.protobuf.IStringValue|null|undefined} name
       * @memberof propel.core.LeadOrigin
       * @instance
       */
      LeadOrigin.prototype.name = null;

      /**
       * LeadOrigin service.
       * @member {google.protobuf.IStringValue|null|undefined} service
       * @memberof propel.core.LeadOrigin
       * @instance
       */
      LeadOrigin.prototype.service = null;

      /**
       * LeadOrigin url.
       * @member {google.protobuf.IStringValue|null|undefined} url
       * @memberof propel.core.LeadOrigin
       * @instance
       */
      LeadOrigin.prototype.url = null;

      /**
       * LeadOrigin meta.
       * @member {Object.<string,string>} meta
       * @memberof propel.core.LeadOrigin
       * @instance
       */
      LeadOrigin.prototype.meta = $util.emptyObject;

      /**
       * Creates a new LeadOrigin instance using the specified properties.
       * @function create
       * @memberof propel.core.LeadOrigin
       * @static
       * @param {propel.core.ILeadOrigin=} [properties] Properties to set
       * @returns {propel.core.LeadOrigin} LeadOrigin instance
       */
      LeadOrigin.create = function create(properties) {
        return new LeadOrigin(properties);
      };

      /**
       * Encodes the specified LeadOrigin message. Does not implicitly {@link propel.core.LeadOrigin.verify|verify} messages.
       * @function encode
       * @memberof propel.core.LeadOrigin
       * @static
       * @param {propel.core.ILeadOrigin} message LeadOrigin message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      LeadOrigin.encode = function encode(message, writer) {
        if (!writer) writer = $Writer.create();
        if (message.vendorId != null && message.hasOwnProperty('vendorId'))
          $root.google.protobuf.StringValue.encode(
            message.vendorId,
            writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
          ).ldelim();
        if (message.name != null && message.hasOwnProperty('name'))
          $root.google.protobuf.StringValue.encode(
            message.name,
            writer.uint32(/* id 2, wireType 2 =*/ 18).fork()
          ).ldelim();
        if (message.meta != null && message.hasOwnProperty('meta'))
          for (var keys = Object.keys(message.meta), i = 0; i < keys.length; ++i)
            writer
              .uint32(/* id 3, wireType 2 =*/ 26)
              .fork()
              .uint32(/* id 1, wireType 2 =*/ 10)
              .string(keys[i])
              .uint32(/* id 2, wireType 2 =*/ 18)
              .string(message.meta[keys[i]])
              .ldelim();
        if (message.service != null && message.hasOwnProperty('service'))
          $root.google.protobuf.StringValue.encode(
            message.service,
            writer.uint32(/* id 4, wireType 2 =*/ 34).fork()
          ).ldelim();
        if (message.url != null && message.hasOwnProperty('url'))
          $root.google.protobuf.StringValue.encode(
            message.url,
            writer.uint32(/* id 5, wireType 2 =*/ 42).fork()
          ).ldelim();
        return writer;
      };

      /**
       * Encodes the specified LeadOrigin message, length delimited. Does not implicitly {@link propel.core.LeadOrigin.verify|verify} messages.
       * @function encodeDelimited
       * @memberof propel.core.LeadOrigin
       * @static
       * @param {propel.core.ILeadOrigin} message LeadOrigin message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      LeadOrigin.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
      };

      /**
       * Decodes a LeadOrigin message from the specified reader or buffer.
       * @function decode
       * @memberof propel.core.LeadOrigin
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @param {number} [length] Message length if known beforehand
       * @returns {propel.core.LeadOrigin} LeadOrigin
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      LeadOrigin.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length,
          message = new $root.propel.core.LeadOrigin(),
          key;
        while (reader.pos < end) {
          var tag = reader.uint32();
          switch (tag >>> 3) {
            case 1:
              message.vendorId = $root.google.protobuf.StringValue.decode(reader, reader.uint32());
              break;
            case 2:
              message.name = $root.google.protobuf.StringValue.decode(reader, reader.uint32());
              break;
            case 4:
              message.service = $root.google.protobuf.StringValue.decode(reader, reader.uint32());
              break;
            case 5:
              message.url = $root.google.protobuf.StringValue.decode(reader, reader.uint32());
              break;
            case 3:
              reader.skip().pos++;
              if (message.meta === $util.emptyObject) message.meta = {};
              key = reader.string();
              reader.pos++;
              message.meta[key] = reader.string();
              break;
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };

      /**
       * Decodes a LeadOrigin message from the specified reader or buffer, length delimited.
       * @function decodeDelimited
       * @memberof propel.core.LeadOrigin
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @returns {propel.core.LeadOrigin} LeadOrigin
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      LeadOrigin.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader)) reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
      };

      /**
       * Verifies a LeadOrigin message.
       * @function verify
       * @memberof propel.core.LeadOrigin
       * @static
       * @param {Object.<string,*>} message Plain object to verify
       * @returns {string|null} `null` if valid, otherwise the reason why it is not
       */
      LeadOrigin.verify = function verify(message) {
        if (typeof message !== 'object' || message === null) return 'object expected';
        if (message.vendorId != null && message.hasOwnProperty('vendorId')) {
          var error = $root.google.protobuf.StringValue.verify(message.vendorId);
          if (error) return 'vendorId.' + error;
        }
        if (message.name != null && message.hasOwnProperty('name')) {
          var error = $root.google.protobuf.StringValue.verify(message.name);
          if (error) return 'name.' + error;
        }
        if (message.service != null && message.hasOwnProperty('service')) {
          var error = $root.google.protobuf.StringValue.verify(message.service);
          if (error) return 'service.' + error;
        }
        if (message.url != null && message.hasOwnProperty('url')) {
          var error = $root.google.protobuf.StringValue.verify(message.url);
          if (error) return 'url.' + error;
        }
        if (message.meta != null && message.hasOwnProperty('meta')) {
          if (!$util.isObject(message.meta)) return 'meta: object expected';
          var key = Object.keys(message.meta);
          for (var i = 0; i < key.length; ++i)
            if (!$util.isString(message.meta[key[i]])) return 'meta: string{k:string} expected';
        }
        return null;
      };

      /**
       * Creates a LeadOrigin message from a plain object. Also converts values to their respective internal types.
       * @function fromObject
       * @memberof propel.core.LeadOrigin
       * @static
       * @param {Object.<string,*>} object Plain object
       * @returns {propel.core.LeadOrigin} LeadOrigin
       */
      LeadOrigin.fromObject = function fromObject(object) {
        if (object instanceof $root.propel.core.LeadOrigin) return object;
        var message = new $root.propel.core.LeadOrigin();
        if (object.vendorId != null) {
          if (typeof object.vendorId !== 'object')
            throw TypeError('.propel.core.LeadOrigin.vendorId: object expected');
          message.vendorId = $root.google.protobuf.StringValue.fromObject(object.vendorId);
        }
        if (object.name != null) {
          if (typeof object.name !== 'object')
            throw TypeError('.propel.core.LeadOrigin.name: object expected');
          message.name = $root.google.protobuf.StringValue.fromObject(object.name);
        }
        if (object.service != null) {
          if (typeof object.service !== 'object')
            throw TypeError('.propel.core.LeadOrigin.service: object expected');
          message.service = $root.google.protobuf.StringValue.fromObject(object.service);
        }
        if (object.url != null) {
          if (typeof object.url !== 'object')
            throw TypeError('.propel.core.LeadOrigin.url: object expected');
          message.url = $root.google.protobuf.StringValue.fromObject(object.url);
        }
        if (object.meta) {
          if (typeof object.meta !== 'object')
            throw TypeError('.propel.core.LeadOrigin.meta: object expected');
          message.meta = {};
          for (var keys = Object.keys(object.meta), i = 0; i < keys.length; ++i)
            message.meta[keys[i]] = String(object.meta[keys[i]]);
        }
        return message;
      };

      /**
       * Creates a plain object from a LeadOrigin message. Also converts values to other types if specified.
       * @function toObject
       * @memberof propel.core.LeadOrigin
       * @static
       * @param {propel.core.LeadOrigin} message LeadOrigin
       * @param {$protobuf.IConversionOptions} [options] Conversion options
       * @returns {Object.<string,*>} Plain object
       */
      LeadOrigin.toObject = function toObject(message, options) {
        if (!options) options = {};
        var object = {};
        if (options.objects || options.defaults) object.meta = {};
        if (options.defaults) {
          object.vendorId = null;
          object.name = null;
          object.service = null;
          object.url = null;
        }
        if (message.vendorId != null && message.hasOwnProperty('vendorId'))
          object.vendorId = $root.google.protobuf.StringValue.toObject(message.vendorId, options);
        if (message.name != null && message.hasOwnProperty('name'))
          object.name = $root.google.protobuf.StringValue.toObject(message.name, options);
        var keys2;
        if (message.meta && (keys2 = Object.keys(message.meta)).length) {
          object.meta = {};
          for (var j = 0; j < keys2.length; ++j) object.meta[keys2[j]] = message.meta[keys2[j]];
        }
        if (message.service != null && message.hasOwnProperty('service'))
          object.service = $root.google.protobuf.StringValue.toObject(message.service, options);
        if (message.url != null && message.hasOwnProperty('url'))
          object.url = $root.google.protobuf.StringValue.toObject(message.url, options);
        return object;
      };

      /**
       * Converts this LeadOrigin to JSON.
       * @function toJSON
       * @memberof propel.core.LeadOrigin
       * @instance
       * @returns {Object.<string,*>} JSON object
       */
      LeadOrigin.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
      };

      return LeadOrigin;
    })();

    core.LeadAddress = (function () {
      /**
       * Properties of a LeadAddress.
       * @memberof propel.core
       * @interface ILeadAddress
       * @property {string|null} [address1] LeadAddress address1
       * @property {string|null} [address2] LeadAddress address2
       * @property {string|null} [city] LeadAddress city
       * @property {string|null} [state] LeadAddress state
       * @property {string|null} [zip] LeadAddress zip
       */

      /**
       * Constructs a new LeadAddress.
       * @memberof propel.core
       * @classdesc Represents a LeadAddress.
       * @implements ILeadAddress
       * @constructor
       * @param {propel.core.ILeadAddress=} [properties] Properties to set
       */
      function LeadAddress(properties) {
        if (properties)
          for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
      }

      /**
       * LeadAddress address1.
       * @member {string} address1
       * @memberof propel.core.LeadAddress
       * @instance
       */
      LeadAddress.prototype.address1 = '';

      /**
       * LeadAddress address2.
       * @member {string} address2
       * @memberof propel.core.LeadAddress
       * @instance
       */
      LeadAddress.prototype.address2 = '';

      /**
       * LeadAddress city.
       * @member {string} city
       * @memberof propel.core.LeadAddress
       * @instance
       */
      LeadAddress.prototype.city = '';

      /**
       * LeadAddress state.
       * @member {string} state
       * @memberof propel.core.LeadAddress
       * @instance
       */
      LeadAddress.prototype.state = '';

      /**
       * LeadAddress zip.
       * @member {string} zip
       * @memberof propel.core.LeadAddress
       * @instance
       */
      LeadAddress.prototype.zip = '';

      /**
       * Creates a new LeadAddress instance using the specified properties.
       * @function create
       * @memberof propel.core.LeadAddress
       * @static
       * @param {propel.core.ILeadAddress=} [properties] Properties to set
       * @returns {propel.core.LeadAddress} LeadAddress instance
       */
      LeadAddress.create = function create(properties) {
        return new LeadAddress(properties);
      };

      /**
       * Encodes the specified LeadAddress message. Does not implicitly {@link propel.core.LeadAddress.verify|verify} messages.
       * @function encode
       * @memberof propel.core.LeadAddress
       * @static
       * @param {propel.core.ILeadAddress} message LeadAddress message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      LeadAddress.encode = function encode(message, writer) {
        if (!writer) writer = $Writer.create();
        if (message.address1 != null && message.hasOwnProperty('address1'))
          writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.address1);
        if (message.address2 != null && message.hasOwnProperty('address2'))
          writer.uint32(/* id 2, wireType 2 =*/ 18).string(message.address2);
        if (message.city != null && message.hasOwnProperty('city'))
          writer.uint32(/* id 3, wireType 2 =*/ 26).string(message.city);
        if (message.state != null && message.hasOwnProperty('state'))
          writer.uint32(/* id 4, wireType 2 =*/ 34).string(message.state);
        if (message.zip != null && message.hasOwnProperty('zip'))
          writer.uint32(/* id 5, wireType 2 =*/ 42).string(message.zip);
        return writer;
      };

      /**
       * Encodes the specified LeadAddress message, length delimited. Does not implicitly {@link propel.core.LeadAddress.verify|verify} messages.
       * @function encodeDelimited
       * @memberof propel.core.LeadAddress
       * @static
       * @param {propel.core.ILeadAddress} message LeadAddress message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      LeadAddress.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
      };

      /**
       * Decodes a LeadAddress message from the specified reader or buffer.
       * @function decode
       * @memberof propel.core.LeadAddress
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @param {number} [length] Message length if known beforehand
       * @returns {propel.core.LeadAddress} LeadAddress
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      LeadAddress.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length,
          message = new $root.propel.core.LeadAddress();
        while (reader.pos < end) {
          var tag = reader.uint32();
          switch (tag >>> 3) {
            case 1:
              message.address1 = reader.string();
              break;
            case 2:
              message.address2 = reader.string();
              break;
            case 3:
              message.city = reader.string();
              break;
            case 4:
              message.state = reader.string();
              break;
            case 5:
              message.zip = reader.string();
              break;
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };

      /**
       * Decodes a LeadAddress message from the specified reader or buffer, length delimited.
       * @function decodeDelimited
       * @memberof propel.core.LeadAddress
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @returns {propel.core.LeadAddress} LeadAddress
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      LeadAddress.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader)) reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
      };

      /**
       * Verifies a LeadAddress message.
       * @function verify
       * @memberof propel.core.LeadAddress
       * @static
       * @param {Object.<string,*>} message Plain object to verify
       * @returns {string|null} `null` if valid, otherwise the reason why it is not
       */
      LeadAddress.verify = function verify(message) {
        if (typeof message !== 'object' || message === null) return 'object expected';
        if (message.address1 != null && message.hasOwnProperty('address1'))
          if (!$util.isString(message.address1)) return 'address1: string expected';
        if (message.address2 != null && message.hasOwnProperty('address2'))
          if (!$util.isString(message.address2)) return 'address2: string expected';
        if (message.city != null && message.hasOwnProperty('city'))
          if (!$util.isString(message.city)) return 'city: string expected';
        if (message.state != null && message.hasOwnProperty('state'))
          if (!$util.isString(message.state)) return 'state: string expected';
        if (message.zip != null && message.hasOwnProperty('zip'))
          if (!$util.isString(message.zip)) return 'zip: string expected';
        return null;
      };

      /**
       * Creates a LeadAddress message from a plain object. Also converts values to their respective internal types.
       * @function fromObject
       * @memberof propel.core.LeadAddress
       * @static
       * @param {Object.<string,*>} object Plain object
       * @returns {propel.core.LeadAddress} LeadAddress
       */
      LeadAddress.fromObject = function fromObject(object) {
        if (object instanceof $root.propel.core.LeadAddress) return object;
        var message = new $root.propel.core.LeadAddress();
        if (object.address1 != null) message.address1 = String(object.address1);
        if (object.address2 != null) message.address2 = String(object.address2);
        if (object.city != null) message.city = String(object.city);
        if (object.state != null) message.state = String(object.state);
        if (object.zip != null) message.zip = String(object.zip);
        return message;
      };

      /**
       * Creates a plain object from a LeadAddress message. Also converts values to other types if specified.
       * @function toObject
       * @memberof propel.core.LeadAddress
       * @static
       * @param {propel.core.LeadAddress} message LeadAddress
       * @param {$protobuf.IConversionOptions} [options] Conversion options
       * @returns {Object.<string,*>} Plain object
       */
      LeadAddress.toObject = function toObject(message, options) {
        if (!options) options = {};
        var object = {};
        if (options.defaults) {
          object.address1 = '';
          object.address2 = '';
          object.city = '';
          object.state = '';
          object.zip = '';
        }
        if (message.address1 != null && message.hasOwnProperty('address1'))
          object.address1 = message.address1;
        if (message.address2 != null && message.hasOwnProperty('address2'))
          object.address2 = message.address2;
        if (message.city != null && message.hasOwnProperty('city')) object.city = message.city;
        if (message.state != null && message.hasOwnProperty('state')) object.state = message.state;
        if (message.zip != null && message.hasOwnProperty('zip')) object.zip = message.zip;
        return object;
      };

      /**
       * Converts this LeadAddress to JSON.
       * @function toJSON
       * @memberof propel.core.LeadAddress
       * @instance
       * @returns {Object.<string,*>} JSON object
       */
      LeadAddress.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
      };

      return LeadAddress;
    })();

    core.LeadCustomer = (function () {
      /**
       * Properties of a LeadCustomer.
       * @memberof propel.core
       * @interface ILeadCustomer
       * @property {google.protobuf.IStringValue|null} [userProfileId] LeadCustomer userProfileId
       * @property {Object.<string,string>|null} [userInfo] LeadCustomer userInfo
       * @property {google.protobuf.IStringValue|null} [name] LeadCustomer name
       * @property {google.protobuf.IStringValue|null} [phoneNumber] LeadCustomer phoneNumber
       * @property {google.protobuf.IStringValue|null} [email] LeadCustomer email
       * @property {propel.core.ILeadAddress|null} [address] LeadCustomer address
       * @property {google.protobuf.IStringValue|null} [comments] LeadCustomer comments
       */

      /**
       * Constructs a new LeadCustomer.
       * @memberof propel.core
       * @classdesc Represents a LeadCustomer.
       * @implements ILeadCustomer
       * @constructor
       * @param {propel.core.ILeadCustomer=} [properties] Properties to set
       */
      function LeadCustomer(properties) {
        this.userInfo = {};
        if (properties)
          for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
      }

      /**
       * LeadCustomer userProfileId.
       * @member {google.protobuf.IStringValue|null|undefined} userProfileId
       * @memberof propel.core.LeadCustomer
       * @instance
       */
      LeadCustomer.prototype.userProfileId = null;

      /**
       * LeadCustomer userInfo.
       * @member {Object.<string,string>} userInfo
       * @memberof propel.core.LeadCustomer
       * @instance
       */
      LeadCustomer.prototype.userInfo = $util.emptyObject;

      /**
       * LeadCustomer name.
       * @member {google.protobuf.IStringValue|null|undefined} name
       * @memberof propel.core.LeadCustomer
       * @instance
       */
      LeadCustomer.prototype.name = null;

      /**
       * LeadCustomer phoneNumber.
       * @member {google.protobuf.IStringValue|null|undefined} phoneNumber
       * @memberof propel.core.LeadCustomer
       * @instance
       */
      LeadCustomer.prototype.phoneNumber = null;

      /**
       * LeadCustomer email.
       * @member {google.protobuf.IStringValue|null|undefined} email
       * @memberof propel.core.LeadCustomer
       * @instance
       */
      LeadCustomer.prototype.email = null;

      /**
       * LeadCustomer address.
       * @member {propel.core.ILeadAddress|null|undefined} address
       * @memberof propel.core.LeadCustomer
       * @instance
       */
      LeadCustomer.prototype.address = null;

      /**
       * LeadCustomer comments.
       * @member {google.protobuf.IStringValue|null|undefined} comments
       * @memberof propel.core.LeadCustomer
       * @instance
       */
      LeadCustomer.prototype.comments = null;

      /**
       * Creates a new LeadCustomer instance using the specified properties.
       * @function create
       * @memberof propel.core.LeadCustomer
       * @static
       * @param {propel.core.ILeadCustomer=} [properties] Properties to set
       * @returns {propel.core.LeadCustomer} LeadCustomer instance
       */
      LeadCustomer.create = function create(properties) {
        return new LeadCustomer(properties);
      };

      /**
       * Encodes the specified LeadCustomer message. Does not implicitly {@link propel.core.LeadCustomer.verify|verify} messages.
       * @function encode
       * @memberof propel.core.LeadCustomer
       * @static
       * @param {propel.core.ILeadCustomer} message LeadCustomer message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      LeadCustomer.encode = function encode(message, writer) {
        if (!writer) writer = $Writer.create();
        if (message.userProfileId != null && message.hasOwnProperty('userProfileId'))
          $root.google.protobuf.StringValue.encode(
            message.userProfileId,
            writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
          ).ldelim();
        if (message.userInfo != null && message.hasOwnProperty('userInfo'))
          for (var keys = Object.keys(message.userInfo), i = 0; i < keys.length; ++i)
            writer
              .uint32(/* id 2, wireType 2 =*/ 18)
              .fork()
              .uint32(/* id 1, wireType 2 =*/ 10)
              .string(keys[i])
              .uint32(/* id 2, wireType 2 =*/ 18)
              .string(message.userInfo[keys[i]])
              .ldelim();
        if (message.name != null && message.hasOwnProperty('name'))
          $root.google.protobuf.StringValue.encode(
            message.name,
            writer.uint32(/* id 3, wireType 2 =*/ 26).fork()
          ).ldelim();
        if (message.phoneNumber != null && message.hasOwnProperty('phoneNumber'))
          $root.google.protobuf.StringValue.encode(
            message.phoneNumber,
            writer.uint32(/* id 4, wireType 2 =*/ 34).fork()
          ).ldelim();
        if (message.email != null && message.hasOwnProperty('email'))
          $root.google.protobuf.StringValue.encode(
            message.email,
            writer.uint32(/* id 5, wireType 2 =*/ 42).fork()
          ).ldelim();
        if (message.address != null && message.hasOwnProperty('address'))
          $root.propel.core.LeadAddress.encode(
            message.address,
            writer.uint32(/* id 6, wireType 2 =*/ 50).fork()
          ).ldelim();
        if (message.comments != null && message.hasOwnProperty('comments'))
          $root.google.protobuf.StringValue.encode(
            message.comments,
            writer.uint32(/* id 7, wireType 2 =*/ 58).fork()
          ).ldelim();
        return writer;
      };

      /**
       * Encodes the specified LeadCustomer message, length delimited. Does not implicitly {@link propel.core.LeadCustomer.verify|verify} messages.
       * @function encodeDelimited
       * @memberof propel.core.LeadCustomer
       * @static
       * @param {propel.core.ILeadCustomer} message LeadCustomer message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      LeadCustomer.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
      };

      /**
       * Decodes a LeadCustomer message from the specified reader or buffer.
       * @function decode
       * @memberof propel.core.LeadCustomer
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @param {number} [length] Message length if known beforehand
       * @returns {propel.core.LeadCustomer} LeadCustomer
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      LeadCustomer.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length,
          message = new $root.propel.core.LeadCustomer(),
          key;
        while (reader.pos < end) {
          var tag = reader.uint32();
          switch (tag >>> 3) {
            case 1:
              message.userProfileId = $root.google.protobuf.StringValue.decode(
                reader,
                reader.uint32()
              );
              break;
            case 2:
              reader.skip().pos++;
              if (message.userInfo === $util.emptyObject) message.userInfo = {};
              key = reader.string();
              reader.pos++;
              message.userInfo[key] = reader.string();
              break;
            case 3:
              message.name = $root.google.protobuf.StringValue.decode(reader, reader.uint32());
              break;
            case 4:
              message.phoneNumber = $root.google.protobuf.StringValue.decode(
                reader,
                reader.uint32()
              );
              break;
            case 5:
              message.email = $root.google.protobuf.StringValue.decode(reader, reader.uint32());
              break;
            case 6:
              message.address = $root.propel.core.LeadAddress.decode(reader, reader.uint32());
              break;
            case 7:
              message.comments = $root.google.protobuf.StringValue.decode(reader, reader.uint32());
              break;
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };

      /**
       * Decodes a LeadCustomer message from the specified reader or buffer, length delimited.
       * @function decodeDelimited
       * @memberof propel.core.LeadCustomer
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @returns {propel.core.LeadCustomer} LeadCustomer
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      LeadCustomer.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader)) reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
      };

      /**
       * Verifies a LeadCustomer message.
       * @function verify
       * @memberof propel.core.LeadCustomer
       * @static
       * @param {Object.<string,*>} message Plain object to verify
       * @returns {string|null} `null` if valid, otherwise the reason why it is not
       */
      LeadCustomer.verify = function verify(message) {
        if (typeof message !== 'object' || message === null) return 'object expected';
        if (message.userProfileId != null && message.hasOwnProperty('userProfileId')) {
          var error = $root.google.protobuf.StringValue.verify(message.userProfileId);
          if (error) return 'userProfileId.' + error;
        }
        if (message.userInfo != null && message.hasOwnProperty('userInfo')) {
          if (!$util.isObject(message.userInfo)) return 'userInfo: object expected';
          var key = Object.keys(message.userInfo);
          for (var i = 0; i < key.length; ++i)
            if (!$util.isString(message.userInfo[key[i]]))
              return 'userInfo: string{k:string} expected';
        }
        if (message.name != null && message.hasOwnProperty('name')) {
          var error = $root.google.protobuf.StringValue.verify(message.name);
          if (error) return 'name.' + error;
        }
        if (message.phoneNumber != null && message.hasOwnProperty('phoneNumber')) {
          var error = $root.google.protobuf.StringValue.verify(message.phoneNumber);
          if (error) return 'phoneNumber.' + error;
        }
        if (message.email != null && message.hasOwnProperty('email')) {
          var error = $root.google.protobuf.StringValue.verify(message.email);
          if (error) return 'email.' + error;
        }
        if (message.address != null && message.hasOwnProperty('address')) {
          var error = $root.propel.core.LeadAddress.verify(message.address);
          if (error) return 'address.' + error;
        }
        if (message.comments != null && message.hasOwnProperty('comments')) {
          var error = $root.google.protobuf.StringValue.verify(message.comments);
          if (error) return 'comments.' + error;
        }
        return null;
      };

      /**
       * Creates a LeadCustomer message from a plain object. Also converts values to their respective internal types.
       * @function fromObject
       * @memberof propel.core.LeadCustomer
       * @static
       * @param {Object.<string,*>} object Plain object
       * @returns {propel.core.LeadCustomer} LeadCustomer
       */
      LeadCustomer.fromObject = function fromObject(object) {
        if (object instanceof $root.propel.core.LeadCustomer) return object;
        var message = new $root.propel.core.LeadCustomer();
        if (object.userProfileId != null) {
          if (typeof object.userProfileId !== 'object')
            throw TypeError('.propel.core.LeadCustomer.userProfileId: object expected');
          message.userProfileId = $root.google.protobuf.StringValue.fromObject(
            object.userProfileId
          );
        }
        if (object.userInfo) {
          if (typeof object.userInfo !== 'object')
            throw TypeError('.propel.core.LeadCustomer.userInfo: object expected');
          message.userInfo = {};
          for (var keys = Object.keys(object.userInfo), i = 0; i < keys.length; ++i)
            message.userInfo[keys[i]] = String(object.userInfo[keys[i]]);
        }
        if (object.name != null) {
          if (typeof object.name !== 'object')
            throw TypeError('.propel.core.LeadCustomer.name: object expected');
          message.name = $root.google.protobuf.StringValue.fromObject(object.name);
        }
        if (object.phoneNumber != null) {
          if (typeof object.phoneNumber !== 'object')
            throw TypeError('.propel.core.LeadCustomer.phoneNumber: object expected');
          message.phoneNumber = $root.google.protobuf.StringValue.fromObject(object.phoneNumber);
        }
        if (object.email != null) {
          if (typeof object.email !== 'object')
            throw TypeError('.propel.core.LeadCustomer.email: object expected');
          message.email = $root.google.protobuf.StringValue.fromObject(object.email);
        }
        if (object.address != null) {
          if (typeof object.address !== 'object')
            throw TypeError('.propel.core.LeadCustomer.address: object expected');
          message.address = $root.propel.core.LeadAddress.fromObject(object.address);
        }
        if (object.comments != null) {
          if (typeof object.comments !== 'object')
            throw TypeError('.propel.core.LeadCustomer.comments: object expected');
          message.comments = $root.google.protobuf.StringValue.fromObject(object.comments);
        }
        return message;
      };

      /**
       * Creates a plain object from a LeadCustomer message. Also converts values to other types if specified.
       * @function toObject
       * @memberof propel.core.LeadCustomer
       * @static
       * @param {propel.core.LeadCustomer} message LeadCustomer
       * @param {$protobuf.IConversionOptions} [options] Conversion options
       * @returns {Object.<string,*>} Plain object
       */
      LeadCustomer.toObject = function toObject(message, options) {
        if (!options) options = {};
        var object = {};
        if (options.objects || options.defaults) object.userInfo = {};
        if (options.defaults) {
          object.userProfileId = null;
          object.name = null;
          object.phoneNumber = null;
          object.email = null;
          object.address = null;
          object.comments = null;
        }
        if (message.userProfileId != null && message.hasOwnProperty('userProfileId'))
          object.userProfileId = $root.google.protobuf.StringValue.toObject(
            message.userProfileId,
            options
          );
        var keys2;
        if (message.userInfo && (keys2 = Object.keys(message.userInfo)).length) {
          object.userInfo = {};
          for (var j = 0; j < keys2.length; ++j)
            object.userInfo[keys2[j]] = message.userInfo[keys2[j]];
        }
        if (message.name != null && message.hasOwnProperty('name'))
          object.name = $root.google.protobuf.StringValue.toObject(message.name, options);
        if (message.phoneNumber != null && message.hasOwnProperty('phoneNumber'))
          object.phoneNumber = $root.google.protobuf.StringValue.toObject(
            message.phoneNumber,
            options
          );
        if (message.email != null && message.hasOwnProperty('email'))
          object.email = $root.google.protobuf.StringValue.toObject(message.email, options);
        if (message.address != null && message.hasOwnProperty('address'))
          object.address = $root.propel.core.LeadAddress.toObject(message.address, options);
        if (message.comments != null && message.hasOwnProperty('comments'))
          object.comments = $root.google.protobuf.StringValue.toObject(message.comments, options);
        return object;
      };

      /**
       * Converts this LeadCustomer to JSON.
       * @function toJSON
       * @memberof propel.core.LeadCustomer
       * @instance
       * @returns {Object.<string,*>} JSON object
       */
      LeadCustomer.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
      };

      return LeadCustomer;
    })();

    core.LeadFinancing = (function () {
      /**
       * Properties of a LeadFinancing.
       * @memberof propel.core
       * @interface ILeadFinancing
       * @property {google.protobuf.IUInt32Value|null} [preferredLoanAmount] LeadFinancing preferredLoanAmount
       * @property {google.protobuf.IUInt32Value|null} [preferredPaymentAmount] LeadFinancing preferredPaymentAmount
       * @property {google.protobuf.IStringValue|null} [softPullStatus] LeadFinancing softPullStatus
       */

      /**
       * Constructs a new LeadFinancing.
       * @memberof propel.core
       * @classdesc Represents a LeadFinancing.
       * @implements ILeadFinancing
       * @constructor
       * @param {propel.core.ILeadFinancing=} [properties] Properties to set
       */
      function LeadFinancing(properties) {
        if (properties)
          for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
      }

      /**
       * LeadFinancing preferredLoanAmount.
       * @member {google.protobuf.IUInt32Value|null|undefined} preferredLoanAmount
       * @memberof propel.core.LeadFinancing
       * @instance
       */
      LeadFinancing.prototype.preferredLoanAmount = null;

      /**
       * LeadFinancing preferredPaymentAmount.
       * @member {google.protobuf.IUInt32Value|null|undefined} preferredPaymentAmount
       * @memberof propel.core.LeadFinancing
       * @instance
       */
      LeadFinancing.prototype.preferredPaymentAmount = null;

      /**
       * LeadFinancing softPullStatus.
       * @member {google.protobuf.IStringValue|null|undefined} softPullStatus
       * @memberof propel.core.LeadFinancing
       * @instance
       */
      LeadFinancing.prototype.softPullStatus = null;

      /**
       * Creates a new LeadFinancing instance using the specified properties.
       * @function create
       * @memberof propel.core.LeadFinancing
       * @static
       * @param {propel.core.ILeadFinancing=} [properties] Properties to set
       * @returns {propel.core.LeadFinancing} LeadFinancing instance
       */
      LeadFinancing.create = function create(properties) {
        return new LeadFinancing(properties);
      };

      /**
       * Encodes the specified LeadFinancing message. Does not implicitly {@link propel.core.LeadFinancing.verify|verify} messages.
       * @function encode
       * @memberof propel.core.LeadFinancing
       * @static
       * @param {propel.core.ILeadFinancing} message LeadFinancing message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      LeadFinancing.encode = function encode(message, writer) {
        if (!writer) writer = $Writer.create();
        if (message.preferredLoanAmount != null && message.hasOwnProperty('preferredLoanAmount'))
          $root.google.protobuf.UInt32Value.encode(
            message.preferredLoanAmount,
            writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
          ).ldelim();
        if (
          message.preferredPaymentAmount != null &&
          message.hasOwnProperty('preferredPaymentAmount')
        )
          $root.google.protobuf.UInt32Value.encode(
            message.preferredPaymentAmount,
            writer.uint32(/* id 2, wireType 2 =*/ 18).fork()
          ).ldelim();
        if (message.softPullStatus != null && message.hasOwnProperty('softPullStatus'))
          $root.google.protobuf.StringValue.encode(
            message.softPullStatus,
            writer.uint32(/* id 3, wireType 2 =*/ 26).fork()
          ).ldelim();
        return writer;
      };

      /**
       * Encodes the specified LeadFinancing message, length delimited. Does not implicitly {@link propel.core.LeadFinancing.verify|verify} messages.
       * @function encodeDelimited
       * @memberof propel.core.LeadFinancing
       * @static
       * @param {propel.core.ILeadFinancing} message LeadFinancing message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      LeadFinancing.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
      };

      /**
       * Decodes a LeadFinancing message from the specified reader or buffer.
       * @function decode
       * @memberof propel.core.LeadFinancing
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @param {number} [length] Message length if known beforehand
       * @returns {propel.core.LeadFinancing} LeadFinancing
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      LeadFinancing.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length,
          message = new $root.propel.core.LeadFinancing();
        while (reader.pos < end) {
          var tag = reader.uint32();
          switch (tag >>> 3) {
            case 1:
              message.preferredLoanAmount = $root.google.protobuf.UInt32Value.decode(
                reader,
                reader.uint32()
              );
              break;
            case 2:
              message.preferredPaymentAmount = $root.google.protobuf.UInt32Value.decode(
                reader,
                reader.uint32()
              );
              break;
            case 3:
              message.softPullStatus = $root.google.protobuf.StringValue.decode(
                reader,
                reader.uint32()
              );
              break;
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };

      /**
       * Decodes a LeadFinancing message from the specified reader or buffer, length delimited.
       * @function decodeDelimited
       * @memberof propel.core.LeadFinancing
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @returns {propel.core.LeadFinancing} LeadFinancing
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      LeadFinancing.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader)) reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
      };

      /**
       * Verifies a LeadFinancing message.
       * @function verify
       * @memberof propel.core.LeadFinancing
       * @static
       * @param {Object.<string,*>} message Plain object to verify
       * @returns {string|null} `null` if valid, otherwise the reason why it is not
       */
      LeadFinancing.verify = function verify(message) {
        if (typeof message !== 'object' || message === null) return 'object expected';
        if (message.preferredLoanAmount != null && message.hasOwnProperty('preferredLoanAmount')) {
          var error = $root.google.protobuf.UInt32Value.verify(message.preferredLoanAmount);
          if (error) return 'preferredLoanAmount.' + error;
        }
        if (
          message.preferredPaymentAmount != null &&
          message.hasOwnProperty('preferredPaymentAmount')
        ) {
          var error = $root.google.protobuf.UInt32Value.verify(message.preferredPaymentAmount);
          if (error) return 'preferredPaymentAmount.' + error;
        }
        if (message.softPullStatus != null && message.hasOwnProperty('softPullStatus')) {
          var error = $root.google.protobuf.StringValue.verify(message.softPullStatus);
          if (error) return 'softPullStatus.' + error;
        }
        return null;
      };

      /**
       * Creates a LeadFinancing message from a plain object. Also converts values to their respective internal types.
       * @function fromObject
       * @memberof propel.core.LeadFinancing
       * @static
       * @param {Object.<string,*>} object Plain object
       * @returns {propel.core.LeadFinancing} LeadFinancing
       */
      LeadFinancing.fromObject = function fromObject(object) {
        if (object instanceof $root.propel.core.LeadFinancing) return object;
        var message = new $root.propel.core.LeadFinancing();
        if (object.preferredLoanAmount != null) {
          if (typeof object.preferredLoanAmount !== 'object')
            throw TypeError('.propel.core.LeadFinancing.preferredLoanAmount: object expected');
          message.preferredLoanAmount = $root.google.protobuf.UInt32Value.fromObject(
            object.preferredLoanAmount
          );
        }
        if (object.preferredPaymentAmount != null) {
          if (typeof object.preferredPaymentAmount !== 'object')
            throw TypeError('.propel.core.LeadFinancing.preferredPaymentAmount: object expected');
          message.preferredPaymentAmount = $root.google.protobuf.UInt32Value.fromObject(
            object.preferredPaymentAmount
          );
        }
        if (object.softPullStatus != null) {
          if (typeof object.softPullStatus !== 'object')
            throw TypeError('.propel.core.LeadFinancing.softPullStatus: object expected');
          message.softPullStatus = $root.google.protobuf.StringValue.fromObject(
            object.softPullStatus
          );
        }
        return message;
      };

      /**
       * Creates a plain object from a LeadFinancing message. Also converts values to other types if specified.
       * @function toObject
       * @memberof propel.core.LeadFinancing
       * @static
       * @param {propel.core.LeadFinancing} message LeadFinancing
       * @param {$protobuf.IConversionOptions} [options] Conversion options
       * @returns {Object.<string,*>} Plain object
       */
      LeadFinancing.toObject = function toObject(message, options) {
        if (!options) options = {};
        var object = {};
        if (options.defaults) {
          object.preferredLoanAmount = null;
          object.preferredPaymentAmount = null;
          object.softPullStatus = null;
        }
        if (message.preferredLoanAmount != null && message.hasOwnProperty('preferredLoanAmount'))
          object.preferredLoanAmount = $root.google.protobuf.UInt32Value.toObject(
            message.preferredLoanAmount,
            options
          );
        if (
          message.preferredPaymentAmount != null &&
          message.hasOwnProperty('preferredPaymentAmount')
        )
          object.preferredPaymentAmount = $root.google.protobuf.UInt32Value.toObject(
            message.preferredPaymentAmount,
            options
          );
        if (message.softPullStatus != null && message.hasOwnProperty('softPullStatus'))
          object.softPullStatus = $root.google.protobuf.StringValue.toObject(
            message.softPullStatus,
            options
          );
        return object;
      };

      /**
       * Converts this LeadFinancing to JSON.
       * @function toJSON
       * @memberof propel.core.LeadFinancing
       * @instance
       * @returns {Object.<string,*>} JSON object
       */
      LeadFinancing.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
      };

      return LeadFinancing;
    })();

    core.LeadExperiment = (function () {
      /**
       * Properties of a LeadExperiment.
       * @memberof propel.core
       * @interface ILeadExperiment
       * @property {google.protobuf.IStringValue|null} [provider] LeadExperiment provider
       * @property {string|null} [name] LeadExperiment name
       * @property {string|null} [id] LeadExperiment id
       */

      /**
       * Constructs a new LeadExperiment.
       * @memberof propel.core
       * @classdesc Represents a LeadExperiment.
       * @implements ILeadExperiment
       * @constructor
       * @param {propel.core.ILeadExperiment=} [properties] Properties to set
       */
      function LeadExperiment(properties) {
        if (properties)
          for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
      }

      /**
       * LeadExperiment provider.
       * @member {google.protobuf.IStringValue|null|undefined} provider
       * @memberof propel.core.LeadExperiment
       * @instance
       */
      LeadExperiment.prototype.provider = null;

      /**
       * LeadExperiment name.
       * @member {string} name
       * @memberof propel.core.LeadExperiment
       * @instance
       */
      LeadExperiment.prototype.name = '';

      /**
       * LeadExperiment id.
       * @member {string} id
       * @memberof propel.core.LeadExperiment
       * @instance
       */
      LeadExperiment.prototype.id = '';

      /**
       * Creates a new LeadExperiment instance using the specified properties.
       * @function create
       * @memberof propel.core.LeadExperiment
       * @static
       * @param {propel.core.ILeadExperiment=} [properties] Properties to set
       * @returns {propel.core.LeadExperiment} LeadExperiment instance
       */
      LeadExperiment.create = function create(properties) {
        return new LeadExperiment(properties);
      };

      /**
       * Encodes the specified LeadExperiment message. Does not implicitly {@link propel.core.LeadExperiment.verify|verify} messages.
       * @function encode
       * @memberof propel.core.LeadExperiment
       * @static
       * @param {propel.core.ILeadExperiment} message LeadExperiment message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      LeadExperiment.encode = function encode(message, writer) {
        if (!writer) writer = $Writer.create();
        if (message.provider != null && message.hasOwnProperty('provider'))
          $root.google.protobuf.StringValue.encode(
            message.provider,
            writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
          ).ldelim();
        if (message.name != null && message.hasOwnProperty('name'))
          writer.uint32(/* id 2, wireType 2 =*/ 18).string(message.name);
        if (message.id != null && message.hasOwnProperty('id'))
          writer.uint32(/* id 3, wireType 2 =*/ 26).string(message.id);
        return writer;
      };

      /**
       * Encodes the specified LeadExperiment message, length delimited. Does not implicitly {@link propel.core.LeadExperiment.verify|verify} messages.
       * @function encodeDelimited
       * @memberof propel.core.LeadExperiment
       * @static
       * @param {propel.core.ILeadExperiment} message LeadExperiment message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      LeadExperiment.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
      };

      /**
       * Decodes a LeadExperiment message from the specified reader or buffer.
       * @function decode
       * @memberof propel.core.LeadExperiment
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @param {number} [length] Message length if known beforehand
       * @returns {propel.core.LeadExperiment} LeadExperiment
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      LeadExperiment.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length,
          message = new $root.propel.core.LeadExperiment();
        while (reader.pos < end) {
          var tag = reader.uint32();
          switch (tag >>> 3) {
            case 1:
              message.provider = $root.google.protobuf.StringValue.decode(reader, reader.uint32());
              break;
            case 2:
              message.name = reader.string();
              break;
            case 3:
              message.id = reader.string();
              break;
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };

      /**
       * Decodes a LeadExperiment message from the specified reader or buffer, length delimited.
       * @function decodeDelimited
       * @memberof propel.core.LeadExperiment
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @returns {propel.core.LeadExperiment} LeadExperiment
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      LeadExperiment.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader)) reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
      };

      /**
       * Verifies a LeadExperiment message.
       * @function verify
       * @memberof propel.core.LeadExperiment
       * @static
       * @param {Object.<string,*>} message Plain object to verify
       * @returns {string|null} `null` if valid, otherwise the reason why it is not
       */
      LeadExperiment.verify = function verify(message) {
        if (typeof message !== 'object' || message === null) return 'object expected';
        if (message.provider != null && message.hasOwnProperty('provider')) {
          var error = $root.google.protobuf.StringValue.verify(message.provider);
          if (error) return 'provider.' + error;
        }
        if (message.name != null && message.hasOwnProperty('name'))
          if (!$util.isString(message.name)) return 'name: string expected';
        if (message.id != null && message.hasOwnProperty('id'))
          if (!$util.isString(message.id)) return 'id: string expected';
        return null;
      };

      /**
       * Creates a LeadExperiment message from a plain object. Also converts values to their respective internal types.
       * @function fromObject
       * @memberof propel.core.LeadExperiment
       * @static
       * @param {Object.<string,*>} object Plain object
       * @returns {propel.core.LeadExperiment} LeadExperiment
       */
      LeadExperiment.fromObject = function fromObject(object) {
        if (object instanceof $root.propel.core.LeadExperiment) return object;
        var message = new $root.propel.core.LeadExperiment();
        if (object.provider != null) {
          if (typeof object.provider !== 'object')
            throw TypeError('.propel.core.LeadExperiment.provider: object expected');
          message.provider = $root.google.protobuf.StringValue.fromObject(object.provider);
        }
        if (object.name != null) message.name = String(object.name);
        if (object.id != null) message.id = String(object.id);
        return message;
      };

      /**
       * Creates a plain object from a LeadExperiment message. Also converts values to other types if specified.
       * @function toObject
       * @memberof propel.core.LeadExperiment
       * @static
       * @param {propel.core.LeadExperiment} message LeadExperiment
       * @param {$protobuf.IConversionOptions} [options] Conversion options
       * @returns {Object.<string,*>} Plain object
       */
      LeadExperiment.toObject = function toObject(message, options) {
        if (!options) options = {};
        var object = {};
        if (options.defaults) {
          object.provider = null;
          object.name = '';
          object.id = '';
        }
        if (message.provider != null && message.hasOwnProperty('provider'))
          object.provider = $root.google.protobuf.StringValue.toObject(message.provider, options);
        if (message.name != null && message.hasOwnProperty('name')) object.name = message.name;
        if (message.id != null && message.hasOwnProperty('id')) object.id = message.id;
        return object;
      };

      /**
       * Converts this LeadExperiment to JSON.
       * @function toJSON
       * @memberof propel.core.LeadExperiment
       * @instance
       * @returns {Object.<string,*>} JSON object
       */
      LeadExperiment.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
      };

      return LeadExperiment;
    })();

    core.IncomingLead = (function () {
      /**
       * Properties of an IncomingLead.
       * @memberof propel.core
       * @interface IIncomingLead
       * @property {string|null} [id] IncomingLead id
       * @property {propel.core.ILeadOrigin|null} [origin] IncomingLead origin
       * @property {propel.core.ILeadCustomer|null} [customer] IncomingLead customer
       * @property {propel.core.ILeadFinancing|null} [financing] IncomingLead financing
       * @property {google.protobuf.IStringValue|null} [dealershipId] IncomingLead dealershipId
       * @property {propel.core.IVehicle|null} [tradeInVehicle] IncomingLead tradeInVehicle
       * @property {propel.core.IVehicle|null} [interestVehicle] IncomingLead interestVehicle
       * @property {propel.core.LeadContactPreference|null} [contactPreference] IncomingLead contactPreference
       * @property {propel.core.LeadContactTimePreference|null} [contactTimePreference] IncomingLead contactTimePreference
       * @property {google.protobuf.IStringValue|null} [channel] IncomingLead channel
       * @property {google.protobuf.IStruct|null} [info] IncomingLead info
       * @property {propel.core.ILeadExperiment|null} [experiment] IncomingLead experiment
       */

      /**
       * Constructs a new IncomingLead.
       * @memberof propel.core
       * @classdesc Represents an IncomingLead.
       * @implements IIncomingLead
       * @constructor
       * @param {propel.core.IIncomingLead=} [properties] Properties to set
       */
      function IncomingLead(properties) {
        if (properties)
          for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
      }

      /**
       * IncomingLead id.
       * @member {string} id
       * @memberof propel.core.IncomingLead
       * @instance
       */
      IncomingLead.prototype.id = '';

      /**
       * IncomingLead origin.
       * @member {propel.core.ILeadOrigin|null|undefined} origin
       * @memberof propel.core.IncomingLead
       * @instance
       */
      IncomingLead.prototype.origin = null;

      /**
       * IncomingLead customer.
       * @member {propel.core.ILeadCustomer|null|undefined} customer
       * @memberof propel.core.IncomingLead
       * @instance
       */
      IncomingLead.prototype.customer = null;

      /**
       * IncomingLead financing.
       * @member {propel.core.ILeadFinancing|null|undefined} financing
       * @memberof propel.core.IncomingLead
       * @instance
       */
      IncomingLead.prototype.financing = null;

      /**
       * IncomingLead dealershipId.
       * @member {google.protobuf.IStringValue|null|undefined} dealershipId
       * @memberof propel.core.IncomingLead
       * @instance
       */
      IncomingLead.prototype.dealershipId = null;

      /**
       * IncomingLead tradeInVehicle.
       * @member {propel.core.IVehicle|null|undefined} tradeInVehicle
       * @memberof propel.core.IncomingLead
       * @instance
       */
      IncomingLead.prototype.tradeInVehicle = null;

      /**
       * IncomingLead interestVehicle.
       * @member {propel.core.IVehicle|null|undefined} interestVehicle
       * @memberof propel.core.IncomingLead
       * @instance
       */
      IncomingLead.prototype.interestVehicle = null;

      /**
       * IncomingLead contactPreference.
       * @member {propel.core.LeadContactPreference} contactPreference
       * @memberof propel.core.IncomingLead
       * @instance
       */
      IncomingLead.prototype.contactPreference = 0;

      /**
       * IncomingLead contactTimePreference.
       * @member {propel.core.LeadContactTimePreference} contactTimePreference
       * @memberof propel.core.IncomingLead
       * @instance
       */
      IncomingLead.prototype.contactTimePreference = 0;

      /**
       * IncomingLead channel.
       * @member {google.protobuf.IStringValue|null|undefined} channel
       * @memberof propel.core.IncomingLead
       * @instance
       */
      IncomingLead.prototype.channel = null;

      /**
       * IncomingLead info.
       * @member {google.protobuf.IStruct|null|undefined} info
       * @memberof propel.core.IncomingLead
       * @instance
       */
      IncomingLead.prototype.info = null;

      /**
       * IncomingLead experiment.
       * @member {propel.core.ILeadExperiment|null|undefined} experiment
       * @memberof propel.core.IncomingLead
       * @instance
       */
      IncomingLead.prototype.experiment = null;

      /**
       * Creates a new IncomingLead instance using the specified properties.
       * @function create
       * @memberof propel.core.IncomingLead
       * @static
       * @param {propel.core.IIncomingLead=} [properties] Properties to set
       * @returns {propel.core.IncomingLead} IncomingLead instance
       */
      IncomingLead.create = function create(properties) {
        return new IncomingLead(properties);
      };

      /**
       * Encodes the specified IncomingLead message. Does not implicitly {@link propel.core.IncomingLead.verify|verify} messages.
       * @function encode
       * @memberof propel.core.IncomingLead
       * @static
       * @param {propel.core.IIncomingLead} message IncomingLead message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      IncomingLead.encode = function encode(message, writer) {
        if (!writer) writer = $Writer.create();
        if (message.origin != null && message.hasOwnProperty('origin'))
          $root.propel.core.LeadOrigin.encode(
            message.origin,
            writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
          ).ldelim();
        if (message.customer != null && message.hasOwnProperty('customer'))
          $root.propel.core.LeadCustomer.encode(
            message.customer,
            writer.uint32(/* id 2, wireType 2 =*/ 18).fork()
          ).ldelim();
        if (message.tradeInVehicle != null && message.hasOwnProperty('tradeInVehicle'))
          $root.propel.core.Vehicle.encode(
            message.tradeInVehicle,
            writer.uint32(/* id 3, wireType 2 =*/ 26).fork()
          ).ldelim();
        if (message.interestVehicle != null && message.hasOwnProperty('interestVehicle'))
          $root.propel.core.Vehicle.encode(
            message.interestVehicle,
            writer.uint32(/* id 4, wireType 2 =*/ 34).fork()
          ).ldelim();
        if (message.contactPreference != null && message.hasOwnProperty('contactPreference'))
          writer.uint32(/* id 5, wireType 0 =*/ 40).int32(message.contactPreference);
        if (
          message.contactTimePreference != null &&
          message.hasOwnProperty('contactTimePreference')
        )
          writer.uint32(/* id 6, wireType 0 =*/ 48).int32(message.contactTimePreference);
        if (message.financing != null && message.hasOwnProperty('financing'))
          $root.propel.core.LeadFinancing.encode(
            message.financing,
            writer.uint32(/* id 7, wireType 2 =*/ 58).fork()
          ).ldelim();
        if (message.channel != null && message.hasOwnProperty('channel'))
          $root.google.protobuf.StringValue.encode(
            message.channel,
            writer.uint32(/* id 8, wireType 2 =*/ 66).fork()
          ).ldelim();
        if (message.id != null && message.hasOwnProperty('id'))
          writer.uint32(/* id 9, wireType 2 =*/ 74).string(message.id);
        if (message.info != null && message.hasOwnProperty('info'))
          $root.google.protobuf.Struct.encode(
            message.info,
            writer.uint32(/* id 10, wireType 2 =*/ 82).fork()
          ).ldelim();
        if (message.experiment != null && message.hasOwnProperty('experiment'))
          $root.propel.core.LeadExperiment.encode(
            message.experiment,
            writer.uint32(/* id 11, wireType 2 =*/ 90).fork()
          ).ldelim();
        if (message.dealershipId != null && message.hasOwnProperty('dealershipId'))
          $root.google.protobuf.StringValue.encode(
            message.dealershipId,
            writer.uint32(/* id 12, wireType 2 =*/ 98).fork()
          ).ldelim();
        return writer;
      };

      /**
       * Encodes the specified IncomingLead message, length delimited. Does not implicitly {@link propel.core.IncomingLead.verify|verify} messages.
       * @function encodeDelimited
       * @memberof propel.core.IncomingLead
       * @static
       * @param {propel.core.IIncomingLead} message IncomingLead message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      IncomingLead.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
      };

      /**
       * Decodes an IncomingLead message from the specified reader or buffer.
       * @function decode
       * @memberof propel.core.IncomingLead
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @param {number} [length] Message length if known beforehand
       * @returns {propel.core.IncomingLead} IncomingLead
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      IncomingLead.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length,
          message = new $root.propel.core.IncomingLead();
        while (reader.pos < end) {
          var tag = reader.uint32();
          switch (tag >>> 3) {
            case 9:
              message.id = reader.string();
              break;
            case 1:
              message.origin = $root.propel.core.LeadOrigin.decode(reader, reader.uint32());
              break;
            case 2:
              message.customer = $root.propel.core.LeadCustomer.decode(reader, reader.uint32());
              break;
            case 7:
              message.financing = $root.propel.core.LeadFinancing.decode(reader, reader.uint32());
              break;
            case 12:
              message.dealershipId = $root.google.protobuf.StringValue.decode(
                reader,
                reader.uint32()
              );
              break;
            case 3:
              message.tradeInVehicle = $root.propel.core.Vehicle.decode(reader, reader.uint32());
              break;
            case 4:
              message.interestVehicle = $root.propel.core.Vehicle.decode(reader, reader.uint32());
              break;
            case 5:
              message.contactPreference = reader.int32();
              break;
            case 6:
              message.contactTimePreference = reader.int32();
              break;
            case 8:
              message.channel = $root.google.protobuf.StringValue.decode(reader, reader.uint32());
              break;
            case 10:
              message.info = $root.google.protobuf.Struct.decode(reader, reader.uint32());
              break;
            case 11:
              message.experiment = $root.propel.core.LeadExperiment.decode(reader, reader.uint32());
              break;
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };

      /**
       * Decodes an IncomingLead message from the specified reader or buffer, length delimited.
       * @function decodeDelimited
       * @memberof propel.core.IncomingLead
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @returns {propel.core.IncomingLead} IncomingLead
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      IncomingLead.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader)) reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
      };

      /**
       * Verifies an IncomingLead message.
       * @function verify
       * @memberof propel.core.IncomingLead
       * @static
       * @param {Object.<string,*>} message Plain object to verify
       * @returns {string|null} `null` if valid, otherwise the reason why it is not
       */
      IncomingLead.verify = function verify(message) {
        if (typeof message !== 'object' || message === null) return 'object expected';
        if (message.id != null && message.hasOwnProperty('id'))
          if (!$util.isString(message.id)) return 'id: string expected';
        if (message.origin != null && message.hasOwnProperty('origin')) {
          var error = $root.propel.core.LeadOrigin.verify(message.origin);
          if (error) return 'origin.' + error;
        }
        if (message.customer != null && message.hasOwnProperty('customer')) {
          var error = $root.propel.core.LeadCustomer.verify(message.customer);
          if (error) return 'customer.' + error;
        }
        if (message.financing != null && message.hasOwnProperty('financing')) {
          var error = $root.propel.core.LeadFinancing.verify(message.financing);
          if (error) return 'financing.' + error;
        }
        if (message.dealershipId != null && message.hasOwnProperty('dealershipId')) {
          var error = $root.google.protobuf.StringValue.verify(message.dealershipId);
          if (error) return 'dealershipId.' + error;
        }
        if (message.tradeInVehicle != null && message.hasOwnProperty('tradeInVehicle')) {
          var error = $root.propel.core.Vehicle.verify(message.tradeInVehicle);
          if (error) return 'tradeInVehicle.' + error;
        }
        if (message.interestVehicle != null && message.hasOwnProperty('interestVehicle')) {
          var error = $root.propel.core.Vehicle.verify(message.interestVehicle);
          if (error) return 'interestVehicle.' + error;
        }
        if (message.contactPreference != null && message.hasOwnProperty('contactPreference'))
          switch (message.contactPreference) {
            default:
              return 'contactPreference: enum value expected';
            case 0:
            case 1:
            case 2:
            case 3:
              break;
          }
        if (
          message.contactTimePreference != null &&
          message.hasOwnProperty('contactTimePreference')
        )
          switch (message.contactTimePreference) {
            default:
              return 'contactTimePreference: enum value expected';
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
              break;
          }
        if (message.channel != null && message.hasOwnProperty('channel')) {
          var error = $root.google.protobuf.StringValue.verify(message.channel);
          if (error) return 'channel.' + error;
        }
        if (message.info != null && message.hasOwnProperty('info')) {
          var error = $root.google.protobuf.Struct.verify(message.info);
          if (error) return 'info.' + error;
        }
        if (message.experiment != null && message.hasOwnProperty('experiment')) {
          var error = $root.propel.core.LeadExperiment.verify(message.experiment);
          if (error) return 'experiment.' + error;
        }
        return null;
      };

      /**
       * Creates an IncomingLead message from a plain object. Also converts values to their respective internal types.
       * @function fromObject
       * @memberof propel.core.IncomingLead
       * @static
       * @param {Object.<string,*>} object Plain object
       * @returns {propel.core.IncomingLead} IncomingLead
       */
      IncomingLead.fromObject = function fromObject(object) {
        if (object instanceof $root.propel.core.IncomingLead) return object;
        var message = new $root.propel.core.IncomingLead();
        if (object.id != null) message.id = String(object.id);
        if (object.origin != null) {
          if (typeof object.origin !== 'object')
            throw TypeError('.propel.core.IncomingLead.origin: object expected');
          message.origin = $root.propel.core.LeadOrigin.fromObject(object.origin);
        }
        if (object.customer != null) {
          if (typeof object.customer !== 'object')
            throw TypeError('.propel.core.IncomingLead.customer: object expected');
          message.customer = $root.propel.core.LeadCustomer.fromObject(object.customer);
        }
        if (object.financing != null) {
          if (typeof object.financing !== 'object')
            throw TypeError('.propel.core.IncomingLead.financing: object expected');
          message.financing = $root.propel.core.LeadFinancing.fromObject(object.financing);
        }
        if (object.dealershipId != null) {
          if (typeof object.dealershipId !== 'object')
            throw TypeError('.propel.core.IncomingLead.dealershipId: object expected');
          message.dealershipId = $root.google.protobuf.StringValue.fromObject(object.dealershipId);
        }
        if (object.tradeInVehicle != null) {
          if (typeof object.tradeInVehicle !== 'object')
            throw TypeError('.propel.core.IncomingLead.tradeInVehicle: object expected');
          message.tradeInVehicle = $root.propel.core.Vehicle.fromObject(object.tradeInVehicle);
        }
        if (object.interestVehicle != null) {
          if (typeof object.interestVehicle !== 'object')
            throw TypeError('.propel.core.IncomingLead.interestVehicle: object expected');
          message.interestVehicle = $root.propel.core.Vehicle.fromObject(object.interestVehicle);
        }
        switch (object.contactPreference) {
          case 'CONTACT_UNKNOWN':
          case 0:
            message.contactPreference = 0;
            break;
          case 'CONTACT_EMAIL':
          case 1:
            message.contactPreference = 1;
            break;
          case 'CONTACT_SMS':
          case 2:
            message.contactPreference = 2;
            break;
          case 'CONTACT_CALL':
          case 3:
            message.contactPreference = 3;
            break;
        }
        switch (object.contactTimePreference) {
          case 'TIME_UNKNOWN':
          case 0:
            message.contactTimePreference = 0;
            break;
          case 'TIME_MORNING':
          case 1:
            message.contactTimePreference = 1;
            break;
          case 'TIME_AFTERNOON':
          case 2:
            message.contactTimePreference = 2;
            break;
          case 'TIME_EVENING':
          case 3:
            message.contactTimePreference = 3;
            break;
          case 'TIME_DAY':
          case 4:
            message.contactTimePreference = 4;
            break;
        }
        if (object.channel != null) {
          if (typeof object.channel !== 'object')
            throw TypeError('.propel.core.IncomingLead.channel: object expected');
          message.channel = $root.google.protobuf.StringValue.fromObject(object.channel);
        }
        if (object.info != null) {
          if (typeof object.info !== 'object')
            throw TypeError('.propel.core.IncomingLead.info: object expected');
          message.info = $root.google.protobuf.Struct.fromObject(object.info);
        }
        if (object.experiment != null) {
          if (typeof object.experiment !== 'object')
            throw TypeError('.propel.core.IncomingLead.experiment: object expected');
          message.experiment = $root.propel.core.LeadExperiment.fromObject(object.experiment);
        }
        return message;
      };

      /**
       * Creates a plain object from an IncomingLead message. Also converts values to other types if specified.
       * @function toObject
       * @memberof propel.core.IncomingLead
       * @static
       * @param {propel.core.IncomingLead} message IncomingLead
       * @param {$protobuf.IConversionOptions} [options] Conversion options
       * @returns {Object.<string,*>} Plain object
       */
      IncomingLead.toObject = function toObject(message, options) {
        if (!options) options = {};
        var object = {};
        if (options.defaults) {
          object.origin = null;
          object.customer = null;
          object.tradeInVehicle = null;
          object.interestVehicle = null;
          object.contactPreference = options.enums === String ? 'CONTACT_UNKNOWN' : 0;
          object.contactTimePreference = options.enums === String ? 'TIME_UNKNOWN' : 0;
          object.financing = null;
          object.channel = null;
          object.id = '';
          object.info = null;
          object.experiment = null;
          object.dealershipId = null;
        }
        if (message.origin != null && message.hasOwnProperty('origin'))
          object.origin = $root.propel.core.LeadOrigin.toObject(message.origin, options);
        if (message.customer != null && message.hasOwnProperty('customer'))
          object.customer = $root.propel.core.LeadCustomer.toObject(message.customer, options);
        if (message.tradeInVehicle != null && message.hasOwnProperty('tradeInVehicle'))
          object.tradeInVehicle = $root.propel.core.Vehicle.toObject(
            message.tradeInVehicle,
            options
          );
        if (message.interestVehicle != null && message.hasOwnProperty('interestVehicle'))
          object.interestVehicle = $root.propel.core.Vehicle.toObject(
            message.interestVehicle,
            options
          );
        if (message.contactPreference != null && message.hasOwnProperty('contactPreference'))
          object.contactPreference =
            options.enums === String
              ? $root.propel.core.LeadContactPreference[message.contactPreference]
              : message.contactPreference;
        if (
          message.contactTimePreference != null &&
          message.hasOwnProperty('contactTimePreference')
        )
          object.contactTimePreference =
            options.enums === String
              ? $root.propel.core.LeadContactTimePreference[message.contactTimePreference]
              : message.contactTimePreference;
        if (message.financing != null && message.hasOwnProperty('financing'))
          object.financing = $root.propel.core.LeadFinancing.toObject(message.financing, options);
        if (message.channel != null && message.hasOwnProperty('channel'))
          object.channel = $root.google.protobuf.StringValue.toObject(message.channel, options);
        if (message.id != null && message.hasOwnProperty('id')) object.id = message.id;
        if (message.info != null && message.hasOwnProperty('info'))
          object.info = $root.google.protobuf.Struct.toObject(message.info, options);
        if (message.experiment != null && message.hasOwnProperty('experiment'))
          object.experiment = $root.propel.core.LeadExperiment.toObject(
            message.experiment,
            options
          );
        if (message.dealershipId != null && message.hasOwnProperty('dealershipId'))
          object.dealershipId = $root.google.protobuf.StringValue.toObject(
            message.dealershipId,
            options
          );
        return object;
      };

      /**
       * Converts this IncomingLead to JSON.
       * @function toJSON
       * @memberof propel.core.IncomingLead
       * @instance
       * @returns {Object.<string,*>} JSON object
       */
      IncomingLead.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
      };

      return IncomingLead;
    })();

    core.VehicleOption = (function () {
      /**
       * Properties of a VehicleOption.
       * @memberof propel.core
       * @interface IVehicleOption
       * @property {string|null} [name] VehicleOption name
       * @property {string|null} [oemCode] VehicleOption oemCode
       */

      /**
       * Constructs a new VehicleOption.
       * @memberof propel.core
       * @classdesc Represents a VehicleOption.
       * @implements IVehicleOption
       * @constructor
       * @param {propel.core.IVehicleOption=} [properties] Properties to set
       */
      function VehicleOption(properties) {
        if (properties)
          for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
      }

      /**
       * VehicleOption name.
       * @member {string} name
       * @memberof propel.core.VehicleOption
       * @instance
       */
      VehicleOption.prototype.name = '';

      /**
       * VehicleOption oemCode.
       * @member {string} oemCode
       * @memberof propel.core.VehicleOption
       * @instance
       */
      VehicleOption.prototype.oemCode = '';

      /**
       * Creates a new VehicleOption instance using the specified properties.
       * @function create
       * @memberof propel.core.VehicleOption
       * @static
       * @param {propel.core.IVehicleOption=} [properties] Properties to set
       * @returns {propel.core.VehicleOption} VehicleOption instance
       */
      VehicleOption.create = function create(properties) {
        return new VehicleOption(properties);
      };

      /**
       * Encodes the specified VehicleOption message. Does not implicitly {@link propel.core.VehicleOption.verify|verify} messages.
       * @function encode
       * @memberof propel.core.VehicleOption
       * @static
       * @param {propel.core.IVehicleOption} message VehicleOption message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      VehicleOption.encode = function encode(message, writer) {
        if (!writer) writer = $Writer.create();
        if (message.name != null && message.hasOwnProperty('name'))
          writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.name);
        if (message.oemCode != null && message.hasOwnProperty('oemCode'))
          writer.uint32(/* id 2, wireType 2 =*/ 18).string(message.oemCode);
        return writer;
      };

      /**
       * Encodes the specified VehicleOption message, length delimited. Does not implicitly {@link propel.core.VehicleOption.verify|verify} messages.
       * @function encodeDelimited
       * @memberof propel.core.VehicleOption
       * @static
       * @param {propel.core.IVehicleOption} message VehicleOption message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      VehicleOption.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
      };

      /**
       * Decodes a VehicleOption message from the specified reader or buffer.
       * @function decode
       * @memberof propel.core.VehicleOption
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @param {number} [length] Message length if known beforehand
       * @returns {propel.core.VehicleOption} VehicleOption
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      VehicleOption.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length,
          message = new $root.propel.core.VehicleOption();
        while (reader.pos < end) {
          var tag = reader.uint32();
          switch (tag >>> 3) {
            case 1:
              message.name = reader.string();
              break;
            case 2:
              message.oemCode = reader.string();
              break;
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };

      /**
       * Decodes a VehicleOption message from the specified reader or buffer, length delimited.
       * @function decodeDelimited
       * @memberof propel.core.VehicleOption
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @returns {propel.core.VehicleOption} VehicleOption
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      VehicleOption.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader)) reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
      };

      /**
       * Verifies a VehicleOption message.
       * @function verify
       * @memberof propel.core.VehicleOption
       * @static
       * @param {Object.<string,*>} message Plain object to verify
       * @returns {string|null} `null` if valid, otherwise the reason why it is not
       */
      VehicleOption.verify = function verify(message) {
        if (typeof message !== 'object' || message === null) return 'object expected';
        if (message.name != null && message.hasOwnProperty('name'))
          if (!$util.isString(message.name)) return 'name: string expected';
        if (message.oemCode != null && message.hasOwnProperty('oemCode'))
          if (!$util.isString(message.oemCode)) return 'oemCode: string expected';
        return null;
      };

      /**
       * Creates a VehicleOption message from a plain object. Also converts values to their respective internal types.
       * @function fromObject
       * @memberof propel.core.VehicleOption
       * @static
       * @param {Object.<string,*>} object Plain object
       * @returns {propel.core.VehicleOption} VehicleOption
       */
      VehicleOption.fromObject = function fromObject(object) {
        if (object instanceof $root.propel.core.VehicleOption) return object;
        var message = new $root.propel.core.VehicleOption();
        if (object.name != null) message.name = String(object.name);
        if (object.oemCode != null) message.oemCode = String(object.oemCode);
        return message;
      };

      /**
       * Creates a plain object from a VehicleOption message. Also converts values to other types if specified.
       * @function toObject
       * @memberof propel.core.VehicleOption
       * @static
       * @param {propel.core.VehicleOption} message VehicleOption
       * @param {$protobuf.IConversionOptions} [options] Conversion options
       * @returns {Object.<string,*>} Plain object
       */
      VehicleOption.toObject = function toObject(message, options) {
        if (!options) options = {};
        var object = {};
        if (options.defaults) {
          object.name = '';
          object.oemCode = '';
        }
        if (message.name != null && message.hasOwnProperty('name')) object.name = message.name;
        if (message.oemCode != null && message.hasOwnProperty('oemCode'))
          object.oemCode = message.oemCode;
        return object;
      };

      /**
       * Converts this VehicleOption to JSON.
       * @function toJSON
       * @memberof propel.core.VehicleOption
       * @instance
       * @returns {Object.<string,*>} JSON object
       */
      VehicleOption.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
      };

      return VehicleOption;
    })();

    core.VehicleTimeframe = (function () {
      /**
       * Properties of a VehicleTimeframe.
       * @memberof propel.core
       * @interface IVehicleTimeframe
       * @property {google.protobuf.IStringValue|null} [earliest] VehicleTimeframe earliest
       * @property {google.protobuf.IStringValue|null} [latest] VehicleTimeframe latest
       * @property {google.protobuf.IStringValue|null} [description] VehicleTimeframe description
       */

      /**
       * Constructs a new VehicleTimeframe.
       * @memberof propel.core
       * @classdesc Represents a VehicleTimeframe.
       * @implements IVehicleTimeframe
       * @constructor
       * @param {propel.core.IVehicleTimeframe=} [properties] Properties to set
       */
      function VehicleTimeframe(properties) {
        if (properties)
          for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
      }

      /**
       * VehicleTimeframe earliest.
       * @member {google.protobuf.IStringValue|null|undefined} earliest
       * @memberof propel.core.VehicleTimeframe
       * @instance
       */
      VehicleTimeframe.prototype.earliest = null;

      /**
       * VehicleTimeframe latest.
       * @member {google.protobuf.IStringValue|null|undefined} latest
       * @memberof propel.core.VehicleTimeframe
       * @instance
       */
      VehicleTimeframe.prototype.latest = null;

      /**
       * VehicleTimeframe description.
       * @member {google.protobuf.IStringValue|null|undefined} description
       * @memberof propel.core.VehicleTimeframe
       * @instance
       */
      VehicleTimeframe.prototype.description = null;

      /**
       * Creates a new VehicleTimeframe instance using the specified properties.
       * @function create
       * @memberof propel.core.VehicleTimeframe
       * @static
       * @param {propel.core.IVehicleTimeframe=} [properties] Properties to set
       * @returns {propel.core.VehicleTimeframe} VehicleTimeframe instance
       */
      VehicleTimeframe.create = function create(properties) {
        return new VehicleTimeframe(properties);
      };

      /**
       * Encodes the specified VehicleTimeframe message. Does not implicitly {@link propel.core.VehicleTimeframe.verify|verify} messages.
       * @function encode
       * @memberof propel.core.VehicleTimeframe
       * @static
       * @param {propel.core.IVehicleTimeframe} message VehicleTimeframe message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      VehicleTimeframe.encode = function encode(message, writer) {
        if (!writer) writer = $Writer.create();
        if (message.earliest != null && message.hasOwnProperty('earliest'))
          $root.google.protobuf.StringValue.encode(
            message.earliest,
            writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
          ).ldelim();
        if (message.latest != null && message.hasOwnProperty('latest'))
          $root.google.protobuf.StringValue.encode(
            message.latest,
            writer.uint32(/* id 2, wireType 2 =*/ 18).fork()
          ).ldelim();
        if (message.description != null && message.hasOwnProperty('description'))
          $root.google.protobuf.StringValue.encode(
            message.description,
            writer.uint32(/* id 3, wireType 2 =*/ 26).fork()
          ).ldelim();
        return writer;
      };

      /**
       * Encodes the specified VehicleTimeframe message, length delimited. Does not implicitly {@link propel.core.VehicleTimeframe.verify|verify} messages.
       * @function encodeDelimited
       * @memberof propel.core.VehicleTimeframe
       * @static
       * @param {propel.core.IVehicleTimeframe} message VehicleTimeframe message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      VehicleTimeframe.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
      };

      /**
       * Decodes a VehicleTimeframe message from the specified reader or buffer.
       * @function decode
       * @memberof propel.core.VehicleTimeframe
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @param {number} [length] Message length if known beforehand
       * @returns {propel.core.VehicleTimeframe} VehicleTimeframe
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      VehicleTimeframe.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length,
          message = new $root.propel.core.VehicleTimeframe();
        while (reader.pos < end) {
          var tag = reader.uint32();
          switch (tag >>> 3) {
            case 1:
              message.earliest = $root.google.protobuf.StringValue.decode(reader, reader.uint32());
              break;
            case 2:
              message.latest = $root.google.protobuf.StringValue.decode(reader, reader.uint32());
              break;
            case 3:
              message.description = $root.google.protobuf.StringValue.decode(
                reader,
                reader.uint32()
              );
              break;
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };

      /**
       * Decodes a VehicleTimeframe message from the specified reader or buffer, length delimited.
       * @function decodeDelimited
       * @memberof propel.core.VehicleTimeframe
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @returns {propel.core.VehicleTimeframe} VehicleTimeframe
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      VehicleTimeframe.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader)) reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
      };

      /**
       * Verifies a VehicleTimeframe message.
       * @function verify
       * @memberof propel.core.VehicleTimeframe
       * @static
       * @param {Object.<string,*>} message Plain object to verify
       * @returns {string|null} `null` if valid, otherwise the reason why it is not
       */
      VehicleTimeframe.verify = function verify(message) {
        if (typeof message !== 'object' || message === null) return 'object expected';
        if (message.earliest != null && message.hasOwnProperty('earliest')) {
          var error = $root.google.protobuf.StringValue.verify(message.earliest);
          if (error) return 'earliest.' + error;
        }
        if (message.latest != null && message.hasOwnProperty('latest')) {
          var error = $root.google.protobuf.StringValue.verify(message.latest);
          if (error) return 'latest.' + error;
        }
        if (message.description != null && message.hasOwnProperty('description')) {
          var error = $root.google.protobuf.StringValue.verify(message.description);
          if (error) return 'description.' + error;
        }
        return null;
      };

      /**
       * Creates a VehicleTimeframe message from a plain object. Also converts values to their respective internal types.
       * @function fromObject
       * @memberof propel.core.VehicleTimeframe
       * @static
       * @param {Object.<string,*>} object Plain object
       * @returns {propel.core.VehicleTimeframe} VehicleTimeframe
       */
      VehicleTimeframe.fromObject = function fromObject(object) {
        if (object instanceof $root.propel.core.VehicleTimeframe) return object;
        var message = new $root.propel.core.VehicleTimeframe();
        if (object.earliest != null) {
          if (typeof object.earliest !== 'object')
            throw TypeError('.propel.core.VehicleTimeframe.earliest: object expected');
          message.earliest = $root.google.protobuf.StringValue.fromObject(object.earliest);
        }
        if (object.latest != null) {
          if (typeof object.latest !== 'object')
            throw TypeError('.propel.core.VehicleTimeframe.latest: object expected');
          message.latest = $root.google.protobuf.StringValue.fromObject(object.latest);
        }
        if (object.description != null) {
          if (typeof object.description !== 'object')
            throw TypeError('.propel.core.VehicleTimeframe.description: object expected');
          message.description = $root.google.protobuf.StringValue.fromObject(object.description);
        }
        return message;
      };

      /**
       * Creates a plain object from a VehicleTimeframe message. Also converts values to other types if specified.
       * @function toObject
       * @memberof propel.core.VehicleTimeframe
       * @static
       * @param {propel.core.VehicleTimeframe} message VehicleTimeframe
       * @param {$protobuf.IConversionOptions} [options] Conversion options
       * @returns {Object.<string,*>} Plain object
       */
      VehicleTimeframe.toObject = function toObject(message, options) {
        if (!options) options = {};
        var object = {};
        if (options.defaults) {
          object.earliest = null;
          object.latest = null;
          object.description = null;
        }
        if (message.earliest != null && message.hasOwnProperty('earliest'))
          object.earliest = $root.google.protobuf.StringValue.toObject(message.earliest, options);
        if (message.latest != null && message.hasOwnProperty('latest'))
          object.latest = $root.google.protobuf.StringValue.toObject(message.latest, options);
        if (message.description != null && message.hasOwnProperty('description'))
          object.description = $root.google.protobuf.StringValue.toObject(
            message.description,
            options
          );
        return object;
      };

      /**
       * Converts this VehicleTimeframe to JSON.
       * @function toJSON
       * @memberof propel.core.VehicleTimeframe
       * @instance
       * @returns {Object.<string,*>} JSON object
       */
      VehicleTimeframe.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
      };

      return VehicleTimeframe;
    })();

    core.VehiclePricingOffer = (function () {
      /**
       * Properties of a VehiclePricingOffer.
       * @memberof propel.core
       * @interface IVehiclePricingOffer
       * @property {number|null} [amount] VehiclePricingOffer amount
       * @property {propel.core.VehiclePricingOffer.IAdjustment|null} [baseValue] VehiclePricingOffer baseValue
       * @property {Array.<propel.core.VehiclePricingOffer.IAdjustment>|null} [adjustments] VehiclePricingOffer adjustments
       * @property {google.protobuf.IStringValue|null} [expiresAt] VehiclePricingOffer expiresAt
       */

      /**
       * Constructs a new VehiclePricingOffer.
       * @memberof propel.core
       * @classdesc Represents a VehiclePricingOffer.
       * @implements IVehiclePricingOffer
       * @constructor
       * @param {propel.core.IVehiclePricingOffer=} [properties] Properties to set
       */
      function VehiclePricingOffer(properties) {
        this.adjustments = [];
        if (properties)
          for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
      }

      /**
       * VehiclePricingOffer amount.
       * @member {number} amount
       * @memberof propel.core.VehiclePricingOffer
       * @instance
       */
      VehiclePricingOffer.prototype.amount = 0;

      /**
       * VehiclePricingOffer baseValue.
       * @member {propel.core.VehiclePricingOffer.IAdjustment|null|undefined} baseValue
       * @memberof propel.core.VehiclePricingOffer
       * @instance
       */
      VehiclePricingOffer.prototype.baseValue = null;

      /**
       * VehiclePricingOffer adjustments.
       * @member {Array.<propel.core.VehiclePricingOffer.IAdjustment>} adjustments
       * @memberof propel.core.VehiclePricingOffer
       * @instance
       */
      VehiclePricingOffer.prototype.adjustments = $util.emptyArray;

      /**
       * VehiclePricingOffer expiresAt.
       * @member {google.protobuf.IStringValue|null|undefined} expiresAt
       * @memberof propel.core.VehiclePricingOffer
       * @instance
       */
      VehiclePricingOffer.prototype.expiresAt = null;

      /**
       * Creates a new VehiclePricingOffer instance using the specified properties.
       * @function create
       * @memberof propel.core.VehiclePricingOffer
       * @static
       * @param {propel.core.IVehiclePricingOffer=} [properties] Properties to set
       * @returns {propel.core.VehiclePricingOffer} VehiclePricingOffer instance
       */
      VehiclePricingOffer.create = function create(properties) {
        return new VehiclePricingOffer(properties);
      };

      /**
       * Encodes the specified VehiclePricingOffer message. Does not implicitly {@link propel.core.VehiclePricingOffer.verify|verify} messages.
       * @function encode
       * @memberof propel.core.VehiclePricingOffer
       * @static
       * @param {propel.core.IVehiclePricingOffer} message VehiclePricingOffer message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      VehiclePricingOffer.encode = function encode(message, writer) {
        if (!writer) writer = $Writer.create();
        if (message.amount != null && message.hasOwnProperty('amount'))
          writer.uint32(/* id 1, wireType 0 =*/ 8).uint32(message.amount);
        if (message.baseValue != null && message.hasOwnProperty('baseValue'))
          $root.propel.core.VehiclePricingOffer.Adjustment.encode(
            message.baseValue,
            writer.uint32(/* id 2, wireType 2 =*/ 18).fork()
          ).ldelim();
        if (message.adjustments != null && message.adjustments.length)
          for (var i = 0; i < message.adjustments.length; ++i)
            $root.propel.core.VehiclePricingOffer.Adjustment.encode(
              message.adjustments[i],
              writer.uint32(/* id 3, wireType 2 =*/ 26).fork()
            ).ldelim();
        if (message.expiresAt != null && message.hasOwnProperty('expiresAt'))
          $root.google.protobuf.StringValue.encode(
            message.expiresAt,
            writer.uint32(/* id 4, wireType 2 =*/ 34).fork()
          ).ldelim();
        return writer;
      };

      /**
       * Encodes the specified VehiclePricingOffer message, length delimited. Does not implicitly {@link propel.core.VehiclePricingOffer.verify|verify} messages.
       * @function encodeDelimited
       * @memberof propel.core.VehiclePricingOffer
       * @static
       * @param {propel.core.IVehiclePricingOffer} message VehiclePricingOffer message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      VehiclePricingOffer.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
      };

      /**
       * Decodes a VehiclePricingOffer message from the specified reader or buffer.
       * @function decode
       * @memberof propel.core.VehiclePricingOffer
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @param {number} [length] Message length if known beforehand
       * @returns {propel.core.VehiclePricingOffer} VehiclePricingOffer
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      VehiclePricingOffer.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length,
          message = new $root.propel.core.VehiclePricingOffer();
        while (reader.pos < end) {
          var tag = reader.uint32();
          switch (tag >>> 3) {
            case 1:
              message.amount = reader.uint32();
              break;
            case 2:
              message.baseValue = $root.propel.core.VehiclePricingOffer.Adjustment.decode(
                reader,
                reader.uint32()
              );
              break;
            case 3:
              if (!(message.adjustments && message.adjustments.length)) message.adjustments = [];
              message.adjustments.push(
                $root.propel.core.VehiclePricingOffer.Adjustment.decode(reader, reader.uint32())
              );
              break;
            case 4:
              message.expiresAt = $root.google.protobuf.StringValue.decode(reader, reader.uint32());
              break;
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };

      /**
       * Decodes a VehiclePricingOffer message from the specified reader or buffer, length delimited.
       * @function decodeDelimited
       * @memberof propel.core.VehiclePricingOffer
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @returns {propel.core.VehiclePricingOffer} VehiclePricingOffer
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      VehiclePricingOffer.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader)) reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
      };

      /**
       * Verifies a VehiclePricingOffer message.
       * @function verify
       * @memberof propel.core.VehiclePricingOffer
       * @static
       * @param {Object.<string,*>} message Plain object to verify
       * @returns {string|null} `null` if valid, otherwise the reason why it is not
       */
      VehiclePricingOffer.verify = function verify(message) {
        if (typeof message !== 'object' || message === null) return 'object expected';
        if (message.amount != null && message.hasOwnProperty('amount'))
          if (!$util.isInteger(message.amount)) return 'amount: integer expected';
        if (message.baseValue != null && message.hasOwnProperty('baseValue')) {
          var error = $root.propel.core.VehiclePricingOffer.Adjustment.verify(message.baseValue);
          if (error) return 'baseValue.' + error;
        }
        if (message.adjustments != null && message.hasOwnProperty('adjustments')) {
          if (!Array.isArray(message.adjustments)) return 'adjustments: array expected';
          for (var i = 0; i < message.adjustments.length; ++i) {
            var error = $root.propel.core.VehiclePricingOffer.Adjustment.verify(
              message.adjustments[i]
            );
            if (error) return 'adjustments.' + error;
          }
        }
        if (message.expiresAt != null && message.hasOwnProperty('expiresAt')) {
          var error = $root.google.protobuf.StringValue.verify(message.expiresAt);
          if (error) return 'expiresAt.' + error;
        }
        return null;
      };

      /**
       * Creates a VehiclePricingOffer message from a plain object. Also converts values to their respective internal types.
       * @function fromObject
       * @memberof propel.core.VehiclePricingOffer
       * @static
       * @param {Object.<string,*>} object Plain object
       * @returns {propel.core.VehiclePricingOffer} VehiclePricingOffer
       */
      VehiclePricingOffer.fromObject = function fromObject(object) {
        if (object instanceof $root.propel.core.VehiclePricingOffer) return object;
        var message = new $root.propel.core.VehiclePricingOffer();
        if (object.amount != null) message.amount = object.amount >>> 0;
        if (object.baseValue != null) {
          if (typeof object.baseValue !== 'object')
            throw TypeError('.propel.core.VehiclePricingOffer.baseValue: object expected');
          message.baseValue = $root.propel.core.VehiclePricingOffer.Adjustment.fromObject(
            object.baseValue
          );
        }
        if (object.adjustments) {
          if (!Array.isArray(object.adjustments))
            throw TypeError('.propel.core.VehiclePricingOffer.adjustments: array expected');
          message.adjustments = [];
          for (var i = 0; i < object.adjustments.length; ++i) {
            if (typeof object.adjustments[i] !== 'object')
              throw TypeError('.propel.core.VehiclePricingOffer.adjustments: object expected');
            message.adjustments[i] = $root.propel.core.VehiclePricingOffer.Adjustment.fromObject(
              object.adjustments[i]
            );
          }
        }
        if (object.expiresAt != null) {
          if (typeof object.expiresAt !== 'object')
            throw TypeError('.propel.core.VehiclePricingOffer.expiresAt: object expected');
          message.expiresAt = $root.google.protobuf.StringValue.fromObject(object.expiresAt);
        }
        return message;
      };

      /**
       * Creates a plain object from a VehiclePricingOffer message. Also converts values to other types if specified.
       * @function toObject
       * @memberof propel.core.VehiclePricingOffer
       * @static
       * @param {propel.core.VehiclePricingOffer} message VehiclePricingOffer
       * @param {$protobuf.IConversionOptions} [options] Conversion options
       * @returns {Object.<string,*>} Plain object
       */
      VehiclePricingOffer.toObject = function toObject(message, options) {
        if (!options) options = {};
        var object = {};
        if (options.arrays || options.defaults) object.adjustments = [];
        if (options.defaults) {
          object.amount = 0;
          object.baseValue = null;
          object.expiresAt = null;
        }
        if (message.amount != null && message.hasOwnProperty('amount'))
          object.amount = message.amount;
        if (message.baseValue != null && message.hasOwnProperty('baseValue'))
          object.baseValue = $root.propel.core.VehiclePricingOffer.Adjustment.toObject(
            message.baseValue,
            options
          );
        if (message.adjustments && message.adjustments.length) {
          object.adjustments = [];
          for (var j = 0; j < message.adjustments.length; ++j)
            object.adjustments[j] = $root.propel.core.VehiclePricingOffer.Adjustment.toObject(
              message.adjustments[j],
              options
            );
        }
        if (message.expiresAt != null && message.hasOwnProperty('expiresAt'))
          object.expiresAt = $root.google.protobuf.StringValue.toObject(message.expiresAt, options);
        return object;
      };

      /**
       * Converts this VehiclePricingOffer to JSON.
       * @function toJSON
       * @memberof propel.core.VehiclePricingOffer
       * @instance
       * @returns {Object.<string,*>} JSON object
       */
      VehiclePricingOffer.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
      };

      VehiclePricingOffer.Adjustment = (function () {
        /**
         * Properties of an Adjustment.
         * @memberof propel.core.VehiclePricingOffer
         * @interface IAdjustment
         * @property {string|null} [key] Adjustment key
         * @property {string|null} [name] Adjustment name
         * @property {number|null} [value] Adjustment value
         */

        /**
         * Constructs a new Adjustment.
         * @memberof propel.core.VehiclePricingOffer
         * @classdesc Represents an Adjustment.
         * @implements IAdjustment
         * @constructor
         * @param {propel.core.VehiclePricingOffer.IAdjustment=} [properties] Properties to set
         */
        function Adjustment(properties) {
          if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
              if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
        }

        /**
         * Adjustment key.
         * @member {string} key
         * @memberof propel.core.VehiclePricingOffer.Adjustment
         * @instance
         */
        Adjustment.prototype.key = '';

        /**
         * Adjustment name.
         * @member {string} name
         * @memberof propel.core.VehiclePricingOffer.Adjustment
         * @instance
         */
        Adjustment.prototype.name = '';

        /**
         * Adjustment value.
         * @member {number} value
         * @memberof propel.core.VehiclePricingOffer.Adjustment
         * @instance
         */
        Adjustment.prototype.value = 0;

        /**
         * Creates a new Adjustment instance using the specified properties.
         * @function create
         * @memberof propel.core.VehiclePricingOffer.Adjustment
         * @static
         * @param {propel.core.VehiclePricingOffer.IAdjustment=} [properties] Properties to set
         * @returns {propel.core.VehiclePricingOffer.Adjustment} Adjustment instance
         */
        Adjustment.create = function create(properties) {
          return new Adjustment(properties);
        };

        /**
         * Encodes the specified Adjustment message. Does not implicitly {@link propel.core.VehiclePricingOffer.Adjustment.verify|verify} messages.
         * @function encode
         * @memberof propel.core.VehiclePricingOffer.Adjustment
         * @static
         * @param {propel.core.VehiclePricingOffer.IAdjustment} message Adjustment message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Adjustment.encode = function encode(message, writer) {
          if (!writer) writer = $Writer.create();
          if (message.key != null && message.hasOwnProperty('key'))
            writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.key);
          if (message.name != null && message.hasOwnProperty('name'))
            writer.uint32(/* id 2, wireType 2 =*/ 18).string(message.name);
          if (message.value != null && message.hasOwnProperty('value'))
            writer.uint32(/* id 3, wireType 0 =*/ 24).int32(message.value);
          return writer;
        };

        /**
         * Encodes the specified Adjustment message, length delimited. Does not implicitly {@link propel.core.VehiclePricingOffer.Adjustment.verify|verify} messages.
         * @function encodeDelimited
         * @memberof propel.core.VehiclePricingOffer.Adjustment
         * @static
         * @param {propel.core.VehiclePricingOffer.IAdjustment} message Adjustment message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Adjustment.encodeDelimited = function encodeDelimited(message, writer) {
          return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an Adjustment message from the specified reader or buffer.
         * @function decode
         * @memberof propel.core.VehiclePricingOffer.Adjustment
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {propel.core.VehiclePricingOffer.Adjustment} Adjustment
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Adjustment.decode = function decode(reader, length) {
          if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
          var end = length === undefined ? reader.len : reader.pos + length,
            message = new $root.propel.core.VehiclePricingOffer.Adjustment();
          while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
              case 1:
                message.key = reader.string();
                break;
              case 2:
                message.name = reader.string();
                break;
              case 3:
                message.value = reader.int32();
                break;
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };

        /**
         * Decodes an Adjustment message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof propel.core.VehiclePricingOffer.Adjustment
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {propel.core.VehiclePricingOffer.Adjustment} Adjustment
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Adjustment.decodeDelimited = function decodeDelimited(reader) {
          if (!(reader instanceof $Reader)) reader = new $Reader(reader);
          return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an Adjustment message.
         * @function verify
         * @memberof propel.core.VehiclePricingOffer.Adjustment
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Adjustment.verify = function verify(message) {
          if (typeof message !== 'object' || message === null) return 'object expected';
          if (message.key != null && message.hasOwnProperty('key'))
            if (!$util.isString(message.key)) return 'key: string expected';
          if (message.name != null && message.hasOwnProperty('name'))
            if (!$util.isString(message.name)) return 'name: string expected';
          if (message.value != null && message.hasOwnProperty('value'))
            if (!$util.isInteger(message.value)) return 'value: integer expected';
          return null;
        };

        /**
         * Creates an Adjustment message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof propel.core.VehiclePricingOffer.Adjustment
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {propel.core.VehiclePricingOffer.Adjustment} Adjustment
         */
        Adjustment.fromObject = function fromObject(object) {
          if (object instanceof $root.propel.core.VehiclePricingOffer.Adjustment) return object;
          var message = new $root.propel.core.VehiclePricingOffer.Adjustment();
          if (object.key != null) message.key = String(object.key);
          if (object.name != null) message.name = String(object.name);
          if (object.value != null) message.value = object.value | 0;
          return message;
        };

        /**
         * Creates a plain object from an Adjustment message. Also converts values to other types if specified.
         * @function toObject
         * @memberof propel.core.VehiclePricingOffer.Adjustment
         * @static
         * @param {propel.core.VehiclePricingOffer.Adjustment} message Adjustment
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Adjustment.toObject = function toObject(message, options) {
          if (!options) options = {};
          var object = {};
          if (options.defaults) {
            object.key = '';
            object.name = '';
            object.value = 0;
          }
          if (message.key != null && message.hasOwnProperty('key')) object.key = message.key;
          if (message.name != null && message.hasOwnProperty('name')) object.name = message.name;
          if (message.value != null && message.hasOwnProperty('value'))
            object.value = message.value;
          return object;
        };

        /**
         * Converts this Adjustment to JSON.
         * @function toJSON
         * @memberof propel.core.VehiclePricingOffer.Adjustment
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Adjustment.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Adjustment;
      })();

      return VehiclePricingOffer;
    })();

    core.VehiclePricing = (function () {
      /**
       * Properties of a VehiclePricing.
       * @memberof propel.core
       * @interface IVehiclePricing
       * @property {string|null} [sourceId] VehiclePricing sourceId
       * @property {propel.core.IVehiclePricingOffer|null} [offer] VehiclePricing offer
       * @property {Object.<string,string>|null} [metadata] VehiclePricing metadata
       */

      /**
       * Constructs a new VehiclePricing.
       * @memberof propel.core
       * @classdesc Represents a VehiclePricing.
       * @implements IVehiclePricing
       * @constructor
       * @param {propel.core.IVehiclePricing=} [properties] Properties to set
       */
      function VehiclePricing(properties) {
        this.metadata = {};
        if (properties)
          for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
      }

      /**
       * VehiclePricing sourceId.
       * @member {string} sourceId
       * @memberof propel.core.VehiclePricing
       * @instance
       */
      VehiclePricing.prototype.sourceId = '';

      /**
       * VehiclePricing offer.
       * @member {propel.core.IVehiclePricingOffer|null|undefined} offer
       * @memberof propel.core.VehiclePricing
       * @instance
       */
      VehiclePricing.prototype.offer = null;

      /**
       * VehiclePricing metadata.
       * @member {Object.<string,string>} metadata
       * @memberof propel.core.VehiclePricing
       * @instance
       */
      VehiclePricing.prototype.metadata = $util.emptyObject;

      // OneOf field names bound to virtual getters and setters
      var $oneOfFields;

      /**
       * VehiclePricing value.
       * @member {"offer"|undefined} value
       * @memberof propel.core.VehiclePricing
       * @instance
       */
      Object.defineProperty(VehiclePricing.prototype, 'value', {
        get: $util.oneOfGetter(($oneOfFields = ['offer'])),
        set: $util.oneOfSetter($oneOfFields),
      });

      /**
       * Creates a new VehiclePricing instance using the specified properties.
       * @function create
       * @memberof propel.core.VehiclePricing
       * @static
       * @param {propel.core.IVehiclePricing=} [properties] Properties to set
       * @returns {propel.core.VehiclePricing} VehiclePricing instance
       */
      VehiclePricing.create = function create(properties) {
        return new VehiclePricing(properties);
      };

      /**
       * Encodes the specified VehiclePricing message. Does not implicitly {@link propel.core.VehiclePricing.verify|verify} messages.
       * @function encode
       * @memberof propel.core.VehiclePricing
       * @static
       * @param {propel.core.IVehiclePricing} message VehiclePricing message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      VehiclePricing.encode = function encode(message, writer) {
        if (!writer) writer = $Writer.create();
        if (message.sourceId != null && message.hasOwnProperty('sourceId'))
          writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.sourceId);
        if (message.metadata != null && message.hasOwnProperty('metadata'))
          for (var keys = Object.keys(message.metadata), i = 0; i < keys.length; ++i)
            writer
              .uint32(/* id 5, wireType 2 =*/ 42)
              .fork()
              .uint32(/* id 1, wireType 2 =*/ 10)
              .string(keys[i])
              .uint32(/* id 2, wireType 2 =*/ 18)
              .string(message.metadata[keys[i]])
              .ldelim();
        if (message.offer != null && message.hasOwnProperty('offer'))
          $root.propel.core.VehiclePricingOffer.encode(
            message.offer,
            writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
          ).ldelim();
        return writer;
      };

      /**
       * Encodes the specified VehiclePricing message, length delimited. Does not implicitly {@link propel.core.VehiclePricing.verify|verify} messages.
       * @function encodeDelimited
       * @memberof propel.core.VehiclePricing
       * @static
       * @param {propel.core.IVehiclePricing} message VehiclePricing message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      VehiclePricing.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
      };

      /**
       * Decodes a VehiclePricing message from the specified reader or buffer.
       * @function decode
       * @memberof propel.core.VehiclePricing
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @param {number} [length] Message length if known beforehand
       * @returns {propel.core.VehiclePricing} VehiclePricing
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      VehiclePricing.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length,
          message = new $root.propel.core.VehiclePricing(),
          key;
        while (reader.pos < end) {
          var tag = reader.uint32();
          switch (tag >>> 3) {
            case 1:
              message.sourceId = reader.string();
              break;
            case 100:
              message.offer = $root.propel.core.VehiclePricingOffer.decode(reader, reader.uint32());
              break;
            case 5:
              reader.skip().pos++;
              if (message.metadata === $util.emptyObject) message.metadata = {};
              key = reader.string();
              reader.pos++;
              message.metadata[key] = reader.string();
              break;
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };

      /**
       * Decodes a VehiclePricing message from the specified reader or buffer, length delimited.
       * @function decodeDelimited
       * @memberof propel.core.VehiclePricing
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @returns {propel.core.VehiclePricing} VehiclePricing
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      VehiclePricing.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader)) reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
      };

      /**
       * Verifies a VehiclePricing message.
       * @function verify
       * @memberof propel.core.VehiclePricing
       * @static
       * @param {Object.<string,*>} message Plain object to verify
       * @returns {string|null} `null` if valid, otherwise the reason why it is not
       */
      VehiclePricing.verify = function verify(message) {
        if (typeof message !== 'object' || message === null) return 'object expected';
        var properties = {};
        if (message.sourceId != null && message.hasOwnProperty('sourceId'))
          if (!$util.isString(message.sourceId)) return 'sourceId: string expected';
        if (message.offer != null && message.hasOwnProperty('offer')) {
          properties.value = 1;
          {
            var error = $root.propel.core.VehiclePricingOffer.verify(message.offer);
            if (error) return 'offer.' + error;
          }
        }
        if (message.metadata != null && message.hasOwnProperty('metadata')) {
          if (!$util.isObject(message.metadata)) return 'metadata: object expected';
          var key = Object.keys(message.metadata);
          for (var i = 0; i < key.length; ++i)
            if (!$util.isString(message.metadata[key[i]]))
              return 'metadata: string{k:string} expected';
        }
        return null;
      };

      /**
       * Creates a VehiclePricing message from a plain object. Also converts values to their respective internal types.
       * @function fromObject
       * @memberof propel.core.VehiclePricing
       * @static
       * @param {Object.<string,*>} object Plain object
       * @returns {propel.core.VehiclePricing} VehiclePricing
       */
      VehiclePricing.fromObject = function fromObject(object) {
        if (object instanceof $root.propel.core.VehiclePricing) return object;
        var message = new $root.propel.core.VehiclePricing();
        if (object.sourceId != null) message.sourceId = String(object.sourceId);
        if (object.offer != null) {
          if (typeof object.offer !== 'object')
            throw TypeError('.propel.core.VehiclePricing.offer: object expected');
          message.offer = $root.propel.core.VehiclePricingOffer.fromObject(object.offer);
        }
        if (object.metadata) {
          if (typeof object.metadata !== 'object')
            throw TypeError('.propel.core.VehiclePricing.metadata: object expected');
          message.metadata = {};
          for (var keys = Object.keys(object.metadata), i = 0; i < keys.length; ++i)
            message.metadata[keys[i]] = String(object.metadata[keys[i]]);
        }
        return message;
      };

      /**
       * Creates a plain object from a VehiclePricing message. Also converts values to other types if specified.
       * @function toObject
       * @memberof propel.core.VehiclePricing
       * @static
       * @param {propel.core.VehiclePricing} message VehiclePricing
       * @param {$protobuf.IConversionOptions} [options] Conversion options
       * @returns {Object.<string,*>} Plain object
       */
      VehiclePricing.toObject = function toObject(message, options) {
        if (!options) options = {};
        var object = {};
        if (options.objects || options.defaults) object.metadata = {};
        if (options.defaults) object.sourceId = '';
        if (message.sourceId != null && message.hasOwnProperty('sourceId'))
          object.sourceId = message.sourceId;
        var keys2;
        if (message.metadata && (keys2 = Object.keys(message.metadata)).length) {
          object.metadata = {};
          for (var j = 0; j < keys2.length; ++j)
            object.metadata[keys2[j]] = message.metadata[keys2[j]];
        }
        if (message.offer != null && message.hasOwnProperty('offer')) {
          object.offer = $root.propel.core.VehiclePricingOffer.toObject(message.offer, options);
          if (options.oneofs) object.value = 'offer';
        }
        return object;
      };

      /**
       * Converts this VehiclePricing to JSON.
       * @function toJSON
       * @memberof propel.core.VehiclePricing
       * @instance
       * @returns {Object.<string,*>} JSON object
       */
      VehiclePricing.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
      };

      return VehiclePricing;
    })();

    core.Vehicle = (function () {
      /**
       * Properties of a Vehicle.
       * @memberof propel.core
       * @interface IVehicle
       * @property {google.protobuf.IStringValue|null} [vehicleId] Vehicle vehicleId
       * @property {google.protobuf.IStringValue|null} [stockNumber] Vehicle stockNumber
       * @property {google.protobuf.IStringValue|null} [vin] Vehicle vin
       * @property {google.protobuf.IStringValue|null} [year] Vehicle year
       * @property {google.protobuf.IStringValue|null} [make] Vehicle make
       * @property {google.protobuf.IStringValue|null} [model] Vehicle model
       * @property {google.protobuf.IStringValue|null} [trim] Vehicle trim
       * @property {google.protobuf.IStringValue|null} [doors] Vehicle doors
       * @property {google.protobuf.IStringValue|null} [bodyStyle] Vehicle bodyStyle
       * @property {Array.<string>|null} [exteriorColors] Vehicle exteriorColors
       * @property {Array.<string>|null} [interiorColors] Vehicle interiorColors
       * @property {Array.<propel.core.IVehicleOption>|null} [options] Vehicle options
       * @property {propel.core.IVehicleTimeframe|null} [timeframe] Vehicle timeframe
       * @property {google.protobuf.IStringValue|null} [adfComments] Vehicle adfComments
       * @property {Array.<propel.core.IVehiclePricing>|null} [tradeInPricing] Vehicle tradeInPricing
       */

      /**
       * Constructs a new Vehicle.
       * @memberof propel.core
       * @classdesc Represents a Vehicle.
       * @implements IVehicle
       * @constructor
       * @param {propel.core.IVehicle=} [properties] Properties to set
       */
      function Vehicle(properties) {
        this.exteriorColors = [];
        this.interiorColors = [];
        this.options = [];
        this.tradeInPricing = [];
        if (properties)
          for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
      }

      /**
       * Vehicle vehicleId.
       * @member {google.protobuf.IStringValue|null|undefined} vehicleId
       * @memberof propel.core.Vehicle
       * @instance
       */
      Vehicle.prototype.vehicleId = null;

      /**
       * Vehicle stockNumber.
       * @member {google.protobuf.IStringValue|null|undefined} stockNumber
       * @memberof propel.core.Vehicle
       * @instance
       */
      Vehicle.prototype.stockNumber = null;

      /**
       * Vehicle vin.
       * @member {google.protobuf.IStringValue|null|undefined} vin
       * @memberof propel.core.Vehicle
       * @instance
       */
      Vehicle.prototype.vin = null;

      /**
       * Vehicle year.
       * @member {google.protobuf.IStringValue|null|undefined} year
       * @memberof propel.core.Vehicle
       * @instance
       */
      Vehicle.prototype.year = null;

      /**
       * Vehicle make.
       * @member {google.protobuf.IStringValue|null|undefined} make
       * @memberof propel.core.Vehicle
       * @instance
       */
      Vehicle.prototype.make = null;

      /**
       * Vehicle model.
       * @member {google.protobuf.IStringValue|null|undefined} model
       * @memberof propel.core.Vehicle
       * @instance
       */
      Vehicle.prototype.model = null;

      /**
       * Vehicle trim.
       * @member {google.protobuf.IStringValue|null|undefined} trim
       * @memberof propel.core.Vehicle
       * @instance
       */
      Vehicle.prototype.trim = null;

      /**
       * Vehicle doors.
       * @member {google.protobuf.IStringValue|null|undefined} doors
       * @memberof propel.core.Vehicle
       * @instance
       */
      Vehicle.prototype.doors = null;

      /**
       * Vehicle bodyStyle.
       * @member {google.protobuf.IStringValue|null|undefined} bodyStyle
       * @memberof propel.core.Vehicle
       * @instance
       */
      Vehicle.prototype.bodyStyle = null;

      /**
       * Vehicle exteriorColors.
       * @member {Array.<string>} exteriorColors
       * @memberof propel.core.Vehicle
       * @instance
       */
      Vehicle.prototype.exteriorColors = $util.emptyArray;

      /**
       * Vehicle interiorColors.
       * @member {Array.<string>} interiorColors
       * @memberof propel.core.Vehicle
       * @instance
       */
      Vehicle.prototype.interiorColors = $util.emptyArray;

      /**
       * Vehicle options.
       * @member {Array.<propel.core.IVehicleOption>} options
       * @memberof propel.core.Vehicle
       * @instance
       */
      Vehicle.prototype.options = $util.emptyArray;

      /**
       * Vehicle timeframe.
       * @member {propel.core.IVehicleTimeframe|null|undefined} timeframe
       * @memberof propel.core.Vehicle
       * @instance
       */
      Vehicle.prototype.timeframe = null;

      /**
       * Vehicle adfComments.
       * @member {google.protobuf.IStringValue|null|undefined} adfComments
       * @memberof propel.core.Vehicle
       * @instance
       */
      Vehicle.prototype.adfComments = null;

      /**
       * Vehicle tradeInPricing.
       * @member {Array.<propel.core.IVehiclePricing>} tradeInPricing
       * @memberof propel.core.Vehicle
       * @instance
       */
      Vehicle.prototype.tradeInPricing = $util.emptyArray;

      /**
       * Creates a new Vehicle instance using the specified properties.
       * @function create
       * @memberof propel.core.Vehicle
       * @static
       * @param {propel.core.IVehicle=} [properties] Properties to set
       * @returns {propel.core.Vehicle} Vehicle instance
       */
      Vehicle.create = function create(properties) {
        return new Vehicle(properties);
      };

      /**
       * Encodes the specified Vehicle message. Does not implicitly {@link propel.core.Vehicle.verify|verify} messages.
       * @function encode
       * @memberof propel.core.Vehicle
       * @static
       * @param {propel.core.IVehicle} message Vehicle message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      Vehicle.encode = function encode(message, writer) {
        if (!writer) writer = $Writer.create();
        if (message.vehicleId != null && message.hasOwnProperty('vehicleId'))
          $root.google.protobuf.StringValue.encode(
            message.vehicleId,
            writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
          ).ldelim();
        if (message.stockNumber != null && message.hasOwnProperty('stockNumber'))
          $root.google.protobuf.StringValue.encode(
            message.stockNumber,
            writer.uint32(/* id 2, wireType 2 =*/ 18).fork()
          ).ldelim();
        if (message.vin != null && message.hasOwnProperty('vin'))
          $root.google.protobuf.StringValue.encode(
            message.vin,
            writer.uint32(/* id 3, wireType 2 =*/ 26).fork()
          ).ldelim();
        if (message.year != null && message.hasOwnProperty('year'))
          $root.google.protobuf.StringValue.encode(
            message.year,
            writer.uint32(/* id 4, wireType 2 =*/ 34).fork()
          ).ldelim();
        if (message.make != null && message.hasOwnProperty('make'))
          $root.google.protobuf.StringValue.encode(
            message.make,
            writer.uint32(/* id 5, wireType 2 =*/ 42).fork()
          ).ldelim();
        if (message.model != null && message.hasOwnProperty('model'))
          $root.google.protobuf.StringValue.encode(
            message.model,
            writer.uint32(/* id 6, wireType 2 =*/ 50).fork()
          ).ldelim();
        if (message.trim != null && message.hasOwnProperty('trim'))
          $root.google.protobuf.StringValue.encode(
            message.trim,
            writer.uint32(/* id 7, wireType 2 =*/ 58).fork()
          ).ldelim();
        if (message.doors != null && message.hasOwnProperty('doors'))
          $root.google.protobuf.StringValue.encode(
            message.doors,
            writer.uint32(/* id 8, wireType 2 =*/ 66).fork()
          ).ldelim();
        if (message.bodyStyle != null && message.hasOwnProperty('bodyStyle'))
          $root.google.protobuf.StringValue.encode(
            message.bodyStyle,
            writer.uint32(/* id 9, wireType 2 =*/ 74).fork()
          ).ldelim();
        if (message.exteriorColors != null && message.exteriorColors.length)
          for (var i = 0; i < message.exteriorColors.length; ++i)
            writer.uint32(/* id 10, wireType 2 =*/ 82).string(message.exteriorColors[i]);
        if (message.interiorColors != null && message.interiorColors.length)
          for (var i = 0; i < message.interiorColors.length; ++i)
            writer.uint32(/* id 11, wireType 2 =*/ 90).string(message.interiorColors[i]);
        if (message.options != null && message.options.length)
          for (var i = 0; i < message.options.length; ++i)
            $root.propel.core.VehicleOption.encode(
              message.options[i],
              writer.uint32(/* id 12, wireType 2 =*/ 98).fork()
            ).ldelim();
        if (message.adfComments != null && message.hasOwnProperty('adfComments'))
          $root.google.protobuf.StringValue.encode(
            message.adfComments,
            writer.uint32(/* id 13, wireType 2 =*/ 106).fork()
          ).ldelim();
        if (message.tradeInPricing != null && message.tradeInPricing.length)
          for (var i = 0; i < message.tradeInPricing.length; ++i)
            $root.propel.core.VehiclePricing.encode(
              message.tradeInPricing[i],
              writer.uint32(/* id 14, wireType 2 =*/ 114).fork()
            ).ldelim();
        if (message.timeframe != null && message.hasOwnProperty('timeframe'))
          $root.propel.core.VehicleTimeframe.encode(
            message.timeframe,
            writer.uint32(/* id 15, wireType 2 =*/ 122).fork()
          ).ldelim();
        return writer;
      };

      /**
       * Encodes the specified Vehicle message, length delimited. Does not implicitly {@link propel.core.Vehicle.verify|verify} messages.
       * @function encodeDelimited
       * @memberof propel.core.Vehicle
       * @static
       * @param {propel.core.IVehicle} message Vehicle message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      Vehicle.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
      };

      /**
       * Decodes a Vehicle message from the specified reader or buffer.
       * @function decode
       * @memberof propel.core.Vehicle
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @param {number} [length] Message length if known beforehand
       * @returns {propel.core.Vehicle} Vehicle
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      Vehicle.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length,
          message = new $root.propel.core.Vehicle();
        while (reader.pos < end) {
          var tag = reader.uint32();
          switch (tag >>> 3) {
            case 1:
              message.vehicleId = $root.google.protobuf.StringValue.decode(reader, reader.uint32());
              break;
            case 2:
              message.stockNumber = $root.google.protobuf.StringValue.decode(
                reader,
                reader.uint32()
              );
              break;
            case 3:
              message.vin = $root.google.protobuf.StringValue.decode(reader, reader.uint32());
              break;
            case 4:
              message.year = $root.google.protobuf.StringValue.decode(reader, reader.uint32());
              break;
            case 5:
              message.make = $root.google.protobuf.StringValue.decode(reader, reader.uint32());
              break;
            case 6:
              message.model = $root.google.protobuf.StringValue.decode(reader, reader.uint32());
              break;
            case 7:
              message.trim = $root.google.protobuf.StringValue.decode(reader, reader.uint32());
              break;
            case 8:
              message.doors = $root.google.protobuf.StringValue.decode(reader, reader.uint32());
              break;
            case 9:
              message.bodyStyle = $root.google.protobuf.StringValue.decode(reader, reader.uint32());
              break;
            case 10:
              if (!(message.exteriorColors && message.exteriorColors.length))
                message.exteriorColors = [];
              message.exteriorColors.push(reader.string());
              break;
            case 11:
              if (!(message.interiorColors && message.interiorColors.length))
                message.interiorColors = [];
              message.interiorColors.push(reader.string());
              break;
            case 12:
              if (!(message.options && message.options.length)) message.options = [];
              message.options.push($root.propel.core.VehicleOption.decode(reader, reader.uint32()));
              break;
            case 15:
              message.timeframe = $root.propel.core.VehicleTimeframe.decode(
                reader,
                reader.uint32()
              );
              break;
            case 13:
              message.adfComments = $root.google.protobuf.StringValue.decode(
                reader,
                reader.uint32()
              );
              break;
            case 14:
              if (!(message.tradeInPricing && message.tradeInPricing.length))
                message.tradeInPricing = [];
              message.tradeInPricing.push(
                $root.propel.core.VehiclePricing.decode(reader, reader.uint32())
              );
              break;
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };

      /**
       * Decodes a Vehicle message from the specified reader or buffer, length delimited.
       * @function decodeDelimited
       * @memberof propel.core.Vehicle
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @returns {propel.core.Vehicle} Vehicle
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      Vehicle.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader)) reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
      };

      /**
       * Verifies a Vehicle message.
       * @function verify
       * @memberof propel.core.Vehicle
       * @static
       * @param {Object.<string,*>} message Plain object to verify
       * @returns {string|null} `null` if valid, otherwise the reason why it is not
       */
      Vehicle.verify = function verify(message) {
        if (typeof message !== 'object' || message === null) return 'object expected';
        if (message.vehicleId != null && message.hasOwnProperty('vehicleId')) {
          var error = $root.google.protobuf.StringValue.verify(message.vehicleId);
          if (error) return 'vehicleId.' + error;
        }
        if (message.stockNumber != null && message.hasOwnProperty('stockNumber')) {
          var error = $root.google.protobuf.StringValue.verify(message.stockNumber);
          if (error) return 'stockNumber.' + error;
        }
        if (message.vin != null && message.hasOwnProperty('vin')) {
          var error = $root.google.protobuf.StringValue.verify(message.vin);
          if (error) return 'vin.' + error;
        }
        if (message.year != null && message.hasOwnProperty('year')) {
          var error = $root.google.protobuf.StringValue.verify(message.year);
          if (error) return 'year.' + error;
        }
        if (message.make != null && message.hasOwnProperty('make')) {
          var error = $root.google.protobuf.StringValue.verify(message.make);
          if (error) return 'make.' + error;
        }
        if (message.model != null && message.hasOwnProperty('model')) {
          var error = $root.google.protobuf.StringValue.verify(message.model);
          if (error) return 'model.' + error;
        }
        if (message.trim != null && message.hasOwnProperty('trim')) {
          var error = $root.google.protobuf.StringValue.verify(message.trim);
          if (error) return 'trim.' + error;
        }
        if (message.doors != null && message.hasOwnProperty('doors')) {
          var error = $root.google.protobuf.StringValue.verify(message.doors);
          if (error) return 'doors.' + error;
        }
        if (message.bodyStyle != null && message.hasOwnProperty('bodyStyle')) {
          var error = $root.google.protobuf.StringValue.verify(message.bodyStyle);
          if (error) return 'bodyStyle.' + error;
        }
        if (message.exteriorColors != null && message.hasOwnProperty('exteriorColors')) {
          if (!Array.isArray(message.exteriorColors)) return 'exteriorColors: array expected';
          for (var i = 0; i < message.exteriorColors.length; ++i)
            if (!$util.isString(message.exteriorColors[i]))
              return 'exteriorColors: string[] expected';
        }
        if (message.interiorColors != null && message.hasOwnProperty('interiorColors')) {
          if (!Array.isArray(message.interiorColors)) return 'interiorColors: array expected';
          for (var i = 0; i < message.interiorColors.length; ++i)
            if (!$util.isString(message.interiorColors[i]))
              return 'interiorColors: string[] expected';
        }
        if (message.options != null && message.hasOwnProperty('options')) {
          if (!Array.isArray(message.options)) return 'options: array expected';
          for (var i = 0; i < message.options.length; ++i) {
            var error = $root.propel.core.VehicleOption.verify(message.options[i]);
            if (error) return 'options.' + error;
          }
        }
        if (message.timeframe != null && message.hasOwnProperty('timeframe')) {
          var error = $root.propel.core.VehicleTimeframe.verify(message.timeframe);
          if (error) return 'timeframe.' + error;
        }
        if (message.adfComments != null && message.hasOwnProperty('adfComments')) {
          var error = $root.google.protobuf.StringValue.verify(message.adfComments);
          if (error) return 'adfComments.' + error;
        }
        if (message.tradeInPricing != null && message.hasOwnProperty('tradeInPricing')) {
          if (!Array.isArray(message.tradeInPricing)) return 'tradeInPricing: array expected';
          for (var i = 0; i < message.tradeInPricing.length; ++i) {
            var error = $root.propel.core.VehiclePricing.verify(message.tradeInPricing[i]);
            if (error) return 'tradeInPricing.' + error;
          }
        }
        return null;
      };

      /**
       * Creates a Vehicle message from a plain object. Also converts values to their respective internal types.
       * @function fromObject
       * @memberof propel.core.Vehicle
       * @static
       * @param {Object.<string,*>} object Plain object
       * @returns {propel.core.Vehicle} Vehicle
       */
      Vehicle.fromObject = function fromObject(object) {
        if (object instanceof $root.propel.core.Vehicle) return object;
        var message = new $root.propel.core.Vehicle();
        if (object.vehicleId != null) {
          if (typeof object.vehicleId !== 'object')
            throw TypeError('.propel.core.Vehicle.vehicleId: object expected');
          message.vehicleId = $root.google.protobuf.StringValue.fromObject(object.vehicleId);
        }
        if (object.stockNumber != null) {
          if (typeof object.stockNumber !== 'object')
            throw TypeError('.propel.core.Vehicle.stockNumber: object expected');
          message.stockNumber = $root.google.protobuf.StringValue.fromObject(object.stockNumber);
        }
        if (object.vin != null) {
          if (typeof object.vin !== 'object')
            throw TypeError('.propel.core.Vehicle.vin: object expected');
          message.vin = $root.google.protobuf.StringValue.fromObject(object.vin);
        }
        if (object.year != null) {
          if (typeof object.year !== 'object')
            throw TypeError('.propel.core.Vehicle.year: object expected');
          message.year = $root.google.protobuf.StringValue.fromObject(object.year);
        }
        if (object.make != null) {
          if (typeof object.make !== 'object')
            throw TypeError('.propel.core.Vehicle.make: object expected');
          message.make = $root.google.protobuf.StringValue.fromObject(object.make);
        }
        if (object.model != null) {
          if (typeof object.model !== 'object')
            throw TypeError('.propel.core.Vehicle.model: object expected');
          message.model = $root.google.protobuf.StringValue.fromObject(object.model);
        }
        if (object.trim != null) {
          if (typeof object.trim !== 'object')
            throw TypeError('.propel.core.Vehicle.trim: object expected');
          message.trim = $root.google.protobuf.StringValue.fromObject(object.trim);
        }
        if (object.doors != null) {
          if (typeof object.doors !== 'object')
            throw TypeError('.propel.core.Vehicle.doors: object expected');
          message.doors = $root.google.protobuf.StringValue.fromObject(object.doors);
        }
        if (object.bodyStyle != null) {
          if (typeof object.bodyStyle !== 'object')
            throw TypeError('.propel.core.Vehicle.bodyStyle: object expected');
          message.bodyStyle = $root.google.protobuf.StringValue.fromObject(object.bodyStyle);
        }
        if (object.exteriorColors) {
          if (!Array.isArray(object.exteriorColors))
            throw TypeError('.propel.core.Vehicle.exteriorColors: array expected');
          message.exteriorColors = [];
          for (var i = 0; i < object.exteriorColors.length; ++i)
            message.exteriorColors[i] = String(object.exteriorColors[i]);
        }
        if (object.interiorColors) {
          if (!Array.isArray(object.interiorColors))
            throw TypeError('.propel.core.Vehicle.interiorColors: array expected');
          message.interiorColors = [];
          for (var i = 0; i < object.interiorColors.length; ++i)
            message.interiorColors[i] = String(object.interiorColors[i]);
        }
        if (object.options) {
          if (!Array.isArray(object.options))
            throw TypeError('.propel.core.Vehicle.options: array expected');
          message.options = [];
          for (var i = 0; i < object.options.length; ++i) {
            if (typeof object.options[i] !== 'object')
              throw TypeError('.propel.core.Vehicle.options: object expected');
            message.options[i] = $root.propel.core.VehicleOption.fromObject(object.options[i]);
          }
        }
        if (object.timeframe != null) {
          if (typeof object.timeframe !== 'object')
            throw TypeError('.propel.core.Vehicle.timeframe: object expected');
          message.timeframe = $root.propel.core.VehicleTimeframe.fromObject(object.timeframe);
        }
        if (object.adfComments != null) {
          if (typeof object.adfComments !== 'object')
            throw TypeError('.propel.core.Vehicle.adfComments: object expected');
          message.adfComments = $root.google.protobuf.StringValue.fromObject(object.adfComments);
        }
        if (object.tradeInPricing) {
          if (!Array.isArray(object.tradeInPricing))
            throw TypeError('.propel.core.Vehicle.tradeInPricing: array expected');
          message.tradeInPricing = [];
          for (var i = 0; i < object.tradeInPricing.length; ++i) {
            if (typeof object.tradeInPricing[i] !== 'object')
              throw TypeError('.propel.core.Vehicle.tradeInPricing: object expected');
            message.tradeInPricing[i] = $root.propel.core.VehiclePricing.fromObject(
              object.tradeInPricing[i]
            );
          }
        }
        return message;
      };

      /**
       * Creates a plain object from a Vehicle message. Also converts values to other types if specified.
       * @function toObject
       * @memberof propel.core.Vehicle
       * @static
       * @param {propel.core.Vehicle} message Vehicle
       * @param {$protobuf.IConversionOptions} [options] Conversion options
       * @returns {Object.<string,*>} Plain object
       */
      Vehicle.toObject = function toObject(message, options) {
        if (!options) options = {};
        var object = {};
        if (options.arrays || options.defaults) {
          object.exteriorColors = [];
          object.interiorColors = [];
          object.options = [];
          object.tradeInPricing = [];
        }
        if (options.defaults) {
          object.vehicleId = null;
          object.stockNumber = null;
          object.vin = null;
          object.year = null;
          object.make = null;
          object.model = null;
          object.trim = null;
          object.doors = null;
          object.bodyStyle = null;
          object.adfComments = null;
          object.timeframe = null;
        }
        if (message.vehicleId != null && message.hasOwnProperty('vehicleId'))
          object.vehicleId = $root.google.protobuf.StringValue.toObject(message.vehicleId, options);
        if (message.stockNumber != null && message.hasOwnProperty('stockNumber'))
          object.stockNumber = $root.google.protobuf.StringValue.toObject(
            message.stockNumber,
            options
          );
        if (message.vin != null && message.hasOwnProperty('vin'))
          object.vin = $root.google.protobuf.StringValue.toObject(message.vin, options);
        if (message.year != null && message.hasOwnProperty('year'))
          object.year = $root.google.protobuf.StringValue.toObject(message.year, options);
        if (message.make != null && message.hasOwnProperty('make'))
          object.make = $root.google.protobuf.StringValue.toObject(message.make, options);
        if (message.model != null && message.hasOwnProperty('model'))
          object.model = $root.google.protobuf.StringValue.toObject(message.model, options);
        if (message.trim != null && message.hasOwnProperty('trim'))
          object.trim = $root.google.protobuf.StringValue.toObject(message.trim, options);
        if (message.doors != null && message.hasOwnProperty('doors'))
          object.doors = $root.google.protobuf.StringValue.toObject(message.doors, options);
        if (message.bodyStyle != null && message.hasOwnProperty('bodyStyle'))
          object.bodyStyle = $root.google.protobuf.StringValue.toObject(message.bodyStyle, options);
        if (message.exteriorColors && message.exteriorColors.length) {
          object.exteriorColors = [];
          for (var j = 0; j < message.exteriorColors.length; ++j)
            object.exteriorColors[j] = message.exteriorColors[j];
        }
        if (message.interiorColors && message.interiorColors.length) {
          object.interiorColors = [];
          for (var j = 0; j < message.interiorColors.length; ++j)
            object.interiorColors[j] = message.interiorColors[j];
        }
        if (message.options && message.options.length) {
          object.options = [];
          for (var j = 0; j < message.options.length; ++j)
            object.options[j] = $root.propel.core.VehicleOption.toObject(
              message.options[j],
              options
            );
        }
        if (message.adfComments != null && message.hasOwnProperty('adfComments'))
          object.adfComments = $root.google.protobuf.StringValue.toObject(
            message.adfComments,
            options
          );
        if (message.tradeInPricing && message.tradeInPricing.length) {
          object.tradeInPricing = [];
          for (var j = 0; j < message.tradeInPricing.length; ++j)
            object.tradeInPricing[j] = $root.propel.core.VehiclePricing.toObject(
              message.tradeInPricing[j],
              options
            );
        }
        if (message.timeframe != null && message.hasOwnProperty('timeframe'))
          object.timeframe = $root.propel.core.VehicleTimeframe.toObject(
            message.timeframe,
            options
          );
        return object;
      };

      /**
       * Converts this Vehicle to JSON.
       * @function toJSON
       * @memberof propel.core.Vehicle
       * @instance
       * @returns {Object.<string,*>} JSON object
       */
      Vehicle.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
      };

      return Vehicle;
    })();

    return core;
  })();

  return propel;
})();

$root.google = (function () {
  /**
   * Namespace google.
   * @exports google
   * @namespace
   */
  var google = {};

  google.protobuf = (function () {
    /**
     * Namespace protobuf.
     * @memberof google
     * @namespace
     */
    var protobuf = {};

    protobuf.DoubleValue = (function () {
      /**
       * Properties of a DoubleValue.
       * @memberof google.protobuf
       * @interface IDoubleValue
       * @property {number|null} [value] DoubleValue value
       */

      /**
       * Constructs a new DoubleValue.
       * @memberof google.protobuf
       * @classdesc Represents a DoubleValue.
       * @implements IDoubleValue
       * @constructor
       * @param {google.protobuf.IDoubleValue=} [properties] Properties to set
       */
      function DoubleValue(properties) {
        if (properties)
          for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
      }

      /**
       * DoubleValue value.
       * @member {number} value
       * @memberof google.protobuf.DoubleValue
       * @instance
       */
      DoubleValue.prototype.value = 0;

      /**
       * Creates a new DoubleValue instance using the specified properties.
       * @function create
       * @memberof google.protobuf.DoubleValue
       * @static
       * @param {google.protobuf.IDoubleValue=} [properties] Properties to set
       * @returns {google.protobuf.DoubleValue} DoubleValue instance
       */
      DoubleValue.create = function create(properties) {
        return new DoubleValue(properties);
      };

      /**
       * Encodes the specified DoubleValue message. Does not implicitly {@link google.protobuf.DoubleValue.verify|verify} messages.
       * @function encode
       * @memberof google.protobuf.DoubleValue
       * @static
       * @param {google.protobuf.IDoubleValue} message DoubleValue message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      DoubleValue.encode = function encode(message, writer) {
        if (!writer) writer = $Writer.create();
        if (message.value != null && message.hasOwnProperty('value'))
          writer.uint32(/* id 1, wireType 1 =*/ 9).double(message.value);
        return writer;
      };

      /**
       * Encodes the specified DoubleValue message, length delimited. Does not implicitly {@link google.protobuf.DoubleValue.verify|verify} messages.
       * @function encodeDelimited
       * @memberof google.protobuf.DoubleValue
       * @static
       * @param {google.protobuf.IDoubleValue} message DoubleValue message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      DoubleValue.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
      };

      /**
       * Decodes a DoubleValue message from the specified reader or buffer.
       * @function decode
       * @memberof google.protobuf.DoubleValue
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @param {number} [length] Message length if known beforehand
       * @returns {google.protobuf.DoubleValue} DoubleValue
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      DoubleValue.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length,
          message = new $root.google.protobuf.DoubleValue();
        while (reader.pos < end) {
          var tag = reader.uint32();
          switch (tag >>> 3) {
            case 1:
              message.value = reader.double();
              break;
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };

      /**
       * Decodes a DoubleValue message from the specified reader or buffer, length delimited.
       * @function decodeDelimited
       * @memberof google.protobuf.DoubleValue
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @returns {google.protobuf.DoubleValue} DoubleValue
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      DoubleValue.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader)) reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
      };

      /**
       * Verifies a DoubleValue message.
       * @function verify
       * @memberof google.protobuf.DoubleValue
       * @static
       * @param {Object.<string,*>} message Plain object to verify
       * @returns {string|null} `null` if valid, otherwise the reason why it is not
       */
      DoubleValue.verify = function verify(message) {
        if (typeof message !== 'object' || message === null) return 'object expected';
        if (message.value != null && message.hasOwnProperty('value'))
          if (typeof message.value !== 'number') return 'value: number expected';
        return null;
      };

      /**
       * Creates a DoubleValue message from a plain object. Also converts values to their respective internal types.
       * @function fromObject
       * @memberof google.protobuf.DoubleValue
       * @static
       * @param {Object.<string,*>} object Plain object
       * @returns {google.protobuf.DoubleValue} DoubleValue
       */
      DoubleValue.fromObject = function fromObject(object) {
        if (object instanceof $root.google.protobuf.DoubleValue) return object;
        var message = new $root.google.protobuf.DoubleValue();
        if (object.value != null) message.value = Number(object.value);
        return message;
      };

      /**
       * Creates a plain object from a DoubleValue message. Also converts values to other types if specified.
       * @function toObject
       * @memberof google.protobuf.DoubleValue
       * @static
       * @param {google.protobuf.DoubleValue} message DoubleValue
       * @param {$protobuf.IConversionOptions} [options] Conversion options
       * @returns {Object.<string,*>} Plain object
       */
      DoubleValue.toObject = function toObject(message, options) {
        if (!options) options = {};
        var object = {};
        if (options.defaults) object.value = 0;
        if (message.value != null && message.hasOwnProperty('value'))
          object.value =
            options.json && !isFinite(message.value) ? String(message.value) : message.value;
        return object;
      };

      /**
       * Converts this DoubleValue to JSON.
       * @function toJSON
       * @memberof google.protobuf.DoubleValue
       * @instance
       * @returns {Object.<string,*>} JSON object
       */
      DoubleValue.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
      };

      return DoubleValue;
    })();

    protobuf.FloatValue = (function () {
      /**
       * Properties of a FloatValue.
       * @memberof google.protobuf
       * @interface IFloatValue
       * @property {number|null} [value] FloatValue value
       */

      /**
       * Constructs a new FloatValue.
       * @memberof google.protobuf
       * @classdesc Represents a FloatValue.
       * @implements IFloatValue
       * @constructor
       * @param {google.protobuf.IFloatValue=} [properties] Properties to set
       */
      function FloatValue(properties) {
        if (properties)
          for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
      }

      /**
       * FloatValue value.
       * @member {number} value
       * @memberof google.protobuf.FloatValue
       * @instance
       */
      FloatValue.prototype.value = 0;

      /**
       * Creates a new FloatValue instance using the specified properties.
       * @function create
       * @memberof google.protobuf.FloatValue
       * @static
       * @param {google.protobuf.IFloatValue=} [properties] Properties to set
       * @returns {google.protobuf.FloatValue} FloatValue instance
       */
      FloatValue.create = function create(properties) {
        return new FloatValue(properties);
      };

      /**
       * Encodes the specified FloatValue message. Does not implicitly {@link google.protobuf.FloatValue.verify|verify} messages.
       * @function encode
       * @memberof google.protobuf.FloatValue
       * @static
       * @param {google.protobuf.IFloatValue} message FloatValue message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      FloatValue.encode = function encode(message, writer) {
        if (!writer) writer = $Writer.create();
        if (message.value != null && message.hasOwnProperty('value'))
          writer.uint32(/* id 1, wireType 5 =*/ 13).float(message.value);
        return writer;
      };

      /**
       * Encodes the specified FloatValue message, length delimited. Does not implicitly {@link google.protobuf.FloatValue.verify|verify} messages.
       * @function encodeDelimited
       * @memberof google.protobuf.FloatValue
       * @static
       * @param {google.protobuf.IFloatValue} message FloatValue message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      FloatValue.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
      };

      /**
       * Decodes a FloatValue message from the specified reader or buffer.
       * @function decode
       * @memberof google.protobuf.FloatValue
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @param {number} [length] Message length if known beforehand
       * @returns {google.protobuf.FloatValue} FloatValue
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      FloatValue.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length,
          message = new $root.google.protobuf.FloatValue();
        while (reader.pos < end) {
          var tag = reader.uint32();
          switch (tag >>> 3) {
            case 1:
              message.value = reader.float();
              break;
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };

      /**
       * Decodes a FloatValue message from the specified reader or buffer, length delimited.
       * @function decodeDelimited
       * @memberof google.protobuf.FloatValue
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @returns {google.protobuf.FloatValue} FloatValue
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      FloatValue.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader)) reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
      };

      /**
       * Verifies a FloatValue message.
       * @function verify
       * @memberof google.protobuf.FloatValue
       * @static
       * @param {Object.<string,*>} message Plain object to verify
       * @returns {string|null} `null` if valid, otherwise the reason why it is not
       */
      FloatValue.verify = function verify(message) {
        if (typeof message !== 'object' || message === null) return 'object expected';
        if (message.value != null && message.hasOwnProperty('value'))
          if (typeof message.value !== 'number') return 'value: number expected';
        return null;
      };

      /**
       * Creates a FloatValue message from a plain object. Also converts values to their respective internal types.
       * @function fromObject
       * @memberof google.protobuf.FloatValue
       * @static
       * @param {Object.<string,*>} object Plain object
       * @returns {google.protobuf.FloatValue} FloatValue
       */
      FloatValue.fromObject = function fromObject(object) {
        if (object instanceof $root.google.protobuf.FloatValue) return object;
        var message = new $root.google.protobuf.FloatValue();
        if (object.value != null) message.value = Number(object.value);
        return message;
      };

      /**
       * Creates a plain object from a FloatValue message. Also converts values to other types if specified.
       * @function toObject
       * @memberof google.protobuf.FloatValue
       * @static
       * @param {google.protobuf.FloatValue} message FloatValue
       * @param {$protobuf.IConversionOptions} [options] Conversion options
       * @returns {Object.<string,*>} Plain object
       */
      FloatValue.toObject = function toObject(message, options) {
        if (!options) options = {};
        var object = {};
        if (options.defaults) object.value = 0;
        if (message.value != null && message.hasOwnProperty('value'))
          object.value =
            options.json && !isFinite(message.value) ? String(message.value) : message.value;
        return object;
      };

      /**
       * Converts this FloatValue to JSON.
       * @function toJSON
       * @memberof google.protobuf.FloatValue
       * @instance
       * @returns {Object.<string,*>} JSON object
       */
      FloatValue.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
      };

      return FloatValue;
    })();

    protobuf.Int64Value = (function () {
      /**
       * Properties of an Int64Value.
       * @memberof google.protobuf
       * @interface IInt64Value
       * @property {number|Long|null} [value] Int64Value value
       */

      /**
       * Constructs a new Int64Value.
       * @memberof google.protobuf
       * @classdesc Represents an Int64Value.
       * @implements IInt64Value
       * @constructor
       * @param {google.protobuf.IInt64Value=} [properties] Properties to set
       */
      function Int64Value(properties) {
        if (properties)
          for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
      }

      /**
       * Int64Value value.
       * @member {number|Long} value
       * @memberof google.protobuf.Int64Value
       * @instance
       */
      Int64Value.prototype.value = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;

      /**
       * Creates a new Int64Value instance using the specified properties.
       * @function create
       * @memberof google.protobuf.Int64Value
       * @static
       * @param {google.protobuf.IInt64Value=} [properties] Properties to set
       * @returns {google.protobuf.Int64Value} Int64Value instance
       */
      Int64Value.create = function create(properties) {
        return new Int64Value(properties);
      };

      /**
       * Encodes the specified Int64Value message. Does not implicitly {@link google.protobuf.Int64Value.verify|verify} messages.
       * @function encode
       * @memberof google.protobuf.Int64Value
       * @static
       * @param {google.protobuf.IInt64Value} message Int64Value message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      Int64Value.encode = function encode(message, writer) {
        if (!writer) writer = $Writer.create();
        if (message.value != null && message.hasOwnProperty('value'))
          writer.uint32(/* id 1, wireType 0 =*/ 8).int64(message.value);
        return writer;
      };

      /**
       * Encodes the specified Int64Value message, length delimited. Does not implicitly {@link google.protobuf.Int64Value.verify|verify} messages.
       * @function encodeDelimited
       * @memberof google.protobuf.Int64Value
       * @static
       * @param {google.protobuf.IInt64Value} message Int64Value message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      Int64Value.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
      };

      /**
       * Decodes an Int64Value message from the specified reader or buffer.
       * @function decode
       * @memberof google.protobuf.Int64Value
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @param {number} [length] Message length if known beforehand
       * @returns {google.protobuf.Int64Value} Int64Value
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      Int64Value.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length,
          message = new $root.google.protobuf.Int64Value();
        while (reader.pos < end) {
          var tag = reader.uint32();
          switch (tag >>> 3) {
            case 1:
              message.value = reader.int64();
              break;
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };

      /**
       * Decodes an Int64Value message from the specified reader or buffer, length delimited.
       * @function decodeDelimited
       * @memberof google.protobuf.Int64Value
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @returns {google.protobuf.Int64Value} Int64Value
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      Int64Value.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader)) reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
      };

      /**
       * Verifies an Int64Value message.
       * @function verify
       * @memberof google.protobuf.Int64Value
       * @static
       * @param {Object.<string,*>} message Plain object to verify
       * @returns {string|null} `null` if valid, otherwise the reason why it is not
       */
      Int64Value.verify = function verify(message) {
        if (typeof message !== 'object' || message === null) return 'object expected';
        if (message.value != null && message.hasOwnProperty('value'))
          if (
            !$util.isInteger(message.value) &&
            !(
              message.value &&
              $util.isInteger(message.value.low) &&
              $util.isInteger(message.value.high)
            )
          )
            return 'value: integer|Long expected';
        return null;
      };

      /**
       * Creates an Int64Value message from a plain object. Also converts values to their respective internal types.
       * @function fromObject
       * @memberof google.protobuf.Int64Value
       * @static
       * @param {Object.<string,*>} object Plain object
       * @returns {google.protobuf.Int64Value} Int64Value
       */
      Int64Value.fromObject = function fromObject(object) {
        if (object instanceof $root.google.protobuf.Int64Value) return object;
        var message = new $root.google.protobuf.Int64Value();
        if (object.value != null)
          if ($util.Long) (message.value = $util.Long.fromValue(object.value)).unsigned = false;
          else if (typeof object.value === 'string') message.value = parseInt(object.value, 10);
          else if (typeof object.value === 'number') message.value = object.value;
          else if (typeof object.value === 'object')
            message.value = new $util.LongBits(
              object.value.low >>> 0,
              object.value.high >>> 0
            ).toNumber();
        return message;
      };

      /**
       * Creates a plain object from an Int64Value message. Also converts values to other types if specified.
       * @function toObject
       * @memberof google.protobuf.Int64Value
       * @static
       * @param {google.protobuf.Int64Value} message Int64Value
       * @param {$protobuf.IConversionOptions} [options] Conversion options
       * @returns {Object.<string,*>} Plain object
       */
      Int64Value.toObject = function toObject(message, options) {
        if (!options) options = {};
        var object = {};
        if (options.defaults)
          if ($util.Long) {
            var long = new $util.Long(0, 0, false);
            object.value =
              options.longs === String
                ? long.toString()
                : options.longs === Number
                ? long.toNumber()
                : long;
          } else object.value = options.longs === String ? '0' : 0;
        if (message.value != null && message.hasOwnProperty('value'))
          if (typeof message.value === 'number')
            object.value = options.longs === String ? String(message.value) : message.value;
          else
            object.value =
              options.longs === String
                ? $util.Long.prototype.toString.call(message.value)
                : options.longs === Number
                ? new $util.LongBits(message.value.low >>> 0, message.value.high >>> 0).toNumber()
                : message.value;
        return object;
      };

      /**
       * Converts this Int64Value to JSON.
       * @function toJSON
       * @memberof google.protobuf.Int64Value
       * @instance
       * @returns {Object.<string,*>} JSON object
       */
      Int64Value.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
      };

      return Int64Value;
    })();

    protobuf.UInt64Value = (function () {
      /**
       * Properties of a UInt64Value.
       * @memberof google.protobuf
       * @interface IUInt64Value
       * @property {number|Long|null} [value] UInt64Value value
       */

      /**
       * Constructs a new UInt64Value.
       * @memberof google.protobuf
       * @classdesc Represents a UInt64Value.
       * @implements IUInt64Value
       * @constructor
       * @param {google.protobuf.IUInt64Value=} [properties] Properties to set
       */
      function UInt64Value(properties) {
        if (properties)
          for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
      }

      /**
       * UInt64Value value.
       * @member {number|Long} value
       * @memberof google.protobuf.UInt64Value
       * @instance
       */
      UInt64Value.prototype.value = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;

      /**
       * Creates a new UInt64Value instance using the specified properties.
       * @function create
       * @memberof google.protobuf.UInt64Value
       * @static
       * @param {google.protobuf.IUInt64Value=} [properties] Properties to set
       * @returns {google.protobuf.UInt64Value} UInt64Value instance
       */
      UInt64Value.create = function create(properties) {
        return new UInt64Value(properties);
      };

      /**
       * Encodes the specified UInt64Value message. Does not implicitly {@link google.protobuf.UInt64Value.verify|verify} messages.
       * @function encode
       * @memberof google.protobuf.UInt64Value
       * @static
       * @param {google.protobuf.IUInt64Value} message UInt64Value message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      UInt64Value.encode = function encode(message, writer) {
        if (!writer) writer = $Writer.create();
        if (message.value != null && message.hasOwnProperty('value'))
          writer.uint32(/* id 1, wireType 0 =*/ 8).uint64(message.value);
        return writer;
      };

      /**
       * Encodes the specified UInt64Value message, length delimited. Does not implicitly {@link google.protobuf.UInt64Value.verify|verify} messages.
       * @function encodeDelimited
       * @memberof google.protobuf.UInt64Value
       * @static
       * @param {google.protobuf.IUInt64Value} message UInt64Value message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      UInt64Value.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
      };

      /**
       * Decodes a UInt64Value message from the specified reader or buffer.
       * @function decode
       * @memberof google.protobuf.UInt64Value
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @param {number} [length] Message length if known beforehand
       * @returns {google.protobuf.UInt64Value} UInt64Value
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      UInt64Value.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length,
          message = new $root.google.protobuf.UInt64Value();
        while (reader.pos < end) {
          var tag = reader.uint32();
          switch (tag >>> 3) {
            case 1:
              message.value = reader.uint64();
              break;
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };

      /**
       * Decodes a UInt64Value message from the specified reader or buffer, length delimited.
       * @function decodeDelimited
       * @memberof google.protobuf.UInt64Value
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @returns {google.protobuf.UInt64Value} UInt64Value
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      UInt64Value.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader)) reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
      };

      /**
       * Verifies a UInt64Value message.
       * @function verify
       * @memberof google.protobuf.UInt64Value
       * @static
       * @param {Object.<string,*>} message Plain object to verify
       * @returns {string|null} `null` if valid, otherwise the reason why it is not
       */
      UInt64Value.verify = function verify(message) {
        if (typeof message !== 'object' || message === null) return 'object expected';
        if (message.value != null && message.hasOwnProperty('value'))
          if (
            !$util.isInteger(message.value) &&
            !(
              message.value &&
              $util.isInteger(message.value.low) &&
              $util.isInteger(message.value.high)
            )
          )
            return 'value: integer|Long expected';
        return null;
      };

      /**
       * Creates a UInt64Value message from a plain object. Also converts values to their respective internal types.
       * @function fromObject
       * @memberof google.protobuf.UInt64Value
       * @static
       * @param {Object.<string,*>} object Plain object
       * @returns {google.protobuf.UInt64Value} UInt64Value
       */
      UInt64Value.fromObject = function fromObject(object) {
        if (object instanceof $root.google.protobuf.UInt64Value) return object;
        var message = new $root.google.protobuf.UInt64Value();
        if (object.value != null)
          if ($util.Long) (message.value = $util.Long.fromValue(object.value)).unsigned = true;
          else if (typeof object.value === 'string') message.value = parseInt(object.value, 10);
          else if (typeof object.value === 'number') message.value = object.value;
          else if (typeof object.value === 'object')
            message.value = new $util.LongBits(
              object.value.low >>> 0,
              object.value.high >>> 0
            ).toNumber(true);
        return message;
      };

      /**
       * Creates a plain object from a UInt64Value message. Also converts values to other types if specified.
       * @function toObject
       * @memberof google.protobuf.UInt64Value
       * @static
       * @param {google.protobuf.UInt64Value} message UInt64Value
       * @param {$protobuf.IConversionOptions} [options] Conversion options
       * @returns {Object.<string,*>} Plain object
       */
      UInt64Value.toObject = function toObject(message, options) {
        if (!options) options = {};
        var object = {};
        if (options.defaults)
          if ($util.Long) {
            var long = new $util.Long(0, 0, true);
            object.value =
              options.longs === String
                ? long.toString()
                : options.longs === Number
                ? long.toNumber()
                : long;
          } else object.value = options.longs === String ? '0' : 0;
        if (message.value != null && message.hasOwnProperty('value'))
          if (typeof message.value === 'number')
            object.value = options.longs === String ? String(message.value) : message.value;
          else
            object.value =
              options.longs === String
                ? $util.Long.prototype.toString.call(message.value)
                : options.longs === Number
                ? new $util.LongBits(message.value.low >>> 0, message.value.high >>> 0).toNumber(
                    true
                  )
                : message.value;
        return object;
      };

      /**
       * Converts this UInt64Value to JSON.
       * @function toJSON
       * @memberof google.protobuf.UInt64Value
       * @instance
       * @returns {Object.<string,*>} JSON object
       */
      UInt64Value.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
      };

      return UInt64Value;
    })();

    protobuf.Int32Value = (function () {
      /**
       * Properties of an Int32Value.
       * @memberof google.protobuf
       * @interface IInt32Value
       * @property {number|null} [value] Int32Value value
       */

      /**
       * Constructs a new Int32Value.
       * @memberof google.protobuf
       * @classdesc Represents an Int32Value.
       * @implements IInt32Value
       * @constructor
       * @param {google.protobuf.IInt32Value=} [properties] Properties to set
       */
      function Int32Value(properties) {
        if (properties)
          for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
      }

      /**
       * Int32Value value.
       * @member {number} value
       * @memberof google.protobuf.Int32Value
       * @instance
       */
      Int32Value.prototype.value = 0;

      /**
       * Creates a new Int32Value instance using the specified properties.
       * @function create
       * @memberof google.protobuf.Int32Value
       * @static
       * @param {google.protobuf.IInt32Value=} [properties] Properties to set
       * @returns {google.protobuf.Int32Value} Int32Value instance
       */
      Int32Value.create = function create(properties) {
        return new Int32Value(properties);
      };

      /**
       * Encodes the specified Int32Value message. Does not implicitly {@link google.protobuf.Int32Value.verify|verify} messages.
       * @function encode
       * @memberof google.protobuf.Int32Value
       * @static
       * @param {google.protobuf.IInt32Value} message Int32Value message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      Int32Value.encode = function encode(message, writer) {
        if (!writer) writer = $Writer.create();
        if (message.value != null && message.hasOwnProperty('value'))
          writer.uint32(/* id 1, wireType 0 =*/ 8).int32(message.value);
        return writer;
      };

      /**
       * Encodes the specified Int32Value message, length delimited. Does not implicitly {@link google.protobuf.Int32Value.verify|verify} messages.
       * @function encodeDelimited
       * @memberof google.protobuf.Int32Value
       * @static
       * @param {google.protobuf.IInt32Value} message Int32Value message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      Int32Value.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
      };

      /**
       * Decodes an Int32Value message from the specified reader or buffer.
       * @function decode
       * @memberof google.protobuf.Int32Value
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @param {number} [length] Message length if known beforehand
       * @returns {google.protobuf.Int32Value} Int32Value
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      Int32Value.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length,
          message = new $root.google.protobuf.Int32Value();
        while (reader.pos < end) {
          var tag = reader.uint32();
          switch (tag >>> 3) {
            case 1:
              message.value = reader.int32();
              break;
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };

      /**
       * Decodes an Int32Value message from the specified reader or buffer, length delimited.
       * @function decodeDelimited
       * @memberof google.protobuf.Int32Value
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @returns {google.protobuf.Int32Value} Int32Value
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      Int32Value.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader)) reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
      };

      /**
       * Verifies an Int32Value message.
       * @function verify
       * @memberof google.protobuf.Int32Value
       * @static
       * @param {Object.<string,*>} message Plain object to verify
       * @returns {string|null} `null` if valid, otherwise the reason why it is not
       */
      Int32Value.verify = function verify(message) {
        if (typeof message !== 'object' || message === null) return 'object expected';
        if (message.value != null && message.hasOwnProperty('value'))
          if (!$util.isInteger(message.value)) return 'value: integer expected';
        return null;
      };

      /**
       * Creates an Int32Value message from a plain object. Also converts values to their respective internal types.
       * @function fromObject
       * @memberof google.protobuf.Int32Value
       * @static
       * @param {Object.<string,*>} object Plain object
       * @returns {google.protobuf.Int32Value} Int32Value
       */
      Int32Value.fromObject = function fromObject(object) {
        if (object instanceof $root.google.protobuf.Int32Value) return object;
        var message = new $root.google.protobuf.Int32Value();
        if (object.value != null) message.value = object.value | 0;
        return message;
      };

      /**
       * Creates a plain object from an Int32Value message. Also converts values to other types if specified.
       * @function toObject
       * @memberof google.protobuf.Int32Value
       * @static
       * @param {google.protobuf.Int32Value} message Int32Value
       * @param {$protobuf.IConversionOptions} [options] Conversion options
       * @returns {Object.<string,*>} Plain object
       */
      Int32Value.toObject = function toObject(message, options) {
        if (!options) options = {};
        var object = {};
        if (options.defaults) object.value = 0;
        if (message.value != null && message.hasOwnProperty('value')) object.value = message.value;
        return object;
      };

      /**
       * Converts this Int32Value to JSON.
       * @function toJSON
       * @memberof google.protobuf.Int32Value
       * @instance
       * @returns {Object.<string,*>} JSON object
       */
      Int32Value.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
      };

      return Int32Value;
    })();

    protobuf.UInt32Value = (function () {
      /**
       * Properties of a UInt32Value.
       * @memberof google.protobuf
       * @interface IUInt32Value
       * @property {number|null} [value] UInt32Value value
       */

      /**
       * Constructs a new UInt32Value.
       * @memberof google.protobuf
       * @classdesc Represents a UInt32Value.
       * @implements IUInt32Value
       * @constructor
       * @param {google.protobuf.IUInt32Value=} [properties] Properties to set
       */
      function UInt32Value(properties) {
        if (properties)
          for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
      }

      /**
       * UInt32Value value.
       * @member {number} value
       * @memberof google.protobuf.UInt32Value
       * @instance
       */
      UInt32Value.prototype.value = 0;

      /**
       * Creates a new UInt32Value instance using the specified properties.
       * @function create
       * @memberof google.protobuf.UInt32Value
       * @static
       * @param {google.protobuf.IUInt32Value=} [properties] Properties to set
       * @returns {google.protobuf.UInt32Value} UInt32Value instance
       */
      UInt32Value.create = function create(properties) {
        return new UInt32Value(properties);
      };

      /**
       * Encodes the specified UInt32Value message. Does not implicitly {@link google.protobuf.UInt32Value.verify|verify} messages.
       * @function encode
       * @memberof google.protobuf.UInt32Value
       * @static
       * @param {google.protobuf.IUInt32Value} message UInt32Value message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      UInt32Value.encode = function encode(message, writer) {
        if (!writer) writer = $Writer.create();
        if (message.value != null && message.hasOwnProperty('value'))
          writer.uint32(/* id 1, wireType 0 =*/ 8).uint32(message.value);
        return writer;
      };

      /**
       * Encodes the specified UInt32Value message, length delimited. Does not implicitly {@link google.protobuf.UInt32Value.verify|verify} messages.
       * @function encodeDelimited
       * @memberof google.protobuf.UInt32Value
       * @static
       * @param {google.protobuf.IUInt32Value} message UInt32Value message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      UInt32Value.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
      };

      /**
       * Decodes a UInt32Value message from the specified reader or buffer.
       * @function decode
       * @memberof google.protobuf.UInt32Value
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @param {number} [length] Message length if known beforehand
       * @returns {google.protobuf.UInt32Value} UInt32Value
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      UInt32Value.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length,
          message = new $root.google.protobuf.UInt32Value();
        while (reader.pos < end) {
          var tag = reader.uint32();
          switch (tag >>> 3) {
            case 1:
              message.value = reader.uint32();
              break;
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };

      /**
       * Decodes a UInt32Value message from the specified reader or buffer, length delimited.
       * @function decodeDelimited
       * @memberof google.protobuf.UInt32Value
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @returns {google.protobuf.UInt32Value} UInt32Value
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      UInt32Value.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader)) reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
      };

      /**
       * Verifies a UInt32Value message.
       * @function verify
       * @memberof google.protobuf.UInt32Value
       * @static
       * @param {Object.<string,*>} message Plain object to verify
       * @returns {string|null} `null` if valid, otherwise the reason why it is not
       */
      UInt32Value.verify = function verify(message) {
        if (typeof message !== 'object' || message === null) return 'object expected';
        if (message.value != null && message.hasOwnProperty('value'))
          if (!$util.isInteger(message.value)) return 'value: integer expected';
        return null;
      };

      /**
       * Creates a UInt32Value message from a plain object. Also converts values to their respective internal types.
       * @function fromObject
       * @memberof google.protobuf.UInt32Value
       * @static
       * @param {Object.<string,*>} object Plain object
       * @returns {google.protobuf.UInt32Value} UInt32Value
       */
      UInt32Value.fromObject = function fromObject(object) {
        if (object instanceof $root.google.protobuf.UInt32Value) return object;
        var message = new $root.google.protobuf.UInt32Value();
        if (object.value != null) message.value = object.value >>> 0;
        return message;
      };

      /**
       * Creates a plain object from a UInt32Value message. Also converts values to other types if specified.
       * @function toObject
       * @memberof google.protobuf.UInt32Value
       * @static
       * @param {google.protobuf.UInt32Value} message UInt32Value
       * @param {$protobuf.IConversionOptions} [options] Conversion options
       * @returns {Object.<string,*>} Plain object
       */
      UInt32Value.toObject = function toObject(message, options) {
        if (!options) options = {};
        var object = {};
        if (options.defaults) object.value = 0;
        if (message.value != null && message.hasOwnProperty('value')) object.value = message.value;
        return object;
      };

      /**
       * Converts this UInt32Value to JSON.
       * @function toJSON
       * @memberof google.protobuf.UInt32Value
       * @instance
       * @returns {Object.<string,*>} JSON object
       */
      UInt32Value.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
      };

      return UInt32Value;
    })();

    protobuf.BoolValue = (function () {
      /**
       * Properties of a BoolValue.
       * @memberof google.protobuf
       * @interface IBoolValue
       * @property {boolean|null} [value] BoolValue value
       */

      /**
       * Constructs a new BoolValue.
       * @memberof google.protobuf
       * @classdesc Represents a BoolValue.
       * @implements IBoolValue
       * @constructor
       * @param {google.protobuf.IBoolValue=} [properties] Properties to set
       */
      function BoolValue(properties) {
        if (properties)
          for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
      }

      /**
       * BoolValue value.
       * @member {boolean} value
       * @memberof google.protobuf.BoolValue
       * @instance
       */
      BoolValue.prototype.value = false;

      /**
       * Creates a new BoolValue instance using the specified properties.
       * @function create
       * @memberof google.protobuf.BoolValue
       * @static
       * @param {google.protobuf.IBoolValue=} [properties] Properties to set
       * @returns {google.protobuf.BoolValue} BoolValue instance
       */
      BoolValue.create = function create(properties) {
        return new BoolValue(properties);
      };

      /**
       * Encodes the specified BoolValue message. Does not implicitly {@link google.protobuf.BoolValue.verify|verify} messages.
       * @function encode
       * @memberof google.protobuf.BoolValue
       * @static
       * @param {google.protobuf.IBoolValue} message BoolValue message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      BoolValue.encode = function encode(message, writer) {
        if (!writer) writer = $Writer.create();
        if (message.value != null && message.hasOwnProperty('value'))
          writer.uint32(/* id 1, wireType 0 =*/ 8).bool(message.value);
        return writer;
      };

      /**
       * Encodes the specified BoolValue message, length delimited. Does not implicitly {@link google.protobuf.BoolValue.verify|verify} messages.
       * @function encodeDelimited
       * @memberof google.protobuf.BoolValue
       * @static
       * @param {google.protobuf.IBoolValue} message BoolValue message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      BoolValue.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
      };

      /**
       * Decodes a BoolValue message from the specified reader or buffer.
       * @function decode
       * @memberof google.protobuf.BoolValue
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @param {number} [length] Message length if known beforehand
       * @returns {google.protobuf.BoolValue} BoolValue
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      BoolValue.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length,
          message = new $root.google.protobuf.BoolValue();
        while (reader.pos < end) {
          var tag = reader.uint32();
          switch (tag >>> 3) {
            case 1:
              message.value = reader.bool();
              break;
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };

      /**
       * Decodes a BoolValue message from the specified reader or buffer, length delimited.
       * @function decodeDelimited
       * @memberof google.protobuf.BoolValue
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @returns {google.protobuf.BoolValue} BoolValue
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      BoolValue.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader)) reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
      };

      /**
       * Verifies a BoolValue message.
       * @function verify
       * @memberof google.protobuf.BoolValue
       * @static
       * @param {Object.<string,*>} message Plain object to verify
       * @returns {string|null} `null` if valid, otherwise the reason why it is not
       */
      BoolValue.verify = function verify(message) {
        if (typeof message !== 'object' || message === null) return 'object expected';
        if (message.value != null && message.hasOwnProperty('value'))
          if (typeof message.value !== 'boolean') return 'value: boolean expected';
        return null;
      };

      /**
       * Creates a BoolValue message from a plain object. Also converts values to their respective internal types.
       * @function fromObject
       * @memberof google.protobuf.BoolValue
       * @static
       * @param {Object.<string,*>} object Plain object
       * @returns {google.protobuf.BoolValue} BoolValue
       */
      BoolValue.fromObject = function fromObject(object) {
        if (object instanceof $root.google.protobuf.BoolValue) return object;
        var message = new $root.google.protobuf.BoolValue();
        if (object.value != null) message.value = Boolean(object.value);
        return message;
      };

      /**
       * Creates a plain object from a BoolValue message. Also converts values to other types if specified.
       * @function toObject
       * @memberof google.protobuf.BoolValue
       * @static
       * @param {google.protobuf.BoolValue} message BoolValue
       * @param {$protobuf.IConversionOptions} [options] Conversion options
       * @returns {Object.<string,*>} Plain object
       */
      BoolValue.toObject = function toObject(message, options) {
        if (!options) options = {};
        var object = {};
        if (options.defaults) object.value = false;
        if (message.value != null && message.hasOwnProperty('value')) object.value = message.value;
        return object;
      };

      /**
       * Converts this BoolValue to JSON.
       * @function toJSON
       * @memberof google.protobuf.BoolValue
       * @instance
       * @returns {Object.<string,*>} JSON object
       */
      BoolValue.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
      };

      return BoolValue;
    })();

    protobuf.StringValue = (function () {
      /**
       * Properties of a StringValue.
       * @memberof google.protobuf
       * @interface IStringValue
       * @property {string|null} [value] StringValue value
       */

      /**
       * Constructs a new StringValue.
       * @memberof google.protobuf
       * @classdesc Represents a StringValue.
       * @implements IStringValue
       * @constructor
       * @param {google.protobuf.IStringValue=} [properties] Properties to set
       */
      function StringValue(properties) {
        if (properties)
          for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
      }

      /**
       * StringValue value.
       * @member {string} value
       * @memberof google.protobuf.StringValue
       * @instance
       */
      StringValue.prototype.value = '';

      /**
       * Creates a new StringValue instance using the specified properties.
       * @function create
       * @memberof google.protobuf.StringValue
       * @static
       * @param {google.protobuf.IStringValue=} [properties] Properties to set
       * @returns {google.protobuf.StringValue} StringValue instance
       */
      StringValue.create = function create(properties) {
        return new StringValue(properties);
      };

      /**
       * Encodes the specified StringValue message. Does not implicitly {@link google.protobuf.StringValue.verify|verify} messages.
       * @function encode
       * @memberof google.protobuf.StringValue
       * @static
       * @param {google.protobuf.IStringValue} message StringValue message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      StringValue.encode = function encode(message, writer) {
        if (!writer) writer = $Writer.create();
        if (message.value != null && message.hasOwnProperty('value'))
          writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.value);
        return writer;
      };

      /**
       * Encodes the specified StringValue message, length delimited. Does not implicitly {@link google.protobuf.StringValue.verify|verify} messages.
       * @function encodeDelimited
       * @memberof google.protobuf.StringValue
       * @static
       * @param {google.protobuf.IStringValue} message StringValue message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      StringValue.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
      };

      /**
       * Decodes a StringValue message from the specified reader or buffer.
       * @function decode
       * @memberof google.protobuf.StringValue
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @param {number} [length] Message length if known beforehand
       * @returns {google.protobuf.StringValue} StringValue
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      StringValue.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length,
          message = new $root.google.protobuf.StringValue();
        while (reader.pos < end) {
          var tag = reader.uint32();
          switch (tag >>> 3) {
            case 1:
              message.value = reader.string();
              break;
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };

      /**
       * Decodes a StringValue message from the specified reader or buffer, length delimited.
       * @function decodeDelimited
       * @memberof google.protobuf.StringValue
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @returns {google.protobuf.StringValue} StringValue
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      StringValue.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader)) reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
      };

      /**
       * Verifies a StringValue message.
       * @function verify
       * @memberof google.protobuf.StringValue
       * @static
       * @param {Object.<string,*>} message Plain object to verify
       * @returns {string|null} `null` if valid, otherwise the reason why it is not
       */
      StringValue.verify = function verify(message) {
        if (typeof message !== 'object' || message === null) return 'object expected';
        if (message.value != null && message.hasOwnProperty('value'))
          if (!$util.isString(message.value)) return 'value: string expected';
        return null;
      };

      /**
       * Creates a StringValue message from a plain object. Also converts values to their respective internal types.
       * @function fromObject
       * @memberof google.protobuf.StringValue
       * @static
       * @param {Object.<string,*>} object Plain object
       * @returns {google.protobuf.StringValue} StringValue
       */
      StringValue.fromObject = function fromObject(object) {
        if (object instanceof $root.google.protobuf.StringValue) return object;
        var message = new $root.google.protobuf.StringValue();
        if (object.value != null) message.value = String(object.value);
        return message;
      };

      /**
       * Creates a plain object from a StringValue message. Also converts values to other types if specified.
       * @function toObject
       * @memberof google.protobuf.StringValue
       * @static
       * @param {google.protobuf.StringValue} message StringValue
       * @param {$protobuf.IConversionOptions} [options] Conversion options
       * @returns {Object.<string,*>} Plain object
       */
      StringValue.toObject = function toObject(message, options) {
        if (!options) options = {};
        var object = {};
        if (options.defaults) object.value = '';
        if (message.value != null && message.hasOwnProperty('value')) object.value = message.value;
        return object;
      };

      /**
       * Converts this StringValue to JSON.
       * @function toJSON
       * @memberof google.protobuf.StringValue
       * @instance
       * @returns {Object.<string,*>} JSON object
       */
      StringValue.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
      };

      return StringValue;
    })();

    protobuf.BytesValue = (function () {
      /**
       * Properties of a BytesValue.
       * @memberof google.protobuf
       * @interface IBytesValue
       * @property {Uint8Array|null} [value] BytesValue value
       */

      /**
       * Constructs a new BytesValue.
       * @memberof google.protobuf
       * @classdesc Represents a BytesValue.
       * @implements IBytesValue
       * @constructor
       * @param {google.protobuf.IBytesValue=} [properties] Properties to set
       */
      function BytesValue(properties) {
        if (properties)
          for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
      }

      /**
       * BytesValue value.
       * @member {Uint8Array} value
       * @memberof google.protobuf.BytesValue
       * @instance
       */
      BytesValue.prototype.value = $util.newBuffer([]);

      /**
       * Creates a new BytesValue instance using the specified properties.
       * @function create
       * @memberof google.protobuf.BytesValue
       * @static
       * @param {google.protobuf.IBytesValue=} [properties] Properties to set
       * @returns {google.protobuf.BytesValue} BytesValue instance
       */
      BytesValue.create = function create(properties) {
        return new BytesValue(properties);
      };

      /**
       * Encodes the specified BytesValue message. Does not implicitly {@link google.protobuf.BytesValue.verify|verify} messages.
       * @function encode
       * @memberof google.protobuf.BytesValue
       * @static
       * @param {google.protobuf.IBytesValue} message BytesValue message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      BytesValue.encode = function encode(message, writer) {
        if (!writer) writer = $Writer.create();
        if (message.value != null && message.hasOwnProperty('value'))
          writer.uint32(/* id 1, wireType 2 =*/ 10).bytes(message.value);
        return writer;
      };

      /**
       * Encodes the specified BytesValue message, length delimited. Does not implicitly {@link google.protobuf.BytesValue.verify|verify} messages.
       * @function encodeDelimited
       * @memberof google.protobuf.BytesValue
       * @static
       * @param {google.protobuf.IBytesValue} message BytesValue message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      BytesValue.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
      };

      /**
       * Decodes a BytesValue message from the specified reader or buffer.
       * @function decode
       * @memberof google.protobuf.BytesValue
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @param {number} [length] Message length if known beforehand
       * @returns {google.protobuf.BytesValue} BytesValue
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      BytesValue.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length,
          message = new $root.google.protobuf.BytesValue();
        while (reader.pos < end) {
          var tag = reader.uint32();
          switch (tag >>> 3) {
            case 1:
              message.value = reader.bytes();
              break;
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };

      /**
       * Decodes a BytesValue message from the specified reader or buffer, length delimited.
       * @function decodeDelimited
       * @memberof google.protobuf.BytesValue
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @returns {google.protobuf.BytesValue} BytesValue
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      BytesValue.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader)) reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
      };

      /**
       * Verifies a BytesValue message.
       * @function verify
       * @memberof google.protobuf.BytesValue
       * @static
       * @param {Object.<string,*>} message Plain object to verify
       * @returns {string|null} `null` if valid, otherwise the reason why it is not
       */
      BytesValue.verify = function verify(message) {
        if (typeof message !== 'object' || message === null) return 'object expected';
        if (message.value != null && message.hasOwnProperty('value'))
          if (
            !(
              (message.value && typeof message.value.length === 'number') ||
              $util.isString(message.value)
            )
          )
            return 'value: buffer expected';
        return null;
      };

      /**
       * Creates a BytesValue message from a plain object. Also converts values to their respective internal types.
       * @function fromObject
       * @memberof google.protobuf.BytesValue
       * @static
       * @param {Object.<string,*>} object Plain object
       * @returns {google.protobuf.BytesValue} BytesValue
       */
      BytesValue.fromObject = function fromObject(object) {
        if (object instanceof $root.google.protobuf.BytesValue) return object;
        var message = new $root.google.protobuf.BytesValue();
        if (object.value != null)
          if (typeof object.value === 'string')
            $util.base64.decode(
              object.value,
              (message.value = $util.newBuffer($util.base64.length(object.value))),
              0
            );
          else if (object.value.length) message.value = object.value;
        return message;
      };

      /**
       * Creates a plain object from a BytesValue message. Also converts values to other types if specified.
       * @function toObject
       * @memberof google.protobuf.BytesValue
       * @static
       * @param {google.protobuf.BytesValue} message BytesValue
       * @param {$protobuf.IConversionOptions} [options] Conversion options
       * @returns {Object.<string,*>} Plain object
       */
      BytesValue.toObject = function toObject(message, options) {
        if (!options) options = {};
        var object = {};
        if (options.defaults)
          if (options.bytes === String) object.value = '';
          else {
            object.value = [];
            if (options.bytes !== Array) object.value = $util.newBuffer(object.value);
          }
        if (message.value != null && message.hasOwnProperty('value'))
          object.value =
            options.bytes === String
              ? $util.base64.encode(message.value, 0, message.value.length)
              : options.bytes === Array
              ? Array.prototype.slice.call(message.value)
              : message.value;
        return object;
      };

      /**
       * Converts this BytesValue to JSON.
       * @function toJSON
       * @memberof google.protobuf.BytesValue
       * @instance
       * @returns {Object.<string,*>} JSON object
       */
      BytesValue.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
      };

      return BytesValue;
    })();

    protobuf.Empty = (function () {
      /**
       * Properties of an Empty.
       * @memberof google.protobuf
       * @interface IEmpty
       */

      /**
       * Constructs a new Empty.
       * @memberof google.protobuf
       * @classdesc Represents an Empty.
       * @implements IEmpty
       * @constructor
       * @param {google.protobuf.IEmpty=} [properties] Properties to set
       */
      function Empty(properties) {
        if (properties)
          for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
      }

      /**
       * Creates a new Empty instance using the specified properties.
       * @function create
       * @memberof google.protobuf.Empty
       * @static
       * @param {google.protobuf.IEmpty=} [properties] Properties to set
       * @returns {google.protobuf.Empty} Empty instance
       */
      Empty.create = function create(properties) {
        return new Empty(properties);
      };

      /**
       * Encodes the specified Empty message. Does not implicitly {@link google.protobuf.Empty.verify|verify} messages.
       * @function encode
       * @memberof google.protobuf.Empty
       * @static
       * @param {google.protobuf.IEmpty} message Empty message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      Empty.encode = function encode(message, writer) {
        if (!writer) writer = $Writer.create();
        return writer;
      };

      /**
       * Encodes the specified Empty message, length delimited. Does not implicitly {@link google.protobuf.Empty.verify|verify} messages.
       * @function encodeDelimited
       * @memberof google.protobuf.Empty
       * @static
       * @param {google.protobuf.IEmpty} message Empty message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      Empty.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
      };

      /**
       * Decodes an Empty message from the specified reader or buffer.
       * @function decode
       * @memberof google.protobuf.Empty
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @param {number} [length] Message length if known beforehand
       * @returns {google.protobuf.Empty} Empty
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      Empty.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length,
          message = new $root.google.protobuf.Empty();
        while (reader.pos < end) {
          var tag = reader.uint32();
          switch (tag >>> 3) {
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };

      /**
       * Decodes an Empty message from the specified reader or buffer, length delimited.
       * @function decodeDelimited
       * @memberof google.protobuf.Empty
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @returns {google.protobuf.Empty} Empty
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      Empty.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader)) reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
      };

      /**
       * Verifies an Empty message.
       * @function verify
       * @memberof google.protobuf.Empty
       * @static
       * @param {Object.<string,*>} message Plain object to verify
       * @returns {string|null} `null` if valid, otherwise the reason why it is not
       */
      Empty.verify = function verify(message) {
        if (typeof message !== 'object' || message === null) return 'object expected';
        return null;
      };

      /**
       * Creates an Empty message from a plain object. Also converts values to their respective internal types.
       * @function fromObject
       * @memberof google.protobuf.Empty
       * @static
       * @param {Object.<string,*>} object Plain object
       * @returns {google.protobuf.Empty} Empty
       */
      Empty.fromObject = function fromObject(object) {
        if (object instanceof $root.google.protobuf.Empty) return object;
        return new $root.google.protobuf.Empty();
      };

      /**
       * Creates a plain object from an Empty message. Also converts values to other types if specified.
       * @function toObject
       * @memberof google.protobuf.Empty
       * @static
       * @param {google.protobuf.Empty} message Empty
       * @param {$protobuf.IConversionOptions} [options] Conversion options
       * @returns {Object.<string,*>} Plain object
       */
      Empty.toObject = function toObject() {
        return {};
      };

      /**
       * Converts this Empty to JSON.
       * @function toJSON
       * @memberof google.protobuf.Empty
       * @instance
       * @returns {Object.<string,*>} JSON object
       */
      Empty.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
      };

      return Empty;
    })();

    protobuf.Struct = (function () {
      /**
       * Properties of a Struct.
       * @memberof google.protobuf
       * @interface IStruct
       * @property {Object.<string,google.protobuf.IValue>|null} [fields] Struct fields
       */

      /**
       * Constructs a new Struct.
       * @memberof google.protobuf
       * @classdesc Represents a Struct.
       * @implements IStruct
       * @constructor
       * @param {google.protobuf.IStruct=} [properties] Properties to set
       */
      function Struct(properties) {
        this.fields = {};
        if (properties)
          for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
      }

      /**
       * Struct fields.
       * @member {Object.<string,google.protobuf.IValue>} fields
       * @memberof google.protobuf.Struct
       * @instance
       */
      Struct.prototype.fields = $util.emptyObject;

      /**
       * Creates a new Struct instance using the specified properties.
       * @function create
       * @memberof google.protobuf.Struct
       * @static
       * @param {google.protobuf.IStruct=} [properties] Properties to set
       * @returns {google.protobuf.Struct} Struct instance
       */
      Struct.create = function create(properties) {
        return new Struct(properties);
      };

      /**
       * Encodes the specified Struct message. Does not implicitly {@link google.protobuf.Struct.verify|verify} messages.
       * @function encode
       * @memberof google.protobuf.Struct
       * @static
       * @param {google.protobuf.IStruct} message Struct message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      Struct.encode = function encode(message, writer) {
        if (!writer) writer = $Writer.create();
        if (message.fields != null && message.hasOwnProperty('fields'))
          for (var keys = Object.keys(message.fields), i = 0; i < keys.length; ++i) {
            writer
              .uint32(/* id 1, wireType 2 =*/ 10)
              .fork()
              .uint32(/* id 1, wireType 2 =*/ 10)
              .string(keys[i]);
            $root.google.protobuf.Value.encode(
              message.fields[keys[i]],
              writer.uint32(/* id 2, wireType 2 =*/ 18).fork()
            )
              .ldelim()
              .ldelim();
          }
        return writer;
      };

      /**
       * Encodes the specified Struct message, length delimited. Does not implicitly {@link google.protobuf.Struct.verify|verify} messages.
       * @function encodeDelimited
       * @memberof google.protobuf.Struct
       * @static
       * @param {google.protobuf.IStruct} message Struct message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      Struct.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
      };

      /**
       * Decodes a Struct message from the specified reader or buffer.
       * @function decode
       * @memberof google.protobuf.Struct
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @param {number} [length] Message length if known beforehand
       * @returns {google.protobuf.Struct} Struct
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      Struct.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length,
          message = new $root.google.protobuf.Struct(),
          key;
        while (reader.pos < end) {
          var tag = reader.uint32();
          switch (tag >>> 3) {
            case 1:
              reader.skip().pos++;
              if (message.fields === $util.emptyObject) message.fields = {};
              key = reader.string();
              reader.pos++;
              message.fields[key] = $root.google.protobuf.Value.decode(reader, reader.uint32());
              break;
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };

      /**
       * Decodes a Struct message from the specified reader or buffer, length delimited.
       * @function decodeDelimited
       * @memberof google.protobuf.Struct
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @returns {google.protobuf.Struct} Struct
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      Struct.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader)) reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
      };

      /**
       * Verifies a Struct message.
       * @function verify
       * @memberof google.protobuf.Struct
       * @static
       * @param {Object.<string,*>} message Plain object to verify
       * @returns {string|null} `null` if valid, otherwise the reason why it is not
       */
      Struct.verify = function verify(message) {
        if (typeof message !== 'object' || message === null) return 'object expected';
        if (message.fields != null && message.hasOwnProperty('fields')) {
          if (!$util.isObject(message.fields)) return 'fields: object expected';
          var key = Object.keys(message.fields);
          for (var i = 0; i < key.length; ++i) {
            var error = $root.google.protobuf.Value.verify(message.fields[key[i]]);
            if (error) return 'fields.' + error;
          }
        }
        return null;
      };

      /**
       * Creates a Struct message from a plain object. Also converts values to their respective internal types.
       * @function fromObject
       * @memberof google.protobuf.Struct
       * @static
       * @param {Object.<string,*>} object Plain object
       * @returns {google.protobuf.Struct} Struct
       */
      Struct.fromObject = function fromObject(object) {
        if (object instanceof $root.google.protobuf.Struct) return object;
        var message = new $root.google.protobuf.Struct();
        if (object.fields) {
          if (typeof object.fields !== 'object')
            throw TypeError('.google.protobuf.Struct.fields: object expected');
          message.fields = {};
          for (var keys = Object.keys(object.fields), i = 0; i < keys.length; ++i) {
            if (typeof object.fields[keys[i]] !== 'object')
              throw TypeError('.google.protobuf.Struct.fields: object expected');
            message.fields[keys[i]] = $root.google.protobuf.Value.fromObject(
              object.fields[keys[i]]
            );
          }
        }
        return message;
      };

      /**
       * Creates a plain object from a Struct message. Also converts values to other types if specified.
       * @function toObject
       * @memberof google.protobuf.Struct
       * @static
       * @param {google.protobuf.Struct} message Struct
       * @param {$protobuf.IConversionOptions} [options] Conversion options
       * @returns {Object.<string,*>} Plain object
       */
      Struct.toObject = function toObject(message, options) {
        if (!options) options = {};
        var object = {};
        if (options.objects || options.defaults) object.fields = {};
        var keys2;
        if (message.fields && (keys2 = Object.keys(message.fields)).length) {
          object.fields = {};
          for (var j = 0; j < keys2.length; ++j)
            object.fields[keys2[j]] = $root.google.protobuf.Value.toObject(
              message.fields[keys2[j]],
              options
            );
        }
        return object;
      };

      /**
       * Converts this Struct to JSON.
       * @function toJSON
       * @memberof google.protobuf.Struct
       * @instance
       * @returns {Object.<string,*>} JSON object
       */
      Struct.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
      };

      return Struct;
    })();

    protobuf.Value = (function () {
      /**
       * Properties of a Value.
       * @memberof google.protobuf
       * @interface IValue
       * @property {google.protobuf.NullValue|null} [nullValue] Value nullValue
       * @property {number|null} [numberValue] Value numberValue
       * @property {string|null} [stringValue] Value stringValue
       * @property {boolean|null} [boolValue] Value boolValue
       * @property {google.protobuf.IStruct|null} [structValue] Value structValue
       * @property {google.protobuf.IListValue|null} [listValue] Value listValue
       */

      /**
       * Constructs a new Value.
       * @memberof google.protobuf
       * @classdesc Represents a Value.
       * @implements IValue
       * @constructor
       * @param {google.protobuf.IValue=} [properties] Properties to set
       */
      function Value(properties) {
        if (properties)
          for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
      }

      /**
       * Value nullValue.
       * @member {google.protobuf.NullValue} nullValue
       * @memberof google.protobuf.Value
       * @instance
       */
      Value.prototype.nullValue = 0;

      /**
       * Value numberValue.
       * @member {number} numberValue
       * @memberof google.protobuf.Value
       * @instance
       */
      Value.prototype.numberValue = 0;

      /**
       * Value stringValue.
       * @member {string} stringValue
       * @memberof google.protobuf.Value
       * @instance
       */
      Value.prototype.stringValue = '';

      /**
       * Value boolValue.
       * @member {boolean} boolValue
       * @memberof google.protobuf.Value
       * @instance
       */
      Value.prototype.boolValue = false;

      /**
       * Value structValue.
       * @member {google.protobuf.IStruct|null|undefined} structValue
       * @memberof google.protobuf.Value
       * @instance
       */
      Value.prototype.structValue = null;

      /**
       * Value listValue.
       * @member {google.protobuf.IListValue|null|undefined} listValue
       * @memberof google.protobuf.Value
       * @instance
       */
      Value.prototype.listValue = null;

      // OneOf field names bound to virtual getters and setters
      var $oneOfFields;

      /**
       * Value kind.
       * @member {"nullValue"|"numberValue"|"stringValue"|"boolValue"|"structValue"|"listValue"|undefined} kind
       * @memberof google.protobuf.Value
       * @instance
       */
      Object.defineProperty(Value.prototype, 'kind', {
        get: $util.oneOfGetter(
          ($oneOfFields = [
            'nullValue',
            'numberValue',
            'stringValue',
            'boolValue',
            'structValue',
            'listValue',
          ])
        ),
        set: $util.oneOfSetter($oneOfFields),
      });

      /**
       * Creates a new Value instance using the specified properties.
       * @function create
       * @memberof google.protobuf.Value
       * @static
       * @param {google.protobuf.IValue=} [properties] Properties to set
       * @returns {google.protobuf.Value} Value instance
       */
      Value.create = function create(properties) {
        return new Value(properties);
      };

      /**
       * Encodes the specified Value message. Does not implicitly {@link google.protobuf.Value.verify|verify} messages.
       * @function encode
       * @memberof google.protobuf.Value
       * @static
       * @param {google.protobuf.IValue} message Value message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      Value.encode = function encode(message, writer) {
        if (!writer) writer = $Writer.create();
        if (message.nullValue != null && message.hasOwnProperty('nullValue'))
          writer.uint32(/* id 1, wireType 0 =*/ 8).int32(message.nullValue);
        if (message.numberValue != null && message.hasOwnProperty('numberValue'))
          writer.uint32(/* id 2, wireType 1 =*/ 17).double(message.numberValue);
        if (message.stringValue != null && message.hasOwnProperty('stringValue'))
          writer.uint32(/* id 3, wireType 2 =*/ 26).string(message.stringValue);
        if (message.boolValue != null && message.hasOwnProperty('boolValue'))
          writer.uint32(/* id 4, wireType 0 =*/ 32).bool(message.boolValue);
        if (message.structValue != null && message.hasOwnProperty('structValue'))
          $root.google.protobuf.Struct.encode(
            message.structValue,
            writer.uint32(/* id 5, wireType 2 =*/ 42).fork()
          ).ldelim();
        if (message.listValue != null && message.hasOwnProperty('listValue'))
          $root.google.protobuf.ListValue.encode(
            message.listValue,
            writer.uint32(/* id 6, wireType 2 =*/ 50).fork()
          ).ldelim();
        return writer;
      };

      /**
       * Encodes the specified Value message, length delimited. Does not implicitly {@link google.protobuf.Value.verify|verify} messages.
       * @function encodeDelimited
       * @memberof google.protobuf.Value
       * @static
       * @param {google.protobuf.IValue} message Value message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      Value.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
      };

      /**
       * Decodes a Value message from the specified reader or buffer.
       * @function decode
       * @memberof google.protobuf.Value
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @param {number} [length] Message length if known beforehand
       * @returns {google.protobuf.Value} Value
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      Value.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length,
          message = new $root.google.protobuf.Value();
        while (reader.pos < end) {
          var tag = reader.uint32();
          switch (tag >>> 3) {
            case 1:
              message.nullValue = reader.int32();
              break;
            case 2:
              message.numberValue = reader.double();
              break;
            case 3:
              message.stringValue = reader.string();
              break;
            case 4:
              message.boolValue = reader.bool();
              break;
            case 5:
              message.structValue = $root.google.protobuf.Struct.decode(reader, reader.uint32());
              break;
            case 6:
              message.listValue = $root.google.protobuf.ListValue.decode(reader, reader.uint32());
              break;
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };

      /**
       * Decodes a Value message from the specified reader or buffer, length delimited.
       * @function decodeDelimited
       * @memberof google.protobuf.Value
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @returns {google.protobuf.Value} Value
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      Value.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader)) reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
      };

      /**
       * Verifies a Value message.
       * @function verify
       * @memberof google.protobuf.Value
       * @static
       * @param {Object.<string,*>} message Plain object to verify
       * @returns {string|null} `null` if valid, otherwise the reason why it is not
       */
      Value.verify = function verify(message) {
        if (typeof message !== 'object' || message === null) return 'object expected';
        var properties = {};
        if (message.nullValue != null && message.hasOwnProperty('nullValue')) {
          properties.kind = 1;
          switch (message.nullValue) {
            default:
              return 'nullValue: enum value expected';
            case 0:
              break;
          }
        }
        if (message.numberValue != null && message.hasOwnProperty('numberValue')) {
          if (properties.kind === 1) return 'kind: multiple values';
          properties.kind = 1;
          if (typeof message.numberValue !== 'number') return 'numberValue: number expected';
        }
        if (message.stringValue != null && message.hasOwnProperty('stringValue')) {
          if (properties.kind === 1) return 'kind: multiple values';
          properties.kind = 1;
          if (!$util.isString(message.stringValue)) return 'stringValue: string expected';
        }
        if (message.boolValue != null && message.hasOwnProperty('boolValue')) {
          if (properties.kind === 1) return 'kind: multiple values';
          properties.kind = 1;
          if (typeof message.boolValue !== 'boolean') return 'boolValue: boolean expected';
        }
        if (message.structValue != null && message.hasOwnProperty('structValue')) {
          if (properties.kind === 1) return 'kind: multiple values';
          properties.kind = 1;
          {
            var error = $root.google.protobuf.Struct.verify(message.structValue);
            if (error) return 'structValue.' + error;
          }
        }
        if (message.listValue != null && message.hasOwnProperty('listValue')) {
          if (properties.kind === 1) return 'kind: multiple values';
          properties.kind = 1;
          {
            var error = $root.google.protobuf.ListValue.verify(message.listValue);
            if (error) return 'listValue.' + error;
          }
        }
        return null;
      };

      /**
       * Creates a Value message from a plain object. Also converts values to their respective internal types.
       * @function fromObject
       * @memberof google.protobuf.Value
       * @static
       * @param {Object.<string,*>} object Plain object
       * @returns {google.protobuf.Value} Value
       */
      Value.fromObject = function fromObject(object) {
        if (object instanceof $root.google.protobuf.Value) return object;
        var message = new $root.google.protobuf.Value();
        switch (object.nullValue) {
          case 'NULL_VALUE':
          case 0:
            message.nullValue = 0;
            break;
        }
        if (object.numberValue != null) message.numberValue = Number(object.numberValue);
        if (object.stringValue != null) message.stringValue = String(object.stringValue);
        if (object.boolValue != null) message.boolValue = Boolean(object.boolValue);
        if (object.structValue != null) {
          if (typeof object.structValue !== 'object')
            throw TypeError('.google.protobuf.Value.structValue: object expected');
          message.structValue = $root.google.protobuf.Struct.fromObject(object.structValue);
        }
        if (object.listValue != null) {
          if (typeof object.listValue !== 'object')
            throw TypeError('.google.protobuf.Value.listValue: object expected');
          message.listValue = $root.google.protobuf.ListValue.fromObject(object.listValue);
        }
        return message;
      };

      /**
       * Creates a plain object from a Value message. Also converts values to other types if specified.
       * @function toObject
       * @memberof google.protobuf.Value
       * @static
       * @param {google.protobuf.Value} message Value
       * @param {$protobuf.IConversionOptions} [options] Conversion options
       * @returns {Object.<string,*>} Plain object
       */
      Value.toObject = function toObject(message, options) {
        if (!options) options = {};
        var object = {};
        if (message.nullValue != null && message.hasOwnProperty('nullValue')) {
          object.nullValue =
            options.enums === String
              ? $root.google.protobuf.NullValue[message.nullValue]
              : message.nullValue;
          if (options.oneofs) object.kind = 'nullValue';
        }
        if (message.numberValue != null && message.hasOwnProperty('numberValue')) {
          object.numberValue =
            options.json && !isFinite(message.numberValue)
              ? String(message.numberValue)
              : message.numberValue;
          if (options.oneofs) object.kind = 'numberValue';
        }
        if (message.stringValue != null && message.hasOwnProperty('stringValue')) {
          object.stringValue = message.stringValue;
          if (options.oneofs) object.kind = 'stringValue';
        }
        if (message.boolValue != null && message.hasOwnProperty('boolValue')) {
          object.boolValue = message.boolValue;
          if (options.oneofs) object.kind = 'boolValue';
        }
        if (message.structValue != null && message.hasOwnProperty('structValue')) {
          object.structValue = $root.google.protobuf.Struct.toObject(message.structValue, options);
          if (options.oneofs) object.kind = 'structValue';
        }
        if (message.listValue != null && message.hasOwnProperty('listValue')) {
          object.listValue = $root.google.protobuf.ListValue.toObject(message.listValue, options);
          if (options.oneofs) object.kind = 'listValue';
        }
        return object;
      };

      /**
       * Converts this Value to JSON.
       * @function toJSON
       * @memberof google.protobuf.Value
       * @instance
       * @returns {Object.<string,*>} JSON object
       */
      Value.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
      };

      return Value;
    })();

    /**
     * NullValue enum.
     * @name google.protobuf.NullValue
     * @enum {string}
     * @property {number} NULL_VALUE=0 NULL_VALUE value
     */
    protobuf.NullValue = (function () {
      var valuesById = {},
        values = Object.create(valuesById);
      values[(valuesById[0] = 'NULL_VALUE')] = 0;
      return values;
    })();

    protobuf.ListValue = (function () {
      /**
       * Properties of a ListValue.
       * @memberof google.protobuf
       * @interface IListValue
       * @property {Array.<google.protobuf.IValue>|null} [values] ListValue values
       */

      /**
       * Constructs a new ListValue.
       * @memberof google.protobuf
       * @classdesc Represents a ListValue.
       * @implements IListValue
       * @constructor
       * @param {google.protobuf.IListValue=} [properties] Properties to set
       */
      function ListValue(properties) {
        this.values = [];
        if (properties)
          for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
      }

      /**
       * ListValue values.
       * @member {Array.<google.protobuf.IValue>} values
       * @memberof google.protobuf.ListValue
       * @instance
       */
      ListValue.prototype.values = $util.emptyArray;

      /**
       * Creates a new ListValue instance using the specified properties.
       * @function create
       * @memberof google.protobuf.ListValue
       * @static
       * @param {google.protobuf.IListValue=} [properties] Properties to set
       * @returns {google.protobuf.ListValue} ListValue instance
       */
      ListValue.create = function create(properties) {
        return new ListValue(properties);
      };

      /**
       * Encodes the specified ListValue message. Does not implicitly {@link google.protobuf.ListValue.verify|verify} messages.
       * @function encode
       * @memberof google.protobuf.ListValue
       * @static
       * @param {google.protobuf.IListValue} message ListValue message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      ListValue.encode = function encode(message, writer) {
        if (!writer) writer = $Writer.create();
        if (message.values != null && message.values.length)
          for (var i = 0; i < message.values.length; ++i)
            $root.google.protobuf.Value.encode(
              message.values[i],
              writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
            ).ldelim();
        return writer;
      };

      /**
       * Encodes the specified ListValue message, length delimited. Does not implicitly {@link google.protobuf.ListValue.verify|verify} messages.
       * @function encodeDelimited
       * @memberof google.protobuf.ListValue
       * @static
       * @param {google.protobuf.IListValue} message ListValue message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      ListValue.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
      };

      /**
       * Decodes a ListValue message from the specified reader or buffer.
       * @function decode
       * @memberof google.protobuf.ListValue
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @param {number} [length] Message length if known beforehand
       * @returns {google.protobuf.ListValue} ListValue
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      ListValue.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length,
          message = new $root.google.protobuf.ListValue();
        while (reader.pos < end) {
          var tag = reader.uint32();
          switch (tag >>> 3) {
            case 1:
              if (!(message.values && message.values.length)) message.values = [];
              message.values.push($root.google.protobuf.Value.decode(reader, reader.uint32()));
              break;
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };

      /**
       * Decodes a ListValue message from the specified reader or buffer, length delimited.
       * @function decodeDelimited
       * @memberof google.protobuf.ListValue
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @returns {google.protobuf.ListValue} ListValue
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      ListValue.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader)) reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
      };

      /**
       * Verifies a ListValue message.
       * @function verify
       * @memberof google.protobuf.ListValue
       * @static
       * @param {Object.<string,*>} message Plain object to verify
       * @returns {string|null} `null` if valid, otherwise the reason why it is not
       */
      ListValue.verify = function verify(message) {
        if (typeof message !== 'object' || message === null) return 'object expected';
        if (message.values != null && message.hasOwnProperty('values')) {
          if (!Array.isArray(message.values)) return 'values: array expected';
          for (var i = 0; i < message.values.length; ++i) {
            var error = $root.google.protobuf.Value.verify(message.values[i]);
            if (error) return 'values.' + error;
          }
        }
        return null;
      };

      /**
       * Creates a ListValue message from a plain object. Also converts values to their respective internal types.
       * @function fromObject
       * @memberof google.protobuf.ListValue
       * @static
       * @param {Object.<string,*>} object Plain object
       * @returns {google.protobuf.ListValue} ListValue
       */
      ListValue.fromObject = function fromObject(object) {
        if (object instanceof $root.google.protobuf.ListValue) return object;
        var message = new $root.google.protobuf.ListValue();
        if (object.values) {
          if (!Array.isArray(object.values))
            throw TypeError('.google.protobuf.ListValue.values: array expected');
          message.values = [];
          for (var i = 0; i < object.values.length; ++i) {
            if (typeof object.values[i] !== 'object')
              throw TypeError('.google.protobuf.ListValue.values: object expected');
            message.values[i] = $root.google.protobuf.Value.fromObject(object.values[i]);
          }
        }
        return message;
      };

      /**
       * Creates a plain object from a ListValue message. Also converts values to other types if specified.
       * @function toObject
       * @memberof google.protobuf.ListValue
       * @static
       * @param {google.protobuf.ListValue} message ListValue
       * @param {$protobuf.IConversionOptions} [options] Conversion options
       * @returns {Object.<string,*>} Plain object
       */
      ListValue.toObject = function toObject(message, options) {
        if (!options) options = {};
        var object = {};
        if (options.arrays || options.defaults) object.values = [];
        if (message.values && message.values.length) {
          object.values = [];
          for (var j = 0; j < message.values.length; ++j)
            object.values[j] = $root.google.protobuf.Value.toObject(message.values[j], options);
        }
        return object;
      };

      /**
       * Converts this ListValue to JSON.
       * @function toJSON
       * @memberof google.protobuf.ListValue
       * @instance
       * @returns {Object.<string,*>} JSON object
       */
      ListValue.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
      };

      return ListValue;
    })();

    return protobuf;
  })();

  return google;
})();

module.exports = $root;
